function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e385) { throw _e385; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e386) { didErr = true; err = _e386; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
var t = "undefined" != typeof window && null != window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
    e = function e(t, _e2) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  for (; _e2 !== n;) {
    var _n2 = _e2.nextSibling;
    t.removeChild(_e2), _e2 = _n2;
  }
},
    n = "{{lit-".concat(String(Math.random()).slice(2), "}}"),
    i = "<!--".concat(n, "-->"),
    r = new RegExp("".concat(n, "|").concat(i));

var s = /*#__PURE__*/_createClass(function s(t, e) {
  _classCallCheck(this, s);

  this.parts = [], this.element = e;
  var i = [],
      _s2 = [],
      o = document.createTreeWalker(e.content, 133, null, !1);
  var h = 0,
      u = -1,
      d = 0;
  var p = t.strings,
      A = t.values.length;

  for (; d < A;) {
    var _t2 = o.nextNode();

    if (null !== _t2) {
      if (u++, 1 === _t2.nodeType) {
        if (_t2.hasAttributes()) {
          var _e3 = _t2.attributes,
              _n3 = _e3.length;
          var _i2 = 0;

          for (var _t3 = 0; _t3 < _n3; _t3++) {
            a(_e3[_t3].name, "$lit$") && _i2++;
          }

          for (; _i2-- > 0;) {
            var _e4 = p[d],
                _n4 = c.exec(_e4)[2],
                _i3 = _n4.toLowerCase() + "$lit$",
                _s5 = _t2.getAttribute(_i3);

            _t2.removeAttribute(_i3);

            var _a2 = _s5.split(r);

            this.parts.push({
              type: "attribute",
              index: u,
              name: _n4,
              strings: _a2
            }), d += _a2.length - 1;
          }
        }

        "TEMPLATE" === _t2.tagName && (_s2.push(_t2), o.currentNode = _t2.content);
      } else if (3 === _t2.nodeType) {
        var _e5 = _t2.data;

        if (_e5.indexOf(n) >= 0) {
          var _n5 = _t2.parentNode,
              _s6 = _e5.split(r),
              _o2 = _s6.length - 1;

          for (var _e6 = 0; _e6 < _o2; _e6++) {
            var _i4 = void 0,
                _r2 = _s6[_e6];

            if ("" === _r2) _i4 = l();else {
              var _t4 = c.exec(_r2);

              null !== _t4 && a(_t4[2], "$lit$") && (_r2 = _r2.slice(0, _t4.index) + _t4[1] + _t4[2].slice(0, -"$lit$".length) + _t4[3]), _i4 = document.createTextNode(_r2);
            }
            _n5.insertBefore(_i4, _t2), this.parts.push({
              type: "node",
              index: ++u
            });
          }

          "" === _s6[_o2] ? (_n5.insertBefore(l(), _t2), i.push(_t2)) : _t2.data = _s6[_o2], d += _o2;
        }
      } else if (8 === _t2.nodeType) if (_t2.data === n) {
        var _e7 = _t2.parentNode;
        null !== _t2.previousSibling && u !== h || (u++, _e7.insertBefore(l(), _t2)), h = u, this.parts.push({
          type: "node",
          index: u
        }), null === _t2.nextSibling ? _t2.data = "" : (i.push(_t2), u--), d++;
      } else {
        var _e8 = -1;

        for (; -1 !== (_e8 = _t2.data.indexOf(n, _e8 + 1));) {
          this.parts.push({
            type: "node",
            index: -1
          }), d++;
        }
      }
    } else o.currentNode = _s2.pop();
  }

  for (var _i6 = 0, _i5 = i; _i6 < _i5.length; _i6++) {
    var _t5 = _i5[_i6];

    _t5.parentNode.removeChild(_t5);
  }
});

var a = function a(t, e) {
  var n = t.length - e.length;
  return n >= 0 && t.slice(n) === e;
},
    o = function o(t) {
  return -1 !== t.index;
},
    l = function l() {
  return document.createComment("");
},
    c = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;

function h(t, e) {
  var n = t.element.content,
      i = t.parts,
      r = document.createTreeWalker(n, 133, null, !1);
  var s = d(i),
      a = i[s],
      o = -1,
      l = 0;
  var c = [];
  var h = null;

  for (; r.nextNode();) {
    o++;
    var _t6 = r.currentNode;

    for (_t6.previousSibling === h && (h = null), e.has(_t6) && (c.push(_t6), null === h && (h = _t6)), null !== h && l++; void 0 !== a && a.index === o;) {
      a.index = null !== h ? -1 : a.index - l, s = d(i, s), a = i[s];
    }
  }

  c.forEach(function (t) {
    return t.parentNode.removeChild(t);
  });
}

var u = function u(t) {
  var e = 11 === t.nodeType ? 0 : 1;
  var n = document.createTreeWalker(t, 133, null, !1);

  for (; n.nextNode();) {
    e++;
  }

  return e;
},
    d = function d(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

  for (var _n6 = e + 1; _n6 < t.length; _n6++) {
    var _e9 = t[_n6];
    if (o(_e9)) return _n6;
  }

  return -1;
};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var p = new WeakMap(),
    A = function A(t) {
  return "function" == typeof t && p.has(t);
},
    m = {},
    g = {};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var f = /*#__PURE__*/function () {
  function f(t, e, n) {
    _classCallCheck(this, f);

    this.__parts = [], this.template = t, this.processor = e, this.options = n;
  }

  _createClass(f, [{
    key: "update",
    value: function update(t) {
      var e = 0;

      var _iterator = _createForOfIteratorHelper(this.__parts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _n7 = _step.value;
          void 0 !== _n7 && _n7.setValue(t[e]), e++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.__parts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t7 = _step2.value;
          void 0 !== _t7 && _t7.commit();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_clone",
    value: function _clone() {
      var e = t ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
          n = [],
          i = this.template.parts,
          r = document.createTreeWalker(e, 133, null, !1);
      var s,
          a = 0,
          l = 0,
          c = r.nextNode();

      for (; a < i.length;) {
        if (s = i[a], o(s)) {
          var _this$__parts;

          for (; l < s.index;) {
            l++, "TEMPLATE" === c.nodeName && (n.push(c), r.currentNode = c.content), null === (c = r.nextNode()) && (r.currentNode = n.pop(), c = r.nextNode());
          }

          if ("node" === s.type) {
            var _t8 = this.processor.handleTextExpression(this.options);

            _t8.insertAfterNode(c.previousSibling), this.__parts.push(_t8);
          } else (_this$__parts = this.__parts).push.apply(_this$__parts, _toConsumableArray(this.processor.handleAttributeExpressions(c, s.name, s.strings, this.options)));

          a++;
        } else this.__parts.push(void 0), a++;
      }

      return t && (document.adoptNode(e), customElements.upgrade(e)), e;
    }
  }]);

  return f;
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


var v = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
  createHTML: function createHTML(t) {
    return t;
  }
}),
    y = " ".concat(n, " ");

var x = /*#__PURE__*/function () {
  function x(t) {
    _classCallCheck(this, x);

    this.value = void 0, this.__pendingValue = void 0, this.options = t;
  }

  _createClass(x, [{
    key: "appendInto",
    value: function appendInto(t) {
      this.startNode = t.appendChild(l()), this.endNode = t.appendChild(l());
    }
  }, {
    key: "insertAfterNode",
    value: function insertAfterNode(t) {
      this.startNode = t, this.endNode = t.nextSibling;
    }
  }, {
    key: "appendIntoPart",
    value: function appendIntoPart(t) {
      t.__insert(this.startNode = l()), t.__insert(this.endNode = l());
    }
  }, {
    key: "insertAfterPart",
    value: function insertAfterPart(t) {
      t.__insert(this.startNode = l()), this.endNode = t.endNode, t.endNode = this.startNode;
    }
  }, {
    key: "setValue",
    value: function setValue(t) {
      this.__pendingValue = t;
    }
  }, {
    key: "commit",
    value: function commit() {
      if (null === this.startNode.parentNode) return;

      for (; A(this.__pendingValue);) {
        var _t9 = this.__pendingValue;
        this.__pendingValue = m, _t9(this);
      }

      var t = this.__pendingValue;
      t !== m && (function (t) {
        return null === t || !("object" == _typeof(t) || "function" == typeof t);
      }(t) ? t !== this.value && this.__commitText(t) : t instanceof /*#__PURE__*/function () {
        function _class(t, e, n, i) {
          _classCallCheck(this, _class);

          this.strings = t, this.values = e, this.type = n, this.processor = i;
        }

        _createClass(_class, [{
          key: "getHTML",
          value: function getHTML() {
            var t = this.strings.length - 1;
            var e = "",
                r = !1;

            for (var _s7 = 0; _s7 < t; _s7++) {
              var _t10 = this.strings[_s7],
                  _a3 = _t10.lastIndexOf("\x3c!--");

              r = (_a3 > -1 || r) && -1 === _t10.indexOf("--\x3e", _a3 + 1);

              var _o3 = c.exec(_t10);

              e += null === _o3 ? _t10 + (r ? y : i) : _t10.substr(0, _o3.index) + _o3[1] + _o3[2] + "$lit$" + _o3[3] + n;
            }

            return e += this.strings[t], e;
          }
        }, {
          key: "getTemplateElement",
          value: function getTemplateElement() {
            var t = document.createElement("template");
            var e = this.getHTML();
            return void 0 !== v && (e = v.createHTML(e)), t.innerHTML = e, t;
          }
        }]);

        return _class;
      }()
      /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
      ? this.__commitTemplateResult(t) : t instanceof Node ? this.__commitNode(t) : function (t) {
        return Array.isArray(t) || !(!t || !t[Symbol.iterator]);
      }(t) ? this.__commitIterable(t) : t === g ? (this.value = g, this.clear()) : this.__commitText(t));
    }
  }, {
    key: "__insert",
    value: function __insert(t) {
      this.endNode.parentNode.insertBefore(t, this.endNode);
    }
  }, {
    key: "__commitNode",
    value: function __commitNode(t) {
      this.value !== t && (this.clear(), this.__insert(t), this.value = t);
    }
  }, {
    key: "__commitText",
    value: function __commitText(t) {
      var e = this.startNode.nextSibling,
          n = "string" == typeof (t = null == t ? "" : t) ? t : String(t);
      e === this.endNode.previousSibling && 3 === e.nodeType ? e.data = n : this.__commitNode(document.createTextNode(n)), this.value = t;
    }
  }, {
    key: "__commitTemplateResult",
    value: function __commitTemplateResult(t) {
      var e = this.options.templateFactory(t);
      if (this.value instanceof f && this.value.template === e) this.value.update(t.values);else {
        var _n8 = new f(e, t.processor, this.options),
            _i7 = _n8._clone();

        _n8.update(t.values), this.__commitNode(_i7), this.value = _n8;
      }
    }
  }, {
    key: "__commitIterable",
    value: function __commitIterable(t) {
      Array.isArray(this.value) || (this.value = [], this.clear());
      var e = this.value;
      var n,
          i = 0;

      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r3 = _step3.value;
          n = e[i], void 0 === n && (n = new x(this.options), e.push(n), 0 === i ? n.appendIntoPart(this) : n.insertAfterPart(e[i - 1])), n.setValue(_r3), n.commit(), i++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      i < e.length && (e.length = i, this.clear(n && n.endNode));
    }
  }, {
    key: "clear",
    value: function clear() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startNode;
      e(this.startNode.parentNode, t.nextSibling, this.endNode);
    }
  }]);

  return x;
}();

var w = !1;
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

function E(t) {
  var e = b.get(t.type);
  void 0 === e && (e = {
    stringsArray: new WeakMap(),
    keyString: new Map()
  }, b.set(t.type, e));
  var i = e.stringsArray.get(t.strings);
  if (void 0 !== i) return i;
  var r = t.strings.join(n);
  return i = e.keyString.get(r), void 0 === i && (i = new s(t, t.getTemplateElement()), e.keyString.set(r, i)), e.stringsArray.set(t.strings, i), i;
}

(function () {
  try {
    var _t11 = {
      get capture() {
        return w = !0, !1;
      }

    };
    window.addEventListener("test", _t11, _t11), window.removeEventListener("test", _t11, _t11);
  } catch (t) {}
})();

var b = new Map(),
    _ = new WeakMap();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


"undefined" != typeof window && (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.4.1");
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

var I = function I(t, e) {
  return "".concat(t, "--").concat(e);
};

var C = !0;
void 0 === window.ShadyCSS ? C = !1 : void 0 === window.ShadyCSS.prepareTemplateDom && (console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."), C = !1);

var M = function M(t) {
  return function (e) {
    var i = I(e.type, t);
    var r = b.get(i);
    void 0 === r && (r = {
      stringsArray: new WeakMap(),
      keyString: new Map()
    }, b.set(i, r));
    var a = r.stringsArray.get(e.strings);
    if (void 0 !== a) return a;
    var o = e.strings.join(n);

    if (a = r.keyString.get(o), void 0 === a) {
      var _n9 = e.getTemplateElement();

      C && window.ShadyCSS.prepareTemplateDom(_n9, t), a = new s(e, _n9), r.keyString.set(o, a);
    }

    return r.stringsArray.set(e.strings, a), a;
  };
},
    S = ["html", "svg"],
    B = new Set(),
    T = function T(t, e, n) {
  B.add(t);
  var i = n ? n.element : document.createElement("template"),
      r = e.querySelectorAll("style"),
      s = r.length;
  if (0 === s) return void window.ShadyCSS.prepareTemplateStyles(i, t);
  var a = document.createElement("style");

  for (var _t12 = 0; _t12 < s; _t12++) {
    var _e10 = r[_t12];
    _e10.parentNode.removeChild(_e10), a.textContent += _e10.textContent;
  }

  (function (t) {
    S.forEach(function (e) {
      var n = b.get(I(e, t));
      void 0 !== n && n.keyString.forEach(function (t) {
        var e = t.element.content,
            n = new Set();
        Array.from(e.querySelectorAll("style")).forEach(function (t) {
          n.add(t);
        }), h(t, n);
      });
    });
  })(t);

  var o = i.content;
  n ? function (t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = t.element.content,
        r = t.parts;
    if (null == n) return void i.appendChild(e);
    var s = document.createTreeWalker(i, 133, null, !1);
    var a = d(r),
        o = 0,
        l = -1;

    for (; s.nextNode();) {
      for (l++, s.currentNode === n && (o = u(e), n.parentNode.insertBefore(e, n)); -1 !== a && r[a].index === l;) {
        if (o > 0) {
          for (; -1 !== a;) {
            r[a].index += o, a = d(r, a);
          }

          return;
        }

        a = d(r, a);
      }
    }
  }(n, a, o.firstChild) : o.insertBefore(a, o.firstChild), window.ShadyCSS.prepareTemplateStyles(i, t);
  var l = o.querySelector("style");
  if (window.ShadyCSS.nativeShadow && null !== l) e.insertBefore(l.cloneNode(!0), e.firstChild);else if (n) {
    o.insertBefore(a, o.firstChild);

    var _t13 = new Set();

    _t13.add(a), h(n, _t13);
  }
};

window.JSCompiler_renameProperty = function (t, e) {
  return t;
};

var L = {
  toAttribute: function toAttribute(t, e) {
    switch (e) {
      case Boolean:
        return t ? "" : null;

      case Object:
      case Array:
        return null == t ? t : JSON.stringify(t);
    }

    return t;
  },
  fromAttribute: function fromAttribute(t, e) {
    switch (e) {
      case Boolean:
        return null !== t;

      case Number:
        return null === t ? null : Number(t);

      case Object:
      case Array:
        return JSON.parse(t);
    }

    return t;
  }
},
    R = function R(t, e) {
  return e !== t && (e == e || t == t);
},
    D = {
  attribute: !0,
  type: String,
  converter: L,
  reflect: !1,
  hasChanged: R
};

var Q = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Q, _HTMLElement);

  var _super = _createSuper(Q);

  function Q() {
    var _this;

    _classCallCheck(this, Q);

    _this = _super.call(this), _this.initialize();
    return _this;
  }

  _createClass(Q, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._updateState = 0, this._updatePromise = new Promise(function (t) {
        return _this2._enableUpdatingResolver = t;
      }), this._changedProperties = new Map(), this._saveInstanceProperties(), this.requestUpdateInternal();
    }
  }, {
    key: "_saveInstanceProperties",
    value: function _saveInstanceProperties() {
      var _this3 = this;

      this.constructor._classProperties.forEach(function (t, e) {
        if (_this3.hasOwnProperty(e)) {
          var _t14 = _this3[e];
          delete _this3[e], _this3._instanceProperties || (_this3._instanceProperties = new Map()), _this3._instanceProperties.set(e, _t14);
        }
      });
    }
  }, {
    key: "_applyInstanceProperties",
    value: function _applyInstanceProperties() {
      var _this4 = this;

      this._instanceProperties.forEach(function (t, e) {
        return _this4[e] = t;
      }), this._instanceProperties = void 0;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.enableUpdating();
    }
  }, {
    key: "enableUpdating",
    value: function enableUpdating() {
      void 0 !== this._enableUpdatingResolver && (this._enableUpdatingResolver(), this._enableUpdatingResolver = void 0);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {}
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(t, e, n) {
      e !== n && this._attributeToProperty(t, n);
    }
  }, {
    key: "_propertyToAttribute",
    value: function _propertyToAttribute(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : D;

      var i = this.constructor,
          r = i._attributeNameForProperty(t, n);

      if (void 0 !== r) {
        var _t15 = i._propertyValueToAttribute(e, n);

        if (void 0 === _t15) return;
        this._updateState = 8 | this._updateState, null == _t15 ? this.removeAttribute(r) : this.setAttribute(r, _t15), this._updateState = -9 & this._updateState;
      }
    }
  }, {
    key: "_attributeToProperty",
    value: function _attributeToProperty(t, e) {
      if (8 & this._updateState) return;

      var n = this.constructor,
          i = n._attributeToPropertyMap.get(t);

      if (void 0 !== i) {
        var _t16 = n.getPropertyOptions(i);

        this._updateState = 16 | this._updateState, this[i] = n._propertyValueFromAttribute(e, _t16), this._updateState = -17 & this._updateState;
      }
    }
  }, {
    key: "requestUpdateInternal",
    value: function requestUpdateInternal(t, e, n) {
      var i = !0;

      if (void 0 !== t) {
        var _r4 = this.constructor;
        n = n || _r4.getPropertyOptions(t), _r4._valueHasChanged(this[t], e, n.hasChanged) ? (this._changedProperties.has(t) || this._changedProperties.set(t, e), !0 !== n.reflect || 16 & this._updateState || (void 0 === this._reflectingProperties && (this._reflectingProperties = new Map()), this._reflectingProperties.set(t, n))) : i = !1;
      }

      !this._hasRequestedUpdate && i && (this._updatePromise = this._enqueueUpdate());
    }
  }, {
    key: "requestUpdate",
    value: function requestUpdate(t, e) {
      return this.requestUpdateInternal(t, e), this.updateComplete;
    }
  }, {
    key: "_enqueueUpdate",
    value: function () {
      var _enqueueUpdate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._updateState = 4 | this._updateState;
                _context.prev = 1;
                _context.next = 4;
                return this._updatePromise;

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);

              case 8:
                t = this.performUpdate();
                _context.t1 = null != t;

                if (!_context.t1) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return t;

              case 13:
                return _context.abrupt("return", !this._hasRequestedUpdate);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function _enqueueUpdate() {
        return _enqueueUpdate2.apply(this, arguments);
      }

      return _enqueueUpdate;
    }()
  }, {
    key: "_hasRequestedUpdate",
    get: function get() {
      return 4 & this._updateState;
    }
  }, {
    key: "hasUpdated",
    get: function get() {
      return 1 & this._updateState;
    }
  }, {
    key: "performUpdate",
    value: function performUpdate() {
      if (!this._hasRequestedUpdate) return;
      this._instanceProperties && this._applyInstanceProperties();
      var t = !1;
      var e = this._changedProperties;

      try {
        t = this.shouldUpdate(e), t ? this.update(e) : this._markUpdated();
      } catch (e) {
        throw t = !1, this._markUpdated(), e;
      }

      t && (1 & this._updateState || (this._updateState = 1 | this._updateState, this.firstUpdated(e)), this.updated(e));
    }
  }, {
    key: "_markUpdated",
    value: function _markUpdated() {
      this._changedProperties = new Map(), this._updateState = -5 & this._updateState;
    }
  }, {
    key: "updateComplete",
    get: function get() {
      return this._getUpdateComplete();
    }
  }, {
    key: "_getUpdateComplete",
    value: function _getUpdateComplete() {
      return this.getUpdateComplete();
    }
  }, {
    key: "getUpdateComplete",
    value: function getUpdateComplete() {
      return this._updatePromise;
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(t) {
      return !0;
    }
  }, {
    key: "update",
    value: function update(t) {
      var _this5 = this;

      void 0 !== this._reflectingProperties && this._reflectingProperties.size > 0 && (this._reflectingProperties.forEach(function (t, e) {
        return _this5._propertyToAttribute(e, _this5[e], t);
      }), this._reflectingProperties = void 0), this._markUpdated();
    }
  }, {
    key: "updated",
    value: function updated(t) {}
  }, {
    key: "firstUpdated",
    value: function firstUpdated(t) {}
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this6 = this;

      this.finalize();
      var t = [];
      return this._classProperties.forEach(function (e, n) {
        var i = _this6._attributeNameForProperty(n, e);

        void 0 !== i && (_this6._attributeToPropertyMap.set(i, n), t.push(i));
      }), t;
    }
  }, {
    key: "_ensureClassProperties",
    value: function _ensureClassProperties() {
      var _this7 = this;

      if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
        this._classProperties = new Map();

        var _t17 = Object.getPrototypeOf(this)._classProperties;

        void 0 !== _t17 && _t17.forEach(function (t, e) {
          return _this7._classProperties.set(e, t);
        });
      }
    }
  }, {
    key: "createProperty",
    value: function createProperty(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D;
      if (this._ensureClassProperties(), this._classProperties.set(t, e), e.noAccessor || this.prototype.hasOwnProperty(t)) return;
      var n = "symbol" == _typeof(t) ? Symbol() : "__".concat(t),
          i = this.getPropertyDescriptor(t, n, e);
      void 0 !== i && Object.defineProperty(this.prototype, t, i);
    }
  }, {
    key: "getPropertyDescriptor",
    value: function getPropertyDescriptor(t, e, n) {
      return {
        get: function get() {
          return this[e];
        },
        set: function set(i) {
          var r = this[t];
          this[e] = i, this.requestUpdateInternal(t, r, n);
        },
        configurable: !0,
        enumerable: !0
      };
    }
  }, {
    key: "getPropertyOptions",
    value: function getPropertyOptions(t) {
      return this._classProperties && this._classProperties.get(t) || D;
    }
  }, {
    key: "finalize",
    value: function finalize() {
      var t = Object.getPrototypeOf(this);

      if (t.hasOwnProperty("finalized") || t.finalize(), this.finalized = !0, this._ensureClassProperties(), this._attributeToPropertyMap = new Map(), this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
        var _t18 = this.properties,
            _e11 = [].concat(_toConsumableArray(Object.getOwnPropertyNames(_t18)), _toConsumableArray("function" == typeof Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(_t18) : []));

        var _iterator4 = _createForOfIteratorHelper(_e11),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _n10 = _step4.value;
            this.createProperty(_n10, _t18[_n10]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "_attributeNameForProperty",
    value: function _attributeNameForProperty(t, e) {
      var n = e.attribute;
      return !1 === n ? void 0 : "string" == typeof n ? n : "string" == typeof t ? t.toLowerCase() : void 0;
    }
  }, {
    key: "_valueHasChanged",
    value: function _valueHasChanged(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : R;
      return n(t, e);
    }
  }, {
    key: "_propertyValueFromAttribute",
    value: function _propertyValueFromAttribute(t, e) {
      var n = e.type,
          i = e.converter || L,
          r = "function" == typeof i ? i : i.fromAttribute;
      return r ? r(t, n) : t;
    }
  }, {
    key: "_propertyValueToAttribute",
    value: function _propertyValueToAttribute(t, e) {
      if (void 0 === e.reflect) return;
      var n = e.type,
          i = e.converter;
      return (i && i.toAttribute || L.toAttribute)(t, n);
    }
  }]);

  return Q;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

Q.finalized = !0;
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

var P = function P(t, e) {
  return "method" === e.kind && e.descriptor && !("value" in e.descriptor) ? Object.assign(Object.assign({}, e), {
    finisher: function finisher(n) {
      n.createProperty(e.key, t);
    }
  }) : {
    kind: "field",
    key: Symbol(),
    placement: "own",
    descriptor: {},
    initializer: function initializer() {
      "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
    },
    finisher: function finisher(n) {
      n.createProperty(e.key, t);
    }
  };
};

function F(t) {
  return function (e, n) {
    return void 0 !== n ? function (t, e, n) {
      e.constructor.createProperty(n, t);
    }(t, e, n) : P(t, e);
  };
}
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/


var N = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
    U = Symbol();

var k = /*#__PURE__*/function () {
  function k(t, e) {
    _classCallCheck(this, k);

    if (e !== U) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t;
  }

  _createClass(k, [{
    key: "styleSheet",
    get: function get() {
      return void 0 === this._styleSheet && (N ? (this._styleSheet = new CSSStyleSheet(), this._styleSheet.replaceSync(this.cssText)) : this._styleSheet = null), this._styleSheet;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.cssText;
    }
  }]);

  return k;
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */


(window.litElementVersions || (window.litElementVersions = [])).push("2.5.1");
var G = {};

var O = /*#__PURE__*/function (_Q) {
  _inherits(O, _Q);

  var _super2 = _createSuper(O);

  function O() {
    _classCallCheck(this, O);

    return _super2.apply(this, arguments);
  }

  _createClass(O, [{
    key: "initialize",
    value: function initialize() {
      _get(_getPrototypeOf(O.prototype), "initialize", this).call(this), this.constructor._getUniqueStyles(), this.renderRoot = this.createRenderRoot(), window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot && this.adoptStyles();
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this.attachShadow(this.constructor.shadowRootOptions);
    }
  }, {
    key: "adoptStyles",
    value: function adoptStyles() {
      var t = this.constructor._styles;
      0 !== t.length && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow ? N ? this.renderRoot.adoptedStyleSheets = t.map(function (t) {
        return t instanceof CSSStyleSheet ? t : t.styleSheet;
      }) : this._needsShimAdoptedStyleSheets = !0 : window.ShadyCSS.ScopingShim.prepareAdoptedCssText(t.map(function (t) {
        return t.cssText;
      }), this.localName));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(O.prototype), "connectedCallback", this).call(this), this.hasUpdated && void 0 !== window.ShadyCSS && window.ShadyCSS.styleElement(this);
    }
  }, {
    key: "update",
    value: function update(t) {
      var _this8 = this;

      var e = this.render();
      _get(_getPrototypeOf(O.prototype), "update", this).call(this, t), e !== G && this.constructor.render(e, this.renderRoot, {
        scopeName: this.localName,
        eventContext: this
      }), this._needsShimAdoptedStyleSheets && (this._needsShimAdoptedStyleSheets = !1, this.constructor._styles.forEach(function (t) {
        var e = document.createElement("style");
        e.textContent = t.cssText, _this8.renderRoot.appendChild(e);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return G;
    }
  }], [{
    key: "getStyles",
    value: function getStyles() {
      return this.styles;
    }
  }, {
    key: "_getUniqueStyles",
    value: function _getUniqueStyles() {
      if (this.hasOwnProperty(JSCompiler_renameProperty("_styles", this))) return;
      var t = this.getStyles();

      if (Array.isArray(t)) {
        var _e12 = function _e12(t, n) {
          return t.reduceRight(function (t, n) {
            return Array.isArray(n) ? _e12(n, t) : (t.add(n), t);
          }, n);
        },
            _n11 = _e12(t, new Set()),
            _i8 = [];

        _n11.forEach(function (t) {
          return _i8.unshift(t);
        }), this._styles = _i8;
      } else this._styles = void 0 === t ? [] : [t];

      this._styles = this._styles.map(function (t) {
        if (t instanceof CSSStyleSheet && !N) {
          var _e13 = Array.prototype.slice.call(t.cssRules).reduce(function (t, e) {
            return t + e.cssText;
          }, "");

          return new k(String(_e13), U);
        }

        return t;
      });
    }
  }]);

  return O;
}(Q);

O.finalized = !0, O.render = function (t, n, i) {
  if (!i || "object" != _typeof(i) || !i.scopeName) throw new Error("The `scopeName` option is required.");

  var r = i.scopeName,
      s = _.has(n),
      a = C && 11 === n.nodeType && !!n.host,
      o = a && !B.has(r),
      l = o ? document.createDocumentFragment() : n;

  if (function (t, n, i) {
    var r = _.get(n);

    void 0 === r && (e(n, n.firstChild), _.set(n, r = new x(Object.assign({
      templateFactory: E
    }, i))), r.appendInto(n)), r.setValue(t), r.commit();
  }(t, l, Object.assign({
    templateFactory: M(r)
  }, i)), o) {
    var _t19 = _.get(l);

    _.delete(l);

    var _i9 = _t19.value instanceof f ? _t19.value.template : void 0;

    T(r, l, _i9), e(n, n.firstChild), n.appendChild(l), _.set(n, _t19);
  }

  !s && a && window.ShadyCSS.styleElement(n.host);
}, O.shadowRootOptions = {
  mode: "open"
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var H = null != navigator.xr && null != self.XRSession && null != navigator.xr.isSessionSupported,
    z = H && self.XRSession.prototype.requestHitTestSource,
    V = null != self.ResizeObserver,
    W = null != self.IntersectionObserver,
    q = z;
(function () {
  var t = navigator.userAgent || navigator.vendor || self.opera;
  var e = !1;
  (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (e = !0);
})(), /\bCrOS\b/.test(navigator.userAgent);

var j = /android/i.test(navigator.userAgent),
    Y = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
    J = function () {
  var t = document.createElement("a");
  return Boolean(t.relList && t.relList.supports && t.relList.supports("ar"));
}();

/Safari\//.test(navigator.userAgent);
var X = /firefox/i.test(navigator.userAgent),
    K = /OculusBrowser/.test(navigator.userAgent);
Y && /CriOS\//.test(navigator.userAgent);
var Z = j && !X && !K;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var $ = document.createElement("template");
$.innerHTML = '\n<style>\n:host {\n  display: block;\n  position: relative;\n  contain: strict;\n  width: 300px;\n  height: 150px;\n}\n\n/* NOTE: This ruleset is our integration surface area with the\n * :focus-visible polyfill.\n *\n * @see https://github.com/WICG/focus-visible/pull/196 */\n:host([data-js-focus-visible]:focus:not(.focus-visible)),\n:host([data-js-focus-visible]) :focus:not(.focus-visible) {\n  outline: none;\n}\n\n.container {\n  position: relative;\n}\n\n.userInput {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: relative;\n  overflow: hidden;\n}\n\ncanvas {\n  position: absolute;\n  display: none;\n  pointer-events: none;\n  /* NOTE(cdata): Chrome 76 and below apparently have a bug\n   * that causes our canvas not to display pixels unless it is\n   * on its own render layer\n   * @see https://github.com/google/model-viewer/pull/755#issuecomment-536597893\n   */\n  transform: translateZ(0);\n}\n\ncanvas.show {\n  display: block;\n}\n\n/* Adapted from HTML5 Boilerplate\n *\n * @see https://github.com/h5bp/html5-boilerplate/blob/ceb4620c78fc82e13534fc44202a3f168754873f/dist/css/main.css#L122-L133 */\n.screen-reader-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.slot {\n  position: absolute;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.slot > * {\n  pointer-events: initial;\n}\n\n.annotation-wrapper ::slotted(*) {\n  opacity: var(--max-hotspot-opacity, 1);\n  transition: opacity 0.3s;\n}\n\n.pointer-tumbling .annotation-wrapper ::slotted(*) {\n  pointer-events: none;\n}\n\n.annotation-wrapper ::slotted(*) {\n  pointer-events: initial;\n}\n\n.annotation-wrapper.hide ::slotted(*) {\n  opacity: var(--min-hotspot-opacity, 0.25);\n}\n\n.slot.poster {\n  opacity: 0;\n  transition: opacity 0.3s 0.3s;\n  background-color: inherit;\n}\n\n.slot.poster.show {\n  opacity: 1;\n  transition: none;\n}\n\n.slot.poster > * {\n  pointer-events: initial;\n}\n\n.slot.poster:not(.show) > * {\n  pointer-events: none;\n}\n\n#default-poster {\n  width: 100%;\n  height: 100%;\n  /* The default poster is a <button> so we need to set display\n   * to prevent it from being affected by text-align: */\n  display: block;\n  position: absolute;\n  border: none;\n  padding: 0;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: var(--poster-color, #fff);\n  background-image: var(--poster-image, none);\n}\n\n#default-progress-bar {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n#default-progress-bar > .mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--progress-mask, #fff);\n  transition: opacity 0.3s;\n  opacity: 0.2;\n}\n\n#default-progress-bar > .bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--progress-bar-height, 5px);\n  background-color: var(--progress-bar-color, rgba(0, 0, 0, 0.4));\n  transition: transform 0.09s;\n  transform-origin: top left;\n  transform: scaleX(0);\n  overflow: hidden;\n}\n\n#default-progress-bar > .bar.hide {\n  transition: opacity 0.3s 1s;\n  opacity: 0;\n}\n\n.slot.interaction-prompt {\n  display: var(--interaction-prompt-display, flex);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  align-items: center;\n  justify-content: center;\n\n  opacity: 0;\n  will-change: opacity;\n  overflow: hidden;\n  transition: opacity 0.3s;\n}\n\n.slot.interaction-prompt.visible {\n  opacity: 1;\n}\n\n.slot.interaction-prompt > .animated-container {\n  will-change: transform, opacity;\n}\n\n.slot.interaction-prompt > * {\n  pointer-events: none;\n}\n\n.slot.ar-button {\n  -moz-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n\n  display: var(--ar-button-display, block);\n}\n\n.slot.ar-button:not(.enabled) {\n  display: none;\n}\n\n.fab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  background-color: #fff;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 100px;\n}\n\n.fab > * {\n  opacity: 0.87;\n}\n\n#default-ar-button {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  transform: scale(var(--ar-button-scale, 1));\n  transform-origin: bottom right;\n}\n\n.slot.default {\n  pointer-events: none;\n}\n\n.slot.progress-bar {\n  pointer-events: none;\n}\n\n.slot.exit-webxr-ar-button {\n  pointer-events: none;\n}\n\n.slot.exit-webxr-ar-button:not(.enabled) {\n  display: none;\n}\n\n#default-exit-webxr-ar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n}\n\n#default-exit-webxr-ar-button > svg {\n  fill: #fff;\n}\n</style>\n<div class="container">\n  <div class="userInput" tabindex="0" role="img"\n      aria-label="A depiction of a 3D model"\n      aria-live="polite">\n      <div class="slot canvas">\n        <slot name="canvas">\n          <canvas></canvas>\n        </slot>\n      </div>\n  </div>\n\n  \x3c!-- NOTE(cdata): We need to wrap slots because browsers without ShadowDOM\n        will have their <slot> elements removed by ShadyCSS --\x3e\n  <div class="slot poster">\n    <slot name="poster">\n      <button type="button" id="default-poster" aria-hidden="true" aria-label="Activate to view in 3D!"></button>\n    </slot>\n  </div>\n\n  <div class="slot ar-button">\n    <slot name="ar-button">\n      <a id="default-ar-button" part="default-ar-button" class="fab"\n          tabindex="2"\n          aria-label="View this 3D model up close">\n        \n<svg version="1.1" id="view_x5F_in_x5F_AR_x5F_icon"\n\t xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px"\n\t viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">\n<rect id="Bounding_Box" x="0" y="0" fill="none" width="24" height="24"/>\n<g id="Art_layer">\n\t<path d="M3,4c0-0.55,0.45-1,1-1h2V1H4C2.35,1,1,2.35,1,4v2h2V4z"/>\n\t<path d="M20,3c0.55,0,1,0.45,1,1v2h2V4c0-1.65-1.35-3-3-3h-2v2H20z"/>\n\t<path d="M4,21c-0.55,0-1-0.45-1-1v-2H1v2c0,1.65,1.35,3,3,3h2v-2H4z"/>\n\t<path d="M20,21c0.55,0,1-0.45,1-1v-2h2v2c0,1.65-1.35,3-3,3h-2v-2H20z"/>\n\t<g>\n\t\t<path d="M18.25,7.6l-5.5-3.18c-0.46-0.27-1.04-0.27-1.5,0L5.75,7.6C5.29,7.87,5,8.36,5,8.9v6.35c0,0.54,0.29,1.03,0.75,1.3\n\t\t\tl5.5,3.18c0.46,0.27,1.04,0.27,1.5,0l5.5-3.18c0.46-0.27,0.75-0.76,0.75-1.3V8.9C19,8.36,18.71,7.87,18.25,7.6z M7,14.96v-4.62\n\t\t\tl4,2.32v4.61L7,14.96z M12,10.93L8,8.61l4-2.31l4,2.31L12,10.93z M13,17.27v-4.61l4-2.32v4.62L13,17.27z"/>\n\t</g>\n</g>\n</svg>\n      </a>\n    </slot>\n  </div>\n\n  <div class="slot interaction-prompt">\n    <div class="animated-container">\n      <slot name="interaction-prompt" aria-hidden="true">\n        \n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="36">\n    <defs>\n        <path id="A" d="M.001.232h24.997V36H.001z" />\n    </defs>\n    <g transform="translate(-11 -4)" fill="none" fill-rule="evenodd">\n        <path fill-opacity="0" fill="#fff" d="M0 0h44v44H0z" />\n        <g transform="translate(11 3)">\n            <path d="M8.733 11.165c.04-1.108.766-2.027 1.743-2.307a2.54 2.54 0 0 1 .628-.089c.16 0 .314.017.463.044 1.088.2 1.9 1.092 1.9 2.16v8.88h1.26c2.943-1.39 5-4.45 5-8.025a9.01 9.01 0 0 0-1.9-5.56l-.43-.5c-.765-.838-1.683-1.522-2.712-2-1.057-.49-2.226-.77-3.46-.77s-2.4.278-3.46.77c-1.03.478-1.947 1.162-2.71 2l-.43.5a9.01 9.01 0 0 0-1.9 5.56 9.04 9.04 0 0 0 .094 1.305c.03.21.088.41.13.617l.136.624c.083.286.196.56.305.832l.124.333a8.78 8.78 0 0 0 .509.953l.065.122a8.69 8.69 0 0 0 3.521 3.191l1.11.537v-9.178z" fill-opacity=".5" fill="#e4e4e4" />\n            <path d="M22.94 26.218l-2.76 7.74c-.172.485-.676.8-1.253.8H12.24c-1.606 0-3.092-.68-3.98-1.82-1.592-2.048-3.647-3.822-6.11-5.27-.095-.055-.15-.137-.152-.23-.004-.1.046-.196.193-.297.56-.393 1.234-.6 1.926-.6a3.43 3.43 0 0 1 .691.069l4.922.994V10.972c0-.663.615-1.203 1.37-1.203s1.373.54 1.373 1.203v9.882h2.953c.273 0 .533.073.757.21l6.257 3.874c.027.017.045.042.07.06.41.296.586.77.426 1.22M4.1 16.614c-.024-.04-.042-.083-.065-.122a8.69 8.69 0 0 1-.509-.953c-.048-.107-.08-.223-.124-.333l-.305-.832c-.058-.202-.09-.416-.136-.624l-.13-.617a9.03 9.03 0 0 1-.094-1.305c0-2.107.714-4.04 1.9-5.56l.43-.5c.764-.84 1.682-1.523 2.71-2 1.058-.49 2.226-.77 3.46-.77s2.402.28 3.46.77c1.03.477 1.947 1.16 2.712 2l.428.5a9 9 0 0 1 1.901 5.559c0 3.577-2.056 6.636-5 8.026h-1.26v-8.882c0-1.067-.822-1.96-1.9-2.16-.15-.028-.304-.044-.463-.044-.22 0-.427.037-.628.09-.977.28-1.703 1.198-1.743 2.306v9.178l-1.11-.537C6.18 19.098 4.96 18 4.1 16.614M22.97 24.09l-6.256-3.874c-.102-.063-.218-.098-.33-.144 2.683-1.8 4.354-4.855 4.354-8.243 0-.486-.037-.964-.104-1.43a9.97 9.97 0 0 0-1.57-4.128l-.295-.408-.066-.092a10.05 10.05 0 0 0-.949-1.078c-.342-.334-.708-.643-1.094-.922-1.155-.834-2.492-1.412-3.94-1.65l-.732-.088-.748-.03a9.29 9.29 0 0 0-1.482.119c-1.447.238-2.786.816-3.94 1.65a9.33 9.33 0 0 0-.813.686 9.59 9.59 0 0 0-.845.877l-.385.437-.36.5-.288.468-.418.778-.04.09c-.593 1.28-.93 2.71-.93 4.222 0 3.832 2.182 7.342 5.56 8.938l1.437.68v4.946L5 25.64a4.44 4.44 0 0 0-.888-.086c-.017 0-.034.003-.05.003-.252.004-.503.033-.75.08a5.08 5.08 0 0 0-.237.056c-.193.046-.382.107-.568.18-.075.03-.15.057-.225.1-.25.114-.494.244-.723.405a1.31 1.31 0 0 0-.566 1.122 1.28 1.28 0 0 0 .645 1.051C4 29.925 5.96 31.614 7.473 33.563a5.06 5.06 0 0 0 .434.491c1.086 1.082 2.656 1.713 4.326 1.715h6.697c.748-.001 1.43-.333 1.858-.872.142-.18.256-.38.336-.602l2.757-7.74c.094-.26.13-.53.112-.794s-.088-.52-.203-.76a2.19 2.19 0 0 0-.821-.91" fill-opacity=".6" fill="#000" />\n            <path d="M22.444 24.94l-6.257-3.874a1.45 1.45 0 0 0-.757-.211h-2.953v-9.88c0-.663-.616-1.203-1.373-1.203s-1.37.54-1.37 1.203v16.643l-4.922-.994a3.44 3.44 0 0 0-.692-.069 3.35 3.35 0 0 0-1.925.598c-.147.102-.198.198-.194.298.004.094.058.176.153.23 2.462 1.448 4.517 3.22 6.11 5.27.887 1.14 2.373 1.82 3.98 1.82h6.686c.577 0 1.08-.326 1.253-.8l2.76-7.74c.16-.448-.017-.923-.426-1.22-.025-.02-.043-.043-.07-.06z" fill="#fff" />\n            <g transform="translate(0 .769)">\n                <mask id="B" fill="#fff">\n                    <use xlink:href="#A" />\n                </mask>\n                <path d="M23.993 24.992a1.96 1.96 0 0 1-.111.794l-2.758 7.74c-.08.22-.194.423-.336.602-.427.54-1.11.87-1.857.872h-6.698c-1.67-.002-3.24-.633-4.326-1.715-.154-.154-.3-.318-.434-.49C5.96 30.846 4 29.157 1.646 27.773c-.385-.225-.626-.618-.645-1.05a1.31 1.31 0 0 1 .566-1.122 4.56 4.56 0 0 1 .723-.405l.225-.1a4.3 4.3 0 0 1 .568-.18l.237-.056c.248-.046.5-.075.75-.08.018 0 .034-.003.05-.003.303-.001.597.027.89.086l3.722.752V20.68l-1.436-.68c-3.377-1.596-5.56-5.106-5.56-8.938 0-1.51.336-2.94.93-4.222.015-.03.025-.06.04-.09.127-.267.268-.525.418-.778.093-.16.186-.316.288-.468.063-.095.133-.186.2-.277L3.773 5c.118-.155.26-.29.385-.437.266-.3.544-.604.845-.877a9.33 9.33 0 0 1 .813-.686C6.97 2.167 8.31 1.59 9.757 1.35a9.27 9.27 0 0 1 1.481-.119 8.82 8.82 0 0 1 .748.031c.247.02.49.05.733.088 1.448.238 2.786.816 3.94 1.65.387.28.752.588 1.094.922a9.94 9.94 0 0 1 .949 1.078l.066.092c.102.133.203.268.295.408a9.97 9.97 0 0 1 1.571 4.128c.066.467.103.945.103 1.43 0 3.388-1.67 6.453-4.353 8.243.11.046.227.08.33.144l6.256 3.874c.37.23.645.55.82.9.115.24.185.498.203.76m.697-1.195c-.265-.55-.677-1.007-1.194-1.326l-5.323-3.297c2.255-2.037 3.564-4.97 3.564-8.114 0-2.19-.637-4.304-1.84-6.114-.126-.188-.26-.37-.4-.552-.645-.848-1.402-1.6-2.252-2.204C15.472.91 13.393.232 11.238.232A10.21 10.21 0 0 0 5.23 2.19c-.848.614-1.606 1.356-2.253 2.205-.136.18-.272.363-.398.55C1.374 6.756.737 8.87.737 11.06c0 4.218 2.407 8.08 6.133 9.842l.863.41v3.092l-2.525-.51c-.356-.07-.717-.106-1.076-.106a5.45 5.45 0 0 0-3.14.996c-.653.46-1.022 1.202-.99 1.983a2.28 2.28 0 0 0 1.138 1.872c2.24 1.318 4.106 2.923 5.543 4.772 1.26 1.62 3.333 2.59 5.55 2.592h6.698c1.42-.001 2.68-.86 3.134-2.138l2.76-7.74c.272-.757.224-1.584-.134-2.325" fill-opacity=".05" fill="#000" mask="url(#B)" />\n            </g>\n        </g>\n    </g>\n</svg>\n      </slot>\n    </div>\n  </div>\n\n  <div class="slot default">\n    <slot></slot>\n\n    <div class="slot progress-bar">\n      <slot name="progress-bar">\n        <div id="default-progress-bar" aria-hidden="true">\n          <div class="mask" part="default-progress-mask"></div>\n          <div class="bar" part="default-progress-bar"></div>\n        </div>\n      </slot>\n    </div>\n    \n    <div class="slot exit-webxr-ar-button">\n      <slot name="exit-webxr-ar-button">\n        <a id="default-exit-webxr-ar-button" part="default-exit-webxr-ar-button"\n            tabindex="3"\n            aria-label="Exit AR"\n            aria-hidden="true">\n          \n<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="#000000">\n    \x3c!-- NOTE(cdata): This SVG filter is a stop-gap until we can implement\n         support for dynamic re-coloring of UI components --\x3e\n    <defs>\n      <filter id="drop-shadow" x="-100%" y="-100%" width="300%" height="300%">\n        <feGaussianBlur in="SourceAlpha" stdDeviation="1"/>\n        <feOffset dx="0" dy="0" result="offsetblur"/>\n        <feFlood flood-color="#000000"/>\n        <feComposite in2="offsetblur" operator="in"/>\n        <feMerge>\n          <feMergeNode/>\n          <feMergeNode in="SourceGraphic"/>\n        </feMerge>\n      </filter>\n    </defs>\n    <path filter="url(#drop-shadow)" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>\n        </a>\n      </slot>\n    </div>\n  </div>\n</div>';

var tt = /*#__PURE__*/function () {
  function tt() {
    _classCallCheck(this, tt);
  }

  _createClass(tt, [{
    key: "addEventListener",
    value: function addEventListener(t, e) {
      void 0 === this._listeners && (this._listeners = {});
      var n = this._listeners;
      void 0 === n[t] && (n[t] = []), -1 === n[t].indexOf(e) && n[t].push(e);
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(t, e) {
      if (void 0 === this._listeners) return !1;
      var n = this._listeners;
      return void 0 !== n[t] && -1 !== n[t].indexOf(e);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(t, e) {
      if (void 0 === this._listeners) return;
      var n = this._listeners[t];

      if (void 0 !== n) {
        var _t20 = n.indexOf(e);

        -1 !== _t20 && n.splice(_t20, 1);
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(t) {
      if (void 0 === this._listeners) return;
      var e = this._listeners[t.type];

      if (void 0 !== e) {
        t.target = this;

        var _n12 = e.slice(0);

        for (var _e14 = 0, _i10 = _n12.length; _e14 < _i10; _e14++) {
          _n12[_e14].call(this, t);
        }

        t.target = null;
      }
    }
  }]);

  return tt;
}();

var et = [];

for (var _t21 = 0; _t21 < 256; _t21++) {
  et[_t21] = (_t21 < 16 ? "0" : "") + _t21.toString(16);
}

var nt = 1234567;
var it = Math.PI / 180,
    rt = 180 / Math.PI;

function st() {
  var t = 4294967295 * Math.random() | 0,
      e = 4294967295 * Math.random() | 0,
      n = 4294967295 * Math.random() | 0,
      i = 4294967295 * Math.random() | 0;
  return (et[255 & t] + et[t >> 8 & 255] + et[t >> 16 & 255] + et[t >> 24 & 255] + "-" + et[255 & e] + et[e >> 8 & 255] + "-" + et[e >> 16 & 15 | 64] + et[e >> 24 & 255] + "-" + et[63 & n | 128] + et[n >> 8 & 255] + "-" + et[n >> 16 & 255] + et[n >> 24 & 255] + et[255 & i] + et[i >> 8 & 255] + et[i >> 16 & 255] + et[i >> 24 & 255]).toUpperCase();
}

function at(t, e, n) {
  return Math.max(e, Math.min(n, t));
}

function ot(t, e) {
  return (t % e + e) % e;
}

function lt(t, e, n) {
  return (1 - n) * t + n * e;
}

function ct(t) {
  return 0 == (t & t - 1) && 0 !== t;
}

function ht(t) {
  return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
}

function ut(t) {
  return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}

var dt = Object.freeze({
  __proto__: null,
  DEG2RAD: it,
  RAD2DEG: rt,
  generateUUID: st,
  clamp: at,
  euclideanModulo: ot,
  mapLinear: function mapLinear(t, e, n, i, r) {
    return i + (t - e) * (r - i) / (n - e);
  },
  inverseLerp: function inverseLerp(t, e, n) {
    return t !== e ? (n - t) / (e - t) : 0;
  },
  lerp: lt,
  damp: function damp(t, e, n, i) {
    return lt(t, e, 1 - Math.exp(-n * i));
  },
  pingpong: function pingpong(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return e - Math.abs(ot(t, 2 * e) - e);
  },
  smoothstep: function smoothstep(t, e, n) {
    return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * (3 - 2 * t);
  },
  smootherstep: function smootherstep(t, e, n) {
    return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e)) * t * t * (t * (6 * t - 15) + 10);
  },
  randInt: function randInt(t, e) {
    return t + Math.floor(Math.random() * (e - t + 1));
  },
  randFloat: function randFloat(t, e) {
    return t + Math.random() * (e - t);
  },
  randFloatSpread: function randFloatSpread(t) {
    return t * (.5 - Math.random());
  },
  seededRandom: function seededRandom(t) {
    return void 0 !== t && (nt = t % 2147483647), nt = 16807 * nt % 2147483647, (nt - 1) / 2147483646;
  },
  degToRad: function degToRad(t) {
    return t * it;
  },
  radToDeg: function radToDeg(t) {
    return t * rt;
  },
  isPowerOfTwo: ct,
  ceilPowerOfTwo: ht,
  floorPowerOfTwo: ut,
  setQuaternionFromProperEuler: function setQuaternionFromProperEuler(t, e, n, i, r) {
    var s = Math.cos,
        a = Math.sin,
        o = s(n / 2),
        l = a(n / 2),
        c = s((e + i) / 2),
        h = a((e + i) / 2),
        u = s((e - i) / 2),
        d = a((e - i) / 2),
        p = s((i - e) / 2),
        A = a((i - e) / 2);

    switch (r) {
      case "XYX":
        t.set(o * h, l * u, l * d, o * c);
        break;

      case "YZY":
        t.set(l * d, o * h, l * u, o * c);
        break;

      case "ZXZ":
        t.set(l * u, l * d, o * h, o * c);
        break;

      case "XZX":
        t.set(o * h, l * A, l * p, o * c);
        break;

      case "YXY":
        t.set(l * p, o * h, l * A, o * c);
        break;

      case "ZYZ":
        t.set(l * A, l * p, o * h, o * c);
        break;

      default:
        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
    }
  }
});

var pt = /*#__PURE__*/function () {
  function pt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, pt);

    this.x = t, this.y = e;
  }

  _createClass(pt, [{
    key: "width",
    get: function get() {
      return this.x;
    },
    set: function set(t) {
      this.x = t;
    }
  }, {
    key: "height",
    get: function get() {
      return this.y;
    },
    set: function set(t) {
      this.y = t;
    }
  }, {
    key: "set",
    value: function set(t, e) {
      return this.x = t, this.y = e, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.x *= t.x, this.y *= t.y, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this;
    }
  }, {
    key: "divide",
    value: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      var e = this.x,
          n = this.y,
          i = t.elements;
      return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y;
    }
  }, {
    key: "cross",
    value: function cross(t) {
      return this.x * t.y - this.y * t.x;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "angle",
    value: function angle() {
      return Math.atan2(-this.y, -this.x) + Math.PI;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(t) {
      var e = this.x - t.x,
          n = this.y - t.y;
      return e * e + n * n;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this;
    }
  }, {
    key: "rotateAround",
    value: function rotateAround(t, e) {
      var n = Math.cos(e),
          i = Math.sin(e),
          r = this.x - t.x,
          s = this.y - t.y;
      return this.x = r * n - s * i + t.x, this.y = r * i + s * n + t.y, this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this;
    }
  }]);

  return pt;
}();

pt.prototype.isVector2 = !0;

var At = /*#__PURE__*/function () {
  function At() {
    _classCallCheck(this, At);

    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
  }

  _createClass(At, [{
    key: "set",
    value: function set(t, e, n, i, r, s, a, o, l) {
      var c = this.elements;
      return c[0] = t, c[1] = i, c[2] = a, c[3] = e, c[4] = r, c[5] = o, c[6] = n, c[7] = s, c[8] = l, this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.elements,
          n = t.elements;
      return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(t, e, n) {
      return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
  }, {
    key: "setFromMatrix4",
    value: function setFromMatrix4(t) {
      var e = t.elements;
      return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.multiplyMatrices(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(t, e) {
      var n = t.elements,
          i = e.elements,
          r = this.elements,
          s = n[0],
          a = n[3],
          o = n[6],
          l = n[1],
          c = n[4],
          h = n[7],
          u = n[2],
          d = n[5],
          p = n[8],
          A = i[0],
          m = i[3],
          g = i[6],
          f = i[1],
          v = i[4],
          y = i[7],
          x = i[2],
          w = i[5],
          E = i[8];
      return r[0] = s * A + a * f + o * x, r[3] = s * m + a * v + o * w, r[6] = s * g + a * y + o * E, r[1] = l * A + c * f + h * x, r[4] = l * m + c * v + h * w, r[7] = l * g + c * y + h * E, r[2] = u * A + d * f + p * x, r[5] = u * m + d * v + p * w, r[8] = u * g + d * y + p * E, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      var e = this.elements;
      return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          c = t[8];
      return e * s * c - e * a * l - n * r * c + n * a * o + i * r * l - i * s * o;
    }
  }, {
    key: "invert",
    value: function invert() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          c = t[8],
          h = c * s - a * l,
          u = a * o - c * r,
          d = l * r - s * o,
          p = e * h + n * u + i * d;
      if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var A = 1 / p;
      return t[0] = h * A, t[1] = (i * l - c * n) * A, t[2] = (a * n - i * s) * A, t[3] = u * A, t[4] = (c * e - i * o) * A, t[5] = (i * r - a * e) * A, t[6] = d * A, t[7] = (n * o - l * e) * A, t[8] = (s * e - n * r) * A, this;
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var t;
      var e = this.elements;
      return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
  }, {
    key: "getNormalMatrix",
    value: function getNormalMatrix(t) {
      return this.setFromMatrix4(t).invert().transpose();
    }
  }, {
    key: "transposeIntoArray",
    value: function transposeIntoArray(t) {
      var e = this.elements;
      return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
  }, {
    key: "setUvTransform",
    value: function setUvTransform(t, e, n, i, r, s, a) {
      var o = Math.cos(r),
          l = Math.sin(r);
      return this.set(n * o, n * l, -n * (o * s + l * a) + s + t, -i * l, i * o, -i * (-l * s + o * a) + a + e, 0, 0, 1), this;
    }
  }, {
    key: "scale",
    value: function scale(t, e) {
      var n = this.elements;
      return n[0] *= t, n[3] *= t, n[6] *= t, n[1] *= e, n[4] *= e, n[7] *= e, this;
    }
  }, {
    key: "rotate",
    value: function rotate(t) {
      var e = Math.cos(t),
          n = Math.sin(t),
          i = this.elements,
          r = i[0],
          s = i[3],
          a = i[6],
          o = i[1],
          l = i[4],
          c = i[7];
      return i[0] = e * r + n * o, i[3] = e * s + n * l, i[6] = e * a + n * c, i[1] = -n * r + e * o, i[4] = -n * s + e * l, i[7] = -n * a + e * c, this;
    }
  }, {
    key: "translate",
    value: function translate(t, e) {
      var n = this.elements;
      return n[0] += t * n[2], n[3] += t * n[5], n[6] += t * n[8], n[1] += e * n[2], n[4] += e * n[5], n[7] += e * n[8], this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      var e = this.elements,
          n = t.elements;

      for (var _t22 = 0; _t22 < 9; _t22++) {
        if (e[_t22] !== n[_t22]) return !1;
      }

      return !0;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _n13 = 0; _n13 < 9; _n13++) {
        this.elements[_n13] = t[_n13 + e];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.elements;
      return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }]);

  return At;
}();

var mt;
At.prototype.isMatrix3 = !0;

var gt = /*#__PURE__*/function () {
  function gt() {
    _classCallCheck(this, gt);
  }

  _createClass(gt, null, [{
    key: "getDataURL",
    value: function getDataURL(t) {
      if (/^data:/i.test(t.src)) return t.src;
      if ("undefined" == typeof HTMLCanvasElement) return t.src;
      var e;
      if (t instanceof HTMLCanvasElement) e = t;else {
        void 0 === mt && (mt = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas")), mt.width = t.width, mt.height = t.height;

        var _n14 = mt.getContext("2d");

        t instanceof ImageData ? _n14.putImageData(t, 0, 0) : _n14.drawImage(t, 0, 0, t.width, t.height), e = mt;
      }
      return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
  }]);

  return gt;
}();

var ft = 0;

var vt = /*#__PURE__*/function (_tt) {
  _inherits(vt, _tt);

  var _super3 = _createSuper(vt);

  function vt() {
    var _this9;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : vt.DEFAULT_IMAGE;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vt.DEFAULT_MAPPING;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1001;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1001;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1006;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1008;
    var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1023;
    var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1009;
    var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
    var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 3e3;

    _classCallCheck(this, vt);

    _this9 = _super3.call(this), Object.defineProperty(_assertThisInitialized(_this9), "id", {
      value: ft++
    }), _this9.uuid = st(), _this9.name = "", _this9.image = t, _this9.mipmaps = [], _this9.mapping = e, _this9.wrapS = n, _this9.wrapT = i, _this9.magFilter = r, _this9.minFilter = s, _this9.anisotropy = l, _this9.format = a, _this9.internalFormat = null, _this9.type = o, _this9.offset = new pt(0, 0), _this9.repeat = new pt(1, 1), _this9.center = new pt(0, 0), _this9.rotation = 0, _this9.matrixAutoUpdate = !0, _this9.matrix = new At(), _this9.generateMipmaps = !0, _this9.premultiplyAlpha = !1, _this9.flipY = !0, _this9.unpackAlignment = 4, _this9.encoding = c, _this9.version = 0, _this9.onUpdate = null, _this9.isRenderTargetTexture = !1;
    return _this9;
  }

  _createClass(vt, [{
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.name = t.name, this.image = t.image, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t;
      if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
      var n = {
        metadata: {
          version: 4.5,
          type: "Texture",
          generator: "Texture.toJSON"
        },
        uuid: this.uuid,
        name: this.name,
        mapping: this.mapping,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        type: this.type,
        encoding: this.encoding,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };

      if (void 0 !== this.image) {
        var _i11 = this.image;

        if (void 0 === _i11.uuid && (_i11.uuid = st()), !e && void 0 === t.images[_i11.uuid]) {
          var _e15;

          if (Array.isArray(_i11)) {
            _e15 = [];

            for (var _t23 = 0, _n15 = _i11.length; _t23 < _n15; _t23++) {
              _i11[_t23].isDataTexture ? _e15.push(yt(_i11[_t23].image)) : _e15.push(yt(_i11[_t23]));
            }
          } else _e15 = yt(_i11);

          t.images[_i11.uuid] = {
            uuid: _i11.uuid,
            url: _e15
          };
        }

        n.image = _i11.uuid;
      }

      return e || (t.textures[this.uuid] = n), n;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }, {
    key: "transformUv",
    value: function transformUv(t) {
      if (300 !== this.mapping) return t;
      if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch (this.wrapS) {
        case 1e3:
          t.x = t.x - Math.floor(t.x);
          break;

        case 1001:
          t.x = t.x < 0 ? 0 : 1;
          break;

        case 1002:
          1 === Math.abs(Math.floor(t.x) % 2) ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
      }
      if (t.y < 0 || t.y > 1) switch (this.wrapT) {
        case 1e3:
          t.y = t.y - Math.floor(t.y);
          break;

        case 1001:
          t.y = t.y < 0 ? 0 : 1;
          break;

        case 1002:
          1 === Math.abs(Math.floor(t.y) % 2) ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
      }
      return this.flipY && (t.y = 1 - t.y), t;
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }]);

  return vt;
}(tt);

function yt(t) {
  return "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap ? gt.getDataURL(t) : t.data ? {
    data: Array.prototype.slice.call(t.data),
    width: t.width,
    height: t.height,
    type: t.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}

vt.DEFAULT_IMAGE = void 0, vt.DEFAULT_MAPPING = 300, vt.prototype.isTexture = !0;

var xt = /*#__PURE__*/function () {
  function xt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, xt);

    this.x = t, this.y = e, this.z = n, this.w = i;
  }

  _createClass(xt, [{
    key: "width",
    get: function get() {
      return this.z;
    },
    set: function set(t) {
      this.z = t;
    }
  }, {
    key: "height",
    get: function get() {
      return this.w;
    },
    set: function set(t) {
      this.w = t;
    }
  }, {
    key: "set",
    value: function set(t, e, n, i) {
      return this.x = t, this.y = e, this.z = n, this.w = i, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t) {
      return this.z = t, this;
    }
  }, {
    key: "setW",
    value: function setW(t) {
      return this.w = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        case 2:
          this.z = e;
          break;

        case 3:
          this.w = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        case 3:
          return this.w;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this.w = void 0 !== t.w ? t.w : 1, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = this.w,
          s = t.elements;
      return this.x = s[0] * e + s[4] * n + s[8] * i + s[12] * r, this.y = s[1] * e + s[5] * n + s[9] * i + s[13] * r, this.z = s[2] * e + s[6] * n + s[10] * i + s[14] * r, this.w = s[3] * e + s[7] * n + s[11] * i + s[15] * r, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "setAxisAngleFromQuaternion",
    value: function setAxisAngleFromQuaternion(t) {
      this.w = 2 * Math.acos(t.w);
      var e = Math.sqrt(1 - t.w * t.w);
      return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
  }, {
    key: "setAxisAngleFromRotationMatrix",
    value: function setAxisAngleFromRotationMatrix(t) {
      var e, n, i, r;
      var s = .01,
          a = .1,
          o = t.elements,
          l = o[0],
          c = o[4],
          h = o[8],
          u = o[1],
          d = o[5],
          p = o[9],
          A = o[2],
          m = o[6],
          g = o[10];

      if (Math.abs(c - u) < s && Math.abs(h - A) < s && Math.abs(p - m) < s) {
        if (Math.abs(c + u) < a && Math.abs(h + A) < a && Math.abs(p + m) < a && Math.abs(l + d + g - 3) < a) return this.set(1, 0, 0, 0), this;
        e = Math.PI;

        var _t24 = (l + 1) / 2,
            _o4 = (d + 1) / 2,
            _f2 = (g + 1) / 2,
            _v2 = (c + u) / 4,
            _y = (h + A) / 4,
            _x = (p + m) / 4;

        return _t24 > _o4 && _t24 > _f2 ? _t24 < s ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(_t24), i = _v2 / n, r = _y / n) : _o4 > _f2 ? _o4 < s ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(_o4), n = _v2 / i, r = _x / i) : _f2 < s ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(_f2), n = _y / r, i = _x / r), this.set(n, i, r, e), this;
      }

      var f = Math.sqrt((m - p) * (m - p) + (h - A) * (h - A) + (u - c) * (u - c));
      return Math.abs(f) < .001 && (f = 1), this.x = (m - p) / f, this.y = (h - A) / f, this.z = (u - c) / f, this.w = Math.acos((l + d + g - 1) / 2), this;
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this.w = t.w + (e.w - t.w) * n, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
  }]);

  return xt;
}();

xt.prototype.isVector4 = !0;

var wt = /*#__PURE__*/function (_tt2) {
  _inherits(wt, _tt2);

  var _super4 = _createSuper(wt);

  function wt(t, e) {
    var _this10;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, wt);

    _this10 = _super4.call(this), _this10.width = t, _this10.height = e, _this10.depth = 1, _this10.scissor = new xt(0, 0, t, e), _this10.scissorTest = !1, _this10.viewport = new xt(0, 0, t, e), _this10.texture = new vt(void 0, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), _this10.texture.isRenderTargetTexture = !0, _this10.texture.image = {
      width: t,
      height: e,
      depth: 1
    }, _this10.texture.generateMipmaps = void 0 !== n.generateMipmaps && n.generateMipmaps, _this10.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, _this10.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, _this10.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer, _this10.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null;
    return _this10;
  }

  _createClass(wt, [{
    key: "setTexture",
    value: function setTexture(t) {
      t.image = {
        width: this.width,
        height: this.height,
        depth: this.depth
      }, this.texture = t;
    }
  }, {
    key: "setSize",
    value: function setSize(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      this.width === t && this.height === e && this.depth === n || (this.width = t, this.height = e, this.depth = n, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.image = _objectSpread({}, this.texture.image), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.depthTexture = t.depthTexture, this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return wt;
}(tt);

wt.prototype.isWebGLRenderTarget = !0;

/*#__PURE__*/
(function (_wt) {
  _inherits(_class2, _wt);

  var _super5 = _createSuper(_class2);

  function _class2(t, e, n) {
    var _this11;

    _classCallCheck(this, _class2);

    _this11 = _super5.call(this, t, e);
    var i = _this11.texture;
    _this11.texture = [];

    for (var _t25 = 0; _t25 < n; _t25++) {
      _this11.texture[_t25] = i.clone();
    }

    return _this11;
  }

  _createClass(_class2, [{
    key: "setSize",
    value: function setSize(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.width !== t || this.height !== e || this.depth !== n) {
        this.width = t, this.height = e, this.depth = n;

        for (var _i12 = 0, _r5 = this.texture.length; _i12 < _r5; _i12++) {
          this.texture[_i12].image.width = t, this.texture[_i12].image.height = e, this.texture[_i12].image.depth = n;
        }

        this.dispose();
      }

      return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.depthTexture = t.depthTexture, this.texture.length = 0;

      for (var _e16 = 0, _n16 = t.texture.length; _e16 < _n16; _e16++) {
        this.texture[_e16] = t.texture[_e16].clone();
      }

      return this;
    }
  }]);

  return _class2;
})(wt).prototype.isWebGLMultipleRenderTargets = !0;

var Et = /*#__PURE__*/function (_wt2) {
  _inherits(Et, _wt2);

  var _super6 = _createSuper(Et);

  function Et(t, e, n) {
    var _this12;

    _classCallCheck(this, Et);

    _this12 = _super6.call(this, t, e, n), _this12.samples = 4;
    return _this12;
  }

  _createClass(Et, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Et.prototype), "copy", this).call(this, t), this.samples = t.samples, this;
    }
  }]);

  return Et;
}(wt);

Et.prototype.isWebGLMultisampleRenderTarget = !0;

var bt = /*#__PURE__*/function () {
  function bt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, bt);

    this._x = t, this._y = e, this._z = n, this._w = i;
  }

  _createClass(bt, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(t) {
      this._x = t, this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(t) {
      this._y = t, this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(t) {
      this._z = t, this._onChangeCallback();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(t) {
      this._w = t, this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(t, e, n, i) {
      return this._x = t, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(t, e) {
      if (!t || !t.isEuler) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
      var n = t._x,
          i = t._y,
          r = t._z,
          s = t._order,
          a = Math.cos,
          o = Math.sin,
          l = a(n / 2),
          c = a(i / 2),
          h = a(r / 2),
          u = o(n / 2),
          d = o(i / 2),
          p = o(r / 2);

      switch (s) {
        case "XYZ":
          this._x = u * c * h + l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h - u * d * p;
          break;

        case "YXZ":
          this._x = u * c * h + l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h + u * d * p;
          break;

        case "ZXY":
          this._x = u * c * h - l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h - u * d * p;
          break;

        case "ZYX":
          this._x = u * c * h - l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h + u * d * p;
          break;

        case "YZX":
          this._x = u * c * h + l * d * p, this._y = l * d * h + u * c * p, this._z = l * c * p - u * d * h, this._w = l * c * h - u * d * p;
          break;

        case "XZY":
          this._x = u * c * h - l * d * p, this._y = l * d * h - u * c * p, this._z = l * c * p + u * d * h, this._w = l * c * h + u * d * p;
          break;

        default:
          console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + s);
      }

      return !1 !== e && this._onChangeCallback(), this;
    }
  }, {
    key: "setFromAxisAngle",
    value: function setFromAxisAngle(t, e) {
      var n = e / 2,
          i = Math.sin(n);
      return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(t) {
      var e = t.elements,
          n = e[0],
          i = e[4],
          r = e[8],
          s = e[1],
          a = e[5],
          o = e[9],
          l = e[2],
          c = e[6],
          h = e[10],
          u = n + a + h;

      if (u > 0) {
        var _t26 = .5 / Math.sqrt(u + 1);

        this._w = .25 / _t26, this._x = (c - o) * _t26, this._y = (r - l) * _t26, this._z = (s - i) * _t26;
      } else if (n > a && n > h) {
        var _t27 = 2 * Math.sqrt(1 + n - a - h);

        this._w = (c - o) / _t27, this._x = .25 * _t27, this._y = (i + s) / _t27, this._z = (r + l) / _t27;
      } else if (a > h) {
        var _t28 = 2 * Math.sqrt(1 + a - n - h);

        this._w = (r - l) / _t28, this._x = (i + s) / _t28, this._y = .25 * _t28, this._z = (o + c) / _t28;
      } else {
        var _t29 = 2 * Math.sqrt(1 + h - n - a);

        this._w = (s - i) / _t29, this._x = (r + l) / _t29, this._y = (o + c) / _t29, this._z = .25 * _t29;
      }

      return this._onChangeCallback(), this;
    }
  }, {
    key: "setFromUnitVectors",
    value: function setFromUnitVectors(t, e) {
      var n = t.dot(e) + 1;
      return n < Number.EPSILON ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = n), this.normalize();
    }
  }, {
    key: "angleTo",
    value: function angleTo(t) {
      return 2 * Math.acos(Math.abs(at(this.dot(t), -1, 1)));
    }
  }, {
    key: "rotateTowards",
    value: function rotateTowards(t, e) {
      var n = this.angleTo(t);
      if (0 === n) return this;
      var i = Math.min(1, e / n);
      return this.slerp(t, i), this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(0, 0, 0, 1);
    }
  }, {
    key: "invert",
    value: function invert() {
      return this.conjugate();
    }
  }, {
    key: "conjugate",
    value: function conjugate() {
      return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var t = this.length();
      return 0 === t ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t, e)) : this.multiplyQuaternions(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyQuaternions(t, this);
    }
  }, {
    key: "multiplyQuaternions",
    value: function multiplyQuaternions(t, e) {
      var n = t._x,
          i = t._y,
          r = t._z,
          s = t._w,
          a = e._x,
          o = e._y,
          l = e._z,
          c = e._w;
      return this._x = n * c + s * a + i * l - r * o, this._y = i * c + s * o + r * a - n * l, this._z = r * c + s * l + n * o - i * a, this._w = s * c - n * a - i * o - r * l, this._onChangeCallback(), this;
    }
  }, {
    key: "slerp",
    value: function slerp(t, e) {
      if (0 === e) return this;
      if (1 === e) return this.copy(t);
      var n = this._x,
          i = this._y,
          r = this._z,
          s = this._w;
      var a = s * t._w + n * t._x + i * t._y + r * t._z;
      if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = s, this._x = n, this._y = i, this._z = r, this;
      var o = 1 - a * a;

      if (o <= Number.EPSILON) {
        var _t30 = 1 - e;

        return this._w = _t30 * s + e * this._w, this._x = _t30 * n + e * this._x, this._y = _t30 * i + e * this._y, this._z = _t30 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
      }

      var l = Math.sqrt(o),
          c = Math.atan2(l, a),
          h = Math.sin((1 - e) * c) / l,
          u = Math.sin(e * c) / l;
      return this._w = s * h + this._w * u, this._x = n * h + this._x * u, this._y = i * h + this._y * u, this._z = r * h + this._z * u, this._onChangeCallback(), this;
    }
  }, {
    key: "slerpQuaternions",
    value: function slerpQuaternions(t, e, n) {
      this.copy(t).slerp(e, n);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e) {
      return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
  }, {
    key: "_onChange",
    value: function _onChange(t) {
      return this._onChangeCallback = t, this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }], [{
    key: "slerp",
    value: function slerp(t, e, n, i) {
      return console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."), n.slerpQuaternions(t, e, i);
    }
  }, {
    key: "slerpFlat",
    value: function slerpFlat(t, e, n, i, r, s, a) {
      var o = n[i + 0],
          l = n[i + 1],
          c = n[i + 2],
          h = n[i + 3];
      var u = r[s + 0],
          d = r[s + 1],
          p = r[s + 2],
          A = r[s + 3];
      if (0 === a) return t[e + 0] = o, t[e + 1] = l, t[e + 2] = c, void (t[e + 3] = h);
      if (1 === a) return t[e + 0] = u, t[e + 1] = d, t[e + 2] = p, void (t[e + 3] = A);

      if (h !== A || o !== u || l !== d || c !== p) {
        var _t31 = 1 - a;

        var _e17 = o * u + l * d + c * p + h * A,
            _n17 = _e17 >= 0 ? 1 : -1,
            _i13 = 1 - _e17 * _e17;

        if (_i13 > Number.EPSILON) {
          var _r7 = Math.sqrt(_i13),
              _s8 = Math.atan2(_r7, _e17 * _n17);

          _t31 = Math.sin(_t31 * _s8) / _r7, a = Math.sin(a * _s8) / _r7;
        }

        var _r6 = a * _n17;

        if (o = o * _t31 + u * _r6, l = l * _t31 + d * _r6, c = c * _t31 + p * _r6, h = h * _t31 + A * _r6, _t31 === 1 - a) {
          var _t32 = 1 / Math.sqrt(o * o + l * l + c * c + h * h);

          o *= _t32, l *= _t32, c *= _t32, h *= _t32;
        }
      }

      t[e] = o, t[e + 1] = l, t[e + 2] = c, t[e + 3] = h;
    }
  }, {
    key: "multiplyQuaternionsFlat",
    value: function multiplyQuaternionsFlat(t, e, n, i, r, s) {
      var a = n[i],
          o = n[i + 1],
          l = n[i + 2],
          c = n[i + 3],
          h = r[s],
          u = r[s + 1],
          d = r[s + 2],
          p = r[s + 3];
      return t[e] = a * p + c * h + o * d - l * u, t[e + 1] = o * p + c * u + l * h - a * d, t[e + 2] = l * p + c * d + a * u - o * h, t[e + 3] = c * p - a * h - o * u - l * d, t;
    }
  }]);

  return bt;
}();

bt.prototype.isQuaternion = !0;

var _t = /*#__PURE__*/function () {
  function _t() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, _t);

    this.x = t, this.y = e, this.z = n;
  }

  _createClass(_t, [{
    key: "set",
    value: function set(t, e, n) {
      return void 0 === n && (n = this.z), this.x = t, this.y = e, this.z = n, this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.x = t, this.y = t, this.z = t, this;
    }
  }, {
    key: "setX",
    value: function setX(t) {
      return this.x = t, this;
    }
  }, {
    key: "setY",
    value: function setY(t) {
      return this.y = t, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t) {
      return this.z = t, this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(t, e) {
      switch (t) {
        case 0:
          this.x = e;
          break;

        case 1:
          this.y = e;
          break;

        case 2:
          this.z = e;
          break;

        default:
          throw new Error("index is out of range: " + t);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(t) {
      switch (t) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        default:
          throw new Error("index is out of range: " + t);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
  }, {
    key: "add",
    value: function add(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e)) : (this.x += t.x, this.y += t.y, this.z += t.z, this);
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.x += t, this.y += t, this.z += t, this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(t, e) {
      return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(t, e) {
      return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
  }, {
    key: "sub",
    value: function sub(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e)) : (this.x -= t.x, this.y -= t.y, this.z -= t.z, this);
    }
  }, {
    key: "subScalar",
    value: function subScalar(t) {
      return this.x -= t, this.y -= t, this.z -= t, this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(t, e) {
      return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t, e)) : (this.x *= t.x, this.y *= t.y, this.z *= t.z, this);
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.x *= t, this.y *= t, this.z *= t, this;
    }
  }, {
    key: "multiplyVectors",
    value: function multiplyVectors(t, e) {
      return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
  }, {
    key: "applyEuler",
    value: function applyEuler(t) {
      return t && t.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(Ct.setFromEuler(t));
    }
  }, {
    key: "applyAxisAngle",
    value: function applyAxisAngle(t, e) {
      return this.applyQuaternion(Ct.setFromAxisAngle(t, e));
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements;
      return this.x = r[0] * e + r[3] * n + r[6] * i, this.y = r[1] * e + r[4] * n + r[7] * i, this.z = r[2] * e + r[5] * n + r[8] * i, this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      return this.applyMatrix3(t).normalize();
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements,
          s = 1 / (r[3] * e + r[7] * n + r[11] * i + r[15]);
      return this.x = (r[0] * e + r[4] * n + r[8] * i + r[12]) * s, this.y = (r[1] * e + r[5] * n + r[9] * i + r[13]) * s, this.z = (r[2] * e + r[6] * n + r[10] * i + r[14]) * s, this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.x,
          s = t.y,
          a = t.z,
          o = t.w,
          l = o * e + s * i - a * n,
          c = o * n + a * e - r * i,
          h = o * i + r * n - s * e,
          u = -r * e - s * n - a * i;
      return this.x = l * o + u * -r + c * -a - h * -s, this.y = c * o + u * -s + h * -r - l * -a, this.z = h * o + u * -a + l * -s - c * -r, this;
    }
  }, {
    key: "project",
    value: function project(t) {
      return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
  }, {
    key: "unproject",
    value: function unproject(t) {
      return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      var e = this.x,
          n = this.y,
          i = this.z,
          r = t.elements;
      return this.x = r[0] * e + r[4] * n + r[8] * i, this.y = r[1] * e + r[5] * n + r[9] * i, this.z = r[2] * e + r[6] * n + r[10] * i, this.normalize();
    }
  }, {
    key: "divide",
    value: function divide(t) {
      return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(t) {
      return this.multiplyScalar(1 / t);
    }
  }, {
    key: "min",
    value: function min(t) {
      return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
  }, {
    key: "max",
    value: function max(t) {
      return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
  }, {
    key: "clamp",
    value: function clamp(t, e) {
      return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(t, e) {
      return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(t, e) {
      var n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
  }, {
    key: "dot",
    value: function dot(t) {
      return this.x * t.x + this.y * t.y + this.z * t.z;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(t) {
      return this.normalize().multiplyScalar(t);
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(t, e, n) {
      return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this;
    }
  }, {
    key: "cross",
    value: function cross(t, e) {
      return void 0 !== e ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t, e)) : this.crossVectors(this, t);
    }
  }, {
    key: "crossVectors",
    value: function crossVectors(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = e.x,
          a = e.y,
          o = e.z;
      return this.x = i * o - r * a, this.y = r * s - n * o, this.z = n * a - i * s, this;
    }
  }, {
    key: "projectOnVector",
    value: function projectOnVector(t) {
      var e = t.lengthSq();
      if (0 === e) return this.set(0, 0, 0);
      var n = t.dot(this) / e;
      return this.copy(t).multiplyScalar(n);
    }
  }, {
    key: "projectOnPlane",
    value: function projectOnPlane(t) {
      return It.copy(this).projectOnVector(t), this.sub(It);
    }
  }, {
    key: "reflect",
    value: function reflect(t) {
      return this.sub(It.copy(t).multiplyScalar(2 * this.dot(t)));
    }
  }, {
    key: "angleTo",
    value: function angleTo(t) {
      var e = Math.sqrt(this.lengthSq() * t.lengthSq());
      if (0 === e) return Math.PI / 2;
      var n = this.dot(t) / e;
      return Math.acos(at(n, -1, 1));
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(t) {
      return Math.sqrt(this.distanceToSquared(t));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(t) {
      var e = this.x - t.x,
          n = this.y - t.y,
          i = this.z - t.z;
      return e * e + n * n + i * i;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(t) {
      return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
  }, {
    key: "setFromSpherical",
    value: function setFromSpherical(t) {
      return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
  }, {
    key: "setFromSphericalCoords",
    value: function setFromSphericalCoords(t, e, n) {
      var i = Math.sin(e) * t;
      return this.x = i * Math.sin(n), this.y = Math.cos(e) * t, this.z = i * Math.cos(n), this;
    }
  }, {
    key: "setFromCylindrical",
    value: function setFromCylindrical(t) {
      return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
  }, {
    key: "setFromCylindricalCoords",
    value: function setFromCylindricalCoords(t, e, n) {
      return this.x = t * Math.sin(e), this.y = n, this.z = t * Math.cos(e), this;
    }
  }, {
    key: "setFromMatrixPosition",
    value: function setFromMatrixPosition(t) {
      var e = t.elements;
      return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
  }, {
    key: "setFromMatrixScale",
    value: function setFromMatrixScale(t) {
      var e = this.setFromMatrixColumn(t, 0).length(),
          n = this.setFromMatrixColumn(t, 1).length(),
          i = this.setFromMatrixColumn(t, 2).length();
      return this.x = e, this.y = n, this.z = i, this;
    }
  }, {
    key: "setFromMatrixColumn",
    value: function setFromMatrixColumn(t, e) {
      return this.fromArray(t.elements, 4 * e);
    }
  }, {
    key: "setFromMatrix3Column",
    value: function setFromMatrix3Column(t, e) {
      return this.fromArray(t.elements, 3 * e);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.x === this.x && t.y === this.y && t.z === this.z;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e, n) {
      return void 0 !== n && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
  }, {
    key: "random",
    value: function random() {
      return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
  }]);

  return _t;
}();

_t.prototype.isVector3 = !0;
var It = new _t(),
    Ct = new bt();

var Mt = /*#__PURE__*/function () {
  function Mt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t(1 / 0, 1 / 0, 1 / 0);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t(-1 / 0, -1 / 0, -1 / 0);

    _classCallCheck(this, Mt);

    this.min = t, this.max = e;
  }

  _createClass(Mt, [{
    key: "set",
    value: function set(t, e) {
      return this.min.copy(t), this.max.copy(e), this;
    }
  }, {
    key: "setFromArray",
    value: function setFromArray(t) {
      var e = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          s = -1 / 0,
          a = -1 / 0;

      for (var _o5 = 0, _l2 = t.length; _o5 < _l2; _o5 += 3) {
        var _l3 = t[_o5],
            _c2 = t[_o5 + 1],
            _h2 = t[_o5 + 2];
        _l3 < e && (e = _l3), _c2 < n && (n = _c2), _h2 < i && (i = _h2), _l3 > r && (r = _l3), _c2 > s && (s = _c2), _h2 > a && (a = _h2);
      }

      return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
  }, {
    key: "setFromBufferAttribute",
    value: function setFromBufferAttribute(t) {
      var e = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          s = -1 / 0,
          a = -1 / 0;

      for (var _o6 = 0, _l4 = t.count; _o6 < _l4; _o6++) {
        var _l5 = t.getX(_o6),
            _c3 = t.getY(_o6),
            _h3 = t.getZ(_o6);

        _l5 < e && (e = _l5), _c3 < n && (n = _c3), _h3 < i && (i = _h3), _l5 > r && (r = _l5), _c3 > s && (s = _c3), _h3 > a && (a = _h3);
      }

      return this.min.set(e, n, i), this.max.set(r, s, a), this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t) {
      this.makeEmpty();

      for (var _e18 = 0, _n18 = t.length; _e18 < _n18; _e18++) {
        this.expandByPoint(t[_e18]);
      }

      return this;
    }
  }, {
    key: "setFromCenterAndSize",
    value: function setFromCenterAndSize(t, e) {
      var n = Bt.copy(e).multiplyScalar(.5);
      return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
    }
  }, {
    key: "setFromObject",
    value: function setFromObject(t) {
      return this.makeEmpty(), this.expandByObject(t);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.min.copy(t.min), this.max.copy(t.max), this;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
  }, {
    key: "getCenter",
    value: function getCenter(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
  }, {
    key: "getSize",
    value: function getSize(t) {
      return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(t) {
      return this.min.min(t), this.max.max(t), this;
    }
  }, {
    key: "expandByVector",
    value: function expandByVector(t) {
      return this.min.sub(t), this.max.add(t), this;
    }
  }, {
    key: "expandByScalar",
    value: function expandByScalar(t) {
      return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
  }, {
    key: "expandByObject",
    value: function expandByObject(t) {
      t.updateWorldMatrix(!1, !1);
      var e = t.geometry;
      void 0 !== e && (null === e.boundingBox && e.computeBoundingBox(), Tt.copy(e.boundingBox), Tt.applyMatrix4(t.matrixWorld), this.union(Tt));
      var n = t.children;

      for (var _t33 = 0, _e19 = n.length; _t33 < _e19; _t33++) {
        this.expandByObject(n[_t33]);
      }

      return this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
  }, {
    key: "containsBox",
    value: function containsBox(t) {
      return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
  }, {
    key: "getParameter",
    value: function getParameter(t, e) {
      return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return this.clampPoint(t.center, Bt), Bt.distanceToSquared(t.center) <= t.radius * t.radius;
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      var e, n;
      return t.normal.x > 0 ? (e = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, n += t.normal.z * this.min.z), e <= -t.constant && n >= -t.constant;
    }
  }, {
    key: "intersectsTriangle",
    value: function intersectsTriangle(t) {
      if (this.isEmpty()) return !1;
      this.getCenter(Nt), Ut.subVectors(this.max, Nt), Lt.subVectors(t.a, Nt), Rt.subVectors(t.b, Nt), Dt.subVectors(t.c, Nt), Qt.subVectors(Rt, Lt), Pt.subVectors(Dt, Rt), Ft.subVectors(Lt, Dt);
      var e = [0, -Qt.z, Qt.y, 0, -Pt.z, Pt.y, 0, -Ft.z, Ft.y, Qt.z, 0, -Qt.x, Pt.z, 0, -Pt.x, Ft.z, 0, -Ft.x, -Qt.y, Qt.x, 0, -Pt.y, Pt.x, 0, -Ft.y, Ft.x, 0];
      return !!Ot(e, Lt, Rt, Dt, Ut) && (e = [1, 0, 0, 0, 1, 0, 0, 0, 1], !!Ot(e, Lt, Rt, Dt, Ut) && (kt.crossVectors(Qt, Pt), e = [kt.x, kt.y, kt.z], Ot(e, Lt, Rt, Dt, Ut)));
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(t, e) {
      return e.copy(t).clamp(this.min, this.max);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return Bt.copy(t).clamp(this.min, this.max).sub(t).length();
    }
  }, {
    key: "getBoundingSphere",
    value: function getBoundingSphere(t) {
      return this.getCenter(t.center), t.radius = .5 * this.getSize(Bt).length(), t;
    }
  }, {
    key: "intersect",
    value: function intersect(t) {
      return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
  }, {
    key: "union",
    value: function union(t) {
      return this.min.min(t.min), this.max.max(t.max), this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.isEmpty() || (St[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), St[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), St[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), St[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), St[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), St[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), St[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), St[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(St)), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.min.add(t), this.max.add(t), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.min.equals(this.min) && t.max.equals(this.max);
    }
  }]);

  return Mt;
}();

Mt.prototype.isBox3 = !0;
var St = [new _t(), new _t(), new _t(), new _t(), new _t(), new _t(), new _t(), new _t()],
    Bt = new _t(),
    Tt = new Mt(),
    Lt = new _t(),
    Rt = new _t(),
    Dt = new _t(),
    Qt = new _t(),
    Pt = new _t(),
    Ft = new _t(),
    Nt = new _t(),
    Ut = new _t(),
    kt = new _t(),
    Gt = new _t();

function Ot(t, e, n, i, r) {
  for (var _s9 = 0, _a4 = t.length - 3; _s9 <= _a4; _s9 += 3) {
    Gt.fromArray(t, _s9);

    var _a5 = r.x * Math.abs(Gt.x) + r.y * Math.abs(Gt.y) + r.z * Math.abs(Gt.z),
        _o7 = e.dot(Gt),
        _l6 = n.dot(Gt),
        _c4 = i.dot(Gt);

    if (Math.max(-Math.max(_o7, _l6, _c4), Math.min(_o7, _l6, _c4)) > _a5) return !1;
  }

  return !0;
}

var Ht = new Mt(),
    zt = new _t(),
    Vt = new _t(),
    Wt = new _t();

var qt = /*#__PURE__*/function () {
  function qt() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    _classCallCheck(this, qt);

    this.center = t, this.radius = e;
  }

  _createClass(qt, [{
    key: "set",
    value: function set(t, e) {
      return this.center.copy(t), this.radius = e, this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t, e) {
      var n = this.center;
      void 0 !== e ? n.copy(e) : Ht.setFromPoints(t).getCenter(n);
      var i = 0;

      for (var _e20 = 0, _r8 = t.length; _e20 < _r8; _e20++) {
        i = Math.max(i, n.distanceToSquared(t[_e20]));
      }

      return this.radius = Math.sqrt(i), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.center.copy(t.center), this.radius = t.radius, this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.radius < 0;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      return this.center.set(0, 0, 0), this.radius = -1, this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return t.distanceTo(this.center) - this.radius;
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      var e = this.radius + t.radius;
      return t.center.distanceToSquared(this.center) <= e * e;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsSphere(this);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(t, e) {
      var n = this.center.distanceToSquared(t);
      return e.copy(t), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(t) {
      return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.center.add(t), this;
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(t) {
      Wt.subVectors(t, this.center);
      var e = Wt.lengthSq();

      if (e > this.radius * this.radius) {
        var _t34 = Math.sqrt(e),
            _n19 = .5 * (_t34 - this.radius);

        this.center.add(Wt.multiplyScalar(_n19 / _t34)), this.radius += _n19;
      }

      return this;
    }
  }, {
    key: "union",
    value: function union(t) {
      return Vt.subVectors(t.center, this.center).normalize().multiplyScalar(t.radius), this.expandByPoint(zt.copy(t.center).add(Vt)), this.expandByPoint(zt.copy(t.center).sub(Vt)), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.center.equals(this.center) && t.radius === this.radius;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return qt;
}();

var jt = new _t(),
    Yt = new _t(),
    Jt = new _t(),
    Xt = new _t(),
    Kt = new _t(),
    Zt = new _t(),
    $t = new _t();

var te = /*#__PURE__*/function () {
  function te() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t(0, 0, -1);

    _classCallCheck(this, te);

    this.origin = t, this.direction = e;
  }

  _createClass(te, [{
    key: "set",
    value: function set(t, e) {
      return this.origin.copy(t), this.direction.copy(e), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
  }, {
    key: "at",
    value: function at(t, e) {
      return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
  }, {
    key: "lookAt",
    value: function lookAt(t) {
      return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
  }, {
    key: "recast",
    value: function recast(t) {
      return this.origin.copy(this.at(t, jt)), this;
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(t, e) {
      e.subVectors(t, this.origin);
      var n = e.dot(this.direction);
      return n < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(n).add(this.origin);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return Math.sqrt(this.distanceSqToPoint(t));
    }
  }, {
    key: "distanceSqToPoint",
    value: function distanceSqToPoint(t) {
      var e = jt.subVectors(t, this.origin).dot(this.direction);
      return e < 0 ? this.origin.distanceToSquared(t) : (jt.copy(this.direction).multiplyScalar(e).add(this.origin), jt.distanceToSquared(t));
    }
  }, {
    key: "distanceSqToSegment",
    value: function distanceSqToSegment(t, e, n, i) {
      Yt.copy(t).add(e).multiplyScalar(.5), Jt.copy(e).sub(t).normalize(), Xt.copy(this.origin).sub(Yt);
      var r = .5 * t.distanceTo(e),
          s = -this.direction.dot(Jt),
          a = Xt.dot(this.direction),
          o = -Xt.dot(Jt),
          l = Xt.lengthSq(),
          c = Math.abs(1 - s * s);
      var h, u, d, p;
      if (c > 0) {
        if (h = s * o - a, u = s * a - o, p = r * c, h >= 0) {
          if (u >= -p) {
            if (u <= p) {
              var _t35 = 1 / c;

              h *= _t35, u *= _t35, d = h * (h + s * u + 2 * a) + u * (s * h + u + 2 * o) + l;
            } else u = r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
          } else u = -r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
        } else u <= -p ? (h = Math.max(0, -(-s * r + a)), u = h > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -h * h + u * (u + 2 * o) + l) : u <= p ? (h = 0, u = Math.min(Math.max(-r, -o), r), d = u * (u + 2 * o) + l) : (h = Math.max(0, -(s * r + a)), u = h > 0 ? r : Math.min(Math.max(-r, -o), r), d = -h * h + u * (u + 2 * o) + l);
      } else u = s > 0 ? -r : r, h = Math.max(0, -(s * u + a)), d = -h * h + u * (u + 2 * o) + l;
      return n && n.copy(this.direction).multiplyScalar(h).add(this.origin), i && i.copy(Jt).multiplyScalar(u).add(Yt), d;
    }
  }, {
    key: "intersectSphere",
    value: function intersectSphere(t, e) {
      jt.subVectors(t.center, this.origin);
      var n = jt.dot(this.direction),
          i = jt.dot(jt) - n * n,
          r = t.radius * t.radius;
      if (i > r) return null;
      var s = Math.sqrt(r - i),
          a = n - s,
          o = n + s;
      return a < 0 && o < 0 ? null : a < 0 ? this.at(o, e) : this.at(a, e);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
  }, {
    key: "distanceToPlane",
    value: function distanceToPlane(t) {
      var e = t.normal.dot(this.direction);
      if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
      var n = -(this.origin.dot(t.normal) + t.constant) / e;
      return n >= 0 ? n : null;
    }
  }, {
    key: "intersectPlane",
    value: function intersectPlane(t, e) {
      var n = this.distanceToPlane(t);
      return null === n ? null : this.at(n, e);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(t) {
      var e = t.distanceToPoint(this.origin);
      if (0 === e) return !0;
      return t.normal.dot(this.direction) * e < 0;
    }
  }, {
    key: "intersectBox",
    value: function intersectBox(t, e) {
      var n, i, r, s, a, o;
      var l = 1 / this.direction.x,
          c = 1 / this.direction.y,
          h = 1 / this.direction.z,
          u = this.origin;
      return l >= 0 ? (n = (t.min.x - u.x) * l, i = (t.max.x - u.x) * l) : (n = (t.max.x - u.x) * l, i = (t.min.x - u.x) * l), c >= 0 ? (r = (t.min.y - u.y) * c, s = (t.max.y - u.y) * c) : (r = (t.max.y - u.y) * c, s = (t.min.y - u.y) * c), n > s || r > i ? null : ((r > n || n != n) && (n = r), (s < i || i != i) && (i = s), h >= 0 ? (a = (t.min.z - u.z) * h, o = (t.max.z - u.z) * h) : (a = (t.max.z - u.z) * h, o = (t.min.z - u.z) * h), n > o || a > i ? null : ((a > n || n != n) && (n = a), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, e)));
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return null !== this.intersectBox(t, jt);
    }
  }, {
    key: "intersectTriangle",
    value: function intersectTriangle(t, e, n, i, r) {
      Kt.subVectors(e, t), Zt.subVectors(n, t), $t.crossVectors(Kt, Zt);
      var s,
          a = this.direction.dot($t);

      if (a > 0) {
        if (i) return null;
        s = 1;
      } else {
        if (!(a < 0)) return null;
        s = -1, a = -a;
      }

      Xt.subVectors(this.origin, t);
      var o = s * this.direction.dot(Zt.crossVectors(Xt, Zt));
      if (o < 0) return null;
      var l = s * this.direction.dot(Kt.cross(Xt));
      if (l < 0) return null;
      if (o + l > a) return null;
      var c = -s * Xt.dot($t);
      return c < 0 ? null : this.at(c / a, r);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return te;
}();

var ee = /*#__PURE__*/function () {
  function ee() {
    _classCallCheck(this, ee);

    this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
  }

  _createClass(ee, [{
    key: "set",
    value: function set(t, e, n, i, r, s, a, o, l, c, h, u, d, p, A, m) {
      var g = this.elements;
      return g[0] = t, g[4] = e, g[8] = n, g[12] = i, g[1] = r, g[5] = s, g[9] = a, g[13] = o, g[2] = l, g[6] = c, g[10] = h, g[14] = u, g[3] = d, g[7] = p, g[11] = A, g[15] = m, this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ee().fromArray(this.elements);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.elements,
          n = t.elements;
      return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
    }
  }, {
    key: "copyPosition",
    value: function copyPosition(t) {
      var e = this.elements,
          n = t.elements;
      return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
    }
  }, {
    key: "setFromMatrix3",
    value: function setFromMatrix3(t) {
      var e = t.elements;
      return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(t, e, n) {
      return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
  }, {
    key: "makeBasis",
    value: function makeBasis(t, e, n) {
      return this.set(t.x, e.x, n.x, 0, t.y, e.y, n.y, 0, t.z, e.z, n.z, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "extractRotation",
    value: function extractRotation(t) {
      var e = this.elements,
          n = t.elements,
          i = 1 / ne.setFromMatrixColumn(t, 0).length(),
          r = 1 / ne.setFromMatrixColumn(t, 1).length(),
          s = 1 / ne.setFromMatrixColumn(t, 2).length();
      return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * r, e[5] = n[5] * r, e[6] = n[6] * r, e[7] = 0, e[8] = n[8] * s, e[9] = n[9] * s, e[10] = n[10] * s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
  }, {
    key: "makeRotationFromEuler",
    value: function makeRotationFromEuler(t) {
      t && t.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
      var e = this.elements,
          n = t.x,
          i = t.y,
          r = t.z,
          s = Math.cos(n),
          a = Math.sin(n),
          o = Math.cos(i),
          l = Math.sin(i),
          c = Math.cos(r),
          h = Math.sin(r);

      if ("XYZ" === t.order) {
        var _t36 = s * c,
            _n20 = s * h,
            _i14 = a * c,
            _r9 = a * h;

        e[0] = o * c, e[4] = -o * h, e[8] = l, e[1] = _n20 + _i14 * l, e[5] = _t36 - _r9 * l, e[9] = -a * o, e[2] = _r9 - _t36 * l, e[6] = _i14 + _n20 * l, e[10] = s * o;
      } else if ("YXZ" === t.order) {
        var _t37 = o * c,
            _n21 = o * h,
            _i15 = l * c,
            _r10 = l * h;

        e[0] = _t37 + _r10 * a, e[4] = _i15 * a - _n21, e[8] = s * l, e[1] = s * h, e[5] = s * c, e[9] = -a, e[2] = _n21 * a - _i15, e[6] = _r10 + _t37 * a, e[10] = s * o;
      } else if ("ZXY" === t.order) {
        var _t38 = o * c,
            _n22 = o * h,
            _i16 = l * c,
            _r11 = l * h;

        e[0] = _t38 - _r11 * a, e[4] = -s * h, e[8] = _i16 + _n22 * a, e[1] = _n22 + _i16 * a, e[5] = s * c, e[9] = _r11 - _t38 * a, e[2] = -s * l, e[6] = a, e[10] = s * o;
      } else if ("ZYX" === t.order) {
        var _t39 = s * c,
            _n23 = s * h,
            _i17 = a * c,
            _r12 = a * h;

        e[0] = o * c, e[4] = _i17 * l - _n23, e[8] = _t39 * l + _r12, e[1] = o * h, e[5] = _r12 * l + _t39, e[9] = _n23 * l - _i17, e[2] = -l, e[6] = a * o, e[10] = s * o;
      } else if ("YZX" === t.order) {
        var _t40 = s * o,
            _n24 = s * l,
            _i18 = a * o,
            _r13 = a * l;

        e[0] = o * c, e[4] = _r13 - _t40 * h, e[8] = _i18 * h + _n24, e[1] = h, e[5] = s * c, e[9] = -a * c, e[2] = -l * c, e[6] = _n24 * h + _i18, e[10] = _t40 - _r13 * h;
      } else if ("XZY" === t.order) {
        var _t41 = s * o,
            _n25 = s * l,
            _i19 = a * o,
            _r14 = a * l;

        e[0] = o * c, e[4] = -h, e[8] = l * c, e[1] = _t41 * h + _r14, e[5] = s * c, e[9] = _n25 * h - _i19, e[2] = _i19 * h - _n25, e[6] = a * c, e[10] = _r14 * h + _t41;
      }

      return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
  }, {
    key: "makeRotationFromQuaternion",
    value: function makeRotationFromQuaternion(t) {
      return this.compose(re, t, se);
    }
  }, {
    key: "lookAt",
    value: function lookAt(t, e, n) {
      var i = this.elements;
      return le.subVectors(t, e), 0 === le.lengthSq() && (le.z = 1), le.normalize(), ae.crossVectors(n, le), 0 === ae.lengthSq() && (1 === Math.abs(n.z) ? le.x += 1e-4 : le.z += 1e-4, le.normalize(), ae.crossVectors(n, le)), ae.normalize(), oe.crossVectors(le, ae), i[0] = ae.x, i[4] = oe.x, i[8] = le.x, i[1] = ae.y, i[5] = oe.y, i[9] = le.y, i[2] = ae.z, i[6] = oe.z, i[10] = le.z, this;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t, e)) : this.multiplyMatrices(this, t);
    }
  }, {
    key: "premultiply",
    value: function premultiply(t) {
      return this.multiplyMatrices(t, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(t, e) {
      var n = t.elements,
          i = e.elements,
          r = this.elements,
          s = n[0],
          a = n[4],
          o = n[8],
          l = n[12],
          c = n[1],
          h = n[5],
          u = n[9],
          d = n[13],
          p = n[2],
          A = n[6],
          m = n[10],
          g = n[14],
          f = n[3],
          v = n[7],
          y = n[11],
          x = n[15],
          w = i[0],
          E = i[4],
          b = i[8],
          _ = i[12],
          I = i[1],
          C = i[5],
          M = i[9],
          S = i[13],
          B = i[2],
          T = i[6],
          L = i[10],
          R = i[14],
          D = i[3],
          Q = i[7],
          P = i[11],
          F = i[15];
      return r[0] = s * w + a * I + o * B + l * D, r[4] = s * E + a * C + o * T + l * Q, r[8] = s * b + a * M + o * L + l * P, r[12] = s * _ + a * S + o * R + l * F, r[1] = c * w + h * I + u * B + d * D, r[5] = c * E + h * C + u * T + d * Q, r[9] = c * b + h * M + u * L + d * P, r[13] = c * _ + h * S + u * R + d * F, r[2] = p * w + A * I + m * B + g * D, r[6] = p * E + A * C + m * T + g * Q, r[10] = p * b + A * M + m * L + g * P, r[14] = p * _ + A * S + m * R + g * F, r[3] = f * w + v * I + y * B + x * D, r[7] = f * E + v * C + y * T + x * Q, r[11] = f * b + v * M + y * L + x * P, r[15] = f * _ + v * S + y * R + x * F, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      var e = this.elements;
      return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var t = this.elements,
          e = t[0],
          n = t[4],
          i = t[8],
          r = t[12],
          s = t[1],
          a = t[5],
          o = t[9],
          l = t[13],
          c = t[2],
          h = t[6],
          u = t[10],
          d = t[14];
      return t[3] * (+r * o * h - i * l * h - r * a * u + n * l * u + i * a * d - n * o * d) + t[7] * (+e * o * d - e * l * u + r * s * u - i * s * d + i * l * c - r * o * c) + t[11] * (+e * l * h - e * a * d - r * s * h + n * s * d + r * a * c - n * l * c) + t[15] * (-i * a * c - e * o * h + e * a * u + i * s * h - n * s * u + n * o * c);
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var t = this.elements;
      var e;
      return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(t, e, n) {
      var i = this.elements;
      return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = n), this;
    }
  }, {
    key: "invert",
    value: function invert() {
      var t = this.elements,
          e = t[0],
          n = t[1],
          i = t[2],
          r = t[3],
          s = t[4],
          a = t[5],
          o = t[6],
          l = t[7],
          c = t[8],
          h = t[9],
          u = t[10],
          d = t[11],
          p = t[12],
          A = t[13],
          m = t[14],
          g = t[15],
          f = h * m * l - A * u * l + A * o * d - a * m * d - h * o * g + a * u * g,
          v = p * u * l - c * m * l - p * o * d + s * m * d + c * o * g - s * u * g,
          y = c * A * l - p * h * l + p * a * d - s * A * d - c * a * g + s * h * g,
          x = p * h * o - c * A * o - p * a * u + s * A * u + c * a * m - s * h * m,
          w = e * f + n * v + i * y + r * x;
      if (0 === w) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      var E = 1 / w;
      return t[0] = f * E, t[1] = (A * u * r - h * m * r - A * i * d + n * m * d + h * i * g - n * u * g) * E, t[2] = (a * m * r - A * o * r + A * i * l - n * m * l - a * i * g + n * o * g) * E, t[3] = (h * o * r - a * u * r - h * i * l + n * u * l + a * i * d - n * o * d) * E, t[4] = v * E, t[5] = (c * m * r - p * u * r + p * i * d - e * m * d - c * i * g + e * u * g) * E, t[6] = (p * o * r - s * m * r - p * i * l + e * m * l + s * i * g - e * o * g) * E, t[7] = (s * u * r - c * o * r + c * i * l - e * u * l - s * i * d + e * o * d) * E, t[8] = y * E, t[9] = (p * h * r - c * A * r - p * n * d + e * A * d + c * n * g - e * h * g) * E, t[10] = (s * A * r - p * a * r + p * n * l - e * A * l - s * n * g + e * a * g) * E, t[11] = (c * a * r - s * h * r - c * n * l + e * h * l + s * n * d - e * a * d) * E, t[12] = x * E, t[13] = (c * A * i - p * h * i + p * n * u - e * A * u - c * n * m + e * h * m) * E, t[14] = (p * a * i - s * A * i - p * n * o + e * A * o + s * n * m - e * a * m) * E, t[15] = (s * h * i - c * a * i + c * n * o - e * h * o - s * n * u + e * a * u) * E, this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      var e = this.elements,
          n = t.x,
          i = t.y,
          r = t.z;
      return e[0] *= n, e[4] *= i, e[8] *= r, e[1] *= n, e[5] *= i, e[9] *= r, e[2] *= n, e[6] *= i, e[10] *= r, e[3] *= n, e[7] *= i, e[11] *= r, this;
    }
  }, {
    key: "getMaxScaleOnAxis",
    value: function getMaxScaleOnAxis() {
      var t = this.elements,
          e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2],
          n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6],
          i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
      return Math.sqrt(Math.max(e, n, i));
    }
  }, {
    key: "makeTranslation",
    value: function makeTranslation(t, e, n) {
      return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationX",
    value: function makeRotationX(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationY",
    value: function makeRotationY(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationZ",
    value: function makeRotationZ(t) {
      var e = Math.cos(t),
          n = Math.sin(t);
      return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeRotationAxis",
    value: function makeRotationAxis(t, e) {
      var n = Math.cos(e),
          i = Math.sin(e),
          r = 1 - n,
          s = t.x,
          a = t.y,
          o = t.z,
          l = r * s,
          c = r * a;
      return this.set(l * s + n, l * a - i * o, l * o + i * a, 0, l * a + i * o, c * a + n, c * o - i * s, 0, l * o - i * a, c * o + i * s, r * o * o + n, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeScale",
    value: function makeScale(t, e, n) {
      return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "makeShear",
    value: function makeShear(t, e, n, i, r, s) {
      return this.set(1, n, r, 0, t, 1, s, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
  }, {
    key: "compose",
    value: function compose(t, e, n) {
      var i = this.elements,
          r = e._x,
          s = e._y,
          a = e._z,
          o = e._w,
          l = r + r,
          c = s + s,
          h = a + a,
          u = r * l,
          d = r * c,
          p = r * h,
          A = s * c,
          m = s * h,
          g = a * h,
          f = o * l,
          v = o * c,
          y = o * h,
          x = n.x,
          w = n.y,
          E = n.z;
      return i[0] = (1 - (A + g)) * x, i[1] = (d + y) * x, i[2] = (p - v) * x, i[3] = 0, i[4] = (d - y) * w, i[5] = (1 - (u + g)) * w, i[6] = (m + f) * w, i[7] = 0, i[8] = (p + v) * E, i[9] = (m - f) * E, i[10] = (1 - (u + A)) * E, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
  }, {
    key: "decompose",
    value: function decompose(t, e, n) {
      var i = this.elements;
      var r = ne.set(i[0], i[1], i[2]).length();
      var s = ne.set(i[4], i[5], i[6]).length(),
          a = ne.set(i[8], i[9], i[10]).length();
      this.determinant() < 0 && (r = -r), t.x = i[12], t.y = i[13], t.z = i[14], ie.copy(this);
      var o = 1 / r,
          l = 1 / s,
          c = 1 / a;
      return ie.elements[0] *= o, ie.elements[1] *= o, ie.elements[2] *= o, ie.elements[4] *= l, ie.elements[5] *= l, ie.elements[6] *= l, ie.elements[8] *= c, ie.elements[9] *= c, ie.elements[10] *= c, e.setFromRotationMatrix(ie), n.x = r, n.y = s, n.z = a, this;
    }
  }, {
    key: "makePerspective",
    value: function makePerspective(t, e, n, i, r, s) {
      void 0 === s && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
      var a = this.elements,
          o = 2 * r / (e - t),
          l = 2 * r / (n - i),
          c = (e + t) / (e - t),
          h = (n + i) / (n - i),
          u = -(s + r) / (s - r),
          d = -2 * s * r / (s - r);
      return a[0] = o, a[4] = 0, a[8] = c, a[12] = 0, a[1] = 0, a[5] = l, a[9] = h, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = u, a[14] = d, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
  }, {
    key: "makeOrthographic",
    value: function makeOrthographic(t, e, n, i, r, s) {
      var a = this.elements,
          o = 1 / (e - t),
          l = 1 / (n - i),
          c = 1 / (s - r),
          h = (e + t) * o,
          u = (n + i) * l,
          d = (s + r) * c;
      return a[0] = 2 * o, a[4] = 0, a[8] = 0, a[12] = -h, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -u, a[2] = 0, a[6] = 0, a[10] = -2 * c, a[14] = -d, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      var e = this.elements,
          n = t.elements;

      for (var _t42 = 0; _t42 < 16; _t42++) {
        if (e[_t42] !== n[_t42]) return !1;
      }

      return !0;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _n26 = 0; _n26 < 16; _n26++) {
        this.elements[_n26] = t[_n26 + e];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.elements;
      return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t[e + 9] = n[9], t[e + 10] = n[10], t[e + 11] = n[11], t[e + 12] = n[12], t[e + 13] = n[13], t[e + 14] = n[14], t[e + 15] = n[15], t;
    }
  }]);

  return ee;
}();

ee.prototype.isMatrix4 = !0;
var ne = new _t(),
    ie = new ee(),
    re = new _t(0, 0, 0),
    se = new _t(1, 1, 1),
    ae = new _t(),
    oe = new _t(),
    le = new _t(),
    ce = new ee(),
    he = new bt();

var ue = /*#__PURE__*/function () {
  function ue() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ue.DefaultOrder;

    _classCallCheck(this, ue);

    this._x = t, this._y = e, this._z = n, this._order = i;
  }

  _createClass(ue, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(t) {
      this._x = t, this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(t) {
      this._y = t, this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(t) {
      this._z = t, this._onChangeCallback();
    }
  }, {
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(t) {
      this._order = t, this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;
      return this._x = t, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var i = t.elements,
          r = i[0],
          s = i[4],
          a = i[8],
          o = i[1],
          l = i[5],
          c = i[9],
          h = i[2],
          u = i[6],
          d = i[10];

      switch (e) {
        case "XYZ":
          this._y = Math.asin(at(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-s, r)) : (this._x = Math.atan2(u, l), this._z = 0);
          break;

        case "YXZ":
          this._x = Math.asin(-at(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(a, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-h, r), this._z = 0);
          break;

        case "ZXY":
          this._x = Math.asin(at(u, -1, 1)), Math.abs(u) < .9999999 ? (this._y = Math.atan2(-h, d), this._z = Math.atan2(-s, l)) : (this._y = 0, this._z = Math.atan2(o, r));
          break;

        case "ZYX":
          this._y = Math.asin(-at(h, -1, 1)), Math.abs(h) < .9999999 ? (this._x = Math.atan2(u, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-s, l));
          break;

        case "YZX":
          this._z = Math.asin(at(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-h, r)) : (this._x = 0, this._y = Math.atan2(a, d));
          break;

        case "XZY":
          this._z = Math.asin(-at(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(u, l), this._y = Math.atan2(a, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
          break;

        default:
          console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
      }

      return this._order = e, !0 === n && this._onChangeCallback(), this;
    }
  }, {
    key: "setFromQuaternion",
    value: function setFromQuaternion(t, e, n) {
      return ce.makeRotationFromQuaternion(t), this.setFromRotationMatrix(ce, e, n);
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      return this.set(t.x, t.y, t.z, e);
    }
  }, {
    key: "reorder",
    value: function reorder(t) {
      return he.setFromEuler(this), this.setFromQuaternion(he, t);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      return this._x = t[0], this._y = t[1], this._z = t[2], void 0 !== t[3] && (this._order = t[3]), this._onChangeCallback(), this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
  }, {
    key: "toVector3",
    value: function toVector3(t) {
      return t ? t.set(this._x, this._y, this._z) : new _t(this._x, this._y, this._z);
    }
  }, {
    key: "_onChange",
    value: function _onChange(t) {
      return this._onChangeCallback = t, this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }]);

  return ue;
}();

ue.prototype.isEuler = !0, ue.DefaultOrder = "XYZ", ue.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];

var de = /*#__PURE__*/function () {
  function de() {
    _classCallCheck(this, de);

    this.mask = 1;
  }

  _createClass(de, [{
    key: "set",
    value: function set(t) {
      this.mask = 1 << t | 0;
    }
  }, {
    key: "enable",
    value: function enable(t) {
      this.mask |= 1 << t | 0;
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      this.mask = -1;
    }
  }, {
    key: "toggle",
    value: function toggle(t) {
      this.mask ^= 1 << t | 0;
    }
  }, {
    key: "disable",
    value: function disable(t) {
      this.mask &= ~(1 << t | 0);
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      this.mask = 0;
    }
  }, {
    key: "test",
    value: function test(t) {
      return 0 != (this.mask & t.mask);
    }
  }]);

  return de;
}();

var pe = 0;
var Ae = new _t(),
    me = new bt(),
    ge = new ee(),
    fe = new _t(),
    ve = new _t(),
    ye = new _t(),
    xe = new bt(),
    we = new _t(1, 0, 0),
    Ee = new _t(0, 1, 0),
    be = new _t(0, 0, 1),
    _e = {
  type: "added"
},
    Ie = {
  type: "removed"
};

var Ce = /*#__PURE__*/function (_tt3) {
  _inherits(Ce, _tt3);

  var _super7 = _createSuper(Ce);

  function Ce() {
    var _this13;

    _classCallCheck(this, Ce);

    _this13 = _super7.call(this), Object.defineProperty(_assertThisInitialized(_this13), "id", {
      value: pe++
    }), _this13.uuid = st(), _this13.name = "", _this13.type = "Object3D", _this13.parent = null, _this13.children = [], _this13.up = Ce.DefaultUp.clone();
    var t = new _t(),
        e = new ue(),
        n = new bt(),
        i = new _t(1, 1, 1);
    e._onChange(function () {
      n.setFromEuler(e, !1);
    }), n._onChange(function () {
      e.setFromQuaternion(n, void 0, !1);
    }), Object.defineProperties(_assertThisInitialized(_this13), {
      position: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      modelViewMatrix: {
        value: new ee()
      },
      normalMatrix: {
        value: new At()
      }
    }), _this13.matrix = new ee(), _this13.matrixWorld = new ee(), _this13.matrixAutoUpdate = Ce.DefaultMatrixAutoUpdate, _this13.matrixWorldNeedsUpdate = !1, _this13.layers = new de(), _this13.visible = !0, _this13.castShadow = !1, _this13.receiveShadow = !1, _this13.frustumCulled = !0, _this13.renderOrder = 0, _this13.animations = [], _this13.userData = {};
    return _this13;
  }

  _createClass(Ce, [{
    key: "onBeforeRender",
    value: function onBeforeRender() {}
  }, {
    key: "onAfterRender",
    value: function onAfterRender() {}
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      return this.quaternion.premultiply(t), this;
    }
  }, {
    key: "setRotationFromAxisAngle",
    value: function setRotationFromAxisAngle(t, e) {
      this.quaternion.setFromAxisAngle(t, e);
    }
  }, {
    key: "setRotationFromEuler",
    value: function setRotationFromEuler(t) {
      this.quaternion.setFromEuler(t, !0);
    }
  }, {
    key: "setRotationFromMatrix",
    value: function setRotationFromMatrix(t) {
      this.quaternion.setFromRotationMatrix(t);
    }
  }, {
    key: "setRotationFromQuaternion",
    value: function setRotationFromQuaternion(t) {
      this.quaternion.copy(t);
    }
  }, {
    key: "rotateOnAxis",
    value: function rotateOnAxis(t, e) {
      return me.setFromAxisAngle(t, e), this.quaternion.multiply(me), this;
    }
  }, {
    key: "rotateOnWorldAxis",
    value: function rotateOnWorldAxis(t, e) {
      return me.setFromAxisAngle(t, e), this.quaternion.premultiply(me), this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(t) {
      return this.rotateOnAxis(we, t);
    }
  }, {
    key: "rotateY",
    value: function rotateY(t) {
      return this.rotateOnAxis(Ee, t);
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(t) {
      return this.rotateOnAxis(be, t);
    }
  }, {
    key: "translateOnAxis",
    value: function translateOnAxis(t, e) {
      return Ae.copy(t).applyQuaternion(this.quaternion), this.position.add(Ae.multiplyScalar(e)), this;
    }
  }, {
    key: "translateX",
    value: function translateX(t) {
      return this.translateOnAxis(we, t);
    }
  }, {
    key: "translateY",
    value: function translateY(t) {
      return this.translateOnAxis(Ee, t);
    }
  }, {
    key: "translateZ",
    value: function translateZ(t) {
      return this.translateOnAxis(be, t);
    }
  }, {
    key: "localToWorld",
    value: function localToWorld(t) {
      return t.applyMatrix4(this.matrixWorld);
    }
  }, {
    key: "worldToLocal",
    value: function worldToLocal(t) {
      return t.applyMatrix4(ge.copy(this.matrixWorld).invert());
    }
  }, {
    key: "lookAt",
    value: function lookAt(t, e, n) {
      t.isVector3 ? fe.copy(t) : fe.set(t, e, n);
      var i = this.parent;
      this.updateWorldMatrix(!0, !1), ve.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? ge.lookAt(ve, fe, this.up) : ge.lookAt(fe, ve, this.up), this.quaternion.setFromRotationMatrix(ge), i && (ge.extractRotation(i.matrixWorld), me.setFromRotationMatrix(ge), this.quaternion.premultiply(me.invert()));
    }
  }, {
    key: "add",
    value: function add(t) {
      if (arguments.length > 1) {
        for (var _t43 = 0; _t43 < arguments.length; _t43++) {
          this.add(arguments[_t43]);
        }

        return this;
      }

      return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(_e)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
  }, {
    key: "remove",
    value: function remove(t) {
      if (arguments.length > 1) {
        for (var _t44 = 0; _t44 < arguments.length; _t44++) {
          this.remove(arguments[_t44]);
        }

        return this;
      }

      var e = this.children.indexOf(t);
      return -1 !== e && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(Ie)), this;
    }
  }, {
    key: "removeFromParent",
    value: function removeFromParent() {
      var t = this.parent;
      return null !== t && t.remove(this), this;
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var _t45 = 0; _t45 < this.children.length; _t45++) {
        var _e21 = this.children[_t45];
        _e21.parent = null, _e21.dispatchEvent(Ie);
      }

      return this.children.length = 0, this;
    }
  }, {
    key: "attach",
    value: function attach(t) {
      return this.updateWorldMatrix(!0, !1), ge.copy(this.matrixWorld).invert(), null !== t.parent && (t.parent.updateWorldMatrix(!0, !1), ge.multiply(t.parent.matrixWorld)), t.applyMatrix4(ge), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
  }, {
    key: "getObjectById",
    value: function getObjectById(t) {
      return this.getObjectByProperty("id", t);
    }
  }, {
    key: "getObjectByName",
    value: function getObjectByName(t) {
      return this.getObjectByProperty("name", t);
    }
  }, {
    key: "getObjectByProperty",
    value: function getObjectByProperty(t, e) {
      if (this[t] === e) return this;

      for (var _n27 = 0, _i20 = this.children.length; _n27 < _i20; _n27++) {
        var _i21 = this.children[_n27].getObjectByProperty(t, e);

        if (void 0 !== _i21) return _i21;
      }
    }
  }, {
    key: "getWorldPosition",
    value: function getWorldPosition(t) {
      return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
  }, {
    key: "getWorldQuaternion",
    value: function getWorldQuaternion(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(ve, t, ye), t;
    }
  }, {
    key: "getWorldScale",
    value: function getWorldScale(t) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(ve, xe, t), t;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(t) {
      this.updateWorldMatrix(!0, !1);
      var e = this.matrixWorld.elements;
      return t.set(e[8], e[9], e[10]).normalize();
    }
  }, {
    key: "raycast",
    value: function raycast() {}
  }, {
    key: "traverse",
    value: function traverse(t) {
      t(this);
      var e = this.children;

      for (var _n28 = 0, _i22 = e.length; _n28 < _i22; _n28++) {
        e[_n28].traverse(t);
      }
    }
  }, {
    key: "traverseVisible",
    value: function traverseVisible(t) {
      if (!1 === this.visible) return;
      t(this);
      var e = this.children;

      for (var _n29 = 0, _i23 = e.length; _n29 < _i23; _n29++) {
        e[_n29].traverseVisible(t);
      }
    }
  }, {
    key: "traverseAncestors",
    value: function traverseAncestors(t) {
      var e = this.parent;
      null !== e && (t(e), e.traverseAncestors(t));
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
      var e = this.children;

      for (var _n30 = 0, _i24 = e.length; _n30 < _i24; _n30++) {
        e[_n30].updateMatrixWorld(t);
      }
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(t, e) {
      var n = this.parent;

      if (!0 === t && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
        var _t46 = this.children;

        for (var _e22 = 0, _n31 = _t46.length; _e22 < _n31; _e22++) {
          _t46[_e22].updateWorldMatrix(!1, !0);
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t,
          n = {};
      e && (t = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {}
      }, n.metadata = {
        version: 4.5,
        type: "Object",
        generator: "Object3D.toJSON"
      });
      var i = {};

      function r(e, n) {
        return void 0 === e[n.uuid] && (e[n.uuid] = n.toJSON(t)), n.uuid;
      }

      if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), "{}" !== JSON.stringify(this.userData) && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && (i.environment = this.environment.toJSON(t).uuid);else if (this.isMesh || this.isLine || this.isPoints) {
        i.geometry = r(t.geometries, this.geometry);
        var _e23 = this.geometry.parameters;

        if (void 0 !== _e23 && void 0 !== _e23.shapes) {
          var _n32 = _e23.shapes;
          if (Array.isArray(_n32)) for (var _e24 = 0, _i25 = _n32.length; _e24 < _i25; _e24++) {
            var _i26 = _n32[_e24];
            r(t.shapes, _i26);
          } else r(t.shapes, _n32);
        }
      }
      if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) if (Array.isArray(this.material)) {
        var _e25 = [];

        for (var _n33 = 0, _i27 = this.material.length; _n33 < _i27; _n33++) {
          _e25.push(r(t.materials, this.material[_n33]));
        }

        i.material = _e25;
      } else i.material = r(t.materials, this.material);

      if (this.children.length > 0) {
        i.children = [];

        for (var _e26 = 0; _e26 < this.children.length; _e26++) {
          i.children.push(this.children[_e26].toJSON(t).object);
        }
      }

      if (this.animations.length > 0) {
        i.animations = [];

        for (var _e27 = 0; _e27 < this.animations.length; _e27++) {
          var _n34 = this.animations[_e27];
          i.animations.push(r(t.animations, _n34));
        }
      }

      if (e) {
        var _e28 = s(t.geometries),
            _i28 = s(t.materials),
            _r15 = s(t.textures),
            _a6 = s(t.images),
            _o8 = s(t.shapes),
            _l7 = s(t.skeletons),
            _c5 = s(t.animations);

        _e28.length > 0 && (n.geometries = _e28), _i28.length > 0 && (n.materials = _i28), _r15.length > 0 && (n.textures = _r15), _a6.length > 0 && (n.images = _a6), _o8.length > 0 && (n.shapes = _o8), _l7.length > 0 && (n.skeletons = _l7), _c5.length > 0 && (n.animations = _c5);
      }

      return n.object = i, n;

      function s(t) {
        var e = [];

        for (var _n35 in t) {
          var _i29 = t[_n35];
          delete _i29.metadata, e.push(_i29);
        }

        return e;
      }
    }
  }, {
    key: "clone",
    value: function clone(t) {
      return new this.constructor().copy(this, t);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), !0 === e) for (var _e29 = 0; _e29 < t.children.length; _e29++) {
        var _n36 = t.children[_e29];
        this.add(_n36.clone());
      }
      return this;
    }
  }]);

  return Ce;
}(tt);

Ce.DefaultUp = new _t(0, 1, 0), Ce.DefaultMatrixAutoUpdate = !0, Ce.prototype.isObject3D = !0;
var Me = new _t(),
    Se = new _t(),
    Be = new _t(),
    Te = new _t(),
    Le = new _t(),
    Re = new _t(),
    De = new _t(),
    Qe = new _t(),
    Pe = new _t(),
    Fe = new _t();

var Ne = /*#__PURE__*/function () {
  function Ne() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _t();

    _classCallCheck(this, Ne);

    this.a = t, this.b = e, this.c = n;
  }

  _createClass(Ne, [{
    key: "set",
    value: function set(t, e, n) {
      return this.a.copy(t), this.b.copy(e), this.c.copy(n), this;
    }
  }, {
    key: "setFromPointsAndIndices",
    value: function setFromPointsAndIndices(t, e, n, i) {
      return this.a.copy(t[e]), this.b.copy(t[n]), this.c.copy(t[i]), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      return Me.subVectors(this.c, this.b), Se.subVectors(this.a, this.b), .5 * Me.cross(Se).length();
    }
  }, {
    key: "getMidpoint",
    value: function getMidpoint(t) {
      return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
  }, {
    key: "getNormal",
    value: function getNormal(t) {
      return Ne.getNormal(this.a, this.b, this.c, t);
    }
  }, {
    key: "getPlane",
    value: function getPlane(t) {
      return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
  }, {
    key: "getBarycoord",
    value: function getBarycoord(t, e) {
      return Ne.getBarycoord(t, this.a, this.b, this.c, e);
    }
  }, {
    key: "getUV",
    value: function getUV(t, e, n, i, r) {
      return Ne.getUV(t, this.a, this.b, this.c, e, n, i, r);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      return Ne.containsPoint(t, this.a, this.b, this.c);
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(t) {
      return Ne.isFrontFacing(this.a, this.b, this.c, t);
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsTriangle(this);
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(t, e) {
      var n = this.a,
          i = this.b,
          r = this.c;
      var s, a;
      Le.subVectors(i, n), Re.subVectors(r, n), Qe.subVectors(t, n);
      var o = Le.dot(Qe),
          l = Re.dot(Qe);
      if (o <= 0 && l <= 0) return e.copy(n);
      Pe.subVectors(t, i);
      var c = Le.dot(Pe),
          h = Re.dot(Pe);
      if (c >= 0 && h <= c) return e.copy(i);
      var u = o * h - c * l;
      if (u <= 0 && o >= 0 && c <= 0) return s = o / (o - c), e.copy(n).addScaledVector(Le, s);
      Fe.subVectors(t, r);
      var d = Le.dot(Fe),
          p = Re.dot(Fe);
      if (p >= 0 && d <= p) return e.copy(r);
      var A = d * l - o * p;
      if (A <= 0 && l >= 0 && p <= 0) return a = l / (l - p), e.copy(n).addScaledVector(Re, a);
      var m = c * p - d * h;
      if (m <= 0 && h - c >= 0 && d - p >= 0) return De.subVectors(r, i), a = (h - c) / (h - c + (d - p)), e.copy(i).addScaledVector(De, a);
      var g = 1 / (m + A + u);
      return s = A * g, a = u * g, e.copy(n).addScaledVector(Le, s).addScaledVector(Re, a);
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
  }], [{
    key: "getNormal",
    value: function getNormal(t, e, n, i) {
      i.subVectors(n, e), Me.subVectors(t, e), i.cross(Me);
      var r = i.lengthSq();
      return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
    }
  }, {
    key: "getBarycoord",
    value: function getBarycoord(t, e, n, i, r) {
      Me.subVectors(i, e), Se.subVectors(n, e), Be.subVectors(t, e);
      var s = Me.dot(Me),
          a = Me.dot(Se),
          o = Me.dot(Be),
          l = Se.dot(Se),
          c = Se.dot(Be),
          h = s * l - a * a;
      if (0 === h) return r.set(-2, -1, -1);
      var u = 1 / h,
          d = (l * o - a * c) * u,
          p = (s * c - a * o) * u;
      return r.set(1 - d - p, p, d);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t, e, n, i) {
      return this.getBarycoord(t, e, n, i, Te), Te.x >= 0 && Te.y >= 0 && Te.x + Te.y <= 1;
    }
  }, {
    key: "getUV",
    value: function getUV(t, e, n, i, r, s, a, o) {
      return this.getBarycoord(t, e, n, i, Te), o.set(0, 0), o.addScaledVector(r, Te.x), o.addScaledVector(s, Te.y), o.addScaledVector(a, Te.z), o;
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(t, e, n, i) {
      return Me.subVectors(n, e), Se.subVectors(t, e), Me.cross(Se).dot(i) < 0;
    }
  }]);

  return Ne;
}();

var Ue = 0;

var ke = /*#__PURE__*/function (_tt4) {
  _inherits(ke, _tt4);

  var _super8 = _createSuper(ke);

  function ke() {
    var _this14;

    _classCallCheck(this, ke);

    _this14 = _super8.call(this), Object.defineProperty(_assertThisInitialized(_this14), "id", {
      value: Ue++
    }), _this14.uuid = st(), _this14.name = "", _this14.type = "Material", _this14.fog = !0, _this14.blending = 1, _this14.side = 0, _this14.vertexColors = !1, _this14.opacity = 1, _this14.transparent = !1, _this14.blendSrc = 204, _this14.blendDst = 205, _this14.blendEquation = 100, _this14.blendSrcAlpha = null, _this14.blendDstAlpha = null, _this14.blendEquationAlpha = null, _this14.depthFunc = 3, _this14.depthTest = !0, _this14.depthWrite = !0, _this14.stencilWriteMask = 255, _this14.stencilFunc = 519, _this14.stencilRef = 0, _this14.stencilFuncMask = 255, _this14.stencilFail = 7680, _this14.stencilZFail = 7680, _this14.stencilZPass = 7680, _this14.stencilWrite = !1, _this14.clippingPlanes = null, _this14.clipIntersection = !1, _this14.clipShadows = !1, _this14.shadowSide = null, _this14.colorWrite = !0, _this14.precision = null, _this14.polygonOffset = !1, _this14.polygonOffsetFactor = 0, _this14.polygonOffsetUnits = 0, _this14.dithering = !1, _this14.alphaTest = 0, _this14.alphaToCoverage = !1, _this14.premultipliedAlpha = !1, _this14.visible = !0, _this14.toneMapped = !0, _this14.userData = {}, _this14.version = 0;
    return _this14;
  }

  _createClass(ke, [{
    key: "onBuild",
    value: function onBuild() {}
  }, {
    key: "onBeforeCompile",
    value: function onBeforeCompile() {}
  }, {
    key: "customProgramCacheKey",
    value: function customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
  }, {
    key: "setValues",
    value: function setValues(t) {
      if (void 0 !== t) for (var _e30 in t) {
        var _n37 = t[_e30];

        if (void 0 === _n37) {
          console.warn("THREE.Material: '" + _e30 + "' parameter is undefined.");
          continue;
        }

        if ("shading" === _e30) {
          console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === _n37;
          continue;
        }

        var _i30 = this[_e30];
        void 0 !== _i30 ? _i30 && _i30.isColor ? _i30.set(_n37) : _i30 && _i30.isVector3 && _n37 && _n37.isVector3 ? _i30.copy(_n37) : this[_e30] = _n37 : console.warn("THREE." + this.type + ": '" + _e30 + "' is not a property of this material.");
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = void 0 === t || "string" == typeof t;
      e && (t = {
        textures: {},
        images: {}
      });
      var n = {
        metadata: {
          version: 4.5,
          type: "Material",
          generator: "Material.toJSON"
        }
      };

      function i(t) {
        var e = [];

        for (var _n38 in t) {
          var _i31 = t[_n38];
          delete _i31.metadata, e.push(_i31);
        }

        return e;
      }

      if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), this.sheen && this.sheen.isColor && (n.sheen = this.sheen.getHex()), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularTint && this.specularTint.isColor && (n.specularTint = this.specularTint.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularTintMap && this.specularTintMap.isTexture && (n.specularTintMap = this.specularTintMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), void 0 !== this.attenuationDistance && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationTint && (n.attenuationTint = this.attenuationTint.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (n.blending = this.blending), 0 !== this.side && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaToCoverage && (n.alphaToCoverage = this.alphaToCoverage), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = this.flatShading), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), e) {
        var _e31 = i(t.textures),
            _r16 = i(t.images);

        _e31.length > 0 && (n.textures = _e31), _r16.length > 0 && (n.images = _r16);
      }

      return n;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.name = t.name, this.fog = t.fog, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
      var e = t.clippingPlanes;
      var n = null;

      if (null !== e) {
        var _t47 = e.length;
        n = new Array(_t47);

        for (var _i32 = 0; _i32 !== _t47; ++_i32) {
          n[_i32] = e[_i32].clone();
        }
      }

      return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }]);

  return ke;
}(tt);

ke.prototype.isMaterial = !0;
var Ge = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
},
    Oe = {
  h: 0,
  s: 0,
  l: 0
},
    He = {
  h: 0,
  s: 0,
  l: 0
};

function ze(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - n) : t;
}

function Ve(t) {
  return t < .04045 ? .0773993808 * t : Math.pow(.9478672986 * t + .0521327014, 2.4);
}

function We(t) {
  return t < .0031308 ? 12.92 * t : 1.055 * Math.pow(t, .41666) - .055;
}

var qe = /*#__PURE__*/function () {
  function qe(t, e, n) {
    _classCallCheck(this, qe);

    return void 0 === e && void 0 === n ? this.set(t) : this.setRGB(t, e, n);
  }

  _createClass(qe, [{
    key: "set",
    value: function set(t) {
      return t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t), this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(t) {
      return this.r = t, this.g = t, this.b = t, this;
    }
  }, {
    key: "setHex",
    value: function setHex(t) {
      return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (255 & t) / 255, this;
    }
  }, {
    key: "setRGB",
    value: function setRGB(t, e, n) {
      return this.r = t, this.g = e, this.b = n, this;
    }
  }, {
    key: "setHSL",
    value: function setHSL(t, e, n) {
      if (t = ot(t, 1), e = at(e, 0, 1), n = at(n, 0, 1), 0 === e) this.r = this.g = this.b = n;else {
        var _i33 = n <= .5 ? n * (1 + e) : n + e - n * e,
            _r17 = 2 * n - _i33;

        this.r = ze(_r17, _i33, t + 1 / 3), this.g = ze(_r17, _i33, t), this.b = ze(_r17, _i33, t - 1 / 3);
      }
      return this;
    }
  }, {
    key: "setStyle",
    value: function setStyle(t) {
      function e(e) {
        void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
      }

      var n;

      if (n = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
        var _t48;

        var _i34 = n[1],
            _r18 = n[2];

        switch (_i34) {
          case "rgb":
          case "rgba":
            if (_t48 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r18)) return this.r = Math.min(255, parseInt(_t48[1], 10)) / 255, this.g = Math.min(255, parseInt(_t48[2], 10)) / 255, this.b = Math.min(255, parseInt(_t48[3], 10)) / 255, e(_t48[4]), this;
            if (_t48 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r18)) return this.r = Math.min(100, parseInt(_t48[1], 10)) / 100, this.g = Math.min(100, parseInt(_t48[2], 10)) / 100, this.b = Math.min(100, parseInt(_t48[3], 10)) / 100, e(_t48[4]), this;
            break;

          case "hsl":
          case "hsla":
            if (_t48 = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(_r18)) {
              var _n39 = parseFloat(_t48[1]) / 360,
                  _i35 = parseInt(_t48[2], 10) / 100,
                  _r19 = parseInt(_t48[3], 10) / 100;

              return e(_t48[4]), this.setHSL(_n39, _i35, _r19);
            }

        }
      } else if (n = /^\#([A-Fa-f\d]+)$/.exec(t)) {
        var _t49 = n[1],
            _e32 = _t49.length;
        if (3 === _e32) return this.r = parseInt(_t49.charAt(0) + _t49.charAt(0), 16) / 255, this.g = parseInt(_t49.charAt(1) + _t49.charAt(1), 16) / 255, this.b = parseInt(_t49.charAt(2) + _t49.charAt(2), 16) / 255, this;
        if (6 === _e32) return this.r = parseInt(_t49.charAt(0) + _t49.charAt(1), 16) / 255, this.g = parseInt(_t49.charAt(2) + _t49.charAt(3), 16) / 255, this.b = parseInt(_t49.charAt(4) + _t49.charAt(5), 16) / 255, this;
      }

      return t && t.length > 0 ? this.setColorName(t) : this;
    }
  }, {
    key: "setColorName",
    value: function setColorName(t) {
      var e = Ge[t.toLowerCase()];
      return void 0 !== e ? this.setHex(e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
  }, {
    key: "copyGammaToLinear",
    value: function copyGammaToLinear(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return this.r = Math.pow(t.r, e), this.g = Math.pow(t.g, e), this.b = Math.pow(t.b, e), this;
    }
  }, {
    key: "copyLinearToGamma",
    value: function copyLinearToGamma(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var n = e > 0 ? 1 / e : 1;
      return this.r = Math.pow(t.r, n), this.g = Math.pow(t.g, n), this.b = Math.pow(t.b, n), this;
    }
  }, {
    key: "convertGammaToLinear",
    value: function convertGammaToLinear(t) {
      return this.copyGammaToLinear(this, t), this;
    }
  }, {
    key: "convertLinearToGamma",
    value: function convertLinearToGamma(t) {
      return this.copyLinearToGamma(this, t), this;
    }
  }, {
    key: "copySRGBToLinear",
    value: function copySRGBToLinear(t) {
      return this.r = Ve(t.r), this.g = Ve(t.g), this.b = Ve(t.b), this;
    }
  }, {
    key: "copyLinearToSRGB",
    value: function copyLinearToSRGB(t) {
      return this.r = We(t.r), this.g = We(t.g), this.b = We(t.b), this;
    }
  }, {
    key: "convertSRGBToLinear",
    value: function convertSRGBToLinear() {
      return this.copySRGBToLinear(this), this;
    }
  }, {
    key: "convertLinearToSRGB",
    value: function convertLinearToSRGB() {
      return this.copyLinearToSRGB(this), this;
    }
  }, {
    key: "getHex",
    value: function getHex() {
      return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0;
    }
  }, {
    key: "getHexString",
    value: function getHexString() {
      return ("000000" + this.getHex().toString(16)).slice(-6);
    }
  }, {
    key: "getHSL",
    value: function getHSL(t) {
      var e = this.r,
          n = this.g,
          i = this.b,
          r = Math.max(e, n, i),
          s = Math.min(e, n, i);
      var a, o;
      var l = (s + r) / 2;
      if (s === r) a = 0, o = 0;else {
        var _t50 = r - s;

        switch (o = l <= .5 ? _t50 / (r + s) : _t50 / (2 - r - s), r) {
          case e:
            a = (n - i) / _t50 + (n < i ? 6 : 0);
            break;

          case n:
            a = (i - e) / _t50 + 2;
            break;

          case i:
            a = (e - n) / _t50 + 4;
        }

        a /= 6;
      }
      return t.h = a, t.s = o, t.l = l, t;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")";
    }
  }, {
    key: "offsetHSL",
    value: function offsetHSL(t, e, n) {
      return this.getHSL(Oe), Oe.h += t, Oe.s += e, Oe.l += n, this.setHSL(Oe.h, Oe.s, Oe.l), this;
    }
  }, {
    key: "add",
    value: function add(t) {
      return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
  }, {
    key: "addColors",
    value: function addColors(t, e) {
      return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(t) {
      return this.r += t, this.g += t, this.b += t, this;
    }
  }, {
    key: "sub",
    value: function sub(t) {
      return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
  }, {
    key: "multiply",
    value: function multiply(t) {
      return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(t) {
      return this.r *= t, this.g *= t, this.b *= t, this;
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
  }, {
    key: "lerpColors",
    value: function lerpColors(t, e, n) {
      return this.r = t.r + (e.r - t.r) * n, this.g = t.g + (e.g - t.g) * n, this.b = t.b + (e.b - t.b) * n, this;
    }
  }, {
    key: "lerpHSL",
    value: function lerpHSL(t, e) {
      this.getHSL(Oe), t.getHSL(He);
      var n = lt(Oe.h, He.h, e),
          i = lt(Oe.s, He.s, e),
          r = lt(Oe.l, He.l, e);
      return this.setHSL(n, i, r), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.r === this.r && t.g === this.g && t.b === this.b;
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(t, e) {
      return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), !0 === t.normalized && (this.r /= 255, this.g /= 255, this.b /= 255), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getHex();
    }
  }]);

  return qe;
}();

qe.NAMES = Ge, qe.prototype.isColor = !0, qe.prototype.r = 1, qe.prototype.g = 1, qe.prototype.b = 1;

var je = /*#__PURE__*/function (_ke) {
  _inherits(je, _ke);

  var _super9 = _createSuper(je);

  function je(t) {
    var _this15;

    _classCallCheck(this, je);

    _this15 = _super9.call(this), _this15.type = "MeshBasicMaterial", _this15.color = new qe(16777215), _this15.map = null, _this15.lightMap = null, _this15.lightMapIntensity = 1, _this15.aoMap = null, _this15.aoMapIntensity = 1, _this15.specularMap = null, _this15.alphaMap = null, _this15.envMap = null, _this15.combine = 0, _this15.reflectivity = 1, _this15.refractionRatio = .98, _this15.wireframe = !1, _this15.wireframeLinewidth = 1, _this15.wireframeLinecap = "round", _this15.wireframeLinejoin = "round", _this15.setValues(t);
    return _this15;
  }

  _createClass(je, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(je.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return je;
}(ke);

je.prototype.isMeshBasicMaterial = !0;
var Ye = new _t(),
    Je = new pt();

var Xe = /*#__PURE__*/function () {
  function Xe(t, e, n) {
    _classCallCheck(this, Xe);

    if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.name = "", this.array = t, this.itemSize = e, this.count = void 0 !== t ? t.length / e : 0, this.normalized = !0 === n, this.usage = 35044, this.updateRange = {
      offset: 0,
      count: -1
    }, this.version = 0;
  }

  _createClass(Xe, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(t) {
      return this.usage = t, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(t, e, n) {
      t *= this.itemSize, n *= e.itemSize;

      for (var _i36 = 0, _r20 = this.itemSize; _i36 < _r20; _i36++) {
        this.array[t + _i36] = e.array[n + _i36];
      }

      return this;
    }
  }, {
    key: "copyArray",
    value: function copyArray(t) {
      return this.array.set(t), this;
    }
  }, {
    key: "copyColorsArray",
    value: function copyColorsArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i37 = 0, _r21 = t.length; _i37 < _r21; _i37++) {
        var _r22 = t[_i37];
        void 0 === _r22 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", _i37), _r22 = new qe()), e[n++] = _r22.r, e[n++] = _r22.g, e[n++] = _r22.b;
      }

      return this;
    }
  }, {
    key: "copyVector2sArray",
    value: function copyVector2sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i38 = 0, _r23 = t.length; _i38 < _r23; _i38++) {
        var _r24 = t[_i38];
        void 0 === _r24 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", _i38), _r24 = new pt()), e[n++] = _r24.x, e[n++] = _r24.y;
      }

      return this;
    }
  }, {
    key: "copyVector3sArray",
    value: function copyVector3sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i39 = 0, _r25 = t.length; _i39 < _r25; _i39++) {
        var _r26 = t[_i39];
        void 0 === _r26 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", _i39), _r26 = new _t()), e[n++] = _r26.x, e[n++] = _r26.y, e[n++] = _r26.z;
      }

      return this;
    }
  }, {
    key: "copyVector4sArray",
    value: function copyVector4sArray(t) {
      var e = this.array;
      var n = 0;

      for (var _i40 = 0, _r27 = t.length; _i40 < _r27; _i40++) {
        var _r28 = t[_i40];
        void 0 === _r28 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", _i40), _r28 = new xt()), e[n++] = _r28.x, e[n++] = _r28.y, e[n++] = _r28.z, e[n++] = _r28.w;
      }

      return this;
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(t) {
      if (2 === this.itemSize) for (var _e33 = 0, _n40 = this.count; _e33 < _n40; _e33++) {
        Je.fromBufferAttribute(this, _e33), Je.applyMatrix3(t), this.setXY(_e33, Je.x, Je.y);
      } else if (3 === this.itemSize) for (var _e34 = 0, _n41 = this.count; _e34 < _n41; _e34++) {
        Ye.fromBufferAttribute(this, _e34), Ye.applyMatrix3(t), this.setXYZ(_e34, Ye.x, Ye.y, Ye.z);
      }
      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      for (var _e35 = 0, _n42 = this.count; _e35 < _n42; _e35++) {
        Ye.x = this.getX(_e35), Ye.y = this.getY(_e35), Ye.z = this.getZ(_e35), Ye.applyMatrix4(t), this.setXYZ(_e35, Ye.x, Ye.y, Ye.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      for (var _e36 = 0, _n43 = this.count; _e36 < _n43; _e36++) {
        Ye.x = this.getX(_e36), Ye.y = this.getY(_e36), Ye.z = this.getZ(_e36), Ye.applyNormalMatrix(t), this.setXYZ(_e36, Ye.x, Ye.y, Ye.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      for (var _e37 = 0, _n44 = this.count; _e37 < _n44; _e37++) {
        Ye.x = this.getX(_e37), Ye.y = this.getY(_e37), Ye.z = this.getZ(_e37), Ye.transformDirection(t), this.setXYZ(_e37, Ye.x, Ye.y, Ye.z);
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.array.set(t, e), this;
    }
  }, {
    key: "getX",
    value: function getX(t) {
      return this.array[t * this.itemSize];
    }
  }, {
    key: "setX",
    value: function setX(t, e) {
      return this.array[t * this.itemSize] = e, this;
    }
  }, {
    key: "getY",
    value: function getY(t) {
      return this.array[t * this.itemSize + 1];
    }
  }, {
    key: "setY",
    value: function setY(t, e) {
      return this.array[t * this.itemSize + 1] = e, this;
    }
  }, {
    key: "getZ",
    value: function getZ(t) {
      return this.array[t * this.itemSize + 2];
    }
  }, {
    key: "setZ",
    value: function setZ(t, e) {
      return this.array[t * this.itemSize + 2] = e, this;
    }
  }, {
    key: "getW",
    value: function getW(t) {
      return this.array[t * this.itemSize + 3];
    }
  }, {
    key: "setW",
    value: function setW(t, e) {
      return this.array[t * this.itemSize + 3] = e, this;
    }
  }, {
    key: "setXY",
    value: function setXY(t, e, n) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(t, e, n, i) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(t, e, n, i, r) {
      return t *= this.itemSize, this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this.array[t + 3] = r, this;
    }
  }, {
    key: "onUpload",
    value: function onUpload(t) {
      return this.onUploadCallback = t, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.prototype.slice.call(this.array),
        normalized: this.normalized
      };
      return "" !== this.name && (t.name = this.name), 35044 !== this.usage && (t.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t.updateRange = this.updateRange), t;
    }
  }]);

  return Xe;
}();

Xe.prototype.isBufferAttribute = !0;

var Ke = /*#__PURE__*/function (_Xe) {
  _inherits(Ke, _Xe);

  var _super10 = _createSuper(Ke);

  function Ke(t, e, n) {
    _classCallCheck(this, Ke);

    return _super10.call(this, new Uint16Array(t), e, n);
  }

  return _createClass(Ke);
}(Xe);

var Ze = /*#__PURE__*/function (_Xe2) {
  _inherits(Ze, _Xe2);

  var _super11 = _createSuper(Ze);

  function Ze(t, e, n) {
    _classCallCheck(this, Ze);

    return _super11.call(this, new Uint32Array(t), e, n);
  }

  return _createClass(Ze);
}(Xe);

/*#__PURE__*/
(function (_Xe3) {
  _inherits(_class3, _Xe3);

  var _super12 = _createSuper(_class3);

  function _class3(t, e, n) {
    _classCallCheck(this, _class3);

    return _super12.call(this, new Uint16Array(t), e, n);
  }

  return _createClass(_class3);
})(Xe).prototype.isFloat16BufferAttribute = !0;

var $e = /*#__PURE__*/function (_Xe4) {
  _inherits($e, _Xe4);

  var _super13 = _createSuper($e);

  function $e(t, e, n) {
    _classCallCheck(this, $e);

    return _super13.call(this, new Float32Array(t), e, n);
  }

  return _createClass($e);
}(Xe);

function tn(t) {
  if (0 === t.length) return -1 / 0;
  var e = t[0];

  for (var _n45 = 1, _i41 = t.length; _n45 < _i41; ++_n45) {
    t[_n45] > e && (e = t[_n45]);
  }

  return e;
}

var en = 0;
var nn = new ee(),
    rn = new Ce(),
    sn = new _t(),
    an = new Mt(),
    on = new Mt(),
    ln = new _t();

var cn = /*#__PURE__*/function (_tt5) {
  _inherits(cn, _tt5);

  var _super14 = _createSuper(cn);

  function cn() {
    var _this16;

    _classCallCheck(this, cn);

    _this16 = _super14.call(this), Object.defineProperty(_assertThisInitialized(_this16), "id", {
      value: en++
    }), _this16.uuid = st(), _this16.name = "", _this16.type = "BufferGeometry", _this16.index = null, _this16.attributes = {}, _this16.morphAttributes = {}, _this16.morphTargetsRelative = !1, _this16.groups = [], _this16.boundingBox = null, _this16.boundingSphere = null, _this16.drawRange = {
      start: 0,
      count: 1 / 0
    }, _this16.userData = {};
    return _this16;
  }

  _createClass(cn, [{
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
  }, {
    key: "setIndex",
    value: function setIndex(t) {
      return Array.isArray(t) ? this.index = new (tn(t) > 65535 ? Ze : Ke)(t, 1) : this.index = t, this;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(t) {
      return this.attributes[t];
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(t, e) {
      return this.attributes[t] = e, this;
    }
  }, {
    key: "deleteAttribute",
    value: function deleteAttribute(t) {
      return delete this.attributes[t], this;
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(t) {
      return void 0 !== this.attributes[t];
    }
  }, {
    key: "addGroup",
    value: function addGroup(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.groups.push({
        start: t,
        count: e,
        materialIndex: n
      });
    }
  }, {
    key: "clearGroups",
    value: function clearGroups() {
      this.groups = [];
    }
  }, {
    key: "setDrawRange",
    value: function setDrawRange(t, e) {
      this.drawRange.start = t, this.drawRange.count = e;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      var e = this.attributes.position;
      void 0 !== e && (e.applyMatrix4(t), e.needsUpdate = !0);
      var n = this.attributes.normal;

      if (void 0 !== n) {
        var _e38 = new At().getNormalMatrix(t);

        n.applyNormalMatrix(_e38), n.needsUpdate = !0;
      }

      var i = this.attributes.tangent;
      return void 0 !== i && (i.transformDirection(t), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(t) {
      return nn.makeRotationFromQuaternion(t), this.applyMatrix4(nn), this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(t) {
      return nn.makeRotationX(t), this.applyMatrix4(nn), this;
    }
  }, {
    key: "rotateY",
    value: function rotateY(t) {
      return nn.makeRotationY(t), this.applyMatrix4(nn), this;
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(t) {
      return nn.makeRotationZ(t), this.applyMatrix4(nn), this;
    }
  }, {
    key: "translate",
    value: function translate(t, e, n) {
      return nn.makeTranslation(t, e, n), this.applyMatrix4(nn), this;
    }
  }, {
    key: "scale",
    value: function scale(t, e, n) {
      return nn.makeScale(t, e, n), this.applyMatrix4(nn), this;
    }
  }, {
    key: "lookAt",
    value: function lookAt(t) {
      return rn.lookAt(t), rn.updateMatrix(), this.applyMatrix4(rn.matrix), this;
    }
  }, {
    key: "center",
    value: function center() {
      return this.computeBoundingBox(), this.boundingBox.getCenter(sn).negate(), this.translate(sn.x, sn.y, sn.z), this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(t) {
      var e = [];

      for (var _n46 = 0, _i42 = t.length; _n46 < _i42; _n46++) {
        var _i43 = t[_n46];
        e.push(_i43.x, _i43.y, _i43.z || 0);
      }

      return this.setAttribute("position", new $e(e, 3)), this;
    }
  }, {
    key: "computeBoundingBox",
    value: function computeBoundingBox() {
      null === this.boundingBox && (this.boundingBox = new Mt());
      var t = this.attributes.position,
          e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new _t(-1 / 0, -1 / 0, -1 / 0), new _t(1 / 0, 1 / 0, 1 / 0));

      if (void 0 !== t) {
        if (this.boundingBox.setFromBufferAttribute(t), e) for (var _t51 = 0, _n47 = e.length; _t51 < _n47; _t51++) {
          var _n48 = e[_t51];
          an.setFromBufferAttribute(_n48), this.morphTargetsRelative ? (ln.addVectors(this.boundingBox.min, an.min), this.boundingBox.expandByPoint(ln), ln.addVectors(this.boundingBox.max, an.max), this.boundingBox.expandByPoint(ln)) : (this.boundingBox.expandByPoint(an.min), this.boundingBox.expandByPoint(an.max));
        }
      } else this.boundingBox.makeEmpty();

      (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }, {
    key: "computeBoundingSphere",
    value: function computeBoundingSphere() {
      null === this.boundingSphere && (this.boundingSphere = new qt());
      var t = this.attributes.position,
          e = this.morphAttributes.position;
      if (t && t.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new _t(), 1 / 0);

      if (t) {
        var _n49 = this.boundingSphere.center;
        if (an.setFromBufferAttribute(t), e) for (var _t52 = 0, _n50 = e.length; _t52 < _n50; _t52++) {
          var _n51 = e[_t52];
          on.setFromBufferAttribute(_n51), this.morphTargetsRelative ? (ln.addVectors(an.min, on.min), an.expandByPoint(ln), ln.addVectors(an.max, on.max), an.expandByPoint(ln)) : (an.expandByPoint(on.min), an.expandByPoint(on.max));
        }
        an.getCenter(_n49);
        var _i44 = 0;

        for (var _e39 = 0, _r29 = t.count; _e39 < _r29; _e39++) {
          ln.fromBufferAttribute(t, _e39), _i44 = Math.max(_i44, _n49.distanceToSquared(ln));
        }

        if (e) for (var _r30 = 0, _s10 = e.length; _r30 < _s10; _r30++) {
          var _s11 = e[_r30],
              _a7 = this.morphTargetsRelative;

          for (var _e40 = 0, _r31 = _s11.count; _e40 < _r31; _e40++) {
            ln.fromBufferAttribute(_s11, _e40), _a7 && (sn.fromBufferAttribute(t, _e40), ln.add(sn)), _i44 = Math.max(_i44, _n49.distanceToSquared(ln));
          }
        }
        this.boundingSphere.radius = Math.sqrt(_i44), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }, {
    key: "computeFaceNormals",
    value: function computeFaceNormals() {}
  }, {
    key: "computeTangents",
    value: function computeTangents() {
      var t = this.index,
          e = this.attributes;
      if (null === t || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      var n = t.array,
          i = e.position.array,
          r = e.normal.array,
          s = e.uv.array,
          a = i.length / 3;
      void 0 === e.tangent && this.setAttribute("tangent", new Xe(new Float32Array(4 * a), 4));
      var o = e.tangent.array,
          l = [],
          c = [];

      for (var _t53 = 0; _t53 < a; _t53++) {
        l[_t53] = new _t(), c[_t53] = new _t();
      }

      var h = new _t(),
          u = new _t(),
          d = new _t(),
          p = new pt(),
          A = new pt(),
          m = new pt(),
          g = new _t(),
          f = new _t();

      function v(t, e, n) {
        h.fromArray(i, 3 * t), u.fromArray(i, 3 * e), d.fromArray(i, 3 * n), p.fromArray(s, 2 * t), A.fromArray(s, 2 * e), m.fromArray(s, 2 * n), u.sub(h), d.sub(h), A.sub(p), m.sub(p);
        var r = 1 / (A.x * m.y - m.x * A.y);
        isFinite(r) && (g.copy(u).multiplyScalar(m.y).addScaledVector(d, -A.y).multiplyScalar(r), f.copy(d).multiplyScalar(A.x).addScaledVector(u, -m.x).multiplyScalar(r), l[t].add(g), l[e].add(g), l[n].add(g), c[t].add(f), c[e].add(f), c[n].add(f));
      }

      var y = this.groups;
      0 === y.length && (y = [{
        start: 0,
        count: n.length
      }]);

      for (var _t54 = 0, _e41 = y.length; _t54 < _e41; ++_t54) {
        var _e42 = y[_t54],
            _i45 = _e42.start;

        for (var _t55 = _i45, _r32 = _i45 + _e42.count; _t55 < _r32; _t55 += 3) {
          v(n[_t55 + 0], n[_t55 + 1], n[_t55 + 2]);
        }
      }

      var x = new _t(),
          w = new _t(),
          E = new _t(),
          b = new _t();

      function _(t) {
        E.fromArray(r, 3 * t), b.copy(E);
        var e = l[t];
        x.copy(e), x.sub(E.multiplyScalar(E.dot(e))).normalize(), w.crossVectors(b, e);
        var n = w.dot(c[t]) < 0 ? -1 : 1;
        o[4 * t] = x.x, o[4 * t + 1] = x.y, o[4 * t + 2] = x.z, o[4 * t + 3] = n;
      }

      for (var _t56 = 0, _e43 = y.length; _t56 < _e43; ++_t56) {
        var _e44 = y[_t56],
            _i46 = _e44.start;

        for (var _t57 = _i46, _r33 = _i46 + _e44.count; _t57 < _r33; _t57 += 3) {
          _(n[_t57 + 0]), _(n[_t57 + 1]), _(n[_t57 + 2]);
        }
      }
    }
  }, {
    key: "computeVertexNormals",
    value: function computeVertexNormals() {
      var t = this.index,
          e = this.getAttribute("position");

      if (void 0 !== e) {
        var _n52 = this.getAttribute("normal");

        if (void 0 === _n52) _n52 = new Xe(new Float32Array(3 * e.count), 3), this.setAttribute("normal", _n52);else for (var _t58 = 0, _e45 = _n52.count; _t58 < _e45; _t58++) {
          _n52.setXYZ(_t58, 0, 0, 0);
        }

        var _i47 = new _t(),
            _r34 = new _t(),
            _s12 = new _t(),
            _a8 = new _t(),
            _o9 = new _t(),
            _l8 = new _t(),
            _c6 = new _t(),
            _h4 = new _t();

        if (t) for (var _u2 = 0, _d2 = t.count; _u2 < _d2; _u2 += 3) {
          var _d3 = t.getX(_u2 + 0),
              _p2 = t.getX(_u2 + 1),
              _A2 = t.getX(_u2 + 2);

          _i47.fromBufferAttribute(e, _d3), _r34.fromBufferAttribute(e, _p2), _s12.fromBufferAttribute(e, _A2), _c6.subVectors(_s12, _r34), _h4.subVectors(_i47, _r34), _c6.cross(_h4), _a8.fromBufferAttribute(_n52, _d3), _o9.fromBufferAttribute(_n52, _p2), _l8.fromBufferAttribute(_n52, _A2), _a8.add(_c6), _o9.add(_c6), _l8.add(_c6), _n52.setXYZ(_d3, _a8.x, _a8.y, _a8.z), _n52.setXYZ(_p2, _o9.x, _o9.y, _o9.z), _n52.setXYZ(_A2, _l8.x, _l8.y, _l8.z);
        } else for (var _t59 = 0, _a9 = e.count; _t59 < _a9; _t59 += 3) {
          _i47.fromBufferAttribute(e, _t59 + 0), _r34.fromBufferAttribute(e, _t59 + 1), _s12.fromBufferAttribute(e, _t59 + 2), _c6.subVectors(_s12, _r34), _h4.subVectors(_i47, _r34), _c6.cross(_h4), _n52.setXYZ(_t59 + 0, _c6.x, _c6.y, _c6.z), _n52.setXYZ(_t59 + 1, _c6.x, _c6.y, _c6.z), _n52.setXYZ(_t59 + 2, _c6.x, _c6.y, _c6.z);
        }
        this.normalizeNormals(), _n52.needsUpdate = !0;
      }
    }
  }, {
    key: "merge",
    value: function merge(t, e) {
      if (!t || !t.isBufferGeometry) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t);
      void 0 === e && (e = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
      var n = this.attributes;

      for (var _i48 in n) {
        if (void 0 === t.attributes[_i48]) continue;

        var _r35 = n[_i48].array,
            _s13 = t.attributes[_i48],
            _a10 = _s13.array,
            _o10 = _s13.itemSize * e,
            _l9 = Math.min(_a10.length, _r35.length - _o10);

        for (var _t60 = 0, _e46 = _o10; _t60 < _l9; _t60++, _e46++) {
          _r35[_e46] = _a10[_t60];
        }
      }

      return this;
    }
  }, {
    key: "normalizeNormals",
    value: function normalizeNormals() {
      var t = this.attributes.normal;

      for (var _e47 = 0, _n53 = t.count; _e47 < _n53; _e47++) {
        ln.fromBufferAttribute(t, _e47), ln.normalize(), t.setXYZ(_e47, ln.x, ln.y, ln.z);
      }
    }
  }, {
    key: "toNonIndexed",
    value: function toNonIndexed() {
      function t(t, e) {
        var n = t.array,
            i = t.itemSize,
            r = t.normalized,
            s = new n.constructor(e.length * i);
        var a = 0,
            o = 0;

        for (var _r36 = 0, _l10 = e.length; _r36 < _l10; _r36++) {
          a = t.isInterleavedBufferAttribute ? e[_r36] * t.data.stride + t.offset : e[_r36] * i;

          for (var _t61 = 0; _t61 < i; _t61++) {
            s[o++] = n[a++];
          }
        }

        return new Xe(s, i, r);
      }

      if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
      var e = new cn(),
          n = this.index.array,
          i = this.attributes;

      for (var _r37 in i) {
        var _s14 = t(i[_r37], n);

        e.setAttribute(_r37, _s14);
      }

      var r = this.morphAttributes;

      for (var _i49 in r) {
        var _s15 = [],
            _a11 = r[_i49];

        for (var _e48 = 0, _i50 = _a11.length; _e48 < _i50; _e48++) {
          var _i51 = t(_a11[_e48], n);

          _s15.push(_i51);
        }

        e.morphAttributes[_i49] = _s15;
      }

      e.morphTargetsRelative = this.morphTargetsRelative;
      var s = this.groups;

      for (var _t62 = 0, _n54 = s.length; _t62 < _n54; _t62++) {
        var _n55 = s[_t62];
        e.addGroup(_n55.start, _n55.count, _n55.materialIndex);
      }

      return e;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "BufferGeometry",
          generator: "BufferGeometry.toJSON"
        }
      };

      if (t.uuid = this.uuid, t.type = this.type, "" !== this.name && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), void 0 !== this.parameters) {
        var _e49 = this.parameters;

        for (var _n56 in _e49) {
          void 0 !== _e49[_n56] && (t[_n56] = _e49[_n56]);
        }

        return t;
      }

      t.data = {
        attributes: {}
      };
      var e = this.index;
      null !== e && (t.data.index = {
        type: e.array.constructor.name,
        array: Array.prototype.slice.call(e.array)
      });
      var n = this.attributes;

      for (var _e50 in n) {
        var _i52 = n[_e50];
        t.data.attributes[_e50] = _i52.toJSON(t.data);
      }

      var i = {};
      var r = !1;

      for (var _e51 in this.morphAttributes) {
        var _n57 = this.morphAttributes[_e51],
            _s16 = [];

        for (var _e52 = 0, _i53 = _n57.length; _e52 < _i53; _e52++) {
          var _i54 = _n57[_e52];

          _s16.push(_i54.toJSON(t.data));
        }

        _s16.length > 0 && (i[_e51] = _s16, r = !0);
      }

      r && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
      var s = this.groups;
      s.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(s)));
      var a = this.boundingSphere;
      return null !== a && (t.data.boundingSphere = {
        center: a.center.toArray(),
        radius: a.radius
      }), t;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new cn().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
      var e = {};
      this.name = t.name;
      var n = t.index;
      null !== n && this.setIndex(n.clone(e));
      var i = t.attributes;

      for (var _t63 in i) {
        var _n58 = i[_t63];
        this.setAttribute(_t63, _n58.clone(e));
      }

      var r = t.morphAttributes;

      for (var _t64 in r) {
        var _n59 = [],
            _i55 = r[_t64];

        for (var _t65 = 0, _r38 = _i55.length; _t65 < _r38; _t65++) {
          _n59.push(_i55[_t65].clone(e));
        }

        this.morphAttributes[_t64] = _n59;
      }

      this.morphTargetsRelative = t.morphTargetsRelative;
      var s = t.groups;

      for (var _t66 = 0, _e53 = s.length; _t66 < _e53; _t66++) {
        var _e54 = s[_t66];
        this.addGroup(_e54.start, _e54.count, _e54.materialIndex);
      }

      var a = t.boundingBox;
      null !== a && (this.boundingBox = a.clone());
      var o = t.boundingSphere;
      return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return cn;
}(tt);

cn.prototype.isBufferGeometry = !0;

var hn = new ee(),
    un = new te(),
    dn = new qt(),
    pn = new _t(),
    An = new _t(),
    mn = new _t(),
    gn = new _t(),
    fn = new _t(),
    vn = new _t(),
    yn = new _t(),
    xn = new _t(),
    wn = new _t(),
    En = new pt(),
    bn = new pt(),
    _n = new pt(),
    In = new _t(),
    Cn = new _t();

var Mn = /*#__PURE__*/function (_Ce) {
  _inherits(Mn, _Ce);

  var _super15 = _createSuper(Mn);

  function Mn() {
    var _this17;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new cn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new je();

    _classCallCheck(this, Mn);

    _this17 = _super15.call(this), _this17.type = "Mesh", _this17.geometry = t, _this17.material = e, _this17.updateMorphTargets();
    return _this17;
  }

  _createClass(Mn, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Mn.prototype), "copy", this).call(this, t), void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e55 = t.morphAttributes,
            _n60 = Object.keys(_e55);

        if (_n60.length > 0) {
          var _t67 = _e55[_n60[0]];

          if (void 0 !== _t67) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e56 = 0, _n61 = _t67.length; _e56 < _n61; _e56++) {
              var _n62 = _t67[_e56].name || String(_e56);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n62] = _e56;
            }
          }
        }
      } else {
        var _e57 = t.morphTargets;
        void 0 !== _e57 && _e57.length > 0 && console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.material,
          r = this.matrixWorld;
      if (void 0 === i) return;
      if (null === n.boundingSphere && n.computeBoundingSphere(), dn.copy(n.boundingSphere), dn.applyMatrix4(r), !1 === t.ray.intersectsSphere(dn)) return;
      if (hn.copy(r).invert(), un.copy(t.ray).applyMatrix4(hn), null !== n.boundingBox && !1 === un.intersectsBox(n.boundingBox)) return;
      var s;

      if (n.isBufferGeometry) {
        var _r39 = n.index,
            _a12 = n.attributes.position,
            _o11 = n.morphAttributes.position,
            _l11 = n.morphTargetsRelative,
            _c7 = n.attributes.uv,
            _h5 = n.attributes.uv2,
            _u3 = n.groups,
            _d4 = n.drawRange;
        if (null !== _r39) {
          if (Array.isArray(i)) for (var _n63 = 0, _p3 = _u3.length; _n63 < _p3; _n63++) {
            var _p4 = _u3[_n63],
                _A3 = i[_p4.materialIndex];

            for (var _n64 = Math.max(_p4.start, _d4.start), _i56 = Math.min(_p4.start + _p4.count, _d4.start + _d4.count); _n64 < _i56; _n64 += 3) {
              var _i57 = _r39.getX(_n64),
                  _u4 = _r39.getX(_n64 + 1),
                  _d5 = _r39.getX(_n64 + 2);

              s = Sn(this, _A3, t, un, _a12, _o11, _l11, _c7, _h5, _i57, _u4, _d5), s && (s.faceIndex = Math.floor(_n64 / 3), s.face.materialIndex = _p4.materialIndex, e.push(s));
            }
          } else {
            for (var _n65 = Math.max(0, _d4.start), _u5 = Math.min(_r39.count, _d4.start + _d4.count); _n65 < _u5; _n65 += 3) {
              var _u6 = _r39.getX(_n65),
                  _d6 = _r39.getX(_n65 + 1),
                  _p5 = _r39.getX(_n65 + 2);

              s = Sn(this, i, t, un, _a12, _o11, _l11, _c7, _h5, _u6, _d6, _p5), s && (s.faceIndex = Math.floor(_n65 / 3), e.push(s));
            }
          }
        } else if (void 0 !== _a12) if (Array.isArray(i)) for (var _n66 = 0, _r40 = _u3.length; _n66 < _r40; _n66++) {
          var _r41 = _u3[_n66],
              _p6 = i[_r41.materialIndex];

          for (var _n67 = Math.max(_r41.start, _d4.start), _i58 = Math.min(_r41.start + _r41.count, _d4.start + _d4.count); _n67 < _i58; _n67 += 3) {
            s = Sn(this, _p6, t, un, _a12, _o11, _l11, _c7, _h5, _n67, _n67 + 1, _n67 + 2), s && (s.faceIndex = Math.floor(_n67 / 3), s.face.materialIndex = _r41.materialIndex, e.push(s));
          }
        } else {
          for (var _n68 = Math.max(0, _d4.start), _r42 = Math.min(_a12.count, _d4.start + _d4.count); _n68 < _r42; _n68 += 3) {
            s = Sn(this, i, t, un, _a12, _o11, _l11, _c7, _h5, _n68, _n68 + 1, _n68 + 2), s && (s.faceIndex = Math.floor(_n68 / 3), e.push(s));
          }
        }
      } else n.isGeometry && console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }]);

  return Mn;
}(Ce);

function Sn(t, e, n, i, r, s, a, o, l, c, h, u) {
  pn.fromBufferAttribute(r, c), An.fromBufferAttribute(r, h), mn.fromBufferAttribute(r, u);
  var d = t.morphTargetInfluences;

  if (s && d) {
    yn.set(0, 0, 0), xn.set(0, 0, 0), wn.set(0, 0, 0);

    for (var _t68 = 0, _e58 = s.length; _t68 < _e58; _t68++) {
      var _e59 = d[_t68],
          _n69 = s[_t68];
      0 !== _e59 && (gn.fromBufferAttribute(_n69, c), fn.fromBufferAttribute(_n69, h), vn.fromBufferAttribute(_n69, u), a ? (yn.addScaledVector(gn, _e59), xn.addScaledVector(fn, _e59), wn.addScaledVector(vn, _e59)) : (yn.addScaledVector(gn.sub(pn), _e59), xn.addScaledVector(fn.sub(An), _e59), wn.addScaledVector(vn.sub(mn), _e59)));
    }

    pn.add(yn), An.add(xn), mn.add(wn);
  }

  t.isSkinnedMesh && (t.boneTransform(c, pn), t.boneTransform(h, An), t.boneTransform(u, mn));

  var p = function (t, e, n, i, r, s, a, o) {
    var l;
    if (l = 1 === e.side ? i.intersectTriangle(a, s, r, !0, o) : i.intersectTriangle(r, s, a, 2 !== e.side, o), null === l) return null;
    Cn.copy(o), Cn.applyMatrix4(t.matrixWorld);
    var c = n.ray.origin.distanceTo(Cn);
    return c < n.near || c > n.far ? null : {
      distance: c,
      point: Cn.clone(),
      object: t
    };
  }(t, e, n, i, pn, An, mn, In);

  if (p) {
    o && (En.fromBufferAttribute(o, c), bn.fromBufferAttribute(o, h), _n.fromBufferAttribute(o, u), p.uv = Ne.getUV(In, pn, An, mn, En, bn, _n, new pt())), l && (En.fromBufferAttribute(l, c), bn.fromBufferAttribute(l, h), _n.fromBufferAttribute(l, u), p.uv2 = Ne.getUV(In, pn, An, mn, En, bn, _n, new pt()));
    var _t69 = {
      a: c,
      b: h,
      c: u,
      normal: new _t(),
      materialIndex: 0
    };
    Ne.getNormal(pn, An, mn, _t69.normal), p.face = _t69;
  }

  return p;
}

Mn.prototype.isMesh = !0;

var Bn = /*#__PURE__*/function (_cn) {
  _inherits(Bn, _cn);

  var _super16 = _createSuper(Bn);

  function Bn() {
    var _this18;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck(this, Bn);

    _this18 = _super16.call(this), _this18.type = "BoxGeometry", _this18.parameters = {
      width: t,
      height: e,
      depth: n,
      widthSegments: i,
      heightSegments: r,
      depthSegments: s
    };

    var a = _assertThisInitialized(_this18);

    i = Math.floor(i), r = Math.floor(r), s = Math.floor(s);
    var o = [],
        l = [],
        c = [],
        h = [];
    var u = 0,
        d = 0;

    function p(t, e, n, i, r, s, p, A, m, g, f) {
      var v = s / m,
          y = p / g,
          x = s / 2,
          w = p / 2,
          E = A / 2,
          b = m + 1,
          _ = g + 1;

      var I = 0,
          C = 0;
      var M = new _t();

      for (var _s17 = 0; _s17 < _; _s17++) {
        var _a13 = _s17 * y - w;

        for (var _o12 = 0; _o12 < b; _o12++) {
          var _u7 = _o12 * v - x;

          M[t] = _u7 * i, M[e] = _a13 * r, M[n] = E, l.push(M.x, M.y, M.z), M[t] = 0, M[e] = 0, M[n] = A > 0 ? 1 : -1, c.push(M.x, M.y, M.z), h.push(_o12 / m), h.push(1 - _s17 / g), I += 1;
        }
      }

      for (var _t70 = 0; _t70 < g; _t70++) {
        for (var _e60 = 0; _e60 < m; _e60++) {
          var _n70 = u + _e60 + b * _t70,
              _i59 = u + _e60 + b * (_t70 + 1),
              _r43 = u + (_e60 + 1) + b * (_t70 + 1),
              _s18 = u + (_e60 + 1) + b * _t70;

          o.push(_n70, _i59, _s18), o.push(_i59, _r43, _s18), C += 6;
        }
      }

      a.addGroup(d, C, f), d += C, u += I;
    }

    p("z", "y", "x", -1, -1, n, e, t, s, r, 0), p("z", "y", "x", 1, -1, n, e, -t, s, r, 1), p("x", "z", "y", 1, 1, t, n, e, i, s, 2), p("x", "z", "y", 1, -1, t, n, -e, i, s, 3), p("x", "y", "z", 1, -1, t, e, n, i, r, 4), p("x", "y", "z", -1, -1, t, e, -n, i, r, 5), _this18.setIndex(o), _this18.setAttribute("position", new $e(l, 3)), _this18.setAttribute("normal", new $e(c, 3)), _this18.setAttribute("uv", new $e(h, 2));
    return _this18;
  }

  _createClass(Bn, null, [{
    key: "fromJSON",
    value: function fromJSON(t) {
      return new Bn(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
  }]);

  return Bn;
}(cn);

function Tn(t) {
  var e = {};

  for (var _n71 in t) {
    e[_n71] = {};

    for (var _i60 in t[_n71]) {
      var _r44 = t[_n71][_i60];
      _r44 && (_r44.isColor || _r44.isMatrix3 || _r44.isMatrix4 || _r44.isVector2 || _r44.isVector3 || _r44.isVector4 || _r44.isTexture || _r44.isQuaternion) ? e[_n71][_i60] = _r44.clone() : Array.isArray(_r44) ? e[_n71][_i60] = _r44.slice() : e[_n71][_i60] = _r44;
    }
  }

  return e;
}

function Ln(t) {
  var e = {};

  for (var _n72 = 0; _n72 < t.length; _n72++) {
    var _i61 = Tn(t[_n72]);

    for (var _t71 in _i61) {
      e[_t71] = _i61[_t71];
    }
  }

  return e;
}

var Rn = {
  clone: Tn,
  merge: Ln
};

var Dn = /*#__PURE__*/function (_ke2) {
  _inherits(Dn, _ke2);

  var _super17 = _createSuper(Dn);

  function Dn(t) {
    var _this19;

    _classCallCheck(this, Dn);

    _this19 = _super17.call(this), _this19.type = "ShaderMaterial", _this19.defines = {}, _this19.uniforms = {}, _this19.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", _this19.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", _this19.linewidth = 1, _this19.wireframe = !1, _this19.wireframeLinewidth = 1, _this19.fog = !1, _this19.lights = !1, _this19.clipping = !1, _this19.extensions = {
      derivatives: !1,
      fragDepth: !1,
      drawBuffers: !1,
      shaderTextureLOD: !1
    }, _this19.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv2: [0, 0]
    }, _this19.index0AttributeName = void 0, _this19.uniformsNeedUpdate = !1, _this19.glslVersion = null, void 0 !== t && (void 0 !== t.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), _this19.setValues(t));
    return _this19;
  }

  _createClass(Dn, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Dn.prototype), "copy", this).call(this, t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = Tn(t.uniforms), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Dn.prototype), "toJSON", this).call(this, t);

      e.glslVersion = this.glslVersion, e.uniforms = {};

      for (var _n73 in this.uniforms) {
        var _i62 = this.uniforms[_n73].value;
        _i62 && _i62.isTexture ? e.uniforms[_n73] = {
          type: "t",
          value: _i62.toJSON(t).uuid
        } : _i62 && _i62.isColor ? e.uniforms[_n73] = {
          type: "c",
          value: _i62.getHex()
        } : _i62 && _i62.isVector2 ? e.uniforms[_n73] = {
          type: "v2",
          value: _i62.toArray()
        } : _i62 && _i62.isVector3 ? e.uniforms[_n73] = {
          type: "v3",
          value: _i62.toArray()
        } : _i62 && _i62.isVector4 ? e.uniforms[_n73] = {
          type: "v4",
          value: _i62.toArray()
        } : _i62 && _i62.isMatrix3 ? e.uniforms[_n73] = {
          type: "m3",
          value: _i62.toArray()
        } : _i62 && _i62.isMatrix4 ? e.uniforms[_n73] = {
          type: "m4",
          value: _i62.toArray()
        } : e.uniforms[_n73] = {
          value: _i62
        };
      }

      Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
      var n = {};

      for (var _t72 in this.extensions) {
        !0 === this.extensions[_t72] && (n[_t72] = !0);
      }

      return Object.keys(n).length > 0 && (e.extensions = n), e;
    }
  }]);

  return Dn;
}(ke);

Dn.prototype.isShaderMaterial = !0;

var Qn = /*#__PURE__*/function (_Ce2) {
  _inherits(Qn, _Ce2);

  var _super18 = _createSuper(Qn);

  function Qn() {
    var _this20;

    _classCallCheck(this, Qn);

    _this20 = _super18.call(this), _this20.type = "Camera", _this20.matrixWorldInverse = new ee(), _this20.projectionMatrix = new ee(), _this20.projectionMatrixInverse = new ee();
    return _this20;
  }

  _createClass(Qn, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Qn.prototype), "copy", this).call(this, t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(t) {
      this.updateWorldMatrix(!0, !1);
      var e = this.matrixWorld.elements;
      return t.set(-e[8], -e[9], -e[10]).normalize();
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      _get(_getPrototypeOf(Qn.prototype), "updateMatrixWorld", this).call(this, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(t, e) {
      _get(_getPrototypeOf(Qn.prototype), "updateWorldMatrix", this).call(this, t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Qn;
}(Ce);

Qn.prototype.isCamera = !0;

var Pn = /*#__PURE__*/function (_Qn) {
  _inherits(Pn, _Qn);

  var _super19 = _createSuper(Pn);

  function Pn() {
    var _this21;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2e3;

    _classCallCheck(this, Pn);

    _this21 = _super19.call(this), _this21.type = "PerspectiveCamera", _this21.fov = t, _this21.zoom = 1, _this21.near = n, _this21.far = i, _this21.focus = 10, _this21.aspect = e, _this21.view = null, _this21.filmGauge = 35, _this21.filmOffset = 0, _this21.updateProjectionMatrix();
    return _this21;
  }

  _createClass(Pn, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Pn.prototype), "copy", this).call(this, t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = null === t.view ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
  }, {
    key: "setFocalLength",
    value: function setFocalLength(t) {
      var e = .5 * this.getFilmHeight() / t;
      this.fov = 2 * rt * Math.atan(e), this.updateProjectionMatrix();
    }
  }, {
    key: "getFocalLength",
    value: function getFocalLength() {
      var t = Math.tan(.5 * it * this.fov);
      return .5 * this.getFilmHeight() / t;
    }
  }, {
    key: "getEffectiveFOV",
    value: function getEffectiveFOV() {
      return 2 * rt * Math.atan(Math.tan(.5 * it * this.fov) / this.zoom);
    }
  }, {
    key: "getFilmWidth",
    value: function getFilmWidth() {
      return this.filmGauge * Math.min(this.aspect, 1);
    }
  }, {
    key: "getFilmHeight",
    value: function getFilmHeight() {
      return this.filmGauge / Math.max(this.aspect, 1);
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(t, e, n, i, r, s) {
      this.aspect = t / e, null === this.view && (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var t = this.near;
      var e = t * Math.tan(.5 * it * this.fov) / this.zoom,
          n = 2 * e,
          i = this.aspect * n,
          r = -.5 * i;
      var s = this.view;

      if (null !== this.view && this.view.enabled) {
        var _t73 = s.fullWidth,
            _a14 = s.fullHeight;
        r += s.offsetX * i / _t73, e -= s.offsetY * n / _a14, i *= s.width / _t73, n *= s.height / _a14;
      }

      var a = this.filmOffset;
      0 !== a && (r += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, e, e - n, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Pn.prototype), "toJSON", this).call(this, t);

      return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
  }]);

  return Pn;
}(Qn);

Pn.prototype.isPerspectiveCamera = !0;

var Fn = /*#__PURE__*/function (_Ce3) {
  _inherits(Fn, _Ce3);

  var _super20 = _createSuper(Fn);

  function Fn(t, e, n) {
    var _this22;

    _classCallCheck(this, Fn);

    if (_this22 = _super20.call(this), _this22.type = "CubeCamera", !0 !== n.isWebGLCubeRenderTarget) return _possibleConstructorReturn(_this22, void console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter."));
    _this22.renderTarget = n;
    var i = new Pn(90, 1, t, e);
    i.layers = _this22.layers, i.up.set(0, -1, 0), i.lookAt(new _t(1, 0, 0)), _this22.add(i);
    var r = new Pn(90, 1, t, e);
    r.layers = _this22.layers, r.up.set(0, -1, 0), r.lookAt(new _t(-1, 0, 0)), _this22.add(r);
    var s = new Pn(90, 1, t, e);
    s.layers = _this22.layers, s.up.set(0, 0, 1), s.lookAt(new _t(0, 1, 0)), _this22.add(s);
    var a = new Pn(90, 1, t, e);
    a.layers = _this22.layers, a.up.set(0, 0, -1), a.lookAt(new _t(0, -1, 0)), _this22.add(a);
    var o = new Pn(90, 1, t, e);
    o.layers = _this22.layers, o.up.set(0, -1, 0), o.lookAt(new _t(0, 0, 1)), _this22.add(o);
    var l = new Pn(90, 1, t, e);
    l.layers = _this22.layers, l.up.set(0, -1, 0), l.lookAt(new _t(0, 0, -1)), _this22.add(l);
    return _possibleConstructorReturn(_this22);
  }

  _createClass(Fn, [{
    key: "update",
    value: function update(t, e) {
      null === this.parent && this.updateMatrixWorld();

      var n = this.renderTarget,
          _this$children = _slicedToArray(this.children, 6),
          i = _this$children[0],
          r = _this$children[1],
          s = _this$children[2],
          a = _this$children[3],
          o = _this$children[4],
          l = _this$children[5],
          c = t.xr.enabled,
          h = t.getRenderTarget();

      t.xr.enabled = !1;
      var u = n.texture.generateMipmaps;
      n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0), t.render(e, i), t.setRenderTarget(n, 1), t.render(e, r), t.setRenderTarget(n, 2), t.render(e, s), t.setRenderTarget(n, 3), t.render(e, a), t.setRenderTarget(n, 4), t.render(e, o), n.texture.generateMipmaps = u, t.setRenderTarget(n, 5), t.render(e, l), t.setRenderTarget(h), t.xr.enabled = c;
    }
  }]);

  return Fn;
}(Ce);

var Nn = /*#__PURE__*/function (_vt) {
  _inherits(Nn, _vt);

  var _super21 = _createSuper(Nn);

  function Nn(t, e, n, i, r, s, a, o, l, c) {
    var _this23;

    _classCallCheck(this, Nn);

    _this23 = _super21.call(this, t = void 0 !== t ? t : [], e = void 0 !== e ? e : 301, n, i, r, s, a = void 0 !== a ? a : 1022, o, l, c), _this23.flipY = !1;
    return _this23;
  }

  _createClass(Nn, [{
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(t) {
      this.image = t;
    }
  }]);

  return Nn;
}(vt);

Nn.prototype.isCubeTexture = !0;

var Un = /*#__PURE__*/function (_wt3) {
  _inherits(Un, _wt3);

  var _super22 = _createSuper(Un);

  function Un(t, e, n) {
    var _this24;

    _classCallCheck(this, Un);

    Number.isInteger(e) && (console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )"), e = n), _this24 = _super22.call(this, t, t, e), e = e || {}, _this24.texture = new Nn(void 0, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), _this24.texture.isRenderTargetTexture = !0, _this24.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, _this24.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : 1006, _this24.texture._needsFlipEnvMap = !1;
    return _this24;
  }

  _createClass(Un, [{
    key: "fromEquirectangularTexture",
    value: function fromEquirectangularTexture(t, e) {
      this.texture.type = e.type, this.texture.format = 1023, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
      var n = {
        uniforms: {
          tEquirect: {
            value: null
          }
        },
        vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
        fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
      },
          i = new Bn(5, 5, 5),
          r = new Dn({
        name: "CubemapFromEquirect",
        uniforms: Tn(n.uniforms),
        vertexShader: n.vertexShader,
        fragmentShader: n.fragmentShader,
        side: 1,
        blending: 0
      });
      r.uniforms.tEquirect.value = e;
      var s = new Mn(i, r),
          a = e.minFilter;
      1008 === e.minFilter && (e.minFilter = 1006);
      return new Fn(1, 10, this).update(t, s), e.minFilter = a, s.geometry.dispose(), s.material.dispose(), this;
    }
  }, {
    key: "clear",
    value: function clear(t, e, n, i) {
      var r = t.getRenderTarget();

      for (var _r45 = 0; _r45 < 6; _r45++) {
        t.setRenderTarget(this, _r45), t.clear(e, n, i);
      }

      t.setRenderTarget(r);
    }
  }]);

  return Un;
}(wt);

Un.prototype.isWebGLCubeRenderTarget = !0;
var kn = new _t(),
    Gn = new _t(),
    On = new At();

var Hn = /*#__PURE__*/function () {
  function Hn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t(1, 0, 0);
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Hn);

    this.normal = t, this.constant = e;
  }

  _createClass(Hn, [{
    key: "set",
    value: function set(t, e) {
      return this.normal.copy(t), this.constant = e, this;
    }
  }, {
    key: "setComponents",
    value: function setComponents(t, e, n, i) {
      return this.normal.set(t, e, n), this.constant = i, this;
    }
  }, {
    key: "setFromNormalAndCoplanarPoint",
    value: function setFromNormalAndCoplanarPoint(t, e) {
      return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
  }, {
    key: "setFromCoplanarPoints",
    value: function setFromCoplanarPoints(t, e, n) {
      var i = kn.subVectors(n, e).cross(Gn.subVectors(t, e)).normalize();
      return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var t = 1 / this.normal.length();
      return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this.constant *= -1, this.normal.negate(), this;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(t) {
      return this.normal.dot(t) + this.constant;
    }
  }, {
    key: "distanceToSphere",
    value: function distanceToSphere(t) {
      return this.distanceToPoint(t.center) - t.radius;
    }
  }, {
    key: "projectPoint",
    value: function projectPoint(t, e) {
      return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
  }, {
    key: "intersectLine",
    value: function intersectLine(t, e) {
      var n = t.delta(kn),
          i = this.normal.dot(n);
      if (0 === i) return 0 === this.distanceToPoint(t.start) ? e.copy(t.start) : null;
      var r = -(t.start.dot(this.normal) + this.constant) / i;
      return r < 0 || r > 1 ? null : e.copy(n).multiplyScalar(r).add(t.start);
    }
  }, {
    key: "intersectsLine",
    value: function intersectsLine(t) {
      var e = this.distanceToPoint(t.start),
          n = this.distanceToPoint(t.end);
      return e < 0 && n > 0 || n < 0 && e > 0;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      return t.intersectsPlane(this);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      return t.intersectsPlane(this);
    }
  }, {
    key: "coplanarPoint",
    value: function coplanarPoint(t) {
      return t.copy(this.normal).multiplyScalar(-this.constant);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t, e) {
      var n = e || On.getNormalMatrix(t),
          i = this.coplanarPoint(kn).applyMatrix4(t),
          r = this.normal.applyMatrix3(n).normalize();
      return this.constant = -i.dot(r), this;
    }
  }, {
    key: "translate",
    value: function translate(t) {
      return this.constant -= t.dot(this.normal), this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      return t.normal.equals(this.normal) && t.constant === this.constant;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Hn;
}();

Hn.prototype.isPlane = !0;
var zn = new qt(),
    Vn = new _t();

var Wn = /*#__PURE__*/function () {
  function Wn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Hn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Hn();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Hn();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Hn();
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Hn();
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Hn();

    _classCallCheck(this, Wn);

    this.planes = [t, e, n, i, r, s];
  }

  _createClass(Wn, [{
    key: "set",
    value: function set(t, e, n, i, r, s) {
      var a = this.planes;
      return a[0].copy(t), a[1].copy(e), a[2].copy(n), a[3].copy(i), a[4].copy(r), a[5].copy(s), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = this.planes;

      for (var _n74 = 0; _n74 < 6; _n74++) {
        e[_n74].copy(t.planes[_n74]);
      }

      return this;
    }
  }, {
    key: "setFromProjectionMatrix",
    value: function setFromProjectionMatrix(t) {
      var e = this.planes,
          n = t.elements,
          i = n[0],
          r = n[1],
          s = n[2],
          a = n[3],
          o = n[4],
          l = n[5],
          c = n[6],
          h = n[7],
          u = n[8],
          d = n[9],
          p = n[10],
          A = n[11],
          m = n[12],
          g = n[13],
          f = n[14],
          v = n[15];
      return e[0].setComponents(a - i, h - o, A - u, v - m).normalize(), e[1].setComponents(a + i, h + o, A + u, v + m).normalize(), e[2].setComponents(a + r, h + l, A + d, v + g).normalize(), e[3].setComponents(a - r, h - l, A - d, v - g).normalize(), e[4].setComponents(a - s, h - c, A - p, v - f).normalize(), e[5].setComponents(a + s, h + c, A + p, v + f).normalize(), this;
    }
  }, {
    key: "intersectsObject",
    value: function intersectsObject(t) {
      var e = t.geometry;
      return null === e.boundingSphere && e.computeBoundingSphere(), zn.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(zn);
    }
  }, {
    key: "intersectsSprite",
    value: function intersectsSprite(t) {
      return zn.center.set(0, 0, 0), zn.radius = .7071067811865476, zn.applyMatrix4(t.matrixWorld), this.intersectsSphere(zn);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(t) {
      var e = this.planes,
          n = t.center,
          i = -t.radius;

      for (var _t74 = 0; _t74 < 6; _t74++) {
        if (e[_t74].distanceToPoint(n) < i) return !1;
      }

      return !0;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(t) {
      var e = this.planes;

      for (var _n75 = 0; _n75 < 6; _n75++) {
        var _i63 = e[_n75];
        if (Vn.x = _i63.normal.x > 0 ? t.max.x : t.min.x, Vn.y = _i63.normal.y > 0 ? t.max.y : t.min.y, Vn.z = _i63.normal.z > 0 ? t.max.z : t.min.z, _i63.distanceToPoint(Vn) < 0) return !1;
      }

      return !0;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(t) {
      var e = this.planes;

      for (var _n76 = 0; _n76 < 6; _n76++) {
        if (e[_n76].distanceToPoint(t) < 0) return !1;
      }

      return !0;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Wn;
}();

function qn() {
  var t = null,
      e = !1,
      n = null,
      i = null;

  function r(e, s) {
    n(e, s), i = t.requestAnimationFrame(r);
  }

  return {
    start: function start() {
      !0 !== e && null !== n && (i = t.requestAnimationFrame(r), e = !0);
    },
    stop: function stop() {
      t.cancelAnimationFrame(i), e = !1;
    },
    setAnimationLoop: function setAnimationLoop(t) {
      n = t;
    },
    setContext: function setContext(e) {
      t = e;
    }
  };
}

function jn(t, e) {
  var n = e.isWebGL2,
      i = new WeakMap();
  return {
    get: function get(t) {
      return t.isInterleavedBufferAttribute && (t = t.data), i.get(t);
    },
    remove: function remove(e) {
      e.isInterleavedBufferAttribute && (e = e.data);
      var n = i.get(e);
      n && (t.deleteBuffer(n.buffer), i.delete(e));
    },
    update: function update(e, r) {
      if (e.isGLBufferAttribute) {
        var _t75 = i.get(e);

        return void ((!_t75 || _t75.version < e.version) && i.set(e, {
          buffer: e.buffer,
          type: e.type,
          bytesPerElement: e.elementSize,
          version: e.version
        }));
      }

      e.isInterleavedBufferAttribute && (e = e.data);
      var s = i.get(e);
      void 0 === s ? i.set(e, function (e, i) {
        var r = e.array,
            s = e.usage,
            a = t.createBuffer();
        t.bindBuffer(i, a), t.bufferData(i, r, s), e.onUploadCallback();
        var o = 5126;
        return r instanceof Float32Array ? o = 5126 : r instanceof Float64Array ? console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.") : r instanceof Uint16Array ? e.isFloat16BufferAttribute ? n ? o = 5131 : console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.") : o = 5123 : r instanceof Int16Array ? o = 5122 : r instanceof Uint32Array ? o = 5125 : r instanceof Int32Array ? o = 5124 : r instanceof Int8Array ? o = 5120 : (r instanceof Uint8Array || r instanceof Uint8ClampedArray) && (o = 5121), {
          buffer: a,
          type: o,
          bytesPerElement: r.BYTES_PER_ELEMENT,
          version: e.version
        };
      }(e, r)) : s.version < e.version && (!function (e, i, r) {
        var s = i.array,
            a = i.updateRange;
        t.bindBuffer(r, e), -1 === a.count ? t.bufferSubData(r, 0, s) : (n ? t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s, a.offset, a.count) : t.bufferSubData(r, a.offset * s.BYTES_PER_ELEMENT, s.subarray(a.offset, a.offset + a.count)), a.count = -1);
      }(s.buffer, e, r), s.version = e.version);
    }
  };
}

var Yn = /*#__PURE__*/function (_cn2) {
  _inherits(Yn, _cn2);

  var _super23 = _createSuper(Yn);

  function Yn() {
    var _this25;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Yn);

    _this25 = _super23.call(this), _this25.type = "PlaneGeometry", _this25.parameters = {
      width: t,
      height: e,
      widthSegments: n,
      heightSegments: i
    };
    var r = t / 2,
        s = e / 2,
        a = Math.floor(n),
        o = Math.floor(i),
        l = a + 1,
        c = o + 1,
        h = t / a,
        u = e / o,
        d = [],
        p = [],
        A = [],
        m = [];

    for (var _t76 = 0; _t76 < c; _t76++) {
      var _e61 = _t76 * u - s;

      for (var _n77 = 0; _n77 < l; _n77++) {
        var _i64 = _n77 * h - r;

        p.push(_i64, -_e61, 0), A.push(0, 0, 1), m.push(_n77 / a), m.push(1 - _t76 / o);
      }
    }

    for (var _t77 = 0; _t77 < o; _t77++) {
      for (var _e62 = 0; _e62 < a; _e62++) {
        var _n78 = _e62 + l * _t77,
            _i65 = _e62 + l * (_t77 + 1),
            _r46 = _e62 + 1 + l * (_t77 + 1),
            _s19 = _e62 + 1 + l * _t77;

        d.push(_n78, _i65, _s19), d.push(_i65, _r46, _s19);
      }
    }

    _this25.setIndex(d), _this25.setAttribute("position", new $e(p, 3)), _this25.setAttribute("normal", new $e(A, 3)), _this25.setAttribute("uv", new $e(m, 2));
    return _this25;
  }

  _createClass(Yn, null, [{
    key: "fromJSON",
    value: function fromJSON(t) {
      return new Yn(t.width, t.height, t.widthSegments, t.heightSegments);
    }
  }]);

  return Yn;
}(cn);

var Jn = {
  alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif",
  alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  alphatest_fragment: "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif",
  aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif",
  aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
  begin_vertex: "vec3 transformed = vec3( position );",
  beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
  bsdfs: "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in vec3 f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn ( f90 - f0 ) * fresnel + f0;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in vec3 f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, vec3( 1.0 ), dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif",
  bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
  clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
  clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
  clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
  clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
  color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
  color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
  color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
  color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
  common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}",
  cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
  defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
  displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
  displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif",
  emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
  emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
  encodings_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
  encodings_pars_fragment: "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}",
  envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
  envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
  envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
  envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
  envmap_physical_pars_fragment: "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif",
  envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
  fog_vertex: "#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif",
  fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif",
  fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
  fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
  gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}",
  lightmap_fragment: "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif",
  lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
  lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif",
  lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif",
  lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
  lights_toon_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)",
  lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
  lights_phong_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)",
  lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\t#ifdef SPECULAR\n\t\tvec3 specularIntensityFactor = vec3( specularIntensity );\n\t\tvec3 specularTintFactor = specularTint;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARTINTMAP\n\t\t\tspecularTintFactor *= specularTintMapTexelToLinear( texture2D( specularTintMap, vUv ) ).rgb;\n\t\t#endif\n\t\tmaterial.specularColorF90 = mix( specularIntensityFactor, vec3( 1.0 ), metalnessFactor );\n\t#else\n\t\tvec3 specularIntensityFactor = vec3( 1.0 );\n\t\tvec3 specularTintFactor = vec3( 1.0 );\n\t\tmaterial.specularColorF90 = vec3( 1.0 );\n\t#endif\n\tmaterial.specularColor = mix( min( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ) * specularTintFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularColorF90 = vec3( 1.0 );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif",
  lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n\tvec3 specularColorF90;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), vec3( 1.0 ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularColorF90, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
  lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
  lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif",
  lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
  logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
  logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
  logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
  logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
  map_fragment: "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif",
  map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
  map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
  map_particle_pars_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
  metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
  metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
  morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif",
  morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif",
  morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif",
  normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
  normal_fragment_maps: "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
  normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif",
  clearcoat_normal_fragment_begin: "#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
  clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif",
  clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif",
  packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}",
  premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
  project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
  dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
  dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
  roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
  roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
  shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
  shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
  shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif",
  shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
  skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
  skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif",
  skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
  skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
  specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
  specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
  tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
  tonemapping_pars_fragment: "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
  transmission_fragment: "#ifdef USE_TRANSMISSION\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tfloat ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n\tvec3 transmission = transmissionFactor * getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationTint, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission, transmissionFactor );\n#endif",
  transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec4 vWorldPosition;\n\tvec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n\t\tvec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length(vec3(modelMatrix[0].xyz));\n\t\tmodelScale.y = length(vec3(modelMatrix[1].xyz));\n\t\tmodelScale.z = length(vec3(modelMatrix[2].xyz));\n\t\treturn normalize(refractionVector) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness(float roughness, float ior) {\n\t\treturn roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n\t}\n\tvec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n\t\tfloat framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n\t\treturn texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n\t}\n\tvec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n\t\tif (attenuationDistance == 0.0) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n\t\t\tvec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec3 getIBLVolumeRefraction(vec3 n, vec3 v, float perceptualRoughness, vec3 baseColor, vec3 specularColor,\n\t\tvec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n\t\tvec3 attenuationColor, float attenuationDistance) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n\t\tvec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n\t\treturn (1.0 - specularColor) * attenuatedColor * baseColor;\n\t}\n#endif",
  uv_pars_fragment: "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif",
  uv_pars_vertex: "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif",
  uv_vertex: "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
  uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
  uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif",
  uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif",
  worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
  background_frag: "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
  cube_frag: "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
  depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
  depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
  distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
  distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
  equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
  equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
  linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
  meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
  meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t\t#ifdef USE_TANGENT\n\t\t\tvTangent = normalize( transformedTangent );\n\t\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t\t#endif\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
  meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationTint;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularTint;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARTINTMAP\n\t\tuniform sampler2D specularTintMap;\n\t#endif\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
  meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#ifdef USE_TRANSMISSION\n\tvarying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition;\n#endif\n}",
  normal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}",
  normal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
  points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
  points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
  shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
  shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
  sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
  sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}"
},
    Xn = {
  common: {
    diffuse: {
      value: new qe(16777215)
    },
    opacity: {
      value: 1
    },
    map: {
      value: null
    },
    uvTransform: {
      value: new At()
    },
    uv2Transform: {
      value: new At()
    },
    alphaMap: {
      value: null
    }
  },
  specularmap: {
    specularMap: {
      value: null
    }
  },
  envmap: {
    envMap: {
      value: null
    },
    flipEnvMap: {
      value: -1
    },
    reflectivity: {
      value: 1
    },
    refractionRatio: {
      value: .98
    },
    maxMipLevel: {
      value: 0
    }
  },
  aomap: {
    aoMap: {
      value: null
    },
    aoMapIntensity: {
      value: 1
    }
  },
  lightmap: {
    lightMap: {
      value: null
    },
    lightMapIntensity: {
      value: 1
    }
  },
  emissivemap: {
    emissiveMap: {
      value: null
    }
  },
  bumpmap: {
    bumpMap: {
      value: null
    },
    bumpScale: {
      value: 1
    }
  },
  normalmap: {
    normalMap: {
      value: null
    },
    normalScale: {
      value: new pt(1, 1)
    }
  },
  displacementmap: {
    displacementMap: {
      value: null
    },
    displacementScale: {
      value: 1
    },
    displacementBias: {
      value: 0
    }
  },
  roughnessmap: {
    roughnessMap: {
      value: null
    }
  },
  metalnessmap: {
    metalnessMap: {
      value: null
    }
  },
  gradientmap: {
    gradientMap: {
      value: null
    }
  },
  fog: {
    fogDensity: {
      value: 25e-5
    },
    fogNear: {
      value: 1
    },
    fogFar: {
      value: 2e3
    },
    fogColor: {
      value: new qe(16777215)
    }
  },
  lights: {
    ambientLightColor: {
      value: []
    },
    lightProbe: {
      value: []
    },
    directionalLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    directionalLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    directionalShadowMap: {
      value: []
    },
    directionalShadowMatrix: {
      value: []
    },
    spotLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      }
    },
    spotLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    spotShadowMap: {
      value: []
    },
    spotShadowMatrix: {
      value: []
    },
    pointLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      }
    },
    pointLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      }
    },
    pointShadowMap: {
      value: []
    },
    pointShadowMatrix: {
      value: []
    },
    hemisphereLights: {
      value: [],
      properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      }
    },
    rectAreaLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      }
    },
    ltc_1: {
      value: null
    },
    ltc_2: {
      value: null
    }
  },
  points: {
    diffuse: {
      value: new qe(16777215)
    },
    opacity: {
      value: 1
    },
    size: {
      value: 1
    },
    scale: {
      value: 1
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    uvTransform: {
      value: new At()
    }
  },
  sprite: {
    diffuse: {
      value: new qe(16777215)
    },
    opacity: {
      value: 1
    },
    center: {
      value: new pt(.5, .5)
    },
    rotation: {
      value: 0
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    uvTransform: {
      value: new At()
    }
  }
},
    Kn = {
  basic: {
    uniforms: Ln([Xn.common, Xn.specularmap, Xn.envmap, Xn.aomap, Xn.lightmap, Xn.fog]),
    vertexShader: Jn.meshbasic_vert,
    fragmentShader: Jn.meshbasic_frag
  },
  lambert: {
    uniforms: Ln([Xn.common, Xn.specularmap, Xn.envmap, Xn.aomap, Xn.lightmap, Xn.emissivemap, Xn.fog, Xn.lights, {
      emissive: {
        value: new qe(0)
      }
    }]),
    vertexShader: Jn.meshlambert_vert,
    fragmentShader: Jn.meshlambert_frag
  },
  phong: {
    uniforms: Ln([Xn.common, Xn.specularmap, Xn.envmap, Xn.aomap, Xn.lightmap, Xn.emissivemap, Xn.bumpmap, Xn.normalmap, Xn.displacementmap, Xn.fog, Xn.lights, {
      emissive: {
        value: new qe(0)
      },
      specular: {
        value: new qe(1118481)
      },
      shininess: {
        value: 30
      }
    }]),
    vertexShader: Jn.meshphong_vert,
    fragmentShader: Jn.meshphong_frag
  },
  standard: {
    uniforms: Ln([Xn.common, Xn.envmap, Xn.aomap, Xn.lightmap, Xn.emissivemap, Xn.bumpmap, Xn.normalmap, Xn.displacementmap, Xn.roughnessmap, Xn.metalnessmap, Xn.fog, Xn.lights, {
      emissive: {
        value: new qe(0)
      },
      roughness: {
        value: 1
      },
      metalness: {
        value: 0
      },
      envMapIntensity: {
        value: 1
      }
    }]),
    vertexShader: Jn.meshphysical_vert,
    fragmentShader: Jn.meshphysical_frag
  },
  toon: {
    uniforms: Ln([Xn.common, Xn.aomap, Xn.lightmap, Xn.emissivemap, Xn.bumpmap, Xn.normalmap, Xn.displacementmap, Xn.gradientmap, Xn.fog, Xn.lights, {
      emissive: {
        value: new qe(0)
      }
    }]),
    vertexShader: Jn.meshtoon_vert,
    fragmentShader: Jn.meshtoon_frag
  },
  matcap: {
    uniforms: Ln([Xn.common, Xn.bumpmap, Xn.normalmap, Xn.displacementmap, Xn.fog, {
      matcap: {
        value: null
      }
    }]),
    vertexShader: Jn.meshmatcap_vert,
    fragmentShader: Jn.meshmatcap_frag
  },
  points: {
    uniforms: Ln([Xn.points, Xn.fog]),
    vertexShader: Jn.points_vert,
    fragmentShader: Jn.points_frag
  },
  dashed: {
    uniforms: Ln([Xn.common, Xn.fog, {
      scale: {
        value: 1
      },
      dashSize: {
        value: 1
      },
      totalSize: {
        value: 2
      }
    }]),
    vertexShader: Jn.linedashed_vert,
    fragmentShader: Jn.linedashed_frag
  },
  depth: {
    uniforms: Ln([Xn.common, Xn.displacementmap]),
    vertexShader: Jn.depth_vert,
    fragmentShader: Jn.depth_frag
  },
  normal: {
    uniforms: Ln([Xn.common, Xn.bumpmap, Xn.normalmap, Xn.displacementmap, {
      opacity: {
        value: 1
      }
    }]),
    vertexShader: Jn.normal_vert,
    fragmentShader: Jn.normal_frag
  },
  sprite: {
    uniforms: Ln([Xn.sprite, Xn.fog]),
    vertexShader: Jn.sprite_vert,
    fragmentShader: Jn.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: {
        value: new At()
      },
      t2D: {
        value: null
      }
    },
    vertexShader: Jn.background_vert,
    fragmentShader: Jn.background_frag
  },
  cube: {
    uniforms: Ln([Xn.envmap, {
      opacity: {
        value: 1
      }
    }]),
    vertexShader: Jn.cube_vert,
    fragmentShader: Jn.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: {
        value: null
      }
    },
    vertexShader: Jn.equirect_vert,
    fragmentShader: Jn.equirect_frag
  },
  distanceRGBA: {
    uniforms: Ln([Xn.common, Xn.displacementmap, {
      referencePosition: {
        value: new _t()
      },
      nearDistance: {
        value: 1
      },
      farDistance: {
        value: 1e3
      }
    }]),
    vertexShader: Jn.distanceRGBA_vert,
    fragmentShader: Jn.distanceRGBA_frag
  },
  shadow: {
    uniforms: Ln([Xn.lights, Xn.fog, {
      color: {
        value: new qe(0)
      },
      opacity: {
        value: 1
      }
    }]),
    vertexShader: Jn.shadow_vert,
    fragmentShader: Jn.shadow_frag
  }
};

function Zn(t, e, n, i, r) {
  var s = new qe(0);
  var a,
      o,
      l = 0,
      c = null,
      h = 0,
      u = null;

  function d(t, e) {
    n.buffers.color.setClear(t.r, t.g, t.b, e, r);
  }

  return {
    getClearColor: function getClearColor() {
      return s;
    },
    setClearColor: function setClearColor(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      s.set(t), l = e, d(s, l);
    },
    getClearAlpha: function getClearAlpha() {
      return l;
    },
    setClearAlpha: function setClearAlpha(t) {
      l = t, d(s, l);
    },
    render: function render(n, r) {
      var p = !1,
          A = !0 === r.isScene ? r.background : null;
      A && A.isTexture && (A = e.get(A));
      var m = t.xr,
          g = m.getSession && m.getSession();
      g && "additive" === g.environmentBlendMode && (A = null), null === A ? d(s, l) : A && A.isColor && (d(A, 1), p = !0), (t.autoClear || p) && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), A && (A.isCubeTexture || 306 === A.mapping) ? (void 0 === o && (o = new Mn(new Bn(1, 1, 1), new Dn({
        name: "BackgroundCubeMaterial",
        uniforms: Tn(Kn.cube.uniforms),
        vertexShader: Kn.cube.vertexShader,
        fragmentShader: Kn.cube.fragmentShader,
        side: 1,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })), o.geometry.deleteAttribute("normal"), o.geometry.deleteAttribute("uv"), o.onBeforeRender = function (t, e, n) {
        this.matrixWorld.copyPosition(n.matrixWorld);
      }, Object.defineProperty(o.material, "envMap", {
        get: function get() {
          return this.uniforms.envMap.value;
        }
      }), i.update(o)), o.material.uniforms.envMap.value = A, o.material.uniforms.flipEnvMap.value = A.isCubeTexture && !1 === A.isRenderTargetTexture ? -1 : 1, c === A && h === A.version && u === t.toneMapping || (o.material.needsUpdate = !0, c = A, h = A.version, u = t.toneMapping), n.unshift(o, o.geometry, o.material, 0, 0, null)) : A && A.isTexture && (void 0 === a && (a = new Mn(new Yn(2, 2), new Dn({
        name: "BackgroundMaterial",
        uniforms: Tn(Kn.background.uniforms),
        vertexShader: Kn.background.vertexShader,
        fragmentShader: Kn.background.fragmentShader,
        side: 0,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })), a.geometry.deleteAttribute("normal"), Object.defineProperty(a.material, "map", {
        get: function get() {
          return this.uniforms.t2D.value;
        }
      }), i.update(a)), a.material.uniforms.t2D.value = A, !0 === A.matrixAutoUpdate && A.updateMatrix(), a.material.uniforms.uvTransform.value.copy(A.matrix), c === A && h === A.version && u === t.toneMapping || (a.material.needsUpdate = !0, c = A, h = A.version, u = t.toneMapping), n.unshift(a, a.geometry, a.material, 0, 0, null));
    }
  };
}

function $n(t, e, n, i) {
  var r = t.getParameter(34921),
      s = i.isWebGL2 ? null : e.get("OES_vertex_array_object"),
      a = i.isWebGL2 || null !== s,
      o = {},
      l = d(null);
  var c = l;

  function h(e) {
    return i.isWebGL2 ? t.bindVertexArray(e) : s.bindVertexArrayOES(e);
  }

  function u(e) {
    return i.isWebGL2 ? t.deleteVertexArray(e) : s.deleteVertexArrayOES(e);
  }

  function d(t) {
    var e = [],
        n = [],
        i = [];

    for (var _t78 = 0; _t78 < r; _t78++) {
      e[_t78] = 0, n[_t78] = 0, i[_t78] = 0;
    }

    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: e,
      enabledAttributes: n,
      attributeDivisors: i,
      object: t,
      attributes: {},
      index: null
    };
  }

  function p() {
    var t = c.newAttributes;

    for (var _e63 = 0, _n79 = t.length; _e63 < _n79; _e63++) {
      t[_e63] = 0;
    }
  }

  function A(t) {
    m(t, 0);
  }

  function m(n, r) {
    var s = c.newAttributes,
        a = c.enabledAttributes,
        o = c.attributeDivisors;

    if (s[n] = 1, 0 === a[n] && (t.enableVertexAttribArray(n), a[n] = 1), o[n] !== r) {
      (i.isWebGL2 ? t : e.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r;
    }
  }

  function g() {
    var e = c.newAttributes,
        n = c.enabledAttributes;

    for (var _i66 = 0, _r47 = n.length; _i66 < _r47; _i66++) {
      n[_i66] !== e[_i66] && (t.disableVertexAttribArray(_i66), n[_i66] = 0);
    }
  }

  function f(e, n, r, s, a, o) {
    !0 !== i.isWebGL2 || 5124 !== r && 5125 !== r ? t.vertexAttribPointer(e, n, r, s, a, o) : t.vertexAttribIPointer(e, n, r, a, o);
  }

  function v() {
    y(), c !== l && (c = l, h(c.object));
  }

  function y() {
    l.geometry = null, l.program = null, l.wireframe = !1;
  }

  return {
    setup: function setup(r, l, u, v, y) {
      var x = !1;

      if (a) {
        var _e64 = function (e, n, r) {
          var a = !0 === r.wireframe;
          var l = o[e.id];
          void 0 === l && (l = {}, o[e.id] = l);
          var c = l[n.id];
          void 0 === c && (c = {}, l[n.id] = c);
          var h = c[a];
          void 0 === h && (h = d(i.isWebGL2 ? t.createVertexArray() : s.createVertexArrayOES()), c[a] = h);
          return h;
        }(v, u, l);

        c !== _e64 && (c = _e64, h(c.object)), x = function (t, e) {
          var n = c.attributes,
              i = t.attributes;
          var r = 0;

          for (var _t79 in i) {
            var _e65 = n[_t79],
                _s20 = i[_t79];
            if (void 0 === _e65) return !0;
            if (_e65.attribute !== _s20) return !0;
            if (_e65.data !== _s20.data) return !0;
            r++;
          }

          return c.attributesNum !== r || c.index !== e;
        }(v, y), x && function (t, e) {
          var n = {},
              i = t.attributes;
          var r = 0;

          for (var _t80 in i) {
            var _e66 = i[_t80],
                _s21 = {};
            _s21.attribute = _e66, _e66.data && (_s21.data = _e66.data), n[_t80] = _s21, r++;
          }

          c.attributes = n, c.attributesNum = r, c.index = e;
        }(v, y);
      } else {
        var _t81 = !0 === l.wireframe;

        c.geometry === v.id && c.program === u.id && c.wireframe === _t81 || (c.geometry = v.id, c.program = u.id, c.wireframe = _t81, x = !0);
      }

      !0 === r.isInstancedMesh && (x = !0), null !== y && n.update(y, 34963), x && (!function (r, s, a, o) {
        if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
        p();
        var l = o.attributes,
            c = a.getAttributes(),
            h = s.defaultAttributeValues;

        for (var _e67 in c) {
          var _i67 = c[_e67];

          if (_i67 >= 0) {
            var _s22 = l[_e67];

            if (void 0 !== _s22) {
              var _e68 = _s22.normalized,
                  _r48 = _s22.itemSize,
                  _a15 = n.get(_s22);

              if (void 0 === _a15) continue;
              var _l12 = _a15.buffer,
                  _c8 = _a15.type,
                  _h6 = _a15.bytesPerElement;

              if (_s22.isInterleavedBufferAttribute) {
                var _n80 = _s22.data,
                    _a16 = _n80.stride,
                    _u8 = _s22.offset;
                _n80 && _n80.isInstancedInterleavedBuffer ? (m(_i67, _n80.meshPerAttribute), void 0 === o._maxInstanceCount && (o._maxInstanceCount = _n80.meshPerAttribute * _n80.count)) : A(_i67), t.bindBuffer(34962, _l12), f(_i67, _r48, _c8, _e68, _a16 * _h6, _u8 * _h6);
              } else _s22.isInstancedBufferAttribute ? (m(_i67, _s22.meshPerAttribute), void 0 === o._maxInstanceCount && (o._maxInstanceCount = _s22.meshPerAttribute * _s22.count)) : A(_i67), t.bindBuffer(34962, _l12), f(_i67, _r48, _c8, _e68, 0, 0);
            } else if ("instanceMatrix" === _e67) {
              var _e69 = n.get(r.instanceMatrix);

              if (void 0 === _e69) continue;
              var _s23 = _e69.buffer,
                  _a17 = _e69.type;
              m(_i67 + 0, 1), m(_i67 + 1, 1), m(_i67 + 2, 1), m(_i67 + 3, 1), t.bindBuffer(34962, _s23), t.vertexAttribPointer(_i67 + 0, 4, _a17, !1, 64, 0), t.vertexAttribPointer(_i67 + 1, 4, _a17, !1, 64, 16), t.vertexAttribPointer(_i67 + 2, 4, _a17, !1, 64, 32), t.vertexAttribPointer(_i67 + 3, 4, _a17, !1, 64, 48);
            } else if ("instanceColor" === _e67) {
              var _e70 = n.get(r.instanceColor);

              if (void 0 === _e70) continue;
              var _s24 = _e70.buffer,
                  _a18 = _e70.type;
              m(_i67, 1), t.bindBuffer(34962, _s24), t.vertexAttribPointer(_i67, 3, _a18, !1, 12, 0);
            } else if (void 0 !== h) {
              var _n81 = h[_e67];
              if (void 0 !== _n81) switch (_n81.length) {
                case 2:
                  t.vertexAttrib2fv(_i67, _n81);
                  break;

                case 3:
                  t.vertexAttrib3fv(_i67, _n81);
                  break;

                case 4:
                  t.vertexAttrib4fv(_i67, _n81);
                  break;

                default:
                  t.vertexAttrib1fv(_i67, _n81);
              }
            }
          }
        }

        g();
      }(r, l, u, v), null !== y && t.bindBuffer(34963, n.get(y).buffer));
    },
    reset: v,
    resetDefaultState: y,
    dispose: function dispose() {
      v();

      for (var _t82 in o) {
        var _e71 = o[_t82];

        for (var _t83 in _e71) {
          var _n82 = _e71[_t83];

          for (var _t84 in _n82) {
            u(_n82[_t84].object), delete _n82[_t84];
          }

          delete _e71[_t83];
        }

        delete o[_t82];
      }
    },
    releaseStatesOfGeometry: function releaseStatesOfGeometry(t) {
      if (void 0 === o[t.id]) return;
      var e = o[t.id];

      for (var _t85 in e) {
        var _n83 = e[_t85];

        for (var _t86 in _n83) {
          u(_n83[_t86].object), delete _n83[_t86];
        }

        delete e[_t85];
      }

      delete o[t.id];
    },
    releaseStatesOfProgram: function releaseStatesOfProgram(t) {
      for (var _e72 in o) {
        var _n84 = o[_e72];
        if (void 0 === _n84[t.id]) continue;
        var _i68 = _n84[t.id];

        for (var _t87 in _i68) {
          u(_i68[_t87].object), delete _i68[_t87];
        }

        delete _n84[t.id];
      }
    },
    initAttributes: p,
    enableAttribute: A,
    disableUnusedAttributes: g
  };
}

function ti(t, e, n, i) {
  var r = i.isWebGL2;
  var s;
  this.setMode = function (t) {
    s = t;
  }, this.render = function (e, i) {
    t.drawArrays(s, e, i), n.update(i, s, 1);
  }, this.renderInstances = function (i, a, o) {
    if (0 === o) return;
    var l, c;
    if (r) l = t, c = "drawArraysInstanced";else if (l = e.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    l[c](s, i, a, o), n.update(a, s, o);
  };
}

function ei(t, e, n) {
  var i;

  function r(e) {
    if ("highp" === e) {
      if (t.getShaderPrecisionFormat(35633, 36338).precision > 0 && t.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
      e = "mediump";
    }

    return "mediump" === e && t.getShaderPrecisionFormat(35633, 36337).precision > 0 && t.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
  }

  var s = "undefined" != typeof WebGL2RenderingContext && t instanceof WebGL2RenderingContext || "undefined" != typeof WebGL2ComputeRenderingContext && t instanceof WebGL2ComputeRenderingContext;
  var a = void 0 !== n.precision ? n.precision : "highp";
  var o = r(a);
  o !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", o, "instead."), a = o);
  var l = s || e.has("WEBGL_draw_buffers"),
      c = !0 === n.logarithmicDepthBuffer,
      h = t.getParameter(34930),
      u = t.getParameter(35660),
      d = t.getParameter(3379),
      p = t.getParameter(34076),
      A = t.getParameter(34921),
      m = t.getParameter(36347),
      g = t.getParameter(36348),
      f = t.getParameter(36349),
      v = u > 0,
      y = s || e.has("OES_texture_float");
  return {
    isWebGL2: s,
    drawBuffers: l,
    getMaxAnisotropy: function getMaxAnisotropy() {
      if (void 0 !== i) return i;

      if (!0 === e.has("EXT_texture_filter_anisotropic")) {
        var _n85 = e.get("EXT_texture_filter_anisotropic");

        i = t.getParameter(_n85.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      } else i = 0;

      return i;
    },
    getMaxPrecision: r,
    precision: a,
    logarithmicDepthBuffer: c,
    maxTextures: h,
    maxVertexTextures: u,
    maxTextureSize: d,
    maxCubemapSize: p,
    maxAttributes: A,
    maxVertexUniforms: m,
    maxVaryings: g,
    maxFragmentUniforms: f,
    vertexTextures: v,
    floatFragmentTextures: y,
    floatVertexTextures: v && y,
    maxSamples: s ? t.getParameter(36183) : 0
  };
}

function ni(t) {
  var e = this;
  var n = null,
      i = 0,
      r = !1,
      s = !1;
  var a = new Hn(),
      o = new At(),
      l = {
    value: null,
    needsUpdate: !1
  };

  function c() {
    l.value !== n && (l.value = n, l.needsUpdate = i > 0), e.numPlanes = i, e.numIntersection = 0;
  }

  function h(t, n, i, r) {
    var s = null !== t ? t.length : 0;
    var c = null;

    if (0 !== s) {
      if (c = l.value, !0 !== r || null === c) {
        var _e73 = i + 4 * s,
            _r49 = n.matrixWorldInverse;

        o.getNormalMatrix(_r49), (null === c || c.length < _e73) && (c = new Float32Array(_e73));

        for (var _e74 = 0, _n86 = i; _e74 !== s; ++_e74, _n86 += 4) {
          a.copy(t[_e74]).applyMatrix4(_r49, o), a.normal.toArray(c, _n86), c[_n86 + 3] = a.constant;
        }
      }

      l.value = c, l.needsUpdate = !0;
    }

    return e.numPlanes = s, e.numIntersection = 0, c;
  }

  this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function (t, e, s) {
    var a = 0 !== t.length || e || 0 !== i || r;
    return r = e, n = h(t, s, 0), i = t.length, a;
  }, this.beginShadows = function () {
    s = !0, h(null);
  }, this.endShadows = function () {
    s = !1, c();
  }, this.setState = function (e, a, o) {
    var u = e.clippingPlanes,
        d = e.clipIntersection,
        p = e.clipShadows,
        A = t.get(e);
    if (!r || null === u || 0 === u.length || s && !p) s ? h(null) : c();else {
      var _t88 = s ? 0 : i,
          _e75 = 4 * _t88;

      var _r50 = A.clippingState || null;

      l.value = _r50, _r50 = h(u, a, _e75, o);

      for (var _t89 = 0; _t89 !== _e75; ++_t89) {
        _r50[_t89] = n[_t89];
      }

      A.clippingState = _r50, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += _t88;
    }
  };
}

function ii(t) {
  var e = new WeakMap();

  function n(t, e) {
    return 303 === e ? t.mapping = 301 : 304 === e && (t.mapping = 302), t;
  }

  function i(t) {
    var n = t.target;
    n.removeEventListener("dispose", i);
    var r = e.get(n);
    void 0 !== r && (e.delete(n), r.dispose());
  }

  return {
    get: function get(r) {
      if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
        var _s25 = r.mapping;

        if (303 === _s25 || 304 === _s25) {
          if (e.has(r)) {
            return n(e.get(r).texture, r.mapping);
          }

          {
            var _s26 = r.image;

            if (_s26 && _s26.height > 0) {
              var _a19 = t.getRenderTarget(),
                  _o13 = new Un(_s26.height / 2);

              return _o13.fromEquirectangularTexture(t, r), e.set(r, _o13), t.setRenderTarget(_a19), r.addEventListener("dispose", i), n(_o13.texture, r.mapping);
            }

            return null;
          }
        }
      }

      return r;
    },
    dispose: function dispose() {
      e = new WeakMap();
    }
  };
}

Kn.physical = {
  uniforms: Ln([Kn.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatNormalScale: {
      value: new pt(1, 1)
    },
    clearcoatNormalMap: {
      value: null
    },
    sheen: {
      value: new qe(0)
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionSamplerSize: {
      value: new pt()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    attenuationDistance: {
      value: 0
    },
    attenuationTint: {
      value: new qe(0)
    },
    specularIntensity: {
      value: 0
    },
    specularIntensityMap: {
      value: null
    },
    specularTint: {
      value: new qe(1, 1, 1)
    },
    specularTintMap: {
      value: null
    }
  }]),
  vertexShader: Jn.meshphysical_vert,
  fragmentShader: Jn.meshphysical_frag
};

var ri = /*#__PURE__*/function (_Qn2) {
  _inherits(ri, _Qn2);

  var _super24 = _createSuper(ri);

  function ri() {
    var _this26;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : .1;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2e3;

    _classCallCheck(this, ri);

    _this26 = _super24.call(this), _this26.type = "OrthographicCamera", _this26.zoom = 1, _this26.view = null, _this26.left = t, _this26.right = e, _this26.top = n, _this26.bottom = i, _this26.near = r, _this26.far = s, _this26.updateProjectionMatrix();
    return _this26;
  }

  _createClass(ri, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(ri.prototype), "copy", this).call(this, t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = null === t.view ? null : Object.assign({}, t.view), this;
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(t, e, n, i, r, s) {
      null === this.view && (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = s, this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var t = (this.right - this.left) / (2 * this.zoom),
          e = (this.top - this.bottom) / (2 * this.zoom),
          n = (this.right + this.left) / 2,
          i = (this.top + this.bottom) / 2;
      var r = n - t,
          s = n + t,
          a = i + e,
          o = i - e;

      if (null !== this.view && this.view.enabled) {
        var _t90 = (this.right - this.left) / this.view.fullWidth / this.zoom,
            _e76 = (this.top - this.bottom) / this.view.fullHeight / this.zoom;

        r += _t90 * this.view.offsetX, s = r + _t90 * this.view.width, a -= _e76 * this.view.offsetY, o = a - _e76 * this.view.height;
      }

      this.projectionMatrix.makeOrthographic(r, s, a, o, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(ri.prototype), "toJSON", this).call(this, t);

      return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
    }
  }]);

  return ri;
}(Qn);

ri.prototype.isOrthographicCamera = !0;

var si = /*#__PURE__*/function (_Dn) {
  _inherits(si, _Dn);

  var _super25 = _createSuper(si);

  function si(t) {
    var _this27;

    _classCallCheck(this, si);

    _this27 = _super25.call(this, t), _this27.type = "RawShaderMaterial";
    return _this27;
  }

  return _createClass(si);
}(Dn);

si.prototype.isRawShaderMaterial = !0;

var ai = Math.pow(2, 8),
    oi = [.125, .215, .35, .446, .526, .582],
    li = 5 + oi.length,
    ci = {
  3e3: 0,
  3001: 1,
  3002: 2,
  3004: 3,
  3005: 4,
  3006: 5,
  3007: 6
},
    hi = new je({
  side: 1,
  depthWrite: !1,
  depthTest: !1
}),
    ui = new Mn(new Bn(), hi),
    di = new ri(),
    _i69 = _i(),
    pi = _i69._lodPlanes,
    Ai = _i69._sizeLods,
    mi = _i69._sigmas,
    gi = new qe();

var fi = null;
var vi = (1 + Math.sqrt(5)) / 2,
    yi = 1 / vi,
    xi = [new _t(1, 1, 1), new _t(-1, 1, 1), new _t(1, 1, -1), new _t(-1, 1, -1), new _t(0, vi, yi), new _t(0, vi, -yi), new _t(yi, 0, vi), new _t(-yi, 0, vi), new _t(vi, yi, 0), new _t(-vi, yi, 0)];

function wi(t) {
  var e = Math.max(t.r, t.g, t.b),
      n = Math.min(Math.max(Math.ceil(Math.log2(e)), -128), 127);
  t.multiplyScalar(Math.pow(2, -n));
  return (n + 128) / 255;
}

var Ei = /*#__PURE__*/function () {
  function Ei(t) {
    _classCallCheck(this, Ei);

    this._renderer = t, this._pingPongRenderTarget = null, this._blurMaterial = function (t) {
      var e = new Float32Array(t),
          n = new _t(0, 1, 0);
      return new si({
        name: "SphericalGaussianBlur",
        defines: {
          n: t
        },
        uniforms: {
          envMap: {
            value: null
          },
          samples: {
            value: 1
          },
          weights: {
            value: e
          },
          latitudinal: {
            value: !1
          },
          dTheta: {
            value: 0
          },
          mipInt: {
            value: 0
          },
          poleAxis: {
            value: n
          },
          inputEncoding: {
            value: ci[3e3]
          },
          outputEncoding: {
            value: ci[3e3]
          }
        },
        vertexShader: Bi(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t".concat(Ti(), "\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t"),
        blending: 0,
        depthTest: !1,
        depthWrite: !1
      });
    }(20), this._equirectShader = null, this._cubemapShader = null, this._compileMaterial(this._blurMaterial);
  }

  _createClass(Ei, [{
    key: "fromScene",
    value: function fromScene(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
      fi = this._renderer.getRenderTarget();

      var r = this._allocateTargets();

      return this._sceneToCubeUV(t, n, i, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
    }
  }, {
    key: "fromEquirectangular",
    value: function fromEquirectangular(t) {
      return this._fromTexture(t);
    }
  }, {
    key: "fromCubemap",
    value: function fromCubemap(t) {
      return this._fromTexture(t);
    }
  }, {
    key: "compileCubemapShader",
    value: function compileCubemapShader() {
      null === this._cubemapShader && (this._cubemapShader = Si(), this._compileMaterial(this._cubemapShader));
    }
  }, {
    key: "compileEquirectangularShader",
    value: function compileEquirectangularShader() {
      null === this._equirectShader && (this._equirectShader = Mi(), this._compileMaterial(this._equirectShader));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._blurMaterial.dispose(), null !== this._cubemapShader && this._cubemapShader.dispose(), null !== this._equirectShader && this._equirectShader.dispose();

      for (var _t91 = 0; _t91 < pi.length; _t91++) {
        pi[_t91].dispose();
      }
    }
  }, {
    key: "_cleanup",
    value: function _cleanup(t) {
      this._pingPongRenderTarget.dispose(), this._renderer.setRenderTarget(fi), t.scissorTest = !1, Ci(t, 0, 0, t.width, t.height);
    }
  }, {
    key: "_fromTexture",
    value: function _fromTexture(t) {
      fi = this._renderer.getRenderTarget();

      var e = this._allocateTargets(t);

      return this._textureToCubeUV(t, e), this._applyPMREM(e), this._cleanup(e), e;
    }
  }, {
    key: "_allocateTargets",
    value: function _allocateTargets(t) {
      var e = {
        magFilter: 1003,
        minFilter: 1003,
        generateMipmaps: !1,
        type: 1009,
        format: 1023,
        encoding: bi(t) ? t.encoding : 3002,
        depthBuffer: !1
      },
          n = Ii(e);
      return n.depthBuffer = !t, this._pingPongRenderTarget = Ii(e), n;
    }
  }, {
    key: "_compileMaterial",
    value: function _compileMaterial(t) {
      var e = new Mn(pi[0], t);

      this._renderer.compile(e, di);
    }
  }, {
    key: "_sceneToCubeUV",
    value: function _sceneToCubeUV(t, e, n, i) {
      var r = new Pn(90, 1, e, n),
          s = [1, -1, 1, 1, 1, 1],
          a = [1, 1, 1, -1, -1, -1],
          o = this._renderer,
          l = o.autoClear,
          c = o.outputEncoding,
          h = o.toneMapping;
      o.getClearColor(gi), o.toneMapping = 0, o.outputEncoding = 3e3, o.autoClear = !1;
      var u = !1;
      var d = t.background;

      if (d) {
        if (d.isColor) {
          hi.color.copy(d).convertSRGBToLinear(), t.background = null;

          var _e77 = wi(hi.color);

          hi.opacity = _e77, u = !0;
        }
      } else {
        hi.color.copy(gi).convertSRGBToLinear();

        var _t92 = wi(hi.color);

        hi.opacity = _t92, u = !0;
      }

      for (var _e78 = 0; _e78 < 6; _e78++) {
        var _n87 = _e78 % 3;

        0 == _n87 ? (r.up.set(0, s[_e78], 0), r.lookAt(a[_e78], 0, 0)) : 1 == _n87 ? (r.up.set(0, 0, s[_e78]), r.lookAt(0, a[_e78], 0)) : (r.up.set(0, s[_e78], 0), r.lookAt(0, 0, a[_e78])), Ci(i, _n87 * ai, _e78 > 2 ? ai : 0, ai, ai), o.setRenderTarget(i), u && o.render(ui, r), o.render(t, r);
      }

      o.toneMapping = h, o.outputEncoding = c, o.autoClear = l;
    }
  }, {
    key: "_textureToCubeUV",
    value: function _textureToCubeUV(t, e) {
      var n = this._renderer;
      t.isCubeTexture ? null == this._cubemapShader && (this._cubemapShader = Si()) : null == this._equirectShader && (this._equirectShader = Mi());
      var i = t.isCubeTexture ? this._cubemapShader : this._equirectShader,
          r = new Mn(pi[0], i),
          s = i.uniforms;
      s.envMap.value = t, t.isCubeTexture || s.texelSize.value.set(1 / t.image.width, 1 / t.image.height), s.inputEncoding.value = ci[t.encoding], s.outputEncoding.value = ci[e.texture.encoding], Ci(e, 0, 0, 3 * ai, 2 * ai), n.setRenderTarget(e), n.render(r, di);
    }
  }, {
    key: "_applyPMREM",
    value: function _applyPMREM(t) {
      var e = this._renderer,
          n = e.autoClear;
      e.autoClear = !1;

      for (var _e79 = 1; _e79 < li; _e79++) {
        var _n88 = Math.sqrt(mi[_e79] * mi[_e79] - mi[_e79 - 1] * mi[_e79 - 1]),
            _i70 = xi[(_e79 - 1) % xi.length];

        this._blur(t, _e79 - 1, _e79, _n88, _i70);
      }

      e.autoClear = n;
    }
  }, {
    key: "_blur",
    value: function _blur(t, e, n, i, r) {
      var s = this._pingPongRenderTarget;
      this._halfBlur(t, s, e, n, i, "latitudinal", r), this._halfBlur(s, t, n, n, i, "longitudinal", r);
    }
  }, {
    key: "_halfBlur",
    value: function _halfBlur(t, e, n, i, r, s, a) {
      var o = this._renderer,
          l = this._blurMaterial;
      "latitudinal" !== s && "longitudinal" !== s && console.error("blur direction must be either latitudinal or longitudinal!");
      var c = new Mn(pi[i], l),
          h = l.uniforms,
          u = Ai[n] - 1,
          d = isFinite(r) ? Math.PI / (2 * u) : 2 * Math.PI / 39,
          p = r / d,
          A = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
      A > 20 && console.warn("sigmaRadians, ".concat(r, ", is too large and will clip, as it requested ").concat(A, " samples when the maximum is set to 20"));
      var m = [];
      var g = 0;

      for (var _t93 = 0; _t93 < 20; ++_t93) {
        var _e80 = _t93 / p,
            _n89 = Math.exp(-_e80 * _e80 / 2);

        m.push(_n89), 0 == _t93 ? g += _n89 : _t93 < A && (g += 2 * _n89);
      }

      for (var _t94 = 0; _t94 < m.length; _t94++) {
        m[_t94] = m[_t94] / g;
      }

      h.envMap.value = t.texture, h.samples.value = A, h.weights.value = m, h.latitudinal.value = "latitudinal" === s, a && (h.poleAxis.value = a), h.dTheta.value = d, h.mipInt.value = 8 - n, h.inputEncoding.value = ci[t.texture.encoding], h.outputEncoding.value = ci[t.texture.encoding];
      var f = Ai[i];
      Ci(e, 3 * Math.max(0, ai - 2 * f), (0 === i ? 0 : 2 * ai) + 2 * f * (i > 4 ? i - 8 + 4 : 0), 3 * f, 2 * f), o.setRenderTarget(e), o.render(c, di);
    }
  }]);

  return Ei;
}();

function bi(t) {
  return void 0 !== t && 1009 === t.type && (3e3 === t.encoding || 3001 === t.encoding || 3007 === t.encoding);
}

function _i() {
  var t = [],
      e = [],
      n = [];
  var i = 8;

  for (var _r51 = 0; _r51 < li; _r51++) {
    var _s27 = Math.pow(2, i);

    e.push(_s27);

    var _a20 = 1 / _s27;

    _r51 > 4 ? _a20 = oi[_r51 - 8 + 4 - 1] : 0 == _r51 && (_a20 = 0), n.push(_a20);

    var _o14 = 1 / (_s27 - 1),
        _l13 = -_o14 / 2,
        _c9 = 1 + _o14 / 2,
        _h7 = [_l13, _l13, _c9, _l13, _c9, _c9, _l13, _l13, _c9, _c9, _l13, _c9],
        _u9 = 6,
        _d7 = 6,
        _p7 = 3,
        _A4 = 2,
        _m2 = 1,
        _g2 = new Float32Array(_p7 * _d7 * _u9),
        _f3 = new Float32Array(_A4 * _d7 * _u9),
        _v3 = new Float32Array(_m2 * _d7 * _u9);

    for (var _t95 = 0; _t95 < _u9; _t95++) {
      var _e81 = _t95 % 3 * 2 / 3 - 1,
          _n90 = _t95 > 2 ? 0 : -1,
          _i71 = [_e81, _n90, 0, _e81 + 2 / 3, _n90, 0, _e81 + 2 / 3, _n90 + 1, 0, _e81, _n90, 0, _e81 + 2 / 3, _n90 + 1, 0, _e81, _n90 + 1, 0];

      _g2.set(_i71, _p7 * _d7 * _t95), _f3.set(_h7, _A4 * _d7 * _t95);
      var _r52 = [_t95, _t95, _t95, _t95, _t95, _t95];

      _v3.set(_r52, _m2 * _d7 * _t95);
    }

    var _y2 = new cn();

    _y2.setAttribute("position", new Xe(_g2, _p7)), _y2.setAttribute("uv", new Xe(_f3, _A4)), _y2.setAttribute("faceIndex", new Xe(_v3, _m2)), t.push(_y2), i > 4 && i--;
  }

  return {
    _lodPlanes: t,
    _sizeLods: e,
    _sigmas: n
  };
}

function Ii(t) {
  var e = new wt(3 * ai, 3 * ai, t);
  return e.texture.mapping = 306, e.texture.name = "PMREM.cubeUv", e.scissorTest = !0, e;
}

function Ci(t, e, n, i, r) {
  t.viewport.set(e, n, i, r), t.scissor.set(e, n, i, r);
}

function Mi() {
  var t = new pt(1, 1);
  return new si({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: {
        value: null
      },
      texelSize: {
        value: t
      },
      inputEncoding: {
        value: ci[3e3]
      },
      outputEncoding: {
        value: ci[3e3]
      }
    },
    vertexShader: Bi(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform vec2 texelSize;\n\n\t\t\t".concat(Ti(), "\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tvec2 f = fract( uv / texelSize - 0.5 );\n\t\t\t\tuv -= f * texelSize;\n\t\t\t\tvec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.x += texelSize.x;\n\t\t\t\tvec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.y += texelSize.y;\n\t\t\t\tvec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.x -= texelSize.x;\n\t\t\t\tvec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\n\t\t\t\tvec3 tm = mix( tl, tr, f.x );\n\t\t\t\tvec3 bm = mix( bl, br, f.x );\n\t\t\t\tgl_FragColor.rgb = mix( tm, bm, f.y );\n\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t"),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}

function Si() {
  return new si({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: {
        value: null
      },
      inputEncoding: {
        value: ci[3e3]
      },
      outputEncoding: {
        value: ci[3e3]
      }
    },
    vertexShader: Bi(),
    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\t".concat(Ti(), "\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t"),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}

function Bi() {
  return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute vec3 position;\n\t\tattribute vec2 uv;\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}

function Ti() {
  return "\n\n\t\tuniform int inputEncoding;\n\t\tuniform int outputEncoding;\n\n\t\t#include <encodings_pars_fragment>\n\n\t\tvec4 inputTexelToLinear( vec4 value ) {\n\n\t\t\tif ( inputEncoding == 0 ) {\n\n\t\t\t\treturn value;\n\n\t\t\t} else if ( inputEncoding == 1 ) {\n\n\t\t\t\treturn sRGBToLinear( value );\n\n\t\t\t} else if ( inputEncoding == 2 ) {\n\n\t\t\t\treturn RGBEToLinear( value );\n\n\t\t\t} else if ( inputEncoding == 3 ) {\n\n\t\t\t\treturn RGBMToLinear( value, 7.0 );\n\n\t\t\t} else if ( inputEncoding == 4 ) {\n\n\t\t\t\treturn RGBMToLinear( value, 16.0 );\n\n\t\t\t} else if ( inputEncoding == 5 ) {\n\n\t\t\t\treturn RGBDToLinear( value, 256.0 );\n\n\t\t\t} else {\n\n\t\t\t\treturn GammaToLinear( value, 2.2 );\n\n\t\t\t}\n\n\t\t}\n\n\t\tvec4 linearToOutputTexel( vec4 value ) {\n\n\t\t\tif ( outputEncoding == 0 ) {\n\n\t\t\t\treturn value;\n\n\t\t\t} else if ( outputEncoding == 1 ) {\n\n\t\t\t\treturn LinearTosRGB( value );\n\n\t\t\t} else if ( outputEncoding == 2 ) {\n\n\t\t\t\treturn LinearToRGBE( value );\n\n\t\t\t} else if ( outputEncoding == 3 ) {\n\n\t\t\t\treturn LinearToRGBM( value, 7.0 );\n\n\t\t\t} else if ( outputEncoding == 4 ) {\n\n\t\t\t\treturn LinearToRGBM( value, 16.0 );\n\n\t\t\t} else if ( outputEncoding == 5 ) {\n\n\t\t\t\treturn LinearToRGBD( value, 256.0 );\n\n\t\t\t} else {\n\n\t\t\t\treturn LinearToGamma( value, 2.2 );\n\n\t\t\t}\n\n\t\t}\n\n\t\tvec4 envMapTexelToLinear( vec4 color ) {\n\n\t\t\treturn inputTexelToLinear( color );\n\n\t\t}\n\t";
}

function Li(t) {
  var e = new WeakMap(),
      n = null;

  function i(t) {
    var n = t.target;
    n.removeEventListener("dispose", i);
    var r = e.get(n);
    void 0 !== r && (r.delete(n), r.dispose());
  }

  return {
    get: function get(r) {
      if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
        var _s28 = r.mapping,
            _a21 = 303 === _s28 || 304 === _s28,
            _o15 = 301 === _s28 || 302 === _s28;

        if (_a21 || _o15) {
          if (e.has(r)) return e.get(r).texture;
          {
            var _s29 = r.image;

            if (_a21 && _s29 && _s29.height > 0 || _o15 && _s29 && function (t) {
              var e = 0;
              var n = 6;

              for (var _i72 = 0; _i72 < n; _i72++) {
                void 0 !== t[_i72] && e++;
              }

              return e === n;
            }(_s29)) {
              var _s30 = t.getRenderTarget();

              null === n && (n = new Ei(t));

              var _o16 = _a21 ? n.fromEquirectangular(r) : n.fromCubemap(r);

              return e.set(r, _o16), t.setRenderTarget(_s30), r.addEventListener("dispose", i), _o16.texture;
            }

            return null;
          }
        }
      }

      return r;
    },
    dispose: function dispose() {
      e = new WeakMap(), null !== n && (n.dispose(), n = null);
    }
  };
}

function Ri(t) {
  var e = {};

  function n(n) {
    if (void 0 !== e[n]) return e[n];
    var i;

    switch (n) {
      case "WEBGL_depth_texture":
        i = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
        break;

      case "EXT_texture_filter_anisotropic":
        i = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;

      case "WEBGL_compressed_texture_s3tc":
        i = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;

      case "WEBGL_compressed_texture_pvrtc":
        i = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;

      default:
        i = t.getExtension(n);
    }

    return e[n] = i, i;
  }

  return {
    has: function has(t) {
      return null !== n(t);
    },
    init: function init(t) {
      t.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float");
    },
    get: function get(t) {
      var e = n(t);
      return null === e && console.warn("THREE.WebGLRenderer: " + t + " extension not supported."), e;
    }
  };
}

function Di(t, e, n, i) {
  var r = {},
      s = new WeakMap();

  function a(t) {
    var o = t.target;
    null !== o.index && e.remove(o.index);

    for (var _t96 in o.attributes) {
      e.remove(o.attributes[_t96]);
    }

    o.removeEventListener("dispose", a), delete r[o.id];
    var l = s.get(o);
    l && (e.remove(l), s.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
  }

  function o(t) {
    var n = [],
        i = t.index,
        r = t.attributes.position;
    var a = 0;

    if (null !== i) {
      var _t97 = i.array;
      a = i.version;

      for (var _e82 = 0, _i73 = _t97.length; _e82 < _i73; _e82 += 3) {
        var _i74 = _t97[_e82 + 0],
            _r53 = _t97[_e82 + 1],
            _s31 = _t97[_e82 + 2];
        n.push(_i74, _r53, _r53, _s31, _s31, _i74);
      }
    } else {
      var _t98 = r.array;
      a = r.version;

      for (var _e83 = 0, _i75 = _t98.length / 3 - 1; _e83 < _i75; _e83 += 3) {
        var _t99 = _e83 + 0,
            _i76 = _e83 + 1,
            _r54 = _e83 + 2;

        n.push(_t99, _i76, _i76, _r54, _r54, _t99);
      }
    }

    var o = new (tn(n) > 65535 ? Ze : Ke)(n, 1);
    o.version = a;
    var l = s.get(t);
    l && e.remove(l), s.set(t, o);
  }

  return {
    get: function get(t, e) {
      return !0 === r[e.id] || (e.addEventListener("dispose", a), r[e.id] = !0, n.memory.geometries++), e;
    },
    update: function update(t) {
      var n = t.attributes;

      for (var _t100 in n) {
        e.update(n[_t100], 34962);
      }

      var i = t.morphAttributes;

      for (var _t101 in i) {
        var _n91 = i[_t101];

        for (var _t102 = 0, _i77 = _n91.length; _t102 < _i77; _t102++) {
          e.update(_n91[_t102], 34962);
        }
      }
    },
    getWireframeAttribute: function getWireframeAttribute(t) {
      var e = s.get(t);

      if (e) {
        var _n92 = t.index;
        null !== _n92 && e.version < _n92.version && o(t);
      } else o(t);

      return s.get(t);
    }
  };
}

function Qi(t, e, n, i) {
  var r = i.isWebGL2;
  var s, a, o;
  this.setMode = function (t) {
    s = t;
  }, this.setIndex = function (t) {
    a = t.type, o = t.bytesPerElement;
  }, this.render = function (e, i) {
    t.drawElements(s, i, a, e * o), n.update(i, s, 1);
  }, this.renderInstances = function (i, l, c) {
    if (0 === c) return;
    var h, u;
    if (r) h = t, u = "drawElementsInstanced";else if (h = e.get("ANGLE_instanced_arrays"), u = "drawElementsInstancedANGLE", null === h) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
    h[u](s, l, a, i * o, c), n.update(l, s, c);
  };
}

function Pi(t) {
  var e = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  return {
    memory: {
      geometries: 0,
      textures: 0
    },
    render: e,
    programs: null,
    autoReset: !0,
    reset: function reset() {
      e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    },
    update: function update(t, n, i) {
      switch (e.calls++, n) {
        case 4:
          e.triangles += i * (t / 3);
          break;

        case 1:
          e.lines += i * (t / 2);
          break;

        case 3:
          e.lines += i * (t - 1);
          break;

        case 2:
          e.lines += i * t;
          break;

        case 0:
          e.points += i * t;
          break;

        default:
          console.error("THREE.WebGLInfo: Unknown draw mode:", n);
      }
    }
  };
}

function Fi(t, e) {
  return t[0] - e[0];
}

function Ni(t, e) {
  return Math.abs(e[1]) - Math.abs(t[1]);
}

function Ui(t) {
  var e = {},
      n = new Float32Array(8),
      i = [];

  for (var _t103 = 0; _t103 < 8; _t103++) {
    i[_t103] = [_t103, 0];
  }

  return {
    update: function update(r, s, a, o) {
      var l = r.morphTargetInfluences,
          c = void 0 === l ? 0 : l.length;
      var h = e[s.id];

      if (void 0 === h || h.length !== c) {
        h = [];

        for (var _t104 = 0; _t104 < c; _t104++) {
          h[_t104] = [_t104, 0];
        }

        e[s.id] = h;
      }

      for (var _t105 = 0; _t105 < c; _t105++) {
        var _e84 = h[_t105];
        _e84[0] = _t105, _e84[1] = l[_t105];
      }

      h.sort(Ni);

      for (var _t106 = 0; _t106 < 8; _t106++) {
        _t106 < c && h[_t106][1] ? (i[_t106][0] = h[_t106][0], i[_t106][1] = h[_t106][1]) : (i[_t106][0] = Number.MAX_SAFE_INTEGER, i[_t106][1] = 0);
      }

      i.sort(Fi);
      var u = s.morphAttributes.position,
          d = s.morphAttributes.normal;
      var p = 0;

      for (var _t107 = 0; _t107 < 8; _t107++) {
        var _e85 = i[_t107],
            _r55 = _e85[0],
            _a22 = _e85[1];
        _r55 !== Number.MAX_SAFE_INTEGER && _a22 ? (u && s.getAttribute("morphTarget" + _t107) !== u[_r55] && s.setAttribute("morphTarget" + _t107, u[_r55]), d && s.getAttribute("morphNormal" + _t107) !== d[_r55] && s.setAttribute("morphNormal" + _t107, d[_r55]), n[_t107] = _a22, p += _a22) : (u && !0 === s.hasAttribute("morphTarget" + _t107) && s.deleteAttribute("morphTarget" + _t107), d && !0 === s.hasAttribute("morphNormal" + _t107) && s.deleteAttribute("morphNormal" + _t107), n[_t107] = 0);
      }

      var A = s.morphTargetsRelative ? 1 : 1 - p;
      o.getUniforms().setValue(t, "morphTargetBaseInfluence", A), o.getUniforms().setValue(t, "morphTargetInfluences", n);
    }
  };
}

function ki(t, e, n, i) {
  var r = new WeakMap();

  function s(t) {
    var e = t.target;
    e.removeEventListener("dispose", s), n.remove(e.instanceMatrix), null !== e.instanceColor && n.remove(e.instanceColor);
  }

  return {
    update: function update(t) {
      var a = i.render.frame,
          o = t.geometry,
          l = e.get(t, o);
      return r.get(l) !== a && (e.update(l), r.set(l, a)), t.isInstancedMesh && (!1 === t.hasEventListener("dispose", s) && t.addEventListener("dispose", s), n.update(t.instanceMatrix, 34962), null !== t.instanceColor && n.update(t.instanceColor, 34962)), l;
    },
    dispose: function dispose() {
      r = new WeakMap();
    }
  };
}

var Gi = /*#__PURE__*/function (_vt2) {
  _inherits(Gi, _vt2);

  var _super26 = _createSuper(Gi);

  function Gi() {
    var _this28;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Gi);

    _this28 = _super26.call(this, null), _this28.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, _this28.magFilter = 1003, _this28.minFilter = 1003, _this28.wrapR = 1001, _this28.generateMipmaps = !1, _this28.flipY = !1, _this28.unpackAlignment = 1, _this28.needsUpdate = !0;
    return _this28;
  }

  return _createClass(Gi);
}(vt);

Gi.prototype.isDataTexture2DArray = !0;

var Oi = /*#__PURE__*/function (_vt3) {
  _inherits(Oi, _vt3);

  var _super27 = _createSuper(Oi);

  function Oi() {
    var _this29;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Oi);

    _this29 = _super27.call(this, null), _this29.image = {
      data: t,
      width: e,
      height: n,
      depth: i
    }, _this29.magFilter = 1003, _this29.minFilter = 1003, _this29.wrapR = 1001, _this29.generateMipmaps = !1, _this29.flipY = !1, _this29.unpackAlignment = 1, _this29.needsUpdate = !0;
    return _this29;
  }

  return _createClass(Oi);
}(vt);

Oi.prototype.isDataTexture3D = !0;
var Hi = new vt(),
    zi = new Gi(),
    Vi = new Oi(),
    Wi = new Nn(),
    qi = [],
    ji = [],
    Yi = new Float32Array(16),
    Ji = new Float32Array(9),
    Xi = new Float32Array(4);

function Ki(t, e, n) {
  var i = t[0];
  if (i <= 0 || i > 0) return t;
  var r = e * n;
  var s = qi[r];

  if (void 0 === s && (s = new Float32Array(r), qi[r] = s), 0 !== e) {
    i.toArray(s, 0);

    for (var _i78 = 1, _r56 = 0; _i78 !== e; ++_i78) {
      _r56 += n, t[_i78].toArray(s, _r56);
    }
  }

  return s;
}

function Zi(t, e) {
  if (t.length !== e.length) return !1;

  for (var _n93 = 0, _i79 = t.length; _n93 < _i79; _n93++) {
    if (t[_n93] !== e[_n93]) return !1;
  }

  return !0;
}

function $i(t, e) {
  for (var _n94 = 0, _i80 = e.length; _n94 < _i80; _n94++) {
    t[_n94] = e[_n94];
  }
}

function tr(t, e) {
  var n = ji[e];
  void 0 === n && (n = new Int32Array(e), ji[e] = n);

  for (var _i81 = 0; _i81 !== e; ++_i81) {
    n[_i81] = t.allocateTextureUnit();
  }

  return n;
}

function er(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
}

function nr(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y || (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);else {
    if (Zi(n, e)) return;
    t.uniform2fv(this.addr, e), $i(n, e);
  }
}

function ir(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z || (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);else if (void 0 !== e.r) n[0] === e.r && n[1] === e.g && n[2] === e.b || (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);else {
    if (Zi(n, e)) return;
    t.uniform3fv(this.addr, e), $i(n, e);
  }
}

function rr(t, e) {
  var n = this.cache;
  if (void 0 !== e.x) n[0] === e.x && n[1] === e.y && n[2] === e.z && n[3] === e.w || (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);else {
    if (Zi(n, e)) return;
    t.uniform4fv(this.addr, e), $i(n, e);
  }
}

function sr(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (Zi(n, e)) return;
    t.uniformMatrix2fv(this.addr, !1, e), $i(n, e);
  } else {
    if (Zi(n, i)) return;
    Xi.set(i), t.uniformMatrix2fv(this.addr, !1, Xi), $i(n, i);
  }
}

function ar(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (Zi(n, e)) return;
    t.uniformMatrix3fv(this.addr, !1, e), $i(n, e);
  } else {
    if (Zi(n, i)) return;
    Ji.set(i), t.uniformMatrix3fv(this.addr, !1, Ji), $i(n, i);
  }
}

function or(t, e) {
  var n = this.cache,
      i = e.elements;

  if (void 0 === i) {
    if (Zi(n, e)) return;
    t.uniformMatrix4fv(this.addr, !1, e), $i(n, e);
  } else {
    if (Zi(n, i)) return;
    Yi.set(i), t.uniformMatrix4fv(this.addr, !1, Yi), $i(n, i);
  }
}

function lr(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
}

function cr(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform2iv(this.addr, e), $i(n, e));
}

function hr(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform3iv(this.addr, e), $i(n, e));
}

function ur(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform4iv(this.addr, e), $i(n, e));
}

function dr(t, e) {
  var n = this.cache;
  n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
}

function pr(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform2uiv(this.addr, e), $i(n, e));
}

function Ar(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform3uiv(this.addr, e), $i(n, e));
}

function mr(t, e) {
  var n = this.cache;
  Zi(n, e) || (t.uniform4uiv(this.addr, e), $i(n, e));
}

function gr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.safeSetTexture2D(e || Hi, r);
}

function fr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(e || Vi, r);
}

function vr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.safeSetTextureCube(e || Wi, r);
}

function yr(t, e, n) {
  var i = this.cache,
      r = n.allocateTextureUnit();
  i[0] !== r && (t.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(e || zi, r);
}

function xr(t, e) {
  t.uniform1fv(this.addr, e);
}

function wr(t, e) {
  var n = Ki(e, this.size, 2);
  t.uniform2fv(this.addr, n);
}

function Er(t, e) {
  var n = Ki(e, this.size, 3);
  t.uniform3fv(this.addr, n);
}

function br(t, e) {
  var n = Ki(e, this.size, 4);
  t.uniform4fv(this.addr, n);
}

function _r(t, e) {
  var n = Ki(e, this.size, 4);
  t.uniformMatrix2fv(this.addr, !1, n);
}

function Ir(t, e) {
  var n = Ki(e, this.size, 9);
  t.uniformMatrix3fv(this.addr, !1, n);
}

function Cr(t, e) {
  var n = Ki(e, this.size, 16);
  t.uniformMatrix4fv(this.addr, !1, n);
}

function Mr(t, e) {
  t.uniform1iv(this.addr, e);
}

function Sr(t, e) {
  t.uniform2iv(this.addr, e);
}

function Br(t, e) {
  t.uniform3iv(this.addr, e);
}

function Tr(t, e) {
  t.uniform4iv(this.addr, e);
}

function Lr(t, e) {
  t.uniform1uiv(this.addr, e);
}

function Rr(t, e) {
  t.uniform2uiv(this.addr, e);
}

function Dr(t, e) {
  t.uniform3uiv(this.addr, e);
}

function Qr(t, e) {
  t.uniform4uiv(this.addr, e);
}

function Pr(t, e, n) {
  var i = e.length,
      r = tr(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t108 = 0; _t108 !== i; ++_t108) {
    n.safeSetTexture2D(e[_t108] || Hi, r[_t108]);
  }
}

function Fr(t, e, n) {
  var i = e.length,
      r = tr(n, i);
  t.uniform1iv(this.addr, r);

  for (var _t109 = 0; _t109 !== i; ++_t109) {
    n.safeSetTextureCube(e[_t109] || Wi, r[_t109]);
  }
}

function Nr(t, e, n) {
  this.id = t, this.addr = n, this.cache = [], this.setValue = function (t) {
    switch (t) {
      case 5126:
        return er;

      case 35664:
        return nr;

      case 35665:
        return ir;

      case 35666:
        return rr;

      case 35674:
        return sr;

      case 35675:
        return ar;

      case 35676:
        return or;

      case 5124:
      case 35670:
        return lr;

      case 35667:
      case 35671:
        return cr;

      case 35668:
      case 35672:
        return hr;

      case 35669:
      case 35673:
        return ur;

      case 5125:
        return dr;

      case 36294:
        return pr;

      case 36295:
        return Ar;

      case 36296:
        return mr;

      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return gr;

      case 35679:
      case 36299:
      case 36307:
        return fr;

      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return vr;

      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return yr;
    }
  }(e.type);
}

function Ur(t, e, n) {
  this.id = t, this.addr = n, this.cache = [], this.size = e.size, this.setValue = function (t) {
    switch (t) {
      case 5126:
        return xr;

      case 35664:
        return wr;

      case 35665:
        return Er;

      case 35666:
        return br;

      case 35674:
        return _r;

      case 35675:
        return Ir;

      case 35676:
        return Cr;

      case 5124:
      case 35670:
        return Mr;

      case 35667:
      case 35671:
        return Sr;

      case 35668:
      case 35672:
        return Br;

      case 35669:
      case 35673:
        return Tr;

      case 5125:
        return Lr;

      case 36294:
        return Rr;

      case 36295:
        return Dr;

      case 36296:
        return Qr;

      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return Pr;

      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return Fr;
    }
  }(e.type);
}

function kr(t) {
  this.id = t, this.seq = [], this.map = {};
}

Ur.prototype.updateCache = function (t) {
  var e = this.cache;
  t instanceof Float32Array && e.length !== t.length && (this.cache = new Float32Array(t.length)), $i(e, t);
}, kr.prototype.setValue = function (t, e, n) {
  var i = this.seq;

  for (var _r57 = 0, _s32 = i.length; _r57 !== _s32; ++_r57) {
    var _s33 = i[_r57];

    _s33.setValue(t, e[_s33.id], n);
  }
};
var Gr = /(\w+)(\])?(\[|\.)?/g;

function Or(t, e) {
  t.seq.push(e), t.map[e.id] = e;
}

function Hr(t, e, n) {
  var i = t.name,
      r = i.length;

  for (Gr.lastIndex = 0;;) {
    var _s34 = Gr.exec(i),
        _a23 = Gr.lastIndex;

    var _o17 = _s34[1];

    var _l14 = "]" === _s34[2],
        _c10 = _s34[3];

    if (_l14 && (_o17 |= 0), void 0 === _c10 || "[" === _c10 && _a23 + 2 === r) {
      Or(n, void 0 === _c10 ? new Nr(_o17, t, e) : new Ur(_o17, t, e));
      break;
    }

    {
      var _t110 = n.map[_o17];
      void 0 === _t110 && (_t110 = new kr(_o17), Or(n, _t110)), n = _t110;
    }
  }
}

function zr(t, e) {
  this.seq = [], this.map = {};
  var n = t.getProgramParameter(e, 35718);

  for (var _i82 = 0; _i82 < n; ++_i82) {
    var _n95 = t.getActiveUniform(e, _i82);

    Hr(_n95, t.getUniformLocation(e, _n95.name), this);
  }
}

function Vr(t, e, n) {
  var i = t.createShader(e);
  return t.shaderSource(i, n), t.compileShader(i), i;
}

zr.prototype.setValue = function (t, e, n, i) {
  var r = this.map[e];
  void 0 !== r && r.setValue(t, n, i);
}, zr.prototype.setOptional = function (t, e, n) {
  var i = e[n];
  void 0 !== i && this.setValue(t, n, i);
}, zr.upload = function (t, e, n, i) {
  for (var _r58 = 0, _s35 = e.length; _r58 !== _s35; ++_r58) {
    var _s36 = e[_r58],
        _a24 = n[_s36.id];
    !1 !== _a24.needsUpdate && _s36.setValue(t, _a24.value, i);
  }
}, zr.seqWithValue = function (t, e) {
  var n = [];

  for (var _i83 = 0, _r59 = t.length; _i83 !== _r59; ++_i83) {
    var _r60 = t[_i83];
    _r60.id in e && n.push(_r60);
  }

  return n;
};
var Wr = 0;

function qr(t) {
  switch (t) {
    case 3e3:
      return ["Linear", "( value )"];

    case 3001:
      return ["sRGB", "( value )"];

    case 3002:
      return ["RGBE", "( value )"];

    case 3004:
      return ["RGBM", "( value, 7.0 )"];

    case 3005:
      return ["RGBM", "( value, 16.0 )"];

    case 3006:
      return ["RGBD", "( value, 256.0 )"];

    case 3007:
      return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];

    case 3003:
      return ["LogLuv", "( value )"];

    default:
      return console.warn("THREE.WebGLProgram: Unsupported encoding:", t), ["Linear", "( value )"];
  }
}

function jr(t, e, n) {
  var i = t.getShaderParameter(e, 35713),
      r = t.getShaderInfoLog(e).trim();
  if (i && "" === r) return "";
  return "THREE.WebGLShader: gl.getShaderInfoLog() " + n + "\n" + r + function (t) {
    var e = t.split("\n");

    for (var _t111 = 0; _t111 < e.length; _t111++) {
      e[_t111] = _t111 + 1 + ": " + e[_t111];
    }

    return e.join("\n");
  }(t.getShaderSource(e));
}

function Yr(t, e) {
  var n = qr(e);
  return "vec4 " + t + "( vec4 value ) { return " + n[0] + "ToLinear" + n[1] + "; }";
}

function Jr(t, e) {
  var n = qr(e);
  return "vec4 " + t + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }";
}

function Xr(t, e) {
  var n;

  switch (e) {
    case 1:
      n = "Linear";
      break;

    case 2:
      n = "Reinhard";
      break;

    case 3:
      n = "OptimizedCineon";
      break;

    case 4:
      n = "ACESFilmic";
      break;

    case 5:
      n = "Custom";
      break;

    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
  }

  return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}

function Kr(t) {
  return "" !== t;
}

function Zr(t, e) {
  return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}

function $r(t, e) {
  return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}

var ts = /^[ \t]*#include +<([\w\d./]+)>/gm;

function es(t) {
  return t.replace(ts, ns);
}

function ns(t, e) {
  var n = Jn[e];
  if (void 0 === n) throw new Error("Can not resolve #include <" + e + ">");
  return es(n);
}

var is = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g,
    rs = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function ss(t) {
  return t.replace(rs, os).replace(is, as);
}

function as(t, e, n, i) {
  return console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."), os(t, e, n, i);
}

function os(t, e, n, i) {
  var r = "";

  for (var _t112 = parseInt(e); _t112 < parseInt(n); _t112++) {
    r += i.replace(/\[\s*i\s*\]/g, "[ " + _t112 + " ]").replace(/UNROLLED_LOOP_INDEX/g, _t112);
  }

  return r;
}

function ls(t) {
  var e = "precision " + t.precision + " float;\nprecision " + t.precision + " int;";
  return "highp" === t.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t.precision && (e += "\n#define LOW_PRECISION"), e;
}

function cs(t, e, n, i) {
  var r = t.getContext(),
      s = n.defines;
  var a = n.vertexShader,
      o = n.fragmentShader;

  var l = function (t) {
    var e = "SHADOWMAP_TYPE_BASIC";
    return 1 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF" : 2 === t.shadowMapType ? e = "SHADOWMAP_TYPE_PCF_SOFT" : 3 === t.shadowMapType && (e = "SHADOWMAP_TYPE_VSM"), e;
  }(n),
      c = function (t) {
    var e = "ENVMAP_TYPE_CUBE";
    if (t.envMap) switch (t.envMapMode) {
      case 301:
      case 302:
        e = "ENVMAP_TYPE_CUBE";
        break;

      case 306:
      case 307:
        e = "ENVMAP_TYPE_CUBE_UV";
    }
    return e;
  }(n),
      h = function (t) {
    var e = "ENVMAP_MODE_REFLECTION";
    if (t.envMap) switch (t.envMapMode) {
      case 302:
      case 307:
        e = "ENVMAP_MODE_REFRACTION";
    }
    return e;
  }(n),
      u = function (t) {
    var e = "ENVMAP_BLENDING_NONE";
    if (t.envMap) switch (t.combine) {
      case 0:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;

      case 1:
        e = "ENVMAP_BLENDING_MIX";
        break;

      case 2:
        e = "ENVMAP_BLENDING_ADD";
    }
    return e;
  }(n),
      d = t.gammaFactor > 0 ? t.gammaFactor : 1,
      p = n.isWebGL2 ? "" : function (t) {
    return [t.extensionDerivatives || t.envMapCubeUV || t.bumpMap || t.tangentSpaceNormalMap || t.clearcoatNormalMap || t.flatShading || "physical" === t.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "", (t.extensionFragDepth || t.logarithmicDepthBuffer) && t.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "", t.extensionDrawBuffers && t.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "", (t.extensionShaderTextureLOD || t.envMap || t.transmission > 0) && t.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(Kr).join("\n");
  }(n),
      A = function (t) {
    var e = [];

    for (var _n96 in t) {
      var _i84 = t[_n96];
      !1 !== _i84 && e.push("#define " + _n96 + " " + _i84);
    }

    return e.join("\n");
  }(s),
      m = r.createProgram();

  var g,
      f,
      v = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
  n.isRawShaderMaterial ? (g = [A].filter(Kr).join("\n"), g.length > 0 && (g += "\n"), f = [p, A].filter(Kr).join("\n"), f.length > 0 && (f += "\n")) : (g = [ls(n), "#define SHADER_NAME " + n.shaderName, A, n.instancing ? "#define USE_INSTANCING" : "", n.instancingColor ? "#define USE_INSTANCING_COLOR" : "", n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define GAMMA_FACTOR " + d, "#define MAX_BONES " + n.maxBones, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + h : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularTintMap ? "#define USE_SPECULARTINTMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.useVertexTexture ? "#define BONE_TEXTURE" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + l : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", "#ifdef USE_INSTANCING", "\tattribute mat4 instanceMatrix;", "#endif", "#ifdef USE_INSTANCING_COLOR", "\tattribute vec3 instanceColor;", "#endif", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_TANGENT", "\tattribute vec4 tangent;", "#endif", "#if defined( USE_COLOR_ALPHA )", "\tattribute vec4 color;", "#elif defined( USE_COLOR )", "\tattribute vec3 color;", "#endif", "#ifdef USE_MORPHTARGETS", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(Kr).join("\n"), f = [p, ls(n), "#define SHADER_NAME " + n.shaderName, A, n.alphaTest ? "#define ALPHATEST " + n.alphaTest + (n.alphaTest % 1 ? "" : ".0") : "", "#define GAMMA_FACTOR " + d, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.matcap ? "#define USE_MATCAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + c : "", n.envMap ? "#define " + h : "", n.envMap ? "#define " + u : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.normalMap && n.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", n.normalMap && n.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "", n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "", n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "", n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "", n.specularTintMap ? "#define USE_SPECULARTINTMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.sheen ? "#define USE_SHEEN" : "", n.transmission ? "#define USE_TRANSMISSION" : "", n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "", n.thicknessMap ? "#define USE_THICKNESSMAP" : "", n.vertexTangents ? "#define USE_TANGENT" : "", n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "", n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "", n.vertexUvs ? "#define USE_UV" : "", n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + l : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "", (n.extensionShaderTextureLOD || n.envMap) && n.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", "uniform bool isOrthographic;", 0 !== n.toneMapping ? "#define TONE_MAPPING" : "", 0 !== n.toneMapping ? Jn.tonemapping_pars_fragment : "", 0 !== n.toneMapping ? Xr("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", Jn.encodings_pars_fragment, n.map ? Yr("mapTexelToLinear", n.mapEncoding) : "", n.matcap ? Yr("matcapTexelToLinear", n.matcapEncoding) : "", n.envMap ? Yr("envMapTexelToLinear", n.envMapEncoding) : "", n.emissiveMap ? Yr("emissiveMapTexelToLinear", n.emissiveMapEncoding) : "", n.specularTintMap ? Yr("specularTintMapTexelToLinear", n.specularTintMapEncoding) : "", n.lightMap ? Yr("lightMapTexelToLinear", n.lightMapEncoding) : "", Jr("linearToOutputTexel", n.outputEncoding), n.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "", "\n"].filter(Kr).join("\n")), a = es(a), a = Zr(a, n), a = $r(a, n), o = es(o), o = Zr(o, n), o = $r(o, n), a = ss(a), o = ss(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (v = "#version 300 es\n", g = ["#define attribute in", "#define varying out", "#define texture2D texture"].join("\n") + "\n" + g, f = ["#define varying in", "300 es" === n.glslVersion ? "" : "out highp vec4 pc_fragColor;", "300 es" === n.glslVersion ? "" : "#define gl_FragColor pc_fragColor", "#define gl_FragDepthEXT gl_FragDepth", "#define texture2D texture", "#define textureCube texture", "#define texture2DProj textureProj", "#define texture2DLodEXT textureLod", "#define texture2DProjLodEXT textureProjLod", "#define textureCubeLodEXT textureLod", "#define texture2DGradEXT textureGrad", "#define texture2DProjGradEXT textureProjGrad", "#define textureCubeGradEXT textureGrad"].join("\n") + "\n" + f);
  var y = v + f + o,
      x = Vr(r, 35633, v + g + a),
      w = Vr(r, 35632, y);

  if (r.attachShader(m, x), r.attachShader(m, w), void 0 !== n.index0AttributeName ? r.bindAttribLocation(m, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(m, 0, "position"), r.linkProgram(m), t.debug.checkShaderErrors) {
    var _t113 = r.getProgramInfoLog(m).trim(),
        _e86 = r.getShaderInfoLog(x).trim(),
        _n97 = r.getShaderInfoLog(w).trim();

    var _i85 = !0,
        _s37 = !0;

    if (!1 === r.getProgramParameter(m, 35714)) {
      _i85 = !1;

      var _e87 = jr(r, x, "vertex"),
          _n98 = jr(r, w, "fragment");

      console.error("THREE.WebGLProgram: shader error: ", r.getError(), "35715", r.getProgramParameter(m, 35715), "gl.getProgramInfoLog", _t113, _e87, _n98);
    } else "" !== _t113 ? console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", _t113) : "" !== _e86 && "" !== _n97 || (_s37 = !1);

    _s37 && (this.diagnostics = {
      runnable: _i85,
      programLog: _t113,
      vertexShader: {
        log: _e86,
        prefix: g
      },
      fragmentShader: {
        log: _n97,
        prefix: f
      }
    });
  }

  var E, b;
  return r.deleteShader(x), r.deleteShader(w), this.getUniforms = function () {
    return void 0 === E && (E = new zr(r, m)), E;
  }, this.getAttributes = function () {
    return void 0 === b && (b = function (t, e) {
      var n = {},
          i = t.getProgramParameter(e, 35721);

      for (var _r61 = 0; _r61 < i; _r61++) {
        var _i86 = t.getActiveAttrib(e, _r61).name;
        n[_i86] = t.getAttribLocation(e, _i86);
      }

      return n;
    }(r, m)), b;
  }, this.destroy = function () {
    i.releaseStatesOfProgram(this), r.deleteProgram(m), this.program = void 0;
  }, this.name = n.shaderName, this.id = Wr++, this.cacheKey = e, this.usedTimes = 1, this.program = m, this.vertexShader = x, this.fragmentShader = w, this;
}

function hs(t, e, n, i, r, s, a) {
  var o = [],
      l = r.isWebGL2,
      c = r.logarithmicDepthBuffer,
      h = r.floatVertexTextures,
      u = r.maxVertexUniforms,
      d = r.vertexTextures;
  var p = r.precision;
  var A = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  },
      m = ["precision", "isWebGL2", "supportsVertexTextures", "outputEncoding", "instancing", "instancingColor", "map", "mapEncoding", "matcap", "matcapEncoding", "envMap", "envMapMode", "envMapEncoding", "envMapCubeUV", "lightMap", "lightMapEncoding", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "objectSpaceNormalMap", "tangentSpaceNormalMap", "clearcoatMap", "clearcoatRoughnessMap", "clearcoatNormalMap", "displacementMap", "specularMap", "specularIntensityMap", "specularTintMap", "specularTintMapEncoding", "roughnessMap", "metalnessMap", "gradientMap", "alphaMap", "combine", "vertexColors", "vertexAlphas", "vertexTangents", "vertexUvs", "uvsVertexOnly", "fog", "useFog", "fogExp2", "flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning", "maxBones", "useVertexTexture", "morphTargets", "morphNormals", "premultipliedAlpha", "numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights", "numDirLightShadows", "numPointLightShadows", "numSpotLightShadows", "shadowMapEnabled", "shadowMapType", "toneMapping", "physicallyCorrectLights", "alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering", "sheen", "transmission", "transmissionMap", "thicknessMap"];

  function g(t) {
    var e;
    return t && t.isTexture ? e = t.encoding : t && t.isWebGLRenderTarget ? (console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."), e = t.texture.encoding) : e = 3e3, e;
  }

  return {
    getParameters: function getParameters(s, o, m, f, v) {
      var y = f.fog,
          x = s.isMeshStandardMaterial ? f.environment : null,
          w = (s.isMeshStandardMaterial ? n : e).get(s.envMap || x),
          E = A[s.type],
          b = v.isSkinnedMesh ? function (t) {
        var e = t.skeleton.bones;
        if (h) return 1024;
        {
          var _t114 = u,
              _n99 = Math.floor((_t114 - 20) / 4),
              _i87 = Math.min(_n99, e.length);

          return _i87 < e.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + e.length + " bones. This GPU supports " + _i87 + "."), 0) : _i87;
        }
      }(v) : 0;

      var _, I;

      if (null !== s.precision && (p = r.getMaxPrecision(s.precision), p !== s.precision && console.warn("THREE.WebGLProgram.getParameters:", s.precision, "not supported, using", p, "instead.")), E) {
        var _t115 = Kn[E];
        _ = _t115.vertexShader, I = _t115.fragmentShader;
      } else _ = s.vertexShader, I = s.fragmentShader;

      var C = t.getRenderTarget();
      return {
        isWebGL2: l,
        shaderID: E,
        shaderName: s.type,
        vertexShader: _,
        fragmentShader: I,
        defines: s.defines,
        isRawShaderMaterial: !0 === s.isRawShaderMaterial,
        glslVersion: s.glslVersion,
        precision: p,
        instancing: !0 === v.isInstancedMesh,
        instancingColor: !0 === v.isInstancedMesh && null !== v.instanceColor,
        supportsVertexTextures: d,
        outputEncoding: null !== C ? g(C.texture) : t.outputEncoding,
        map: !!s.map,
        mapEncoding: g(s.map),
        matcap: !!s.matcap,
        matcapEncoding: g(s.matcap),
        envMap: !!w,
        envMapMode: w && w.mapping,
        envMapEncoding: g(w),
        envMapCubeUV: !!w && (306 === w.mapping || 307 === w.mapping),
        lightMap: !!s.lightMap,
        lightMapEncoding: g(s.lightMap),
        aoMap: !!s.aoMap,
        emissiveMap: !!s.emissiveMap,
        emissiveMapEncoding: g(s.emissiveMap),
        bumpMap: !!s.bumpMap,
        normalMap: !!s.normalMap,
        objectSpaceNormalMap: 1 === s.normalMapType,
        tangentSpaceNormalMap: 0 === s.normalMapType,
        clearcoatMap: !!s.clearcoatMap,
        clearcoatRoughnessMap: !!s.clearcoatRoughnessMap,
        clearcoatNormalMap: !!s.clearcoatNormalMap,
        displacementMap: !!s.displacementMap,
        roughnessMap: !!s.roughnessMap,
        metalnessMap: !!s.metalnessMap,
        specularMap: !!s.specularMap,
        specularIntensityMap: !!s.specularIntensityMap,
        specularTintMap: !!s.specularTintMap,
        specularTintMapEncoding: g(s.specularTintMap),
        alphaMap: !!s.alphaMap,
        gradientMap: !!s.gradientMap,
        sheen: !!s.sheen,
        transmission: !!s.transmission,
        transmissionMap: !!s.transmissionMap,
        thicknessMap: !!s.thicknessMap,
        combine: s.combine,
        vertexTangents: !!s.normalMap && !!v.geometry && !!v.geometry.attributes.tangent,
        vertexColors: s.vertexColors,
        vertexAlphas: !0 === s.vertexColors && !!v.geometry && !!v.geometry.attributes.color && 4 === v.geometry.attributes.color.itemSize,
        vertexUvs: !!(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatMap || s.clearcoatRoughnessMap || s.clearcoatNormalMap || s.displacementMap || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularTintMap),
        uvsVertexOnly: !(s.map || s.bumpMap || s.normalMap || s.specularMap || s.alphaMap || s.emissiveMap || s.roughnessMap || s.metalnessMap || s.clearcoatNormalMap || s.transmission || s.transmissionMap || s.thicknessMap || s.specularIntensityMap || s.specularTintMap || !s.displacementMap),
        fog: !!y,
        useFog: s.fog,
        fogExp2: y && y.isFogExp2,
        flatShading: !!s.flatShading,
        sizeAttenuation: s.sizeAttenuation,
        logarithmicDepthBuffer: c,
        skinning: !0 === v.isSkinnedMesh && b > 0,
        maxBones: b,
        useVertexTexture: h,
        morphTargets: !!v.geometry && !!v.geometry.morphAttributes.position,
        morphNormals: !!v.geometry && !!v.geometry.morphAttributes.normal,
        numDirLights: o.directional.length,
        numPointLights: o.point.length,
        numSpotLights: o.spot.length,
        numRectAreaLights: o.rectArea.length,
        numHemiLights: o.hemi.length,
        numDirLightShadows: o.directionalShadowMap.length,
        numPointLightShadows: o.pointShadowMap.length,
        numSpotLightShadows: o.spotShadowMap.length,
        numClippingPlanes: a.numPlanes,
        numClipIntersection: a.numIntersection,
        dithering: s.dithering,
        shadowMapEnabled: t.shadowMap.enabled && m.length > 0,
        shadowMapType: t.shadowMap.type,
        toneMapping: s.toneMapped ? t.toneMapping : 0,
        physicallyCorrectLights: t.physicallyCorrectLights,
        premultipliedAlpha: s.premultipliedAlpha,
        alphaTest: s.alphaTest,
        doubleSided: 2 === s.side,
        flipSided: 1 === s.side,
        depthPacking: void 0 !== s.depthPacking && s.depthPacking,
        index0AttributeName: s.index0AttributeName,
        extensionDerivatives: s.extensions && s.extensions.derivatives,
        extensionFragDepth: s.extensions && s.extensions.fragDepth,
        extensionDrawBuffers: s.extensions && s.extensions.drawBuffers,
        extensionShaderTextureLOD: s.extensions && s.extensions.shaderTextureLOD,
        rendererExtensionFragDepth: l || i.has("EXT_frag_depth"),
        rendererExtensionDrawBuffers: l || i.has("WEBGL_draw_buffers"),
        rendererExtensionShaderTextureLod: l || i.has("EXT_shader_texture_lod"),
        customProgramCacheKey: s.customProgramCacheKey()
      };
    },
    getProgramCacheKey: function getProgramCacheKey(e) {
      var n = [];
      if (e.shaderID ? n.push(e.shaderID) : (n.push(e.fragmentShader), n.push(e.vertexShader)), void 0 !== e.defines) for (var _t116 in e.defines) {
        n.push(_t116), n.push(e.defines[_t116]);
      }

      if (!1 === e.isRawShaderMaterial) {
        for (var _t117 = 0; _t117 < m.length; _t117++) {
          n.push(e[m[_t117]]);
        }

        n.push(t.outputEncoding), n.push(t.gammaFactor);
      }

      return n.push(e.customProgramCacheKey), n.join();
    },
    getUniforms: function getUniforms(t) {
      var e = A[t.type];
      var n;

      if (e) {
        var _t118 = Kn[e];
        n = Rn.clone(_t118.uniforms);
      } else n = t.uniforms;

      return n;
    },
    acquireProgram: function acquireProgram(e, n) {
      var i;

      for (var _t119 = 0, _e88 = o.length; _t119 < _e88; _t119++) {
        var _e89 = o[_t119];

        if (_e89.cacheKey === n) {
          i = _e89, ++i.usedTimes;
          break;
        }
      }

      return void 0 === i && (i = new cs(t, n, e, s), o.push(i)), i;
    },
    releaseProgram: function releaseProgram(t) {
      if (0 == --t.usedTimes) {
        var _e90 = o.indexOf(t);

        o[_e90] = o[o.length - 1], o.pop(), t.destroy();
      }
    },
    programs: o
  };
}

function us() {
  var t = new WeakMap();
  return {
    get: function get(e) {
      var n = t.get(e);
      return void 0 === n && (n = {}, t.set(e, n)), n;
    },
    remove: function remove(e) {
      t.delete(e);
    },
    update: function update(e, n, i) {
      t.get(e)[n] = i;
    },
    dispose: function dispose() {
      t = new WeakMap();
    }
  };
}

function ds(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.program !== e.program ? t.program.id - e.program.id : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
}

function ps(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
}

function As(t) {
  var e = [];
  var n = 0;
  var i = [],
      r = [],
      s = [],
      a = {
    id: -1
  };

  function o(i, r, s, o, l, c) {
    var h = e[n];
    var u = t.get(s);
    return void 0 === h ? (h = {
      id: i.id,
      object: i,
      geometry: r,
      material: s,
      program: u.program || a,
      groupOrder: o,
      renderOrder: i.renderOrder,
      z: l,
      group: c
    }, e[n] = h) : (h.id = i.id, h.object = i, h.geometry = r, h.material = s, h.program = u.program || a, h.groupOrder = o, h.renderOrder = i.renderOrder, h.z = l, h.group = c), n++, h;
  }

  return {
    opaque: i,
    transmissive: r,
    transparent: s,
    init: function init() {
      n = 0, i.length = 0, r.length = 0, s.length = 0;
    },
    push: function push(t, e, n, a, l, c) {
      var h = o(t, e, n, a, l, c);
      n.transmission > 0 ? r.push(h) : !0 === n.transparent ? s.push(h) : i.push(h);
    },
    unshift: function unshift(t, e, n, a, l, c) {
      var h = o(t, e, n, a, l, c);
      n.transmission > 0 ? r.unshift(h) : !0 === n.transparent ? s.unshift(h) : i.unshift(h);
    },
    finish: function finish() {
      for (var _t120 = n, _i88 = e.length; _t120 < _i88; _t120++) {
        var _n100 = e[_t120];
        if (null === _n100.id) break;
        _n100.id = null, _n100.object = null, _n100.geometry = null, _n100.material = null, _n100.program = null, _n100.group = null;
      }
    },
    sort: function sort(t, e) {
      i.length > 1 && i.sort(t || ds), r.length > 1 && r.sort(e || ps), s.length > 1 && s.sort(e || ps);
    }
  };
}

function ms(t) {
  var e = new WeakMap();
  return {
    get: function get(n, i) {
      var r;
      return !1 === e.has(n) ? (r = new As(t), e.set(n, [r])) : i >= e.get(n).length ? (r = new As(t), e.get(n).push(r)) : r = e.get(n)[i], r;
    },
    dispose: function dispose() {
      e = new WeakMap();
    }
  };
}

function gs() {
  var t = {};
  return {
    get: function get(e) {
      if (void 0 !== t[e.id]) return t[e.id];
      var n;

      switch (e.type) {
        case "DirectionalLight":
          n = {
            direction: new _t(),
            color: new qe()
          };
          break;

        case "SpotLight":
          n = {
            position: new _t(),
            direction: new _t(),
            color: new qe(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;

        case "PointLight":
          n = {
            position: new _t(),
            color: new qe(),
            distance: 0,
            decay: 0
          };
          break;

        case "HemisphereLight":
          n = {
            direction: new _t(),
            skyColor: new qe(),
            groundColor: new qe()
          };
          break;

        case "RectAreaLight":
          n = {
            color: new qe(),
            position: new _t(),
            halfWidth: new _t(),
            halfHeight: new _t()
          };
      }

      return t[e.id] = n, n;
    }
  };
}

var fs = 0;

function vs(t, e) {
  return (e.castShadow ? 1 : 0) - (t.castShadow ? 1 : 0);
}

function ys(t, e) {
  var n = new gs(),
      i = function () {
    var t = {};
    return {
      get: function get(e) {
        if (void 0 !== t[e.id]) return t[e.id];
        var n;

        switch (e.type) {
          case "DirectionalLight":
          case "SpotLight":
            n = {
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new pt()
            };
            break;

          case "PointLight":
            n = {
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new pt(),
              shadowCameraNear: 1,
              shadowCameraFar: 1e3
            };
        }

        return t[e.id] = n, n;
      }
    };
  }(),
      r = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };

  for (var _t121 = 0; _t121 < 9; _t121++) {
    r.probe.push(new _t());
  }

  var s = new _t(),
      a = new ee(),
      o = new ee();
  return {
    setup: function setup(s) {
      var a = 0,
          o = 0,
          l = 0;

      for (var _t122 = 0; _t122 < 9; _t122++) {
        r.probe[_t122].set(0, 0, 0);
      }

      var c = 0,
          h = 0,
          u = 0,
          d = 0,
          p = 0,
          A = 0,
          m = 0,
          g = 0;
      s.sort(vs);

      for (var _t123 = 0, _e91 = s.length; _t123 < _e91; _t123++) {
        var _e92 = s[_t123],
            _f4 = _e92.color,
            _v4 = _e92.intensity,
            _y3 = _e92.distance,
            _x2 = _e92.shadow && _e92.shadow.map ? _e92.shadow.map.texture : null;

        if (_e92.isAmbientLight) a += _f4.r * _v4, o += _f4.g * _v4, l += _f4.b * _v4;else if (_e92.isLightProbe) for (var _t124 = 0; _t124 < 9; _t124++) {
          r.probe[_t124].addScaledVector(_e92.sh.coefficients[_t124], _v4);
        } else if (_e92.isDirectionalLight) {
          var _t125 = n.get(_e92);

          if (_t125.color.copy(_e92.color).multiplyScalar(_e92.intensity), _e92.castShadow) {
            var _t126 = _e92.shadow,
                _n101 = i.get(_e92);

            _n101.shadowBias = _t126.bias, _n101.shadowNormalBias = _t126.normalBias, _n101.shadowRadius = _t126.radius, _n101.shadowMapSize = _t126.mapSize, r.directionalShadow[c] = _n101, r.directionalShadowMap[c] = _x2, r.directionalShadowMatrix[c] = _e92.shadow.matrix, A++;
          }

          r.directional[c] = _t125, c++;
        } else if (_e92.isSpotLight) {
          var _t127 = n.get(_e92);

          if (_t127.position.setFromMatrixPosition(_e92.matrixWorld), _t127.color.copy(_f4).multiplyScalar(_v4), _t127.distance = _y3, _t127.coneCos = Math.cos(_e92.angle), _t127.penumbraCos = Math.cos(_e92.angle * (1 - _e92.penumbra)), _t127.decay = _e92.decay, _e92.castShadow) {
            var _t128 = _e92.shadow,
                _n102 = i.get(_e92);

            _n102.shadowBias = _t128.bias, _n102.shadowNormalBias = _t128.normalBias, _n102.shadowRadius = _t128.radius, _n102.shadowMapSize = _t128.mapSize, r.spotShadow[u] = _n102, r.spotShadowMap[u] = _x2, r.spotShadowMatrix[u] = _e92.shadow.matrix, g++;
          }

          r.spot[u] = _t127, u++;
        } else if (_e92.isRectAreaLight) {
          var _t129 = n.get(_e92);

          _t129.color.copy(_f4).multiplyScalar(_v4), _t129.halfWidth.set(.5 * _e92.width, 0, 0), _t129.halfHeight.set(0, .5 * _e92.height, 0), r.rectArea[d] = _t129, d++;
        } else if (_e92.isPointLight) {
          var _t130 = n.get(_e92);

          if (_t130.color.copy(_e92.color).multiplyScalar(_e92.intensity), _t130.distance = _e92.distance, _t130.decay = _e92.decay, _e92.castShadow) {
            var _t131 = _e92.shadow,
                _n103 = i.get(_e92);

            _n103.shadowBias = _t131.bias, _n103.shadowNormalBias = _t131.normalBias, _n103.shadowRadius = _t131.radius, _n103.shadowMapSize = _t131.mapSize, _n103.shadowCameraNear = _t131.camera.near, _n103.shadowCameraFar = _t131.camera.far, r.pointShadow[h] = _n103, r.pointShadowMap[h] = _x2, r.pointShadowMatrix[h] = _e92.shadow.matrix, m++;
          }

          r.point[h] = _t130, h++;
        } else if (_e92.isHemisphereLight) {
          var _t132 = n.get(_e92);

          _t132.skyColor.copy(_e92.color).multiplyScalar(_v4), _t132.groundColor.copy(_e92.groundColor).multiplyScalar(_v4), r.hemi[p] = _t132, p++;
        }
      }

      d > 0 && (e.isWebGL2 || !0 === t.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = Xn.LTC_FLOAT_1, r.rectAreaLTC2 = Xn.LTC_FLOAT_2) : !0 === t.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = Xn.LTC_HALF_1, r.rectAreaLTC2 = Xn.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = a, r.ambient[1] = o, r.ambient[2] = l;
      var f = r.hash;
      f.directionalLength === c && f.pointLength === h && f.spotLength === u && f.rectAreaLength === d && f.hemiLength === p && f.numDirectionalShadows === A && f.numPointShadows === m && f.numSpotShadows === g || (r.directional.length = c, r.spot.length = u, r.rectArea.length = d, r.point.length = h, r.hemi.length = p, r.directionalShadow.length = A, r.directionalShadowMap.length = A, r.pointShadow.length = m, r.pointShadowMap.length = m, r.spotShadow.length = g, r.spotShadowMap.length = g, r.directionalShadowMatrix.length = A, r.pointShadowMatrix.length = m, r.spotShadowMatrix.length = g, f.directionalLength = c, f.pointLength = h, f.spotLength = u, f.rectAreaLength = d, f.hemiLength = p, f.numDirectionalShadows = A, f.numPointShadows = m, f.numSpotShadows = g, r.version = fs++);
    },
    setupView: function setupView(t, e) {
      var n = 0,
          i = 0,
          l = 0,
          c = 0,
          h = 0;
      var u = e.matrixWorldInverse;

      for (var _e93 = 0, _d8 = t.length; _e93 < _d8; _e93++) {
        var _d9 = t[_e93];

        if (_d9.isDirectionalLight) {
          var _t133 = r.directional[n];
          _t133.direction.setFromMatrixPosition(_d9.matrixWorld), s.setFromMatrixPosition(_d9.target.matrixWorld), _t133.direction.sub(s), _t133.direction.transformDirection(u), n++;
        } else if (_d9.isSpotLight) {
          var _t134 = r.spot[l];
          _t134.position.setFromMatrixPosition(_d9.matrixWorld), _t134.position.applyMatrix4(u), _t134.direction.setFromMatrixPosition(_d9.matrixWorld), s.setFromMatrixPosition(_d9.target.matrixWorld), _t134.direction.sub(s), _t134.direction.transformDirection(u), l++;
        } else if (_d9.isRectAreaLight) {
          var _t135 = r.rectArea[c];
          _t135.position.setFromMatrixPosition(_d9.matrixWorld), _t135.position.applyMatrix4(u), o.identity(), a.copy(_d9.matrixWorld), a.premultiply(u), o.extractRotation(a), _t135.halfWidth.set(.5 * _d9.width, 0, 0), _t135.halfHeight.set(0, .5 * _d9.height, 0), _t135.halfWidth.applyMatrix4(o), _t135.halfHeight.applyMatrix4(o), c++;
        } else if (_d9.isPointLight) {
          var _t136 = r.point[i];
          _t136.position.setFromMatrixPosition(_d9.matrixWorld), _t136.position.applyMatrix4(u), i++;
        } else if (_d9.isHemisphereLight) {
          var _t137 = r.hemi[h];
          _t137.direction.setFromMatrixPosition(_d9.matrixWorld), _t137.direction.transformDirection(u), _t137.direction.normalize(), h++;
        }
      }
    },
    state: r
  };
}

function xs(t, e) {
  var n = new ys(t, e),
      i = [],
      r = [];
  return {
    init: function init() {
      i.length = 0, r.length = 0;
    },
    state: {
      lightsArray: i,
      shadowsArray: r,
      lights: n
    },
    setupLights: function setupLights() {
      n.setup(i);
    },
    setupLightsView: function setupLightsView(t) {
      n.setupView(i, t);
    },
    pushLight: function pushLight(t) {
      i.push(t);
    },
    pushShadow: function pushShadow(t) {
      r.push(t);
    }
  };
}

function ws(t, e) {
  var n = new WeakMap();
  return {
    get: function get(i) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var s;
      return !1 === n.has(i) ? (s = new xs(t, e), n.set(i, [s])) : r >= n.get(i).length ? (s = new xs(t, e), n.get(i).push(s)) : s = n.get(i)[r], s;
    },
    dispose: function dispose() {
      n = new WeakMap();
    }
  };
}

var Es = /*#__PURE__*/function (_ke3) {
  _inherits(Es, _ke3);

  var _super28 = _createSuper(Es);

  function Es(t) {
    var _this30;

    _classCallCheck(this, Es);

    _this30 = _super28.call(this), _this30.type = "MeshDepthMaterial", _this30.depthPacking = 3200, _this30.map = null, _this30.alphaMap = null, _this30.displacementMap = null, _this30.displacementScale = 1, _this30.displacementBias = 0, _this30.wireframe = !1, _this30.wireframeLinewidth = 1, _this30.fog = !1, _this30.setValues(t);
    return _this30;
  }

  _createClass(Es, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Es.prototype), "copy", this).call(this, t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
  }]);

  return Es;
}(ke);

Es.prototype.isMeshDepthMaterial = !0;

var bs = /*#__PURE__*/function (_ke4) {
  _inherits(bs, _ke4);

  var _super29 = _createSuper(bs);

  function bs(t) {
    var _this31;

    _classCallCheck(this, bs);

    _this31 = _super29.call(this), _this31.type = "MeshDistanceMaterial", _this31.referencePosition = new _t(), _this31.nearDistance = 1, _this31.farDistance = 1e3, _this31.map = null, _this31.alphaMap = null, _this31.displacementMap = null, _this31.displacementScale = 1, _this31.displacementBias = 0, _this31.fog = !1, _this31.setValues(t);
    return _this31;
  }

  _createClass(bs, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(bs.prototype), "copy", this).call(this, t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
  }]);

  return bs;
}(ke);

bs.prototype.isMeshDistanceMaterial = !0;

function _s(t, e, n) {
  var i = new Wn();
  var r = new pt(),
      s = new pt(),
      a = new xt(),
      o = new Es({
    depthPacking: 3201
  }),
      l = new bs(),
      c = {},
      h = n.maxTextureSize,
      u = {
    0: 1,
    1: 0,
    2: 2
  },
      d = new Dn({
    defines: {
      SAMPLE_RATE: 2 / 8,
      HALF_SAMPLE_RATE: 1 / 8
    },
    uniforms: {
      shadow_pass: {
        value: null
      },
      resolution: {
        value: new pt()
      },
      radius: {
        value: 4
      }
    },
    vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
    fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
  }),
      p = d.clone();
  p.defines.HORIZONTAL_PASS = 1;
  var A = new cn();
  A.setAttribute("position", new Xe(new Float32Array([-1, -1, .5, 3, -1, .5, -1, 3, .5]), 3));
  var m = new Mn(A, d),
      g = this;

  function f(n, i) {
    var r = e.update(m);
    d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, t.setRenderTarget(n.mapPass), t.clear(), t.renderBufferDirect(i, null, r, d, m, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, t.setRenderTarget(n.map), t.clear(), t.renderBufferDirect(i, null, r, p, m, null);
  }

  function v(e, n, i, r, s, a, h) {
    var d = null;
    var p = !0 === r.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;

    if (d = void 0 !== p ? p : !0 === r.isPointLight ? l : o, t.localClippingEnabled && !0 === i.clipShadows && 0 !== i.clippingPlanes.length) {
      var _t138 = d.uuid,
          _e94 = i.uuid;
      var _n104 = c[_t138];
      void 0 === _n104 && (_n104 = {}, c[_t138] = _n104);
      var _r62 = _n104[_e94];
      void 0 === _r62 && (_r62 = d.clone(), _n104[_e94] = _r62), d = _r62;
    }

    return d.visible = i.visible, d.wireframe = i.wireframe, d.side = 3 === h ? null !== i.shadowSide ? i.shadowSide : i.side : null !== i.shadowSide ? i.shadowSide : u[i.side], d.clipShadows = i.clipShadows, d.clippingPlanes = i.clippingPlanes, d.clipIntersection = i.clipIntersection, d.wireframeLinewidth = i.wireframeLinewidth, d.linewidth = i.linewidth, !0 === r.isPointLight && !0 === d.isMeshDistanceMaterial && (d.referencePosition.setFromMatrixPosition(r.matrixWorld), d.nearDistance = s, d.farDistance = a), d;
  }

  function y(n, r, s, a, o) {
    if (!1 === n.visible) return;

    if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && 3 === o) && (!n.frustumCulled || i.intersectsObject(n))) {
      n.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, n.matrixWorld);

      var _i89 = e.update(n),
          _r63 = n.material;

      if (Array.isArray(_r63)) {
        var _e95 = _i89.groups;

        for (var _l15 = 0, _c11 = _e95.length; _l15 < _c11; _l15++) {
          var _c12 = _e95[_l15],
              _h8 = _r63[_c12.materialIndex];

          if (_h8 && _h8.visible) {
            var _e96 = v(n, 0, _h8, a, s.near, s.far, o);

            t.renderBufferDirect(s, null, _i89, _e96, n, _c12);
          }
        }
      } else if (_r63.visible) {
        var _e97 = v(n, 0, _r63, a, s.near, s.far, o);

        t.renderBufferDirect(s, null, _i89, _e97, n, null);
      }
    }

    var l = n.children;

    for (var _t139 = 0, _e98 = l.length; _t139 < _e98; _t139++) {
      y(l[_t139], r, s, a, o);
    }
  }

  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1, this.render = function (e, n, o) {
    if (!1 === g.enabled) return;
    if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
    if (0 === e.length) return;
    var l = t.getRenderTarget(),
        c = t.getActiveCubeFace(),
        u = t.getActiveMipmapLevel(),
        d = t.state;
    d.setBlending(0), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);

    for (var _l16 = 0, _c13 = e.length; _l16 < _c13; _l16++) {
      var _c14 = e[_l16],
          _u10 = _c14.shadow;

      if (void 0 === _u10) {
        console.warn("THREE.WebGLShadowMap:", _c14, "has no shadow.");
        continue;
      }

      if (!1 === _u10.autoUpdate && !1 === _u10.needsUpdate) continue;
      r.copy(_u10.mapSize);

      var _p8 = _u10.getFrameExtents();

      if (r.multiply(_p8), s.copy(_u10.mapSize), (r.x > h || r.y > h) && (r.x > h && (s.x = Math.floor(h / _p8.x), r.x = s.x * _p8.x, _u10.mapSize.x = s.x), r.y > h && (s.y = Math.floor(h / _p8.y), r.y = s.y * _p8.y, _u10.mapSize.y = s.y)), null === _u10.map && !_u10.isPointLightShadow && 3 === this.type) {
        var _t140 = {
          minFilter: 1006,
          magFilter: 1006,
          format: 1023
        };
        _u10.map = new wt(r.x, r.y, _t140), _u10.map.texture.name = _c14.name + ".shadowMap", _u10.mapPass = new wt(r.x, r.y, _t140), _u10.camera.updateProjectionMatrix();
      }

      if (null === _u10.map) {
        var _t141 = {
          minFilter: 1003,
          magFilter: 1003,
          format: 1023
        };
        _u10.map = new wt(r.x, r.y, _t141), _u10.map.texture.name = _c14.name + ".shadowMap", _u10.camera.updateProjectionMatrix();
      }

      t.setRenderTarget(_u10.map), t.clear();

      var _A5 = _u10.getViewportCount();

      for (var _t142 = 0; _t142 < _A5; _t142++) {
        var _e99 = _u10.getViewport(_t142);

        a.set(s.x * _e99.x, s.y * _e99.y, s.x * _e99.z, s.y * _e99.w), d.viewport(a), _u10.updateMatrices(_c14, _t142), i = _u10.getFrustum(), y(n, o, _u10.camera, _c14, this.type);
      }

      _u10.isPointLightShadow || 3 !== this.type || f(_u10, o), _u10.needsUpdate = !1;
    }

    g.needsUpdate = !1, t.setRenderTarget(l, c, u);
  };
}

function Is(t, e, n) {
  var i = n.isWebGL2;
  var r = new function () {
    var e = !1;
    var n = new xt();
    var i = null;
    var r = new xt(0, 0, 0, 0);
    return {
      setMask: function setMask(n) {
        i === n || e || (t.colorMask(n, n, n, n), i = n);
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e, i, s, a, o) {
        !0 === o && (e *= a, i *= a, s *= a), n.set(e, i, s, a), !1 === r.equals(n) && (t.clearColor(e, i, s, a), r.copy(n));
      },
      reset: function reset() {
        e = !1, i = null, r.set(-1, 0, 0, 0);
      }
    };
  }(),
      s = new function () {
    var e = !1,
        n = null,
        i = null,
        r = null;
    return {
      setTest: function setTest(t) {
        t ? N(2929) : U(2929);
      },
      setMask: function setMask(i) {
        n === i || e || (t.depthMask(i), n = i);
      },
      setFunc: function setFunc(e) {
        if (i !== e) {
          if (e) switch (e) {
            case 0:
              t.depthFunc(512);
              break;

            case 1:
              t.depthFunc(519);
              break;

            case 2:
              t.depthFunc(513);
              break;

            case 3:
              t.depthFunc(515);
              break;

            case 4:
              t.depthFunc(514);
              break;

            case 5:
              t.depthFunc(518);
              break;

            case 6:
              t.depthFunc(516);
              break;

            case 7:
              t.depthFunc(517);
              break;

            default:
              t.depthFunc(515);
          } else t.depthFunc(515);
          i = e;
        }
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e) {
        r !== e && (t.clearDepth(e), r = e);
      },
      reset: function reset() {
        e = !1, n = null, i = null, r = null;
      }
    };
  }(),
      a = new function () {
    var e = !1,
        n = null,
        i = null,
        r = null,
        s = null,
        a = null,
        o = null,
        l = null,
        c = null;
    return {
      setTest: function setTest(t) {
        e || (t ? N(2960) : U(2960));
      },
      setMask: function setMask(i) {
        n === i || e || (t.stencilMask(i), n = i);
      },
      setFunc: function setFunc(e, n, a) {
        i === e && r === n && s === a || (t.stencilFunc(e, n, a), i = e, r = n, s = a);
      },
      setOp: function setOp(e, n, i) {
        a === e && o === n && l === i || (t.stencilOp(e, n, i), a = e, o = n, l = i);
      },
      setLocked: function setLocked(t) {
        e = t;
      },
      setClear: function setClear(e) {
        c !== e && (t.clearStencil(e), c = e);
      },
      reset: function reset() {
        e = !1, n = null, i = null, r = null, s = null, a = null, o = null, l = null, c = null;
      }
    };
  }();
  var o = {},
      l = null,
      c = {},
      h = null,
      u = !1,
      d = null,
      p = null,
      A = null,
      m = null,
      g = null,
      f = null,
      v = null,
      y = !1,
      x = null,
      w = null,
      E = null,
      b = null,
      _ = null;
  var I = t.getParameter(35661);
  var C = !1,
      M = 0;
  var S = t.getParameter(7938);
  -1 !== S.indexOf("WebGL") ? (M = parseFloat(/^WebGL (\d)/.exec(S)[1]), C = M >= 1) : -1 !== S.indexOf("OpenGL ES") && (M = parseFloat(/^OpenGL ES (\d)/.exec(S)[1]), C = M >= 2);
  var B = null,
      T = {};
  var L = t.getParameter(3088),
      R = t.getParameter(2978),
      D = new xt().fromArray(L),
      Q = new xt().fromArray(R);

  function P(e, n, i) {
    var r = new Uint8Array(4),
        s = t.createTexture();
    t.bindTexture(e, s), t.texParameteri(e, 10241, 9728), t.texParameteri(e, 10240, 9728);

    for (var _e100 = 0; _e100 < i; _e100++) {
      t.texImage2D(n + _e100, 0, 6408, 1, 1, 0, 6408, 5121, r);
    }

    return s;
  }

  var F = {};

  function N(e) {
    !0 !== o[e] && (t.enable(e), o[e] = !0);
  }

  function U(e) {
    !1 !== o[e] && (t.disable(e), o[e] = !1);
  }

  F[3553] = P(3553, 3553, 1), F[34067] = P(34067, 34069, 6), r.setClear(0, 0, 0, 1), s.setClear(1), a.setClear(0), N(2929), s.setFunc(3), H(!1), z(1), N(2884), O(0);
  var k = {
    100: 32774,
    101: 32778,
    102: 32779
  };
  if (i) k[103] = 32775, k[104] = 32776;else {
    var _t143 = e.get("EXT_blend_minmax");

    null !== _t143 && (k[103] = _t143.MIN_EXT, k[104] = _t143.MAX_EXT);
  }
  var G = {
    200: 0,
    201: 1,
    202: 768,
    204: 770,
    210: 776,
    208: 774,
    206: 772,
    203: 769,
    205: 771,
    209: 775,
    207: 773
  };

  function O(e, n, i, r, s, a, o, l) {
    if (0 !== e) {
      if (!1 === u && (N(3042), u = !0), 5 === e) s = s || n, a = a || i, o = o || r, n === p && s === g || (t.blendEquationSeparate(k[n], k[s]), p = n, g = s), i === A && r === m && a === f && o === v || (t.blendFuncSeparate(G[i], G[r], G[a], G[o]), A = i, m = r, f = a, v = o), d = e, y = null;else if (e !== d || l !== y) {
        if (100 === p && 100 === g || (t.blendEquation(32774), p = 100, g = 100), l) switch (e) {
          case 1:
            t.blendFuncSeparate(1, 771, 1, 771);
            break;

          case 2:
            t.blendFunc(1, 1);
            break;

          case 3:
            t.blendFuncSeparate(0, 0, 769, 771);
            break;

          case 4:
            t.blendFuncSeparate(0, 768, 0, 770);
            break;

          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        } else switch (e) {
          case 1:
            t.blendFuncSeparate(770, 771, 1, 771);
            break;

          case 2:
            t.blendFunc(770, 1);
            break;

          case 3:
            t.blendFunc(0, 769);
            break;

          case 4:
            t.blendFunc(0, 768);
            break;

          default:
            console.error("THREE.WebGLState: Invalid blending: ", e);
        }
        A = null, m = null, f = null, v = null, d = e, y = l;
      }
    } else !0 === u && (U(3042), u = !1);
  }

  function H(e) {
    x !== e && (e ? t.frontFace(2304) : t.frontFace(2305), x = e);
  }

  function z(e) {
    0 !== e ? (N(2884), e !== w && (1 === e ? t.cullFace(1029) : 2 === e ? t.cullFace(1028) : t.cullFace(1032))) : U(2884), w = e;
  }

  function V(e, n, i) {
    e ? (N(32823), b === n && _ === i || (t.polygonOffset(n, i), b = n, _ = i)) : U(32823);
  }

  function W(e) {
    void 0 === e && (e = 33984 + I - 1), B !== e && (t.activeTexture(e), B = e);
  }

  return {
    buffers: {
      color: r,
      depth: s,
      stencil: a
    },
    enable: N,
    disable: U,
    bindFramebuffer: function bindFramebuffer(e, n) {
      return null === n && null !== l && (n = l), c[e] !== n && (t.bindFramebuffer(e, n), c[e] = n, i && (36009 === e && (c[36160] = n), 36160 === e && (c[36009] = n)), !0);
    },
    bindXRFramebuffer: function bindXRFramebuffer(e) {
      e !== l && (t.bindFramebuffer(36160, e), l = e);
    },
    useProgram: function useProgram(e) {
      return h !== e && (t.useProgram(e), h = e, !0);
    },
    setBlending: O,
    setMaterial: function setMaterial(t, e) {
      2 === t.side ? U(2884) : N(2884);
      var n = 1 === t.side;
      e && (n = !n), H(n), 1 === t.blending && !1 === t.transparent ? O(0) : O(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha), s.setFunc(t.depthFunc), s.setTest(t.depthTest), s.setMask(t.depthWrite), r.setMask(t.colorWrite);
      var i = t.stencilWrite;
      a.setTest(i), i && (a.setMask(t.stencilWriteMask), a.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), a.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), V(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? N(32926) : U(32926);
    },
    setFlipSided: H,
    setCullFace: z,
    setLineWidth: function setLineWidth(e) {
      e !== E && (C && t.lineWidth(e), E = e);
    },
    setPolygonOffset: V,
    setScissorTest: function setScissorTest(t) {
      t ? N(3089) : U(3089);
    },
    activeTexture: W,
    bindTexture: function bindTexture(e, n) {
      null === B && W();
      var i = T[B];
      void 0 === i && (i = {
        type: void 0,
        texture: void 0
      }, T[B] = i), i.type === e && i.texture === n || (t.bindTexture(e, n || F[e]), i.type = e, i.texture = n);
    },
    unbindTexture: function unbindTexture() {
      var e = T[B];
      void 0 !== e && void 0 !== e.type && (t.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
    },
    compressedTexImage2D: function compressedTexImage2D() {
      try {
        t.compressedTexImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texImage2D: function texImage2D() {
      try {
        t.texImage2D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    texImage3D: function texImage3D() {
      try {
        t.texImage3D.apply(t, arguments);
      } catch (t) {
        console.error("THREE.WebGLState:", t);
      }
    },
    scissor: function scissor(e) {
      !1 === D.equals(e) && (t.scissor(e.x, e.y, e.z, e.w), D.copy(e));
    },
    viewport: function viewport(e) {
      !1 === Q.equals(e) && (t.viewport(e.x, e.y, e.z, e.w), Q.copy(e));
    },
    reset: function reset() {
      t.disable(3042), t.disable(2884), t.disable(2929), t.disable(32823), t.disable(3089), t.disable(2960), t.disable(32926), t.blendEquation(32774), t.blendFunc(1, 0), t.blendFuncSeparate(1, 0, 1, 0), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(513), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(519, 0, 4294967295), t.stencilOp(7680, 7680, 7680), t.clearStencil(0), t.cullFace(1029), t.frontFace(2305), t.polygonOffset(0, 0), t.activeTexture(33984), t.bindFramebuffer(36160, null), !0 === i && (t.bindFramebuffer(36009, null), t.bindFramebuffer(36008, null)), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), o = {}, B = null, T = {}, l = null, c = {}, h = null, u = !1, d = null, p = null, A = null, m = null, g = null, f = null, v = null, y = !1, x = null, w = null, E = null, b = null, _ = null, D.set(0, 0, t.canvas.width, t.canvas.height), Q.set(0, 0, t.canvas.width, t.canvas.height), r.reset(), s.reset(), a.reset();
    }
  };
}

function Cs(t, e, n, i, r, s, a) {
  var o = r.isWebGL2,
      l = r.maxTextures,
      c = r.maxCubemapSize,
      h = r.maxTextureSize,
      u = r.maxSamples,
      d = new WeakMap();
  var p,
      A = !1;

  try {
    A = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
  } catch (t) {}

  function m(t, e) {
    return A ? new OffscreenCanvas(t, e) : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  }

  function g(t, e, n, i) {
    var r = 1;

    if ((t.width > i || t.height > i) && (r = i / Math.max(t.width, t.height)), r < 1 || !0 === e) {
      if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
        var _i90 = e ? ut : Math.floor,
            _s38 = _i90(r * t.width),
            _a25 = _i90(r * t.height);

        void 0 === p && (p = m(_s38, _a25));

        var _o18 = n ? m(_s38, _a25) : p;

        _o18.width = _s38, _o18.height = _a25;
        return _o18.getContext("2d").drawImage(t, 0, 0, _s38, _a25), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t.width + "x" + t.height + ") to (" + _s38 + "x" + _a25 + ")."), _o18;
      }

      return "data" in t && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t.width + "x" + t.height + ")."), t;
    }

    return t;
  }

  function f(t) {
    return ct(t.width) && ct(t.height);
  }

  function v(t, e) {
    return t.generateMipmaps && e && 1003 !== t.minFilter && 1006 !== t.minFilter;
  }

  function y(e, n, r, s) {
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    t.generateMipmap(e);
    i.get(n).__maxMipLevel = Math.log2(Math.max(r, s, a));
  }

  function x(n, i, r) {
    if (!1 === o) return i;

    if (null !== n) {
      if (void 0 !== t[n]) return t[n];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
    }

    var s = i;
    return 6403 === i && (5126 === r && (s = 33326), 5131 === r && (s = 33325), 5121 === r && (s = 33321)), 6407 === i && (5126 === r && (s = 34837), 5131 === r && (s = 34843), 5121 === r && (s = 32849)), 6408 === i && (5126 === r && (s = 34836), 5131 === r && (s = 34842), 5121 === r && (s = 32856)), 33325 !== s && 33326 !== s && 34842 !== s && 34836 !== s || e.get("EXT_color_buffer_float"), s;
  }

  function w(t) {
    return 1003 === t || 1004 === t || 1005 === t ? 9728 : 9729;
  }

  function E(e) {
    var n = e.target;
    n.removeEventListener("dispose", E), function (e) {
      var n = i.get(e);
      if (void 0 === n.__webglInit) return;
      t.deleteTexture(n.__webglTexture), i.remove(e);
    }(n), n.isVideoTexture && d.delete(n), a.memory.textures--;
  }

  function b(e) {
    var n = e.target;
    n.removeEventListener("dispose", b), function (e) {
      var n = e.texture,
          r = i.get(e),
          s = i.get(n);
      if (!e) return;
      void 0 !== s.__webglTexture && (t.deleteTexture(s.__webglTexture), a.memory.textures--);
      e.depthTexture && e.depthTexture.dispose();
      if (e.isWebGLCubeRenderTarget) for (var _e101 = 0; _e101 < 6; _e101++) {
        t.deleteFramebuffer(r.__webglFramebuffer[_e101]), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer[_e101]);
      } else t.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && t.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer && t.deleteRenderbuffer(r.__webglColorRenderbuffer), r.__webglDepthRenderbuffer && t.deleteRenderbuffer(r.__webglDepthRenderbuffer);
      if (e.isWebGLMultipleRenderTargets) for (var _e102 = 0, _r64 = n.length; _e102 < _r64; _e102++) {
        var _r65 = i.get(n[_e102]);

        _r65.__webglTexture && (t.deleteTexture(_r65.__webglTexture), a.memory.textures--), i.remove(n[_e102]);
      }
      i.remove(n), i.remove(e);
    }(n);
  }

  var _ = 0;

  function I(t, e) {
    var r = i.get(t);

    if (t.isVideoTexture && function (t) {
      var e = a.render.frame;
      d.get(t) !== e && (d.set(t, e), t.update());
    }(t), t.version > 0 && r.__version !== t.version) {
      var _n105 = t.image;
      if (void 0 === _n105) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");else {
        if (!1 !== _n105.complete) return void L(r, t, e);
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      }
    }

    n.activeTexture(33984 + e), n.bindTexture(3553, r.__webglTexture);
  }

  function C(e, r) {
    var a = i.get(e);
    e.version > 0 && a.__version !== e.version ? function (e, i, r) {
      if (6 !== i.image.length) return;
      T(e, i), n.activeTexture(33984 + r), n.bindTexture(34067, e.__webglTexture), t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);
      var a = i && (i.isCompressedTexture || i.image[0].isCompressedTexture),
          l = i.image[0] && i.image[0].isDataTexture,
          h = [];

      for (var _t144 = 0; _t144 < 6; _t144++) {
        h[_t144] = a || l ? l ? i.image[_t144].image : i.image[_t144] : g(i.image[_t144], !1, !0, c);
      }

      var u = h[0],
          d = f(u) || o,
          p = s.convert(i.format),
          A = s.convert(i.type),
          m = x(i.internalFormat, p, A);
      var w;

      if (B(34067, i, d), a) {
        for (var _t145 = 0; _t145 < 6; _t145++) {
          w = h[_t145].mipmaps;

          for (var _e103 = 0; _e103 < w.length; _e103++) {
            var _r66 = w[_e103];
            1023 !== i.format && 1022 !== i.format ? null !== p ? n.compressedTexImage2D(34069 + _t145, _e103, m, _r66.width, _r66.height, 0, _r66.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : n.texImage2D(34069 + _t145, _e103, m, _r66.width, _r66.height, 0, p, A, _r66.data);
          }
        }

        e.__maxMipLevel = w.length - 1;
      } else {
        w = i.mipmaps;

        for (var _t146 = 0; _t146 < 6; _t146++) {
          if (l) {
            n.texImage2D(34069 + _t146, 0, m, h[_t146].width, h[_t146].height, 0, p, A, h[_t146].data);

            for (var _e104 = 0; _e104 < w.length; _e104++) {
              var _i91 = w[_e104].image[_t146].image;
              n.texImage2D(34069 + _t146, _e104 + 1, m, _i91.width, _i91.height, 0, p, A, _i91.data);
            }
          } else {
            n.texImage2D(34069 + _t146, 0, m, p, A, h[_t146]);

            for (var _e105 = 0; _e105 < w.length; _e105++) {
              var _i92 = w[_e105];
              n.texImage2D(34069 + _t146, _e105 + 1, m, p, A, _i92.image[_t146]);
            }
          }
        }

        e.__maxMipLevel = w.length;
      }

      v(i, d) && y(34067, i, u.width, u.height);
      e.__version = i.version, i.onUpdate && i.onUpdate(i);
    }(a, e, r) : (n.activeTexture(33984 + r), n.bindTexture(34067, a.__webglTexture));
  }

  var M = {
    1e3: 10497,
    1001: 33071,
    1002: 33648
  },
      S = {
    1003: 9728,
    1004: 9984,
    1005: 9986,
    1006: 9729,
    1007: 9985,
    1008: 9987
  };

  function B(n, s, a) {
    if (a ? (t.texParameteri(n, 10242, M[s.wrapS]), t.texParameteri(n, 10243, M[s.wrapT]), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, M[s.wrapR]), t.texParameteri(n, 10240, S[s.magFilter]), t.texParameteri(n, 10241, S[s.minFilter])) : (t.texParameteri(n, 10242, 33071), t.texParameteri(n, 10243, 33071), 32879 !== n && 35866 !== n || t.texParameteri(n, 32882, 33071), 1001 === s.wrapS && 1001 === s.wrapT || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t.texParameteri(n, 10240, w(s.magFilter)), t.texParameteri(n, 10241, w(s.minFilter)), 1003 !== s.minFilter && 1006 !== s.minFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), !0 === e.has("EXT_texture_filter_anisotropic")) {
      var _a26 = e.get("EXT_texture_filter_anisotropic");

      if (1015 === s.type && !1 === e.has("OES_texture_float_linear")) return;
      if (!1 === o && 1016 === s.type && !1 === e.has("OES_texture_half_float_linear")) return;
      (s.anisotropy > 1 || i.get(s).__currentAnisotropy) && (t.texParameterf(n, _a26.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(s.anisotropy, r.getMaxAnisotropy())), i.get(s).__currentAnisotropy = s.anisotropy);
    }
  }

  function T(e, n) {
    void 0 === e.__webglInit && (e.__webglInit = !0, n.addEventListener("dispose", E), e.__webglTexture = t.createTexture(), a.memory.textures++);
  }

  function L(e, i, r) {
    var a = 3553;
    i.isDataTexture2DArray && (a = 35866), i.isDataTexture3D && (a = 32879), T(e, i), n.activeTexture(33984 + r), n.bindTexture(a, e.__webglTexture), t.pixelStorei(37440, i.flipY), t.pixelStorei(37441, i.premultiplyAlpha), t.pixelStorei(3317, i.unpackAlignment), t.pixelStorei(37443, 0);

    var l = function (t) {
      return !o && (1001 !== t.wrapS || 1001 !== t.wrapT || 1003 !== t.minFilter && 1006 !== t.minFilter);
    }(i) && !1 === f(i.image),
        c = g(i.image, l, !1, h),
        u = f(c) || o,
        d = s.convert(i.format);

    var p,
        A = s.convert(i.type),
        m = x(i.internalFormat, d, A);
    B(a, i, u);
    var w = i.mipmaps;
    if (i.isDepthTexture) m = 6402, o ? m = 1015 === i.type ? 36012 : 1014 === i.type ? 33190 : 1020 === i.type ? 35056 : 33189 : 1015 === i.type && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), 1026 === i.format && 6402 === m && 1012 !== i.type && 1014 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), i.type = 1012, A = s.convert(i.type)), 1027 === i.format && 6402 === m && (m = 34041, 1020 !== i.type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), i.type = 1020, A = s.convert(i.type))), n.texImage2D(3553, 0, m, c.width, c.height, 0, d, A, null);else if (i.isDataTexture) {
      if (w.length > 0 && u) {
        for (var _t147 = 0, _e106 = w.length; _t147 < _e106; _t147++) {
          p = w[_t147], n.texImage2D(3553, _t147, m, p.width, p.height, 0, d, A, p.data);
        }

        i.generateMipmaps = !1, e.__maxMipLevel = w.length - 1;
      } else n.texImage2D(3553, 0, m, c.width, c.height, 0, d, A, c.data), e.__maxMipLevel = 0;
    } else if (i.isCompressedTexture) {
      for (var _t148 = 0, _e107 = w.length; _t148 < _e107; _t148++) {
        p = w[_t148], 1023 !== i.format && 1022 !== i.format ? null !== d ? n.compressedTexImage2D(3553, _t148, m, p.width, p.height, 0, p.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : n.texImage2D(3553, _t148, m, p.width, p.height, 0, d, A, p.data);
      }

      e.__maxMipLevel = w.length - 1;
    } else if (i.isDataTexture2DArray) n.texImage3D(35866, 0, m, c.width, c.height, c.depth, 0, d, A, c.data), e.__maxMipLevel = 0;else if (i.isDataTexture3D) n.texImage3D(32879, 0, m, c.width, c.height, c.depth, 0, d, A, c.data), e.__maxMipLevel = 0;else if (w.length > 0 && u) {
      for (var _t149 = 0, _e108 = w.length; _t149 < _e108; _t149++) {
        p = w[_t149], n.texImage2D(3553, _t149, m, d, A, p);
      }

      i.generateMipmaps = !1, e.__maxMipLevel = w.length - 1;
    } else n.texImage2D(3553, 0, m, d, A, c), e.__maxMipLevel = 0;
    v(i, u) && y(a, i, c.width, c.height), e.__version = i.version, i.onUpdate && i.onUpdate(i);
  }

  function R(e, r, a, o, l) {
    var c = s.convert(a.format),
        h = s.convert(a.type),
        u = x(a.internalFormat, c, h);
    32879 === l || 35866 === l ? n.texImage3D(l, 0, u, r.width, r.height, r.depth, 0, c, h, null) : n.texImage2D(l, 0, u, r.width, r.height, 0, c, h, null), n.bindFramebuffer(36160, e), t.framebufferTexture2D(36160, o, l, i.get(a).__webglTexture, 0), n.bindFramebuffer(36160, null);
  }

  function D(e, n, i) {
    if (t.bindRenderbuffer(36161, e), n.depthBuffer && !n.stencilBuffer) {
      var _r67 = 33189;

      if (i) {
        var _e109 = n.depthTexture;
        _e109 && _e109.isDepthTexture && (1015 === _e109.type ? _r67 = 36012 : 1014 === _e109.type && (_r67 = 33190));

        var _i93 = P(n);

        t.renderbufferStorageMultisample(36161, _i93, _r67, n.width, n.height);
      } else t.renderbufferStorage(36161, _r67, n.width, n.height);

      t.framebufferRenderbuffer(36160, 36096, 36161, e);
    } else if (n.depthBuffer && n.stencilBuffer) {
      if (i) {
        var _e110 = P(n);

        t.renderbufferStorageMultisample(36161, _e110, 35056, n.width, n.height);
      } else t.renderbufferStorage(36161, 34041, n.width, n.height);

      t.framebufferRenderbuffer(36160, 33306, 36161, e);
    } else {
      var _e111 = !0 === n.isWebGLMultipleRenderTargets ? n.texture[0] : n.texture,
          _r68 = s.convert(_e111.format),
          _a27 = s.convert(_e111.type),
          _o19 = x(_e111.internalFormat, _r68, _a27);

      if (i) {
        var _e112 = P(n);

        t.renderbufferStorageMultisample(36161, _e112, _o19, n.width, n.height);
      } else t.renderbufferStorage(36161, _o19, n.width, n.height);
    }

    t.bindRenderbuffer(36161, null);
  }

  function Q(e) {
    var r = i.get(e),
        s = !0 === e.isWebGLCubeRenderTarget;

    if (e.depthTexture) {
      if (s) throw new Error("target.depthTexture not supported in Cube render targets");
      !function (e, r) {
        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (n.bindFramebuffer(36160, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), I(r.depthTexture, 0);

        var s = i.get(r.depthTexture).__webglTexture;

        if (1026 === r.depthTexture.format) t.framebufferTexture2D(36160, 36096, 3553, s, 0);else {
          if (1027 !== r.depthTexture.format) throw new Error("Unknown depthTexture format");
          t.framebufferTexture2D(36160, 33306, 3553, s, 0);
        }
      }(r.__webglFramebuffer, e);
    } else if (s) {
      r.__webglDepthbuffer = [];

      for (var _i94 = 0; _i94 < 6; _i94++) {
        n.bindFramebuffer(36160, r.__webglFramebuffer[_i94]), r.__webglDepthbuffer[_i94] = t.createRenderbuffer(), D(r.__webglDepthbuffer[_i94], e, !1);
      }
    } else n.bindFramebuffer(36160, r.__webglFramebuffer), r.__webglDepthbuffer = t.createRenderbuffer(), D(r.__webglDepthbuffer, e, !1);

    n.bindFramebuffer(36160, null);
  }

  function P(t) {
    return o && t.isWebGLMultisampleRenderTarget ? Math.min(u, t.samples) : 0;
  }

  var F = !1,
      N = !1;
  this.allocateTextureUnit = function () {
    var t = _;
    return t >= l && console.warn("THREE.WebGLTextures: Trying to use " + t + " texture units while this GPU supports only " + l), _ += 1, t;
  }, this.resetTextureUnits = function () {
    _ = 0;
  }, this.setTexture2D = I, this.setTexture2DArray = function (t, e) {
    var r = i.get(t);
    t.version > 0 && r.__version !== t.version ? L(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(35866, r.__webglTexture));
  }, this.setTexture3D = function (t, e) {
    var r = i.get(t);
    t.version > 0 && r.__version !== t.version ? L(r, t, e) : (n.activeTexture(33984 + e), n.bindTexture(32879, r.__webglTexture));
  }, this.setTextureCube = C, this.setupRenderTarget = function (e) {
    var l = e.texture,
        c = i.get(e),
        h = i.get(l);
    e.addEventListener("dispose", b), !0 !== e.isWebGLMultipleRenderTargets && (h.__webglTexture = t.createTexture(), h.__version = l.version, a.memory.textures++);
    var u = !0 === e.isWebGLCubeRenderTarget,
        d = !0 === e.isWebGLMultipleRenderTargets,
        p = !0 === e.isWebGLMultisampleRenderTarget,
        A = l.isDataTexture3D || l.isDataTexture2DArray,
        m = f(e) || o;

    if (!o || 1022 !== l.format || 1015 !== l.type && 1016 !== l.type || (l.format = 1023, console.warn("THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.")), u) {
      c.__webglFramebuffer = [];

      for (var _e113 = 0; _e113 < 6; _e113++) {
        c.__webglFramebuffer[_e113] = t.createFramebuffer();
      }
    } else if (c.__webglFramebuffer = t.createFramebuffer(), d) {
      if (r.drawBuffers) {
        var _n106 = e.texture;

        for (var _e114 = 0, _r69 = _n106.length; _e114 < _r69; _e114++) {
          var _r70 = i.get(_n106[_e114]);

          void 0 === _r70.__webglTexture && (_r70.__webglTexture = t.createTexture(), a.memory.textures++);
        }
      } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
    } else if (p) if (o) {
      c.__webglMultisampledFramebuffer = t.createFramebuffer(), c.__webglColorRenderbuffer = t.createRenderbuffer(), t.bindRenderbuffer(36161, c.__webglColorRenderbuffer);

      var _i95 = s.convert(l.format),
          _r71 = s.convert(l.type),
          _a28 = x(l.internalFormat, _i95, _r71),
          _o20 = P(e);

      t.renderbufferStorageMultisample(36161, _o20, _a28, e.width, e.height), n.bindFramebuffer(36160, c.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(36160, 36064, 36161, c.__webglColorRenderbuffer), t.bindRenderbuffer(36161, null), e.depthBuffer && (c.__webglDepthRenderbuffer = t.createRenderbuffer(), D(c.__webglDepthRenderbuffer, e, !0)), n.bindFramebuffer(36160, null);
    } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");

    if (u) {
      n.bindTexture(34067, h.__webglTexture), B(34067, l, m);

      for (var _t150 = 0; _t150 < 6; _t150++) {
        R(c.__webglFramebuffer[_t150], e, l, 36064, 34069 + _t150);
      }

      v(l, m) && y(34067, l, e.width, e.height), n.bindTexture(34067, null);
    } else if (d) {
      var _t151 = e.texture;

      for (var _r72 = 0, _s39 = _t151.length; _r72 < _s39; _r72++) {
        var _s40 = _t151[_r72],
            _a29 = i.get(_s40);

        n.bindTexture(3553, _a29.__webglTexture), B(3553, _s40, m), R(c.__webglFramebuffer, e, _s40, 36064 + _r72, 3553), v(_s40, m) && y(3553, _s40, e.width, e.height);
      }

      n.bindTexture(3553, null);
    } else {
      var _t152 = 3553;
      if (A) if (o) {
        _t152 = l.isDataTexture3D ? 32879 : 35866;
      } else console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
      n.bindTexture(_t152, h.__webglTexture), B(_t152, l, m), R(c.__webglFramebuffer, e, l, 36064, _t152), v(l, m) && y(_t152, l, e.width, e.height, e.depth), n.bindTexture(_t152, null);
    }

    e.depthBuffer && Q(e);
  }, this.updateRenderTargetMipmap = function (t) {
    var e = f(t) || o,
        r = !0 === t.isWebGLMultipleRenderTargets ? t.texture : [t.texture];

    for (var _s41 = 0, _a30 = r.length; _s41 < _a30; _s41++) {
      var _a31 = r[_s41];

      if (v(_a31, e)) {
        var _e115 = t.isWebGLCubeRenderTarget ? 34067 : 3553,
            _r73 = i.get(_a31).__webglTexture;

        n.bindTexture(_e115, _r73), y(_e115, _a31, t.width, t.height), n.bindTexture(_e115, null);
      }
    }
  }, this.updateMultisampleRenderTarget = function (e) {
    if (e.isWebGLMultisampleRenderTarget) if (o) {
      var _r74 = e.width,
          _s42 = e.height;
      var _a32 = 16384;
      e.depthBuffer && (_a32 |= 256), e.stencilBuffer && (_a32 |= 1024);

      var _o21 = i.get(e);

      n.bindFramebuffer(36008, _o21.__webglMultisampledFramebuffer), n.bindFramebuffer(36009, _o21.__webglFramebuffer), t.blitFramebuffer(0, 0, _r74, _s42, 0, 0, _r74, _s42, _a32, 9728), n.bindFramebuffer(36008, null), n.bindFramebuffer(36009, _o21.__webglMultisampledFramebuffer);
    } else console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
  }, this.safeSetTexture2D = function (t, e) {
    t && t.isWebGLRenderTarget && (!1 === F && (console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead."), F = !0), t = t.texture), I(t, e);
  }, this.safeSetTextureCube = function (t, e) {
    t && t.isWebGLCubeRenderTarget && (!1 === N && (console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead."), N = !0), t = t.texture), C(t, e);
  };
}

function Ms(t, e, n) {
  var i = n.isWebGL2;
  return {
    convert: function convert(t) {
      var n;
      if (1009 === t) return 5121;
      if (1017 === t) return 32819;
      if (1018 === t) return 32820;
      if (1019 === t) return 33635;
      if (1010 === t) return 5120;
      if (1011 === t) return 5122;
      if (1012 === t) return 5123;
      if (1013 === t) return 5124;
      if (1014 === t) return 5125;
      if (1015 === t) return 5126;
      if (1016 === t) return i ? 5131 : (n = e.get("OES_texture_half_float"), null !== n ? n.HALF_FLOAT_OES : null);
      if (1021 === t) return 6406;
      if (1022 === t) return 6407;
      if (1023 === t) return 6408;
      if (1024 === t) return 6409;
      if (1025 === t) return 6410;
      if (1026 === t) return 6402;
      if (1027 === t) return 34041;
      if (1028 === t) return 6403;
      if (1029 === t) return 36244;
      if (1030 === t) return 33319;
      if (1031 === t) return 33320;
      if (1032 === t) return 36248;
      if (1033 === t) return 36249;

      if (33776 === t || 33777 === t || 33778 === t || 33779 === t) {
        if (n = e.get("WEBGL_compressed_texture_s3tc"), null === n) return null;
        if (33776 === t) return n.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (33777 === t) return n.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (33778 === t) return n.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (33779 === t) return n.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      }

      if (35840 === t || 35841 === t || 35842 === t || 35843 === t) {
        if (n = e.get("WEBGL_compressed_texture_pvrtc"), null === n) return null;
        if (35840 === t) return n.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (35841 === t) return n.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (35842 === t) return n.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (35843 === t) return n.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      }

      if (36196 === t) return n = e.get("WEBGL_compressed_texture_etc1"), null !== n ? n.COMPRESSED_RGB_ETC1_WEBGL : null;

      if ((37492 === t || 37496 === t) && (n = e.get("WEBGL_compressed_texture_etc"), null !== n)) {
        if (37492 === t) return n.COMPRESSED_RGB8_ETC2;
        if (37496 === t) return n.COMPRESSED_RGBA8_ETC2_EAC;
      }

      return 37808 === t || 37809 === t || 37810 === t || 37811 === t || 37812 === t || 37813 === t || 37814 === t || 37815 === t || 37816 === t || 37817 === t || 37818 === t || 37819 === t || 37820 === t || 37821 === t || 37840 === t || 37841 === t || 37842 === t || 37843 === t || 37844 === t || 37845 === t || 37846 === t || 37847 === t || 37848 === t || 37849 === t || 37850 === t || 37851 === t || 37852 === t || 37853 === t ? (n = e.get("WEBGL_compressed_texture_astc"), null !== n ? t : null) : 36492 === t ? (n = e.get("EXT_texture_compression_bptc"), null !== n ? t : null) : 1020 === t ? i ? 34042 : (n = e.get("WEBGL_depth_texture"), null !== n ? n.UNSIGNED_INT_24_8_WEBGL : null) : void 0;
    }
  };
}

var Ss = /*#__PURE__*/function (_Pn) {
  _inherits(Ss, _Pn);

  var _super30 = _createSuper(Ss);

  function Ss() {
    var _this32;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Ss);

    _this32 = _super30.call(this), _this32.cameras = t;
    return _this32;
  }

  return _createClass(Ss);
}(Pn);

Ss.prototype.isArrayCamera = !0;

var Bs = /*#__PURE__*/function (_Ce4) {
  _inherits(Bs, _Ce4);

  var _super31 = _createSuper(Bs);

  function Bs() {
    var _this33;

    _classCallCheck(this, Bs);

    _this33 = _super31.call(this), _this33.type = "Group";
    return _this33;
  }

  return _createClass(Bs);
}(Ce);

Bs.prototype.isGroup = !0;
var Ts = {
  type: "move"
};

var Ls = /*#__PURE__*/function () {
  function Ls() {
    _classCallCheck(this, Ls);

    this._targetRay = null, this._grip = null, this._hand = null;
  }

  _createClass(Ls, [{
    key: "getHandSpace",
    value: function getHandSpace() {
      return null === this._hand && (this._hand = new Bs(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
        pinching: !1
      }), this._hand;
    }
  }, {
    key: "getTargetRaySpace",
    value: function getTargetRaySpace() {
      return null === this._targetRay && (this._targetRay = new Bs(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new _t(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new _t()), this._targetRay;
    }
  }, {
    key: "getGripSpace",
    value: function getGripSpace() {
      return null === this._grip && (this._grip = new Bs(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new _t(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new _t()), this._grip;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(t) {
      return null !== this._targetRay && this._targetRay.dispatchEvent(t), null !== this._grip && this._grip.dispatchEvent(t), null !== this._hand && this._hand.dispatchEvent(t), this;
    }
  }, {
    key: "disconnect",
    value: function disconnect(t) {
      return this.dispatchEvent({
        type: "disconnected",
        data: t
      }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
  }, {
    key: "update",
    value: function update(t, e, n) {
      var i = null,
          r = null,
          s = null;
      var a = this._targetRay,
          o = this._grip,
          l = this._hand;
      if (t && "visible-blurred" !== e.session.visibilityState) if (null !== a && (i = e.getPose(t.targetRaySpace, n), null !== i && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(Ts))), l && t.hand) {
        s = !0;

        var _iterator5 = _createForOfIteratorHelper(t.hand.values()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _i97 = _step5.value;

            var _t153 = e.getJointPose(_i97, n);

            if (void 0 === l.joints[_i97.jointName]) {
              var _t154 = new Bs();

              _t154.matrixAutoUpdate = !1, _t154.visible = !1, l.joints[_i97.jointName] = _t154, l.add(_t154);
            }

            var _r76 = l.joints[_i97.jointName];
            null !== _t153 && (_r76.matrix.fromArray(_t153.transform.matrix), _r76.matrix.decompose(_r76.position, _r76.rotation, _r76.scale), _r76.jointRadius = _t153.radius), _r76.visible = null !== _t153;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        var _i96 = l.joints["index-finger-tip"],
            _r75 = l.joints["thumb-tip"],
            _a33 = _i96.position.distanceTo(_r75.position),
            _o22 = .02,
            _c15 = .005;

        l.inputState.pinching && _a33 > _o22 + _c15 ? (l.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: t.handedness,
          target: this
        })) : !l.inputState.pinching && _a33 <= _o22 - _c15 && (l.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: t.handedness,
          target: this
        }));
      } else null !== o && t.gripSpace && (r = e.getPose(t.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
      return null !== a && (a.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== s), this;
    }
  }]);

  return Ls;
}();

var Rs = /*#__PURE__*/function (_tt6) {
  _inherits(Rs, _tt6);

  var _super32 = _createSuper(Rs);

  function Rs(t, e) {
    var _this34;

    _classCallCheck(this, Rs);

    _this34 = _super32.call(this);

    var n = _assertThisInitialized(_this34),
        i = t.state;

    var r = null,
        s = 1,
        a = null,
        o = "local-floor",
        l = null,
        c = null,
        h = null,
        u = null,
        d = null;
    var p = [],
        A = new Map(),
        m = new Pn();
    m.layers.enable(1), m.viewport = new xt();
    var g = new Pn();
    g.layers.enable(2), g.viewport = new xt();
    var f = [m, g],
        v = new Ss();
    v.layers.enable(1), v.layers.enable(2);
    var y = null,
        x = null;

    function w(t) {
      var e = A.get(t.inputSource);
      e && e.dispatchEvent({
        type: t.type,
        data: t.inputSource
      });
    }

    function E() {
      A.forEach(function (t, e) {
        t.disconnect(e);
      }), A.clear(), y = null, x = null, i.bindXRFramebuffer(null), t.setRenderTarget(t.getRenderTarget()), S.stop(), n.isPresenting = !1, n.dispatchEvent({
        type: "sessionend"
      });
    }

    function b(t) {
      var e = r.inputSources;

      for (var _t155 = 0; _t155 < p.length; _t155++) {
        A.set(e[_t155], p[_t155]);
      }

      for (var _e116 = 0; _e116 < t.removed.length; _e116++) {
        var _n107 = t.removed[_e116],
            _i98 = A.get(_n107);

        _i98 && (_i98.dispatchEvent({
          type: "disconnected",
          data: _n107
        }), A.delete(_n107));
      }

      for (var _e117 = 0; _e117 < t.added.length; _e117++) {
        var _n108 = t.added[_e117],
            _i99 = A.get(_n108);

        _i99 && _i99.dispatchEvent({
          type: "connected",
          data: _n108
        });
      }
    }

    _this34.cameraAutoUpdate = !0, _this34.enabled = !1, _this34.isPresenting = !1, _this34.getController = function (t) {
      var e = p[t];
      return void 0 === e && (e = new Ls(), p[t] = e), e.getTargetRaySpace();
    }, _this34.getControllerGrip = function (t) {
      var e = p[t];
      return void 0 === e && (e = new Ls(), p[t] = e), e.getGripSpace();
    }, _this34.getHand = function (t) {
      var e = p[t];
      return void 0 === e && (e = new Ls(), p[t] = e), e.getHandSpace();
    }, _this34.setFramebufferScaleFactor = function (t) {
      s = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, _this34.setReferenceSpaceType = function (t) {
      o = t, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, _this34.getReferenceSpace = function () {
      return a;
    }, _this34.getSession = function () {
      return r;
    }, _this34.setSession = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var _t156, _n109, _n110, _n111, _i100;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(r = t, null !== r)) {
                  _context2.next = 21;
                  break;
                }

                r.addEventListener("select", w), r.addEventListener("selectstart", w), r.addEventListener("selectend", w), r.addEventListener("squeeze", w), r.addEventListener("squeezestart", w), r.addEventListener("squeezeend", w), r.addEventListener("end", E), r.addEventListener("inputsourceschange", b);
                _t156 = e.getContextAttributes();
                _context2.t0 = !0 !== _t156.xrCompatible;

                if (!_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return e.makeXRCompatible();

              case 7:
                if (!(void 0 === r.renderState.layers)) {
                  _context2.next = 12;
                  break;
                }

                _n109 = {
                  antialias: _t156.antialias,
                  alpha: _t156.alpha,
                  depth: _t156.depth,
                  stencil: _t156.stencil,
                  framebufferScaleFactor: s
                };
                d = new XRWebGLLayer(r, e, _n109), r.updateRenderState({
                  baseLayer: d
                });
                _context2.next = 14;
                break;

              case 12:
                _n110 = 0;

                if (_t156.antialias) {
                  _n111 = {
                    antialias: !0,
                    alpha: _t156.alpha,
                    depth: _t156.depth,
                    stencil: _t156.stencil,
                    framebufferScaleFactor: s
                  };
                  d = new XRWebGLLayer(r, e, _n111), r.updateRenderState({
                    layers: [d]
                  });
                } else {
                  _t156.depth && (_n110 = _t156.stencil ? 34041 : 6402);
                  _i100 = {
                    colorFormat: _t156.alpha ? 6408 : 6407,
                    depthFormat: _n110,
                    scaleFactor: s
                  };
                  c = new XRWebGLBinding(r, e), u = c.createProjectionLayer(_i100), h = e.createFramebuffer(), r.updateRenderState({
                    layers: [u]
                  });
                }

              case 14:
                _context2.next = 16;
                return r.requestReferenceSpace(o);

              case 16:
                a = _context2.sent;
                S.setContext(r);
                S.start();
                n.isPresenting = !0;
                n.dispatchEvent({
                  type: "sessionstart"
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var _ = new _t(),
        I = new _t();

    function C(t, e) {
      null === e ? t.matrixWorld.copy(t.matrix) : t.matrixWorld.multiplyMatrices(e.matrixWorld, t.matrix), t.matrixWorldInverse.copy(t.matrixWorld).invert();
    }

    _this34.updateCamera = function (t) {
      if (null === r) return;
      v.near = g.near = m.near = t.near, v.far = g.far = m.far = t.far, y === v.near && x === v.far || (r.updateRenderState({
        depthNear: v.near,
        depthFar: v.far
      }), y = v.near, x = v.far);
      var e = t.parent,
          n = v.cameras;
      C(v, e);

      for (var _t157 = 0; _t157 < n.length; _t157++) {
        C(n[_t157], e);
      }

      v.matrixWorld.decompose(v.position, v.quaternion, v.scale), t.position.copy(v.position), t.quaternion.copy(v.quaternion), t.scale.copy(v.scale), t.matrix.copy(v.matrix), t.matrixWorld.copy(v.matrixWorld);
      var i = t.children;

      for (var _t158 = 0, _e118 = i.length; _t158 < _e118; _t158++) {
        i[_t158].updateMatrixWorld(!0);
      }

      2 === n.length ? function (t, e, n) {
        _.setFromMatrixPosition(e.matrixWorld), I.setFromMatrixPosition(n.matrixWorld);

        var i = _.distanceTo(I),
            r = e.projectionMatrix.elements,
            s = n.projectionMatrix.elements,
            a = r[14] / (r[10] - 1),
            o = r[14] / (r[10] + 1),
            l = (r[9] + 1) / r[5],
            c = (r[9] - 1) / r[5],
            h = (r[8] - 1) / r[0],
            u = (s[8] + 1) / s[0],
            d = a * h,
            p = a * u,
            A = i / (-h + u),
            m = A * -h;

        e.matrixWorld.decompose(t.position, t.quaternion, t.scale), t.translateX(m), t.translateZ(A), t.matrixWorld.compose(t.position, t.quaternion, t.scale), t.matrixWorldInverse.copy(t.matrixWorld).invert();
        var g = a + A,
            f = o + A,
            v = d - m,
            y = p + (i - m),
            x = l * o / f * g,
            w = c * o / f * g;
        t.projectionMatrix.makePerspective(v, y, x, w, g, f);
      }(v, m, g) : v.projectionMatrix.copy(m.projectionMatrix);
    }, _this34.getCamera = function () {
      return v;
    }, _this34.getFoveation = function () {
      return null !== u ? u.fixedFoveation : null !== d ? d.fixedFoveation : void 0;
    }, _this34.setFoveation = function (t) {
      null !== u && (u.fixedFoveation = t), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = t);
    };
    var M = null;
    var S = new qn();
    S.setAnimationLoop(function (t, n) {
      if (l = n.getViewerPose(a), null !== l) {
        var _t159 = l.views;
        null !== d && i.bindXRFramebuffer(d.framebuffer);

        var _n112 = !1;

        _t159.length !== v.cameras.length && (v.cameras.length = 0, _n112 = !0);

        for (var _r77 = 0; _r77 < _t159.length; _r77++) {
          var _s43 = _t159[_r77];
          var _a34 = null;
          if (null !== d) _a34 = d.getViewport(_s43);else {
            var _t160 = c.getViewSubImage(u, _s43);

            i.bindXRFramebuffer(h), void 0 !== _t160.depthStencilTexture && e.framebufferTexture2D(36160, 36096, 3553, _t160.depthStencilTexture, 0), e.framebufferTexture2D(36160, 36064, 3553, _t160.colorTexture, 0), _a34 = _t160.viewport;
          }
          var _o23 = f[_r77];
          _o23.matrix.fromArray(_s43.transform.matrix), _o23.projectionMatrix.fromArray(_s43.projectionMatrix), _o23.viewport.set(_a34.x, _a34.y, _a34.width, _a34.height), 0 === _r77 && v.matrix.copy(_o23.matrix), !0 === _n112 && v.cameras.push(_o23);
        }
      }

      var s = r.inputSources;

      for (var _t161 = 0; _t161 < p.length; _t161++) {
        var _e119 = p[_t161],
            _i101 = s[_t161];

        _e119.update(_i101, n, a);
      }

      M && M(t, n);
    }), _this34.setAnimationLoop = function (t) {
      M = t;
    }, _this34.dispose = function () {};
    return _this34;
  }

  return _createClass(Rs);
}(tt);

function Ds(t) {
  function e(e, n) {
    e.opacity.value = n.opacity, n.color && e.diffuse.value.copy(n.color), n.emissive && e.emissive.value.copy(n.emissive).multiplyScalar(n.emissiveIntensity), n.map && (e.map.value = n.map), n.alphaMap && (e.alphaMap.value = n.alphaMap), n.specularMap && (e.specularMap.value = n.specularMap);
    var i = t.get(n).envMap;

    if (i) {
      e.envMap.value = i, e.flipEnvMap.value = i.isCubeTexture && !1 === i.isRenderTargetTexture ? -1 : 1, e.reflectivity.value = n.reflectivity, e.refractionRatio.value = n.refractionRatio;

      var _r78 = t.get(i).__maxMipLevel;

      void 0 !== _r78 && (e.maxMipLevel.value = _r78);
    }

    var r, s;
    n.lightMap && (e.lightMap.value = n.lightMap, e.lightMapIntensity.value = n.lightMapIntensity), n.aoMap && (e.aoMap.value = n.aoMap, e.aoMapIntensity.value = n.aoMapIntensity), n.map ? r = n.map : n.specularMap ? r = n.specularMap : n.displacementMap ? r = n.displacementMap : n.normalMap ? r = n.normalMap : n.bumpMap ? r = n.bumpMap : n.roughnessMap ? r = n.roughnessMap : n.metalnessMap ? r = n.metalnessMap : n.alphaMap ? r = n.alphaMap : n.emissiveMap ? r = n.emissiveMap : n.clearcoatMap ? r = n.clearcoatMap : n.clearcoatNormalMap ? r = n.clearcoatNormalMap : n.clearcoatRoughnessMap ? r = n.clearcoatRoughnessMap : n.specularIntensityMap ? r = n.specularIntensityMap : n.specularTintMap && (r = n.specularTintMap), void 0 !== r && (r.isWebGLRenderTarget && (r = r.texture), !0 === r.matrixAutoUpdate && r.updateMatrix(), e.uvTransform.value.copy(r.matrix)), n.aoMap ? s = n.aoMap : n.lightMap && (s = n.lightMap), void 0 !== s && (s.isWebGLRenderTarget && (s = s.texture), !0 === s.matrixAutoUpdate && s.updateMatrix(), e.uv2Transform.value.copy(s.matrix));
  }

  function n(e, n) {
    e.roughness.value = n.roughness, e.metalness.value = n.metalness, n.roughnessMap && (e.roughnessMap.value = n.roughnessMap), n.metalnessMap && (e.metalnessMap.value = n.metalnessMap), n.emissiveMap && (e.emissiveMap.value = n.emissiveMap), n.bumpMap && (e.bumpMap.value = n.bumpMap, e.bumpScale.value = n.bumpScale, 1 === n.side && (e.bumpScale.value *= -1)), n.normalMap && (e.normalMap.value = n.normalMap, e.normalScale.value.copy(n.normalScale), 1 === n.side && e.normalScale.value.negate()), n.displacementMap && (e.displacementMap.value = n.displacementMap, e.displacementScale.value = n.displacementScale, e.displacementBias.value = n.displacementBias);
    t.get(n).envMap && (e.envMapIntensity.value = n.envMapIntensity);
  }

  return {
    refreshFogUniforms: function refreshFogUniforms(t, e) {
      t.fogColor.value.copy(e.color), e.isFog ? (t.fogNear.value = e.near, t.fogFar.value = e.far) : e.isFogExp2 && (t.fogDensity.value = e.density);
    },
    refreshMaterialUniforms: function refreshMaterialUniforms(t, i, r, s, a) {
      i.isMeshBasicMaterial ? e(t, i) : i.isMeshLambertMaterial ? (e(t, i), function (t, e) {
        e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
      }(t, i)) : i.isMeshToonMaterial ? (e(t, i), function (t, e) {
        e.gradientMap && (t.gradientMap.value = e.gradientMap);
        e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
        e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
        e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
      }(t, i)) : i.isMeshPhongMaterial ? (e(t, i), function (t, e) {
        t.specular.value.copy(e.specular), t.shininess.value = Math.max(e.shininess, 1e-4), e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
        e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
        e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
      }(t, i)) : i.isMeshStandardMaterial ? (e(t, i), i.isMeshPhysicalMaterial ? function (t, e, i) {
        n(t, e), t.reflectivity.value = e.reflectivity, t.clearcoat.value = e.clearcoat, t.clearcoatRoughness.value = e.clearcoatRoughness, e.sheen && t.sheen.value.copy(e.sheen);
        e.clearcoatMap && (t.clearcoatMap.value = e.clearcoatMap);
        e.clearcoatRoughnessMap && (t.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap);
        e.clearcoatNormalMap && (t.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), t.clearcoatNormalMap.value = e.clearcoatNormalMap, 1 === e.side && t.clearcoatNormalScale.value.negate());
        t.transmission.value = e.transmission, e.transmissionMap && (t.transmissionMap.value = e.transmissionMap);
        e.transmission > 0 && (t.transmissionSamplerMap.value = i.texture, t.transmissionSamplerSize.value.set(i.width, i.height));
        t.thickness.value = e.thickness, e.thicknessMap && (t.thicknessMap.value = e.thicknessMap);
        t.attenuationDistance.value = e.attenuationDistance, t.attenuationTint.value.copy(e.attenuationTint), t.specularIntensity.value = e.specularIntensity, t.specularTint.value.copy(e.specularTint), e.specularIntensityMap && (t.specularIntensityMap.value = e.specularIntensityMap);
        e.specularTintMap && (t.specularTintMap.value = e.specularTintMap);
      }(t, i, a) : n(t, i)) : i.isMeshMatcapMaterial ? (e(t, i), function (t, e) {
        e.matcap && (t.matcap.value = e.matcap);
        e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
        e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
      }(t, i)) : i.isMeshDepthMaterial ? (e(t, i), function (t, e) {
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
      }(t, i)) : i.isMeshDistanceMaterial ? (e(t, i), function (t, e) {
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
        t.referencePosition.value.copy(e.referencePosition), t.nearDistance.value = e.nearDistance, t.farDistance.value = e.farDistance;
      }(t, i)) : i.isMeshNormalMaterial ? (e(t, i), function (t, e) {
        e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
        e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
        e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias);
      }(t, i)) : i.isLineBasicMaterial ? (function (t, e) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity;
      }(t, i), i.isLineDashedMaterial && function (t, e) {
        t.dashSize.value = e.dashSize, t.totalSize.value = e.dashSize + e.gapSize, t.scale.value = e.scale;
      }(t, i)) : i.isPointsMaterial ? function (t, e, n, i) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.size.value = e.size * n, t.scale.value = .5 * i, e.map && (t.map.value = e.map);
        e.alphaMap && (t.alphaMap.value = e.alphaMap);
        var r;
        e.map ? r = e.map : e.alphaMap && (r = e.alphaMap);
        void 0 !== r && (!0 === r.matrixAutoUpdate && r.updateMatrix(), t.uvTransform.value.copy(r.matrix));
      }(t, i, r, s) : i.isSpriteMaterial ? function (t, e) {
        t.diffuse.value.copy(e.color), t.opacity.value = e.opacity, t.rotation.value = e.rotation, e.map && (t.map.value = e.map);
        e.alphaMap && (t.alphaMap.value = e.alphaMap);
        var n;
        e.map ? n = e.map : e.alphaMap && (n = e.alphaMap);
        void 0 !== n && (!0 === n.matrixAutoUpdate && n.updateMatrix(), t.uvTransform.value.copy(n.matrix));
      }(t, i) : i.isShadowMaterial ? (t.color.value.copy(i.color), t.opacity.value = i.opacity) : i.isShaderMaterial && (i.uniformsNeedUpdate = !1);
    }
  };
}

function Qs() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = void 0 !== t.canvas ? t.canvas : function () {
    var t = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
    return t.style.display = "block", t;
  }(),
      n = void 0 !== t.context ? t.context : null,
      i = void 0 !== t.alpha && t.alpha,
      r = void 0 === t.depth || t.depth,
      s = void 0 === t.stencil || t.stencil,
      a = void 0 !== t.antialias && t.antialias,
      o = void 0 === t.premultipliedAlpha || t.premultipliedAlpha,
      l = void 0 !== t.preserveDrawingBuffer && t.preserveDrawingBuffer,
      c = void 0 !== t.powerPreference ? t.powerPreference : "default",
      h = void 0 !== t.failIfMajorPerformanceCaveat && t.failIfMajorPerformanceCaveat;
  var u = null,
      d = null;
  var p = [],
      A = [];
  this.domElement = e, this.debug = {
    checkShaderErrors: !0
  }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.gammaFactor = 2, this.outputEncoding = 3e3, this.physicallyCorrectLights = !1, this.toneMapping = 0, this.toneMappingExposure = 1;
  var m = this;
  var g = !1,
      f = 0,
      v = 0,
      y = null,
      x = -1,
      w = null;
  var E = new xt(),
      b = new xt();
  var _ = null,
      I = e.width,
      C = e.height,
      M = 1,
      S = null,
      B = null;
  var T = new xt(0, 0, I, C),
      L = new xt(0, 0, I, C);
  var R = !1;
  var D = [],
      Q = new Wn();
  var P = !1,
      F = !1,
      N = null;
  var U = new ee(),
      k = new _t(),
      G = {
    background: null,
    fog: null,
    environment: null,
    overrideMaterial: null,
    isScene: !0
  };

  function O() {
    return null === y ? M : 1;
  }

  var H,
      z,
      V,
      W,
      q,
      j,
      Y,
      J,
      X,
      K,
      Z,
      $,
      tt,
      et,
      nt,
      it,
      rt,
      st,
      at,
      ot,
      lt,
      ct,
      ht,
      ut = n;

  function dt(t, n) {
    for (var _i102 = 0; _i102 < t.length; _i102++) {
      var _r79 = t[_i102],
          _s44 = e.getContext(_r79, n);

      if (null !== _s44) return _s44;
    }

    return null;
  }

  try {
    var _t162 = {
      alpha: i,
      depth: r,
      stencil: s,
      antialias: a,
      premultipliedAlpha: o,
      preserveDrawingBuffer: l,
      powerPreference: c,
      failIfMajorPerformanceCaveat: h
    };

    if (e.addEventListener("webglcontextlost", mt, !1), e.addEventListener("webglcontextrestored", gt, !1), null === ut) {
      var _e120 = ["webgl2", "webgl", "experimental-webgl"];
      if (!0 === m.isWebGL1Renderer && _e120.shift(), ut = dt(_e120, _t162), null === ut) throw dt(_e120) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
    }

    void 0 === ut.getShaderPrecisionFormat && (ut.getShaderPrecisionFormat = function () {
      return {
        rangeMin: 1,
        rangeMax: 1,
        precision: 1
      };
    });
  } catch (t) {
    throw console.error("THREE.WebGLRenderer: " + t.message), t;
  }

  function pt() {
    H = new Ri(ut), z = new ei(ut, H, t), H.init(z), ct = new Ms(ut, H, z), V = new Is(ut, H, z), D[0] = 1029, W = new Pi(ut), q = new us(), j = new Cs(ut, H, V, q, z, ct, W), Y = new ii(m), J = new Li(m), X = new jn(ut, z), ht = new $n(ut, H, X, z), K = new Di(ut, X, W, ht), Z = new ki(ut, K, X, W), at = new Ui(ut), it = new ni(q), $ = new hs(m, Y, J, H, z, ht, it), tt = new Ds(q), et = new ms(q), nt = new ws(H, z), st = new Zn(m, Y, V, Z, o), rt = new _s(m, Z, z), ot = new ti(ut, H, W, z), lt = new Qi(ut, H, W, z), W.programs = $.programs, m.capabilities = z, m.extensions = H, m.properties = q, m.renderLists = et, m.shadowMap = rt, m.state = V, m.info = W;
  }

  pt();
  var At = new Rs(m, ut);

  function mt(t) {
    t.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
  }

  function gt() {
    console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
    var t = W.autoReset,
        e = rt.enabled,
        n = rt.autoUpdate,
        i = rt.needsUpdate,
        r = rt.type;
    pt(), W.autoReset = t, rt.enabled = e, rt.autoUpdate = n, rt.needsUpdate = i, rt.type = r;
  }

  function ft(t) {
    var e = t.target;
    e.removeEventListener("dispose", ft), function (t) {
      (function (t) {
        var e = q.get(t).programs;
        void 0 !== e && e.forEach(function (t) {
          $.releaseProgram(t);
        });
      })(t), q.remove(t);
    }(e);
  }

  this.xr = At, this.getContext = function () {
    return ut;
  }, this.getContextAttributes = function () {
    return ut.getContextAttributes();
  }, this.forceContextLoss = function () {
    var t = H.get("WEBGL_lose_context");
    t && t.loseContext();
  }, this.forceContextRestore = function () {
    var t = H.get("WEBGL_lose_context");
    t && t.restoreContext();
  }, this.getPixelRatio = function () {
    return M;
  }, this.setPixelRatio = function (t) {
    void 0 !== t && (M = t, this.setSize(I, C, !1));
  }, this.getSize = function (t) {
    return t.set(I, C);
  }, this.setSize = function (t, n, i) {
    At.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (I = t, C = n, e.width = Math.floor(t * M), e.height = Math.floor(n * M), !1 !== i && (e.style.width = t + "px", e.style.height = n + "px"), this.setViewport(0, 0, t, n));
  }, this.getDrawingBufferSize = function (t) {
    return t.set(I * M, C * M).floor();
  }, this.setDrawingBufferSize = function (t, n, i) {
    I = t, C = n, M = i, e.width = Math.floor(t * i), e.height = Math.floor(n * i), this.setViewport(0, 0, t, n);
  }, this.getCurrentViewport = function (t) {
    return t.copy(E);
  }, this.getViewport = function (t) {
    return t.copy(T);
  }, this.setViewport = function (t, e, n, i) {
    t.isVector4 ? T.set(t.x, t.y, t.z, t.w) : T.set(t, e, n, i), V.viewport(E.copy(T).multiplyScalar(M).floor());
  }, this.getScissor = function (t) {
    return t.copy(L);
  }, this.setScissor = function (t, e, n, i) {
    t.isVector4 ? L.set(t.x, t.y, t.z, t.w) : L.set(t, e, n, i), V.scissor(b.copy(L).multiplyScalar(M).floor());
  }, this.getScissorTest = function () {
    return R;
  }, this.setScissorTest = function (t) {
    V.setScissorTest(R = t);
  }, this.setOpaqueSort = function (t) {
    S = t;
  }, this.setTransparentSort = function (t) {
    B = t;
  }, this.getClearColor = function (t) {
    return t.copy(st.getClearColor());
  }, this.setClearColor = function () {
    st.setClearColor.apply(st, arguments);
  }, this.getClearAlpha = function () {
    return st.getClearAlpha();
  }, this.setClearAlpha = function () {
    st.setClearAlpha.apply(st, arguments);
  }, this.clear = function (t, e, n) {
    var i = 0;
    (void 0 === t || t) && (i |= 16384), (void 0 === e || e) && (i |= 256), (void 0 === n || n) && (i |= 1024), ut.clear(i);
  }, this.clearColor = function () {
    this.clear(!0, !1, !1);
  }, this.clearDepth = function () {
    this.clear(!1, !0, !1);
  }, this.clearStencil = function () {
    this.clear(!1, !1, !0);
  }, this.dispose = function () {
    e.removeEventListener("webglcontextlost", mt, !1), e.removeEventListener("webglcontextrestored", gt, !1), et.dispose(), nt.dispose(), q.dispose(), Y.dispose(), J.dispose(), Z.dispose(), ht.dispose(), At.dispose(), At.removeEventListener("sessionstart", yt), At.removeEventListener("sessionend", bt), N && (N.dispose(), N = null), It.stop();
  }, this.renderBufferImmediate = function (t, e) {
    ht.initAttributes();
    var n = q.get(t);
    t.hasPositions && !n.position && (n.position = ut.createBuffer()), t.hasNormals && !n.normal && (n.normal = ut.createBuffer()), t.hasUvs && !n.uv && (n.uv = ut.createBuffer()), t.hasColors && !n.color && (n.color = ut.createBuffer());
    var i = e.getAttributes();
    t.hasPositions && (ut.bindBuffer(34962, n.position), ut.bufferData(34962, t.positionArray, 35048), ht.enableAttribute(i.position), ut.vertexAttribPointer(i.position, 3, 5126, !1, 0, 0)), t.hasNormals && (ut.bindBuffer(34962, n.normal), ut.bufferData(34962, t.normalArray, 35048), ht.enableAttribute(i.normal), ut.vertexAttribPointer(i.normal, 3, 5126, !1, 0, 0)), t.hasUvs && (ut.bindBuffer(34962, n.uv), ut.bufferData(34962, t.uvArray, 35048), ht.enableAttribute(i.uv), ut.vertexAttribPointer(i.uv, 2, 5126, !1, 0, 0)), t.hasColors && (ut.bindBuffer(34962, n.color), ut.bufferData(34962, t.colorArray, 35048), ht.enableAttribute(i.color), ut.vertexAttribPointer(i.color, 3, 5126, !1, 0, 0)), ht.disableUnusedAttributes(), ut.drawArrays(4, 0, t.count), t.count = 0;
  }, this.renderBufferDirect = function (t, e, n, i, r, s) {
    null === e && (e = G);
    var a = r.isMesh && r.matrixWorld.determinant() < 0,
        o = Lt(t, e, i, r);
    V.setMaterial(i, a);
    var l = n.index;
    var c = n.attributes.position;

    if (null === l) {
      if (void 0 === c || 0 === c.count) return;
    } else if (0 === l.count) return;

    var h,
        u = 1;
    !0 === i.wireframe && (l = K.getWireframeAttribute(n), u = 2), void 0 === n.morphAttributes.position && void 0 === n.morphAttributes.normal || at.update(r, n, i, o), ht.setup(r, i, o, n, l);
    var d = ot;
    null !== l && (h = X.get(l), d = lt, d.setIndex(h));
    var p = null !== l ? l.count : c.count,
        A = n.drawRange.start * u,
        m = n.drawRange.count * u,
        g = null !== s ? s.start * u : 0,
        f = null !== s ? s.count * u : 1 / 0,
        v = Math.max(A, g),
        y = Math.min(p, A + m, g + f) - 1,
        x = Math.max(0, y - v + 1);

    if (0 !== x) {
      if (r.isMesh) !0 === i.wireframe ? (V.setLineWidth(i.wireframeLinewidth * O()), d.setMode(1)) : d.setMode(4);else if (r.isLine) {
        var _t163 = i.linewidth;
        void 0 === _t163 && (_t163 = 1), V.setLineWidth(_t163 * O()), r.isLineSegments ? d.setMode(1) : r.isLineLoop ? d.setMode(2) : d.setMode(3);
      } else r.isPoints ? d.setMode(0) : r.isSprite && d.setMode(4);
      if (r.isInstancedMesh) d.renderInstances(v, x, r.count);else if (n.isInstancedBufferGeometry) {
        var _t164 = Math.min(n.instanceCount, n._maxInstanceCount);

        d.renderInstances(v, x, _t164);
      } else d.render(v, x);
    }
  }, this.compile = function (t, e) {
    d = nt.get(t), d.init(), A.push(d), t.traverseVisible(function (t) {
      t.isLight && t.layers.test(e.layers) && (d.pushLight(t), t.castShadow && d.pushShadow(t));
    }), d.setupLights(), t.traverse(function (e) {
      var n = e.material;
      if (n) if (Array.isArray(n)) for (var _i103 = 0; _i103 < n.length; _i103++) {
        Bt(n[_i103], t, e);
      } else Bt(n, t, e);
    }), A.pop(), d = null;
  };
  var vt = null;

  function yt() {
    It.stop();
  }

  function bt() {
    It.start();
  }

  var It = new qn();

  function Ct(t, e, n, i) {
    if (!1 === t.visible) return;
    if (t.layers.test(e.layers)) if (t.isGroup) n = t.renderOrder;else if (t.isLOD) !0 === t.autoUpdate && t.update(e);else if (t.isLight) d.pushLight(t), t.castShadow && d.pushShadow(t);else if (t.isSprite) {
      if (!t.frustumCulled || Q.intersectsSprite(t)) {
        i && k.setFromMatrixPosition(t.matrixWorld).applyMatrix4(U);

        var _e121 = Z.update(t),
            _r80 = t.material;

        _r80.visible && u.push(t, _e121, _r80, n, k.z, null);
      }
    } else if (t.isImmediateRenderObject) i && k.setFromMatrixPosition(t.matrixWorld).applyMatrix4(U), u.push(t, null, t.material, n, k.z, null);else if ((t.isMesh || t.isLine || t.isPoints) && (t.isSkinnedMesh && t.skeleton.frame !== W.render.frame && (t.skeleton.update(), t.skeleton.frame = W.render.frame), !t.frustumCulled || Q.intersectsObject(t))) {
      i && k.setFromMatrixPosition(t.matrixWorld).applyMatrix4(U);

      var _e122 = Z.update(t),
          _r81 = t.material;

      if (Array.isArray(_r81)) {
        var _i104 = _e122.groups;

        for (var _s45 = 0, _a35 = _i104.length; _s45 < _a35; _s45++) {
          var _a36 = _i104[_s45],
              _o24 = _r81[_a36.materialIndex];
          _o24 && _o24.visible && u.push(t, _e122, _o24, n, k.z, _a36);
        }
      } else _r81.visible && u.push(t, _e122, _r81, n, k.z, null);
    }
    var r = t.children;

    for (var _t165 = 0, _s46 = r.length; _t165 < _s46; _t165++) {
      Ct(r[_t165], e, n, i);
    }
  }

  function Mt(t, e, n) {
    var i = !0 === e.isScene ? e.overrideMaterial : null;

    if (n.isArrayCamera) {
      var _r82 = n.cameras;

      for (var _n113 = 0, _s47 = _r82.length; _n113 < _s47; _n113++) {
        var _s48 = _r82[_n113];
        V.viewport(E.copy(_s48.viewport)), d.setupLightsView(_s48);

        for (var _n114 = 0, _r83 = t.length; _n114 < _r83; _n114++) {
          var _r84 = t[_n114],
              _a37 = _r84.object,
              _o25 = _r84.geometry,
              _l17 = null === i ? _r84.material : i,
              _c16 = _r84.group;

          _a37.layers.test(_s48.layers) && St(_a37, e, _s48, _o25, _l17, _c16);
        }
      }
    } else for (var _r85 = 0, _s49 = t.length; _r85 < _s49; _r85++) {
      var _s50 = t[_r85];
      St(_s50.object, e, n, _s50.geometry, null === i ? _s50.material : i, _s50.group);
    }
  }

  function St(t, e, n, i, r, s) {
    if (t.onBeforeRender(m, e, n, i, r, s), t.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix), t.isImmediateRenderObject) {
      var _i105 = Lt(n, e, r, t);

      V.setMaterial(r), ht.reset(), function (t, e) {
        t.render(function (t) {
          m.renderBufferImmediate(t, e);
        });
      }(t, _i105);
    } else !0 === r.transparent && 2 === r.side ? (r.side = 1, r.needsUpdate = !0, m.renderBufferDirect(n, e, i, r, t, s), r.side = 0, r.needsUpdate = !0, m.renderBufferDirect(n, e, i, r, t, s), r.side = 2) : m.renderBufferDirect(n, e, i, r, t, s);

    t.onAfterRender(m, e, n, i, r, s);
  }

  function Bt(t, e, n) {
    !0 !== e.isScene && (e = G);
    var i = q.get(t),
        r = d.state.lights,
        s = d.state.shadowsArray,
        a = r.state.version,
        o = $.getParameters(t, r.state, s, e, n),
        l = $.getProgramCacheKey(o);
    var c = i.programs;
    i.environment = t.isMeshStandardMaterial ? e.environment : null, i.fog = e.fog, i.envMap = (t.isMeshStandardMaterial ? J : Y).get(t.envMap || i.environment), void 0 === c && (t.addEventListener("dispose", ft), c = new Map(), i.programs = c);
    var h = c.get(l);

    if (void 0 !== h) {
      if (i.currentProgram === h && i.lightsStateVersion === a) return Tt(t, o), h;
    } else o.uniforms = $.getUniforms(t), t.onBuild(o, m), t.onBeforeCompile(o, m), h = $.acquireProgram(o, l), c.set(l, h), i.uniforms = o.uniforms;

    var u = i.uniforms;
    (t.isShaderMaterial || t.isRawShaderMaterial) && !0 !== t.clipping || (u.clippingPlanes = it.uniform), Tt(t, o), i.needsLights = function (t) {
      return t.isMeshLambertMaterial || t.isMeshToonMaterial || t.isMeshPhongMaterial || t.isMeshStandardMaterial || t.isShadowMaterial || t.isShaderMaterial && !0 === t.lights;
    }(t), i.lightsStateVersion = a, i.needsLights && (u.ambientLightColor.value = r.state.ambient, u.lightProbe.value = r.state.probe, u.directionalLights.value = r.state.directional, u.directionalLightShadows.value = r.state.directionalShadow, u.spotLights.value = r.state.spot, u.spotLightShadows.value = r.state.spotShadow, u.rectAreaLights.value = r.state.rectArea, u.ltc_1.value = r.state.rectAreaLTC1, u.ltc_2.value = r.state.rectAreaLTC2, u.pointLights.value = r.state.point, u.pointLightShadows.value = r.state.pointShadow, u.hemisphereLights.value = r.state.hemi, u.directionalShadowMap.value = r.state.directionalShadowMap, u.directionalShadowMatrix.value = r.state.directionalShadowMatrix, u.spotShadowMap.value = r.state.spotShadowMap, u.spotShadowMatrix.value = r.state.spotShadowMatrix, u.pointShadowMap.value = r.state.pointShadowMap, u.pointShadowMatrix.value = r.state.pointShadowMatrix);
    var p = h.getUniforms(),
        A = zr.seqWithValue(p.seq, u);
    return i.currentProgram = h, i.uniformsList = A, h;
  }

  function Tt(t, e) {
    var n = q.get(t);
    n.outputEncoding = e.outputEncoding, n.instancing = e.instancing, n.skinning = e.skinning, n.morphTargets = e.morphTargets, n.morphNormals = e.morphNormals, n.numClippingPlanes = e.numClippingPlanes, n.numIntersection = e.numClipIntersection, n.vertexAlphas = e.vertexAlphas, n.vertexTangents = e.vertexTangents;
  }

  function Lt(t, e, n, i) {
    !0 !== e.isScene && (e = G), j.resetTextureUnits();
    var r = e.fog,
        s = n.isMeshStandardMaterial ? e.environment : null,
        a = null === y ? m.outputEncoding : y.texture.encoding,
        o = (n.isMeshStandardMaterial ? J : Y).get(n.envMap || s),
        l = !0 === n.vertexColors && !!i.geometry && !!i.geometry.attributes.color && 4 === i.geometry.attributes.color.itemSize,
        c = !!i.geometry && !!i.geometry.attributes.tangent,
        h = !!i.geometry && !!i.geometry.morphAttributes.position,
        u = !!i.geometry && !!i.geometry.morphAttributes.normal,
        p = q.get(n),
        A = d.state.lights;

    if (!0 === P && (!0 === F || t !== w)) {
      var _e123 = t === w && n.id === x;

      it.setState(n, t, _e123);
    }

    var g = !1;
    n.version === p.__version ? p.needsLights && p.lightsStateVersion !== A.state.version || p.outputEncoding !== a || i.isInstancedMesh && !1 === p.instancing ? g = !0 : i.isInstancedMesh || !0 !== p.instancing ? i.isSkinnedMesh && !1 === p.skinning ? g = !0 : i.isSkinnedMesh || !0 !== p.skinning ? p.envMap !== o || n.fog && p.fog !== r ? g = !0 : void 0 === p.numClippingPlanes || p.numClippingPlanes === it.numPlanes && p.numIntersection === it.numIntersection ? (p.vertexAlphas !== l || p.vertexTangents !== c || p.morphTargets !== h || p.morphNormals !== u) && (g = !0) : g = !0 : g = !0 : g = !0 : (g = !0, p.__version = n.version);
    var f = p.currentProgram;
    !0 === g && (f = Bt(n, e, i));
    var v = !1,
        E = !1,
        b = !1;

    var _ = f.getUniforms(),
        I = p.uniforms;

    if (V.useProgram(f.program) && (v = !0, E = !0, b = !0), n.id !== x && (x = n.id, E = !0), v || w !== t) {
      if (_.setValue(ut, "projectionMatrix", t.projectionMatrix), z.logarithmicDepthBuffer && _.setValue(ut, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2)), w !== t && (w = t, E = !0, b = !0), n.isShaderMaterial || n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshStandardMaterial || n.envMap) {
        var _e124 = _.map.cameraPosition;
        void 0 !== _e124 && _e124.setValue(ut, k.setFromMatrixPosition(t.matrixWorld));
      }

      (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial) && _.setValue(ut, "isOrthographic", !0 === t.isOrthographicCamera), (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial || n.isShadowMaterial || i.isSkinnedMesh) && _.setValue(ut, "viewMatrix", t.matrixWorldInverse);
    }

    if (i.isSkinnedMesh) {
      _.setOptional(ut, i, "bindMatrix"), _.setOptional(ut, i, "bindMatrixInverse");
      var _t166 = i.skeleton;
      _t166 && (z.floatVertexTextures ? (null === _t166.boneTexture && _t166.computeBoneTexture(), _.setValue(ut, "boneTexture", _t166.boneTexture, j), _.setValue(ut, "boneTextureSize", _t166.boneTextureSize)) : _.setOptional(ut, _t166, "boneMatrices"));
    }

    var S, B;
    return (E || p.receiveShadow !== i.receiveShadow) && (p.receiveShadow = i.receiveShadow, _.setValue(ut, "receiveShadow", i.receiveShadow)), E && (_.setValue(ut, "toneMappingExposure", m.toneMappingExposure), p.needsLights && (B = b, (S = I).ambientLightColor.needsUpdate = B, S.lightProbe.needsUpdate = B, S.directionalLights.needsUpdate = B, S.directionalLightShadows.needsUpdate = B, S.pointLights.needsUpdate = B, S.pointLightShadows.needsUpdate = B, S.spotLights.needsUpdate = B, S.spotLightShadows.needsUpdate = B, S.rectAreaLights.needsUpdate = B, S.hemisphereLights.needsUpdate = B), r && n.fog && tt.refreshFogUniforms(I, r), tt.refreshMaterialUniforms(I, n, M, C, N), zr.upload(ut, p.uniformsList, I, j)), n.isShaderMaterial && !0 === n.uniformsNeedUpdate && (zr.upload(ut, p.uniformsList, I, j), n.uniformsNeedUpdate = !1), n.isSpriteMaterial && _.setValue(ut, "center", i.center), _.setValue(ut, "modelViewMatrix", i.modelViewMatrix), _.setValue(ut, "normalMatrix", i.normalMatrix), _.setValue(ut, "modelMatrix", i.matrixWorld), f;
  }

  It.setAnimationLoop(function (t) {
    vt && vt(t);
  }), "undefined" != typeof window && It.setContext(window), this.setAnimationLoop = function (t) {
    vt = t, At.setAnimationLoop(t), null === t ? It.stop() : It.start();
  }, At.addEventListener("sessionstart", yt), At.addEventListener("sessionend", bt), this.render = function (t, e) {
    if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
    if (!0 === g) return;
    !0 === t.autoUpdate && t.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), !0 === At.enabled && !0 === At.isPresenting && (!0 === At.cameraAutoUpdate && At.updateCamera(e), e = At.getCamera()), !0 === t.isScene && t.onBeforeRender(m, t, e, y), d = nt.get(t, A.length), d.init(), A.push(d), U.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), Q.setFromProjectionMatrix(U), F = this.localClippingEnabled, P = it.init(this.clippingPlanes, F, e), u = et.get(t, p.length), u.init(), p.push(u), Ct(t, e, 0, m.sortObjects), u.finish(), !0 === m.sortObjects && u.sort(S, B), !0 === P && it.beginShadows();
    var n = d.state.shadowsArray;
    rt.render(n, t, e), d.setupLights(), d.setupLightsView(e), !0 === P && it.endShadows(), !0 === this.info.autoReset && this.info.reset(), st.render(u, t);
    var i = u.opaque,
        r = u.transmissive,
        s = u.transparent;
    i.length > 0 && Mt(i, t, e), r.length > 0 && function (t, e, n, i) {
      if (null === N) {
        var _t167 = !0 === a && !0 === z.isWebGL2;

        N = new (_t167 ? Et : wt)(1024, 1024, {
          generateMipmaps: !0,
          type: null !== ct.convert(1016) ? 1016 : 1009,
          minFilter: 1008,
          magFilter: 1003,
          wrapS: 1001,
          wrapT: 1001
        });
      }

      var r = m.getRenderTarget();
      m.setRenderTarget(N), m.clear();
      var s = m.toneMapping;
      m.toneMapping = 0, Mt(t, n, i), m.toneMapping = s, j.updateMultisampleRenderTarget(N), j.updateRenderTargetMipmap(N), m.setRenderTarget(r), Mt(e, n, i);
    }(i, r, t, e), s.length > 0 && Mt(s, t, e), null !== y && (j.updateMultisampleRenderTarget(y), j.updateRenderTargetMipmap(y)), !0 === t.isScene && t.onAfterRender(m, t, e), V.buffers.depth.setTest(!0), V.buffers.depth.setMask(!0), V.buffers.color.setMask(!0), V.setPolygonOffset(!1), ht.resetDefaultState(), x = -1, w = null, A.pop(), d = A.length > 0 ? A[A.length - 1] : null, p.pop(), u = p.length > 0 ? p[p.length - 1] : null;
  }, this.getActiveCubeFace = function () {
    return f;
  }, this.getActiveMipmapLevel = function () {
    return v;
  }, this.getRenderTarget = function () {
    return y;
  }, this.setRenderTarget = function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    y = t, f = e, v = n, t && void 0 === q.get(t).__webglFramebuffer && j.setupRenderTarget(t);
    var i = null,
        r = !1,
        s = !1;

    if (t) {
      var _n115 = t.texture;
      (_n115.isDataTexture3D || _n115.isDataTexture2DArray) && (s = !0);

      var _a38 = q.get(t).__webglFramebuffer;

      t.isWebGLCubeRenderTarget ? (i = _a38[e], r = !0) : i = t.isWebGLMultisampleRenderTarget ? q.get(t).__webglMultisampledFramebuffer : _a38, E.copy(t.viewport), b.copy(t.scissor), _ = t.scissorTest;
    } else E.copy(T).multiplyScalar(M).floor(), b.copy(L).multiplyScalar(M).floor(), _ = R;

    if (V.bindFramebuffer(36160, i) && z.drawBuffers) {
      var _e125 = !1;

      if (t) {
        if (t.isWebGLMultipleRenderTargets) {
          var _n116 = t.texture;

          if (D.length !== _n116.length || 36064 !== D[0]) {
            for (var _t168 = 0, _e126 = _n116.length; _t168 < _e126; _t168++) {
              D[_t168] = 36064 + _t168;
            }

            D.length = _n116.length, _e125 = !0;
          }
        } else 1 === D.length && 36064 === D[0] || (D[0] = 36064, D.length = 1, _e125 = !0);
      } else 1 === D.length && 1029 === D[0] || (D[0] = 1029, D.length = 1, _e125 = !0);
      _e125 && (z.isWebGL2 ? ut.drawBuffers(D) : H.get("WEBGL_draw_buffers").drawBuffersWEBGL(D));
    }

    if (V.viewport(E), V.scissor(b), V.setScissorTest(_), r) {
      var _i106 = q.get(t.texture);

      ut.framebufferTexture2D(36160, 36064, 34069 + e, _i106.__webglTexture, n);
    } else if (s) {
      var _i107 = q.get(t.texture),
          _r86 = e || 0;

      ut.framebufferTextureLayer(36160, 36064, _i107.__webglTexture, n || 0, _r86);
    }
  }, this.readRenderTargetPixels = function (t, e, n, i, r, s, a) {
    if (!t || !t.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");

    var o = q.get(t).__webglFramebuffer;

    if (t.isWebGLCubeRenderTarget && void 0 !== a && (o = o[a]), o) {
      V.bindFramebuffer(36160, o);

      try {
        var _a39 = t.texture,
            _o26 = _a39.format,
            _l18 = _a39.type;
        if (1023 !== _o26 && ct.convert(_o26) !== ut.getParameter(35739)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");

        var _c17 = 1016 === _l18 && (H.has("EXT_color_buffer_half_float") || z.isWebGL2 && H.has("EXT_color_buffer_float"));

        if (!(1009 === _l18 || ct.convert(_l18) === ut.getParameter(35738) || 1015 === _l18 && (z.isWebGL2 || H.has("OES_texture_float") || H.has("WEBGL_color_buffer_float")) || _c17)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
        36053 === ut.checkFramebufferStatus(36160) ? e >= 0 && e <= t.width - i && n >= 0 && n <= t.height - r && ut.readPixels(e, n, i, r, ct.convert(_o26), ct.convert(_l18), s) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
      } finally {
        var _t169 = null !== y ? q.get(y).__webglFramebuffer : null;

        V.bindFramebuffer(36160, _t169);
      }
    }
  }, this.copyFramebufferToTexture = function (t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = Math.pow(2, -n),
        r = Math.floor(e.image.width * i),
        s = Math.floor(e.image.height * i);
    var a = ct.convert(e.format);
    z.isWebGL2 && (6407 === a && (a = 32849), 6408 === a && (a = 32856)), j.setTexture2D(e, 0), ut.copyTexImage2D(3553, n, a, t.x, t.y, r, s, 0), V.unbindTexture();
  }, this.copyTextureToTexture = function (t, e, n) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var r = e.image.width,
        s = e.image.height,
        a = ct.convert(n.format),
        o = ct.convert(n.type);
    j.setTexture2D(n, 0), ut.pixelStorei(37440, n.flipY), ut.pixelStorei(37441, n.premultiplyAlpha), ut.pixelStorei(3317, n.unpackAlignment), e.isDataTexture ? ut.texSubImage2D(3553, i, t.x, t.y, r, s, a, o, e.image.data) : e.isCompressedTexture ? ut.compressedTexSubImage2D(3553, i, t.x, t.y, e.mipmaps[0].width, e.mipmaps[0].height, a, e.mipmaps[0].data) : ut.texSubImage2D(3553, i, t.x, t.y, a, o, e.image), 0 === i && n.generateMipmaps && ut.generateMipmap(3553), V.unbindTexture();
  }, this.copyTextureToTexture3D = function (t, e, n, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    if (m.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
    var s = t.max.x - t.min.x + 1,
        a = t.max.y - t.min.y + 1,
        o = t.max.z - t.min.z + 1,
        l = ct.convert(i.format),
        c = ct.convert(i.type);
    var h;
    if (i.isDataTexture3D) j.setTexture3D(i, 0), h = 32879;else {
      if (!i.isDataTexture2DArray) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      j.setTexture2DArray(i, 0), h = 35866;
    }
    ut.pixelStorei(37440, i.flipY), ut.pixelStorei(37441, i.premultiplyAlpha), ut.pixelStorei(3317, i.unpackAlignment);
    var u = ut.getParameter(3314),
        d = ut.getParameter(32878),
        p = ut.getParameter(3316),
        A = ut.getParameter(3315),
        g = ut.getParameter(32877),
        f = n.isCompressedTexture ? n.mipmaps[0] : n.image;
    ut.pixelStorei(3314, f.width), ut.pixelStorei(32878, f.height), ut.pixelStorei(3316, t.min.x), ut.pixelStorei(3315, t.min.y), ut.pixelStorei(32877, t.min.z), n.isDataTexture || n.isDataTexture3D ? ut.texSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, c, f.data) : n.isCompressedTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), ut.compressedTexSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, f.data)) : ut.texSubImage3D(h, r, e.x, e.y, e.z, s, a, o, l, c, f), ut.pixelStorei(3314, u), ut.pixelStorei(32878, d), ut.pixelStorei(3316, p), ut.pixelStorei(3315, A), ut.pixelStorei(32877, g), 0 === r && i.generateMipmaps && ut.generateMipmap(h), V.unbindTexture();
  }, this.initTexture = function (t) {
    j.setTexture2D(t, 0), V.unbindTexture();
  }, this.resetState = function () {
    f = 0, v = 0, y = null, V.reset(), ht.reset();
  }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
    detail: this
  }));
}

/*#__PURE__*/
(function (_Qs) {
  _inherits(_class4, _Qs);

  var _super33 = _createSuper(_class4);

  function _class4() {
    _classCallCheck(this, _class4);

    return _super33.apply(this, arguments);
  }

  return _createClass(_class4);
})(Qs).prototype.isWebGL1Renderer = !0;

var Ps = /*#__PURE__*/function (_Ce5) {
  _inherits(Ps, _Ce5);

  var _super34 = _createSuper(Ps);

  function Ps() {
    var _this35;

    _classCallCheck(this, Ps);

    _this35 = _super34.call(this), _this35.type = "Scene", _this35.background = null, _this35.environment = null, _this35.fog = null, _this35.overrideMaterial = null, _this35.autoUpdate = !0, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
      detail: _assertThisInitialized(_this35)
    }));
    return _this35;
  }

  _createClass(Ps, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(Ps.prototype), "copy", this).call(this, t, e), null !== t.background && (this.background = t.background.clone()), null !== t.environment && (this.environment = t.environment.clone()), null !== t.fog && (this.fog = t.fog.clone()), null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone()), this.autoUpdate = t.autoUpdate, this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(Ps.prototype), "toJSON", this).call(this, t);

      return null !== this.fog && (e.object.fog = this.fog.toJSON()), e;
    }
  }]);

  return Ps;
}(Ce);

Ps.prototype.isScene = !0;

var Fs = /*#__PURE__*/function () {
  function Fs(t, e) {
    _classCallCheck(this, Fs);

    this.array = t, this.stride = e, this.count = void 0 !== t ? t.length / e : 0, this.usage = 35044, this.updateRange = {
      offset: 0,
      count: -1
    }, this.version = 0, this.uuid = st();
  }

  _createClass(Fs, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(t) {
      !0 === t && this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(t) {
      return this.usage = t, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(t, e, n) {
      t *= this.stride, n *= e.stride;

      for (var _i108 = 0, _r87 = this.stride; _i108 < _r87; _i108++) {
        this.array[t + _i108] = e.array[n + _i108];
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.array.set(t, e), this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = st()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
      var e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]),
          n = new this.constructor(e, this.stride);
      return n.setUsage(this.usage), n;
    }
  }, {
    key: "onUpload",
    value: function onUpload(t) {
      return this.onUploadCallback = t, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      return void 0 === t.arrayBuffers && (t.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = st()), void 0 === t.arrayBuffers[this.array.buffer._uuid] && (t.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer))), {
        uuid: this.uuid,
        buffer: this.array.buffer._uuid,
        type: this.array.constructor.name,
        stride: this.stride
      };
    }
  }]);

  return Fs;
}();

Fs.prototype.isInterleavedBuffer = !0;
var Ns = new _t();

var Us = /*#__PURE__*/function () {
  function Us(t, e, n) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

    _classCallCheck(this, Us);

    this.name = "", this.data = t, this.itemSize = e, this.offset = n, this.normalized = !0 === i;
  }

  _createClass(Us, [{
    key: "count",
    get: function get() {
      return this.data.count;
    }
  }, {
    key: "array",
    get: function get() {
      return this.data.array;
    }
  }, {
    key: "needsUpdate",
    set: function set(t) {
      this.data.needsUpdate = t;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(t) {
      for (var _e127 = 0, _n117 = this.data.count; _e127 < _n117; _e127++) {
        Ns.x = this.getX(_e127), Ns.y = this.getY(_e127), Ns.z = this.getZ(_e127), Ns.applyMatrix4(t), this.setXYZ(_e127, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(t) {
      for (var _e128 = 0, _n118 = this.count; _e128 < _n118; _e128++) {
        Ns.x = this.getX(_e128), Ns.y = this.getY(_e128), Ns.z = this.getZ(_e128), Ns.applyNormalMatrix(t), this.setXYZ(_e128, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(t) {
      for (var _e129 = 0, _n119 = this.count; _e129 < _n119; _e129++) {
        Ns.x = this.getX(_e129), Ns.y = this.getY(_e129), Ns.z = this.getZ(_e129), Ns.transformDirection(t), this.setXYZ(_e129, Ns.x, Ns.y, Ns.z);
      }

      return this;
    }
  }, {
    key: "setX",
    value: function setX(t, e) {
      return this.data.array[t * this.data.stride + this.offset] = e, this;
    }
  }, {
    key: "setY",
    value: function setY(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
  }, {
    key: "setZ",
    value: function setZ(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
  }, {
    key: "setW",
    value: function setW(t, e) {
      return this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
  }, {
    key: "getX",
    value: function getX(t) {
      return this.data.array[t * this.data.stride + this.offset];
    }
  }, {
    key: "getY",
    value: function getY(t) {
      return this.data.array[t * this.data.stride + this.offset + 1];
    }
  }, {
    key: "getZ",
    value: function getZ(t) {
      return this.data.array[t * this.data.stride + this.offset + 2];
    }
  }, {
    key: "getW",
    value: function getW(t) {
      return this.data.array[t * this.data.stride + this.offset + 3];
    }
  }, {
    key: "setXY",
    value: function setXY(t, e, n) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(t, e, n, i) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(t, e, n, i, r) {
      return t = t * this.data.stride + this.offset, this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this.data.array[t + 3] = r, this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      if (void 0 === t) {
        console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
        var _t170 = [];

        for (var _e130 = 0; _e130 < this.count; _e130++) {
          var _n120 = _e130 * this.data.stride + this.offset;

          for (var _e131 = 0; _e131 < this.itemSize; _e131++) {
            _t170.push(this.data.array[_n120 + _e131]);
          }
        }

        return new Xe(new this.array.constructor(_t170), this.itemSize, this.normalized);
      }

      return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new Us(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      if (void 0 === t) {
        console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
        var _t171 = [];

        for (var _e132 = 0; _e132 < this.count; _e132++) {
          var _n121 = _e132 * this.data.stride + this.offset;

          for (var _e133 = 0; _e133 < this.itemSize; _e133++) {
            _t171.push(this.data.array[_n121 + _e133]);
          }
        }

        return {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: _t171,
          normalized: this.normalized
        };
      }

      return void 0 === t.interleavedBuffers && (t.interleavedBuffers = {}), void 0 === t.interleavedBuffers[this.data.uuid] && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }]);

  return Us;
}();

Us.prototype.isInterleavedBufferAttribute = !0;

var ks = /*#__PURE__*/function (_ke5) {
  _inherits(ks, _ke5);

  var _super35 = _createSuper(ks);

  function ks(t) {
    var _this36;

    _classCallCheck(this, ks);

    _this36 = _super35.call(this), _this36.type = "SpriteMaterial", _this36.color = new qe(16777215), _this36.map = null, _this36.alphaMap = null, _this36.rotation = 0, _this36.sizeAttenuation = !0, _this36.transparent = !0, _this36.setValues(t);
    return _this36;
  }

  _createClass(ks, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ks.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.rotation = t.rotation, this.sizeAttenuation = t.sizeAttenuation, this;
    }
  }]);

  return ks;
}(ke);

var Gs;
ks.prototype.isSpriteMaterial = !0;
var Os = new _t(),
    Hs = new _t(),
    zs = new _t(),
    Vs = new pt(),
    Ws = new pt(),
    qs = new ee(),
    js = new _t(),
    Ys = new _t(),
    Js = new _t(),
    Xs = new pt(),
    Ks = new pt(),
    Zs = new pt();

function $s(t, e, n, i, r, s) {
  Vs.subVectors(t, n).addScalar(.5).multiply(i), void 0 !== r ? (Ws.x = s * Vs.x - r * Vs.y, Ws.y = r * Vs.x + s * Vs.y) : Ws.copy(Vs), t.copy(e), t.x += Ws.x, t.y += Ws.y, t.applyMatrix4(qs);
}

/*#__PURE__*/
(function (_Ce6) {
  _inherits(_class5, _Ce6);

  var _super36 = _createSuper(_class5);

  function _class5(t) {
    var _this37;

    _classCallCheck(this, _class5);

    if (_this37 = _super36.call(this), _this37.type = "Sprite", void 0 === Gs) {
      Gs = new cn();

      var _t172 = new Float32Array([-.5, -.5, 0, 0, 0, .5, -.5, 0, 1, 0, .5, .5, 0, 1, 1, -.5, .5, 0, 0, 1]),
          _e134 = new Fs(_t172, 5);

      Gs.setIndex([0, 1, 2, 0, 2, 3]), Gs.setAttribute("position", new Us(_e134, 3, 0, !1)), Gs.setAttribute("uv", new Us(_e134, 2, 3, !1));
    }

    _this37.geometry = Gs, _this37.material = void 0 !== t ? t : new ks(), _this37.center = new pt(.5, .5);
    return _possibleConstructorReturn(_this37);
  }

  _createClass(_class5, [{
    key: "raycast",
    value: function raycast(t, e) {
      null === t.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), Hs.setFromMatrixScale(this.matrixWorld), qs.copy(t.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t.camera.matrixWorldInverse, this.matrixWorld), zs.setFromMatrixPosition(this.modelViewMatrix), t.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && Hs.multiplyScalar(-zs.z);
      var n = this.material.rotation;
      var i, r;
      0 !== n && (r = Math.cos(n), i = Math.sin(n));
      var s = this.center;
      $s(js.set(-.5, -.5, 0), zs, s, Hs, i, r), $s(Ys.set(.5, -.5, 0), zs, s, Hs, i, r), $s(Js.set(.5, .5, 0), zs, s, Hs, i, r), Xs.set(0, 0), Ks.set(1, 0), Zs.set(1, 1);
      var a = t.ray.intersectTriangle(js, Ys, Js, !1, Os);
      if (null === a && ($s(Ys.set(-.5, .5, 0), zs, s, Hs, i, r), Ks.set(0, 1), a = t.ray.intersectTriangle(js, Js, Ys, !1, Os), null === a)) return;
      var o = t.ray.origin.distanceTo(Os);
      o < t.near || o > t.far || e.push({
        distance: o,
        point: Os.clone(),
        uv: Ne.getUV(Os, js, Ys, Js, Xs, Ks, Zs, new pt()),
        face: null,
        object: this
      });
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class5.prototype), "copy", this).call(this, t), void 0 !== t.center && this.center.copy(t.center), this.material = t.material, this;
    }
  }]);

  return _class5;
})(Ce).prototype.isSprite = !0;
var ta = new _t(),
    ea = new xt(),
    na = new xt(),
    ia = new _t(),
    ra = new ee();

var sa = /*#__PURE__*/function (_Mn) {
  _inherits(sa, _Mn);

  var _super37 = _createSuper(sa);

  function sa(t, e) {
    var _this38;

    _classCallCheck(this, sa);

    _this38 = _super37.call(this, t, e), _this38.type = "SkinnedMesh", _this38.bindMode = "attached", _this38.bindMatrix = new ee(), _this38.bindMatrixInverse = new ee();
    return _this38;
  }

  _createClass(sa, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(sa.prototype), "copy", this).call(this, t), this.bindMode = t.bindMode, this.bindMatrix.copy(t.bindMatrix), this.bindMatrixInverse.copy(t.bindMatrixInverse), this.skeleton = t.skeleton, this;
    }
  }, {
    key: "bind",
    value: function bind(t, e) {
      this.skeleton = t, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
    }
  }, {
    key: "pose",
    value: function pose() {
      this.skeleton.pose();
    }
  }, {
    key: "normalizeSkinWeights",
    value: function normalizeSkinWeights() {
      var t = new xt(),
          e = this.geometry.attributes.skinWeight;

      for (var _n122 = 0, _i109 = e.count; _n122 < _i109; _n122++) {
        t.x = e.getX(_n122), t.y = e.getY(_n122), t.z = e.getZ(_n122), t.w = e.getW(_n122);

        var _i110 = 1 / t.manhattanLength();

        _i110 !== 1 / 0 ? t.multiplyScalar(_i110) : t.set(1, 0, 0, 0), e.setXYZW(_n122, t.x, t.y, t.z, t.w);
      }
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      _get(_getPrototypeOf(sa.prototype), "updateMatrixWorld", this).call(this, t), "attached" === this.bindMode ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : "detached" === this.bindMode ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }, {
    key: "boneTransform",
    value: function boneTransform(t, e) {
      var n = this.skeleton,
          i = this.geometry;
      ea.fromBufferAttribute(i.attributes.skinIndex, t), na.fromBufferAttribute(i.attributes.skinWeight, t), ta.fromBufferAttribute(i.attributes.position, t).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);

      for (var _t173 = 0; _t173 < 4; _t173++) {
        var _i111 = na.getComponent(_t173);

        if (0 !== _i111) {
          var _r88 = ea.getComponent(_t173);

          ra.multiplyMatrices(n.bones[_r88].matrixWorld, n.boneInverses[_r88]), e.addScaledVector(ia.copy(ta).applyMatrix4(ra), _i111);
        }
      }

      return e.applyMatrix4(this.bindMatrixInverse);
    }
  }]);

  return sa;
}(Mn);

sa.prototype.isSkinnedMesh = !0;

var aa = /*#__PURE__*/function (_Ce7) {
  _inherits(aa, _Ce7);

  var _super38 = _createSuper(aa);

  function aa() {
    var _this39;

    _classCallCheck(this, aa);

    _this39 = _super38.call(this), _this39.type = "Bone";
    return _this39;
  }

  return _createClass(aa);
}(Ce);

aa.prototype.isBone = !0;

var oa = /*#__PURE__*/function (_vt4) {
  _inherits(oa, _vt4);

  var _super39 = _createSuper(oa);

  function oa() {
    var _this40;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 ? arguments[3] : undefined;
    var r = arguments.length > 4 ? arguments[4] : undefined;
    var s = arguments.length > 5 ? arguments[5] : undefined;
    var a = arguments.length > 6 ? arguments[6] : undefined;
    var o = arguments.length > 7 ? arguments[7] : undefined;
    var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1003;
    var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1003;
    var h = arguments.length > 10 ? arguments[10] : undefined;
    var u = arguments.length > 11 ? arguments[11] : undefined;

    _classCallCheck(this, oa);

    _this40 = _super39.call(this, null, s, a, o, l, c, i, r, h, u), _this40.image = {
      data: t,
      width: e,
      height: n
    }, _this40.magFilter = l, _this40.minFilter = c, _this40.generateMipmaps = !1, _this40.flipY = !1, _this40.unpackAlignment = 1, _this40.needsUpdate = !0;
    return _this40;
  }

  return _createClass(oa);
}(vt);

oa.prototype.isDataTexture = !0;
var la = new ee(),
    ca = new ee();

var ha = /*#__PURE__*/function () {
  function ha() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, ha);

    this.uuid = st(), this.bones = t.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.frame = -1, this.init();
  }

  _createClass(ha, [{
    key: "init",
    value: function init() {
      var t = this.bones,
          e = this.boneInverses;
      if (this.boneMatrices = new Float32Array(16 * t.length), 0 === e.length) this.calculateInverses();else if (t.length !== e.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];

        for (var _t174 = 0, _e135 = this.bones.length; _t174 < _e135; _t174++) {
          this.boneInverses.push(new ee());
        }
      }
    }
  }, {
    key: "calculateInverses",
    value: function calculateInverses() {
      this.boneInverses.length = 0;

      for (var _t175 = 0, _e136 = this.bones.length; _t175 < _e136; _t175++) {
        var _e137 = new ee();

        this.bones[_t175] && _e137.copy(this.bones[_t175].matrixWorld).invert(), this.boneInverses.push(_e137);
      }
    }
  }, {
    key: "pose",
    value: function pose() {
      for (var _t176 = 0, _e138 = this.bones.length; _t176 < _e138; _t176++) {
        var _e139 = this.bones[_t176];
        _e139 && _e139.matrixWorld.copy(this.boneInverses[_t176]).invert();
      }

      for (var _t177 = 0, _e140 = this.bones.length; _t177 < _e140; _t177++) {
        var _e141 = this.bones[_t177];
        _e141 && (_e141.parent && _e141.parent.isBone ? (_e141.matrix.copy(_e141.parent.matrixWorld).invert(), _e141.matrix.multiply(_e141.matrixWorld)) : _e141.matrix.copy(_e141.matrixWorld), _e141.matrix.decompose(_e141.position, _e141.quaternion, _e141.scale));
      }
    }
  }, {
    key: "update",
    value: function update() {
      var t = this.bones,
          e = this.boneInverses,
          n = this.boneMatrices,
          i = this.boneTexture;

      for (var _i112 = 0, _r89 = t.length; _i112 < _r89; _i112++) {
        var _r90 = t[_i112] ? t[_i112].matrixWorld : ca;

        la.multiplyMatrices(_r90, e[_i112]), la.toArray(n, 16 * _i112);
      }

      null !== i && (i.needsUpdate = !0);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ha(this.bones, this.boneInverses);
    }
  }, {
    key: "computeBoneTexture",
    value: function computeBoneTexture() {
      var t = Math.sqrt(4 * this.bones.length);
      t = ht(t), t = Math.max(t, 4);
      var e = new Float32Array(t * t * 4);
      e.set(this.boneMatrices);
      var n = new oa(e, t, t, 1023, 1015);
      return this.boneMatrices = e, this.boneTexture = n, this.boneTextureSize = t, this;
    }
  }, {
    key: "getBoneByName",
    value: function getBoneByName(t) {
      for (var _e142 = 0, _n123 = this.bones.length; _e142 < _n123; _e142++) {
        var _n124 = this.bones[_e142];
        if (_n124.name === t) return _n124;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t, e) {
      this.uuid = t.uuid;

      for (var _n125 = 0, _i113 = t.bones.length; _n125 < _i113; _n125++) {
        var _i114 = t.bones[_n125];
        var _r91 = e[_i114];
        void 0 === _r91 && (console.warn("THREE.Skeleton: No bone found with UUID:", _i114), _r91 = new aa()), this.bones.push(_r91), this.boneInverses.push(new ee().fromArray(t.boneInverses[_n125]));
      }

      return this.init(), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "Skeleton",
          generator: "Skeleton.toJSON"
        },
        bones: [],
        boneInverses: []
      };
      t.uuid = this.uuid;
      var e = this.bones,
          n = this.boneInverses;

      for (var _i115 = 0, _r92 = e.length; _i115 < _r92; _i115++) {
        var _r93 = e[_i115];
        t.bones.push(_r93.uuid);
        var _s51 = n[_i115];
        t.boneInverses.push(_s51.toArray());
      }

      return t;
    }
  }]);

  return ha;
}();

var ua = new ee(),
    da = new ee(),
    pa = [],
    Aa = new Mn();

/*#__PURE__*/
(function (_Mn2) {
  _inherits(_class6, _Mn2);

  var _super40 = _createSuper(_class6);

  function _class6(t, e, n) {
    var _this41;

    _classCallCheck(this, _class6);

    _this41 = _super40.call(this, t, e), _this41.instanceMatrix = new Xe(new Float32Array(16 * n), 16), _this41.instanceColor = null, _this41.count = n, _this41.frustumCulled = !1;
    return _this41;
  }

  _createClass(_class6, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class6.prototype), "copy", this).call(this, t), this.instanceMatrix.copy(t.instanceMatrix), null !== t.instanceColor && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, this;
    }
  }, {
    key: "getColorAt",
    value: function getColorAt(t, e) {
      e.fromArray(this.instanceColor.array, 3 * t);
    }
  }, {
    key: "getMatrixAt",
    value: function getMatrixAt(t, e) {
      e.fromArray(this.instanceMatrix.array, 16 * t);
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.matrixWorld,
          i = this.count;
      if (Aa.geometry = this.geometry, Aa.material = this.material, void 0 !== Aa.material) for (var _r94 = 0; _r94 < i; _r94++) {
        this.getMatrixAt(_r94, ua), da.multiplyMatrices(n, ua), Aa.matrixWorld = da, Aa.raycast(t, pa);

        for (var _t178 = 0, _n126 = pa.length; _t178 < _n126; _t178++) {
          var _n127 = pa[_t178];
          _n127.instanceId = _r94, _n127.object = this, e.push(_n127);
        }

        pa.length = 0;
      }
    }
  }, {
    key: "setColorAt",
    value: function setColorAt(t, e) {
      null === this.instanceColor && (this.instanceColor = new Xe(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t);
    }
  }, {
    key: "setMatrixAt",
    value: function setMatrixAt(t, e) {
      e.toArray(this.instanceMatrix.array, 16 * t);
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {}
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: "dispose"
      });
    }
  }]);

  return _class6;
})(Mn).prototype.isInstancedMesh = !0;

var ma = /*#__PURE__*/function (_ke6) {
  _inherits(ma, _ke6);

  var _super41 = _createSuper(ma);

  function ma(t) {
    var _this42;

    _classCallCheck(this, ma);

    _this42 = _super41.call(this), _this42.type = "LineBasicMaterial", _this42.color = new qe(16777215), _this42.linewidth = 1, _this42.linecap = "round", _this42.linejoin = "round", _this42.setValues(t);
    return _this42;
  }

  _createClass(ma, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ma.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this;
    }
  }]);

  return ma;
}(ke);

ma.prototype.isLineBasicMaterial = !0;
var ga = new _t(),
    fa = new _t(),
    va = new ee(),
    ya = new te(),
    xa = new qt();

var wa = /*#__PURE__*/function (_Ce8) {
  _inherits(wa, _Ce8);

  var _super42 = _createSuper(wa);

  function wa() {
    var _this43;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new cn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ma();

    _classCallCheck(this, wa);

    _this43 = _super42.call(this), _this43.type = "Line", _this43.geometry = t, _this43.material = e, _this43.updateMorphTargets();
    return _this43;
  }

  _createClass(wa, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(wa.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var t = this.geometry;
      if (t.isBufferGeometry) {
        if (null === t.index) {
          var _e143 = t.attributes.position,
              _n128 = [0];

          for (var _t179 = 1, _i116 = _e143.count; _t179 < _i116; _t179++) {
            ga.fromBufferAttribute(_e143, _t179 - 1), fa.fromBufferAttribute(_e143, _t179), _n128[_t179] = _n128[_t179 - 1], _n128[_t179] += ga.distanceTo(fa);
          }

          t.setAttribute("lineDistance", new $e(_n128, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      } else t.isGeometry && console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      return this;
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.matrixWorld,
          r = t.params.Line.threshold,
          s = n.drawRange;
      if (null === n.boundingSphere && n.computeBoundingSphere(), xa.copy(n.boundingSphere), xa.applyMatrix4(i), xa.radius += r, !1 === t.ray.intersectsSphere(xa)) return;
      va.copy(i).invert(), ya.copy(t.ray).applyMatrix4(va);
      var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = a * a,
          l = new _t(),
          c = new _t(),
          h = new _t(),
          u = new _t(),
          d = this.isLineSegments ? 2 : 1;

      if (n.isBufferGeometry) {
        var _i117 = n.index,
            _r95 = n.attributes.position;

        if (null !== _i117) {
          for (var _n129 = Math.max(0, s.start), _a40 = Math.min(_i117.count, s.start + s.count) - 1; _n129 < _a40; _n129 += d) {
            var _s52 = _i117.getX(_n129),
                _a41 = _i117.getX(_n129 + 1);

            l.fromBufferAttribute(_r95, _s52), c.fromBufferAttribute(_r95, _a41);
            if (ya.distanceSqToSegment(l, c, u, h) > o) continue;
            u.applyMatrix4(this.matrixWorld);

            var _d10 = t.ray.origin.distanceTo(u);

            _d10 < t.near || _d10 > t.far || e.push({
              distance: _d10,
              point: h.clone().applyMatrix4(this.matrixWorld),
              index: _n129,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        } else {
          for (var _n130 = Math.max(0, s.start), _i118 = Math.min(_r95.count, s.start + s.count) - 1; _n130 < _i118; _n130 += d) {
            l.fromBufferAttribute(_r95, _n130), c.fromBufferAttribute(_r95, _n130 + 1);
            if (ya.distanceSqToSegment(l, c, u, h) > o) continue;
            u.applyMatrix4(this.matrixWorld);

            var _i119 = t.ray.origin.distanceTo(u);

            _i119 < t.near || _i119 > t.far || e.push({
              distance: _i119,
              point: h.clone().applyMatrix4(this.matrixWorld),
              index: _n130,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        }
      } else n.isGeometry && console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e144 = t.morphAttributes,
            _n131 = Object.keys(_e144);

        if (_n131.length > 0) {
          var _t180 = _e144[_n131[0]];

          if (void 0 !== _t180) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e145 = 0, _n132 = _t180.length; _e145 < _n132; _e145++) {
              var _n133 = _t180[_e145].name || String(_e145);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n133] = _e145;
            }
          }
        }
      } else {
        var _e146 = t.morphTargets;
        void 0 !== _e146 && _e146.length > 0 && console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }]);

  return wa;
}(Ce);

wa.prototype.isLine = !0;
var Ea = new _t(),
    ba = new _t();

var _a = /*#__PURE__*/function (_wa) {
  _inherits(_a, _wa);

  var _super43 = _createSuper(_a);

  function _a(t, e) {
    var _this44;

    _classCallCheck(this, _a);

    _this44 = _super43.call(this, t, e), _this44.type = "LineSegments";
    return _this44;
  }

  _createClass(_a, [{
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var t = this.geometry;
      if (t.isBufferGeometry) {
        if (null === t.index) {
          var _e147 = t.attributes.position,
              _n134 = [];

          for (var _t181 = 0, _i120 = _e147.count; _t181 < _i120; _t181 += 2) {
            Ea.fromBufferAttribute(_e147, _t181), ba.fromBufferAttribute(_e147, _t181 + 1), _n134[_t181] = 0 === _t181 ? 0 : _n134[_t181 - 1], _n134[_t181 + 1] = _n134[_t181] + Ea.distanceTo(ba);
          }

          t.setAttribute("lineDistance", new $e(_n134, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      } else t.isGeometry && console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      return this;
    }
  }]);

  return _a;
}(wa);

_a.prototype.isLineSegments = !0;

var Ia = /*#__PURE__*/function (_wa2) {
  _inherits(Ia, _wa2);

  var _super44 = _createSuper(Ia);

  function Ia(t, e) {
    var _this45;

    _classCallCheck(this, Ia);

    _this45 = _super44.call(this, t, e), _this45.type = "LineLoop";
    return _this45;
  }

  return _createClass(Ia);
}(wa);

Ia.prototype.isLineLoop = !0;

var Ca = /*#__PURE__*/function (_ke7) {
  _inherits(Ca, _ke7);

  var _super45 = _createSuper(Ca);

  function Ca(t) {
    var _this46;

    _classCallCheck(this, Ca);

    _this46 = _super45.call(this), _this46.type = "PointsMaterial", _this46.color = new qe(16777215), _this46.map = null, _this46.alphaMap = null, _this46.size = 1, _this46.sizeAttenuation = !0, _this46.setValues(t);
    return _this46;
  }

  _createClass(Ca, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ca.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this;
    }
  }]);

  return Ca;
}(ke);

Ca.prototype.isPointsMaterial = !0;
var Ma = new ee(),
    Sa = new te(),
    Ba = new qt(),
    Ta = new _t();

var La = /*#__PURE__*/function (_Ce9) {
  _inherits(La, _Ce9);

  var _super46 = _createSuper(La);

  function La() {
    var _this47;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new cn();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Ca();

    _classCallCheck(this, La);

    _this47 = _super46.call(this), _this47.type = "Points", _this47.geometry = t, _this47.material = e, _this47.updateMorphTargets();
    return _this47;
  }

  _createClass(La, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(La.prototype), "copy", this).call(this, t), this.material = t.material, this.geometry = t.geometry, this;
    }
  }, {
    key: "raycast",
    value: function raycast(t, e) {
      var n = this.geometry,
          i = this.matrixWorld,
          r = t.params.Points.threshold,
          s = n.drawRange;
      if (null === n.boundingSphere && n.computeBoundingSphere(), Ba.copy(n.boundingSphere), Ba.applyMatrix4(i), Ba.radius += r, !1 === t.ray.intersectsSphere(Ba)) return;
      Ma.copy(i).invert(), Sa.copy(t.ray).applyMatrix4(Ma);
      var a = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = a * a;

      if (n.isBufferGeometry) {
        var _r96 = n.index,
            _a42 = n.attributes.position;

        if (null !== _r96) {
          for (var _n135 = Math.max(0, s.start), _l19 = Math.min(_r96.count, s.start + s.count); _n135 < _l19; _n135++) {
            var _s53 = _r96.getX(_n135);

            Ta.fromBufferAttribute(_a42, _s53), Ra(Ta, _s53, o, i, t, e, this);
          }
        } else {
          for (var _n136 = Math.max(0, s.start), _r97 = Math.min(_a42.count, s.start + s.count); _n136 < _r97; _n136++) {
            Ta.fromBufferAttribute(_a42, _n136), Ra(Ta, _n136, o, i, t, e, this);
          }
        }
      } else console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var t = this.geometry;

      if (t.isBufferGeometry) {
        var _e148 = t.morphAttributes,
            _n137 = Object.keys(_e148);

        if (_n137.length > 0) {
          var _t182 = _e148[_n137[0]];

          if (void 0 !== _t182) {
            this.morphTargetInfluences = [], this.morphTargetDictionary = {};

            for (var _e149 = 0, _n138 = _t182.length; _e149 < _n138; _e149++) {
              var _n139 = _t182[_e149].name || String(_e149);

              this.morphTargetInfluences.push(0), this.morphTargetDictionary[_n139] = _e149;
            }
          }
        }
      } else {
        var _e150 = t.morphTargets;
        void 0 !== _e150 && _e150.length > 0 && console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }]);

  return La;
}(Ce);

function Ra(t, e, n, i, r, s, a) {
  var o = Sa.distanceSqToPoint(t);

  if (o < n) {
    var _n140 = new _t();

    Sa.closestPointToPoint(t, _n140), _n140.applyMatrix4(i);

    var _l20 = r.ray.origin.distanceTo(_n140);

    if (_l20 < r.near || _l20 > r.far) return;
    s.push({
      distance: _l20,
      distanceToRay: Math.sqrt(o),
      point: _n140,
      index: e,
      face: null,
      object: a
    });
  }
}

La.prototype.isPoints = !0;

/*#__PURE__*/
(function (_vt5) {
  _inherits(_class7, _vt5);

  var _super47 = _createSuper(_class7);

  function _class7(t, e, n, i, r, s, a, o, l) {
    var _this48;

    _classCallCheck(this, _class7);

    _this48 = _super47.call(this, t, e, n, i, r, s, a, o, l), _this48.format = void 0 !== a ? a : 1022, _this48.minFilter = void 0 !== s ? s : 1006, _this48.magFilter = void 0 !== r ? r : 1006, _this48.generateMipmaps = !1;

    var c = _assertThisInitialized(_this48);

    "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(function e() {
      c.needsUpdate = !0, t.requestVideoFrameCallback(e);
    });
    return _this48;
  }

  _createClass(_class7, [{
    key: "clone",
    value: function clone() {
      return new this.constructor(this.image).copy(this);
    }
  }, {
    key: "update",
    value: function update() {
      var t = this.image;
      !1 === "requestVideoFrameCallback" in t && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
  }]);

  return _class7;
})(vt).prototype.isVideoTexture = !0;

var Da = /*#__PURE__*/function (_vt6) {
  _inherits(Da, _vt6);

  var _super48 = _createSuper(Da);

  function Da(t, e, n, i, r, s, a, o, l, c, h, u) {
    var _this49;

    _classCallCheck(this, Da);

    _this49 = _super48.call(this, null, s, a, o, l, c, i, r, h, u), _this49.image = {
      width: e,
      height: n
    }, _this49.mipmaps = t, _this49.flipY = !1, _this49.generateMipmaps = !1;
    return _this49;
  }

  return _createClass(Da);
}(vt);

Da.prototype.isCompressedTexture = !0;

/*#__PURE__*/
(function (_vt7) {
  _inherits(_class8, _vt7);

  var _super49 = _createSuper(_class8);

  function _class8(t, e, n, i, r, s, a, o, l) {
    var _this50;

    _classCallCheck(this, _class8);

    _this50 = _super49.call(this, t, e, n, i, r, s, a, o, l), _this50.needsUpdate = !0;
    return _this50;
  }

  return _createClass(_class8);
})(vt).prototype.isCanvasTexture = !0;

/*#__PURE__*/
(function (_vt8) {
  _inherits(_class9, _vt8);

  var _super50 = _createSuper(_class9);

  function _class9(t, e, n, i, r, s, a, o, l, c) {
    var _this51;

    _classCallCheck(this, _class9);

    if (1026 !== (c = void 0 !== c ? c : 1026) && 1027 !== c) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    void 0 === n && 1026 === c && (n = 1012), void 0 === n && 1027 === c && (n = 1020), _this51 = _super50.call(this, null, i, r, s, a, o, c, n, l), _this51.image = {
      width: t,
      height: e
    }, _this51.magFilter = void 0 !== a ? a : 1003, _this51.minFilter = void 0 !== o ? o : 1003, _this51.flipY = !1, _this51.generateMipmaps = !1;
    return _this51;
  }

  return _createClass(_class9);
})(vt).prototype.isDepthTexture = !0, new _t(), new _t(), new _t(), new Ne();

var Qa = /*#__PURE__*/function () {
  function Qa() {
    _classCallCheck(this, Qa);

    this.type = "Curve", this.arcLengthDivisions = 200;
  }

  _createClass(Qa, [{
    key: "getPoint",
    value: function getPoint() {
      return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
  }, {
    key: "getPointAt",
    value: function getPointAt(t, e) {
      var n = this.getUtoTmapping(t);
      return this.getPoint(n, e);
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var e = [];

      for (var _n141 = 0; _n141 <= t; _n141++) {
        e.push(this.getPoint(_n141 / t));
      }

      return e;
    }
  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var e = [];

      for (var _n142 = 0; _n142 <= t; _n142++) {
        e.push(this.getPointAt(_n142 / t));
      }

      return e;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var t = this.getLengths();
      return t[t.length - 1];
    }
  }, {
    key: "getLengths",
    value: function getLengths() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;
      if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
      this.needsUpdate = !1;
      var e = [];
      var n,
          i = this.getPoint(0),
          r = 0;
      e.push(0);

      for (var _s54 = 1; _s54 <= t; _s54++) {
        n = this.getPoint(_s54 / t), r += n.distanceTo(i), e.push(r), i = n;
      }

      return this.cacheArcLengths = e, e;
    }
  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = !0, this.getLengths();
    }
  }, {
    key: "getUtoTmapping",
    value: function getUtoTmapping(t, e) {
      var n = this.getLengths();
      var i = 0;
      var r = n.length;
      var s;
      s = e || t * n[r - 1];
      var a,
          o = 0,
          l = r - 1;

      for (; o <= l;) {
        if (i = Math.floor(o + (l - o) / 2), a = n[i] - s, a < 0) o = i + 1;else {
          if (!(a > 0)) {
            l = i;
            break;
          }

          l = i - 1;
        }
      }

      if (i = l, n[i] === s) return i / (r - 1);
      var c = n[i];
      return (i + (s - c) / (n[i + 1] - c)) / (r - 1);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t, e) {
      var n = 1e-4;
      var i = t - n,
          r = t + n;
      i < 0 && (i = 0), r > 1 && (r = 1);
      var s = this.getPoint(i),
          a = this.getPoint(r),
          o = e || (s.isVector2 ? new pt() : new _t());
      return o.copy(a).sub(s).normalize(), o;
    }
  }, {
    key: "getTangentAt",
    value: function getTangentAt(t, e) {
      var n = this.getUtoTmapping(t);
      return this.getTangent(n, e);
    }
  }, {
    key: "computeFrenetFrames",
    value: function computeFrenetFrames(t, e) {
      var n = new _t(),
          i = [],
          r = [],
          s = [],
          a = new _t(),
          o = new ee();

      for (var _e151 = 0; _e151 <= t; _e151++) {
        var _n143 = _e151 / t;

        i[_e151] = this.getTangentAt(_n143, new _t()), i[_e151].normalize();
      }

      r[0] = new _t(), s[0] = new _t();
      var l = Number.MAX_VALUE;
      var c = Math.abs(i[0].x),
          h = Math.abs(i[0].y),
          u = Math.abs(i[0].z);
      c <= l && (l = c, n.set(1, 0, 0)), h <= l && (l = h, n.set(0, 1, 0)), u <= l && n.set(0, 0, 1), a.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], a), s[0].crossVectors(i[0], r[0]);

      for (var _e152 = 1; _e152 <= t; _e152++) {
        if (r[_e152] = r[_e152 - 1].clone(), s[_e152] = s[_e152 - 1].clone(), a.crossVectors(i[_e152 - 1], i[_e152]), a.length() > Number.EPSILON) {
          a.normalize();

          var _t183 = Math.acos(at(i[_e152 - 1].dot(i[_e152]), -1, 1));

          r[_e152].applyMatrix4(o.makeRotationAxis(a, _t183));
        }

        s[_e152].crossVectors(i[_e152], r[_e152]);
      }

      if (!0 === e) {
        var _e153 = Math.acos(at(r[0].dot(r[t]), -1, 1));

        _e153 /= t, i[0].dot(a.crossVectors(r[0], r[t])) > 0 && (_e153 = -_e153);

        for (var _n144 = 1; _n144 <= t; _n144++) {
          r[_n144].applyMatrix4(o.makeRotationAxis(i[_n144], _e153 * _n144)), s[_n144].crossVectors(i[_n144], r[_n144]);
        }
      }

      return {
        tangents: i,
        normals: r,
        binormals: s
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {
        metadata: {
          version: 4.5,
          type: "Curve",
          generator: "Curve.toJSON"
        }
      };
      return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
  }]);

  return Qa;
}();

var Pa = /*#__PURE__*/function (_Qa) {
  _inherits(Pa, _Qa);

  var _super51 = _createSuper(Pa);

  function Pa() {
    var _this52;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2 * Math.PI;
    var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
    var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

    _classCallCheck(this, Pa);

    _this52 = _super51.call(this), _this52.type = "EllipseCurve", _this52.aX = t, _this52.aY = e, _this52.xRadius = n, _this52.yRadius = i, _this52.aStartAngle = r, _this52.aEndAngle = s, _this52.aClockwise = a, _this52.aRotation = o;
    return _this52;
  }

  _createClass(Pa, [{
    key: "getPoint",
    value: function getPoint(t, e) {
      var n = e || new pt(),
          i = 2 * Math.PI;
      var r = this.aEndAngle - this.aStartAngle;
      var s = Math.abs(r) < Number.EPSILON;

      for (; r < 0;) {
        r += i;
      }

      for (; r > i;) {
        r -= i;
      }

      r < Number.EPSILON && (r = s ? 0 : i), !0 !== this.aClockwise || s || (r === i ? r = -i : r -= i);
      var a = this.aStartAngle + t * r;
      var o = this.aX + this.xRadius * Math.cos(a),
          l = this.aY + this.yRadius * Math.sin(a);

      if (0 !== this.aRotation) {
        var _t184 = Math.cos(this.aRotation),
            _e154 = Math.sin(this.aRotation),
            _n145 = o - this.aX,
            _i121 = l - this.aY;

        o = _n145 * _t184 - _i121 * _e154 + this.aX, l = _n145 * _e154 + _i121 * _t184 + this.aY;
      }

      return n.set(o, l);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Pa.prototype), "copy", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Pa.prototype), "toJSON", this).call(this);

      return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Pa.prototype), "fromJSON", this).call(this, t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
  }]);

  return Pa;
}(Qa);

Pa.prototype.isEllipseCurve = !0;

var Fa = /*#__PURE__*/function (_Pa) {
  _inherits(Fa, _Pa);

  var _super52 = _createSuper(Fa);

  function Fa(t, e, n, i, r, s) {
    var _this53;

    _classCallCheck(this, Fa);

    _this53 = _super52.call(this, t, e, n, n, i, r, s), _this53.type = "ArcCurve";
    return _this53;
  }

  return _createClass(Fa);
}(Pa);

function Na() {
  var t = 0,
      e = 0,
      n = 0,
      i = 0;

  function r(r, s, a, o) {
    t = r, e = a, n = -3 * r + 3 * s - 2 * a - o, i = 2 * r - 2 * s + a + o;
  }

  return {
    initCatmullRom: function initCatmullRom(t, e, n, i, s) {
      r(e, n, s * (n - t), s * (i - e));
    },
    initNonuniformCatmullRom: function initNonuniformCatmullRom(t, e, n, i, s, a, o) {
      var l = (e - t) / s - (n - t) / (s + a) + (n - e) / a,
          c = (n - e) / a - (i - e) / (a + o) + (i - n) / o;
      l *= a, c *= a, r(e, n, l, c);
    },
    calc: function calc(r) {
      var s = r * r;
      return t + e * r + n * s + i * (s * r);
    }
  };
}

Fa.prototype.isArcCurve = !0;
var Ua = new _t(),
    ka = new Na(),
    Ga = new Na(),
    Oa = new Na();

var Ha = /*#__PURE__*/function (_Qa2) {
  _inherits(Ha, _Qa2);

  var _super53 = _createSuper(Ha);

  function Ha() {
    var _this54;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "centripetal";
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .5;

    _classCallCheck(this, Ha);

    _this54 = _super53.call(this), _this54.type = "CatmullRomCurve3", _this54.points = t, _this54.closed = e, _this54.curveType = n, _this54.tension = i;
    return _this54;
  }

  _createClass(Ha, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
      var n = e,
          i = this.points,
          r = i.length,
          s = (r - (this.closed ? 0 : 1)) * t;
      var a,
          o,
          l = Math.floor(s),
          c = s - l;
      this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === c && l === r - 1 && (l = r - 2, c = 1), this.closed || l > 0 ? a = i[(l - 1) % r] : (Ua.subVectors(i[0], i[1]).add(i[0]), a = Ua);
      var h = i[l % r],
          u = i[(l + 1) % r];

      if (this.closed || l + 2 < r ? o = i[(l + 2) % r] : (Ua.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), o = Ua), "centripetal" === this.curveType || "chordal" === this.curveType) {
        var _t185 = "chordal" === this.curveType ? .5 : .25;

        var _e155 = Math.pow(a.distanceToSquared(h), _t185),
            _n146 = Math.pow(h.distanceToSquared(u), _t185),
            _i122 = Math.pow(u.distanceToSquared(o), _t185);

        _n146 < 1e-4 && (_n146 = 1), _e155 < 1e-4 && (_e155 = _n146), _i122 < 1e-4 && (_i122 = _n146), ka.initNonuniformCatmullRom(a.x, h.x, u.x, o.x, _e155, _n146, _i122), Ga.initNonuniformCatmullRom(a.y, h.y, u.y, o.y, _e155, _n146, _i122), Oa.initNonuniformCatmullRom(a.z, h.z, u.z, o.z, _e155, _n146, _i122);
      } else "catmullrom" === this.curveType && (ka.initCatmullRom(a.x, h.x, u.x, o.x, this.tension), Ga.initCatmullRom(a.y, h.y, u.y, o.y, this.tension), Oa.initCatmullRom(a.z, h.z, u.z, o.z, this.tension));

      return n.set(ka.calc(c), Ga.calc(c), Oa.calc(c)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(Ha.prototype), "copy", this).call(this, t), this.points = [];

      for (var _e156 = 0, _n147 = t.points.length; _e156 < _n147; _e156++) {
        var _n148 = t.points[_e156];
        this.points.push(_n148.clone());
      }

      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ha.prototype), "toJSON", this).call(this);

      t.points = [];

      for (var _e157 = 0, _n149 = this.points.length; _e157 < _n149; _e157++) {
        var _n150 = this.points[_e157];
        t.points.push(_n150.toArray());
      }

      return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(Ha.prototype), "fromJSON", this).call(this, t), this.points = [];

      for (var _e158 = 0, _n151 = t.points.length; _e158 < _n151; _e158++) {
        var _n152 = t.points[_e158];
        this.points.push(new _t().fromArray(_n152));
      }

      return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
  }]);

  return Ha;
}(Qa);

function za(t, e, n, i, r) {
  var s = .5 * (i - e),
      a = .5 * (r - n),
      o = t * t;
  return (2 * n - 2 * i + s + a) * (t * o) + (-3 * n + 3 * i - 2 * s - a) * o + s * t + n;
}

function Va(t, e, n, i) {
  return function (t, e) {
    var n = 1 - t;
    return n * n * e;
  }(t, e) + function (t, e) {
    return 2 * (1 - t) * t * e;
  }(t, n) + function (t, e) {
    return t * t * e;
  }(t, i);
}

function Wa(t, e, n, i, r) {
  return function (t, e) {
    var n = 1 - t;
    return n * n * n * e;
  }(t, e) + function (t, e) {
    var n = 1 - t;
    return 3 * n * n * t * e;
  }(t, n) + function (t, e) {
    return 3 * (1 - t) * t * t * e;
  }(t, i) + function (t, e) {
    return t * t * t * e;
  }(t, r);
}

Ha.prototype.isCatmullRomCurve3 = !0;

var qa = /*#__PURE__*/function (_Qa3) {
  _inherits(qa, _Qa3);

  var _super54 = _createSuper(qa);

  function qa() {
    var _this55;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new pt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new pt();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new pt();

    _classCallCheck(this, qa);

    _this55 = _super54.call(this), _this55.type = "CubicBezierCurve", _this55.v0 = t, _this55.v1 = e, _this55.v2 = n, _this55.v3 = i;
    return _this55;
  }

  _createClass(qa, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2,
          a = this.v3;
      return n.set(Wa(t, i.x, r.x, s.x, a.x), Wa(t, i.y, r.y, s.y, a.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(qa.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(qa.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(qa.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
  }]);

  return qa;
}(Qa);

qa.prototype.isCubicBezierCurve = !0;

var ja = /*#__PURE__*/function (_Qa4) {
  _inherits(ja, _Qa4);

  var _super55 = _createSuper(ja);

  function ja() {
    var _this56;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _t();
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _t();

    _classCallCheck(this, ja);

    _this56 = _super55.call(this), _this56.type = "CubicBezierCurve3", _this56.v0 = t, _this56.v1 = e, _this56.v2 = n, _this56.v3 = i;
    return _this56;
  }

  _createClass(ja, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2,
          a = this.v3;
      return n.set(Wa(t, i.x, r.x, s.x, a.x), Wa(t, i.y, r.y, s.y, a.y), Wa(t, i.z, r.z, s.z, a.z)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ja.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(ja.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(ja.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
  }]);

  return ja;
}(Qa);

ja.prototype.isCubicBezierCurve3 = !0;

var Ya = /*#__PURE__*/function (_Qa5) {
  _inherits(Ya, _Qa5);

  var _super56 = _createSuper(Ya);

  function Ya() {
    var _this57;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new pt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();

    _classCallCheck(this, Ya);

    _this57 = _super56.call(this), _this57.type = "LineCurve", _this57.v1 = t, _this57.v2 = e;
    return _this57;
  }

  _createClass(Ya, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
      var n = e;
      return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
    }
  }, {
    key: "getPointAt",
    value: function getPointAt(t, e) {
      return this.getPoint(t, e);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t, e) {
      var n = e || new pt();
      return n.copy(this.v2).sub(this.v1).normalize(), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ya.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ya.prototype), "toJSON", this).call(this);

      return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Ya.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Ya;
}(Qa);

Ya.prototype.isLineCurve = !0;

var Ja = /*#__PURE__*/function (_Qa6) {
  _inherits(Ja, _Qa6);

  var _super57 = _createSuper(Ja);

  function Ja() {
    var _this58;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new pt();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new pt();

    _classCallCheck(this, Ja);

    _this58 = _super57.call(this), _this58.type = "QuadraticBezierCurve", _this58.v0 = t, _this58.v1 = e, _this58.v2 = n;
    return _this58;
  }

  _createClass(Ja, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2;
      return n.set(Va(t, i.x, r.x, s.x), Va(t, i.y, r.y, s.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ja.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ja.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Ja.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Ja;
}(Qa);

Ja.prototype.isQuadraticBezierCurve = !0;

var Xa = /*#__PURE__*/function (_Qa7) {
  _inherits(Xa, _Qa7);

  var _super58 = _createSuper(Xa);

  function Xa() {
    var _this59;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _t();

    _classCallCheck(this, Xa);

    _this59 = _super58.call(this), _this59.type = "QuadraticBezierCurve3", _this59.v0 = t, _this59.v1 = e, _this59.v2 = n;
    return _this59;
  }

  _createClass(Xa, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
      var n = e,
          i = this.v0,
          r = this.v1,
          s = this.v2;
      return n.set(Va(t, i.x, r.x, s.x), Va(t, i.y, r.y, s.y), Va(t, i.z, r.z, s.z)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Xa.prototype), "copy", this).call(this, t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Xa.prototype), "toJSON", this).call(this);

      return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(Xa.prototype), "fromJSON", this).call(this, t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
  }]);

  return Xa;
}(Qa);

Xa.prototype.isQuadraticBezierCurve3 = !0;

var Ka = /*#__PURE__*/function (_Qa8) {
  _inherits(Ka, _Qa8);

  var _super59 = _createSuper(Ka);

  function Ka() {
    var _this60;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Ka);

    _this60 = _super59.call(this), _this60.type = "SplineCurve", _this60.points = t;
    return _this60;
  }

  _createClass(Ka, [{
    key: "getPoint",
    value: function getPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pt();
      var n = e,
          i = this.points,
          r = (i.length - 1) * t,
          s = Math.floor(r),
          a = r - s,
          o = i[0 === s ? s : s - 1],
          l = i[s],
          c = i[s > i.length - 2 ? i.length - 1 : s + 1],
          h = i[s > i.length - 3 ? i.length - 1 : s + 2];
      return n.set(za(a, o.x, l.x, c.x, h.x), za(a, o.y, l.y, c.y, h.y)), n;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(Ka.prototype), "copy", this).call(this, t), this.points = [];

      for (var _e159 = 0, _n153 = t.points.length; _e159 < _n153; _e159++) {
        var _n154 = t.points[_e159];
        this.points.push(_n154.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(Ka.prototype), "toJSON", this).call(this);

      t.points = [];

      for (var _e160 = 0, _n155 = this.points.length; _e160 < _n155; _e160++) {
        var _n156 = this.points[_e160];
        t.points.push(_n156.toArray());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(Ka.prototype), "fromJSON", this).call(this, t), this.points = [];

      for (var _e161 = 0, _n157 = t.points.length; _e161 < _n157; _e161++) {
        var _n158 = t.points[_e161];
        this.points.push(new pt().fromArray(_n158));
      }

      return this;
    }
  }]);

  return Ka;
}(Qa);

Ka.prototype.isSplineCurve = !0;
var Za = Object.freeze({
  __proto__: null,
  ArcCurve: Fa,
  CatmullRomCurve3: Ha,
  CubicBezierCurve: qa,
  CubicBezierCurve3: ja,
  EllipseCurve: Pa,
  LineCurve: Ya,
  LineCurve3: /*#__PURE__*/function (_Qa9) {
    _inherits(LineCurve3, _Qa9);

    var _super60 = _createSuper(LineCurve3);

    function LineCurve3() {
      var _this61;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _t();
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();

      _classCallCheck(this, LineCurve3);

      _this61 = _super60.call(this), _this61.type = "LineCurve3", _this61.isLineCurve3 = !0, _this61.v1 = t, _this61.v2 = e;
      return _this61;
    }

    _createClass(LineCurve3, [{
      key: "getPoint",
      value: function getPoint(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _t();
        var n = e;
        return 1 === t ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
      }
    }, {
      key: "getPointAt",
      value: function getPointAt(t, e) {
        return this.getPoint(t, e);
      }
    }, {
      key: "copy",
      value: function copy(t) {
        return _get(_getPrototypeOf(LineCurve3.prototype), "copy", this).call(this, t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        var t = _get(_getPrototypeOf(LineCurve3.prototype), "toJSON", this).call(this);

        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return _get(_getPrototypeOf(LineCurve3.prototype), "fromJSON", this).call(this, t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
      }
    }]);

    return LineCurve3;
  }(Qa),
  QuadraticBezierCurve: Ja,
  QuadraticBezierCurve3: Xa,
  SplineCurve: Ka
});

var $a = function $a(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var i = e && e.length,
      r = i ? e[0] * n : t.length;
  var s = to(t, 0, r, n, !0);
  var a = [];
  if (!s || s.next === s.prev) return a;
  var o, l, c, h, u, d, p;

  if (i && (s = function (t, e, n, i) {
    var r = [];
    var s, a, o, l, c;

    for (s = 0, a = e.length; s < a; s++) {
      o = e[s] * i, l = s < a - 1 ? e[s + 1] * i : t.length, c = to(t, o, l, i, !1), c === c.next && (c.steiner = !0), r.push(uo(c));
    }

    for (r.sort(oo), s = 0; s < r.length; s++) {
      lo(r[s], n), n = eo(n, n.next);
    }

    return n;
  }(t, e, s, n)), t.length > 80 * n) {
    o = c = t[0], l = h = t[1];

    for (var _e162 = n; _e162 < r; _e162 += n) {
      u = t[_e162], d = t[_e162 + 1], u < o && (o = u), d < l && (l = d), u > c && (c = u), d > h && (h = d);
    }

    p = Math.max(c - o, h - l), p = 0 !== p ? 1 / p : 0;
  }

  return no(s, a, n, o, l, p), a;
};

function to(t, e, n, i, r) {
  var s, a;
  if (r === function (t, e, n, i) {
    var r = 0;

    for (var _s55 = e, _a43 = n - i; _s55 < n; _s55 += i) {
      r += (t[_a43] - t[_s55]) * (t[_s55 + 1] + t[_a43 + 1]), _a43 = _s55;
    }

    return r;
  }(t, e, n, i) > 0) for (s = e; s < n; s += i) {
    a = Eo(s, t[s], t[s + 1], a);
  } else for (s = n - i; s >= e; s -= i) {
    a = Eo(s, t[s], t[s + 1], a);
  }
  return a && go(a, a.next) && (bo(a), a = a.next), a;
}

function eo(t, e) {
  if (!t) return t;
  e || (e = t);
  var n,
      i = t;

  do {
    if (n = !1, i.steiner || !go(i, i.next) && 0 !== mo(i.prev, i, i.next)) i = i.next;else {
      if (bo(i), i = e = i.prev, i === i.next) break;
      n = !0;
    }
  } while (n || i !== e);

  return e;
}

function no(t, e, n, i, r, s, a) {
  if (!t) return;
  !a && s && function (t, e, n, i) {
    var r = t;

    do {
      null === r.z && (r.z = ho(r.x, r.y, e, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
    } while (r !== t);

    r.prevZ.nextZ = null, r.prevZ = null, function (t) {
      var e,
          n,
          i,
          r,
          s,
          a,
          o,
          l,
          c = 1;

      do {
        for (n = t, t = null, s = null, a = 0; n;) {
          for (a++, i = n, o = 0, e = 0; e < c && (o++, i = i.nextZ, i); e++) {
            ;
          }

          for (l = c; o > 0 || l > 0 && i;) {
            0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), s ? s.nextZ = r : t = r, r.prevZ = s, s = r;
          }

          n = i;
        }

        s.nextZ = null, c *= 2;
      } while (a > 1);
    }(r);
  }(t, i, r, s);
  var o,
      l,
      c = t;

  for (; t.prev !== t.next;) {
    if (o = t.prev, l = t.next, s ? ro(t, i, r, s) : io(t)) e.push(o.i / n), e.push(t.i / n), e.push(l.i / n), bo(t), t = l.next, c = l.next;else if ((t = l) === c) {
      a ? 1 === a ? no(t = so(eo(t), e, n), e, n, i, r, s, 2) : 2 === a && ao(t, e, n, i, r, s) : no(eo(t), e, n, i, r, s, 1);
      break;
    }
  }
}

function io(t) {
  var e = t.prev,
      n = t,
      i = t.next;
  if (mo(e, n, i) >= 0) return !1;
  var r = t.next.next;

  for (; r !== t.prev;) {
    if (po(e.x, e.y, n.x, n.y, i.x, i.y, r.x, r.y) && mo(r.prev, r, r.next) >= 0) return !1;
    r = r.next;
  }

  return !0;
}

function ro(t, e, n, i) {
  var r = t.prev,
      s = t,
      a = t.next;
  if (mo(r, s, a) >= 0) return !1;
  var o = r.x < s.x ? r.x < a.x ? r.x : a.x : s.x < a.x ? s.x : a.x,
      l = r.y < s.y ? r.y < a.y ? r.y : a.y : s.y < a.y ? s.y : a.y,
      c = r.x > s.x ? r.x > a.x ? r.x : a.x : s.x > a.x ? s.x : a.x,
      h = r.y > s.y ? r.y > a.y ? r.y : a.y : s.y > a.y ? s.y : a.y,
      u = ho(o, l, e, n, i),
      d = ho(c, h, e, n, i);
  var p = t.prevZ,
      A = t.nextZ;

  for (; p && p.z >= u && A && A.z <= d;) {
    if (p !== t.prev && p !== t.next && po(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && mo(p.prev, p, p.next) >= 0) return !1;
    if (p = p.prevZ, A !== t.prev && A !== t.next && po(r.x, r.y, s.x, s.y, a.x, a.y, A.x, A.y) && mo(A.prev, A, A.next) >= 0) return !1;
    A = A.nextZ;
  }

  for (; p && p.z >= u;) {
    if (p !== t.prev && p !== t.next && po(r.x, r.y, s.x, s.y, a.x, a.y, p.x, p.y) && mo(p.prev, p, p.next) >= 0) return !1;
    p = p.prevZ;
  }

  for (; A && A.z <= d;) {
    if (A !== t.prev && A !== t.next && po(r.x, r.y, s.x, s.y, a.x, a.y, A.x, A.y) && mo(A.prev, A, A.next) >= 0) return !1;
    A = A.nextZ;
  }

  return !0;
}

function so(t, e, n) {
  var i = t;

  do {
    var _r98 = i.prev,
        _s56 = i.next.next;
    !go(_r98, _s56) && fo(_r98, i, i.next, _s56) && xo(_r98, _s56) && xo(_s56, _r98) && (e.push(_r98.i / n), e.push(i.i / n), e.push(_s56.i / n), bo(i), bo(i.next), i = t = _s56), i = i.next;
  } while (i !== t);

  return eo(i);
}

function ao(t, e, n, i, r, s) {
  var a = t;

  do {
    var _t186 = a.next.next;

    for (; _t186 !== a.prev;) {
      if (a.i !== _t186.i && Ao(a, _t186)) {
        var _o27 = wo(a, _t186);

        return a = eo(a, a.next), _o27 = eo(_o27, _o27.next), no(a, e, n, i, r, s), void no(_o27, e, n, i, r, s);
      }

      _t186 = _t186.next;
    }

    a = a.next;
  } while (a !== t);
}

function oo(t, e) {
  return t.x - e.x;
}

function lo(t, e) {
  if (e = function (t, e) {
    var n = e;
    var i = t.x,
        r = t.y;
    var s,
        a = -1 / 0;

    do {
      if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
        var _t187 = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);

        if (_t187 <= i && _t187 > a) {
          if (a = _t187, _t187 === i) {
            if (r === n.y) return n;
            if (r === n.next.y) return n.next;
          }

          s = n.x < n.next.x ? n : n.next;
        }
      }

      n = n.next;
    } while (n !== e);

    if (!s) return null;
    if (i === a) return s;
    var o = s,
        l = s.x,
        c = s.y;
    var h,
        u = 1 / 0;
    n = s;

    do {
      i >= n.x && n.x >= l && i !== n.x && po(r < c ? i : a, r, l, c, r < c ? a : i, r, n.x, n.y) && (h = Math.abs(r - n.y) / (i - n.x), xo(n, t) && (h < u || h === u && (n.x > s.x || n.x === s.x && co(s, n))) && (s = n, u = h)), n = n.next;
    } while (n !== o);

    return s;
  }(t, e)) {
    var _n159 = wo(e, t);

    eo(e, e.next), eo(_n159, _n159.next);
  }
}

function co(t, e) {
  return mo(t.prev, t, e.prev) < 0 && mo(e.next, t, t.next) < 0;
}

function ho(t, e, n, i, r) {
  return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * r) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * r) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
}

function uo(t) {
  var e = t,
      n = t;

  do {
    (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
  } while (e !== t);

  return n;
}

function po(t, e, n, i, r, s, a, o) {
  return (r - a) * (e - o) - (t - a) * (s - o) >= 0 && (t - a) * (i - o) - (n - a) * (e - o) >= 0 && (n - a) * (s - o) - (r - a) * (i - o) >= 0;
}

function Ao(t, e) {
  return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
    var n = t;

    do {
      if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && fo(n, n.next, t, e)) return !0;
      n = n.next;
    } while (n !== t);

    return !1;
  }(t, e) && (xo(t, e) && xo(e, t) && function (t, e) {
    var n = t,
        i = !1;
    var r = (t.x + e.x) / 2,
        s = (t.y + e.y) / 2;

    do {
      n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
    } while (n !== t);

    return i;
  }(t, e) && (mo(t.prev, t, e.prev) || mo(t, e.prev, e)) || go(t, e) && mo(t.prev, t, t.next) > 0 && mo(e.prev, e, e.next) > 0);
}

function mo(t, e, n) {
  return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}

function go(t, e) {
  return t.x === e.x && t.y === e.y;
}

function fo(t, e, n, i) {
  var r = yo(mo(t, e, n)),
      s = yo(mo(t, e, i)),
      a = yo(mo(n, i, t)),
      o = yo(mo(n, i, e));
  return r !== s && a !== o || !(0 !== r || !vo(t, n, e)) || !(0 !== s || !vo(t, i, e)) || !(0 !== a || !vo(n, t, i)) || !(0 !== o || !vo(n, e, i));
}

function vo(t, e, n) {
  return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}

function yo(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}

function xo(t, e) {
  return mo(t.prev, t, t.next) < 0 ? mo(t, e, t.next) >= 0 && mo(t, t.prev, e) >= 0 : mo(t, e, t.prev) < 0 || mo(t, t.next, e) < 0;
}

function wo(t, e) {
  var n = new _o(t.i, t.x, t.y),
      i = new _o(e.i, e.x, e.y),
      r = t.next,
      s = e.prev;
  return t.next = e, e.prev = t, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, i.prev = s, i;
}

function Eo(t, e, n, i) {
  var r = new _o(t, e, n);
  return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
}

function bo(t) {
  t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}

function _o(t, e, n) {
  this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}

var Io = /*#__PURE__*/function () {
  function Io() {
    _classCallCheck(this, Io);
  }

  _createClass(Io, null, [{
    key: "area",
    value: function area(t) {
      var e = t.length;
      var n = 0;

      for (var _i123 = e - 1, _r99 = 0; _r99 < e; _i123 = _r99++) {
        n += t[_i123].x * t[_r99].y - t[_r99].x * t[_i123].y;
      }

      return .5 * n;
    }
  }, {
    key: "isClockWise",
    value: function isClockWise(t) {
      return Io.area(t) < 0;
    }
  }, {
    key: "triangulateShape",
    value: function triangulateShape(t, e) {
      var n = [],
          i = [],
          r = [];
      Co(t), Mo(n, t);
      var s = t.length;
      e.forEach(Co);

      for (var _t188 = 0; _t188 < e.length; _t188++) {
        i.push(s), s += e[_t188].length, Mo(n, e[_t188]);
      }

      var a = $a(n, i);

      for (var _t189 = 0; _t189 < a.length; _t189 += 3) {
        r.push(a.slice(_t189, _t189 + 3));
      }

      return r;
    }
  }]);

  return Io;
}();

function Co(t) {
  var e = t.length;
  e > 2 && t[e - 1].equals(t[0]) && t.pop();
}

function Mo(t, e) {
  for (var _n160 = 0; _n160 < e.length; _n160++) {
    t.push(e[_n160].x), t.push(e[_n160].y);
  }
}

var So = /*#__PURE__*/function (_cn3) {
  _inherits(So, _cn3);

  var _super61 = _createSuper(So);

  function So(t, e) {
    var _this62;

    _classCallCheck(this, So);

    _this62 = _super61.call(this), _this62.type = "ExtrudeGeometry", _this62.parameters = {
      shapes: t,
      options: e
    }, t = Array.isArray(t) ? t : [t];

    var n = _assertThisInitialized(_this62),
        i = [],
        r = [];

    for (var _e163 = 0, _n161 = t.length; _e163 < _n161; _e163++) {
      s(t[_e163]);
    }

    function s(t) {
      var s = [],
          a = void 0 !== e.curveSegments ? e.curveSegments : 12,
          o = void 0 !== e.steps ? e.steps : 1;
      var l = void 0 !== e.depth ? e.depth : 100,
          c = void 0 === e.bevelEnabled || e.bevelEnabled,
          h = void 0 !== e.bevelThickness ? e.bevelThickness : 6,
          u = void 0 !== e.bevelSize ? e.bevelSize : h - 2,
          d = void 0 !== e.bevelOffset ? e.bevelOffset : 0,
          p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
      var A = e.extrudePath,
          m = void 0 !== e.UVGenerator ? e.UVGenerator : Bo;
      void 0 !== e.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = e.amount);
      var g,
          f,
          v,
          y,
          x,
          w = !1;
      A && (g = A.getSpacedPoints(o), w = !0, c = !1, f = A.computeFrenetFrames(o, !1), v = new _t(), y = new _t(), x = new _t()), c || (p = 0, h = 0, u = 0, d = 0);
      var E = t.extractPoints(a);
      var b = E.shape;
      var _ = E.holes;

      if (!Io.isClockWise(b)) {
        b = b.reverse();

        for (var _t190 = 0, _e164 = _.length; _t190 < _e164; _t190++) {
          var _e165 = _[_t190];
          Io.isClockWise(_e165) && (_[_t190] = _e165.reverse());
        }
      }

      var I = Io.triangulateShape(b, _),
          C = b;

      for (var _t191 = 0, _e166 = _.length; _t191 < _e166; _t191++) {
        var _e167 = _[_t191];
        b = b.concat(_e167);
      }

      function M(t, e, n) {
        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), e.clone().multiplyScalar(n).add(t);
      }

      var S = b.length,
          B = I.length;

      function T(t, e, n) {
        var i, r, s;
        var a = t.x - e.x,
            o = t.y - e.y,
            l = n.x - t.x,
            c = n.y - t.y,
            h = a * a + o * o,
            u = a * c - o * l;

        if (Math.abs(u) > Number.EPSILON) {
          var _u11 = Math.sqrt(h),
              _d11 = Math.sqrt(l * l + c * c),
              _p9 = e.x - o / _u11,
              _A6 = e.y + a / _u11,
              _m3 = ((n.x - c / _d11 - _p9) * c - (n.y + l / _d11 - _A6) * l) / (a * c - o * l);

          i = _p9 + a * _m3 - t.x, r = _A6 + o * _m3 - t.y;

          var _g3 = i * i + r * r;

          if (_g3 <= 2) return new pt(i, r);
          s = Math.sqrt(_g3 / 2);
        } else {
          var _t192 = !1;

          a > Number.EPSILON ? l > Number.EPSILON && (_t192 = !0) : a < -Number.EPSILON ? l < -Number.EPSILON && (_t192 = !0) : Math.sign(o) === Math.sign(c) && (_t192 = !0), _t192 ? (i = -o, r = a, s = Math.sqrt(h)) : (i = a, r = o, s = Math.sqrt(h / 2));
        }

        return new pt(i / s, r / s);
      }

      var L = [];

      for (var _t193 = 0, _e168 = C.length, _n162 = _e168 - 1, _i124 = _t193 + 1; _t193 < _e168; _t193++, _n162++, _i124++) {
        _n162 === _e168 && (_n162 = 0), _i124 === _e168 && (_i124 = 0), L[_t193] = T(C[_t193], C[_n162], C[_i124]);
      }

      var R = [];
      var D,
          Q = L.concat();

      for (var _t194 = 0, _e169 = _.length; _t194 < _e169; _t194++) {
        var _e170 = _[_t194];
        D = [];

        for (var _t195 = 0, _n163 = _e170.length, _i125 = _n163 - 1, _r100 = _t195 + 1; _t195 < _n163; _t195++, _i125++, _r100++) {
          _i125 === _n163 && (_i125 = 0), _r100 === _n163 && (_r100 = 0), D[_t195] = T(_e170[_t195], _e170[_i125], _e170[_r100]);
        }

        R.push(D), Q = Q.concat(D);
      }

      for (var _t196 = 0; _t196 < p; _t196++) {
        var _e171 = _t196 / p,
            _n164 = h * Math.cos(_e171 * Math.PI / 2),
            _i126 = u * Math.sin(_e171 * Math.PI / 2) + d;

        for (var _t197 = 0, _e172 = C.length; _t197 < _e172; _t197++) {
          var _e173 = M(C[_t197], L[_t197], _i126);

          N(_e173.x, _e173.y, -_n164);
        }

        for (var _t198 = 0, _e174 = _.length; _t198 < _e174; _t198++) {
          var _e175 = _[_t198];
          D = R[_t198];

          for (var _t199 = 0, _r101 = _e175.length; _t199 < _r101; _t199++) {
            var _r102 = M(_e175[_t199], D[_t199], _i126);

            N(_r102.x, _r102.y, -_n164);
          }
        }
      }

      var P = u + d;

      for (var _t200 = 0; _t200 < S; _t200++) {
        var _e176 = c ? M(b[_t200], Q[_t200], P) : b[_t200];

        w ? (y.copy(f.normals[0]).multiplyScalar(_e176.x), v.copy(f.binormals[0]).multiplyScalar(_e176.y), x.copy(g[0]).add(y).add(v), N(x.x, x.y, x.z)) : N(_e176.x, _e176.y, 0);
      }

      for (var _t201 = 1; _t201 <= o; _t201++) {
        for (var _e177 = 0; _e177 < S; _e177++) {
          var _n165 = c ? M(b[_e177], Q[_e177], P) : b[_e177];

          w ? (y.copy(f.normals[_t201]).multiplyScalar(_n165.x), v.copy(f.binormals[_t201]).multiplyScalar(_n165.y), x.copy(g[_t201]).add(y).add(v), N(x.x, x.y, x.z)) : N(_n165.x, _n165.y, l / o * _t201);
        }
      }

      for (var _t202 = p - 1; _t202 >= 0; _t202--) {
        var _e178 = _t202 / p,
            _n166 = h * Math.cos(_e178 * Math.PI / 2),
            _i127 = u * Math.sin(_e178 * Math.PI / 2) + d;

        for (var _t203 = 0, _e179 = C.length; _t203 < _e179; _t203++) {
          var _e180 = M(C[_t203], L[_t203], _i127);

          N(_e180.x, _e180.y, l + _n166);
        }

        for (var _t204 = 0, _e181 = _.length; _t204 < _e181; _t204++) {
          var _e182 = _[_t204];
          D = R[_t204];

          for (var _t205 = 0, _r103 = _e182.length; _t205 < _r103; _t205++) {
            var _r104 = M(_e182[_t205], D[_t205], _i127);

            w ? N(_r104.x, _r104.y + g[o - 1].y, g[o - 1].x + _n166) : N(_r104.x, _r104.y, l + _n166);
          }
        }
      }

      function F(t, e) {
        var n = t.length;

        for (; --n >= 0;) {
          var _i128 = n;

          var _r105 = n - 1;

          _r105 < 0 && (_r105 = t.length - 1);

          for (var _t206 = 0, _n167 = o + 2 * p; _t206 < _n167; _t206++) {
            var _n168 = S * _t206,
                _s57 = S * (_t206 + 1);

            k(e + _i128 + _n168, e + _r105 + _n168, e + _r105 + _s57, e + _i128 + _s57);
          }
        }
      }

      function N(t, e, n) {
        s.push(t), s.push(e), s.push(n);
      }

      function U(t, e, r) {
        G(t), G(e), G(r);
        var s = i.length / 3,
            a = m.generateTopUV(n, i, s - 3, s - 2, s - 1);
        O(a[0]), O(a[1]), O(a[2]);
      }

      function k(t, e, r, s) {
        G(t), G(e), G(s), G(e), G(r), G(s);
        var a = i.length / 3,
            o = m.generateSideWallUV(n, i, a - 6, a - 3, a - 2, a - 1);
        O(o[0]), O(o[1]), O(o[3]), O(o[1]), O(o[2]), O(o[3]);
      }

      function G(t) {
        i.push(s[3 * t + 0]), i.push(s[3 * t + 1]), i.push(s[3 * t + 2]);
      }

      function O(t) {
        r.push(t.x), r.push(t.y);
      }

      !function () {
        var t = i.length / 3;

        if (c) {
          var _t207 = 0,
              _e183 = S * _t207;

          for (var _t208 = 0; _t208 < B; _t208++) {
            var _n169 = I[_t208];
            U(_n169[2] + _e183, _n169[1] + _e183, _n169[0] + _e183);
          }

          _t207 = o + 2 * p, _e183 = S * _t207;

          for (var _t209 = 0; _t209 < B; _t209++) {
            var _n170 = I[_t209];
            U(_n170[0] + _e183, _n170[1] + _e183, _n170[2] + _e183);
          }
        } else {
          for (var _t210 = 0; _t210 < B; _t210++) {
            var _e184 = I[_t210];
            U(_e184[2], _e184[1], _e184[0]);
          }

          for (var _t211 = 0; _t211 < B; _t211++) {
            var _e185 = I[_t211];
            U(_e185[0] + S * o, _e185[1] + S * o, _e185[2] + S * o);
          }
        }

        n.addGroup(t, i.length / 3 - t, 0);
      }(), function () {
        var t = i.length / 3;
        var e = 0;
        F(C, e), e += C.length;

        for (var _t212 = 0, _n171 = _.length; _t212 < _n171; _t212++) {
          var _n172 = _[_t212];
          F(_n172, e), e += _n172.length;
        }

        n.addGroup(t, i.length / 3 - t, 1);
      }();
    }

    _this62.setAttribute("position", new $e(i, 3)), _this62.setAttribute("uv", new $e(r, 2)), _this62.computeVertexNormals();
    return _this62;
  }

  _createClass(So, [{
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(So.prototype), "toJSON", this).call(this);

      return function (t, e, n) {
        if (n.shapes = [], Array.isArray(t)) for (var _e186 = 0, _i129 = t.length; _e186 < _i129; _e186++) {
          var _i130 = t[_e186];
          n.shapes.push(_i130.uuid);
        } else n.shapes.push(t.uuid);
        void 0 !== e.extrudePath && (n.options.extrudePath = e.extrudePath.toJSON());
        return n;
      }(this.parameters.shapes, this.parameters.options, t);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(t, e) {
      var n = [];

      for (var _i131 = 0, _r106 = t.shapes.length; _i131 < _r106; _i131++) {
        var _r107 = e[t.shapes[_i131]];
        n.push(_r107);
      }

      var i = t.options.extrudePath;
      return void 0 !== i && (t.options.extrudePath = new Za[i.type]().fromJSON(i)), new So(n, t.options);
    }
  }]);

  return So;
}(cn);

var Bo = {
  generateTopUV: function generateTopUV(t, e, n, i, r) {
    var s = e[3 * n],
        a = e[3 * n + 1],
        o = e[3 * i],
        l = e[3 * i + 1],
        c = e[3 * r],
        h = e[3 * r + 1];
    return [new pt(s, a), new pt(o, l), new pt(c, h)];
  },
  generateSideWallUV: function generateSideWallUV(t, e, n, i, r, s) {
    var a = e[3 * n],
        o = e[3 * n + 1],
        l = e[3 * n + 2],
        c = e[3 * i],
        h = e[3 * i + 1],
        u = e[3 * i + 2],
        d = e[3 * r],
        p = e[3 * r + 1],
        A = e[3 * r + 2],
        m = e[3 * s],
        g = e[3 * s + 1],
        f = e[3 * s + 2];
    return Math.abs(o - h) < Math.abs(a - c) ? [new pt(a, 1 - l), new pt(c, 1 - u), new pt(d, 1 - A), new pt(m, 1 - f)] : [new pt(o, 1 - l), new pt(h, 1 - u), new pt(p, 1 - A), new pt(g, 1 - f)];
  }
};

var To = /*#__PURE__*/function (_cn4) {
  _inherits(To, _cn4);

  var _super62 = _createSuper(To);

  function To(t) {
    var _this63;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

    _classCallCheck(this, To);

    _this63 = _super62.call(this), _this63.type = "ShapeGeometry", _this63.parameters = {
      shapes: t,
      curveSegments: e
    };
    var n = [],
        i = [],
        r = [],
        s = [];
    var a = 0,
        o = 0;
    if (!1 === Array.isArray(t)) l(t);else for (var _e187 = 0; _e187 < t.length; _e187++) {
      l(t[_e187]), _this63.addGroup(a, o, _e187), a += o, o = 0;
    }

    function l(t) {
      var a = i.length / 3,
          l = t.extractPoints(e);
      var c = l.shape;
      var h = l.holes;
      !1 === Io.isClockWise(c) && (c = c.reverse());

      for (var _t213 = 0, _e188 = h.length; _t213 < _e188; _t213++) {
        var _e189 = h[_t213];
        !0 === Io.isClockWise(_e189) && (h[_t213] = _e189.reverse());
      }

      var u = Io.triangulateShape(c, h);

      for (var _t214 = 0, _e190 = h.length; _t214 < _e190; _t214++) {
        var _e191 = h[_t214];
        c = c.concat(_e191);
      }

      for (var _t215 = 0, _e192 = c.length; _t215 < _e192; _t215++) {
        var _e193 = c[_t215];
        i.push(_e193.x, _e193.y, 0), r.push(0, 0, 1), s.push(_e193.x, _e193.y);
      }

      for (var _t216 = 0, _e194 = u.length; _t216 < _e194; _t216++) {
        var _e195 = u[_t216],
            _i132 = _e195[0] + a,
            _r108 = _e195[1] + a,
            _s58 = _e195[2] + a;

        n.push(_i132, _r108, _s58), o += 3;
      }
    }

    _this63.setIndex(n), _this63.setAttribute("position", new $e(i, 3)), _this63.setAttribute("normal", new $e(r, 3)), _this63.setAttribute("uv", new $e(s, 2));
    return _this63;
  }

  _createClass(To, [{
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(To.prototype), "toJSON", this).call(this);

      return function (t, e) {
        if (e.shapes = [], Array.isArray(t)) for (var _n173 = 0, _i133 = t.length; _n173 < _i133; _n173++) {
          var _i134 = t[_n173];
          e.shapes.push(_i134.uuid);
        } else e.shapes.push(t.uuid);
        return e;
      }(this.parameters.shapes, t);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(t, e) {
      var n = [];

      for (var _i135 = 0, _r109 = t.shapes.length; _i135 < _r109; _i135++) {
        var _r110 = e[t.shapes[_i135]];
        n.push(_r110);
      }

      return new To(n, t.curveSegments);
    }
  }]);

  return To;
}(cn);

var Lo = /*#__PURE__*/function (_ke8) {
  _inherits(Lo, _ke8);

  var _super63 = _createSuper(Lo);

  function Lo(t) {
    var _this64;

    _classCallCheck(this, Lo);

    _this64 = _super63.call(this), _this64.type = "ShadowMaterial", _this64.color = new qe(0), _this64.transparent = !0, _this64.setValues(t);
    return _this64;
  }

  _createClass(Lo, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Lo.prototype), "copy", this).call(this, t), this.color.copy(t.color), this;
    }
  }]);

  return Lo;
}(ke);

Lo.prototype.isShadowMaterial = !0;

var Ro = /*#__PURE__*/function (_ke9) {
  _inherits(Ro, _ke9);

  var _super64 = _createSuper(Ro);

  function Ro(t) {
    var _this65;

    _classCallCheck(this, Ro);

    _this65 = _super64.call(this), _this65.defines = {
      STANDARD: ""
    }, _this65.type = "MeshStandardMaterial", _this65.color = new qe(16777215), _this65.roughness = 1, _this65.metalness = 0, _this65.map = null, _this65.lightMap = null, _this65.lightMapIntensity = 1, _this65.aoMap = null, _this65.aoMapIntensity = 1, _this65.emissive = new qe(0), _this65.emissiveIntensity = 1, _this65.emissiveMap = null, _this65.bumpMap = null, _this65.bumpScale = 1, _this65.normalMap = null, _this65.normalMapType = 0, _this65.normalScale = new pt(1, 1), _this65.displacementMap = null, _this65.displacementScale = 1, _this65.displacementBias = 0, _this65.roughnessMap = null, _this65.metalnessMap = null, _this65.alphaMap = null, _this65.envMap = null, _this65.envMapIntensity = 1, _this65.refractionRatio = .98, _this65.wireframe = !1, _this65.wireframeLinewidth = 1, _this65.wireframeLinecap = "round", _this65.wireframeLinejoin = "round", _this65.flatShading = !1, _this65.setValues(t);
    return _this65;
  }

  _createClass(Ro, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Ro.prototype), "copy", this).call(this, t), this.defines = {
        STANDARD: ""
      }, this.color.copy(t.color), this.roughness = t.roughness, this.metalness = t.metalness, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.roughnessMap = t.roughnessMap, this.metalnessMap = t.metalnessMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapIntensity = t.envMapIntensity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
    }
  }]);

  return Ro;
}(ke);

Ro.prototype.isMeshStandardMaterial = !0;

var Do = /*#__PURE__*/function (_Ro) {
  _inherits(Do, _Ro);

  var _super65 = _createSuper(Do);

  function Do(t) {
    var _this66;

    _classCallCheck(this, Do);

    _this66 = _super65.call(this), _this66.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, _this66.type = "MeshPhysicalMaterial", _this66.clearcoat = 0, _this66.clearcoatMap = null, _this66.clearcoatRoughness = 0, _this66.clearcoatRoughnessMap = null, _this66.clearcoatNormalScale = new pt(1, 1), _this66.clearcoatNormalMap = null, _this66.reflectivity = .5, Object.defineProperty(_assertThisInitialized(_this66), "ior", {
      get: function get() {
        return (1 + .4 * this.reflectivity) / (1 - .4 * this.reflectivity);
      },
      set: function set(t) {
        this.reflectivity = at(2.5 * (t - 1) / (t + 1), 0, 1);
      }
    }), _this66.sheen = null, _this66.transmission = 0, _this66.transmissionMap = null, _this66.thickness = .01, _this66.thicknessMap = null, _this66.attenuationDistance = 0, _this66.attenuationTint = new qe(1, 1, 1), _this66.specularIntensity = 1, _this66.specularIntensityMap = null, _this66.specularTint = new qe(1, 1, 1), _this66.specularTintMap = null, _this66.setValues(t);
    return _this66;
  }

  _createClass(Do, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Do.prototype), "copy", this).call(this, t), this.defines = {
        STANDARD: "",
        PHYSICAL: ""
      }, this.clearcoat = t.clearcoat, this.clearcoatMap = t.clearcoatMap, this.clearcoatRoughness = t.clearcoatRoughness, this.clearcoatRoughnessMap = t.clearcoatRoughnessMap, this.clearcoatNormalMap = t.clearcoatNormalMap, this.clearcoatNormalScale.copy(t.clearcoatNormalScale), this.reflectivity = t.reflectivity, t.sheen ? this.sheen = (this.sheen || new qe()).copy(t.sheen) : this.sheen = null, this.transmission = t.transmission, this.transmissionMap = t.transmissionMap, this.thickness = t.thickness, this.thicknessMap = t.thicknessMap, this.attenuationDistance = t.attenuationDistance, this.attenuationTint.copy(t.attenuationTint), this.specularIntensity = t.specularIntensity, this.specularIntensityMap = t.specularIntensityMap, this.specularTint.copy(t.specularTint), this.specularTintMap = t.specularTintMap, this;
    }
  }]);

  return Do;
}(Ro);

Do.prototype.isMeshPhysicalMaterial = !0;

/*#__PURE__*/
(function (_ke10) {
  _inherits(_class10, _ke10);

  var _super66 = _createSuper(_class10);

  function _class10(t) {
    var _this67;

    _classCallCheck(this, _class10);

    _this67 = _super66.call(this), _this67.type = "MeshPhongMaterial", _this67.color = new qe(16777215), _this67.specular = new qe(1118481), _this67.shininess = 30, _this67.map = null, _this67.lightMap = null, _this67.lightMapIntensity = 1, _this67.aoMap = null, _this67.aoMapIntensity = 1, _this67.emissive = new qe(0), _this67.emissiveIntensity = 1, _this67.emissiveMap = null, _this67.bumpMap = null, _this67.bumpScale = 1, _this67.normalMap = null, _this67.normalMapType = 0, _this67.normalScale = new pt(1, 1), _this67.displacementMap = null, _this67.displacementScale = 1, _this67.displacementBias = 0, _this67.specularMap = null, _this67.alphaMap = null, _this67.envMap = null, _this67.combine = 0, _this67.reflectivity = 1, _this67.refractionRatio = .98, _this67.wireframe = !1, _this67.wireframeLinewidth = 1, _this67.wireframeLinecap = "round", _this67.wireframeLinejoin = "round", _this67.flatShading = !1, _this67.setValues(t);
    return _this67;
  }

  _createClass(_class10, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class10.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.specular.copy(t.specular), this.shininess = t.shininess, this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this;
    }
  }]);

  return _class10;
})(ke).prototype.isMeshPhongMaterial = !0;

/*#__PURE__*/
(function (_ke11) {
  _inherits(_class11, _ke11);

  var _super67 = _createSuper(_class11);

  function _class11(t) {
    var _this68;

    _classCallCheck(this, _class11);

    _this68 = _super67.call(this), _this68.defines = {
      TOON: ""
    }, _this68.type = "MeshToonMaterial", _this68.color = new qe(16777215), _this68.map = null, _this68.gradientMap = null, _this68.lightMap = null, _this68.lightMapIntensity = 1, _this68.aoMap = null, _this68.aoMapIntensity = 1, _this68.emissive = new qe(0), _this68.emissiveIntensity = 1, _this68.emissiveMap = null, _this68.bumpMap = null, _this68.bumpScale = 1, _this68.normalMap = null, _this68.normalMapType = 0, _this68.normalScale = new pt(1, 1), _this68.displacementMap = null, _this68.displacementScale = 1, _this68.displacementBias = 0, _this68.alphaMap = null, _this68.wireframe = !1, _this68.wireframeLinewidth = 1, _this68.wireframeLinecap = "round", _this68.wireframeLinejoin = "round", _this68.setValues(t);
    return _this68;
  }

  _createClass(_class11, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class11.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.gradientMap = t.gradientMap, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return _class11;
})(ke).prototype.isMeshToonMaterial = !0;

/*#__PURE__*/
(function (_ke12) {
  _inherits(_class12, _ke12);

  var _super68 = _createSuper(_class12);

  function _class12(t) {
    var _this69;

    _classCallCheck(this, _class12);

    _this69 = _super68.call(this), _this69.type = "MeshNormalMaterial", _this69.bumpMap = null, _this69.bumpScale = 1, _this69.normalMap = null, _this69.normalMapType = 0, _this69.normalScale = new pt(1, 1), _this69.displacementMap = null, _this69.displacementScale = 1, _this69.displacementBias = 0, _this69.wireframe = !1, _this69.wireframeLinewidth = 1, _this69.fog = !1, _this69.flatShading = !1, _this69.setValues(t);
    return _this69;
  }

  _createClass(_class12, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class12.prototype), "copy", this).call(this, t), this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.flatShading = t.flatShading, this;
    }
  }]);

  return _class12;
})(ke).prototype.isMeshNormalMaterial = !0;

/*#__PURE__*/
(function (_ke13) {
  _inherits(_class13, _ke13);

  var _super69 = _createSuper(_class13);

  function _class13(t) {
    var _this70;

    _classCallCheck(this, _class13);

    _this70 = _super69.call(this), _this70.type = "MeshLambertMaterial", _this70.color = new qe(16777215), _this70.map = null, _this70.lightMap = null, _this70.lightMapIntensity = 1, _this70.aoMap = null, _this70.aoMapIntensity = 1, _this70.emissive = new qe(0), _this70.emissiveIntensity = 1, _this70.emissiveMap = null, _this70.specularMap = null, _this70.alphaMap = null, _this70.envMap = null, _this70.combine = 0, _this70.reflectivity = 1, _this70.refractionRatio = .98, _this70.wireframe = !1, _this70.wireframeLinewidth = 1, _this70.wireframeLinecap = "round", _this70.wireframeLinejoin = "round", _this70.setValues(t);
    return _this70;
  }

  _createClass(_class13, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class13.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this;
    }
  }]);

  return _class13;
})(ke).prototype.isMeshLambertMaterial = !0;

/*#__PURE__*/
(function (_ke14) {
  _inherits(_class14, _ke14);

  var _super70 = _createSuper(_class14);

  function _class14(t) {
    var _this71;

    _classCallCheck(this, _class14);

    _this71 = _super70.call(this), _this71.defines = {
      MATCAP: ""
    }, _this71.type = "MeshMatcapMaterial", _this71.color = new qe(16777215), _this71.matcap = null, _this71.map = null, _this71.bumpMap = null, _this71.bumpScale = 1, _this71.normalMap = null, _this71.normalMapType = 0, _this71.normalScale = new pt(1, 1), _this71.displacementMap = null, _this71.displacementScale = 1, _this71.displacementBias = 0, _this71.alphaMap = null, _this71.flatShading = !1, _this71.setValues(t);
    return _this71;
  }

  _createClass(_class14, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class14.prototype), "copy", this).call(this, t), this.defines = {
        MATCAP: ""
      }, this.color.copy(t.color), this.matcap = t.matcap, this.map = t.map, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.alphaMap = t.alphaMap, this.flatShading = t.flatShading, this;
    }
  }]);

  return _class14;
})(ke).prototype.isMeshMatcapMaterial = !0;

/*#__PURE__*/
(function (_ma) {
  _inherits(_class15, _ma);

  var _super71 = _createSuper(_class15);

  function _class15(t) {
    var _this72;

    _classCallCheck(this, _class15);

    _this72 = _super71.call(this), _this72.type = "LineDashedMaterial", _this72.scale = 1, _this72.dashSize = 3, _this72.gapSize = 1, _this72.setValues(t);
    return _this72;
  }

  _createClass(_class15, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class15.prototype), "copy", this).call(this, t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
    }
  }]);

  return _class15;
})(ma).prototype.isLineDashedMaterial = !0;
var Qo = {
  arraySlice: function arraySlice(t, e, n) {
    return Qo.isTypedArray(t) ? new t.constructor(t.subarray(e, void 0 !== n ? n : t.length)) : t.slice(e, n);
  },
  convertArray: function convertArray(t, e, n) {
    return !t || !n && t.constructor === e ? t : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t);
  },
  isTypedArray: function isTypedArray(t) {
    return ArrayBuffer.isView(t) && !(t instanceof DataView);
  },
  getKeyframeOrder: function getKeyframeOrder(t) {
    var e = t.length,
        n = new Array(e);

    for (var _t217 = 0; _t217 !== e; ++_t217) {
      n[_t217] = _t217;
    }

    return n.sort(function (e, n) {
      return t[e] - t[n];
    }), n;
  },
  sortedArray: function sortedArray(t, e, n) {
    var i = t.length,
        r = new t.constructor(i);

    for (var _s59 = 0, _a44 = 0; _a44 !== i; ++_s59) {
      var _i136 = n[_s59] * e;

      for (var _n174 = 0; _n174 !== e; ++_n174) {
        r[_a44++] = t[_i136 + _n174];
      }
    }

    return r;
  },
  flattenJSON: function flattenJSON(t, e, n, i) {
    var r = 1,
        s = t[0];

    for (; void 0 !== s && void 0 === s[i];) {
      s = t[r++];
    }

    if (void 0 === s) return;
    var a = s[i];
    if (void 0 !== a) if (Array.isArray(a)) do {
      a = s[i], void 0 !== a && (e.push(s.time), n.push.apply(n, a)), s = t[r++];
    } while (void 0 !== s);else if (void 0 !== a.toArray) do {
      a = s[i], void 0 !== a && (e.push(s.time), a.toArray(n, n.length)), s = t[r++];
    } while (void 0 !== s);else do {
      a = s[i], void 0 !== a && (e.push(s.time), n.push(a)), s = t[r++];
    } while (void 0 !== s);
  },
  subclip: function subclip(t, e, n, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
    var s = t.clone();
    s.name = e;
    var a = [];

    for (var _t218 = 0; _t218 < s.tracks.length; ++_t218) {
      var _e196 = s.tracks[_t218],
          _o28 = _e196.getValueSize(),
          _l21 = [],
          _c18 = [];

      for (var _t219 = 0; _t219 < _e196.times.length; ++_t219) {
        var _s60 = _e196.times[_t219] * r;

        if (!(_s60 < n || _s60 >= i)) {
          _l21.push(_e196.times[_t219]);

          for (var _n175 = 0; _n175 < _o28; ++_n175) {
            _c18.push(_e196.values[_t219 * _o28 + _n175]);
          }
        }
      }

      0 !== _l21.length && (_e196.times = Qo.convertArray(_l21, _e196.times.constructor), _e196.values = Qo.convertArray(_c18, _e196.values.constructor), a.push(_e196));
    }

    s.tracks = a;
    var o = 1 / 0;

    for (var _t220 = 0; _t220 < s.tracks.length; ++_t220) {
      o > s.tracks[_t220].times[0] && (o = s.tracks[_t220].times[0]);
    }

    for (var _t221 = 0; _t221 < s.tracks.length; ++_t221) {
      s.tracks[_t221].shift(-1 * o);
    }

    return s.resetDuration(), s;
  },
  makeClipAdditive: function makeClipAdditive(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
    i <= 0 && (i = 30);
    var r = n.tracks.length,
        s = e / i;

    var _loop = function _loop(_e197) {
      var i = n.tracks[_e197],
          r = i.ValueTypeName;
      if ("bool" === r || "string" === r) return "continue";
      var a = t.tracks.find(function (t) {
        return t.name === i.name && t.ValueTypeName === r;
      });
      if (void 0 === a) return "continue";
      var o = 0;
      var l = i.getValueSize();
      i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
      var c = 0;
      var h = a.getValueSize();
      a.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = h / 3);
      var u = i.times.length - 1;
      var d = void 0;

      if (s <= i.times[0]) {
        var _t222 = o,
            _e198 = l - o;

        d = Qo.arraySlice(i.values, _t222, _e198);
      } else if (s >= i.times[u]) {
        var _t223 = u * l + o,
            _e199 = _t223 + l - o;

        d = Qo.arraySlice(i.values, _t223, _e199);
      } else {
        var _t224 = i.createInterpolant(),
            _e200 = o,
            _n176 = l - o;

        _t224.evaluate(s), d = Qo.arraySlice(_t224.resultBuffer, _e200, _n176);
      }

      if ("quaternion" === r) {
        new bt().fromArray(d).normalize().conjugate().toArray(d);
      }

      var p = a.times.length;

      for (var _t225 = 0; _t225 < p; ++_t225) {
        var _e201 = _t225 * h + c;

        if ("quaternion" === r) bt.multiplyQuaternionsFlat(a.values, _e201, d, 0, a.values, _e201);else {
          var _t226 = h - 2 * c;

          for (var _n177 = 0; _n177 < _t226; ++_n177) {
            a.values[_e201 + _n177] -= d[_n177];
          }
        }
      }
    };

    for (var _e197 = 0; _e197 < r; ++_e197) {
      var _ret = _loop(_e197);

      if (_ret === "continue") continue;
    }

    return t.blendMode = 2501, t;
  }
};

var Po = /*#__PURE__*/function () {
  function Po(t, e, n, i) {
    _classCallCheck(this, Po);

    this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
  }

  _createClass(Po, [{
    key: "evaluate",
    value: function evaluate(t) {
      var e = this.parameterPositions;
      var n = this._cachedIndex,
          i = e[n],
          r = e[n - 1];

      t: {
        e: {
          var _s61;

          n: {
            i: if (!(t < i)) {
              for (var _s62 = n + 2;;) {
                if (void 0 === i) {
                  if (t < r) break i;
                  return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, t, r);
                }

                if (n === _s62) break;
                if (r = i, i = e[++n], t < i) break e;
              }

              _s61 = e.length;
              break n;
            }

            if (t >= r) break t;
            {
              var _a45 = e[1];
              t < _a45 && (n = 2, r = _a45);

              for (var _s63 = n - 2;;) {
                if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
                if (n === _s63) break;
                if (i = r, r = e[--n - 1], t >= r) break e;
              }

              _s61 = n, n = 0;
            }
          }

          for (; n < _s61;) {
            var _i137 = n + _s61 >>> 1;

            t < e[_i137] ? _s61 = _i137 : n = _i137 + 1;
          }

          if (i = e[n], r = e[n - 1], void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, i);
          if (void 0 === i) return n = e.length, this._cachedIndex = n, this.afterEnd_(n - 1, r, t);
        }

        this._cachedIndex = n, this.intervalChanged_(n, r, i);
      }

      return this.interpolate_(n, r, t, i);
    }
  }, {
    key: "getSettings_",
    value: function getSettings_() {
      return this.settings || this.DefaultSettings_;
    }
  }, {
    key: "copySampleValue_",
    value: function copySampleValue_(t) {
      var e = this.resultBuffer,
          n = this.sampleValues,
          i = this.valueSize,
          r = t * i;

      for (var _t227 = 0; _t227 !== i; ++_t227) {
        e[_t227] = n[r + _t227];
      }

      return e;
    }
  }, {
    key: "interpolate_",
    value: function interpolate_() {
      throw new Error("call to abstract method");
    }
  }, {
    key: "intervalChanged_",
    value: function intervalChanged_() {}
  }]);

  return Po;
}();

Po.prototype.beforeStart_ = Po.prototype.copySampleValue_, Po.prototype.afterEnd_ = Po.prototype.copySampleValue_;

var Fo = /*#__PURE__*/function (_Po) {
  _inherits(Fo, _Po);

  var _super72 = _createSuper(Fo);

  function Fo(t, e, n, i) {
    var _this73;

    _classCallCheck(this, Fo);

    _this73 = _super72.call(this, t, e, n, i), _this73._weightPrev = -0, _this73._offsetPrev = -0, _this73._weightNext = -0, _this73._offsetNext = -0, _this73.DefaultSettings_ = {
      endingStart: 2400,
      endingEnd: 2400
    };
    return _this73;
  }

  _createClass(Fo, [{
    key: "intervalChanged_",
    value: function intervalChanged_(t, e, n) {
      var i = this.parameterPositions;
      var r = t - 2,
          s = t + 1,
          a = i[r],
          o = i[s];
      if (void 0 === a) switch (this.getSettings_().endingStart) {
        case 2401:
          r = t, a = 2 * e - n;
          break;

        case 2402:
          r = i.length - 2, a = e + i[r] - i[r + 1];
          break;

        default:
          r = t, a = n;
      }
      if (void 0 === o) switch (this.getSettings_().endingEnd) {
        case 2401:
          s = t, o = 2 * n - e;
          break;

        case 2402:
          s = 1, o = n + i[1] - i[0];
          break;

        default:
          s = t - 1, o = e;
      }
      var l = .5 * (n - e),
          c = this.valueSize;
      this._weightPrev = l / (e - a), this._weightNext = l / (o - n), this._offsetPrev = r * c, this._offsetNext = s * c;
    }
  }, {
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = t * a,
          l = o - a,
          c = this._offsetPrev,
          h = this._offsetNext,
          u = this._weightPrev,
          d = this._weightNext,
          p = (n - e) / (i - e),
          A = p * p,
          m = A * p,
          g = -u * m + 2 * u * A - u * p,
          f = (1 + u) * m + (-1.5 - 2 * u) * A + (-.5 + u) * p + 1,
          v = (-1 - d) * m + (1.5 + d) * A + .5 * p,
          y = d * m - d * A;

      for (var _t228 = 0; _t228 !== a; ++_t228) {
        r[_t228] = g * s[c + _t228] + f * s[l + _t228] + v * s[o + _t228] + y * s[h + _t228];
      }

      return r;
    }
  }]);

  return Fo;
}(Po);

var No = /*#__PURE__*/function (_Po2) {
  _inherits(No, _Po2);

  var _super73 = _createSuper(No);

  function No(t, e, n, i) {
    _classCallCheck(this, No);

    return _super73.call(this, t, e, n, i);
  }

  _createClass(No, [{
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = t * a,
          l = o - a,
          c = (n - e) / (i - e),
          h = 1 - c;

      for (var _t229 = 0; _t229 !== a; ++_t229) {
        r[_t229] = s[l + _t229] * h + s[o + _t229] * c;
      }

      return r;
    }
  }]);

  return No;
}(Po);

var Uo = /*#__PURE__*/function (_Po3) {
  _inherits(Uo, _Po3);

  var _super74 = _createSuper(Uo);

  function Uo(t, e, n, i) {
    _classCallCheck(this, Uo);

    return _super74.call(this, t, e, n, i);
  }

  _createClass(Uo, [{
    key: "interpolate_",
    value: function interpolate_(t) {
      return this.copySampleValue_(t - 1);
    }
  }]);

  return Uo;
}(Po);

var ko = /*#__PURE__*/function () {
  function ko(t, e, n, i) {
    _classCallCheck(this, ko);

    if (void 0 === t) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
    this.name = t, this.times = Qo.convertArray(e, this.TimeBufferType), this.values = Qo.convertArray(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
  }

  _createClass(ko, [{
    key: "InterpolantFactoryMethodDiscrete",
    value: function InterpolantFactoryMethodDiscrete(t) {
      return new Uo(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "InterpolantFactoryMethodLinear",
    value: function InterpolantFactoryMethodLinear(t) {
      return new No(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "InterpolantFactoryMethodSmooth",
    value: function InterpolantFactoryMethodSmooth(t) {
      return new Fo(this.times, this.values, this.getValueSize(), t);
    }
  }, {
    key: "setInterpolation",
    value: function setInterpolation(t) {
      var e;

      switch (t) {
        case 2300:
          e = this.InterpolantFactoryMethodDiscrete;
          break;

        case 2301:
          e = this.InterpolantFactoryMethodLinear;
          break;

        case 2302:
          e = this.InterpolantFactoryMethodSmooth;
      }

      if (void 0 === e) {
        var _e202 = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;

        if (void 0 === this.createInterpolant) {
          if (t === this.DefaultInterpolation) throw new Error(_e202);
          this.setInterpolation(this.DefaultInterpolation);
        }

        return console.warn("THREE.KeyframeTrack:", _e202), this;
      }

      return this.createInterpolant = e, this;
    }
  }, {
    key: "getInterpolation",
    value: function getInterpolation() {
      switch (this.createInterpolant) {
        case this.InterpolantFactoryMethodDiscrete:
          return 2300;

        case this.InterpolantFactoryMethodLinear:
          return 2301;

        case this.InterpolantFactoryMethodSmooth:
          return 2302;
      }
    }
  }, {
    key: "getValueSize",
    value: function getValueSize() {
      return this.values.length / this.times.length;
    }
  }, {
    key: "shift",
    value: function shift(t) {
      if (0 !== t) {
        var _e203 = this.times;

        for (var _n178 = 0, _i138 = _e203.length; _n178 !== _i138; ++_n178) {
          _e203[_n178] += t;
        }
      }

      return this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      if (1 !== t) {
        var _e204 = this.times;

        for (var _n179 = 0, _i139 = _e204.length; _n179 !== _i139; ++_n179) {
          _e204[_n179] *= t;
        }
      }

      return this;
    }
  }, {
    key: "trim",
    value: function trim(t, e) {
      var n = this.times,
          i = n.length;
      var r = 0,
          s = i - 1;

      for (; r !== i && n[r] < t;) {
        ++r;
      }

      for (; -1 !== s && n[s] > e;) {
        --s;
      }

      if (++s, 0 !== r || s !== i) {
        r >= s && (s = Math.max(s, 1), r = s - 1);

        var _t230 = this.getValueSize();

        this.times = Qo.arraySlice(n, r, s), this.values = Qo.arraySlice(this.values, r * _t230, s * _t230);
      }

      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var t = !0;
      var e = this.getValueSize();
      e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
      var n = this.times,
          i = this.values,
          r = n.length;
      0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
      var s = null;

      for (var _e205 = 0; _e205 !== r; _e205++) {
        var _i140 = n[_e205];

        if ("number" == typeof _i140 && isNaN(_i140)) {
          console.error("THREE.KeyframeTrack: Time is not a valid number.", this, _e205, _i140), t = !1;
          break;
        }

        if (null !== s && s > _i140) {
          console.error("THREE.KeyframeTrack: Out of order keys.", this, _e205, _i140, s), t = !1;
          break;
        }

        s = _i140;
      }

      if (void 0 !== i && Qo.isTypedArray(i)) for (var _e206 = 0, _n180 = i.length; _e206 !== _n180; ++_e206) {
        var _n181 = i[_e206];

        if (isNaN(_n181)) {
          console.error("THREE.KeyframeTrack: Value is not a valid number.", this, _e206, _n181), t = !1;
          break;
        }
      }
      return t;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var t = Qo.arraySlice(this.times),
          e = Qo.arraySlice(this.values),
          n = this.getValueSize(),
          i = 2302 === this.getInterpolation(),
          r = t.length - 1;
      var s = 1;

      for (var _a46 = 1; _a46 < r; ++_a46) {
        var _r111 = !1;

        var _o29 = t[_a46];
        if (_o29 !== t[_a46 + 1] && (1 !== _a46 || _o29 !== t[0])) if (i) _r111 = !0;else {
          var _t231 = _a46 * n,
              _i141 = _t231 - n,
              _s64 = _t231 + n;

          for (var _a47 = 0; _a47 !== n; ++_a47) {
            var _n182 = e[_t231 + _a47];

            if (_n182 !== e[_i141 + _a47] || _n182 !== e[_s64 + _a47]) {
              _r111 = !0;
              break;
            }
          }
        }

        if (_r111) {
          if (_a46 !== s) {
            t[s] = t[_a46];

            var _i142 = _a46 * n,
                _r112 = s * n;

            for (var _t232 = 0; _t232 !== n; ++_t232) {
              e[_r112 + _t232] = e[_i142 + _t232];
            }
          }

          ++s;
        }
      }

      if (r > 0) {
        t[s] = t[r];

        for (var _t233 = r * n, _i143 = s * n, _a48 = 0; _a48 !== n; ++_a48) {
          e[_i143 + _a48] = e[_t233 + _a48];
        }

        ++s;
      }

      return s !== t.length ? (this.times = Qo.arraySlice(t, 0, s), this.values = Qo.arraySlice(e, 0, s * n)) : (this.times = t, this.values = e), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = Qo.arraySlice(this.times, 0),
          e = Qo.arraySlice(this.values, 0),
          n = new (0, this.constructor)(this.name, t, e);
      return n.createInterpolant = this.createInterpolant, n;
    }
  }], [{
    key: "toJSON",
    value: function toJSON(t) {
      var e = t.constructor;
      var n;
      if (e.toJSON !== this.toJSON) n = e.toJSON(t);else {
        n = {
          name: t.name,
          times: Qo.convertArray(t.times, Array),
          values: Qo.convertArray(t.values, Array)
        };

        var _e207 = t.getInterpolation();

        _e207 !== t.DefaultInterpolation && (n.interpolation = _e207);
      }
      return n.type = t.ValueTypeName, n;
    }
  }]);

  return ko;
}();

ko.prototype.TimeBufferType = Float32Array, ko.prototype.ValueBufferType = Float32Array, ko.prototype.DefaultInterpolation = 2301;

var Go = /*#__PURE__*/function (_ko) {
  _inherits(Go, _ko);

  var _super75 = _createSuper(Go);

  function Go() {
    _classCallCheck(this, Go);

    return _super75.apply(this, arguments);
  }

  return _createClass(Go);
}(ko);

Go.prototype.ValueTypeName = "bool", Go.prototype.ValueBufferType = Array, Go.prototype.DefaultInterpolation = 2300, Go.prototype.InterpolantFactoryMethodLinear = void 0, Go.prototype.InterpolantFactoryMethodSmooth = void 0;

var Oo = /*#__PURE__*/function (_ko2) {
  _inherits(Oo, _ko2);

  var _super76 = _createSuper(Oo);

  function Oo() {
    _classCallCheck(this, Oo);

    return _super76.apply(this, arguments);
  }

  return _createClass(Oo);
}(ko);

Oo.prototype.ValueTypeName = "color";

var Ho = /*#__PURE__*/function (_ko3) {
  _inherits(Ho, _ko3);

  var _super77 = _createSuper(Ho);

  function Ho() {
    _classCallCheck(this, Ho);

    return _super77.apply(this, arguments);
  }

  return _createClass(Ho);
}(ko);

Ho.prototype.ValueTypeName = "number";

var zo = /*#__PURE__*/function (_Po4) {
  _inherits(zo, _Po4);

  var _super78 = _createSuper(zo);

  function zo(t, e, n, i) {
    _classCallCheck(this, zo);

    return _super78.call(this, t, e, n, i);
  }

  _createClass(zo, [{
    key: "interpolate_",
    value: function interpolate_(t, e, n, i) {
      var r = this.resultBuffer,
          s = this.sampleValues,
          a = this.valueSize,
          o = (n - e) / (i - e);
      var l = t * a;

      for (var _t234 = l + a; l !== _t234; l += 4) {
        bt.slerpFlat(r, 0, s, l - a, s, l, o);
      }

      return r;
    }
  }]);

  return zo;
}(Po);

var Vo = /*#__PURE__*/function (_ko4) {
  _inherits(Vo, _ko4);

  var _super79 = _createSuper(Vo);

  function Vo() {
    _classCallCheck(this, Vo);

    return _super79.apply(this, arguments);
  }

  _createClass(Vo, [{
    key: "InterpolantFactoryMethodLinear",
    value: function InterpolantFactoryMethodLinear(t) {
      return new zo(this.times, this.values, this.getValueSize(), t);
    }
  }]);

  return Vo;
}(ko);

Vo.prototype.ValueTypeName = "quaternion", Vo.prototype.DefaultInterpolation = 2301, Vo.prototype.InterpolantFactoryMethodSmooth = void 0;

var Wo = /*#__PURE__*/function (_ko5) {
  _inherits(Wo, _ko5);

  var _super80 = _createSuper(Wo);

  function Wo() {
    _classCallCheck(this, Wo);

    return _super80.apply(this, arguments);
  }

  return _createClass(Wo);
}(ko);

Wo.prototype.ValueTypeName = "string", Wo.prototype.ValueBufferType = Array, Wo.prototype.DefaultInterpolation = 2300, Wo.prototype.InterpolantFactoryMethodLinear = void 0, Wo.prototype.InterpolantFactoryMethodSmooth = void 0;

var qo = /*#__PURE__*/function (_ko6) {
  _inherits(qo, _ko6);

  var _super81 = _createSuper(qo);

  function qo() {
    _classCallCheck(this, qo);

    return _super81.apply(this, arguments);
  }

  return _createClass(qo);
}(ko);

qo.prototype.ValueTypeName = "vector";

var jo = /*#__PURE__*/function () {
  function jo(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var n = arguments.length > 2 ? arguments[2] : undefined;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2500;

    _classCallCheck(this, jo);

    this.name = t, this.tracks = n, this.duration = e, this.blendMode = i, this.uuid = st(), this.duration < 0 && this.resetDuration();
  }

  _createClass(jo, [{
    key: "resetDuration",
    value: function resetDuration() {
      var t = 0;

      for (var _e208 = 0, _n183 = this.tracks.length; _e208 !== _n183; ++_e208) {
        var _n184 = this.tracks[_e208];
        t = Math.max(t, _n184.times[_n184.times.length - 1]);
      }

      return this.duration = t, this;
    }
  }, {
    key: "trim",
    value: function trim() {
      for (var _t235 = 0; _t235 < this.tracks.length; _t235++) {
        this.tracks[_t235].trim(0, this.duration);
      }

      return this;
    }
  }, {
    key: "validate",
    value: function validate() {
      var t = !0;

      for (var _e209 = 0; _e209 < this.tracks.length; _e209++) {
        t = t && this.tracks[_e209].validate();
      }

      return t;
    }
  }, {
    key: "optimize",
    value: function optimize() {
      for (var _t236 = 0; _t236 < this.tracks.length; _t236++) {
        this.tracks[_t236].optimize();
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = [];

      for (var _e210 = 0; _e210 < this.tracks.length; _e210++) {
        t.push(this.tracks[_e210].clone());
      }

      return new this.constructor(this.name, this.duration, t, this.blendMode);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.constructor.toJSON(this);
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      var e = [],
          n = t.tracks,
          i = 1 / (t.fps || 1);

      for (var _t237 = 0, _r113 = n.length; _t237 !== _r113; ++_t237) {
        e.push(Yo(n[_t237]).scale(i));
      }

      var r = new this(t.name, t.duration, e, t.blendMode);
      return r.uuid = t.uuid, r;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = [],
          n = t.tracks,
          i = {
        name: t.name,
        duration: t.duration,
        tracks: e,
        uuid: t.uuid,
        blendMode: t.blendMode
      };

      for (var _t238 = 0, _i144 = n.length; _t238 !== _i144; ++_t238) {
        e.push(ko.toJSON(n[_t238]));
      }

      return i;
    }
  }, {
    key: "CreateFromMorphTargetSequence",
    value: function CreateFromMorphTargetSequence(t, e, n, i) {
      var r = e.length,
          s = [];

      for (var _t239 = 0; _t239 < r; _t239++) {
        var _a49 = [],
            _o30 = [];
        _a49.push((_t239 + r - 1) % r, _t239, (_t239 + 1) % r), _o30.push(0, 1, 0);

        var _l22 = Qo.getKeyframeOrder(_a49);

        _a49 = Qo.sortedArray(_a49, 1, _l22), _o30 = Qo.sortedArray(_o30, 1, _l22), i || 0 !== _a49[0] || (_a49.push(r), _o30.push(_o30[0])), s.push(new Ho(".morphTargetInfluences[" + e[_t239].name + "]", _a49, _o30).scale(1 / n));
      }

      return new this(t, -1, s);
    }
  }, {
    key: "findByName",
    value: function findByName(t, e) {
      var n = t;

      if (!Array.isArray(t)) {
        var _e211 = t;
        n = _e211.geometry && _e211.geometry.animations || _e211.animations;
      }

      for (var _t240 = 0; _t240 < n.length; _t240++) {
        if (n[_t240].name === e) return n[_t240];
      }

      return null;
    }
  }, {
    key: "CreateClipsFromMorphTargetSequences",
    value: function CreateClipsFromMorphTargetSequences(t, e, n) {
      var i = {},
          r = /^([\w-]*?)([\d]+)$/;

      for (var _e212 = 0, _n185 = t.length; _e212 < _n185; _e212++) {
        var _n186 = t[_e212],
            _s65 = _n186.name.match(r);

        if (_s65 && _s65.length > 1) {
          var _t241 = _s65[1];
          var _e213 = i[_t241];
          _e213 || (i[_t241] = _e213 = []), _e213.push(_n186);
        }
      }

      var s = [];

      for (var _t242 in i) {
        s.push(this.CreateFromMorphTargetSequence(_t242, i[_t242], e, n));
      }

      return s;
    }
  }, {
    key: "parseAnimation",
    value: function parseAnimation(t, e) {
      if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;

      var n = function n(t, e, _n187, i, r) {
        if (0 !== _n187.length) {
          var _s66 = [],
              _a50 = [];
          Qo.flattenJSON(_n187, _s66, _a50, i), 0 !== _s66.length && r.push(new t(e, _s66, _a50));
        }
      },
          i = [],
          r = t.name || "default",
          s = t.fps || 30,
          a = t.blendMode;

      var o = t.length || -1;
      var l = t.hierarchy || [];

      for (var _t243 = 0; _t243 < l.length; _t243++) {
        var _r114 = l[_t243].keys;
        if (_r114 && 0 !== _r114.length) if (_r114[0].morphTargets) {
          var _t244 = {};

          var _e214 = void 0;

          for (_e214 = 0; _e214 < _r114.length; _e214++) {
            if (_r114[_e214].morphTargets) for (var _n188 = 0; _n188 < _r114[_e214].morphTargets.length; _n188++) {
              _t244[_r114[_e214].morphTargets[_n188]] = -1;
            }
          }

          for (var _n189 in _t244) {
            var _t245 = [],
                _s67 = [];

            for (var _i145 = 0; _i145 !== _r114[_e214].morphTargets.length; ++_i145) {
              var _i146 = _r114[_e214];
              _t245.push(_i146.time), _s67.push(_i146.morphTarget === _n189 ? 1 : 0);
            }

            i.push(new Ho(".morphTargetInfluence[" + _n189 + "]", _t245, _s67));
          }

          o = _t244.length * (s || 1);
        } else {
          var _s68 = ".bones[" + e[_t243].name + "]";

          n(qo, _s68 + ".position", _r114, "pos", i), n(Vo, _s68 + ".quaternion", _r114, "rot", i), n(qo, _s68 + ".scale", _r114, "scl", i);
        }
      }

      if (0 === i.length) return null;
      return new this(r, o, i, a);
    }
  }]);

  return jo;
}();

function Yo(t) {
  if (void 0 === t.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");

  var e = function (t) {
    switch (t.toLowerCase()) {
      case "scalar":
      case "double":
      case "float":
      case "number":
      case "integer":
        return Ho;

      case "vector":
      case "vector2":
      case "vector3":
      case "vector4":
        return qo;

      case "color":
        return Oo;

      case "quaternion":
        return Vo;

      case "bool":
      case "boolean":
        return Go;

      case "string":
        return Wo;
    }

    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t);
  }(t.type);

  if (void 0 === t.times) {
    var _e215 = [],
        _n190 = [];
    Qo.flattenJSON(t.keys, _e215, _n190, "value"), t.times = _e215, t.values = _n190;
  }

  return void 0 !== e.parse ? e.parse(t) : new e(t.name, t.times, t.values, t.interpolation);
}

var Jo = {
  enabled: !1,
  files: {},
  add: function add(t, e) {
    !1 !== this.enabled && (this.files[t] = e);
  },
  get: function get(t) {
    if (!1 !== this.enabled) return this.files[t];
  },
  remove: function remove(t) {
    delete this.files[t];
  },
  clear: function clear() {
    this.files = {};
  }
};
var Xo = new ( /*#__PURE__*/function () {
  function _class16(t, e, n) {
    _classCallCheck(this, _class16);

    var i = this;
    var r,
        s = !1,
        a = 0,
        o = 0;
    var l = [];
    this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = n, this.itemStart = function (t) {
      o++, !1 === s && void 0 !== i.onStart && i.onStart(t, a, o), s = !0;
    }, this.itemEnd = function (t) {
      a++, void 0 !== i.onProgress && i.onProgress(t, a, o), a === o && (s = !1, void 0 !== i.onLoad && i.onLoad());
    }, this.itemError = function (t) {
      void 0 !== i.onError && i.onError(t);
    }, this.resolveURL = function (t) {
      return r ? r(t) : t;
    }, this.setURLModifier = function (t) {
      return r = t, this;
    }, this.addHandler = function (t, e) {
      return l.push(t, e), this;
    }, this.removeHandler = function (t) {
      var e = l.indexOf(t);
      return -1 !== e && l.splice(e, 2), this;
    }, this.getHandler = function (t) {
      for (var _e216 = 0, _n191 = l.length; _e216 < _n191; _e216 += 2) {
        var _n192 = l[_e216],
            _i147 = l[_e216 + 1];
        if (_n192.global && (_n192.lastIndex = 0), _n192.test(t)) return _i147;
      }

      return null;
    };
  }

  return _createClass(_class16);
}())();

var Ko = /*#__PURE__*/function () {
  function Ko(t) {
    _classCallCheck(this, Ko);

    this.manager = void 0 !== t ? t : Xo, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }

  _createClass(Ko, [{
    key: "load",
    value: function load() {}
  }, {
    key: "loadAsync",
    value: function loadAsync(t, e) {
      var n = this;
      return new Promise(function (i, r) {
        n.load(t, i, e, r);
      });
    }
  }, {
    key: "parse",
    value: function parse() {}
  }, {
    key: "setCrossOrigin",
    value: function setCrossOrigin(t) {
      return this.crossOrigin = t, this;
    }
  }, {
    key: "setWithCredentials",
    value: function setWithCredentials(t) {
      return this.withCredentials = t, this;
    }
  }, {
    key: "setPath",
    value: function setPath(t) {
      return this.path = t, this;
    }
  }, {
    key: "setResourcePath",
    value: function setResourcePath(t) {
      return this.resourcePath = t, this;
    }
  }, {
    key: "setRequestHeader",
    value: function setRequestHeader(t) {
      return this.requestHeader = t, this;
    }
  }]);

  return Ko;
}();

var Zo = {};

var $o = /*#__PURE__*/function (_Ko) {
  _inherits($o, _Ko);

  var _super82 = _createSuper($o);

  function $o(t) {
    _classCallCheck(this, $o);

    return _super82.call(this, t);
  }

  _createClass($o, [{
    key: "load",
    value: function load(t, e, n, i) {
      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = this,
          s = Jo.get(t);
      if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
        e && e(s), r.manager.itemEnd(t);
      }, 0), s;
      if (void 0 !== Zo[t]) return void Zo[t].push({
        onLoad: e,
        onProgress: n,
        onError: i
      });
      var a = t.match(/^data:(.*?)(;base64)?,(.*)$/);
      var o;

      if (a) {
        var _n193 = a[1],
            _s69 = !!a[2];

        var _o31 = a[3];
        _o31 = decodeURIComponent(_o31), _s69 && (_o31 = atob(_o31));

        try {
          var _i148;

          var _s70 = (this.responseType || "").toLowerCase();

          switch (_s70) {
            case "arraybuffer":
            case "blob":
              var _t246 = new Uint8Array(_o31.length);

              for (var _e218 = 0; _e218 < _o31.length; _e218++) {
                _t246[_e218] = _o31.charCodeAt(_e218);
              }

              _i148 = "blob" === _s70 ? new Blob([_t246.buffer], {
                type: _n193
              }) : _t246.buffer;
              break;

            case "document":
              var _e217 = new DOMParser();

              _i148 = _e217.parseFromString(_o31, _n193);
              break;

            case "json":
              _i148 = JSON.parse(_o31);
              break;

            default:
              _i148 = _o31;
          }

          setTimeout(function () {
            e && e(_i148), r.manager.itemEnd(t);
          }, 0);
        } catch (e) {
          setTimeout(function () {
            i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
          }, 0);
        }
      } else {
        Zo[t] = [], Zo[t].push({
          onLoad: e,
          onProgress: n,
          onError: i
        }), o = new XMLHttpRequest(), o.open("GET", t, !0), o.addEventListener("load", function (e) {
          var n = this.response,
              i = Zo[t];

          if (delete Zo[t], 200 === this.status || 0 === this.status) {
            0 === this.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), Jo.add(t, n);

            for (var _t247 = 0, _e219 = i.length; _t247 < _e219; _t247++) {
              var _e220 = i[_t247];
              _e220.onLoad && _e220.onLoad(n);
            }

            r.manager.itemEnd(t);
          } else {
            for (var _t248 = 0, _n194 = i.length; _t248 < _n194; _t248++) {
              var _n195 = i[_t248];
              _n195.onError && _n195.onError(e);
            }

            r.manager.itemError(t), r.manager.itemEnd(t);
          }
        }, !1), o.addEventListener("progress", function (e) {
          var n = Zo[t];

          for (var _t249 = 0, _i149 = n.length; _t249 < _i149; _t249++) {
            var _i150 = n[_t249];
            _i150.onProgress && _i150.onProgress(e);
          }
        }, !1), o.addEventListener("error", function (e) {
          var n = Zo[t];
          delete Zo[t];

          for (var _t250 = 0, _i151 = n.length; _t250 < _i151; _t250++) {
            var _i152 = n[_t250];
            _i152.onError && _i152.onError(e);
          }

          r.manager.itemError(t), r.manager.itemEnd(t);
        }, !1), o.addEventListener("abort", function (e) {
          var n = Zo[t];
          delete Zo[t];

          for (var _t251 = 0, _i153 = n.length; _t251 < _i153; _t251++) {
            var _i154 = n[_t251];
            _i154.onError && _i154.onError(e);
          }

          r.manager.itemError(t), r.manager.itemEnd(t);
        }, !1), void 0 !== this.responseType && (o.responseType = this.responseType), void 0 !== this.withCredentials && (o.withCredentials = this.withCredentials), o.overrideMimeType && o.overrideMimeType(void 0 !== this.mimeType ? this.mimeType : "text/plain");

        for (var _t252 in this.requestHeader) {
          o.setRequestHeader(_t252, this.requestHeader[_t252]);
        }

        o.send(null);
      }

      return r.manager.itemStart(t), o;
    }
  }, {
    key: "setResponseType",
    value: function setResponseType(t) {
      return this.responseType = t, this;
    }
  }, {
    key: "setMimeType",
    value: function setMimeType(t) {
      return this.mimeType = t, this;
    }
  }]);

  return $o;
}(Ko);

var tl = /*#__PURE__*/function (_Ko2) {
  _inherits(tl, _Ko2);

  var _super83 = _createSuper(tl);

  function tl(t) {
    _classCallCheck(this, tl);

    return _super83.call(this, t);
  }

  _createClass(tl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = [],
          a = new Da(),
          o = new $o(this.manager);
      o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
      var l = 0;

      function c(c) {
        o.load(t[c], function (t) {
          var n = r.parse(t, !0);
          s[c] = {
            width: n.width,
            height: n.height,
            format: n.format,
            mipmaps: n.mipmaps
          }, l += 1, 6 === l && (1 === n.mipmapCount && (a.minFilter = 1006), a.image = s, a.format = n.format, a.needsUpdate = !0, e && e(a));
        }, n, i);
      }

      if (Array.isArray(t)) for (var _e221 = 0, _n196 = t.length; _e221 < _n196; ++_e221) {
        c(_e221);
      } else o.load(t, function (t) {
        var n = r.parse(t, !0);

        if (n.isCubemap) {
          var _t253 = n.mipmaps.length / n.mipmapCount;

          for (var _e222 = 0; _e222 < _t253; _e222++) {
            s[_e222] = {
              mipmaps: []
            };

            for (var _t254 = 0; _t254 < n.mipmapCount; _t254++) {
              s[_e222].mipmaps.push(n.mipmaps[_e222 * n.mipmapCount + _t254]), s[_e222].format = n.format, s[_e222].width = n.width, s[_e222].height = n.height;
            }
          }

          a.image = s;
        } else a.image.width = n.width, a.image.height = n.height, a.mipmaps = n.mipmaps;

        1 === n.mipmapCount && (a.minFilter = 1006), a.format = n.format, a.needsUpdate = !0, e && e(a);
      }, n, i);
      return a;
    }
  }]);

  return tl;
}(Ko);

var el = /*#__PURE__*/function (_Ko3) {
  _inherits(el, _Ko3);

  var _super84 = _createSuper(el);

  function el(t) {
    _classCallCheck(this, el);

    return _super84.call(this, t);
  }

  _createClass(el, [{
    key: "load",
    value: function load(t, e, n, i) {
      void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = this,
          s = Jo.get(t);
      if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
        e && e(s), r.manager.itemEnd(t);
      }, 0), s;
      var a = document.createElementNS("http://www.w3.org/1999/xhtml", "img");

      function o() {
        a.removeEventListener("load", o, !1), a.removeEventListener("error", l, !1), Jo.add(t, this), e && e(this), r.manager.itemEnd(t);
      }

      function l(e) {
        a.removeEventListener("load", o, !1), a.removeEventListener("error", l, !1), i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
      }

      return a.addEventListener("load", o, !1), a.addEventListener("error", l, !1), "data:" !== t.substr(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), r.manager.itemStart(t), a.src = t, a;
    }
  }]);

  return el;
}(Ko);

var nl = /*#__PURE__*/function (_Ko4) {
  _inherits(nl, _Ko4);

  var _super85 = _createSuper(nl);

  function nl(t) {
    _classCallCheck(this, nl);

    return _super85.call(this, t);
  }

  _createClass(nl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = new Nn(),
          s = new el(this.manager);
      s.setCrossOrigin(this.crossOrigin), s.setPath(this.path);
      var a = 0;

      function o(n) {
        s.load(t[n], function (t) {
          r.images[n] = t, a++, 6 === a && (r.needsUpdate = !0, e && e(r));
        }, void 0, i);
      }

      for (var _e223 = 0; _e223 < t.length; ++_e223) {
        o(_e223);
      }

      return r;
    }
  }]);

  return nl;
}(Ko);

var il = /*#__PURE__*/function (_Ko5) {
  _inherits(il, _Ko5);

  var _super86 = _createSuper(il);

  function il(t) {
    _classCallCheck(this, il);

    return _super86.call(this, t);
  }

  _createClass(il, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = new oa(),
          a = new $o(this.manager);
      return a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setPath(this.path), a.setWithCredentials(r.withCredentials), a.load(t, function (t) {
        var n = r.parse(t);
        n && (void 0 !== n.image ? s.image = n.image : void 0 !== n.data && (s.image.width = n.width, s.image.height = n.height, s.image.data = n.data), s.wrapS = void 0 !== n.wrapS ? n.wrapS : 1001, s.wrapT = void 0 !== n.wrapT ? n.wrapT : 1001, s.magFilter = void 0 !== n.magFilter ? n.magFilter : 1006, s.minFilter = void 0 !== n.minFilter ? n.minFilter : 1006, s.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.encoding && (s.encoding = n.encoding), void 0 !== n.flipY && (s.flipY = n.flipY), void 0 !== n.format && (s.format = n.format), void 0 !== n.type && (s.type = n.type), void 0 !== n.mipmaps && (s.mipmaps = n.mipmaps, s.minFilter = 1008), 1 === n.mipmapCount && (s.minFilter = 1006), void 0 !== n.generateMipmaps && (s.generateMipmaps = n.generateMipmaps), s.needsUpdate = !0, e && e(s, n));
      }, n, i), s;
    }
  }]);

  return il;
}(Ko);

var rl = /*#__PURE__*/function (_Ko6) {
  _inherits(rl, _Ko6);

  var _super87 = _createSuper(rl);

  function rl(t) {
    _classCallCheck(this, rl);

    return _super87.call(this, t);
  }

  _createClass(rl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = new vt(),
          s = new el(this.manager);
      return s.setCrossOrigin(this.crossOrigin), s.setPath(this.path), s.load(t, function (n) {
        r.image = n;
        var i = t.search(/\.jpe?g($|\?)/i) > 0 || 0 === t.search(/^data\:image\/jpeg/);
        r.format = i ? 1022 : 1023, r.needsUpdate = !0, void 0 !== e && e(r);
      }, n, i), r;
    }
  }]);

  return rl;
}(Ko);

var sl = /*#__PURE__*/function (_Qa10) {
  _inherits(sl, _Qa10);

  var _super88 = _createSuper(sl);

  function sl() {
    var _this74;

    _classCallCheck(this, sl);

    _this74 = _super88.call(this), _this74.type = "CurvePath", _this74.curves = [], _this74.autoClose = !1;
    return _this74;
  }

  _createClass(sl, [{
    key: "add",
    value: function add(t) {
      this.curves.push(t);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      var t = this.curves[0].getPoint(0),
          e = this.curves[this.curves.length - 1].getPoint(1);
      t.equals(e) || this.curves.push(new Ya(e, t));
    }
  }, {
    key: "getPoint",
    value: function getPoint(t) {
      var e = t * this.getLength(),
          n = this.getCurveLengths();
      var i = 0;

      for (; i < n.length;) {
        if (n[i] >= e) {
          var _t255 = n[i] - e,
              _r115 = this.curves[i],
              _s71 = _r115.getLength(),
              _a51 = 0 === _s71 ? 0 : 1 - _t255 / _s71;

          return _r115.getPointAt(_a51);
        }

        i++;
      }

      return null;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var t = this.getCurveLengths();
      return t[t.length - 1];
    }
  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
  }, {
    key: "getCurveLengths",
    value: function getCurveLengths() {
      if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
      var t = [];
      var e = 0;

      for (var _n197 = 0, _i155 = this.curves.length; _n197 < _i155; _n197++) {
        e += this.curves[_n197].getLength(), t.push(e);
      }

      return this.cacheLengths = t, t;
    }
  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
      var e = [];

      for (var _n198 = 0; _n198 <= t; _n198++) {
        e.push(this.getPoint(_n198 / t));
      }

      return this.autoClose && e.push(e[0]), e;
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
      var e = [];
      var n;

      for (var _i156 = 0, _r116 = this.curves; _i156 < _r116.length; _i156++) {
        var _s72 = _r116[_i156],
            _a52 = _s72 && _s72.isEllipseCurve ? 2 * t : _s72 && (_s72.isLineCurve || _s72.isLineCurve3) ? 1 : _s72 && _s72.isSplineCurve ? t * _s72.points.length : t,
            _o32 = _s72.getPoints(_a52);

        for (var _t256 = 0; _t256 < _o32.length; _t256++) {
          var _i157 = _o32[_t256];
          n && n.equals(_i157) || (e.push(_i157), n = _i157);
        }
      }

      return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(sl.prototype), "copy", this).call(this, t), this.curves = [];

      for (var _e224 = 0, _n199 = t.curves.length; _e224 < _n199; _e224++) {
        var _n200 = t.curves[_e224];
        this.curves.push(_n200.clone());
      }

      return this.autoClose = t.autoClose, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(sl.prototype), "toJSON", this).call(this);

      t.autoClose = this.autoClose, t.curves = [];

      for (var _e225 = 0, _n201 = this.curves.length; _e225 < _n201; _e225++) {
        var _n202 = this.curves[_e225];
        t.curves.push(_n202.toJSON());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(sl.prototype), "fromJSON", this).call(this, t), this.autoClose = t.autoClose, this.curves = [];

      for (var _e226 = 0, _n203 = t.curves.length; _e226 < _n203; _e226++) {
        var _n204 = t.curves[_e226];
        this.curves.push(new Za[_n204.type]().fromJSON(_n204));
      }

      return this;
    }
  }]);

  return sl;
}(Qa);

var al = /*#__PURE__*/function (_sl) {
  _inherits(al, _sl);

  var _super89 = _createSuper(al);

  function al(t) {
    var _this75;

    _classCallCheck(this, al);

    _this75 = _super89.call(this), _this75.type = "Path", _this75.currentPoint = new pt(), t && _this75.setFromPoints(t);
    return _this75;
  }

  _createClass(al, [{
    key: "setFromPoints",
    value: function setFromPoints(t) {
      this.moveTo(t[0].x, t[0].y);

      for (var _e227 = 1, _n205 = t.length; _e227 < _n205; _e227++) {
        this.lineTo(t[_e227].x, t[_e227].y);
      }

      return this;
    }
  }, {
    key: "moveTo",
    value: function moveTo(t, e) {
      return this.currentPoint.set(t, e), this;
    }
  }, {
    key: "lineTo",
    value: function lineTo(t, e) {
      var n = new Ya(this.currentPoint.clone(), new pt(t, e));
      return this.curves.push(n), this.currentPoint.set(t, e), this;
    }
  }, {
    key: "quadraticCurveTo",
    value: function quadraticCurveTo(t, e, n, i) {
      var r = new Ja(this.currentPoint.clone(), new pt(t, e), new pt(n, i));
      return this.curves.push(r), this.currentPoint.set(n, i), this;
    }
  }, {
    key: "bezierCurveTo",
    value: function bezierCurveTo(t, e, n, i, r, s) {
      var a = new qa(this.currentPoint.clone(), new pt(t, e), new pt(n, i), new pt(r, s));
      return this.curves.push(a), this.currentPoint.set(r, s), this;
    }
  }, {
    key: "splineThru",
    value: function splineThru(t) {
      var e = [this.currentPoint.clone()].concat(t),
          n = new Ka(e);
      return this.curves.push(n), this.currentPoint.copy(t[t.length - 1]), this;
    }
  }, {
    key: "arc",
    value: function arc(t, e, n, i, r, s) {
      var a = this.currentPoint.x,
          o = this.currentPoint.y;
      return this.absarc(t + a, e + o, n, i, r, s), this;
    }
  }, {
    key: "absarc",
    value: function absarc(t, e, n, i, r, s) {
      return this.absellipse(t, e, n, n, i, r, s), this;
    }
  }, {
    key: "ellipse",
    value: function ellipse(t, e, n, i, r, s, a, o) {
      var l = this.currentPoint.x,
          c = this.currentPoint.y;
      return this.absellipse(t + l, e + c, n, i, r, s, a, o), this;
    }
  }, {
    key: "absellipse",
    value: function absellipse(t, e, n, i, r, s, a, o) {
      var l = new Pa(t, e, n, i, r, s, a, o);

      if (this.curves.length > 0) {
        var _t257 = l.getPoint(0);

        _t257.equals(this.currentPoint) || this.lineTo(_t257.x, _t257.y);
      }

      this.curves.push(l);
      var c = l.getPoint(1);
      return this.currentPoint.copy(c), this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(al.prototype), "copy", this).call(this, t), this.currentPoint.copy(t.currentPoint), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(al.prototype), "toJSON", this).call(this);

      return t.currentPoint = this.currentPoint.toArray(), t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return _get(_getPrototypeOf(al.prototype), "fromJSON", this).call(this, t), this.currentPoint.fromArray(t.currentPoint), this;
    }
  }]);

  return al;
}(sl);

var ol = /*#__PURE__*/function (_al) {
  _inherits(ol, _al);

  var _super90 = _createSuper(ol);

  function ol(t) {
    var _this76;

    _classCallCheck(this, ol);

    _this76 = _super90.call(this, t), _this76.uuid = st(), _this76.type = "Shape", _this76.holes = [];
    return _this76;
  }

  _createClass(ol, [{
    key: "getPointsHoles",
    value: function getPointsHoles(t) {
      var e = [];

      for (var _n206 = 0, _i158 = this.holes.length; _n206 < _i158; _n206++) {
        e[_n206] = this.holes[_n206].getPoints(t);
      }

      return e;
    }
  }, {
    key: "extractPoints",
    value: function extractPoints(t) {
      return {
        shape: this.getPoints(t),
        holes: this.getPointsHoles(t)
      };
    }
  }, {
    key: "copy",
    value: function copy(t) {
      _get(_getPrototypeOf(ol.prototype), "copy", this).call(this, t), this.holes = [];

      for (var _e228 = 0, _n207 = t.holes.length; _e228 < _n207; _e228++) {
        var _n208 = t.holes[_e228];
        this.holes.push(_n208.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(ol.prototype), "toJSON", this).call(this);

      t.uuid = this.uuid, t.holes = [];

      for (var _e229 = 0, _n209 = this.holes.length; _e229 < _n209; _e229++) {
        var _n210 = this.holes[_e229];
        t.holes.push(_n210.toJSON());
      }

      return t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      _get(_getPrototypeOf(ol.prototype), "fromJSON", this).call(this, t), this.uuid = t.uuid, this.holes = [];

      for (var _e230 = 0, _n211 = t.holes.length; _e230 < _n211; _e230++) {
        var _n212 = t.holes[_e230];
        this.holes.push(new al().fromJSON(_n212));
      }

      return this;
    }
  }]);

  return ol;
}(al);

var ll = /*#__PURE__*/function (_Ce10) {
  _inherits(ll, _Ce10);

  var _super91 = _createSuper(ll);

  function ll(t) {
    var _this77;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, ll);

    _this77 = _super91.call(this), _this77.type = "Light", _this77.color = new qe(t), _this77.intensity = e;
    return _this77;
  }

  _createClass(ll, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(ll.prototype), "copy", this).call(this, t), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(ll.prototype), "toJSON", this).call(this, t);

      return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
    }
  }]);

  return ll;
}(Ce);

ll.prototype.isLight = !0;

/*#__PURE__*/
(function (_ll) {
  _inherits(_class17, _ll);

  var _super92 = _createSuper(_class17);

  function _class17(t, e, n) {
    var _this78;

    _classCallCheck(this, _class17);

    _this78 = _super92.call(this, t, n), _this78.type = "HemisphereLight", _this78.position.copy(Ce.DefaultUp), _this78.updateMatrix(), _this78.groundColor = new qe(e);
    return _this78;
  }

  _createClass(_class17, [{
    key: "copy",
    value: function copy(t) {
      return ll.prototype.copy.call(this, t), this.groundColor.copy(t.groundColor), this;
    }
  }]);

  return _class17;
})(ll).prototype.isHemisphereLight = !0;
var cl = new ee(),
    hl = new _t(),
    ul = new _t();

var dl = /*#__PURE__*/function () {
  function dl(t) {
    _classCallCheck(this, dl);

    this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.mapSize = new pt(512, 512), this.map = null, this.mapPass = null, this.matrix = new ee(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Wn(), this._frameExtents = new pt(1, 1), this._viewportCount = 1, this._viewports = [new xt(0, 0, 1, 1)];
  }

  _createClass(dl, [{
    key: "getViewportCount",
    value: function getViewportCount() {
      return this._viewportCount;
    }
  }, {
    key: "getFrustum",
    value: function getFrustum() {
      return this._frustum;
    }
  }, {
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = this.camera,
          n = this.matrix;
      hl.setFromMatrixPosition(t.matrixWorld), e.position.copy(hl), ul.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(ul), e.updateMatrixWorld(), cl.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(cl), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(e.projectionMatrix), n.multiply(e.matrixWorldInverse);
    }
  }, {
    key: "getViewport",
    value: function getViewport(t) {
      return this._viewports[t];
    }
  }, {
    key: "getFrameExtents",
    value: function getFrameExtents() {
      return this._frameExtents;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = {};
      return 0 !== this.bias && (t.bias = this.bias), 0 !== this.normalBias && (t.normalBias = this.normalBias), 1 !== this.radius && (t.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
  }]);

  return dl;
}();

var pl = /*#__PURE__*/function (_dl) {
  _inherits(pl, _dl);

  var _super93 = _createSuper(pl);

  function pl() {
    var _this79;

    _classCallCheck(this, pl);

    _this79 = _super93.call(this, new Pn(50, 1, .5, 500)), _this79.focus = 1;
    return _this79;
  }

  _createClass(pl, [{
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = this.camera,
          n = 2 * rt * t.angle * this.focus,
          i = this.mapSize.width / this.mapSize.height,
          r = t.distance || e.far;
      n === e.fov && i === e.aspect && r === e.far || (e.fov = n, e.aspect = i, e.far = r, e.updateProjectionMatrix()), _get(_getPrototypeOf(pl.prototype), "updateMatrices", this).call(this, t);
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(pl.prototype), "copy", this).call(this, t), this.focus = t.focus, this;
    }
  }]);

  return pl;
}(dl);

pl.prototype.isSpotLightShadow = !0;

var Al = /*#__PURE__*/function (_ll2) {
  _inherits(Al, _ll2);

  var _super94 = _createSuper(Al);

  function Al(t, e) {
    var _this80;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 3;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck(this, Al);

    _this80 = _super94.call(this, t, e), _this80.type = "SpotLight", _this80.position.copy(Ce.DefaultUp), _this80.updateMatrix(), _this80.target = new Ce(), _this80.distance = n, _this80.angle = i, _this80.penumbra = r, _this80.decay = s, _this80.shadow = new pl();
    return _this80;
  }

  _createClass(Al, [{
    key: "power",
    get: function get() {
      return this.intensity * Math.PI;
    },
    set: function set(t) {
      this.intensity = t / Math.PI;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(Al.prototype), "copy", this).call(this, t), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
  }]);

  return Al;
}(ll);

Al.prototype.isSpotLight = !0;
var ml = new ee(),
    gl = new _t(),
    fl = new _t();

var vl = /*#__PURE__*/function (_dl2) {
  _inherits(vl, _dl2);

  var _super95 = _createSuper(vl);

  function vl() {
    var _this81;

    _classCallCheck(this, vl);

    _this81 = _super95.call(this, new Pn(90, 1, .5, 500)), _this81._frameExtents = new pt(4, 2), _this81._viewportCount = 6, _this81._viewports = [new xt(2, 1, 1, 1), new xt(0, 1, 1, 1), new xt(3, 1, 1, 1), new xt(1, 1, 1, 1), new xt(3, 0, 1, 1), new xt(1, 0, 1, 1)], _this81._cubeDirections = [new _t(1, 0, 0), new _t(-1, 0, 0), new _t(0, 0, 1), new _t(0, 0, -1), new _t(0, 1, 0), new _t(0, -1, 0)], _this81._cubeUps = [new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 0, 1), new _t(0, 0, -1)];
    return _this81;
  }

  _createClass(vl, [{
    key: "updateMatrices",
    value: function updateMatrices(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.camera,
          i = this.matrix,
          r = t.distance || n.far;
      r !== n.far && (n.far = r, n.updateProjectionMatrix()), gl.setFromMatrixPosition(t.matrixWorld), n.position.copy(gl), fl.copy(n.position), fl.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt(fl), n.updateMatrixWorld(), i.makeTranslation(-gl.x, -gl.y, -gl.z), ml.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(ml);
    }
  }]);

  return vl;
}(dl);

vl.prototype.isPointLightShadow = !0;

var yl = /*#__PURE__*/function (_ll3) {
  _inherits(yl, _ll3);

  var _super96 = _createSuper(yl);

  function yl(t, e) {
    var _this82;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, yl);

    _this82 = _super96.call(this, t, e), _this82.type = "PointLight", _this82.distance = n, _this82.decay = i, _this82.shadow = new vl();
    return _this82;
  }

  _createClass(yl, [{
    key: "power",
    get: function get() {
      return 4 * this.intensity * Math.PI;
    },
    set: function set(t) {
      this.intensity = t / (4 * Math.PI);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(yl.prototype), "copy", this).call(this, t), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
  }]);

  return yl;
}(ll);

yl.prototype.isPointLight = !0;

var xl = /*#__PURE__*/function (_dl3) {
  _inherits(xl, _dl3);

  var _super97 = _createSuper(xl);

  function xl() {
    _classCallCheck(this, xl);

    return _super97.call(this, new ri(-5, 5, 5, -5, .5, 500));
  }

  return _createClass(xl);
}(dl);

xl.prototype.isDirectionalLightShadow = !0;

var wl = /*#__PURE__*/function (_ll4) {
  _inherits(wl, _ll4);

  var _super98 = _createSuper(wl);

  function wl(t, e) {
    var _this83;

    _classCallCheck(this, wl);

    _this83 = _super98.call(this, t, e), _this83.type = "DirectionalLight", _this83.position.copy(Ce.DefaultUp), _this83.updateMatrix(), _this83.target = new Ce(), _this83.shadow = new xl();
    return _this83;
  }

  _createClass(wl, [{
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(wl.prototype), "copy", this).call(this, t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
  }]);

  return wl;
}(ll);

wl.prototype.isDirectionalLight = !0;

/*#__PURE__*/
(function (_ll5) {
  _inherits(_class18, _ll5);

  var _super99 = _createSuper(_class18);

  function _class18(t, e) {
    var _this84;

    _classCallCheck(this, _class18);

    _this84 = _super99.call(this, t, e), _this84.type = "AmbientLight";
    return _this84;
  }

  return _createClass(_class18);
})(ll).prototype.isAmbientLight = !0;

/*#__PURE__*/
(function (_ll6) {
  _inherits(_class19, _ll6);

  var _super100 = _createSuper(_class19);

  function _class19(t, e) {
    var _this85;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

    _classCallCheck(this, _class19);

    _this85 = _super100.call(this, t, e), _this85.type = "RectAreaLight", _this85.width = n, _this85.height = i;
    return _this85;
  }

  _createClass(_class19, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class19.prototype), "copy", this).call(this, t), this.width = t.width, this.height = t.height, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(_class19.prototype), "toJSON", this).call(this, t);

      return e.object.width = this.width, e.object.height = this.height, e;
    }
  }]);

  return _class19;
})(ll).prototype.isRectAreaLight = !0;

var El = /*#__PURE__*/function () {
  function El() {
    _classCallCheck(this, El);

    this.coefficients = [];

    for (var _t258 = 0; _t258 < 9; _t258++) {
      this.coefficients.push(new _t());
    }
  }

  _createClass(El, [{
    key: "set",
    value: function set(t) {
      for (var _e231 = 0; _e231 < 9; _e231++) {
        this.coefficients[_e231].copy(t[_e231]);
      }

      return this;
    }
  }, {
    key: "zero",
    value: function zero() {
      for (var _t259 = 0; _t259 < 9; _t259++) {
        this.coefficients[_t259].set(0, 0, 0);
      }

      return this;
    }
  }, {
    key: "getAt",
    value: function getAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = this.coefficients;
      return e.copy(s[0]).multiplyScalar(.282095), e.addScaledVector(s[1], .488603 * i), e.addScaledVector(s[2], .488603 * r), e.addScaledVector(s[3], .488603 * n), e.addScaledVector(s[4], n * i * 1.092548), e.addScaledVector(s[5], i * r * 1.092548), e.addScaledVector(s[6], .315392 * (3 * r * r - 1)), e.addScaledVector(s[7], n * r * 1.092548), e.addScaledVector(s[8], .546274 * (n * n - i * i)), e;
    }
  }, {
    key: "getIrradianceAt",
    value: function getIrradianceAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z,
          s = this.coefficients;
      return e.copy(s[0]).multiplyScalar(.886227), e.addScaledVector(s[1], 1.023328 * i), e.addScaledVector(s[2], 1.023328 * r), e.addScaledVector(s[3], 1.023328 * n), e.addScaledVector(s[4], .858086 * n * i), e.addScaledVector(s[5], .858086 * i * r), e.addScaledVector(s[6], .743125 * r * r - .247708), e.addScaledVector(s[7], .858086 * n * r), e.addScaledVector(s[8], .429043 * (n * n - i * i)), e;
    }
  }, {
    key: "add",
    value: function add(t) {
      for (var _e232 = 0; _e232 < 9; _e232++) {
        this.coefficients[_e232].add(t.coefficients[_e232]);
      }

      return this;
    }
  }, {
    key: "addScaledSH",
    value: function addScaledSH(t, e) {
      for (var _n213 = 0; _n213 < 9; _n213++) {
        this.coefficients[_n213].addScaledVector(t.coefficients[_n213], e);
      }

      return this;
    }
  }, {
    key: "scale",
    value: function scale(t) {
      for (var _e233 = 0; _e233 < 9; _e233++) {
        this.coefficients[_e233].multiplyScalar(t);
      }

      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(t, e) {
      for (var _n214 = 0; _n214 < 9; _n214++) {
        this.coefficients[_n214].lerp(t.coefficients[_n214], e);
      }

      return this;
    }
  }, {
    key: "equals",
    value: function equals(t) {
      for (var _e234 = 0; _e234 < 9; _e234++) {
        if (!this.coefficients[_e234].equals(t.coefficients[_e234])) return !1;
      }

      return !0;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.set(t.coefficients);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.coefficients;

      for (var _i159 = 0; _i159 < 9; _i159++) {
        n[_i159].fromArray(t, e + 3 * _i159);
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this.coefficients;

      for (var _i160 = 0; _i160 < 9; _i160++) {
        n[_i160].toArray(t, e + 3 * _i160);
      }

      return t;
    }
  }], [{
    key: "getBasisAt",
    value: function getBasisAt(t, e) {
      var n = t.x,
          i = t.y,
          r = t.z;
      e[0] = .282095, e[1] = .488603 * i, e[2] = .488603 * r, e[3] = .488603 * n, e[4] = 1.092548 * n * i, e[5] = 1.092548 * i * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * n * r, e[8] = .546274 * (n * n - i * i);
    }
  }]);

  return El;
}();

El.prototype.isSphericalHarmonics3 = !0;

var bl = /*#__PURE__*/function (_ll7) {
  _inherits(bl, _ll7);

  var _super101 = _createSuper(bl);

  function bl() {
    var _this86;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new El();
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, bl);

    _this86 = _super101.call(this, void 0, e), _this86.sh = t;
    return _this86;
  }

  _createClass(bl, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(bl.prototype), "copy", this).call(this, t), this.sh.copy(t.sh), this;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return this.intensity = t.intensity, this.sh.fromArray(t.sh), this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(bl.prototype), "toJSON", this).call(this, t);

      return e.object.sh = this.sh.toArray(), e;
    }
  }]);

  return bl;
}(ll);

bl.prototype.isLightProbe = !0;

var _l = /*#__PURE__*/function () {
  function _l() {
    _classCallCheck(this, _l);
  }

  _createClass(_l, null, [{
    key: "decodeText",
    value: function decodeText(t) {
      if ("undefined" != typeof TextDecoder) return new TextDecoder().decode(t);
      var e = "";

      for (var _n215 = 0, _i161 = t.length; _n215 < _i161; _n215++) {
        e += String.fromCharCode(t[_n215]);
      }

      try {
        return decodeURIComponent(escape(e));
      } catch (t) {
        return e;
      }
    }
  }, {
    key: "extractUrlBase",
    value: function extractUrlBase(t) {
      var e = t.lastIndexOf("/");
      return -1 === e ? "./" : t.substr(0, e + 1);
    }
  }]);

  return _l;
}();

/*#__PURE__*/
(function (_cn5) {
  _inherits(_class20, _cn5);

  var _super102 = _createSuper(_class20);

  function _class20() {
    var _this87;

    _classCallCheck(this, _class20);

    _this87 = _super102.call(this), _this87.type = "InstancedBufferGeometry", _this87.instanceCount = 1 / 0;
    return _this87;
  }

  _createClass(_class20, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class20.prototype), "copy", this).call(this, t), this.instanceCount = t.instanceCount, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(_class20.prototype), "toJSON", this).call(this, this);

      return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
  }]);

  return _class20;
})(cn).prototype.isInstancedBufferGeometry = !0;

/*#__PURE__*/
(function (_Xe5) {
  _inherits(_class21, _Xe5);

  var _super103 = _createSuper(_class21);

  function _class21(t, e, n) {
    var _this88;

    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, _class21);

    "number" == typeof n && (i = n, n = !1, console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.")), _this88 = _super103.call(this, t, e, n), _this88.meshPerAttribute = i;
    return _this88;
  }

  _createClass(_class21, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class21.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var t = _get(_getPrototypeOf(_class21.prototype), "toJSON", this).call(this);

      return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
  }]);

  return _class21;
})(Xe).prototype.isInstancedBufferAttribute = !0;

var Il = /*#__PURE__*/function (_Ko7) {
  _inherits(Il, _Ko7);

  var _super104 = _createSuper(Il);

  function Il(t) {
    var _this89;

    _classCallCheck(this, Il);

    _this89 = _super104.call(this, t), "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), _this89.options = {
      premultiplyAlpha: "none"
    };
    return _this89;
  }

  _createClass(Il, [{
    key: "setOptions",
    value: function setOptions(t) {
      return this.options = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      void 0 === t && (t = ""), void 0 !== this.path && (t = this.path + t), t = this.manager.resolveURL(t);
      var r = this,
          s = Jo.get(t);
      if (void 0 !== s) return r.manager.itemStart(t), setTimeout(function () {
        e && e(s), r.manager.itemEnd(t);
      }, 0), s;
      var a = {};
      a.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", a.headers = this.requestHeader, fetch(t, a).then(function (t) {
        return t.blob();
      }).then(function (t) {
        return createImageBitmap(t, Object.assign(r.options, {
          colorSpaceConversion: "none"
        }));
      }).then(function (n) {
        Jo.add(t, n), e && e(n), r.manager.itemEnd(t);
      }).catch(function (e) {
        i && i(e), r.manager.itemError(t), r.manager.itemEnd(t);
      }), r.manager.itemStart(t);
    }
  }]);

  return Il;
}(Ko);

var Cl;
Il.prototype.isImageBitmapLoader = !0;

var Ml = function Ml() {
  return void 0 === Cl && (Cl = new (window.AudioContext || window.webkitAudioContext)()), Cl;
};

var Sl = /*#__PURE__*/function (_Ko8) {
  _inherits(Sl, _Ko8);

  var _super105 = _createSuper(Sl);

  function Sl(t) {
    _classCallCheck(this, Sl);

    return _super105.call(this, t);
  }

  _createClass(Sl, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = new $o(this.manager);
      s.setResponseType("arraybuffer"), s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, function (n) {
        try {
          var _t260 = n.slice(0);

          Ml().decodeAudioData(_t260, function (t) {
            e(t);
          });
        } catch (e) {
          i ? i(e) : console.error(e), r.manager.itemError(t);
        }
      }, n, i);
    }
  }]);

  return Sl;
}(Ko);

/*#__PURE__*/
(function (_bl) {
  _inherits(_class22, _bl);

  var _super106 = _createSuper(_class22);

  function _class22(t, e) {
    var _this90;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    _classCallCheck(this, _class22);

    _this90 = _super106.call(this, void 0, n);
    var i = new qe().set(t),
        r = new qe().set(e),
        s = new _t(i.r, i.g, i.b),
        a = new _t(r.r, r.g, r.b),
        o = Math.sqrt(Math.PI),
        l = o * Math.sqrt(.75);
    _this90.sh.coefficients[0].copy(s).add(a).multiplyScalar(o), _this90.sh.coefficients[1].copy(s).sub(a).multiplyScalar(l);
    return _this90;
  }

  return _createClass(_class22);
})(bl).prototype.isHemisphereLightProbe = !0;

/*#__PURE__*/
(function (_bl2) {
  _inherits(_class23, _bl2);

  var _super107 = _createSuper(_class23);

  function _class23(t) {
    var _this91;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, _class23);

    _this91 = _super107.call(this, void 0, e);
    var n = new qe().set(t);

    _this91.sh.coefficients[0].set(n.r, n.g, n.b).multiplyScalar(2 * Math.sqrt(Math.PI));

    return _this91;
  }

  return _createClass(_class23);
})(bl).prototype.isAmbientLightProbe = !0;

var Bl = /*#__PURE__*/function () {
  function Bl(t, e, n) {
    _classCallCheck(this, Bl);

    var i, r, s;

    switch (this.binding = t, this.valueSize = n, e) {
      case "quaternion":
        i = this._slerp, r = this._slerpAdditive, s = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
        break;

      case "string":
      case "bool":
        i = this._select, r = this._select, s = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
        break;

      default:
        i = this._lerp, r = this._lerpAdditive, s = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
    }

    this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = s, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
  }

  _createClass(Bl, [{
    key: "accumulate",
    value: function accumulate(t, e) {
      var n = this.buffer,
          i = this.valueSize,
          r = t * i + i;
      var s = this.cumulativeWeight;

      if (0 === s) {
        for (var _t261 = 0; _t261 !== i; ++_t261) {
          n[r + _t261] = n[_t261];
        }

        s = e;
      } else {
        s += e;

        var _t262 = e / s;

        this._mixBufferRegion(n, r, 0, _t262, i);
      }

      this.cumulativeWeight = s;
    }
  }, {
    key: "accumulateAdditive",
    value: function accumulateAdditive(t) {
      var e = this.buffer,
          n = this.valueSize,
          i = n * this._addIndex;
      0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, i, 0, t, n), this.cumulativeWeightAdditive += t;
    }
  }, {
    key: "apply",
    value: function apply(t) {
      var e = this.valueSize,
          n = this.buffer,
          i = t * e + e,
          r = this.cumulativeWeight,
          s = this.cumulativeWeightAdditive,
          a = this.binding;

      if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
        var _t263 = e * this._origIndex;

        this._mixBufferRegion(n, i, _t263, 1 - r, e);
      }

      s > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * e, 1, e);

      for (var _t264 = e, _r117 = e + e; _t264 !== _r117; ++_t264) {
        if (n[_t264] !== n[_t264 + e]) {
          a.setValue(n, i);
          break;
        }
      }
    }
  }, {
    key: "saveOriginalState",
    value: function saveOriginalState() {
      var t = this.binding,
          e = this.buffer,
          n = this.valueSize,
          i = n * this._origIndex;
      t.getValue(e, i);

      for (var _t265 = n, _r118 = i; _t265 !== _r118; ++_t265) {
        e[_t265] = e[i + _t265 % n];
      }

      this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
  }, {
    key: "restoreOriginalState",
    value: function restoreOriginalState() {
      var t = 3 * this.valueSize;
      this.binding.setValue(this.buffer, t);
    }
  }, {
    key: "_setAdditiveIdentityNumeric",
    value: function _setAdditiveIdentityNumeric() {
      var t = this._addIndex * this.valueSize,
          e = t + this.valueSize;

      for (var _n216 = t; _n216 < e; _n216++) {
        this.buffer[_n216] = 0;
      }
    }
  }, {
    key: "_setAdditiveIdentityQuaternion",
    value: function _setAdditiveIdentityQuaternion() {
      this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
  }, {
    key: "_setAdditiveIdentityOther",
    value: function _setAdditiveIdentityOther() {
      var t = this._origIndex * this.valueSize,
          e = this._addIndex * this.valueSize;

      for (var _n217 = 0; _n217 < this.valueSize; _n217++) {
        this.buffer[e + _n217] = this.buffer[t + _n217];
      }
    }
  }, {
    key: "_select",
    value: function _select(t, e, n, i, r) {
      if (i >= .5) for (var _i162 = 0; _i162 !== r; ++_i162) {
        t[e + _i162] = t[n + _i162];
      }
    }
  }, {
    key: "_slerp",
    value: function _slerp(t, e, n, i) {
      bt.slerpFlat(t, e, t, e, t, n, i);
    }
  }, {
    key: "_slerpAdditive",
    value: function _slerpAdditive(t, e, n, i, r) {
      var s = this._workIndex * r;
      bt.multiplyQuaternionsFlat(t, s, t, e, t, n), bt.slerpFlat(t, e, t, e, t, s, i);
    }
  }, {
    key: "_lerp",
    value: function _lerp(t, e, n, i, r) {
      var s = 1 - i;

      for (var _a53 = 0; _a53 !== r; ++_a53) {
        var _r119 = e + _a53;

        t[_r119] = t[_r119] * s + t[n + _a53] * i;
      }
    }
  }, {
    key: "_lerpAdditive",
    value: function _lerpAdditive(t, e, n, i, r) {
      for (var _s73 = 0; _s73 !== r; ++_s73) {
        var _r120 = e + _s73;

        t[_r120] = t[_r120] + t[n + _s73] * i;
      }
    }
  }]);

  return Bl;
}();

var Tl = new RegExp("[\\[\\]\\.:\\/]", "g"),
    Ll = "[^" + "\\[\\]\\.:\\/".replace("\\.", "") + "]",
    Rl = /((?:WC+[\/:])*)/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Dl = /(WCOD+)?/.source.replace("WCOD", Ll),
    Ql = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Pl = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
    Fl = new RegExp("^" + Rl + Dl + Ql + Pl + "$"),
    Nl = ["material", "materials", "bones"];

var Ul = /*#__PURE__*/function () {
  function Ul(t, e, n) {
    _classCallCheck(this, Ul);

    this.path = e, this.parsedPath = n || Ul.parseTrackName(e), this.node = Ul.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }

  _createClass(Ul, [{
    key: "_getValue_unavailable",
    value: function _getValue_unavailable() {}
  }, {
    key: "_setValue_unavailable",
    value: function _setValue_unavailable() {}
  }, {
    key: "_getValue_direct",
    value: function _getValue_direct(t, e) {
      t[e] = this.node[this.propertyName];
    }
  }, {
    key: "_getValue_array",
    value: function _getValue_array(t, e) {
      var n = this.resolvedProperty;

      for (var _i163 = 0, _r121 = n.length; _i163 !== _r121; ++_i163) {
        t[e++] = n[_i163];
      }
    }
  }, {
    key: "_getValue_arrayElement",
    value: function _getValue_arrayElement(t, e) {
      t[e] = this.resolvedProperty[this.propertyIndex];
    }
  }, {
    key: "_getValue_toArray",
    value: function _getValue_toArray(t, e) {
      this.resolvedProperty.toArray(t, e);
    }
  }, {
    key: "_setValue_direct",
    value: function _setValue_direct(t, e) {
      this.targetObject[this.propertyName] = t[e];
    }
  }, {
    key: "_setValue_direct_setNeedsUpdate",
    value: function _setValue_direct_setNeedsUpdate(t, e) {
      this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_direct_setMatrixWorldNeedsUpdate",
    value: function _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
      this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_array",
    value: function _setValue_array(t, e) {
      var n = this.resolvedProperty;

      for (var _i164 = 0, _r122 = n.length; _i164 !== _r122; ++_i164) {
        n[_i164] = t[e++];
      }
    }
  }, {
    key: "_setValue_array_setNeedsUpdate",
    value: function _setValue_array_setNeedsUpdate(t, e) {
      var n = this.resolvedProperty;

      for (var _i165 = 0, _r123 = n.length; _i165 !== _r123; ++_i165) {
        n[_i165] = t[e++];
      }

      this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_array_setMatrixWorldNeedsUpdate",
    value: function _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
      var n = this.resolvedProperty;

      for (var _i166 = 0, _r124 = n.length; _i166 !== _r124; ++_i166) {
        n[_i166] = t[e++];
      }

      this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_arrayElement",
    value: function _setValue_arrayElement(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e];
    }
  }, {
    key: "_setValue_arrayElement_setNeedsUpdate",
    value: function _setValue_arrayElement_setNeedsUpdate(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
    value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
      this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_setValue_fromArray",
    value: function _setValue_fromArray(t, e) {
      this.resolvedProperty.fromArray(t, e);
    }
  }, {
    key: "_setValue_fromArray_setNeedsUpdate",
    value: function _setValue_fromArray_setNeedsUpdate(t, e) {
      this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
  }, {
    key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
    value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
      this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
  }, {
    key: "_getValue_unbound",
    value: function _getValue_unbound(t, e) {
      this.bind(), this.getValue(t, e);
    }
  }, {
    key: "_setValue_unbound",
    value: function _setValue_unbound(t, e) {
      this.bind(), this.setValue(t, e);
    }
  }, {
    key: "bind",
    value: function bind() {
      var t = this.node;
      var e = this.parsedPath,
          n = e.objectName,
          i = e.propertyName;
      var r = e.propertyIndex;
      if (t || (t = Ul.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) return void console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");

      if (n) {
        var _i167 = e.objectIndex;

        switch (n) {
          case "materials":
            if (!t.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            if (!t.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            t = t.material.materials;
            break;

          case "bones":
            if (!t.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            t = t.skeleton.bones;

            for (var _e235 = 0; _e235 < t.length; _e235++) {
              if (t[_e235].name === _i167) {
                _i167 = _e235;
                break;
              }
            }

            break;

          default:
            if (void 0 === t[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            t = t[n];
        }

        if (void 0 !== _i167) {
          if (void 0 === t[_i167]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
          t = t[_i167];
        }
      }

      var s = t[i];

      if (void 0 === s) {
        var _n218 = e.nodeName;
        return void console.error("THREE.PropertyBinding: Trying to update property for track: " + _n218 + "." + i + " but it wasn't found.", t);
      }

      var a = this.Versioning.None;
      this.targetObject = t, void 0 !== t.needsUpdate ? a = this.Versioning.NeedsUpdate : void 0 !== t.matrixWorldNeedsUpdate && (a = this.Versioning.MatrixWorldNeedsUpdate);
      var o = this.BindingType.Direct;

      if (void 0 !== r) {
        if ("morphTargetInfluences" === i) {
          if (!t.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          if (!t.geometry.isBufferGeometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
          if (!t.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          void 0 !== t.morphTargetDictionary[r] && (r = t.morphTargetDictionary[r]);
        }

        o = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = r;
      } else void 0 !== s.fromArray && void 0 !== s.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (o = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = i;

      this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][a];
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
  }], [{
    key: "create",
    value: function create(t, e, n) {
      return t && t.isAnimationObjectGroup ? new Ul.Composite(t, e, n) : new Ul(t, e, n);
    }
  }, {
    key: "sanitizeNodeName",
    value: function sanitizeNodeName(t) {
      return t.replace(/\s/g, "_").replace(Tl, "");
    }
  }, {
    key: "parseTrackName",
    value: function parseTrackName(t) {
      var e = Fl.exec(t);
      if (!e) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
      var n = {
        nodeName: e[2],
        objectName: e[3],
        objectIndex: e[4],
        propertyName: e[5],
        propertyIndex: e[6]
      },
          i = n.nodeName && n.nodeName.lastIndexOf(".");

      if (void 0 !== i && -1 !== i) {
        var _t266 = n.nodeName.substring(i + 1);

        -1 !== Nl.indexOf(_t266) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = _t266);
      }

      if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
      return n;
    }
  }, {
    key: "findNode",
    value: function findNode(t, e) {
      if (!e || "" === e || "." === e || -1 === e || e === t.name || e === t.uuid) return t;

      if (t.skeleton) {
        var _n219 = t.skeleton.getBoneByName(e);

        if (void 0 !== _n219) return _n219;
      }

      if (t.children) {
        var _n220 = function _n220(t) {
          for (var _i169 = 0; _i169 < t.length; _i169++) {
            var _r125 = t[_i169];
            if (_r125.name === e || _r125.uuid === e) return _r125;

            var _s74 = _n220(_r125.children);

            if (_s74) return _s74;
          }

          return null;
        },
            _i168 = _n220(t.children);

        if (_i168) return _i168;
      }

      return null;
    }
  }]);

  return Ul;
}();

Ul.Composite = /*#__PURE__*/function () {
  function _class24(t, e, n) {
    _classCallCheck(this, _class24);

    var i = n || Ul.parseTrackName(e);
    this._targetGroup = t, this._bindings = t.subscribe_(e, i);
  }

  _createClass(_class24, [{
    key: "getValue",
    value: function getValue(t, e) {
      this.bind();
      var n = this._targetGroup.nCachedObjects_,
          i = this._bindings[n];
      void 0 !== i && i.getValue(t, e);
    }
  }, {
    key: "setValue",
    value: function setValue(t, e) {
      var n = this._bindings;

      for (var _i170 = this._targetGroup.nCachedObjects_, _r126 = n.length; _i170 !== _r126; ++_i170) {
        n[_i170].setValue(t, e);
      }
    }
  }, {
    key: "bind",
    value: function bind() {
      var t = this._bindings;

      for (var _e236 = this._targetGroup.nCachedObjects_, _n221 = t.length; _e236 !== _n221; ++_e236) {
        t[_e236].bind();
      }
    }
  }, {
    key: "unbind",
    value: function unbind() {
      var t = this._bindings;

      for (var _e237 = this._targetGroup.nCachedObjects_, _n222 = t.length; _e237 !== _n222; ++_e237) {
        t[_e237].unbind();
      }
    }
  }]);

  return _class24;
}(), Ul.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
}, Ul.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
}, Ul.prototype.GetterByBindingType = [Ul.prototype._getValue_direct, Ul.prototype._getValue_array, Ul.prototype._getValue_arrayElement, Ul.prototype._getValue_toArray], Ul.prototype.SetterByBindingTypeAndVersioning = [[Ul.prototype._setValue_direct, Ul.prototype._setValue_direct_setNeedsUpdate, Ul.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [Ul.prototype._setValue_array, Ul.prototype._setValue_array_setNeedsUpdate, Ul.prototype._setValue_array_setMatrixWorldNeedsUpdate], [Ul.prototype._setValue_arrayElement, Ul.prototype._setValue_arrayElement_setNeedsUpdate, Ul.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [Ul.prototype._setValue_fromArray, Ul.prototype._setValue_fromArray_setNeedsUpdate, Ul.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];

var kl = /*#__PURE__*/function () {
  function kl(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.blendMode;

    _classCallCheck(this, kl);

    this._mixer = t, this._clip = e, this._localRoot = n, this.blendMode = i;
    var r = e.tracks,
        s = r.length,
        a = new Array(s),
        o = {
      endingStart: 2400,
      endingEnd: 2400
    };

    for (var _t267 = 0; _t267 !== s; ++_t267) {
      var _e238 = r[_t267].createInterpolant(null);

      a[_t267] = _e238, _e238.settings = o;
    }

    this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(s), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
  }

  _createClass(kl, [{
    key: "play",
    value: function play() {
      return this._mixer._activateAction(this), this;
    }
  }, {
    key: "stop",
    value: function stop() {
      return this._mixer._deactivateAction(this), this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
    }
  }, {
    key: "isScheduled",
    value: function isScheduled() {
      return this._mixer._isActiveAction(this);
    }
  }, {
    key: "startAt",
    value: function startAt(t) {
      return this._startTime = t, this;
    }
  }, {
    key: "setLoop",
    value: function setLoop(t, e) {
      return this.loop = t, this.repetitions = e, this;
    }
  }, {
    key: "setEffectiveWeight",
    value: function setEffectiveWeight(t) {
      return this.weight = t, this._effectiveWeight = this.enabled ? t : 0, this.stopFading();
    }
  }, {
    key: "getEffectiveWeight",
    value: function getEffectiveWeight() {
      return this._effectiveWeight;
    }
  }, {
    key: "fadeIn",
    value: function fadeIn(t) {
      return this._scheduleFading(t, 0, 1);
    }
  }, {
    key: "fadeOut",
    value: function fadeOut(t) {
      return this._scheduleFading(t, 1, 0);
    }
  }, {
    key: "crossFadeFrom",
    value: function crossFadeFrom(t, e, n) {
      if (t.fadeOut(e), this.fadeIn(e), n) {
        var _n223 = this._clip.duration,
            _i171 = t._clip.duration,
            _r127 = _i171 / _n223,
            _s75 = _n223 / _i171;

        t.warp(1, _r127, e), this.warp(_s75, 1, e);
      }

      return this;
    }
  }, {
    key: "crossFadeTo",
    value: function crossFadeTo(t, e, n) {
      return t.crossFadeFrom(this, e, n);
    }
  }, {
    key: "stopFading",
    value: function stopFading() {
      var t = this._weightInterpolant;
      return null !== t && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
  }, {
    key: "setEffectiveTimeScale",
    value: function setEffectiveTimeScale(t) {
      return this.timeScale = t, this._effectiveTimeScale = this.paused ? 0 : t, this.stopWarping();
    }
  }, {
    key: "getEffectiveTimeScale",
    value: function getEffectiveTimeScale() {
      return this._effectiveTimeScale;
    }
  }, {
    key: "setDuration",
    value: function setDuration(t) {
      return this.timeScale = this._clip.duration / t, this.stopWarping();
    }
  }, {
    key: "syncWith",
    value: function syncWith(t) {
      return this.time = t.time, this.timeScale = t.timeScale, this.stopWarping();
    }
  }, {
    key: "halt",
    value: function halt(t) {
      return this.warp(this._effectiveTimeScale, 0, t);
    }
  }, {
    key: "warp",
    value: function warp(t, e, n) {
      var i = this._mixer,
          r = i.time,
          s = this.timeScale;
      var a = this._timeScaleInterpolant;
      null === a && (a = i._lendControlInterpolant(), this._timeScaleInterpolant = a);
      var o = a.parameterPositions,
          l = a.sampleValues;
      return o[0] = r, o[1] = r + n, l[0] = t / s, l[1] = e / s, this;
    }
  }, {
    key: "stopWarping",
    value: function stopWarping() {
      var t = this._timeScaleInterpolant;
      return null !== t && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t)), this;
    }
  }, {
    key: "getMixer",
    value: function getMixer() {
      return this._mixer;
    }
  }, {
    key: "getClip",
    value: function getClip() {
      return this._clip;
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return this._localRoot || this._mixer._root;
    }
  }, {
    key: "_update",
    value: function _update(t, e, n, i) {
      if (!this.enabled) return void this._updateWeight(t);
      var r = this._startTime;

      if (null !== r) {
        var _i172 = (t - r) * n;

        if (_i172 < 0 || 0 === n) return;
        this._startTime = null, e = n * _i172;
      }

      e *= this._updateTimeScale(t);

      var s = this._updateTime(e),
          a = this._updateWeight(t);

      if (a > 0) {
        var _t268 = this._interpolants,
            _e239 = this._propertyBindings;

        switch (this.blendMode) {
          case 2501:
            for (var _n224 = 0, _i173 = _t268.length; _n224 !== _i173; ++_n224) {
              _t268[_n224].evaluate(s), _e239[_n224].accumulateAdditive(a);
            }

            break;

          case 2500:
          default:
            for (var _n225 = 0, _r128 = _t268.length; _n225 !== _r128; ++_n225) {
              _t268[_n225].evaluate(s), _e239[_n225].accumulate(i, a);
            }

        }
      }
    }
  }, {
    key: "_updateWeight",
    value: function _updateWeight(t) {
      var e = 0;

      if (this.enabled) {
        e = this.weight;
        var _n226 = this._weightInterpolant;

        if (null !== _n226) {
          var _i174 = _n226.evaluate(t)[0];

          e *= _i174, t > _n226.parameterPositions[1] && (this.stopFading(), 0 === _i174 && (this.enabled = !1));
        }
      }

      return this._effectiveWeight = e, e;
    }
  }, {
    key: "_updateTimeScale",
    value: function _updateTimeScale(t) {
      var e = 0;

      if (!this.paused) {
        e = this.timeScale;
        var _n227 = this._timeScaleInterpolant;

        if (null !== _n227) {
          e *= _n227.evaluate(t)[0], t > _n227.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e);
        }
      }

      return this._effectiveTimeScale = e, e;
    }
  }, {
    key: "_updateTime",
    value: function _updateTime(t) {
      var e = this._clip.duration,
          n = this.loop;
      var i = this.time + t,
          r = this._loopCount;
      var s = 2202 === n;
      if (0 === t) return -1 === r ? i : s && 1 == (1 & r) ? e - i : i;

      if (2200 === n) {
        -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));

        t: {
          if (i >= e) i = e;else {
            if (!(i < 0)) {
              this.time = i;
              break t;
            }

            i = 0;
          }
          this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: t < 0 ? -1 : 1
          });
        }
      } else {
        if (-1 === r && (t >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, s)) : this._setEndings(0 === this.repetitions, !0, s)), i >= e || i < 0) {
          var _n228 = Math.floor(i / e);

          i -= e * _n228, r += Math.abs(_n228);

          var _a54 = this.repetitions - r;

          if (_a54 <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = t > 0 ? e : 0, this.time = i, this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: t > 0 ? 1 : -1
          });else {
            if (1 === _a54) {
              var _e240 = t < 0;

              this._setEndings(_e240, !_e240, s);
            } else this._setEndings(!1, !1, s);

            this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
              type: "loop",
              action: this,
              loopDelta: _n228
            });
          }
        } else this.time = i;

        if (s && 1 == (1 & r)) return e - i;
      }

      return i;
    }
  }, {
    key: "_setEndings",
    value: function _setEndings(t, e, n) {
      var i = this._interpolantSettings;
      n ? (i.endingStart = 2401, i.endingEnd = 2401) : (i.endingStart = t ? this.zeroSlopeAtStart ? 2401 : 2400 : 2402, i.endingEnd = e ? this.zeroSlopeAtEnd ? 2401 : 2400 : 2402);
    }
  }, {
    key: "_scheduleFading",
    value: function _scheduleFading(t, e, n) {
      var i = this._mixer,
          r = i.time;
      var s = this._weightInterpolant;
      null === s && (s = i._lendControlInterpolant(), this._weightInterpolant = s);
      var a = s.parameterPositions,
          o = s.sampleValues;
      return a[0] = r, o[0] = e, a[1] = r + t, o[1] = n, this;
    }
  }]);

  return kl;
}();

var Gl = /*#__PURE__*/function (_tt7) {
  _inherits(Gl, _tt7);

  var _super108 = _createSuper(Gl);

  function Gl(t) {
    var _this92;

    _classCallCheck(this, Gl);

    _this92 = _super108.call(this), _this92._root = t, _this92._initMemoryManager(), _this92._accuIndex = 0, _this92.time = 0, _this92.timeScale = 1;
    return _this92;
  }

  _createClass(Gl, [{
    key: "_bindAction",
    value: function _bindAction(t, e) {
      var n = t._localRoot || this._root,
          i = t._clip.tracks,
          r = i.length,
          s = t._propertyBindings,
          a = t._interpolants,
          o = n.uuid,
          l = this._bindingsByRootAndName;
      var c = l[o];
      void 0 === c && (c = {}, l[o] = c);

      for (var _t269 = 0; _t269 !== r; ++_t269) {
        var _r129 = i[_t269],
            _l23 = _r129.name;
        var _h9 = c[_l23];
        if (void 0 !== _h9) s[_t269] = _h9;else {
          if (_h9 = s[_t269], void 0 !== _h9) {
            null === _h9._cacheIndex && (++_h9.referenceCount, this._addInactiveBinding(_h9, o, _l23));
            continue;
          }

          var _i175 = e && e._propertyBindings[_t269].binding.parsedPath;

          _h9 = new Bl(Ul.create(n, _l23, _i175), _r129.ValueTypeName, _r129.getValueSize()), ++_h9.referenceCount, this._addInactiveBinding(_h9, o, _l23), s[_t269] = _h9;
        }
        a[_t269].resultBuffer = _h9.buffer;
      }
    }
  }, {
    key: "_activateAction",
    value: function _activateAction(t) {
      if (!this._isActiveAction(t)) {
        if (null === t._cacheIndex) {
          var _e242 = (t._localRoot || this._root).uuid,
              _n229 = t._clip.uuid,
              _i176 = this._actionsByClip[_n229];
          this._bindAction(t, _i176 && _i176.knownActions[0]), this._addInactiveAction(t, _n229, _e242);
        }

        var _e241 = t._propertyBindings;

        for (var _t270 = 0, _n230 = _e241.length; _t270 !== _n230; ++_t270) {
          var _n231 = _e241[_t270];
          0 == _n231.useCount++ && (this._lendBinding(_n231), _n231.saveOriginalState());
        }

        this._lendAction(t);
      }
    }
  }, {
    key: "_deactivateAction",
    value: function _deactivateAction(t) {
      if (this._isActiveAction(t)) {
        var _e243 = t._propertyBindings;

        for (var _t271 = 0, _n232 = _e243.length; _t271 !== _n232; ++_t271) {
          var _n233 = _e243[_t271];
          0 == --_n233.useCount && (_n233.restoreOriginalState(), this._takeBackBinding(_n233));
        }

        this._takeBackAction(t);
      }
    }
  }, {
    key: "_initMemoryManager",
    value: function _initMemoryManager() {
      this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
      var t = this;
      this.stats = {
        actions: {
          get total() {
            return t._actions.length;
          },

          get inUse() {
            return t._nActiveActions;
          }

        },
        bindings: {
          get total() {
            return t._bindings.length;
          },

          get inUse() {
            return t._nActiveBindings;
          }

        },
        controlInterpolants: {
          get total() {
            return t._controlInterpolants.length;
          },

          get inUse() {
            return t._nActiveControlInterpolants;
          }

        }
      };
    }
  }, {
    key: "_isActiveAction",
    value: function _isActiveAction(t) {
      var e = t._cacheIndex;
      return null !== e && e < this._nActiveActions;
    }
  }, {
    key: "_addInactiveAction",
    value: function _addInactiveAction(t, e, n) {
      var i = this._actions,
          r = this._actionsByClip;
      var s = r[e];
      if (void 0 === s) s = {
        knownActions: [t],
        actionByRoot: {}
      }, t._byClipCacheIndex = 0, r[e] = s;else {
        var _e244 = s.knownActions;
        t._byClipCacheIndex = _e244.length, _e244.push(t);
      }
      t._cacheIndex = i.length, i.push(t), s.actionByRoot[n] = t;
    }
  }, {
    key: "_removeInactiveAction",
    value: function _removeInactiveAction(t) {
      var e = this._actions,
          n = e[e.length - 1],
          i = t._cacheIndex;
      n._cacheIndex = i, e[i] = n, e.pop(), t._cacheIndex = null;
      var r = t._clip.uuid,
          s = this._actionsByClip,
          a = s[r],
          o = a.knownActions,
          l = o[o.length - 1],
          c = t._byClipCacheIndex;
      l._byClipCacheIndex = c, o[c] = l, o.pop(), t._byClipCacheIndex = null;
      delete a.actionByRoot[(t._localRoot || this._root).uuid], 0 === o.length && delete s[r], this._removeInactiveBindingsForAction(t);
    }
  }, {
    key: "_removeInactiveBindingsForAction",
    value: function _removeInactiveBindingsForAction(t) {
      var e = t._propertyBindings;

      for (var _t272 = 0, _n234 = e.length; _t272 !== _n234; ++_t272) {
        var _n235 = e[_t272];
        0 == --_n235.referenceCount && this._removeInactiveBinding(_n235);
      }
    }
  }, {
    key: "_lendAction",
    value: function _lendAction(t) {
      var e = this._actions,
          n = t._cacheIndex,
          i = this._nActiveActions++,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_takeBackAction",
    value: function _takeBackAction(t) {
      var e = this._actions,
          n = t._cacheIndex,
          i = --this._nActiveActions,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_addInactiveBinding",
    value: function _addInactiveBinding(t, e, n) {
      var i = this._bindingsByRootAndName,
          r = this._bindings;
      var s = i[e];
      void 0 === s && (s = {}, i[e] = s), s[n] = t, t._cacheIndex = r.length, r.push(t);
    }
  }, {
    key: "_removeInactiveBinding",
    value: function _removeInactiveBinding(t) {
      var e = this._bindings,
          n = t.binding,
          i = n.rootNode.uuid,
          r = n.path,
          s = this._bindingsByRootAndName,
          a = s[i],
          o = e[e.length - 1],
          l = t._cacheIndex;
      o._cacheIndex = l, e[l] = o, e.pop(), delete a[r], 0 === Object.keys(a).length && delete s[i];
    }
  }, {
    key: "_lendBinding",
    value: function _lendBinding(t) {
      var e = this._bindings,
          n = t._cacheIndex,
          i = this._nActiveBindings++,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_takeBackBinding",
    value: function _takeBackBinding(t) {
      var e = this._bindings,
          n = t._cacheIndex,
          i = --this._nActiveBindings,
          r = e[i];
      t._cacheIndex = i, e[i] = t, r._cacheIndex = n, e[n] = r;
    }
  }, {
    key: "_lendControlInterpolant",
    value: function _lendControlInterpolant() {
      var t = this._controlInterpolants,
          e = this._nActiveControlInterpolants++;
      var n = t[e];
      return void 0 === n && (n = new No(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), n.__cacheIndex = e, t[e] = n), n;
    }
  }, {
    key: "_takeBackControlInterpolant",
    value: function _takeBackControlInterpolant(t) {
      var e = this._controlInterpolants,
          n = t.__cacheIndex,
          i = --this._nActiveControlInterpolants,
          r = e[i];
      t.__cacheIndex = i, e[i] = t, r.__cacheIndex = n, e[n] = r;
    }
  }, {
    key: "clipAction",
    value: function clipAction(t, e, n) {
      var i = e || this._root,
          r = i.uuid;
      var s = "string" == typeof t ? jo.findByName(i, t) : t;
      var a = null !== s ? s.uuid : t,
          o = this._actionsByClip[a];
      var l = null;

      if (void 0 === n && (n = null !== s ? s.blendMode : 2500), void 0 !== o) {
        var _t273 = o.actionByRoot[r];
        if (void 0 !== _t273 && _t273.blendMode === n) return _t273;
        l = o.knownActions[0], null === s && (s = l._clip);
      }

      if (null === s) return null;
      var c = new kl(this, s, e, n);
      return this._bindAction(c, l), this._addInactiveAction(c, a, r), c;
    }
  }, {
    key: "existingAction",
    value: function existingAction(t, e) {
      var n = e || this._root,
          i = n.uuid,
          r = "string" == typeof t ? jo.findByName(n, t) : t,
          s = r ? r.uuid : t,
          a = this._actionsByClip[s];
      return void 0 !== a && a.actionByRoot[i] || null;
    }
  }, {
    key: "stopAllAction",
    value: function stopAllAction() {
      var t = this._actions;

      for (var _e245 = this._nActiveActions - 1; _e245 >= 0; --_e245) {
        t[_e245].stop();
      }

      return this;
    }
  }, {
    key: "update",
    value: function update(t) {
      t *= this.timeScale;
      var e = this._actions,
          n = this._nActiveActions,
          i = this.time += t,
          r = Math.sign(t),
          s = this._accuIndex ^= 1;

      for (var _a55 = 0; _a55 !== n; ++_a55) {
        e[_a55]._update(i, t, r, s);
      }

      var a = this._bindings,
          o = this._nActiveBindings;

      for (var _t274 = 0; _t274 !== o; ++_t274) {
        a[_t274].apply(s);
      }

      return this;
    }
  }, {
    key: "setTime",
    value: function setTime(t) {
      this.time = 0;

      for (var _t275 = 0; _t275 < this._actions.length; _t275++) {
        this._actions[_t275].time = 0;
      }

      return this.update(t);
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return this._root;
    }
  }, {
    key: "uncacheClip",
    value: function uncacheClip(t) {
      var e = this._actions,
          n = t.uuid,
          i = this._actionsByClip,
          r = i[n];

      if (void 0 !== r) {
        var _t276 = r.knownActions;

        for (var _n236 = 0, _i177 = _t276.length; _n236 !== _i177; ++_n236) {
          var _i178 = _t276[_n236];

          this._deactivateAction(_i178);

          var _r130 = _i178._cacheIndex,
              _s76 = e[e.length - 1];
          _i178._cacheIndex = null, _i178._byClipCacheIndex = null, _s76._cacheIndex = _r130, e[_r130] = _s76, e.pop(), this._removeInactiveBindingsForAction(_i178);
        }

        delete i[n];
      }
    }
  }, {
    key: "uncacheRoot",
    value: function uncacheRoot(t) {
      var e = t.uuid,
          n = this._actionsByClip;

      for (var _t277 in n) {
        var _i179 = n[_t277].actionByRoot[e];
        void 0 !== _i179 && (this._deactivateAction(_i179), this._removeInactiveAction(_i179));
      }

      var i = this._bindingsByRootAndName[e];
      if (void 0 !== i) for (var _t278 in i) {
        var _e246 = i[_t278];
        _e246.restoreOriginalState(), this._removeInactiveBinding(_e246);
      }
    }
  }, {
    key: "uncacheAction",
    value: function uncacheAction(t, e) {
      var n = this.existingAction(t, e);
      null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
    }
  }]);

  return Gl;
}(tt);

Gl.prototype._controlInterpolantsResultBuffer = new Float32Array(1);

/*#__PURE__*/
(function (_Fs) {
  _inherits(_class25, _Fs);

  var _super109 = _createSuper(_class25);

  function _class25(t, e) {
    var _this93;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    _classCallCheck(this, _class25);

    _this93 = _super109.call(this, t, e), _this93.meshPerAttribute = n;
    return _this93;
  }

  _createClass(_class25, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(_class25.prototype), "copy", this).call(this, t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
  }, {
    key: "clone",
    value: function clone(t) {
      var e = _get(_getPrototypeOf(_class25.prototype), "clone", this).call(this, t);

      return e.meshPerAttribute = this.meshPerAttribute, e;
    }
  }, {
    key: "toJSON",
    value: function toJSON(t) {
      var e = _get(_getPrototypeOf(_class25.prototype), "toJSON", this).call(this, t);

      return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
    }
  }]);

  return _class25;
})(Fs).prototype.isInstancedInterleavedBuffer = !0;

function Ol(t, e) {
  return t.distance - e.distance;
}

function Hl(t, e, n, i) {
  if (t.layers.test(e.layers) && t.raycast(e, n), !0 === i) {
    var _i180 = t.children;

    for (var _t279 = 0, _r131 = _i180.length; _t279 < _r131; _t279++) {
      Hl(_i180[_t279], e, n, !0);
    }
  }
}

var zl = /*#__PURE__*/function () {
  function zl() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, zl);

    return this.radius = t, this.phi = e, this.theta = n, this;
  }

  _createClass(zl, [{
    key: "set",
    value: function set(t, e, n) {
      return this.radius = t, this.phi = e, this.theta = n, this;
    }
  }, {
    key: "copy",
    value: function copy(t) {
      return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
  }, {
    key: "makeSafe",
    value: function makeSafe() {
      var t = 1e-6;
      return this.phi = Math.max(t, Math.min(Math.PI - t, this.phi)), this;
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(t) {
      return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
  }, {
    key: "setFromCartesianCoords",
    value: function setFromCartesianCoords(t, e, n) {
      return this.radius = Math.sqrt(t * t + e * e + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, n), this.phi = Math.acos(at(e / this.radius, -1, 1))), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return zl;
}();

/*#__PURE__*/
(function (_Ce11) {
  _inherits(_class26, _Ce11);

  var _super110 = _createSuper(_class26);

  function _class26(t) {
    var _this94;

    _classCallCheck(this, _class26);

    _this94 = _super110.call(this), _this94.material = t, _this94.render = function () {}, _this94.hasPositions = !1, _this94.hasNormals = !1, _this94.hasColors = !1, _this94.hasUvs = !1, _this94.positionArray = null, _this94.normalArray = null, _this94.colorArray = null, _this94.uvArray = null, _this94.count = 0;
    return _this94;
  }

  return _createClass(_class26);
})(Ce).prototype.isImmediateRenderObject = !0;
var Vl = new _t(),
    Wl = new ee(),
    ql = new ee();

var jl = /*#__PURE__*/function (_a56) {
  _inherits(jl, _a56);

  var _super111 = _createSuper(jl);

  function jl(t) {
    var _this95;

    _classCallCheck(this, jl);

    var e = Yl(t),
        n = new cn(),
        i = [],
        r = [],
        s = new qe(0, 0, 1),
        a = new qe(0, 1, 0);

    for (var _t280 = 0; _t280 < e.length; _t280++) {
      var _n237 = e[_t280];
      _n237.parent && _n237.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(s.r, s.g, s.b), r.push(a.r, a.g, a.b));
    }

    n.setAttribute("position", new $e(i, 3)), n.setAttribute("color", new $e(r, 3));
    _this95 = _super111.call(this, n, new ma({
      vertexColors: !0,
      depthTest: !1,
      depthWrite: !1,
      toneMapped: !1,
      transparent: !0
    })), _this95.type = "SkeletonHelper", _this95.isSkeletonHelper = !0, _this95.root = t, _this95.bones = e, _this95.matrix = t.matrixWorld, _this95.matrixAutoUpdate = !1;
    return _this95;
  }

  _createClass(jl, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(t) {
      var e = this.bones,
          n = this.geometry,
          i = n.getAttribute("position");
      ql.copy(this.root.matrixWorld).invert();

      for (var _t281 = 0, _n238 = 0; _t281 < e.length; _t281++) {
        var _r132 = e[_t281];
        _r132.parent && _r132.parent.isBone && (Wl.multiplyMatrices(ql, _r132.matrixWorld), Vl.setFromMatrixPosition(Wl), i.setXYZ(_n238, Vl.x, Vl.y, Vl.z), Wl.multiplyMatrices(ql, _r132.parent.matrixWorld), Vl.setFromMatrixPosition(Wl), i.setXYZ(_n238 + 1, Vl.x, Vl.y, Vl.z), _n238 += 2);
      }

      n.getAttribute("position").needsUpdate = !0, _get(_getPrototypeOf(jl.prototype), "updateMatrixWorld", this).call(this, t);
    }
  }]);

  return jl;
}(_a);

function Yl(t) {
  var e = [];
  t && t.isBone && e.push(t);

  for (var _n239 = 0; _n239 < t.children.length; _n239++) {
    e.push.apply(e, Yl(t.children[_n239]));
  }

  return e;
}

var Jl = new Float32Array(1),
    Xl = new Int32Array(Jl.buffer);

var Kl = /*#__PURE__*/function () {
  function Kl() {
    _classCallCheck(this, Kl);
  }

  _createClass(Kl, null, [{
    key: "toHalfFloat",
    value: function toHalfFloat(t) {
      Jl[0] = t;
      var e = Xl[0];
      var n = e >> 16 & 32768,
          i = e >> 12 & 2047;
      var r = e >> 23 & 255;
      return r < 103 ? n : r > 142 ? (n |= 31744, n |= (255 == r ? 0 : 1) && 8388607 & e, n) : r < 113 ? (i |= 2048, n |= (i >> 114 - r) + (i >> 113 - r & 1), n) : (n |= r - 112 << 10 | i >> 1, n += 1 & i, n);
    }
  }]);

  return Kl;
}();

Qa.create = function (t, e) {
  return console.log("THREE.Curve.create() has been deprecated"), t.prototype = Object.create(Qa.prototype), t.prototype.constructor = t, t.prototype.getPoint = e, t;
}, al.prototype.fromPoints = function (t) {
  return console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints()."), this.setFromPoints(t);
}, /*#__PURE__*/function (_a57) {
  _inherits(_class27, _a57);

  var _super112 = _createSuper(_class27);

  function _class27() {
    var _this96;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4473924;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8947848;

    _classCallCheck(this, _class27);

    n = new qe(n), i = new qe(i);
    var r = e / 2,
        s = t / e,
        a = t / 2,
        o = [],
        l = [];

    for (var _t282 = 0, _c19 = 0, _h10 = -a; _t282 <= e; _t282++, _h10 += s) {
      o.push(-a, 0, _h10, a, 0, _h10), o.push(_h10, 0, -a, _h10, 0, a);

      var _e247 = _t282 === r ? n : i;

      _e247.toArray(l, _c19), _c19 += 3, _e247.toArray(l, _c19), _c19 += 3, _e247.toArray(l, _c19), _c19 += 3, _e247.toArray(l, _c19), _c19 += 3;
    }

    var c = new cn();
    c.setAttribute("position", new $e(o, 3)), c.setAttribute("color", new $e(l, 3));
    _this96 = _super112.call(this, c, new ma({
      vertexColors: !0,
      toneMapped: !1
    })), _this96.type = "GridHelper";
    return _this96;
  }

  return _createClass(_class27);
}(_a).prototype.setColors = function () {
  console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
}, jl.prototype.update = function () {
  console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
}, Ko.prototype.extractUrlBase = function (t) {
  return console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."), _l.extractUrlBase(t);
}, Ko.Handlers = {
  add: function add() {
    console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
  },
  get: function get() {
    console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
  }
}, Mt.prototype.center = function (t) {
  return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(t);
}, Mt.prototype.empty = function () {
  return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, Mt.prototype.isIntersectionBox = function (t) {
  return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
}, Mt.prototype.isIntersectionSphere = function (t) {
  return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
}, Mt.prototype.size = function (t) {
  return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(t);
}, qt.prototype.empty = function () {
  return console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty()."), this.isEmpty();
}, Wn.prototype.setFromMatrix = function (t) {
  return console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix()."), this.setFromProjectionMatrix(t);
}, At.prototype.flattenToArrayOffset = function (t, e) {
  return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
}, At.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
}, At.prototype.multiplyVector3Array = function () {
  console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
}, At.prototype.applyToBufferAttribute = function (t) {
  return console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead."), t.applyMatrix3(this);
}, At.prototype.applyToVector3Array = function () {
  console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
}, At.prototype.getInverse = function (t) {
  return console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
}, ee.prototype.extractPosition = function (t) {
  return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(t);
}, ee.prototype.flattenToArrayOffset = function (t, e) {
  return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(t, e);
}, ee.prototype.getPosition = function () {
  return console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), new _t().setFromMatrixColumn(this, 3);
}, ee.prototype.setRotationFromQuaternion = function (t) {
  return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(t);
}, ee.prototype.multiplyToArray = function () {
  console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
}, ee.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ee.prototype.multiplyVector4 = function (t) {
  return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ee.prototype.multiplyVector3Array = function () {
  console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
}, ee.prototype.rotateAxis = function (t) {
  console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), t.transformDirection(this);
}, ee.prototype.crossVector = function (t) {
  return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ee.prototype.translate = function () {
  console.error("THREE.Matrix4: .translate() has been removed.");
}, ee.prototype.rotateX = function () {
  console.error("THREE.Matrix4: .rotateX() has been removed.");
}, ee.prototype.rotateY = function () {
  console.error("THREE.Matrix4: .rotateY() has been removed.");
}, ee.prototype.rotateZ = function () {
  console.error("THREE.Matrix4: .rotateZ() has been removed.");
}, ee.prototype.rotateByAxis = function () {
  console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
}, ee.prototype.applyToBufferAttribute = function (t) {
  return console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead."), t.applyMatrix4(this);
}, ee.prototype.applyToVector3Array = function () {
  console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
}, ee.prototype.makeFrustum = function (t, e, n, i, r, s) {
  return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(t, e, i, n, r, s);
}, ee.prototype.getInverse = function (t) {
  return console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."), this.copy(t).invert();
}, Hn.prototype.isIntersectionLine = function (t) {
  return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(t);
}, bt.prototype.multiplyVector3 = function (t) {
  return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), t.applyQuaternion(this);
}, bt.prototype.inverse = function () {
  return console.warn("THREE.Quaternion: .inverse() has been renamed to invert()."), this.invert();
}, te.prototype.isIntersectionBox = function (t) {
  return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(t);
}, te.prototype.isIntersectionPlane = function (t) {
  return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(t);
}, te.prototype.isIntersectionSphere = function (t) {
  return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(t);
}, Ne.prototype.area = function () {
  return console.warn("THREE.Triangle: .area() has been renamed to .getArea()."), this.getArea();
}, Ne.prototype.barycoordFromPoint = function (t, e) {
  return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), this.getBarycoord(t, e);
}, Ne.prototype.midpoint = function (t) {
  return console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."), this.getMidpoint(t);
}, Ne.prototypenormal = function (t) {
  return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), this.getNormal(t);
}, Ne.prototype.plane = function (t) {
  return console.warn("THREE.Triangle: .plane() has been renamed to .getPlane()."), this.getPlane(t);
}, Ne.barycoordFromPoint = function (t, e, n, i, r) {
  return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), Ne.getBarycoord(t, e, n, i, r);
}, Ne.normal = function (t, e, n, i) {
  return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), Ne.getNormal(t, e, n, i);
}, ol.prototype.extractAllPoints = function (t) {
  return console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."), this.extractPoints(t);
}, ol.prototype.extrude = function (t) {
  return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new So(this, t);
}, ol.prototype.makeGeometry = function (t) {
  return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new To(this, t);
}, pt.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, pt.prototype.distanceToManhattan = function (t) {
  return console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
}, pt.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, _t.prototype.setEulerFromRotationMatrix = function () {
  console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
}, _t.prototype.setEulerFromQuaternion = function () {
  console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
}, _t.prototype.getPositionFromMatrix = function (t) {
  return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(t);
}, _t.prototype.getScaleFromMatrix = function (t) {
  return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(t);
}, _t.prototype.getColumnFromMatrix = function (t, e) {
  return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(e, t);
}, _t.prototype.applyProjection = function (t) {
  return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(t);
}, _t.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, _t.prototype.distanceToManhattan = function (t) {
  return console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(t);
}, _t.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, xt.prototype.fromAttribute = function (t, e, n) {
  return console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(t, e, n);
}, xt.prototype.lengthManhattan = function () {
  return console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
}, Ce.prototype.getChildByName = function (t) {
  return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(t);
}, Ce.prototype.renderDepth = function () {
  console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
}, Ce.prototype.translate = function (t, e) {
  return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(e, t);
}, Ce.prototype.getWorldRotation = function () {
  console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
}, Ce.prototype.applyMatrix = function (t) {
  return console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
}, Object.defineProperties(Ce.prototype, {
  eulerOrder: {
    get: function get() {
      return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
    },
    set: function set(t) {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = t;
    }
  },
  useQuaternion: {
    get: function get() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    },
    set: function set() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    }
  }
}), Mn.prototype.setDrawMode = function () {
  console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
}, Object.defineProperties(Mn.prototype, {
  drawMode: {
    get: function get() {
      return console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode."), 0;
    },
    set: function set() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
    }
  }
}), sa.prototype.initBones = function () {
  console.error("THREE.SkinnedMesh: initBones() has been removed.");
}, Pn.prototype.setLens = function (t, e) {
  console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== e && (this.filmGauge = e), this.setFocalLength(t);
}, Object.defineProperties(ll.prototype, {
  onlyShadow: {
    set: function set() {
      console.warn("THREE.Light: .onlyShadow has been removed.");
    }
  },
  shadowCameraFov: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = t;
    }
  },
  shadowCameraLeft: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = t;
    }
  },
  shadowCameraRight: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = t;
    }
  },
  shadowCameraTop: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = t;
    }
  },
  shadowCameraBottom: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = t;
    }
  },
  shadowCameraNear: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = t;
    }
  },
  shadowCameraFar: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = t;
    }
  },
  shadowCameraVisible: {
    set: function set() {
      console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
    }
  },
  shadowBias: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = t;
    }
  },
  shadowDarkness: {
    set: function set() {
      console.warn("THREE.Light: .shadowDarkness has been removed.");
    }
  },
  shadowMapWidth: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = t;
    }
  },
  shadowMapHeight: {
    set: function set(t) {
      console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = t;
    }
  }
}), Object.defineProperties(Xe.prototype, {
  length: {
    get: function get() {
      return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
    }
  },
  dynamic: {
    get: function get() {
      return console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), 35048 === this.usage;
    },
    set: function set() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."), this.setUsage(35048);
    }
  }
}), Xe.prototype.setDynamic = function (t) {
  return console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? 35048 : 35044), this;
}, Xe.prototype.copyIndicesArray = function () {
  console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, Xe.prototype.setArray = function () {
  console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, cn.prototype.addIndex = function (t) {
  console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(t);
}, cn.prototype.addAttribute = function (t, e) {
  return console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute()."), e && e.isBufferAttribute || e && e.isInterleavedBufferAttribute ? "index" === t ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(e), this) : this.setAttribute(t, e) : (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.setAttribute(t, new Xe(arguments[1], arguments[2])));
}, cn.prototype.addDrawCall = function (t, e, n) {
  void 0 !== n && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(t, e);
}, cn.prototype.clearDrawCalls = function () {
  console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
}, cn.prototype.computeOffsets = function () {
  console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
}, cn.prototype.removeAttribute = function (t) {
  return console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute()."), this.deleteAttribute(t);
}, cn.prototype.applyMatrix = function (t) {
  return console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
}, Object.defineProperties(cn.prototype, {
  drawcalls: {
    get: function get() {
      return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
    }
  },
  offsets: {
    get: function get() {
      return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
    }
  }
}), Fs.prototype.setDynamic = function (t) {
  return console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead."), this.setUsage(!0 === t ? 35048 : 35044), this;
}, Fs.prototype.setArray = function () {
  console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
}, So.prototype.getArrays = function () {
  console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
}, So.prototype.addShapeList = function () {
  console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
}, So.prototype.addShape = function () {
  console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
}, Ps.prototype.dispose = function () {
  console.error("THREE.Scene: .dispose() has been removed.");
}, Object.defineProperties(ke.prototype, {
  wrapAround: {
    get: function get() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    },
    set: function set() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    }
  },
  overdraw: {
    get: function get() {
      console.warn("THREE.Material: .overdraw has been removed.");
    },
    set: function set() {
      console.warn("THREE.Material: .overdraw has been removed.");
    }
  },
  wrapRGB: {
    get: function get() {
      return console.warn("THREE.Material: .wrapRGB has been removed."), new qe();
    }
  },
  shading: {
    get: function get() {
      console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
    },
    set: function set(t) {
      console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === t;
    }
  },
  stencilMask: {
    get: function get() {
      return console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask;
    },
    set: function set(t) {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead."), this.stencilFuncMask = t;
    }
  },
  vertexTangents: {
    get: function get() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    },
    set: function set() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    }
  }
}), Object.defineProperties(Dn.prototype, {
  derivatives: {
    get: function get() {
      return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
    },
    set: function set(t) {
      console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = t;
    }
  }
}), Qs.prototype.clearTarget = function (t, e, n, i) {
  console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead."), this.setRenderTarget(t), this.clear(e, n, i);
}, Qs.prototype.animate = function (t) {
  console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."), this.setAnimationLoop(t);
}, Qs.prototype.getCurrentRenderTarget = function () {
  return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
}, Qs.prototype.getMaxAnisotropy = function () {
  return console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."), this.capabilities.getMaxAnisotropy();
}, Qs.prototype.getPrecision = function () {
  return console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."), this.capabilities.precision;
}, Qs.prototype.resetGLState = function () {
  return console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset()."), this.state.reset();
}, Qs.prototype.supportsFloatTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
}, Qs.prototype.supportsHalfFloatTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
}, Qs.prototype.supportsStandardDerivatives = function () {
  return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
}, Qs.prototype.supportsCompressedTextureS3TC = function () {
  return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
}, Qs.prototype.supportsCompressedTexturePVRTC = function () {
  return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
}, Qs.prototype.supportsBlendMinMax = function () {
  return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
}, Qs.prototype.supportsVertexTextures = function () {
  return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
}, Qs.prototype.supportsInstancedArrays = function () {
  return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
}, Qs.prototype.enableScissorTest = function (t) {
  console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(t);
}, Qs.prototype.initMaterial = function () {
  console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
}, Qs.prototype.addPrePlugin = function () {
  console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
}, Qs.prototype.addPostPlugin = function () {
  console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
}, Qs.prototype.updateShadowMap = function () {
  console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
}, Qs.prototype.setFaceCulling = function () {
  console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
}, Qs.prototype.allocTextureUnit = function () {
  console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
}, Qs.prototype.setTexture = function () {
  console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
}, Qs.prototype.setTexture2D = function () {
  console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
}, Qs.prototype.setTextureCube = function () {
  console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
}, Qs.prototype.getActiveMipMapLevel = function () {
  return console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel()."), this.getActiveMipmapLevel();
}, Object.defineProperties(Qs.prototype, {
  shadowMapEnabled: {
    get: function get() {
      return this.shadowMap.enabled;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = t;
    }
  },
  shadowMapType: {
    get: function get() {
      return this.shadowMap.type;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = t;
    }
  },
  shadowMapCullFace: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  context: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead."), this.getContext();
    }
  },
  vr: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr"), this.xr;
    }
  },
  gammaInput: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."), !1;
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
    }
  },
  gammaOutput: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), !1;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."), this.outputEncoding = !0 === t ? 3001 : 3e3;
    }
  },
  toneMappingWhitePoint: {
    get: function get() {
      return console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."), 1;
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
    }
  }
}), Object.defineProperties(_s.prototype, {
  cullFace: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  renderReverseSided: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    }
  },
  renderSingleSided: {
    get: function get() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    },
    set: function set() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    }
  }
}), Object.defineProperties(wt.prototype, {
  wrapS: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = t;
    }
  },
  wrapT: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = t;
    }
  },
  magFilter: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = t;
    }
  },
  minFilter: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = t;
    }
  },
  anisotropy: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = t;
    }
  },
  offset: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = t;
    }
  },
  repeat: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = t;
    }
  },
  format: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = t;
    }
  },
  type: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = t;
    }
  },
  generateMipmaps: {
    get: function get() {
      return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
    },
    set: function set(t) {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = t;
    }
  }
}), /*#__PURE__*/function (_Ce12) {
  _inherits(_class28, _Ce12);

  var _super113 = _createSuper(_class28);

  function _class28(t) {
    var _this97;

    _classCallCheck(this, _class28);

    _this97 = _super113.call(this), _this97.type = "Audio", _this97.listener = t, _this97.context = t.context, _this97.gain = _this97.context.createGain(), _this97.gain.connect(t.getInput()), _this97.autoplay = !1, _this97.buffer = null, _this97.detune = 0, _this97.loop = !1, _this97.loopStart = 0, _this97.loopEnd = 0, _this97.offset = 0, _this97.duration = void 0, _this97.playbackRate = 1, _this97.isPlaying = !1, _this97.hasPlaybackControl = !0, _this97.source = null, _this97.sourceType = "empty", _this97._startedAt = 0, _this97._progress = 0, _this97._connected = !1, _this97.filters = [];
    return _this97;
  }

  _createClass(_class28, [{
    key: "getOutput",
    value: function getOutput() {
      return this.gain;
    }
  }, {
    key: "setNodeSource",
    value: function setNodeSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t, this.connect(), this;
    }
  }, {
    key: "setMediaElementSource",
    value: function setMediaElementSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t), this.connect(), this;
    }
  }, {
    key: "setMediaStreamSource",
    value: function setMediaStreamSource(t) {
      return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t), this.connect(), this;
    }
  }, {
    key: "setBuffer",
    value: function setBuffer(t) {
      return this.buffer = t, this.sourceType = "buffer", this.autoplay && this.play(), this;
    }
  }, {
    key: "play",
    value: function play() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
      if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
      this._startedAt = this.context.currentTime + t;
      var e = this.context.createBufferSource();
      return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!1 !== this.hasPlaybackControl) return this._progress = 0, this.source.stop(), this.source.onended = null, this.isPlaying = !1, this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.filters.length > 0) {
        this.source.connect(this.filters[0]);

        for (var _t283 = 1, _e248 = this.filters.length; _t283 < _e248; _t283++) {
          this.filters[_t283 - 1].connect(this.filters[_t283]);
        }

        this.filters[this.filters.length - 1].connect(this.getOutput());
      } else this.source.connect(this.getOutput());

      return this._connected = !0, this;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.filters.length > 0) {
        this.source.disconnect(this.filters[0]);

        for (var _t284 = 1, _e249 = this.filters.length; _t284 < _e249; _t284++) {
          this.filters[_t284 - 1].disconnect(this.filters[_t284]);
        }

        this.filters[this.filters.length - 1].disconnect(this.getOutput());
      } else this.source.disconnect(this.getOutput());

      return this._connected = !1, this;
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.filters;
    }
  }, {
    key: "setFilters",
    value: function setFilters(t) {
      return t || (t = []), !0 === this._connected ? (this.disconnect(), this.filters = t.slice(), this.connect()) : this.filters = t.slice(), this;
    }
  }, {
    key: "setDetune",
    value: function setDetune(t) {
      if (this.detune = t, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
    }
  }, {
    key: "getDetune",
    value: function getDetune() {
      return this.detune;
    }
  }, {
    key: "getFilter",
    value: function getFilter() {
      return this.getFilters()[0];
    }
  }, {
    key: "setFilter",
    value: function setFilter(t) {
      return this.setFilters(t ? [t] : []);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(t) {
      if (!1 !== this.hasPlaybackControl) return this.playbackRate = t, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.playbackRate;
    }
  }, {
    key: "onEnded",
    value: function onEnded() {
      this.isPlaying = !1;
    }
  }, {
    key: "getLoop",
    value: function getLoop() {
      return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
    }
  }, {
    key: "setLoop",
    value: function setLoop(t) {
      if (!1 !== this.hasPlaybackControl) return this.loop = t, !0 === this.isPlaying && (this.source.loop = this.loop), this;
      console.warn("THREE.Audio: this Audio has no playback control.");
    }
  }, {
    key: "setLoopStart",
    value: function setLoopStart(t) {
      return this.loopStart = t, this;
    }
  }, {
    key: "setLoopEnd",
    value: function setLoopEnd(t) {
      return this.loopEnd = t, this;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.gain.gain.value;
    }
  }, {
    key: "setVolume",
    value: function setVolume(t) {
      return this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01), this;
    }
  }]);

  return _class28;
}(Ce).prototype.load = function (t) {
  console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
  var e = this;
  return new Sl().load(t, function (t) {
    e.setBuffer(t);
  }), this;
}, Fn.prototype.updateCubeMap = function (t, e) {
  return console.warn("THREE.CubeCamera: .updateCubeMap() is now .update()."), this.update(t, e);
}, Fn.prototype.clear = function (t, e, n, i) {
  return console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear()."), this.renderTarget.clear(t, e, n, i);
}, gt.crossOrigin = void 0, gt.loadTexture = function (t, e, n, i) {
  console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
  var r = new rl();
  r.setCrossOrigin(this.crossOrigin);
  var s = r.load(t, n, void 0, i);
  return e && (s.mapping = e), s;
}, gt.loadTextureCube = function (t, e, n, i) {
  console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
  var r = new nl();
  r.setCrossOrigin(this.crossOrigin);
  var s = r.load(t, n, void 0, i);
  return e && (s.mapping = e), s;
}, gt.loadCompressedTexture = function () {
  console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
}, gt.loadCompressedTextureCube = function () {
  console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
}, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
  detail: {
    revision: "131"
  }
})), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "131");
var Zl = new WeakMap();

function $l() {
  var t, e;

  function n(t, e, n, i, r, s) {
    var a = s.num_components(),
        o = n.num_points() * a,
        l = o * r.BYTES_PER_ELEMENT,
        c = function (t, e) {
      switch (e) {
        case Float32Array:
          return t.DT_FLOAT32;

        case Int8Array:
          return t.DT_INT8;

        case Int16Array:
          return t.DT_INT16;

        case Int32Array:
          return t.DT_INT32;

        case Uint8Array:
          return t.DT_UINT8;

        case Uint16Array:
          return t.DT_UINT16;

        case Uint32Array:
          return t.DT_UINT32;
      }
    }(t, r),
        h = t._malloc(l);

    e.GetAttributeDataArrayForAllPoints(n, s, c, l, h);
    var u = new r(t.HEAPF32.buffer, h, o).slice();
    return t._free(h), {
      name: i,
      array: u,
      itemSize: a
    };
  }

  onmessage = function onmessage(i) {
    var r = i.data;

    switch (r.type) {
      case "init":
        t = r.decoderConfig, e = new Promise(function (e) {
          t.onModuleLoaded = function (t) {
            e({
              draco: t
            });
          }, DracoDecoderModule(t);
        });
        break;

      case "decode":
        var _i181 = r.buffer,
            _s77 = r.taskConfig;
        e.then(function (t) {
          var e = t.draco,
              a = new e.Decoder(),
              o = new e.DecoderBuffer();
          o.Init(new Int8Array(_i181), _i181.byteLength);

          try {
            var _t285 = function (t, e, i, r) {
              var s = r.attributeIDs,
                  a = r.attributeTypes;
              var o, l;
              var c = e.GetEncodedGeometryType(i);
              if (c === t.TRIANGULAR_MESH) o = new t.Mesh(), l = e.DecodeBufferToMesh(i, o);else {
                if (c !== t.POINT_CLOUD) throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
                o = new t.PointCloud(), l = e.DecodeBufferToPointCloud(i, o);
              }
              if (!l.ok() || 0 === o.ptr) throw new Error("THREE.DRACOLoader: Decoding failed: " + l.error_msg());
              var h = {
                index: null,
                attributes: []
              };

              for (var _i183 in s) {
                var _l24 = self[a[_i183]];

                var _c20 = void 0,
                    _u12 = void 0;

                if (r.useUniqueIDs) _u12 = s[_i183], _c20 = e.GetAttributeByUniqueId(o, _u12);else {
                  if (_u12 = e.GetAttributeId(o, t[s[_i183]]), -1 === _u12) continue;
                  _c20 = e.GetAttribute(o, _u12);
                }
                h.attributes.push(n(t, e, o, _i183, _l24, _c20));
              }

              c === t.TRIANGULAR_MESH && (h.index = function (t, e, n) {
                var i = 3 * n.num_faces(),
                    r = 4 * i,
                    s = t._malloc(r);

                e.GetTrianglesUInt32Array(n, r, s);
                var a = new Uint32Array(t.HEAPF32.buffer, s, i).slice();
                return t._free(s), {
                  array: a,
                  itemSize: 1
                };
              }(t, e, o));
              return t.destroy(o), h;
            }(e, a, o, _s77),
                _i182 = _t285.attributes.map(function (t) {
              return t.array.buffer;
            });

            _t285.index && _i182.push(_t285.index.array.buffer), self.postMessage({
              type: "decode",
              id: r.id,
              geometry: _t285
            }, _i182);
          } catch (t) {
            console.error(t), self.postMessage({
              type: "error",
              id: r.id,
              error: t.message
            });
          } finally {
            e.destroy(o), e.destroy(a);
          }
        });
    }
  };
}

var tc = /*#__PURE__*/function (_Ko9) {
  _inherits(tc, _Ko9);

  var _super114 = _createSuper(tc);

  function tc(t) {
    var _this98;

    _classCallCheck(this, tc);

    _this98 = _super114.call(this, t), _this98.dracoLoader = null, _this98.ktx2Loader = null, _this98.meshoptDecoder = null, _this98.pluginCallbacks = [], _this98.register(function (t) {
      return new sc(t);
    }), _this98.register(function (t) {
      return new hc(t);
    }), _this98.register(function (t) {
      return new uc(t);
    }), _this98.register(function (t) {
      return new ac(t);
    }), _this98.register(function (t) {
      return new oc(t);
    }), _this98.register(function (t) {
      return new lc(t);
    }), _this98.register(function (t) {
      return new cc(t);
    }), _this98.register(function (t) {
      return new ic(t);
    }), _this98.register(function (t) {
      return new dc(t);
    });
    return _this98;
  }

  _createClass(tc, [{
    key: "load",
    value: function load(t, e, n, i) {
      var r = this;
      var s;
      s = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : _l.extractUrlBase(t), this.manager.itemStart(t);

      var a = function a(e) {
        i ? i(e) : console.error(e), r.manager.itemError(t), r.manager.itemEnd(t);
      },
          o = new $o(this.manager);

      o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t, function (n) {
        try {
          r.parse(n, s, function (n) {
            e(n), r.manager.itemEnd(t);
          }, a);
        } catch (t) {
          a(t);
        }
      }, n, a);
    }
  }, {
    key: "setDRACOLoader",
    value: function setDRACOLoader(t) {
      return this.dracoLoader = t, this;
    }
  }, {
    key: "setDDSLoader",
    value: function setDDSLoader() {
      throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
  }, {
    key: "setKTX2Loader",
    value: function setKTX2Loader(t) {
      return this.ktx2Loader = t, this;
    }
  }, {
    key: "setMeshoptDecoder",
    value: function setMeshoptDecoder(t) {
      return this.meshoptDecoder = t, this;
    }
  }, {
    key: "register",
    value: function register(t) {
      return -1 === this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.push(t), this;
    }
  }, {
    key: "unregister",
    value: function unregister(t) {
      return -1 !== this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t), 1), this;
    }
  }, {
    key: "parse",
    value: function parse(t, e, n, i) {
      var r;
      var s = {},
          a = {};
      if ("string" == typeof t) r = t;else {
        if (_l.decodeText(new Uint8Array(t, 0, 4)) === pc) {
          try {
            s[nc.KHR_BINARY_GLTF] = new gc(t);
          } catch (t) {
            return void (i && i(t));
          }

          r = s[nc.KHR_BINARY_GLTF].content;
        } else r = _l.decodeText(new Uint8Array(t));
      }
      var o = JSON.parse(r);
      if (void 0 === o.asset || o.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
      var l = new Yc(o, {
        path: e || this.resourcePath || "",
        crossOrigin: this.crossOrigin,
        requestHeader: this.requestHeader,
        manager: this.manager,
        ktx2Loader: this.ktx2Loader,
        meshoptDecoder: this.meshoptDecoder
      });
      l.fileLoader.setRequestHeader(this.requestHeader);

      for (var _t286 = 0; _t286 < this.pluginCallbacks.length; _t286++) {
        var _e250 = this.pluginCallbacks[_t286](l);

        a[_e250.name] = _e250, s[_e250.name] = !0;
      }

      if (o.extensionsUsed) for (var _t287 = 0; _t287 < o.extensionsUsed.length; ++_t287) {
        var _e251 = o.extensionsUsed[_t287],
            _n240 = o.extensionsRequired || [];

        switch (_e251) {
          case nc.KHR_MATERIALS_UNLIT:
            s[_e251] = new rc();
            break;

          case nc.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
            s[_e251] = new xc();
            break;

          case nc.KHR_DRACO_MESH_COMPRESSION:
            s[_e251] = new fc(o, this.dracoLoader);
            break;

          case nc.KHR_TEXTURE_TRANSFORM:
            s[_e251] = new vc();
            break;

          case nc.KHR_MESH_QUANTIZATION:
            s[_e251] = new wc();
            break;

          default:
            _n240.indexOf(_e251) >= 0 && void 0 === a[_e251] && console.warn('THREE.GLTFLoader: Unknown extension "' + _e251 + '".');
        }
      }
      l.setExtensions(s), l.setPlugins(a), l.parse(n, i);
    }
  }]);

  return tc;
}(Ko);

function ec() {
  var t = {};
  return {
    get: function get(e) {
      return t[e];
    },
    add: function add(e, n) {
      t[e] = n;
    },
    remove: function remove(e) {
      delete t[e];
    },
    removeAll: function removeAll() {
      t = {};
    }
  };
}

var nc = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
};

var ic = /*#__PURE__*/function () {
  function ic(t) {
    _classCallCheck(this, ic);

    this.parser = t, this.name = nc.KHR_LIGHTS_PUNCTUAL, this.cache = {
      refs: {},
      uses: {}
    };
  }

  _createClass(ic, [{
    key: "_markDefs",
    value: function _markDefs() {
      var t = this.parser,
          e = this.parser.json.nodes || [];

      for (var _n241 = 0, _i184 = e.length; _n241 < _i184; _n241++) {
        var _i185 = e[_n241];
        _i185.extensions && _i185.extensions[this.name] && void 0 !== _i185.extensions[this.name].light && t._addNodeRef(this.cache, _i185.extensions[this.name].light);
      }
    }
  }, {
    key: "_loadLight",
    value: function _loadLight(t) {
      var e = this.parser,
          n = "light:" + t;
      var i = e.cache.get(n);
      if (i) return i;
      var r = e.json,
          s = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t];
      var a;
      var o = new qe(16777215);
      void 0 !== s.color && o.fromArray(s.color);
      var l = void 0 !== s.range ? s.range : 0;

      switch (s.type) {
        case "directional":
          a = new wl(o), a.target.position.set(0, 0, -1), a.add(a.target);
          break;

        case "point":
          a = new yl(o), a.distance = l;
          break;

        case "spot":
          a = new Al(o), a.distance = l, s.spot = s.spot || {}, s.spot.innerConeAngle = void 0 !== s.spot.innerConeAngle ? s.spot.innerConeAngle : 0, s.spot.outerConeAngle = void 0 !== s.spot.outerConeAngle ? s.spot.outerConeAngle : Math.PI / 4, a.angle = s.spot.outerConeAngle, a.penumbra = 1 - s.spot.innerConeAngle / s.spot.outerConeAngle, a.target.position.set(0, 0, -1), a.add(a.target);
          break;

        default:
          throw new Error("THREE.GLTFLoader: Unexpected light type: " + s.type);
      }

      return a.position.set(0, 0, 0), a.decay = 2, void 0 !== s.intensity && (a.intensity = s.intensity), a.name = e.createUniqueName(s.name || "light_" + t), i = Promise.resolve(a), e.cache.add(n, i), i;
    }
  }, {
    key: "createNodeAttachment",
    value: function createNodeAttachment(t) {
      var e = this,
          n = this.parser,
          i = n.json.nodes[t],
          r = (i.extensions && i.extensions[this.name] || {}).light;
      return void 0 === r ? null : this._loadLight(r).then(function (t) {
        return n._getNodeRef(e.cache, r, t);
      });
    }
  }]);

  return ic;
}();

var rc = /*#__PURE__*/function () {
  function rc() {
    _classCallCheck(this, rc);

    this.name = nc.KHR_MATERIALS_UNLIT;
  }

  _createClass(rc, [{
    key: "getMaterialType",
    value: function getMaterialType() {
      return je;
    }
  }, {
    key: "extendParams",
    value: function extendParams(t, e, n) {
      var i = [];
      t.color = new qe(1, 1, 1), t.opacity = 1;
      var r = e.pbrMetallicRoughness;

      if (r) {
        if (Array.isArray(r.baseColorFactor)) {
          var _e252 = r.baseColorFactor;
          t.color.fromArray(_e252), t.opacity = _e252[3];
        }

        void 0 !== r.baseColorTexture && i.push(n.assignTexture(t, "map", r.baseColorTexture));
      }

      return Promise.all(i);
    }
  }]);

  return rc;
}();

var sc = /*#__PURE__*/function () {
  function sc(t) {
    _classCallCheck(this, sc);

    this.parser = t, this.name = nc.KHR_MATERIALS_CLEARCOAT;
  }

  _createClass(sc, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Do : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];

      if (void 0 !== s.clearcoatFactor && (e.clearcoat = s.clearcoatFactor), void 0 !== s.clearcoatTexture && r.push(n.assignTexture(e, "clearcoatMap", s.clearcoatTexture)), void 0 !== s.clearcoatRoughnessFactor && (e.clearcoatRoughness = s.clearcoatRoughnessFactor), void 0 !== s.clearcoatRoughnessTexture && r.push(n.assignTexture(e, "clearcoatRoughnessMap", s.clearcoatRoughnessTexture)), void 0 !== s.clearcoatNormalTexture && (r.push(n.assignTexture(e, "clearcoatNormalMap", s.clearcoatNormalTexture)), void 0 !== s.clearcoatNormalTexture.scale)) {
        var _t288 = s.clearcoatNormalTexture.scale;
        e.clearcoatNormalScale = new pt(_t288, -_t288);
      }

      return Promise.all(r);
    }
  }]);

  return sc;
}();

var ac = /*#__PURE__*/function () {
  function ac(t) {
    _classCallCheck(this, ac);

    this.parser = t, this.name = nc.KHR_MATERIALS_TRANSMISSION;
  }

  _createClass(ac, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Do : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      return void 0 !== s.transmissionFactor && (e.transmission = s.transmissionFactor), void 0 !== s.transmissionTexture && r.push(n.assignTexture(e, "transmissionMap", s.transmissionTexture)), Promise.all(r);
    }
  }]);

  return ac;
}();

var oc = /*#__PURE__*/function () {
  function oc(t) {
    _classCallCheck(this, oc);

    this.parser = t, this.name = nc.KHR_MATERIALS_VOLUME;
  }

  _createClass(oc, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Do : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      e.thickness = void 0 !== s.thicknessFactor ? s.thicknessFactor : 0, void 0 !== s.thicknessTexture && r.push(n.assignTexture(e, "thicknessMap", s.thicknessTexture)), e.attenuationDistance = s.attenuationDistance || 0;
      var a = s.attenuationColor || [1, 1, 1];
      return e.attenuationTint = new qe(a[0], a[1], a[2]), Promise.all(r);
    }
  }]);

  return oc;
}();

var lc = /*#__PURE__*/function () {
  function lc(t) {
    _classCallCheck(this, lc);

    this.parser = t, this.name = nc.KHR_MATERIALS_IOR;
  }

  _createClass(lc, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Do : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser.json.materials[t];
      if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
      var i = n.extensions[this.name];
      return e.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
    }
  }]);

  return lc;
}();

var cc = /*#__PURE__*/function () {
  function cc(t) {
    _classCallCheck(this, cc);

    this.parser = t, this.name = nc.KHR_MATERIALS_SPECULAR;
  }

  _createClass(cc, [{
    key: "getMaterialType",
    value: function getMaterialType(t) {
      var e = this.parser.json.materials[t];
      return e.extensions && e.extensions[this.name] ? Do : null;
    }
  }, {
    key: "extendMaterialParams",
    value: function extendMaterialParams(t, e) {
      var n = this.parser,
          i = n.json.materials[t];
      if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
      var r = [],
          s = i.extensions[this.name];
      e.specularIntensity = void 0 !== s.specularFactor ? s.specularFactor : 1, void 0 !== s.specularTexture && r.push(n.assignTexture(e, "specularIntensityMap", s.specularTexture));
      var a = s.specularColorFactor || [1, 1, 1];
      return e.specularTint = new qe(a[0], a[1], a[2]), void 0 !== s.specularColorTexture && r.push(n.assignTexture(e, "specularTintMap", s.specularColorTexture).then(function (t) {
        t.encoding = 3001;
      })), Promise.all(r);
    }
  }]);

  return cc;
}();

var hc = /*#__PURE__*/function () {
  function hc(t) {
    _classCallCheck(this, hc);

    this.parser = t, this.name = nc.KHR_TEXTURE_BASISU;
  }

  _createClass(hc, [{
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.parser,
          n = e.json,
          i = n.textures[t];
      if (!i.extensions || !i.extensions[this.name]) return null;
      var r = i.extensions[this.name],
          s = n.images[r.source],
          a = e.options.ktx2Loader;

      if (!a) {
        if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
        return null;
      }

      return e.loadTextureImage(t, s, a);
    }
  }]);

  return hc;
}();

var uc = /*#__PURE__*/function () {
  function uc(t) {
    _classCallCheck(this, uc);

    this.parser = t, this.name = nc.EXT_TEXTURE_WEBP, this.isSupported = null;
  }

  _createClass(uc, [{
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.name,
          n = this.parser,
          i = n.json,
          r = i.textures[t];
      if (!r.extensions || !r.extensions[e]) return null;
      var s = r.extensions[e],
          a = i.images[s.source];
      var o = n.textureLoader;

      if (a.uri) {
        var _t289 = n.options.manager.getHandler(a.uri);

        null !== _t289 && (o = _t289);
      }

      return this.detectSupport().then(function (r) {
        if (r) return n.loadTextureImage(t, a, o);
        if (i.extensionsRequired && i.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
        return n.loadTexture(t);
      });
    }
  }, {
    key: "detectSupport",
    value: function detectSupport() {
      return this.isSupported || (this.isSupported = new Promise(function (t) {
        var e = new Image();
        e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function () {
          t(1 === e.height);
        };
      })), this.isSupported;
    }
  }]);

  return uc;
}();

var dc = /*#__PURE__*/function () {
  function dc(t) {
    _classCallCheck(this, dc);

    this.name = nc.EXT_MESHOPT_COMPRESSION, this.parser = t;
  }

  _createClass(dc, [{
    key: "loadBufferView",
    value: function loadBufferView(t) {
      var e = this.parser.json,
          n = e.bufferViews[t];

      if (n.extensions && n.extensions[this.name]) {
        var _t290 = n.extensions[this.name],
            _i186 = this.parser.getDependency("buffer", _t290.buffer),
            _r133 = this.parser.options.meshoptDecoder;

        if (!_r133 || !_r133.supported) {
          if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
          return null;
        }

        return Promise.all([_i186, _r133.ready]).then(function (e) {
          var n = _t290.byteOffset || 0,
              i = _t290.byteLength || 0,
              s = _t290.count,
              a = _t290.byteStride,
              o = new ArrayBuffer(s * a),
              l = new Uint8Array(e[0], n, i);
          return _r133.decodeGltfBuffer(new Uint8Array(o), s, a, l, _t290.mode, _t290.filter), o;
        });
      }

      return null;
    }
  }]);

  return dc;
}();

var pc = "glTF",
    Ac = 1313821514,
    mc = 5130562;

var gc = /*#__PURE__*/_createClass(function gc(t) {
  _classCallCheck(this, gc);

  this.name = nc.KHR_BINARY_GLTF, this.content = null, this.body = null;
  var e = new DataView(t, 0, 12);
  if (this.header = {
    magic: _l.decodeText(new Uint8Array(t.slice(0, 4))),
    version: e.getUint32(4, !0),
    length: e.getUint32(8, !0)
  }, this.header.magic !== pc) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
  if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
  var n = this.header.length - 12,
      i = new DataView(t, 12);
  var r = 0;

  for (; r < n;) {
    var _e253 = i.getUint32(r, !0);

    r += 4;

    var _n242 = i.getUint32(r, !0);

    if (r += 4, _n242 === Ac) {
      var _n243 = new Uint8Array(t, 12 + r, _e253);

      this.content = _l.decodeText(_n243);
    } else if (_n242 === mc) {
      var _n244 = 12 + r;

      this.body = t.slice(_n244, _n244 + _e253);
    }

    r += _e253;
  }

  if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
});

var fc = /*#__PURE__*/function () {
  function fc(t, e) {
    _classCallCheck(this, fc);

    if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = nc.KHR_DRACO_MESH_COMPRESSION, this.json = t, this.dracoLoader = e, this.dracoLoader.preload();
  }

  _createClass(fc, [{
    key: "decodePrimitive",
    value: function decodePrimitive(t, e) {
      var n = this.json,
          i = this.dracoLoader,
          r = t.extensions[this.name].bufferView,
          s = t.extensions[this.name].attributes,
          a = {},
          o = {},
          l = {};

      for (var _t291 in s) {
        var _e254 = Qc[_t291] || _t291.toLowerCase();

        a[_e254] = s[_t291];
      }

      for (var _e255 in t.attributes) {
        var _i187 = Qc[_e255] || _e255.toLowerCase();

        if (void 0 !== s[_e255]) {
          var _r134 = n.accessors[t.attributes[_e255]],
              _s78 = Tc[_r134.componentType];
          l[_i187] = _s78, o[_i187] = !0 === _r134.normalized;
        }
      }

      return e.getDependency("bufferView", r).then(function (t) {
        return new Promise(function (e) {
          i.decodeDracoFile(t, function (t) {
            for (var _e256 in t.attributes) {
              var _n245 = t.attributes[_e256],
                  _i188 = o[_e256];
              void 0 !== _i188 && (_n245.normalized = _i188);
            }

            e(t);
          }, a, l);
        });
      });
    }
  }]);

  return fc;
}();

var vc = /*#__PURE__*/function () {
  function vc() {
    _classCallCheck(this, vc);

    this.name = nc.KHR_TEXTURE_TRANSFORM;
  }

  _createClass(vc, [{
    key: "extendTexture",
    value: function extendTexture(t, e) {
      return void 0 !== e.texCoord && console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.'), void 0 === e.offset && void 0 === e.rotation && void 0 === e.scale || (t = t.clone(), void 0 !== e.offset && t.offset.fromArray(e.offset), void 0 !== e.rotation && (t.rotation = e.rotation), void 0 !== e.scale && t.repeat.fromArray(e.scale), t.needsUpdate = !0), t;
    }
  }]);

  return vc;
}();

var yc = /*#__PURE__*/function (_Ro2) {
  _inherits(yc, _Ro2);

  var _super115 = _createSuper(yc);

  function yc(t) {
    var _this99;

    _classCallCheck(this, yc);

    _this99 = _super115.call(this), _this99.isGLTFSpecularGlossinessMaterial = !0;
    var e = ["#ifdef USE_SPECULARMAP", "\tuniform sampler2D specularMap;", "#endif"].join("\n"),
        n = ["#ifdef USE_GLOSSINESSMAP", "\tuniform sampler2D glossinessMap;", "#endif"].join("\n"),
        i = ["vec3 specularFactor = specular;", "#ifdef USE_SPECULARMAP", "\tvec4 texelSpecular = texture2D( specularMap, vUv );", "\ttexelSpecular = sRGBToLinear( texelSpecular );", "\t// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture", "\tspecularFactor *= texelSpecular.rgb;", "#endif"].join("\n"),
        r = ["float glossinessFactor = glossiness;", "#ifdef USE_GLOSSINESSMAP", "\tvec4 texelGlossiness = texture2D( glossinessMap, vUv );", "\t// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture", "\tglossinessFactor *= texelGlossiness.a;", "#endif"].join("\n"),
        s = ["PhysicalMaterial material;", "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );", "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );", "material.specularRoughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.", "material.specularRoughness += geometryRoughness;", "material.specularRoughness = min( material.specularRoughness, 1.0 );", "material.specularColor = specularFactor;"].join("\n"),
        a = {
      specular: {
        value: new qe().setHex(16777215)
      },
      glossiness: {
        value: 1
      },
      specularMap: {
        value: null
      },
      glossinessMap: {
        value: null
      }
    };
    _this99._extraUniforms = a, _this99.onBeforeCompile = function (t) {
      for (var _e257 in a) {
        t.uniforms[_e257] = a[_e257];
      }

      t.fragmentShader = t.fragmentShader.replace("uniform float roughness;", "uniform vec3 specular;").replace("uniform float metalness;", "uniform float glossiness;").replace("#include <roughnessmap_pars_fragment>", e).replace("#include <metalnessmap_pars_fragment>", n).replace("#include <roughnessmap_fragment>", i).replace("#include <metalnessmap_fragment>", r).replace("#include <lights_physical_fragment>", s);
    }, Object.defineProperties(_assertThisInitialized(_this99), {
      specular: {
        get: function get() {
          return a.specular.value;
        },
        set: function set(t) {
          a.specular.value = t;
        }
      },
      specularMap: {
        get: function get() {
          return a.specularMap.value;
        },
        set: function set(t) {
          a.specularMap.value = t, t ? this.defines.USE_SPECULARMAP = "" : delete this.defines.USE_SPECULARMAP;
        }
      },
      glossiness: {
        get: function get() {
          return a.glossiness.value;
        },
        set: function set(t) {
          a.glossiness.value = t;
        }
      },
      glossinessMap: {
        get: function get() {
          return a.glossinessMap.value;
        },
        set: function set(t) {
          a.glossinessMap.value = t, t ? (this.defines.USE_GLOSSINESSMAP = "", this.defines.USE_UV = "") : (delete this.defines.USE_GLOSSINESSMAP, delete this.defines.USE_UV);
        }
      }
    }), delete _this99.metalness, delete _this99.roughness, delete _this99.metalnessMap, delete _this99.roughnessMap, _this99.setValues(t);
    return _this99;
  }

  _createClass(yc, [{
    key: "copy",
    value: function copy(t) {
      return _get(_getPrototypeOf(yc.prototype), "copy", this).call(this, t), this.specularMap = t.specularMap, this.specular.copy(t.specular), this.glossinessMap = t.glossinessMap, this.glossiness = t.glossiness, delete this.metalness, delete this.roughness, delete this.metalnessMap, delete this.roughnessMap, this;
    }
  }]);

  return yc;
}(Ro);

var xc = /*#__PURE__*/function () {
  function xc() {
    _classCallCheck(this, xc);

    this.name = nc.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS, this.specularGlossinessParams = ["color", "map", "lightMap", "lightMapIntensity", "aoMap", "aoMapIntensity", "emissive", "emissiveIntensity", "emissiveMap", "bumpMap", "bumpScale", "normalMap", "normalMapType", "displacementMap", "displacementScale", "displacementBias", "specularMap", "specular", "glossinessMap", "glossiness", "alphaMap", "envMap", "envMapIntensity", "refractionRatio"];
  }

  _createClass(xc, [{
    key: "getMaterialType",
    value: function getMaterialType() {
      return yc;
    }
  }, {
    key: "extendParams",
    value: function extendParams(t, e, n) {
      var i = e.extensions[this.name];
      t.color = new qe(1, 1, 1), t.opacity = 1;
      var r = [];

      if (Array.isArray(i.diffuseFactor)) {
        var _e258 = i.diffuseFactor;
        t.color.fromArray(_e258), t.opacity = _e258[3];
      }

      if (void 0 !== i.diffuseTexture && r.push(n.assignTexture(t, "map", i.diffuseTexture)), t.emissive = new qe(0, 0, 0), t.glossiness = void 0 !== i.glossinessFactor ? i.glossinessFactor : 1, t.specular = new qe(1, 1, 1), Array.isArray(i.specularFactor) && t.specular.fromArray(i.specularFactor), void 0 !== i.specularGlossinessTexture) {
        var _e259 = i.specularGlossinessTexture;
        r.push(n.assignTexture(t, "glossinessMap", _e259)), r.push(n.assignTexture(t, "specularMap", _e259));
      }

      return Promise.all(r);
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(t) {
      var e = new yc(t);
      return e.fog = !0, e.color = t.color, e.map = void 0 === t.map ? null : t.map, e.lightMap = null, e.lightMapIntensity = 1, e.aoMap = void 0 === t.aoMap ? null : t.aoMap, e.aoMapIntensity = 1, e.emissive = t.emissive, e.emissiveIntensity = 1, e.emissiveMap = void 0 === t.emissiveMap ? null : t.emissiveMap, e.bumpMap = void 0 === t.bumpMap ? null : t.bumpMap, e.bumpScale = 1, e.normalMap = void 0 === t.normalMap ? null : t.normalMap, e.normalMapType = 0, t.normalScale && (e.normalScale = t.normalScale), e.displacementMap = null, e.displacementScale = 1, e.displacementBias = 0, e.specularMap = void 0 === t.specularMap ? null : t.specularMap, e.specular = t.specular, e.glossinessMap = void 0 === t.glossinessMap ? null : t.glossinessMap, e.glossiness = t.glossiness, e.alphaMap = null, e.envMap = void 0 === t.envMap ? null : t.envMap, e.envMapIntensity = 1, e.refractionRatio = .98, e;
    }
  }]);

  return xc;
}();

var wc = /*#__PURE__*/_createClass(function wc() {
  _classCallCheck(this, wc);

  this.name = nc.KHR_MESH_QUANTIZATION;
});

var Ec = /*#__PURE__*/function (_Po5) {
  _inherits(Ec, _Po5);

  var _super116 = _createSuper(Ec);

  function Ec(t, e, n, i) {
    _classCallCheck(this, Ec);

    return _super116.call(this, t, e, n, i);
  }

  _createClass(Ec, [{
    key: "copySampleValue_",
    value: function copySampleValue_(t) {
      var e = this.resultBuffer,
          n = this.sampleValues,
          i = this.valueSize,
          r = t * i * 3 + i;

      for (var _t292 = 0; _t292 !== i; _t292++) {
        e[_t292] = n[r + _t292];
      }

      return e;
    }
  }]);

  return Ec;
}(Po);

Ec.prototype.beforeStart_ = Ec.prototype.copySampleValue_, Ec.prototype.afterEnd_ = Ec.prototype.copySampleValue_, Ec.prototype.interpolate_ = function (t, e, n, i) {
  var r = this.resultBuffer,
      s = this.sampleValues,
      a = this.valueSize,
      o = 2 * a,
      l = 3 * a,
      c = i - e,
      h = (n - e) / c,
      u = h * h,
      d = u * h,
      p = t * l,
      A = p - l,
      m = -2 * d + 3 * u,
      g = d - u,
      f = 1 - m,
      v = g - u + h;

  for (var _t293 = 0; _t293 !== a; _t293++) {
    var _e260 = s[A + _t293 + a],
        _n246 = s[A + _t293 + o] * c,
        _i189 = s[p + _t293 + a],
        _l25 = s[p + _t293] * c;

    r[_t293] = f * _e260 + v * _n246 + m * _i189 + g * _l25;
  }

  return r;
};
var bc = 0,
    _c = 1,
    Ic = 2,
    Cc = 3,
    Mc = 4,
    Sc = 5,
    Bc = 6,
    Tc = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
},
    Lc = {
  9728: 1003,
  9729: 1006,
  9984: 1004,
  9985: 1007,
  9986: 1005,
  9987: 1008
},
    Rc = {
  33071: 1001,
  33648: 1002,
  10497: 1e3
},
    Dc = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
},
    Qc = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
},
    Pc = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
},
    Fc = {
  CUBICSPLINE: void 0,
  LINEAR: 2301,
  STEP: 2300
},
    Nc = "OPAQUE",
    Uc = "MASK",
    kc = "BLEND";

function Gc(t, e) {
  return "string" != typeof t || "" === t ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t) || /^data:.*,.*$/i.test(t) || /^blob:.*$/i.test(t) ? t : e + t);
}

function Oc(t) {
  return void 0 === t.DefaultMaterial && (t.DefaultMaterial = new Ro({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: 0
  })), t.DefaultMaterial;
}

function Hc(t, e, n) {
  for (var _i190 in n.extensions) {
    void 0 === t[_i190] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[_i190] = n.extensions[_i190]);
  }
}

function zc(t, e) {
  void 0 !== e.extras && ("object" == _typeof(e.extras) ? Object.assign(t.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}

function Vc(t, e) {
  if (t.updateMorphTargets(), void 0 !== e.weights) for (var _n247 = 0, _i191 = e.weights.length; _n247 < _i191; _n247++) {
    t.morphTargetInfluences[_n247] = e.weights[_n247];
  }

  if (e.extras && Array.isArray(e.extras.targetNames)) {
    var _n248 = e.extras.targetNames;

    if (t.morphTargetInfluences.length === _n248.length) {
      t.morphTargetDictionary = {};

      for (var _e261 = 0, _i192 = _n248.length; _e261 < _i192; _e261++) {
        t.morphTargetDictionary[_n248[_e261]] = _e261;
      }
    } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}

function Wc(t) {
  var e = t.extensions && t.extensions[nc.KHR_DRACO_MESH_COMPRESSION];
  var n;
  return n = e ? "draco:" + e.bufferView + ":" + e.indices + ":" + qc(e.attributes) : t.indices + ":" + qc(t.attributes) + ":" + t.mode, n;
}

function qc(t) {
  var e = "";
  var n = Object.keys(t).sort();

  for (var _i193 = 0, _r135 = n.length; _i193 < _r135; _i193++) {
    e += n[_i193] + ":" + t[n[_i193]] + ";";
  }

  return e;
}

function jc(t) {
  switch (t) {
    case Int8Array:
      return 1 / 127;

    case Uint8Array:
      return 1 / 255;

    case Int16Array:
      return 1 / 32767;

    case Uint16Array:
      return 1 / 65535;

    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}

var Yc = /*#__PURE__*/function () {
  function Yc() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Yc);

    this.json = t, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new ec(), this.associations = new Map(), this.primitiveCache = {}, this.meshCache = {
      refs: {},
      uses: {}
    }, this.cameraCache = {
      refs: {},
      uses: {}
    }, this.lightCache = {
      refs: {},
      uses: {}
    }, this.textureCache = {}, this.nodeNamesUsed = {}, "undefined" != typeof createImageBitmap && !1 === /Firefox/.test(navigator.userAgent) ? this.textureLoader = new Il(this.options.manager) : this.textureLoader = new rl(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new $o(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
  }

  _createClass(Yc, [{
    key: "setExtensions",
    value: function setExtensions(t) {
      this.extensions = t;
    }
  }, {
    key: "setPlugins",
    value: function setPlugins(t) {
      this.plugins = t;
    }
  }, {
    key: "parse",
    value: function parse(t, e) {
      var n = this,
          i = this.json,
          r = this.extensions;
      this.cache.removeAll(), this._invokeAll(function (t) {
        return t._markDefs && t._markDefs();
      }), Promise.all(this._invokeAll(function (t) {
        return t.beforeRoot && t.beforeRoot();
      })).then(function () {
        return Promise.all([n.getDependencies("scene"), n.getDependencies("animation"), n.getDependencies("camera")]);
      }).then(function (e) {
        var s = {
          scene: e[0][i.scene || 0],
          scenes: e[0],
          animations: e[1],
          cameras: e[2],
          asset: i.asset,
          parser: n,
          userData: {}
        };
        Hc(r, s, i), zc(s, i), Promise.all(n._invokeAll(function (t) {
          return t.afterRoot && t.afterRoot(s);
        })).then(function () {
          t(s);
        });
      }).catch(e);
    }
  }, {
    key: "_markDefs",
    value: function _markDefs() {
      var t = this.json.nodes || [],
          e = this.json.skins || [],
          n = this.json.meshes || [];

      for (var _n249 = 0, _i194 = e.length; _n249 < _i194; _n249++) {
        var _i195 = e[_n249].joints;

        for (var _e262 = 0, _n250 = _i195.length; _e262 < _n250; _e262++) {
          t[_i195[_e262]].isBone = !0;
        }
      }

      for (var _e263 = 0, _i196 = t.length; _e263 < _i196; _e263++) {
        var _i197 = t[_e263];
        void 0 !== _i197.mesh && (this._addNodeRef(this.meshCache, _i197.mesh), void 0 !== _i197.skin && (n[_i197.mesh].isSkinnedMesh = !0)), void 0 !== _i197.camera && this._addNodeRef(this.cameraCache, _i197.camera);
      }
    }
  }, {
    key: "_addNodeRef",
    value: function _addNodeRef(t, e) {
      void 0 !== e && (void 0 === t.refs[e] && (t.refs[e] = t.uses[e] = 0), t.refs[e]++);
    }
  }, {
    key: "_getNodeRef",
    value: function _getNodeRef(t, e, n) {
      if (t.refs[e] <= 1) return n;
      var i = n.clone();
      return i.name += "_instance_" + t.uses[e]++, i;
    }
  }, {
    key: "_invokeOne",
    value: function _invokeOne(t) {
      var e = Object.values(this.plugins);
      e.push(this);

      for (var _n251 = 0; _n251 < e.length; _n251++) {
        var _i198 = t(e[_n251]);

        if (_i198) return _i198;
      }

      return null;
    }
  }, {
    key: "_invokeAll",
    value: function _invokeAll(t) {
      var e = Object.values(this.plugins);
      e.unshift(this);
      var n = [];

      for (var _i199 = 0; _i199 < e.length; _i199++) {
        var _r136 = t(e[_i199]);

        _r136 && n.push(_r136);
      }

      return n;
    }
  }, {
    key: "getDependency",
    value: function getDependency(t, e) {
      var n = t + ":" + e;
      var i = this.cache.get(n);

      if (!i) {
        switch (t) {
          case "scene":
            i = this.loadScene(e);
            break;

          case "node":
            i = this.loadNode(e);
            break;

          case "mesh":
            i = this._invokeOne(function (t) {
              return t.loadMesh && t.loadMesh(e);
            });
            break;

          case "accessor":
            i = this.loadAccessor(e);
            break;

          case "bufferView":
            i = this._invokeOne(function (t) {
              return t.loadBufferView && t.loadBufferView(e);
            });
            break;

          case "buffer":
            i = this.loadBuffer(e);
            break;

          case "material":
            i = this._invokeOne(function (t) {
              return t.loadMaterial && t.loadMaterial(e);
            });
            break;

          case "texture":
            i = this._invokeOne(function (t) {
              return t.loadTexture && t.loadTexture(e);
            });
            break;

          case "skin":
            i = this.loadSkin(e);
            break;

          case "animation":
            i = this.loadAnimation(e);
            break;

          case "camera":
            i = this.loadCamera(e);
            break;

          default:
            throw new Error("Unknown type: " + t);
        }

        this.cache.add(n, i);
      }

      return i;
    }
  }, {
    key: "getDependencies",
    value: function getDependencies(t) {
      var e = this.cache.get(t);

      if (!e) {
        var _n252 = this,
            _i200 = this.json[t + ("mesh" === t ? "es" : "s")] || [];

        e = Promise.all(_i200.map(function (e, i) {
          return _n252.getDependency(t, i);
        })), this.cache.add(t, e);
      }

      return e;
    }
  }, {
    key: "loadBuffer",
    value: function loadBuffer(t) {
      var e = this.json.buffers[t],
          n = this.fileLoader;
      if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
      if (void 0 === e.uri && 0 === t) return Promise.resolve(this.extensions[nc.KHR_BINARY_GLTF].body);
      var i = this.options;
      return new Promise(function (t, r) {
        n.load(Gc(e.uri, i.path), t, void 0, function () {
          r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
        });
      });
    }
  }, {
    key: "loadBufferView",
    value: function loadBufferView(t) {
      var e = this.json.bufferViews[t];
      return this.getDependency("buffer", e.buffer).then(function (t) {
        var n = e.byteLength || 0,
            i = e.byteOffset || 0;
        return t.slice(i, i + n);
      });
    }
  }, {
    key: "loadAccessor",
    value: function loadAccessor(t) {
      var e = this,
          n = this.json,
          i = this.json.accessors[t];
      if (void 0 === i.bufferView && void 0 === i.sparse) return Promise.resolve(null);
      var r = [];
      return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function (t) {
        var r = t[0],
            s = Dc[i.type],
            a = Tc[i.componentType],
            o = a.BYTES_PER_ELEMENT,
            l = o * s,
            c = i.byteOffset || 0,
            h = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0,
            u = !0 === i.normalized;
        var d, p;

        if (h && h !== l) {
          var _t294 = Math.floor(c / h),
              _n253 = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + _t294 + ":" + i.count;

          var _l26 = e.cache.get(_n253);

          _l26 || (d = new a(r, _t294 * h, i.count * h / o), _l26 = new Fs(d, h / o), e.cache.add(_n253, _l26)), p = new Us(_l26, s, c % h / o, u);
        } else d = null === r ? new a(i.count * s) : new a(r, c, i.count * s), p = new Xe(d, s, u);

        if (void 0 !== i.sparse) {
          var _e264 = Dc.SCALAR,
              _n254 = Tc[i.sparse.indices.componentType],
              _o33 = i.sparse.indices.byteOffset || 0,
              _l27 = i.sparse.values.byteOffset || 0,
              _c21 = new _n254(t[1], _o33, i.sparse.count * _e264),
              _h11 = new a(t[2], _l27, i.sparse.count * s);

          null !== r && (p = new Xe(p.array.slice(), p.itemSize, p.normalized));

          for (var _t295 = 0, _e265 = _c21.length; _t295 < _e265; _t295++) {
            var _e266 = _c21[_t295];
            if (p.setX(_e266, _h11[_t295 * s]), s >= 2 && p.setY(_e266, _h11[_t295 * s + 1]), s >= 3 && p.setZ(_e266, _h11[_t295 * s + 2]), s >= 4 && p.setW(_e266, _h11[_t295 * s + 3]), s >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
          }
        }

        return p;
      });
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(t) {
      var e = this.json,
          n = this.options,
          i = e.textures[t],
          r = e.images[i.source];
      var s = this.textureLoader;

      if (r.uri) {
        var _t296 = n.manager.getHandler(r.uri);

        null !== _t296 && (s = _t296);
      }

      return this.loadTextureImage(t, r, s);
    }
  }, {
    key: "loadTextureImage",
    value: function loadTextureImage(t, e, n) {
      var i = this,
          r = this.json,
          s = this.options,
          a = r.textures[t],
          o = (e.uri || e.bufferView) + ":" + a.sampler;
      if (this.textureCache[o]) return this.textureCache[o];
      var l = self.URL || self.webkitURL;
      var c = e.uri || "",
          h = !1,
          u = !0;
      var d = c.search(/\.jpe?g($|\?)/i) > 0 || 0 === c.search(/^data\:image\/jpeg/);
      if (("image/jpeg" === e.mimeType || d) && (u = !1), void 0 !== e.bufferView) c = i.getDependency("bufferView", e.bufferView).then(function (t) {
        if ("image/png" === e.mimeType) {
          var _e267 = new DataView(t, 25, 1).getUint8(0, !1);

          u = 6 === _e267 || 4 === _e267 || 3 === _e267;
        }

        h = !0;
        var n = new Blob([t], {
          type: e.mimeType
        });
        return c = l.createObjectURL(n), c;
      });else if (void 0 === e.uri) throw new Error("THREE.GLTFLoader: Image " + t + " is missing URI and bufferView");
      var p = Promise.resolve(c).then(function (t) {
        return new Promise(function (e, i) {
          var r = e;
          !0 === n.isImageBitmapLoader && (r = function r(t) {
            var n = new vt(t);
            n.needsUpdate = !0, e(n);
          }), n.load(Gc(t, s.path), r, void 0, i);
        });
      }).then(function (e) {
        !0 === h && l.revokeObjectURL(c), e.flipY = !1, a.name && (e.name = a.name), u || (e.format = 1022);
        var n = (r.samplers || {})[a.sampler] || {};
        return e.magFilter = Lc[n.magFilter] || 1006, e.minFilter = Lc[n.minFilter] || 1008, e.wrapS = Rc[n.wrapS] || 1e3, e.wrapT = Rc[n.wrapT] || 1e3, i.associations.set(e, {
          type: "textures",
          index: t
        }), e;
      }).catch(function () {
        return console.error("THREE.GLTFLoader: Couldn't load texture", c), null;
      });
      return this.textureCache[o] = p, p;
    }
  }, {
    key: "assignTexture",
    value: function assignTexture(t, e, n) {
      var i = this;
      return this.getDependency("texture", n.index).then(function (r) {
        if (void 0 === n.texCoord || 0 == n.texCoord || "aoMap" === e && 1 == n.texCoord || console.warn("THREE.GLTFLoader: Custom UV set " + n.texCoord + " for texture " + e + " not yet supported."), i.extensions[nc.KHR_TEXTURE_TRANSFORM]) {
          var _t297 = void 0 !== n.extensions ? n.extensions[nc.KHR_TEXTURE_TRANSFORM] : void 0;

          if (_t297) {
            var _e268 = i.associations.get(r);

            r = i.extensions[nc.KHR_TEXTURE_TRANSFORM].extendTexture(r, _t297), i.associations.set(r, _e268);
          }
        }

        return t[e] = r, r;
      });
    }
  }, {
    key: "assignFinalMaterial",
    value: function assignFinalMaterial(t) {
      var e = t.geometry;
      var n = t.material;
      var i = void 0 !== e.attributes.tangent,
          r = void 0 !== e.attributes.color,
          s = void 0 === e.attributes.normal;

      if (t.isPoints) {
        var _t298 = "PointsMaterial:" + n.uuid;

        var _e269 = this.cache.get(_t298);

        _e269 || (_e269 = new Ca(), ke.prototype.copy.call(_e269, n), _e269.color.copy(n.color), _e269.map = n.map, _e269.sizeAttenuation = !1, this.cache.add(_t298, _e269)), n = _e269;
      } else if (t.isLine) {
        var _t299 = "LineBasicMaterial:" + n.uuid;

        var _e270 = this.cache.get(_t299);

        _e270 || (_e270 = new ma(), ke.prototype.copy.call(_e270, n), _e270.color.copy(n.color), this.cache.add(_t299, _e270)), n = _e270;
      }

      if (i || r || s) {
        var _t300 = "ClonedMaterial:" + n.uuid + ":";

        n.isGLTFSpecularGlossinessMaterial && (_t300 += "specular-glossiness:"), i && (_t300 += "vertex-tangents:"), r && (_t300 += "vertex-colors:"), s && (_t300 += "flat-shading:");

        var _e271 = this.cache.get(_t300);

        _e271 || (_e271 = n.clone(), r && (_e271.vertexColors = !0), s && (_e271.flatShading = !0), i && (_e271.normalScale && (_e271.normalScale.y *= -1), _e271.clearcoatNormalScale && (_e271.clearcoatNormalScale.y *= -1)), this.cache.add(_t300, _e271), this.associations.set(_e271, this.associations.get(n))), n = _e271;
      }

      n.aoMap && void 0 === e.attributes.uv2 && void 0 !== e.attributes.uv && e.setAttribute("uv2", e.attributes.uv), t.material = n;
    }
  }, {
    key: "getMaterialType",
    value: function getMaterialType() {
      return Ro;
    }
  }, {
    key: "loadMaterial",
    value: function loadMaterial(t) {
      var e = this,
          n = this.json,
          i = this.extensions,
          r = n.materials[t];
      var s;
      var a = {},
          o = r.extensions || {},
          l = [];

      if (o[nc.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
        var _t301 = i[nc.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
        s = _t301.getMaterialType(), l.push(_t301.extendParams(a, r, e));
      } else if (o[nc.KHR_MATERIALS_UNLIT]) {
        var _t302 = i[nc.KHR_MATERIALS_UNLIT];
        s = _t302.getMaterialType(), l.push(_t302.extendParams(a, r, e));
      } else {
        var _n255 = r.pbrMetallicRoughness || {};

        if (a.color = new qe(1, 1, 1), a.opacity = 1, Array.isArray(_n255.baseColorFactor)) {
          var _t303 = _n255.baseColorFactor;
          a.color.fromArray(_t303), a.opacity = _t303[3];
        }

        void 0 !== _n255.baseColorTexture && l.push(e.assignTexture(a, "map", _n255.baseColorTexture)), a.metalness = void 0 !== _n255.metallicFactor ? _n255.metallicFactor : 1, a.roughness = void 0 !== _n255.roughnessFactor ? _n255.roughnessFactor : 1, void 0 !== _n255.metallicRoughnessTexture && (l.push(e.assignTexture(a, "metalnessMap", _n255.metallicRoughnessTexture)), l.push(e.assignTexture(a, "roughnessMap", _n255.metallicRoughnessTexture))), s = this._invokeOne(function (e) {
          return e.getMaterialType && e.getMaterialType(t);
        }), l.push(Promise.all(this._invokeAll(function (e) {
          return e.extendMaterialParams && e.extendMaterialParams(t, a);
        })));
      }

      !0 === r.doubleSided && (a.side = 2);
      var c = r.alphaMode || Nc;
      return c === kc ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, c === Uc && (a.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && s !== je && (l.push(e.assignTexture(a, "normalMap", r.normalTexture)), a.normalScale = new pt(1, -1), void 0 !== r.normalTexture.scale && a.normalScale.set(r.normalTexture.scale, -r.normalTexture.scale)), void 0 !== r.occlusionTexture && s !== je && (l.push(e.assignTexture(a, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (a.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && s !== je && (a.emissive = new qe().fromArray(r.emissiveFactor)), void 0 !== r.emissiveTexture && s !== je && l.push(e.assignTexture(a, "emissiveMap", r.emissiveTexture)), Promise.all(l).then(function () {
        var n;
        return n = s === yc ? i[nc.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(a) : new s(a), r.name && (n.name = r.name), n.map && (n.map.encoding = 3001), n.emissiveMap && (n.emissiveMap.encoding = 3001), zc(n, r), e.associations.set(n, {
          type: "materials",
          index: t
        }), r.extensions && Hc(i, n, r), n;
      });
    }
  }, {
    key: "createUniqueName",
    value: function createUniqueName(t) {
      var e = Ul.sanitizeNodeName(t || "");
      var n = e;

      for (var _t304 = 1; this.nodeNamesUsed[n]; ++_t304) {
        n = e + "_" + _t304;
      }

      return this.nodeNamesUsed[n] = !0, n;
    }
  }, {
    key: "loadGeometries",
    value: function loadGeometries(t) {
      var e = this,
          n = this.extensions,
          i = this.primitiveCache;

      function r(t) {
        return n[nc.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t, e).then(function (n) {
          return Xc(n, t, e);
        });
      }

      var s = [];

      for (var _n256 = 0, _a58 = t.length; _n256 < _a58; _n256++) {
        var _a59 = t[_n256],
            _o34 = Wc(_a59),
            _l28 = i[_o34];

        if (_l28) s.push(_l28.promise);else {
          var _t305 = void 0;

          _t305 = _a59.extensions && _a59.extensions[nc.KHR_DRACO_MESH_COMPRESSION] ? r(_a59) : Xc(new cn(), _a59, e), i[_o34] = {
            primitive: _a59,
            promise: _t305
          }, s.push(_t305);
        }
      }

      return Promise.all(s);
    }
  }, {
    key: "loadMesh",
    value: function loadMesh(t) {
      var e = this,
          n = this.json,
          i = this.extensions,
          r = n.meshes[t],
          s = r.primitives,
          a = [];

      for (var _t306 = 0, _e272 = s.length; _t306 < _e272; _t306++) {
        var _e273 = void 0 === s[_t306].material ? Oc(this.cache) : this.getDependency("material", s[_t306].material);

        a.push(_e273);
      }

      return a.push(e.loadGeometries(s)), Promise.all(a).then(function (n) {
        var a = n.slice(0, n.length - 1),
            o = n[n.length - 1],
            l = [];

        for (var _n257 = 0, _c22 = o.length; _n257 < _c22; _n257++) {
          var _c23 = o[_n257],
              _h12 = s[_n257];

          var _u13 = void 0;

          var _d12 = a[_n257];
          if (_h12.mode === Mc || _h12.mode === Sc || _h12.mode === Bc || void 0 === _h12.mode) _u13 = !0 === r.isSkinnedMesh ? new sa(_c23, _d12) : new Mn(_c23, _d12), !0 !== _u13.isSkinnedMesh || _u13.geometry.attributes.skinWeight.normalized || _u13.normalizeSkinWeights(), _h12.mode === Sc ? _u13.geometry = Kc(_u13.geometry, 1) : _h12.mode === Bc && (_u13.geometry = Kc(_u13.geometry, 2));else if (_h12.mode === _c) _u13 = new _a(_c23, _d12);else if (_h12.mode === Cc) _u13 = new wa(_c23, _d12);else if (_h12.mode === Ic) _u13 = new Ia(_c23, _d12);else {
            if (_h12.mode !== bc) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + _h12.mode);
            _u13 = new La(_c23, _d12);
          }
          Object.keys(_u13.geometry.morphAttributes).length > 0 && Vc(_u13, r), _u13.name = e.createUniqueName(r.name || "mesh_" + t), zc(_u13, r), _h12.extensions && Hc(i, _u13, _h12), e.assignFinalMaterial(_u13), l.push(_u13);
        }

        if (1 === l.length) return l[0];
        var c = new Bs();

        for (var _t307 = 0, _e274 = l.length; _t307 < _e274; _t307++) {
          c.add(l[_t307]);
        }

        return c;
      });
    }
  }, {
    key: "loadCamera",
    value: function loadCamera(t) {
      var e;
      var n = this.json.cameras[t],
          i = n[n.type];
      if (i) return "perspective" === n.type ? e = new Pn(dt.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (e = new ri(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (e.name = this.createUniqueName(n.name)), zc(e, n), Promise.resolve(e);
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
    }
  }, {
    key: "loadSkin",
    value: function loadSkin(t) {
      var e = this.json.skins[t],
          n = {
        joints: e.joints
      };
      return void 0 === e.inverseBindMatrices ? Promise.resolve(n) : this.getDependency("accessor", e.inverseBindMatrices).then(function (t) {
        return n.inverseBindMatrices = t, n;
      });
    }
  }, {
    key: "loadAnimation",
    value: function loadAnimation(t) {
      var e = this.json.animations[t],
          n = [],
          i = [],
          r = [],
          s = [],
          a = [];

      for (var _t308 = 0, _o35 = e.channels.length; _t308 < _o35; _t308++) {
        var _o36 = e.channels[_t308],
            _l29 = e.samplers[_o36.sampler],
            _c24 = _o36.target,
            _h13 = void 0 !== _c24.node ? _c24.node : _c24.id,
            _u14 = void 0 !== e.parameters ? e.parameters[_l29.input] : _l29.input,
            _d13 = void 0 !== e.parameters ? e.parameters[_l29.output] : _l29.output;

        n.push(this.getDependency("node", _h13)), i.push(this.getDependency("accessor", _u14)), r.push(this.getDependency("accessor", _d13)), s.push(_l29), a.push(_c24);
      }

      return Promise.all([Promise.all(n), Promise.all(i), Promise.all(r), Promise.all(s), Promise.all(a)]).then(function (n) {
        var i = n[0],
            r = n[1],
            s = n[2],
            a = n[3],
            o = n[4],
            l = [];

        var _loop2 = function _loop2(_t309, _e275) {
          var e = i[_t309],
              n = r[_t309],
              c = s[_t309],
              h = a[_t309],
              u = o[_t309];
          if (void 0 === e) return "continue";
          var d = void 0;

          switch (e.updateMatrix(), e.matrixAutoUpdate = !0, Pc[u.path]) {
            case Pc.weights:
              d = Ho;
              break;

            case Pc.rotation:
              d = Vo;
              break;

            case Pc.position:
            case Pc.scale:
            default:
              d = qo;
          }

          var p = e.name ? e.name : e.uuid,
              A = void 0 !== h.interpolation ? Fc[h.interpolation] : 2301,
              m = [];
          Pc[u.path] === Pc.weights ? e.traverse(function (t) {
            !0 === t.isMesh && t.morphTargetInfluences && m.push(t.name ? t.name : t.uuid);
          }) : m.push(p);
          var g = c.array;

          if (c.normalized) {
            var _t310 = jc(g.constructor),
                _e276 = new Float32Array(g.length);

            for (var _n258 = 0, _i201 = g.length; _n258 < _i201; _n258++) {
              _e276[_n258] = g[_n258] * _t310;
            }

            g = _e276;
          }

          for (var _t311 = 0, _e277 = m.length; _t311 < _e277; _t311++) {
            var _e278 = new d(m[_t311] + "." + Pc[u.path], n.array, g, A);

            "CUBICSPLINE" === h.interpolation && (_e278.createInterpolant = function (t) {
              return new Ec(this.times, this.values, this.getValueSize() / 3, t);
            }, _e278.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0), l.push(_e278);
          }
        };

        for (var _t309 = 0, _e275 = i.length; _t309 < _e275; _t309++) {
          var _ret2 = _loop2(_t309, _e275);

          if (_ret2 === "continue") continue;
        }

        var c = e.name ? e.name : "animation_" + t;
        return new jo(c, void 0, l);
      });
    }
  }, {
    key: "createNodeMesh",
    value: function createNodeMesh(t) {
      var e = this.json,
          n = this,
          i = e.nodes[t];
      return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function (t) {
        var e = n._getNodeRef(n.meshCache, i.mesh, t);

        return void 0 !== i.weights && e.traverse(function (t) {
          if (t.isMesh) for (var _e279 = 0, _n259 = i.weights.length; _e279 < _n259; _e279++) {
            t.morphTargetInfluences[_e279] = i.weights[_e279];
          }
        }), e;
      });
    }
  }, {
    key: "loadNode",
    value: function loadNode(t) {
      var e = this.json,
          n = this.extensions,
          i = this,
          r = e.nodes[t],
          s = r.name ? i.createUniqueName(r.name) : "";
      return function () {
        var e = [],
            n = i._invokeOne(function (e) {
          return e.createNodeMesh && e.createNodeMesh(t);
        });

        return n && e.push(n), void 0 !== r.camera && e.push(i.getDependency("camera", r.camera).then(function (t) {
          return i._getNodeRef(i.cameraCache, r.camera, t);
        })), i._invokeAll(function (e) {
          return e.createNodeAttachment && e.createNodeAttachment(t);
        }).forEach(function (t) {
          e.push(t);
        }), Promise.all(e);
      }().then(function (e) {
        var a;
        if (a = !0 === r.isBone ? new aa() : e.length > 1 ? new Bs() : 1 === e.length ? e[0] : new Ce(), a !== e[0]) for (var _t312 = 0, _n260 = e.length; _t312 < _n260; _t312++) {
          a.add(e[_t312]);
        }

        if (r.name && (a.userData.name = r.name, a.name = s), zc(a, r), r.extensions && Hc(n, a, r), void 0 !== r.matrix) {
          var _t313 = new ee();

          _t313.fromArray(r.matrix), a.applyMatrix4(_t313);
        } else void 0 !== r.translation && a.position.fromArray(r.translation), void 0 !== r.rotation && a.quaternion.fromArray(r.rotation), void 0 !== r.scale && a.scale.fromArray(r.scale);

        return i.associations.set(a, {
          type: "nodes",
          index: t
        }), a;
      });
    }
  }, {
    key: "loadScene",
    value: function loadScene(t) {
      var e = this.json,
          n = this.extensions,
          i = this.json.scenes[t],
          r = this,
          s = new Bs();
      i.name && (s.name = r.createUniqueName(i.name)), zc(s, i), i.extensions && Hc(n, s, i);
      var a = i.nodes || [],
          o = [];

      for (var _t314 = 0, _n261 = a.length; _t314 < _n261; _t314++) {
        o.push(Jc(a[_t314], s, e, r));
      }

      return Promise.all(o).then(function () {
        return s;
      });
    }
  }]);

  return Yc;
}();

function Jc(t, e, n, i) {
  var r = n.nodes[t];
  return i.getDependency("node", t).then(function (t) {
    if (void 0 === r.skin) return t;
    var e;
    return i.getDependency("skin", r.skin).then(function (t) {
      e = t;
      var n = [];

      for (var _t315 = 0, _r137 = e.joints.length; _t315 < _r137; _t315++) {
        n.push(i.getDependency("node", e.joints[_t315]));
      }

      return Promise.all(n);
    }).then(function (n) {
      return t.traverse(function (t) {
        if (!t.isMesh) return;
        var i = [],
            r = [];

        for (var _t316 = 0, _s79 = n.length; _t316 < _s79; _t316++) {
          var _s80 = n[_t316];

          if (_s80) {
            i.push(_s80);

            var _n262 = new ee();

            void 0 !== e.inverseBindMatrices && _n262.fromArray(e.inverseBindMatrices.array, 16 * _t316), r.push(_n262);
          } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[_t316]);
        }

        t.bind(new ha(i, r), t.matrixWorld);
      }), t;
    });
  }).then(function (t) {
    e.add(t);
    var s = [];

    if (r.children) {
      var _e280 = r.children;

      for (var _r138 = 0, _a60 = _e280.length; _r138 < _a60; _r138++) {
        var _a61 = _e280[_r138];
        s.push(Jc(_a61, t, n, i));
      }
    }

    return Promise.all(s);
  });
}

function Xc(t, e, n) {
  var i = e.attributes,
      r = [];

  function s(e, i) {
    return n.getDependency("accessor", e).then(function (e) {
      t.setAttribute(i, e);
    });
  }

  for (var _e281 in i) {
    var _n263 = Qc[_e281] || _e281.toLowerCase();

    _n263 in t.attributes || r.push(s(i[_e281], _n263));
  }

  if (void 0 !== e.indices && !t.index) {
    var _i202 = n.getDependency("accessor", e.indices).then(function (e) {
      t.setIndex(e);
    });

    r.push(_i202);
  }

  return zc(t, e), function (t, e, n) {
    var i = e.attributes,
        r = new Mt();
    if (void 0 === i.POSITION) return;
    {
      var _t317 = n.json.accessors[i.POSITION],
          _e282 = _t317.min,
          _s81 = _t317.max;
      if (void 0 === _e282 || void 0 === _s81) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");

      if (r.set(new _t(_e282[0], _e282[1], _e282[2]), new _t(_s81[0], _s81[1], _s81[2])), _t317.normalized) {
        var _e283 = jc(Tc[_t317.componentType]);

        r.min.multiplyScalar(_e283), r.max.multiplyScalar(_e283);
      }
    }
    var s = e.targets;

    if (void 0 !== s) {
      var _t318 = new _t(),
          _e284 = new _t();

      for (var _i203 = 0, _r139 = s.length; _i203 < _r139; _i203++) {
        var _r140 = s[_i203];

        if (void 0 !== _r140.POSITION) {
          var _i204 = n.json.accessors[_r140.POSITION],
              _s82 = _i204.min,
              _a62 = _i204.max;

          if (void 0 !== _s82 && void 0 !== _a62) {
            if (_e284.setX(Math.max(Math.abs(_s82[0]), Math.abs(_a62[0]))), _e284.setY(Math.max(Math.abs(_s82[1]), Math.abs(_a62[1]))), _e284.setZ(Math.max(Math.abs(_s82[2]), Math.abs(_a62[2]))), _i204.normalized) {
              var _t319 = jc(Tc[_i204.componentType]);

              _e284.multiplyScalar(_t319);
            }

            _t318.max(_e284);
          } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }

      r.expandByVector(_t318);
    }

    t.boundingBox = r;
    var a = new qt();
    r.getCenter(a.center), a.radius = r.min.distanceTo(r.max) / 2, t.boundingSphere = a;
  }(t, e, n), Promise.all(r).then(function () {
    return void 0 !== e.targets ? function (t, e, n) {
      var i = !1,
          r = !1;

      for (var _t320 = 0, _n264 = e.length; _t320 < _n264; _t320++) {
        var _n265 = e[_t320];
        if (void 0 !== _n265.POSITION && (i = !0), void 0 !== _n265.NORMAL && (r = !0), i && r) break;
      }

      if (!i && !r) return Promise.resolve(t);
      var s = [],
          a = [];

      for (var _o37 = 0, _l30 = e.length; _o37 < _l30; _o37++) {
        var _l31 = e[_o37];

        if (i) {
          var _e285 = void 0 !== _l31.POSITION ? n.getDependency("accessor", _l31.POSITION) : t.attributes.position;

          s.push(_e285);
        }

        if (r) {
          var _e286 = void 0 !== _l31.NORMAL ? n.getDependency("accessor", _l31.NORMAL) : t.attributes.normal;

          a.push(_e286);
        }
      }

      return Promise.all([Promise.all(s), Promise.all(a)]).then(function (e) {
        var n = e[0],
            s = e[1];
        return i && (t.morphAttributes.position = n), r && (t.morphAttributes.normal = s), t.morphTargetsRelative = !0, t;
      });
    }(t, e.targets, n) : t;
  });
}

function Kc(t, e) {
  var n = t.getIndex();

  if (null === n) {
    var _e287 = [],
        _i205 = t.getAttribute("position");

    if (void 0 === _i205) return console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t;

    for (var _t321 = 0; _t321 < _i205.count; _t321++) {
      _e287.push(_t321);
    }

    t.setIndex(_e287), n = t.getIndex();
  }

  var i = n.count - 2,
      r = [];
  if (2 === e) for (var _t322 = 1; _t322 <= i; _t322++) {
    r.push(n.getX(0)), r.push(n.getX(_t322)), r.push(n.getX(_t322 + 1));
  } else for (var _t323 = 0; _t323 < i; _t323++) {
    _t323 % 2 == 0 ? (r.push(n.getX(_t323)), r.push(n.getX(_t323 + 1)), r.push(n.getX(_t323 + 2))) : (r.push(n.getX(_t323 + 2)), r.push(n.getX(_t323 + 1)), r.push(n.getX(_t323)));
  }
  r.length / 3 !== i && console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
  var s = t.clone();
  return s.setIndex(r), s;
}

var Zc = [171, 75, 84, 88, 32, 50, 48, 187, 13, 10, 26, 10];
var $c, th, eh, nh, ih, rh, sh, ah, oh;
(oh = $c || ($c = {}))[oh.NONE = 0] = "NONE", oh[oh.BASISLZ = 1] = "BASISLZ", oh[oh.ZSTD = 2] = "ZSTD", oh[oh.ZLIB = 3] = "ZLIB", function (t) {
  t[t.BASICFORMAT = 0] = "BASICFORMAT";
}(th || (th = {})), function (t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.ETC1S = 163] = "ETC1S", t[t.UASTC = 166] = "UASTC";
}(eh || (eh = {})), function (t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.SRGB = 1] = "SRGB";
}(nh || (nh = {})), function (t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.LINEAR = 1] = "LINEAR", t[t.SRGB = 2] = "SRGB", t[t.ITU = 3] = "ITU", t[t.NTSC = 4] = "NTSC", t[t.SLOG = 5] = "SLOG", t[t.SLOG2 = 6] = "SLOG2";
}(ih || (ih = {})), function (t) {
  t[t.ALPHA_STRAIGHT = 0] = "ALPHA_STRAIGHT", t[t.ALPHA_PREMULTIPLIED = 1] = "ALPHA_PREMULTIPLIED";
}(rh || (rh = {})), function (t) {
  t[t.RGB = 0] = "RGB", t[t.RRR = 3] = "RRR", t[t.GGG = 4] = "GGG", t[t.AAA = 15] = "AAA";
}(sh || (sh = {})), function (t) {
  t[t.RGB = 0] = "RGB", t[t.RGBA = 3] = "RGBA", t[t.RRR = 4] = "RRR", t[t.RRRG = 5] = "RRRG";
}(ah || (ah = {}));

var lh = /*#__PURE__*/_createClass(function lh() {
  _classCallCheck(this, lh);

  this.vkFormat = 0, this.typeSize = 1, this.pixelWidth = 0, this.pixelHeight = 0, this.pixelDepth = 0, this.layerCount = 0, this.faceCount = 1, this.supercompressionScheme = $c.NONE, this.levels = [], this.dataFormatDescriptor = [{
    vendorId: 0,
    descriptorType: th.BASICFORMAT,
    versionNumber: 2,
    descriptorBlockSize: 40,
    colorModel: eh.UNSPECIFIED,
    colorPrimaries: nh.SRGB,
    transferFunction: nh.SRGB,
    flags: rh.ALPHA_STRAIGHT,
    texelBlockDimension: {
      x: 4,
      y: 4,
      z: 1,
      w: 1
    },
    bytesPlane: [],
    samples: []
  }], this.keyValue = {}, this.globalData = null;
});

var ch = /*#__PURE__*/function () {
  function ch(t, e, n, i) {
    _classCallCheck(this, ch);

    this._dataView = new DataView(t.buffer, t.byteOffset + e, n), this._littleEndian = i, this._offset = 0;
  }

  _createClass(ch, [{
    key: "_nextUint8",
    value: function _nextUint8() {
      var t = this._dataView.getUint8(this._offset);

      return this._offset += 1, t;
    }
  }, {
    key: "_nextUint16",
    value: function _nextUint16() {
      var t = this._dataView.getUint16(this._offset, this._littleEndian);

      return this._offset += 2, t;
    }
  }, {
    key: "_nextUint32",
    value: function _nextUint32() {
      var t = this._dataView.getUint32(this._offset, this._littleEndian);

      return this._offset += 4, t;
    }
  }, {
    key: "_nextUint64",
    value: function _nextUint64() {
      var t = this._dataView.getUint32(this._offset, this._littleEndian) + Math.pow(2, 32) * this._dataView.getUint32(this._offset + 4, this._littleEndian);

      return this._offset += 8, t;
    }
  }, {
    key: "_skip",
    value: function _skip(t) {
      return this._offset += t, this;
    }
  }, {
    key: "_scan",
    value: function _scan(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = this._offset;
      var i = 0;

      for (; this._dataView.getUint8(this._offset) !== e && i < t;) {
        i++, this._offset++;
      }

      return i < t && this._offset++, new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + n, i);
    }
  }]);

  return ch;
}();

function hh(t) {
  return "undefined" != typeof TextDecoder ? new TextDecoder().decode(t) : Buffer.from(t).toString("utf8");
}

var uh = new WeakMap();

var dh = /*#__PURE__*/function (_Ko10) {
  _inherits(dh, _Ko10);

  var _super117 = _createSuper(dh);

  function dh(t) {
    var _this100;

    _classCallCheck(this, dh);

    _this100 = _super117.call(this, t), _this100.transcoderPath = "", _this100.transcoderBinary = null, _this100.transcoderPending = null, _this100.workerLimit = 4, _this100.workerPool = [], _this100.workerNextTaskID = 1, _this100.workerSourceURL = "", _this100.workerConfig = null;
    return _this100;
  }

  _createClass(dh, [{
    key: "setTranscoderPath",
    value: function setTranscoderPath(t) {
      return this.transcoderPath = t, this;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      return this.workerLimit = t, this;
    }
  }, {
    key: "detectSupport",
    value: function detectSupport(t) {
      return this.workerConfig = {
        astcSupported: t.extensions.has("WEBGL_compressed_texture_astc"),
        etc1Supported: t.extensions.has("WEBGL_compressed_texture_etc1"),
        etc2Supported: t.extensions.has("WEBGL_compressed_texture_etc"),
        dxtSupported: t.extensions.has("WEBGL_compressed_texture_s3tc"),
        bptcSupported: t.extensions.has("EXT_texture_compression_bptc"),
        pvrtcSupported: t.extensions.has("WEBGL_compressed_texture_pvrtc") || t.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
      }, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      var _this101 = this;

      var r = new $o(this.manager);
      r.setResponseType("arraybuffer"), r.setWithCredentials(this.withCredentials);
      var s = new Da();
      return r.load(t, function (t) {
        if (uh.has(t)) {
          return uh.get(t).promise.then(e).catch(i);
        }

        _this101._createTexture([t]).then(function (t) {
          s.copy(t), s.needsUpdate = !0, e && e(s);
        }).catch(i);
      }, n, i), s;
    }
  }, {
    key: "parseInternalAsync",
    value: function parseInternalAsync(t) {
      var e = t.levels,
          n = new Set();

      for (var _t324 = 0; _t324 < e.length; _t324++) {
        n.add(e[_t324].data.buffer);
      }

      return this._createTexture(Array.from(n), _objectSpread(_objectSpread({}, t), {}, {
        lowLevel: !0
      }));
    }
  }, {
    key: "_createTexture",
    value: function _createTexture(t) {
      var _this102 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n, i;
      var r = e;
      var s = 0;

      for (var _e288 = 0; _e288 < t.length; _e288++) {
        s += t[_e288].byteLength;
      }

      var a = this._allocateWorker(s).then(function (e) {
        return n = e, i = _this102.workerNextTaskID++, new Promise(function (e, s) {
          n._callbacks[i] = {
            resolve: e,
            reject: s
          }, n.postMessage({
            type: "transcode",
            id: i,
            buffers: t,
            taskConfig: r
          }, t);
        });
      }).then(function (t) {
        var e = t.mipmaps,
            n = t.width,
            i = t.height,
            r = t.format,
            s = new Da(e, n, i, r, 1009);
        return s.minFilter = 1 === e.length ? 1006 : 1008, s.magFilter = 1006, s.generateMipmaps = !1, s.needsUpdate = !0, s;
      });

      return a.catch(function () {
        return !0;
      }).then(function () {
        n && i && (n._taskLoad -= s, delete n._callbacks[i]);
      }), uh.set(t[0], {
        promise: a
      }), a;
    }
  }, {
    key: "_initTranscoder",
    value: function _initTranscoder() {
      var _this103 = this;

      if (!this.transcoderPending) {
        var _t325 = new $o(this.manager);

        _t325.setPath(this.transcoderPath), _t325.setWithCredentials(this.withCredentials);

        var _e289 = new Promise(function (e, n) {
          _t325.load("basis_transcoder.js", e, void 0, n);
        }),
            _n266 = new $o(this.manager);

        _n266.setPath(this.transcoderPath), _n266.setResponseType("arraybuffer"), _n266.setWithCredentials(this.withCredentials);

        var _i206 = new Promise(function (t, e) {
          _n266.load("basis_transcoder.wasm", t, void 0, e);
        });

        this.transcoderPending = Promise.all([_e289, _i206]).then(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              t = _ref3[0],
              e = _ref3[1];

          var n = dh.BasisWorker.toString(),
              i = ["/* constants */", "let _EngineFormat = " + JSON.stringify(dh.EngineFormat), "let _TranscoderFormat = " + JSON.stringify(dh.TranscoderFormat), "let _BasisFormat = " + JSON.stringify(dh.BasisFormat), "/* basis_transcoder.js */", t, "/* worker */", n.substring(n.indexOf("{") + 1, n.lastIndexOf("}"))].join("\n");
          _this103.workerSourceURL = URL.createObjectURL(new Blob([i])), _this103.transcoderBinary = e;
        });
      }

      return this.transcoderPending;
    }
  }, {
    key: "_allocateWorker",
    value: function _allocateWorker(t) {
      var _this104 = this;

      return this._initTranscoder().then(function () {
        if (_this104.workerPool.length < _this104.workerLimit) {
          var _t326 = new Worker(_this104.workerSourceURL);

          _t326._callbacks = {}, _t326._taskLoad = 0, _t326.postMessage({
            type: "init",
            config: _this104.workerConfig,
            transcoderBinary: _this104.transcoderBinary
          }), _t326.onmessage = function (e) {
            var n = e.data;

            switch (n.type) {
              case "transcode":
                _t326._callbacks[n.id].resolve(n);

                break;

              case "error":
                _t326._callbacks[n.id].reject(n);

                break;

              default:
                console.error('THREE.BasisTextureLoader: Unexpected message, "' + n.type + '"');
            }
          }, _this104.workerPool.push(_t326);
        } else _this104.workerPool.sort(function (t, e) {
          return t._taskLoad > e._taskLoad ? -1 : 1;
        });

        var e = _this104.workerPool[_this104.workerPool.length - 1];
        return e._taskLoad += t, e;
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var _t327 = 0; _t327 < this.workerPool.length; _t327++) {
        this.workerPool[_t327].terminate();
      }

      return this.workerPool.length = 0, this;
    }
  }]);

  return dh;
}(Ko);

var ph, Ah, mh;
dh.BasisFormat = {
  ETC1S: 0,
  UASTC_4x4: 1
}, dh.TranscoderFormat = {
  ETC1: 0,
  ETC2: 1,
  BC1: 2,
  BC3: 3,
  BC4: 4,
  BC5: 5,
  BC7_M6_OPAQUE_ONLY: 6,
  BC7_M5: 7,
  PVRTC1_4_RGB: 8,
  PVRTC1_4_RGBA: 9,
  ASTC_4x4: 10,
  ATC_RGB: 11,
  ATC_RGBA_INTERPOLATED_ALPHA: 12,
  RGBA32: 13,
  RGB565: 14,
  BGR565: 15,
  RGBA4444: 16
}, dh.EngineFormat = {
  RGBAFormat: 1023,
  RGBA_ASTC_4x4_Format: 37808,
  RGBA_BPTC_Format: 36492,
  RGBA_ETC2_EAC_Format: 37496,
  RGBA_PVRTC_4BPPV1_Format: 35842,
  RGBA_S3TC_DXT5_Format: 33779,
  RGB_ETC1_Format: 36196,
  RGB_ETC2_Format: 37492,
  RGB_PVRTC_4BPPV1_Format: 35840,
  RGB_S3TC_DXT1_Format: 33776
}, dh.BasisWorker = function () {
  var t, e, n;
  var i = _EngineFormat,
      r = _TranscoderFormat,
      s = _BasisFormat;

  onmessage = function onmessage(i) {
    var r = i.data;

    switch (r.type) {
      case "init":
        t = r.config, a = r.transcoderBinary, e = new Promise(function (t) {
          n = {
            wasmBinary: a,
            onRuntimeInitialized: t
          }, BASIS(n);
        }).then(function () {
          n.initializeBasis();
        });
        break;

      case "transcode":
        e.then(function () {
          try {
            var _ref4 = r.taskConfig.lowLevel ? function (t) {
              var e = t.basisFormat,
                  i = t.width,
                  r = t.height,
                  a = t.hasAlpha,
                  _c25 = c(e, i, r, a),
                  o = _c25.transcoderFormat,
                  l = _c25.engineFormat,
                  A = n.getBytesPerBlockOrPixel(o);

              h(n.isFormatSupported(o), "THREE.BasisTextureLoader: Unsupported format.");
              var m = [];

              if (e === s.ETC1S) {
                var _e291 = new n.LowLevelETC1SImageTranscoder(),
                    _t$globalData = t.globalData,
                    _i208 = _t$globalData.endpointCount,
                    _r141 = _t$globalData.endpointsData,
                    _s83 = _t$globalData.selectorCount,
                    _l33 = _t$globalData.selectorsData,
                    _c26 = _t$globalData.tablesData;

                try {
                  var _n267;

                  _n267 = _e291.decodePalettes(_i208, _r141, _s83, _l33), h(_n267, "THREE.BasisTextureLoader: decodePalettes() failed."), _n267 = _e291.decodeTables(_c26), h(_n267, "THREE.BasisTextureLoader: decodeTables() failed.");

                  for (var _i209 = 0; _i209 < t.levels.length; _i209++) {
                    var _r142 = t.levels[_i209],
                        _s84 = t.globalData.imageDescs[_i209],
                        _l34 = p(o, _r142.width, _r142.height),
                        _c27 = new Uint8Array(_l34);

                    _n267 = _e291.transcodeImage(o, _c27, _l34 / A, _r142.data, u(o, _r142.width), d(o, _r142.height), _r142.width, _r142.height, _r142.index, _s84.rgbSliceByteOffset, _s84.rgbSliceByteLength, _s84.alphaSliceByteOffset, _s84.alphaSliceByteLength, _s84.imageFlags, a, !1, 0, 0), h(_n267, "THREE.BasisTextureLoader: transcodeImage() failed for level " + _r142.index + "."), m.push({
                      data: _c27,
                      width: _r142.width,
                      height: _r142.height
                    });
                  }
                } finally {
                  _e291.delete();
                }
              } else for (var _e292 = 0; _e292 < t.levels.length; _e292++) {
                var _i210 = t.levels[_e292],
                    _r143 = p(o, _i210.width, _i210.height),
                    _s85 = new Uint8Array(_r143);

                h(n.transcodeUASTCImage(o, _s85, _r143 / A, _i210.data, u(o, _i210.width), d(o, _i210.height), _i210.width, _i210.height, _i210.index, 0, _i210.data.byteLength, 0, a, !1, 0, 0, -1, -1), "THREE.BasisTextureLoader: transcodeUASTCImage() failed for level " + _i210.index + "."), m.push({
                  data: _s85,
                  width: _i210.width,
                  height: _i210.height
                });
              }

              return {
                width: i,
                height: r,
                hasAlpha: a,
                mipmaps: m,
                format: l
              };
            }(r.taskConfig) : function (t) {
              var e = new n.BasisFile(new Uint8Array(t)),
                  i = e.isUASTC() ? s.UASTC_4x4 : s.ETC1S,
                  r = e.getImageWidth(0, 0),
                  a = e.getImageHeight(0, 0),
                  o = e.getNumLevels(0),
                  l = e.getHasAlpha();

              function h() {
                e.close(), e.delete();
              }

              var _c28 = c(i, r, a, l),
                  u = _c28.transcoderFormat,
                  d = _c28.engineFormat;

              if (!r || !a || !o) throw h(), new Error("THREE.BasisTextureLoader:\tInvalid texture");
              if (!e.startTranscoding()) throw h(), new Error("THREE.BasisTextureLoader: .startTranscoding failed");
              var p = [];

              for (var _t329 = 0; _t329 < o; _t329++) {
                var _n268 = e.getImageWidth(0, _t329),
                    _i211 = e.getImageHeight(0, _t329),
                    _r144 = new Uint8Array(e.getImageTranscodedSizeInBytes(0, _t329, u));

                if (!e.transcodeImage(_r144, 0, _t329, u, 0, l)) throw h(), new Error("THREE.BasisTextureLoader: .transcodeImage failed.");
                p.push({
                  data: _r144,
                  width: _n268,
                  height: _i211
                });
              }

              return h(), {
                width: r,
                height: a,
                hasAlpha: l,
                mipmaps: p,
                format: d
              };
            }(r.buffers[0]),
                _t328 = _ref4.width,
                _e290 = _ref4.height,
                _i207 = _ref4.hasAlpha,
                _a63 = _ref4.mipmaps,
                _o38 = _ref4.format,
                _l32 = [];

            for (var _t330 = 0; _t330 < _a63.length; ++_t330) {
              _l32.push(_a63[_t330].data.buffer);
            }

            self.postMessage({
              type: "transcode",
              id: r.id,
              width: _t328,
              height: _e290,
              hasAlpha: _i207,
              mipmaps: _a63,
              format: _o38
            }, _l32);
          } catch (t) {
            console.error(t), self.postMessage({
              type: "error",
              id: r.id,
              error: t.message
            });
          }
        });
    }

    var a;
  };

  var a = [{
    if: "astcSupported",
    basisFormat: [s.UASTC_4x4],
    transcoderFormat: [r.ASTC_4x4, r.ASTC_4x4],
    engineFormat: [i.RGBA_ASTC_4x4_Format, i.RGBA_ASTC_4x4_Format],
    priorityETC1S: 1 / 0,
    priorityUASTC: 1,
    needsPowerOfTwo: !1
  }, {
    if: "bptcSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.BC7_M5, r.BC7_M5],
    engineFormat: [i.RGBA_BPTC_Format, i.RGBA_BPTC_Format],
    priorityETC1S: 3,
    priorityUASTC: 2,
    needsPowerOfTwo: !1
  }, {
    if: "dxtSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.BC1, r.BC3],
    engineFormat: [i.RGB_S3TC_DXT1_Format, i.RGBA_S3TC_DXT5_Format],
    priorityETC1S: 4,
    priorityUASTC: 5,
    needsPowerOfTwo: !1
  }, {
    if: "etc2Supported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.ETC1, r.ETC2],
    engineFormat: [i.RGB_ETC2_Format, i.RGBA_ETC2_EAC_Format],
    priorityETC1S: 1,
    priorityUASTC: 3,
    needsPowerOfTwo: !1
  }, {
    if: "etc1Supported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.ETC1, r.ETC1],
    engineFormat: [i.RGB_ETC1_Format, i.RGB_ETC1_Format],
    priorityETC1S: 2,
    priorityUASTC: 4,
    needsPowerOfTwo: !1
  }, {
    if: "pvrtcSupported",
    basisFormat: [s.ETC1S, s.UASTC_4x4],
    transcoderFormat: [r.PVRTC1_4_RGB, r.PVRTC1_4_RGBA],
    engineFormat: [i.RGB_PVRTC_4BPPV1_Format, i.RGBA_PVRTC_4BPPV1_Format],
    priorityETC1S: 5,
    priorityUASTC: 6,
    needsPowerOfTwo: !0
  }],
      o = a.sort(function (t, e) {
    return t.priorityETC1S - e.priorityETC1S;
  }),
      l = a.sort(function (t, e) {
    return t.priorityUASTC - e.priorityUASTC;
  });

  function c(e, n, a, c) {
    var h, u;
    var d = e === s.ETC1S ? o : l;

    for (var _i212 = 0; _i212 < d.length; _i212++) {
      var _r145 = d[_i212];
      if (t[_r145.if] && _r145.basisFormat.includes(e) && (!_r145.needsPowerOfTwo || A(n) && A(a))) return h = _r145.transcoderFormat[c ? 1 : 0], u = _r145.engineFormat[c ? 1 : 0], {
        transcoderFormat: h,
        engineFormat: u
      };
    }

    return console.warn("THREE.BasisTextureLoader: No suitable compressed texture format found. Decoding to RGBA32."), h = r.RGBA32, u = i.RGBAFormat, {
      transcoderFormat: h,
      engineFormat: u
    };
  }

  function h(t, e) {
    if (!t) throw new Error(e);
  }

  function u(t, e) {
    return Math.ceil(e / n.getFormatBlockWidth(t));
  }

  function d(t, e) {
    return Math.ceil(e / n.getFormatBlockHeight(t));
  }

  function p(t, e, i) {
    var s = n.getBytesPerBlockOrPixel(t);
    if (n.formatIsUncompressed(t)) return e * i * s;

    if (t === r.PVRTC1_4_RGB || t === r.PVRTC1_4_RGBA) {
      var _t331 = e + 3 & -4,
          _n269 = i + 3 & -4;

      return (Math.max(8, _t331) * Math.max(8, _n269) * 4 + 7) / 8;
    }

    return u(t, e) * d(t, i) * s;
  }

  function A(t) {
    return t <= 2 || 0 == (t & t - 1) && 0 !== t;
  }
};
var gh = {
  env: {
    emscripten_notify_memory_growth: function emscripten_notify_memory_growth(t) {
      mh = new Uint8Array(Ah.exports.memory.buffer);
    }
  }
};

var fh = /*#__PURE__*/function () {
  function fh() {
    _classCallCheck(this, fh);
  }

  _createClass(fh, [{
    key: "init",
    value: function init() {
      return ph || (ph = fetch("data:application/wasm;base64," + vh).then(function (t) {
        return t.arrayBuffer();
      }).then(function (t) {
        return WebAssembly.instantiate(t, gh);
      }).then(function (t) {
        Ah = t.instance, gh.env.emscripten_notify_memory_growth(0);
      })), ph;
    }
  }, {
    key: "decode",
    value: function decode(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var n = t.byteLength,
          i = Ah.exports.malloc(n);
      mh.set(t, i), e = e || Number(Ah.exports.ZSTD_findDecompressedSize(i, n));
      var r = Ah.exports.malloc(e),
          s = Ah.exports.ZSTD_decompress(r, e, i, n),
          a = mh.slice(r, r + s);
      return Ah.exports.free(i), Ah.exports.free(r), a;
    }
  }]);

  return fh;
}();

var vh = "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";
var yh,
    xh,
    wh = {
  createLevels: function () {
    var _createLevels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t, e) {
      var n, i, r, s, a, o, l;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = t.supercompressionScheme === $c.ZSTD;

              if (!_context3.t0) {
                _context3.next = 4;
                break;
              }

              _context3.next = 4;
              return e.init();

            case 4:
              for (n = [], i = t.pixelWidth, r = t.pixelHeight, s = 0; s < t.levels.length; s++) {
                a = Math.max(1, Math.floor(i / Math.pow(2, s))), o = Math.max(1, Math.floor(r / Math.pow(2, s))), l = t.levels[s].levelData;
                t.supercompressionScheme === $c.ZSTD && (l = e.decode(l, t.levels[s].uncompressedByteLength)), n.push({
                  index: s,
                  width: a,
                  height: o,
                  data: l
                });
              }

              return _context3.abrupt("return", n);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function createLevels(_x4, _x5) {
      return _createLevels.apply(this, arguments);
    }

    return createLevels;
  }(),
  getBasicDFD: function getBasicDFD(t) {
    return t.dataFormatDescriptor[0];
  },
  getAlpha: function getAlpha(t) {
    var e = this.getBasicDFD(t);
    return e.colorModel === eh.UASTC ? (15 & e.samples[0].channelID) === ah.RGBA : 2 === e.samples.length && (15 & e.samples[1].channelID) === sh.AAA;
  },
  getPremultiplyAlpha: function getPremultiplyAlpha(t) {
    return !!(this.getBasicDFD(t).flags & rh.ALPHA_PREMULTIPLIED);
  }
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Eh = Symbol("retainerCount"),
    bh = Symbol("recentlyUsed"),
    _h = Symbol("evict"),
    Ih = Symbol("evictionThreshold"),
    Ch = Symbol("cache");

var Mh = /*#__PURE__*/function (_ref5) {
  function Mh(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

    _classCallCheck(this, Mh);

    this[yh] = new Map(), this[xh] = [], this[Ch] = t, this[Ih] = e;
  }

  _createClass(Mh, [{
    key: "evictionThreshold",
    get: function get() {
      return this[Ih];
    },
    set: function set(t) {
      this[Ih] = t, this[_h]();
    }
  }, {
    key: "cache",
    get: function get() {
      return this[Ch];
    }
  }, {
    key: "retainerCount",
    value: function retainerCount(t) {
      return this[Eh].get(t) || 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this[Eh].clear(), this[bh] = [];
    }
  }, {
    key: "retain",
    value: function retain(t) {
      this[Eh].has(t) || this[Eh].set(t, 0), this[Eh].set(t, this[Eh].get(t) + 1);
      var e = this[bh].indexOf(t);
      -1 !== e && this[bh].splice(e, 1), this[bh].unshift(t), this[_h]();
    }
  }, {
    key: "release",
    value: function release(t) {
      this[Eh].has(t) && this[Eh].set(t, Math.max(this[Eh].get(t) - 1, 0)), this[_h]();
    }
  }, {
    key: _ref5,
    value: function value() {
      if (!(this[bh].length < this[Ih])) for (var _t332 = this[bh].length - 1; _t332 >= this[Ih]; --_t332) {
        var _e293 = this[bh][_t332];
        0 === this[Eh].get(_e293) && (this[Ch].delete(_e293), this[bh].splice(_t332, 1));
      }
    }
  }]);

  return Mh;
}((yh = Eh, xh = bh, _h));
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Sh = function Sh(t, e) {
  var n = new Map();

  var _iterator6 = _createForOfIteratorHelper(t.mappings),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _i213 = _step6.value;

      var _iterator7 = _createForOfIteratorHelper(_i213.variants),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _t333 = _step7.value;
          n.set(e[_t333], {
            material: null,
            gltfMaterialIndex: _i213.material
          });
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return n;
},
    Bh = function Bh(t) {
  return "material" in t && t.userData && t.userData.variantMaterials;
};

var Th = /*#__PURE__*/function () {
  function Th(t) {
    _classCallCheck(this, Th);

    this.parser = t, this.name = "KHR_materials_variants";
  }

  _createClass(Th, [{
    key: "afterRoot",
    value: function afterRoot(t) {
      var _this105 = this;

      var e = this.parser,
          n = e.json;
      if (void 0 === n.extensions || void 0 === n.extensions[this.name]) return null;

      var i = function (t) {
        var e = [],
            n = new Set();

        var _iterator8 = _createForOfIteratorHelper(t),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _i214 = _step8.value;
            var _t334 = _i214,
                _r146 = 0;

            for (; n.has(_t334);) {
              _t334 = _i214 + "." + ++_r146;
            }

            n.add(_t334), e.push(_t334);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return e;
      }((n.extensions[this.name].variants || []).map(function (t) {
        return t.name;
      }));

      var _iterator9 = _createForOfIteratorHelper(t.scenes),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _r147 = _step9.value;

          _r147.traverse(function (t) {
            var r = e.associations.get(t);
            if (!r || "nodes" !== r.type) return;
            var s = n.nodes[r.index].mesh;
            if (void 0 === s) return;
            var a = n.meshes[s].primitives,
                o = "isMesh" in t ? [t] : t.children;

            for (var _t335 = 0; _t335 < a.length; _t335++) {
              var _e294 = a[_t335].extensions;
              _e294 && _e294[_this105.name] && (o[_t335].userData.variantMaterials = Sh(_e294[_this105.name], i));
            }
          });
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      t.userData.variants = i, t.userData.functions = t.userData.functions || {};

      var r = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t, n, i) {
          var r, s, _i215;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  t.userData.originalMaterial || (t.userData.originalMaterial = t.material);
                  r = t.material;
                  s = null;

                  if (!(null !== n && t.userData.variantMaterials.has(n))) {
                    _context4.next = 17;
                    break;
                  }

                  _i215 = t.userData.variantMaterials.get(n);

                  if (!_i215.material) {
                    _context4.next = 9;
                    break;
                  }

                  t.material = _i215.material, "gltfMaterialIndex" in _i215 && (s = _i215.gltfMaterialIndex);
                  _context4.next = 15;
                  break;

                case 9:
                  s = _i215.gltfMaterialIndex;
                  _context4.next = 12;
                  return e.getDependency("material", s);

                case 12:
                  t.material = _context4.sent;
                  e.assignFinalMaterial(t);
                  _i215.material = t.material;

                case 15:
                  _context4.next = 18;
                  break;

                case 17:
                  t.material = t.userData.originalMaterial, e.associations.has(t.material) && (s = e.associations.get(t.material).index);

                case 18:
                  null !== i && i(t, r, s);

                case 19:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function r(_x6, _x7, _x8) {
          return _ref6.apply(this, arguments);
        };
      }(),
          s = function s(t) {
        var n = t.material,
            i = t.userData.variantMaterials,
            r = [];

        var _iterator10 = _createForOfIteratorHelper(i.keys()),
            _step10;

        try {
          var _loop3 = function _loop3() {
            var n = _step10.value;
            var s = i.get(n);
            if (s.material) return "continue";
            var a = s.gltfMaterialIndex;
            r.push(e.getDependency("material", a).then(function (r) {
              t.material = r, e.assignFinalMaterial(t), i.get(n).material = t.material;
            }));
          };

          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _ret3 = _loop3();

            if (_ret3 === "continue") continue;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        return Promise.all(r).then(function () {
          t.material = n;
        });
      };

      return t.userData.functions.selectVariant = function (t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var s = [];
        return n ? t.traverse(function (t) {
          return Bh(t) && s.push(r(t, e, i));
        }) : Bh(t) && s.push(r(t, e, i)), Promise.all(s);
      }, t.userData.functions.ensureLoadVariants = function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        var n = [];
        return e ? t.traverse(function (t) {
          return Bh(t) && n.push(s(t));
        }) : Bh(t) && n.push(s(t)), Promise.all(n);
      }, Promise.resolve();
    }
  }]);

  return Th;
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Lh, Rh;
var Dh = new Map(),
    Qh = new Map();
var Ph;
var Fh = new ( /*#__PURE__*/function (_Ko11) {
  _inherits(_class29, _Ko11);

  var _super118 = _createSuper(_class29);

  function _class29(t) {
    var _this106;

    _classCallCheck(this, _class29);

    _this106 = _super118.call(this, t), _this106.decoderPath = "", _this106.decoderConfig = {}, _this106.decoderBinary = null, _this106.decoderPending = null, _this106.workerLimit = 4, _this106.workerPool = [], _this106.workerNextTaskID = 1, _this106.workerSourceURL = "", _this106.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    }, _this106.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
    return _this106;
  }

  _createClass(_class29, [{
    key: "setDecoderPath",
    value: function setDecoderPath(t) {
      return this.decoderPath = t, this;
    }
  }, {
    key: "setDecoderConfig",
    value: function setDecoderConfig(t) {
      return this.decoderConfig = t, this;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      return this.workerLimit = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      var _this107 = this;

      var r = new $o(this.manager);
      r.setPath(this.path), r.setResponseType("arraybuffer"), r.setRequestHeader(this.requestHeader), r.setWithCredentials(this.withCredentials), r.load(t, function (t) {
        var n = {
          attributeIDs: _this107.defaultAttributeIDs,
          attributeTypes: _this107.defaultAttributeTypes,
          useUniqueIDs: !1
        };

        _this107.decodeGeometry(t, n).then(e).catch(i);
      }, n, i);
    }
  }, {
    key: "decodeDracoFile",
    value: function decodeDracoFile(t, e, n, i) {
      var r = {
        attributeIDs: n || this.defaultAttributeIDs,
        attributeTypes: i || this.defaultAttributeTypes,
        useUniqueIDs: !!n
      };
      this.decodeGeometry(t, r).then(e);
    }
  }, {
    key: "decodeGeometry",
    value: function decodeGeometry(t, e) {
      var _this108 = this;

      for (var _t336 in e.attributeTypes) {
        var _n270 = e.attributeTypes[_t336];
        void 0 !== _n270.BYTES_PER_ELEMENT && (e.attributeTypes[_t336] = _n270.name);
      }

      var n = JSON.stringify(e);

      if (Zl.has(t)) {
        var _e295 = Zl.get(t);

        if (_e295.key === n) return _e295.promise;
        if (0 === t.byteLength) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
      }

      var i;

      var r = this.workerNextTaskID++,
          s = t.byteLength,
          a = this._getWorker(r, s).then(function (n) {
        return i = n, new Promise(function (n, s) {
          i._callbacks[r] = {
            resolve: n,
            reject: s
          }, i.postMessage({
            type: "decode",
            id: r,
            taskConfig: e,
            buffer: t
          }, [t]);
        });
      }).then(function (t) {
        return _this108._createGeometry(t.geometry);
      });

      return a.catch(function () {
        return !0;
      }).then(function () {
        i && r && _this108._releaseTask(i, r);
      }), Zl.set(t, {
        key: n,
        promise: a
      }), a;
    }
  }, {
    key: "_createGeometry",
    value: function _createGeometry(t) {
      var e = new cn();
      t.index && e.setIndex(new Xe(t.index.array, 1));

      for (var _n271 = 0; _n271 < t.attributes.length; _n271++) {
        var _i216 = t.attributes[_n271],
            _r148 = _i216.name,
            _s86 = _i216.array,
            _a64 = _i216.itemSize;
        e.setAttribute(_r148, new Xe(_s86, _a64));
      }

      return e;
    }
  }, {
    key: "_loadLibrary",
    value: function _loadLibrary(t, e) {
      var n = new $o(this.manager);
      return n.setPath(this.decoderPath), n.setResponseType(e), n.setWithCredentials(this.withCredentials), new Promise(function (e, i) {
        n.load(t, e, void 0, i);
      });
    }
  }, {
    key: "preload",
    value: function preload() {
      return this._initDecoder(), this;
    }
  }, {
    key: "_initDecoder",
    value: function _initDecoder() {
      var _this109 = this;

      if (this.decoderPending) return this.decoderPending;
      var t = "object" != (typeof WebAssembly === "undefined" ? "undefined" : _typeof(WebAssembly)) || "js" === this.decoderConfig.type,
          e = [];
      return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then(function (e) {
        var n = e[0];
        t || (_this109.decoderConfig.wasmBinary = e[1]);
        var i = $l.toString(),
            r = ["/* draco decoder */", n, "", "/* worker */", i.substring(i.indexOf("{") + 1, i.lastIndexOf("}"))].join("\n");
        _this109.workerSourceURL = URL.createObjectURL(new Blob([r]));
      }), this.decoderPending;
    }
  }, {
    key: "_getWorker",
    value: function _getWorker(t, e) {
      var _this110 = this;

      return this._initDecoder().then(function () {
        if (_this110.workerPool.length < _this110.workerLimit) {
          var _t337 = new Worker(_this110.workerSourceURL);

          _t337._callbacks = {}, _t337._taskCosts = {}, _t337._taskLoad = 0, _t337.postMessage({
            type: "init",
            decoderConfig: _this110.decoderConfig
          }), _t337.onmessage = function (e) {
            var n = e.data;

            switch (n.type) {
              case "decode":
                _t337._callbacks[n.id].resolve(n);

                break;

              case "error":
                _t337._callbacks[n.id].reject(n);

                break;

              default:
                console.error('THREE.DRACOLoader: Unexpected message, "' + n.type + '"');
            }
          }, _this110.workerPool.push(_t337);
        } else _this110.workerPool.sort(function (t, e) {
          return t._taskLoad > e._taskLoad ? -1 : 1;
        });

        var n = _this110.workerPool[_this110.workerPool.length - 1];
        return n._taskCosts[t] = e, n._taskLoad += e, n;
      });
    }
  }, {
    key: "_releaseTask",
    value: function _releaseTask(t, e) {
      t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
  }, {
    key: "debug",
    value: function debug() {
      console.log("Task load: ", this.workerPool.map(function (t) {
        return t._taskLoad;
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var _t338 = 0; _t338 < this.workerPool.length; ++_t338) {
        this.workerPool[_t338].terminate();
      }

      return this.workerPool.length = 0, this;
    }
  }]);

  return _class29;
}(Ko))();
var Nh;
var Uh = new ( /*#__PURE__*/function (_tl) {
  _inherits(_class30, _tl);

  var _super119 = _createSuper(_class30);

  function _class30(t) {
    var _this111;

    _classCallCheck(this, _class30);

    _this111 = _super119.call(this, t), _this111.basisLoader = new dh(t), _this111.zstd = new fh(), _this111.zstd.init(), "undefined" != typeof MSC_TRANSCODER && console.warn('THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.');
    return _this111;
  }

  _createClass(_class30, [{
    key: "setTranscoderPath",
    value: function setTranscoderPath(t) {
      return this.basisLoader.setTranscoderPath(t), this;
    }
  }, {
    key: "setWorkerLimit",
    value: function setWorkerLimit(t) {
      return this.basisLoader.setWorkerLimit(t), this;
    }
  }, {
    key: "detectSupport",
    value: function detectSupport(t) {
      return this.basisLoader.detectSupport(t), this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      return this.basisLoader.dispose(), this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      var r = this,
          s = new Da();
      return new Promise(function (e, i) {
        new $o(r.manager).setPath(r.path).setResponseType("arraybuffer").load(t, e, n, i);
      }).then(function (t) {
        r.parse(t, function (t) {
          s.copy(t), s.needsUpdate = !0, e && e(s);
        }, i);
      }).catch(i), s;
    }
  }, {
    key: "parse",
    value: function parse(t, e, n) {
      var i = this,
          r = function (t) {
        var e = new Uint8Array(t.buffer, t.byteOffset, Zc.length);
        if (e[0] !== Zc[0] || e[1] !== Zc[1] || e[2] !== Zc[2] || e[3] !== Zc[3] || e[4] !== Zc[4] || e[5] !== Zc[5] || e[6] !== Zc[6] || e[7] !== Zc[7] || e[8] !== Zc[8] || e[9] !== Zc[9] || e[10] !== Zc[10] || e[11] !== Zc[11]) throw new Error("Missing KTX 2.0 identifier.");
        var n = new lh(),
            i = 17 * Uint32Array.BYTES_PER_ELEMENT,
            r = new ch(t, Zc.length, i, !0);
        n.vkFormat = r._nextUint32(), n.typeSize = r._nextUint32(), n.pixelWidth = r._nextUint32(), n.pixelHeight = r._nextUint32(), n.pixelDepth = r._nextUint32(), n.layerCount = r._nextUint32(), n.faceCount = r._nextUint32();

        var s = r._nextUint32();

        n.supercompressionScheme = r._nextUint32();

        var a = r._nextUint32(),
            o = r._nextUint32(),
            l = r._nextUint32(),
            c = r._nextUint32(),
            h = r._nextUint64(),
            u = r._nextUint64(),
            d = new ch(t, Zc.length + i, 3 * s * 8, !0);

        for (var _e296 = 0; _e296 < s; _e296++) {
          n.levels.push({
            levelData: new Uint8Array(t.buffer, t.byteOffset + d._nextUint64(), d._nextUint64()),
            uncompressedByteLength: d._nextUint64()
          });
        }

        var p = new ch(t, a, o, !0),
            A = {
          vendorId: p._skip(4)._nextUint16(),
          descriptorType: p._nextUint16(),
          versionNumber: p._nextUint16(),
          descriptorBlockSize: p._nextUint16(),
          colorModel: p._nextUint8(),
          colorPrimaries: p._nextUint8(),
          transferFunction: p._nextUint8(),
          flags: p._nextUint8(),
          texelBlockDimension: {
            x: p._nextUint8() + 1,
            y: p._nextUint8() + 1,
            z: p._nextUint8() + 1,
            w: p._nextUint8() + 1
          },
          bytesPlane: [p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8()],
          samples: []
        },
            m = (A.descriptorBlockSize / 4 - 6) / 4;

        for (var _t339 = 0; _t339 < m; _t339++) {
          A.samples[_t339] = {
            bitOffset: p._nextUint16(),
            bitLength: p._nextUint8(),
            channelID: p._nextUint8(),
            samplePosition: [p._nextUint8(), p._nextUint8(), p._nextUint8(), p._nextUint8()],
            sampleLower: p._nextUint32(),
            sampleUpper: p._nextUint32()
          };
        }

        n.dataFormatDescriptor.length = 0, n.dataFormatDescriptor.push(A);
        var g = new ch(t, l, c, !0);

        for (; g._offset < c;) {
          var _t340 = g._nextUint32(),
              _e297 = g._scan(_t340),
              _i217 = hh(_e297),
              _r149 = g._scan(_t340 - _e297.byteLength);

          n.keyValue[_i217] = _i217.match(/^ktx/i) ? hh(_r149) : _r149, g._offset % 4 && g._skip(4 - g._offset % 4);
        }

        if (u <= 0) return n;

        var f = new ch(t, h, u, !0),
            v = f._nextUint16(),
            y = f._nextUint16(),
            x = f._nextUint32(),
            w = f._nextUint32(),
            E = f._nextUint32(),
            b = f._nextUint32(),
            _ = [];

        for (var _t341 = 0; _t341 < s; _t341++) {
          _.push({
            imageFlags: f._nextUint32(),
            rgbSliceByteOffset: f._nextUint32(),
            rgbSliceByteLength: f._nextUint32(),
            alphaSliceByteOffset: f._nextUint32(),
            alphaSliceByteLength: f._nextUint32()
          });
        }

        var I = h + f._offset,
            C = I + x,
            M = C + w,
            S = M + E,
            B = new Uint8Array(t.buffer, t.byteOffset + I, x),
            T = new Uint8Array(t.buffer, t.byteOffset + C, w),
            L = new Uint8Array(t.buffer, t.byteOffset + M, E),
            R = new Uint8Array(t.buffer, t.byteOffset + S, b);
        return n.globalData = {
          endpointCount: v,
          selectorCount: y,
          imageDescs: _,
          endpointsData: B,
          selectorsData: T,
          tablesData: L,
          extendedData: R
        }, n;
      }(new Uint8Array(t));

      if (r.pixelDepth > 0) throw new Error("THREE.KTX2Loader: Only 2D textures are currently supported.");
      if (r.layerCount > 1) throw new Error("THREE.KTX2Loader: Array textures are not currently supported.");
      if (r.faceCount > 1) throw new Error("THREE.KTX2Loader: Cube textures are not currently supported.");
      var s = wh.getBasicDFD(r);
      return wh.createLevels(r, this.zstd).then(function (t) {
        var e = s.colorModel === eh.UASTC ? dh.BasisFormat.UASTC_4x4 : dh.BasisFormat.ETC1S,
            n = {
          levels: t,
          width: r.pixelWidth,
          height: r.pixelHeight,
          basisFormat: e,
          hasAlpha: wh.getAlpha(r)
        };
        return e === dh.BasisFormat.ETC1S && (n.globalData = r.globalData), i.basisLoader.parseInternalAsync(n);
      }).then(function (t) {
        t.encoding = s.transferFunction === ih.SRGB ? 3001 : 3e3, t.premultiplyAlpha = wh.getPremultiplyAlpha(r), e(t);
      }).catch(n), this;
    }
  }]);

  return _class30;
}(tl))(),
    kh = Symbol("loader"),
    Gh = Symbol("evictionPolicy"),
    Oh = Symbol("GLTFInstance");

var Hh = /*#__PURE__*/function (_tt8, _ref7) {
  _inherits(Hh, _tt8);

  var _super120 = _createSuper(Hh);

  function Hh(t) {
    var _this112;

    _classCallCheck(this, Hh);

    _this112 = _super120.call(this), _this112[Rh] = new tc().register(function (t) {
      return new Th(t);
    }), _this112[Oh] = t, _this112[kh].setDRACOLoader(Fh), _this112[kh].setKTX2Loader(Uh);
    return _this112;
  }

  _createClass(Hh, [{
    key: _ref7,
    get: function get() {
      return this.constructor[Gh];
    }
  }, {
    key: "preload",
    value: function () {
      var _preload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t, e) {
        var n,
            _e298,
            _i218,
            _r150,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                n = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : function () {};

                if (this.dispatchEvent({
                  type: "preload",
                  element: e,
                  src: t
                }), !Dh.has(t)) {
                  _e298 = function (t, e) {
                    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

                    var i = function i(t) {
                      var e = t.loaded / t.total;
                      n(Math.max(0, Math.min(1, isFinite(e) ? e : 1)));
                    };

                    return new Promise(function (n, r) {
                      e.load(t, n, i, r);
                    });
                  }(t, this[kh], function (t) {
                    n(.8 * t);
                  }), _i218 = this[Oh], _r150 = _e298.then(function (t) {
                    return _i218.prepare(t);
                  }).then(function (t) {
                    return n(.9), new _i218(t);
                  });
                  Dh.set(t, _r150);
                }

                _context5.next = 4;
                return Dh.get(t);

              case 4:
                Qh.set(t, !0);
                n && n(1);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function preload(_x9, _x10) {
        return _preload.apply(this, arguments);
      }

      return preload;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t, e) {
        var _this113 = this;

        var n,
            i,
            r,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                n = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : function () {};
                _context6.next = 3;
                return this.preload(t, e, n);

              case 3:
                _context6.next = 5;
                return Dh.get(t);

              case 5:
                i = _context6.sent;
                _context6.next = 8;
                return i.clone();

              case 8:
                r = _context6.sent;
                return _context6.abrupt("return", (this[Gh].retain(t), r.dispose = function () {
                  var e = r.dispose;
                  var n = !1;
                  return function () {
                    n || (n = !0, e.apply(r), _this113[Gh].release(t));
                  };
                }(), r));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function load(_x11, _x12) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }], [{
    key: "setDRACODecoderLocation",
    value: function setDRACODecoderLocation(t) {
      Ph = t, Fh.setDecoderPath(t);
    }
  }, {
    key: "getDRACODecoderLocation",
    value: function getDRACODecoderLocation() {
      return Ph;
    }
  }, {
    key: "setKTX2TranscoderLocation",
    value: function setKTX2TranscoderLocation(t) {
      Nh = t, Uh.setTranscoderPath(t);
    }
  }, {
    key: "getKTX2TranscoderLocation",
    value: function getKTX2TranscoderLocation() {
      return Nh;
    }
  }, {
    key: "initializeKTX2Loader",
    value: function initializeKTX2Loader(t) {
      Uh.detectSupport(t);
    }
  }, {
    key: "cache",
    get: function get() {
      return Dh;
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      var _this114 = this;

      Dh.forEach(function (t, e) {
        _this114.delete(e);
      }), this[Gh].reset();
    }
  }, {
    key: "has",
    value: function has(t) {
      return Dh.has(t);
    }
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.has(t)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                e = Dh.get(t);
                Qh.delete(t), Dh.delete(t);
                _context7.next = 6;
                return e;

              case 6:
                _context7.sent.dispose();

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x13) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "hasFinishedLoading",
    value: function hasFinishedLoading(t) {
      return !!Qh.get(t);
    }
  }]);

  return Hh;
}(tt, (Lh = Gh, Rh = kh, Gh));

Hh[Lh] = new Mh(Hh);

var zh = /*#__PURE__*/function (_Ce13) {
  _inherits(zh, _Ce13);

  var _super121 = _createSuper(zh);

  function zh(t) {
    var _this115;

    _classCallCheck(this, zh);

    _this115 = _super121.call(this), _this115.element = t || document.createElement("div"), _this115.element.style.position = "absolute", _this115.element.style.userSelect = "none", _this115.element.setAttribute("draggable", !1), _this115.addEventListener("removed", function () {
      this.traverse(function (t) {
        t.element instanceof Element && null !== t.element.parentNode && t.element.parentNode.removeChild(t.element);
      });
    });
    return _this115;
  }

  _createClass(zh, [{
    key: "copy",
    value: function copy(t, e) {
      return _get(_getPrototypeOf(zh.prototype), "copy", this).call(this, t, e), this.element = t.element.cloneNode(!0), this;
    }
  }]);

  return zh;
}(Ce);

zh.prototype.isCSS2DObject = !0;
var Vh = new _t(),
    Wh = new ee(),
    qh = new ee(),
    jh = new _t(),
    Yh = new _t();

var Jh = /*#__PURE__*/_createClass(function Jh() {
  _classCallCheck(this, Jh);

  var t = this;
  var e, n, i, r;
  var s = {
    objects: new WeakMap()
  },
      a = document.createElement("div");

  function o(e, n, c) {
    if (e.isCSS2DObject) {
      e.onBeforeRender(t, n, c), Vh.setFromMatrixPosition(e.matrixWorld), Vh.applyMatrix4(qh);
      var _o39 = e.element;
      /apple/i.test(navigator.vendor) ? _o39.style.transform = "translate(-50%,-50%) translate(" + Math.round(Vh.x * i + i) + "px," + Math.round(-Vh.y * r + r) + "px)" : _o39.style.transform = "translate(-50%,-50%) translate(" + (Vh.x * i + i) + "px," + (-Vh.y * r + r) + "px)", _o39.style.display = e.visible && Vh.z >= -1 && Vh.z <= 1 ? "" : "none";
      var _h14 = {
        distanceToCameraSquared: l(c, e)
      };
      s.objects.set(e, _h14), _o39.parentNode !== a && a.appendChild(_o39), e.onAfterRender(t, n, c);
    }

    for (var _t342 = 0, _i219 = e.children.length; _t342 < _i219; _t342++) {
      o(e.children[_t342], n, c);
    }
  }

  function l(t, e) {
    return jh.setFromMatrixPosition(t.matrixWorld), Yh.setFromMatrixPosition(e.matrixWorld), jh.distanceToSquared(Yh);
  }

  a.style.overflow = "hidden", this.domElement = a, this.getSize = function () {
    return {
      width: e,
      height: n
    };
  }, this.render = function (t, e) {
    !0 === t.autoUpdate && t.updateMatrixWorld(), null === e.parent && e.updateMatrixWorld(), Wh.copy(e.matrixWorldInverse), qh.multiplyMatrices(e.projectionMatrix, Wh), o(t, t, e), function (t) {
      var e = function (t) {
        var e = [];
        return t.traverse(function (t) {
          t.isCSS2DObject && e.push(t);
        }), e;
      }(t).sort(function (t, e) {
        return s.objects.get(t).distanceToCameraSquared - s.objects.get(e).distanceToCameraSquared;
      }),
          n = e.length;

      for (var _t343 = 0, _i220 = e.length; _t343 < _i220; _t343++) {
        e[_t343].element.style.zIndex = n - _t343;
      }
    }(t);
  }, this.setSize = function (t, s) {
    e = t, n = s, i = e / 2, r = n / 2, a.style.width = t + "px", a.style.height = s + "px";
  };
});
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xh = function Xh(t) {
  return t && "null" !== t ? Zh(t) : null;
},
    Kh = function Kh() {
  if (q) return;
  var t = [];
  throw H || t.push("WebXR Device API"), z || t.push("WebXR Hit Test API"), new Error("The following APIs are required for AR, but are missing in this browser: ".concat(t.join(", ")));
},
    Zh = function Zh(t) {
  return new URL(t, window.location.toString()).toString();
},
    $h = function $h(t, e) {
  var n = null;
  return function () {
    for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
      i[_key] = arguments[_key];
    }

    null != n && self.clearTimeout(n), n = self.setTimeout(function () {
      n = null, t.apply(void 0, i);
    }, e);
  };
},
    tu = function tu(t, e, n) {
  return Math.max(e, Math.min(n, t));
},
    eu = function () {
  var t = function () {
    var t = null != document.head ? Array.from(document.head.querySelectorAll("meta")) : [];

    var _iterator11 = _createForOfIteratorHelper(t),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var _e299 = _step11.value;
        if ("viewport" === _e299.name) return !0;
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }

    return !1;
  }();

  return t || console.warn('No <meta name="viewport"> detected; <model-viewer> will cap pixel density at 1.'), function () {
    return t ? window.devicePixelRatio : 1;
  };
}(),
    nu = function () {
  var t = new RegExp("[?&]model-viewer-debug-mode(&|$)");
  return function () {
    return self.ModelViewerElement && self.ModelViewerElement.debugMode || self.location && self.location.search && self.location.search.match(t);
  };
}();

var iu = /*#__PURE__*/function () {
  function iu() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

    _classCallCheck(this, iu);

    this.velocity = 0, this.naturalFrequency = 0, this.setDecayTime(t);
  }

  _createClass(iu, [{
    key: "setDecayTime",
    value: function setDecayTime(t) {
      this.naturalFrequency = 1 / Math.max(.001, t);
    }
  }, {
    key: "update",
    value: function update(t, e, n, i) {
      var r = 2e-4 * this.naturalFrequency;
      if (null == t || 0 === i) return e;
      if (t === e && 0 === this.velocity) return e;
      if (n < 0) return t;
      var s = t - e,
          a = this.velocity + this.naturalFrequency * s,
          o = s + n * a,
          l = Math.exp(-this.naturalFrequency * n),
          c = (a - this.naturalFrequency * o) * l,
          h = -this.naturalFrequency * (c + a * l);
      return Math.abs(c) < r * Math.abs(i) && h * s >= 0 ? (this.velocity = 0, e) : (this.velocity = c, e + o * l);
    }
  }]);

  return iu;
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ru = function ru(t, e) {
  return {
    type: "number",
    number: t,
    unit: e
  };
},
    su = function () {
  var t = {};
  return function (e) {
    var n = e;
    if (n in t) return t[n];
    var i = [];
    var r = 0;

    for (; e;) {
      if (++r > 1e3) {
        e = "";
        break;
      }

      var _t344 = au(e),
          _n272 = _t344.nodes[0];

      if (null == _n272 || 0 === _n272.terms.length) break;
      i.push(_n272), e = _t344.remainingInput;
    }

    return t[n] = i;
  };
}(),
    au = function () {
  var t = /^(\-\-|[a-z\u0240-\uffff])/i,
      e = /^([\*\+\/]|[\-]\s)/i,
      n = /^[\),]/;
  return function (i) {
    var r = [];

    for (; i.length && (i = i.trim(), !n.test(i));) {
      if ("(" === i[0]) {
        var _hu = hu(i),
            _t345 = _hu.nodes,
            _e300 = _hu.remainingInput;

        i = _e300, r.push({
          type: "function",
          name: {
            type: "ident",
            value: "calc"
          },
          arguments: _t345
        });
      } else if (t.test(i)) {
        var _t346 = ou(i),
            _e301 = _t346.nodes[0];

        if ("(" === (i = _t346.remainingInput)[0]) {
          var _hu2 = hu(i),
              _t347 = _hu2.nodes,
              _n273 = _hu2.remainingInput;

          r.push({
            type: "function",
            name: _e301,
            arguments: _t347
          }), i = _n273;
        } else r.push(_e301);
      } else if (e.test(i)) r.push({
        type: "operator",
        value: i[0]
      }), i = i.slice(1);else {
        var _ref8 = "#" === i[0] ? cu(i) : lu(i),
            _t348 = _ref8.nodes,
            _e302 = _ref8.remainingInput;

        if (0 === _t348.length) break;
        r.push(_t348[0]), i = _e302;
      }
    }

    return {
      nodes: [{
        type: "expression",
        terms: r
      }],
      remainingInput: i
    };
  };
}(),
    ou = function () {
  var t = /[^a-z0-9_\-\u0240-\uffff]/i;
  return function (e) {
    var n = e.match(t);
    return {
      nodes: [{
        type: "ident",
        value: null == n ? e : e.substr(0, n.index)
      }],
      remainingInput: null == n ? "" : e.substr(n.index)
    };
  };
}(),
    lu = function () {
  var t = /[\+\-]?(\d+[\.]\d+|\d+|[\.]\d+)([eE][\+\-]?\d+)?/,
      e = /^[a-z%]+/i,
      n = /^(m|mm|cm|rad|deg|[%])$/;
  return function (i) {
    var r = i.match(t),
        s = null == r ? "0" : r[0],
        a = (i = null == s ? i : i.slice(s.length)).match(e);
    var o = null != a && "" !== a[0] ? a[0] : null;
    var l = null == a ? i : i.slice(o.length);
    return null == o || n.test(o) || (o = null), {
      nodes: [{
        type: "number",
        number: parseFloat(s) || 0,
        unit: o
      }],
      remainingInput: l
    };
  };
}(),
    cu = function () {
  var t = /^[a-f0-9]*/i;
  return function (e) {
    var n = (e = e.slice(1).trim()).match(t);
    return {
      nodes: null == n ? [] : [{
        type: "hex",
        value: n[0]
      }],
      remainingInput: null == n ? e : e.slice(n[0].length)
    };
  };
}(),
    hu = function hu(t) {
  var e = [];

  for (t = t.slice(1).trim(); t.length;) {
    var _n274 = au(t);

    if (e.push(_n274.nodes[0]), "," === (t = _n274.remainingInput.trim())[0]) t = t.slice(1).trim();else if (")" === t[0]) {
      t = t.slice(1);
      break;
    }
  }

  return {
    nodes: e,
    remainingInput: t
  };
},
    uu = Symbol("visitedTypes");

var du = /*#__PURE__*/function () {
  function du(t) {
    _classCallCheck(this, du);

    this[uu] = t;
  }

  _createClass(du, [{
    key: "walk",
    value: function walk(t, e) {
      var n = t.slice();

      for (; n.length;) {
        var _t349 = n.shift();

        switch (this[uu].indexOf(_t349.type) > -1 && e(_t349), _t349.type) {
          case "expression":
            n.unshift.apply(n, _toConsumableArray(_t349.terms));
            break;

          case "function":
            n.unshift.apply(n, [_t349.name].concat(_toConsumableArray(_t349.arguments)));
        }
      }
    }
  }]);

  return du;
}();

var pu = Object.freeze({
  type: "number",
  number: 0,
  unit: null
}),
    Au = function Au(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = t.number,
      i = t.unit;

  if (isFinite(n)) {
    if ("rad" === t.unit || null == t.unit) return t;
  } else n = e, i = "rad";

  return {
    type: "number",
    number: ("deg" === i && null != n ? n : 0) * Math.PI / 180,
    unit: "rad"
  };
},
    mu = function mu(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n,
      i = t.number,
      r = t.unit;

  if (isFinite(i)) {
    if ("m" === t.unit) return t;
  } else i = e, r = "m";

  switch (r) {
    default:
      n = 1;
      break;

    case "cm":
      n = .01;
      break;

    case "mm":
      n = .001;
  }

  return {
    type: "number",
    number: n * i,
    unit: "m"
  };
},
    gu = function () {
  var t = function t(_t350) {
    return _t350;
  },
      e = {
    rad: t,
    deg: Au,
    m: t,
    mm: mu,
    cm: mu
  };

  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pu;
    isFinite(t.number) || (t.number = n.number, t.unit = n.unit);
    var i = t.unit;
    if (null == i) return t;
    var r = e[i];
    return null == r ? n : r(t);
  };
}();
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var fu = /*#__PURE__*/function (_zh) {
  _inherits(fu, _zh);

  var _super122 = _createSuper(fu);

  function fu(t) {
    var _this116;

    _classCallCheck(this, fu);

    _this116 = _super122.call(this, document.createElement("div")), _this116.normal = new _t(0, 1, 0), _this116.initialized = !1, _this116.referenceCount = 1, _this116.pivot = document.createElement("div"), _this116.slot = document.createElement("slot"), _this116.element.classList.add("annotation-wrapper"), _this116.slot.name = t.name, _this116.element.appendChild(_this116.pivot), _this116.pivot.appendChild(_this116.slot), _this116.updatePosition(t.position), _this116.updateNormal(t.normal);
    return _this116;
  }

  _createClass(fu, [{
    key: "facingCamera",
    get: function get() {
      return !this.element.classList.contains("hide");
    }
  }, {
    key: "show",
    value: function show() {
      this.facingCamera && this.initialized || this.updateVisibility(!0);
    }
  }, {
    key: "hide",
    value: function hide() {
      !this.facingCamera && this.initialized || this.updateVisibility(!1);
    }
  }, {
    key: "increment",
    value: function increment() {
      this.referenceCount++;
    }
  }, {
    key: "decrement",
    value: function decrement() {
      return this.referenceCount > 0 && --this.referenceCount, 0 === this.referenceCount;
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(t) {
      if (null == t) return;
      var e = su(t)[0].terms;

      for (var _t351 = 0; _t351 < 3; ++_t351) {
        this.position.setComponent(_t351, gu(e[_t351]).number);
      }

      this.updateMatrixWorld();
    }
  }, {
    key: "updateNormal",
    value: function updateNormal(t) {
      if (null == t) return;
      var e = su(t)[0].terms;

      for (var _t352 = 0; _t352 < 3; ++_t352) {
        this.normal.setComponent(_t352, gu(e[_t352]).number);
      }
    }
  }, {
    key: "orient",
    value: function orient(t) {
      this.pivot.style.transform = "rotate(".concat(t, "rad)");
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility(t) {
      t ? this.element.classList.remove("hide") : this.element.classList.add("hide"), this.slot.assignedNodes().forEach(function (e) {
        if (e.nodeType !== Node.ELEMENT_NODE) return;
        var n = e,
            i = n.dataset.visibilityAttribute;

        if (null != i) {
          var _e303 = "data-".concat(i);

          t ? n.setAttribute(_e303, "") : n.removeAttribute(_e303);
        }

        n.dispatchEvent(new CustomEvent("hotspot-visibility", {
          detail: {
            visible: t
          }
        }));
      }), this.initialized = !0;
    }
  }]);

  return fu;
}(zh);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var vu = function vu(t, e, n) {
  var i = n;
  var r = new _t();
  return t.traverse(function (t) {
    var n, s;
    t.updateWorldMatrix(!1, !1);
    var a = t.geometry;
    if (void 0 !== a) if (a.isGeometry) {
      var _o40 = a.vertices;

      for (n = 0, s = _o40.length; n < s; n++) {
        r.copy(_o40[n]), r.applyMatrix4(t.matrixWorld), i = e(i, r);
      }
    } else if (a.isBufferGeometry) {
      var _o41 = a.attributes.position;

      if (void 0 !== _o41) {
        var _a65 = function (t) {
          if (!t.normalized) return 1;
          var e = t.array;
          return e instanceof Int8Array ? 1 / 127 : e instanceof Uint8Array ? 1 / 255 : e instanceof Int16Array ? 1 / 32767 : e instanceof Uint16Array ? 1 / 65535 : 1;
        }(_o41);

        for (n = 0, s = _o41.count; n < s; n++) {
          r.fromBufferAttribute(_o41, n), r.multiplyScalar(_a65), r.applyMatrix4(t.matrixWorld), i = e(i, r);
        }
      }
    }
  }), i;
};

var yu = /*#__PURE__*/function (_wl) {
  _inherits(yu, _wl);

  var _super123 = _createSuper(yu);

  function yu(t, e, n) {
    var _this117;

    _classCallCheck(this, yu);

    _this117 = _super123.call(this), _this117.shadowMaterial = new Lo(), _this117.boundingBox = new Mt(), _this117.size = new _t(), _this117.shadowScale = 1, _this117.isAnimated = !1, _this117.side = "bottom", _this117.needsUpdate = !1, _this117.intensity = 0, _this117.castShadow = !0, _this117.frustumCulled = !1, _this117.floor = new Mn(new Yn(), _this117.shadowMaterial), _this117.floor.rotateX(-Math.PI / 2), _this117.floor.receiveShadow = !0, _this117.floor.castShadow = !1, _this117.floor.frustumCulled = !1, _this117.add(_this117.floor), t.target.add(_assertThisInitialized(_this117)), _this117.target = t.target, _this117.setScene(t, e, n);
    return _this117;
  }

  _createClass(yu, [{
    key: "setScene",
    value: function setScene(t, e, n) {
      if (this.side = n, this.isAnimated = t.animationNames.length > 0, this.boundingBox.copy(t.boundingBox), this.size.copy(t.size), "back" === this.side) {
        var _ref9, _ref10, _ref11;

        var _this$boundingBox = this.boundingBox,
            _t353 = _this$boundingBox.min,
            _e304 = _this$boundingBox.max;
        (_ref9 = [_t353.z, _t353.y], _t353.y = _ref9[0], _t353.z = _ref9[1], _ref9), (_ref10 = [_e304.z, _e304.y], _e304.y = _ref10[0], _e304.z = _ref10[1], _ref10), (_ref11 = [this.size.z, this.size.y], this.size.y = _ref11[0], this.size.z = _ref11[1], _ref11), this.rotation.x = Math.PI / 2, this.rotation.y = Math.PI;
      }

      var i = this.boundingBox,
          r = this.size;

      if (this.isAnimated) {
        var _t354 = 2 * Math.max(r.x, r.y, r.z);

        r.y = _t354, i.expandByVector(r.subScalar(_t354).multiplyScalar(-.5)), i.max.y = i.min.y + _t354, r.set(_t354, _t354, _t354);
      }

      i.getCenter(this.floor.position);
      var s = i.max.y + .002 * r.y;
      "bottom" === n ? (this.position.y = s, this.shadow.camera.up.set(0, 0, 1)) : (this.position.y = 0, this.position.z = s, this.shadow.camera.up.set(0, 1, 0)), this.setSoftness(e);
    }
  }, {
    key: "setSoftness",
    value: function setSoftness(t) {
      var e = Math.pow(2, 9 - 3 * t);
      this.setMapSize(e);
    }
  }, {
    key: "setMapSize",
    value: function setMapSize(t) {
      var _this$shadow = this.shadow,
          e = _this$shadow.camera,
          n = _this$shadow.mapSize,
          i = _this$shadow.map,
          r = this.size,
          s = this.boundingBox;
      null != i && (i.dispose(), this.shadow.map = null), this.isAnimated && (t *= 2);
      var a = Math.floor(r.x > r.z ? t : t * r.x / r.z),
          o = Math.floor(r.x > r.z ? t * r.z / r.x : t);
      n.set(a, o);
      var l = 2.5 * r.x / a,
          c = 2.5 * r.z / o;
      e.left = -s.max.x - l, e.right = -s.min.x + l, e.bottom = s.min.z - c, e.top = s.max.z + c, this.setScaleAndOffset(this.shadowScale, 0), this.floor.scale.set(r.x + 2 * l, r.z + 2 * c, 1), this.needsUpdate = !0;
    }
  }, {
    key: "setIntensity",
    value: function setIntensity(t) {
      this.shadowMaterial.opacity = t, t > 0 ? (this.visible = !0, this.floor.visible = !0) : (this.visible = !1, this.floor.visible = !1);
    }
  }, {
    key: "getIntensity",
    value: function getIntensity() {
      return this.shadowMaterial.opacity;
    }
  }, {
    key: "setRotation",
    value: function setRotation(t) {
      "bottom" === this.side ? (this.shadow.camera.up.set(Math.sin(t), 0, Math.cos(t)), this.shadow.updateMatrices(this)) : this.shadow.updateMatrices(this);
    }
  }, {
    key: "setScaleAndOffset",
    value: function setScaleAndOffset(t, e) {
      var n = this.size.y,
          i = this.shadow.camera;
      this.shadowScale = t, i.near = 0, i.far = n - e / t, i.updateProjectionMatrix(), i.scale.setScalar(t);
      var r = .002 * n;
      this.floor.position.y = 2 * r - i.far;
    }
  }]);

  return yu;
}(wl);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xu = 22.5 * Math.PI / 180,
    wu = Math.sin(xu),
    Eu = Math.tan(xu),
    bu = new _t(),
    _u = new _t(),
    Iu = new _t(),
    Cu = new ( /*#__PURE__*/function () {
  function _class31(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / 0;

    _classCallCheck(this, _class31);

    this.ray = new te(t, e), this.near = n, this.far = i, this.camera = null, this.layers = new de(), this.params = {
      Mesh: {},
      Line: {
        threshold: 1
      },
      LOD: {},
      Points: {
        threshold: 1
      },
      Sprite: {}
    };
  }

  _createClass(_class31, [{
    key: "set",
    value: function set(t, e) {
      this.ray.set(t, e);
    }
  }, {
    key: "setFromCamera",
    value: function setFromCamera(t, e) {
      e && e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e && e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
  }, {
    key: "intersectObject",
    value: function intersectObject(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return Hl(t, this, n, e), n.sort(Ol), n;
    }
  }, {
    key: "intersectObjects",
    value: function intersectObjects(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      for (var _i221 = 0, _r151 = t.length; _i221 < _r151; _i221++) {
        Hl(t[_i221], this, n, e);
      }

      return n.sort(Ol), n;
    }
  }]);

  return _class31;
}())(),
    Mu = new _t();

var Su = /*#__PURE__*/function (_Ps) {
  _inherits(Su, _Ps);

  var _super124 = _createSuper(Su);

  function Su(_ref12) {
    var _this118;

    var t = _ref12.canvas,
        e = _ref12.element,
        n = _ref12.width,
        i = _ref12.height;

    _classCallCheck(this, Su);

    _this118 = _super124.call(this), _this118.context = null, _this118.annotationRenderer = new Jh(), _this118.width = 1, _this118.height = 1, _this118.aspect = 1, _this118.isDirty = !1, _this118.renderCount = 0, _this118.externalRenderer = null, _this118.camera = new Pn(45, 1, .1, 100), _this118.xrCamera = null, _this118.url = null, _this118.target = new Ce(), _this118.modelContainer = new Ce(), _this118.animationNames = [], _this118.boundingBox = new Mt(), _this118.size = new _t(), _this118.idealCameraDistance = 0, _this118.fieldOfViewAspect = 0, _this118.framedFieldOfView = 45, _this118.shadow = null, _this118.shadowIntensity = 0, _this118.shadowSoftness = 1, _this118.exposure = 1, _this118.canScale = !0, _this118.tightBounds = !1, _this118.goalTarget = new _t(), _this118.targetDamperX = new iu(), _this118.targetDamperY = new iu(), _this118.targetDamperZ = new iu(), _this118._currentGLTF = null, _this118.cancelPendingSourceChange = null, _this118.animationsByName = new Map(), _this118.currentAnimationAction = null, _this118.name = "ModelScene", _this118.element = e, _this118.canvas = t, _this118.camera = new Pn(45, 1, .1, 100), _this118.camera.name = "MainCamera", _this118.add(_this118.target), _this118.setSize(n, i), _this118.target.name = "Target", _this118.modelContainer.name = "ModelContainer", _this118.target.add(_this118.modelContainer), _this118.mixer = new Gl(_this118.modelContainer);
    var r = _this118.annotationRenderer.domElement,
        s = r.style;
    s.display = "none", s.pointerEvents = "none", s.position = "absolute", s.top = "0", _this118.element.shadowRoot.querySelector(".default").appendChild(r);
    return _this118;
  }

  _createClass(Su, [{
    key: "createContext",
    value: function createContext() {
      this.context = this.canvas.getContext("2d");
    }
  }, {
    key: "getCamera",
    value: function getCamera() {
      return null != this.xrCamera ? this.xrCamera : this.camera;
    }
  }, {
    key: "setObject",
    value: function () {
      var _setObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.reset();
                this.modelContainer.add(t);
                _context8.next = 4;
                return this.setupScene();

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setObject(_x14) {
        return _setObject.apply(this, arguments);
      }

      return setObject;
    }()
  }, {
    key: "setSource",
    value: function () {
      var _setSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t) {
        var _this119 = this;

        var e,
            _t355,
            n,
            _n275,
            i,
            r,
            s,
            _iterator12,
            _step12,
            _t356,
            _args10 = arguments;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                e = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : function () {};

                if (!(!t || t === this.url)) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return", void e(1));

              case 3:
                if (!(this.reset(), this.url = t, null != this.externalRenderer)) {
                  _context10.next = 8;
                  break;
                }

                _context10.next = 6;
                return this.externalRenderer.load(e);

              case 6:
                _t355 = _context10.sent;
                return _context10.abrupt("return", (this.idealCameraDistance = _t355.framedRadius / wu, this.fieldOfViewAspect = _t355.fieldOfViewAspect, this.frameModel(), void this.dispatchEvent({
                  type: "model-load",
                  url: this.url
                })));

              case 8:
                null != this.cancelPendingSourceChange && (this.cancelPendingSourceChange(), this.cancelPendingSourceChange = null);
                _context10.prev = 9;
                _context10.next = 12;
                return new Promise( /*#__PURE__*/function () {
                  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(n, i) {
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _this119.cancelPendingSourceChange = function () {
                              return i();
                            };

                            _context9.prev = 1;
                            _context9.t0 = n;
                            _context9.next = 5;
                            return _this119.element[wp].loader.load(t, _this119.element, e);

                          case 5:
                            _context9.t1 = _context9.sent;
                            (0, _context9.t0)(_context9.t1);
                            _context9.next = 12;
                            break;

                          case 9:
                            _context9.prev = 9;
                            _context9.t2 = _context9["catch"](1);
                            i(_context9.t2);

                          case 12:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, null, [[1, 9]]);
                  }));

                  return function (_x16, _x17) {
                    return _ref13.apply(this, arguments);
                  };
                }());

              case 12:
                n = _context10.sent;
                _context10.next = 20;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10["catch"](9);

                if (!(null == _context10.t0)) {
                  _context10.next = 19;
                  break;
                }

                return _context10.abrupt("return");

              case 19:
                throw _context10.t0;

              case 20:
                this.reset(), this.url = t, this._currentGLTF = n, null != n && this.modelContainer.add(n.scene);
                _n275 = n, i = _n275.animations, r = new Map(), s = [];
                _iterator12 = _createForOfIteratorHelper(i);

                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    _t356 = _step12.value;
                    r.set(_t356.name, _t356), s.push(_t356.name);
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }

                this.animations = i;
                this.animationsByName = r;
                this.animationNames = s;
                _context10.next = 29;
                return this.setupScene();

              case 29:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[9, 15]]);
      }));

      function setSource(_x15) {
        return _setSource.apply(this, arguments);
      }

      return setSource;
    }()
  }, {
    key: "setupScene",
    value: function () {
      var _setupScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var t;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.updateBoundingBox();
                t = null;
                _context11.t0 = !0 === this.tightBounds;

                if (!_context11.t0) {
                  _context11.next = 7;
                  break;
                }

                _context11.next = 6;
                return this.element.requestUpdate("cameraTarget");

              case 6:
                t = this.getTarget();

              case 7:
                this.updateFraming(t);
                this.frameModel();
                this.setShadowIntensity(this.shadowIntensity);
                this.dispatchEvent({
                  type: "model-load",
                  url: this.url
                });

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setupScene() {
        return _setupScene.apply(this, arguments);
      }

      return setupScene;
    }()
  }, {
    key: "reset",
    value: function reset() {
      this.url = null, this.isDirty = !0, null != this.shadow && this.shadow.setIntensity(0);
      var t = this._currentGLTF;

      if (null != t) {
        var _iterator13 = _createForOfIteratorHelper(this.modelContainer.children),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _t357 = _step13.value;
            this.modelContainer.remove(_t357);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }

        t.dispose(), this._currentGLTF = null;
      }

      null != this.currentAnimationAction && (this.currentAnimationAction.stop(), this.currentAnimationAction = null), this.mixer.stopAllAction(), this.mixer.uncacheRoot(this);
    }
  }, {
    key: "currentGLTF",
    get: function get() {
      return this._currentGLTF;
    }
  }, {
    key: "setSize",
    value: function setSize(t, e) {
      if (this.width !== t || this.height !== e) {
        if (this.width = Math.max(t, 1), this.height = Math.max(e, 1), this.annotationRenderer.setSize(t, e), this.aspect = this.width / this.height, this.frameModel(), null != this.externalRenderer) {
          var n = eu();
          this.externalRenderer.resize(t * n, e * n);
        }

        this.isDirty = !0;
      }
    }
  }, {
    key: "updateBoundingBox",
    value: function updateBoundingBox() {
      if (this.target.remove(this.modelContainer), !0 === this.tightBounds) {
        var _t358 = function _t358(t, e) {
          return t.expandByPoint(e);
        };

        this.boundingBox = vu(this.modelContainer, _t358, new Mt());
      } else this.boundingBox.setFromObject(this.modelContainer);

      this.boundingBox.getSize(this.size), this.target.add(this.modelContainer);
    }
  }, {
    key: "updateFraming",
    value: function updateFraming() {
      var _this120 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.target.remove(this.modelContainer), null == t && (t = this.boundingBox.getCenter(new _t()));
      var e = Math.sqrt(vu(this.modelContainer, function (e, n) {
        return Math.max(e, t.distanceToSquared(n));
      }, 0));
      this.idealCameraDistance = e / wu;
      this.fieldOfViewAspect = vu(this.modelContainer, function (e, n) {
        n.sub(t);
        var i = Math.sqrt(n.x * n.x + n.z * n.z);
        return Math.max(e, i / (_this120.idealCameraDistance - Math.abs(n.y)));
      }, 0) / Eu, this.target.add(this.modelContainer);
    }
  }, {
    key: "frameModel",
    value: function frameModel() {
      var t = Eu * Math.max(1, this.fieldOfViewAspect / this.aspect);
      this.framedFieldOfView = 2 * Math.atan(t) * 180 / Math.PI;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return {
        width: this.width,
        height: this.height
      };
    }
  }, {
    key: "setTarget",
    value: function setTarget(t, e, n) {
      this.goalTarget.set(-t, -e, -n);
    }
  }, {
    key: "setTargetDamperDecayTime",
    value: function setTargetDamperDecayTime(t) {
      this.targetDamperX.setDecayTime(t), this.targetDamperY.setDecayTime(t), this.targetDamperZ.setDecayTime(t);
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      return Mu.copy(this.goalTarget).multiplyScalar(-1);
    }
  }, {
    key: "jumpToGoal",
    value: function jumpToGoal() {
      this.updateTarget(1e4);
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(t) {
      var e = this.goalTarget,
          n = this.target.position;

      if (!e.equals(n)) {
        var _i222 = this.idealCameraDistance;
        var _r152 = n.x,
            _s87 = n.y,
            _a66 = n.z;
        _r152 = this.targetDamperX.update(_r152, e.x, t, _i222), _s87 = this.targetDamperY.update(_s87, e.y, t, _i222), _a66 = this.targetDamperZ.update(_a66, e.z, t, _i222), this.target.position.set(_r152, _s87, _a66), this.target.updateMatrixWorld(), this.setShadowRotation(this.yaw), this.isDirty = !0;
      }
    }
  }, {
    key: "pointTowards",
    value: function pointTowards(t, e) {
      var _this$position = this.position,
          n = _this$position.x,
          i = _this$position.z;
      this.yaw = Math.atan2(t - n, e - i);
    }
  }, {
    key: "yaw",
    get: function get() {
      return this.rotation.y;
    },
    set: function set(t) {
      this.rotation.y = t, this.updateMatrixWorld(!0), this.setShadowRotation(t), this.isDirty = !0;
    }
  }, {
    key: "animationTime",
    get: function get() {
      return null != this.currentAnimationAction ? this.currentAnimationAction.time : 0;
    },
    set: function set(t) {
      this.mixer.setTime(t);
    }
  }, {
    key: "duration",
    get: function get() {
      return null != this.currentAnimationAction && this.currentAnimationAction.getClip() ? this.currentAnimationAction.getClip().duration : 0;
    }
  }, {
    key: "hasActiveAnimation",
    get: function get() {
      return null != this.currentAnimationAction;
    }
  }, {
    key: "playAnimation",
    value: function playAnimation() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (null == this._currentGLTF) return;
      var n = this.animations;
      if (null == n || 0 === n.length) return void console.warn("Cannot play animation (model does not have any animations)");
      var i = null;
      null != t && (i = this.animationsByName.get(t)), null == i && (i = n[0]);

      try {
        var _t359 = this.currentAnimationAction;
        this.currentAnimationAction = this.mixer.clipAction(i, this).play(), this.currentAnimationAction.enabled = !0, null != _t359 && this.currentAnimationAction !== _t359 && this.currentAnimationAction.crossFadeFrom(_t359, e, !1);
      } catch (t) {
        console.error(t);
      }
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      null != this.currentAnimationAction && (this.currentAnimationAction.stop(), this.currentAnimationAction.reset(), this.currentAnimationAction = null), this.mixer.stopAllAction();
    }
  }, {
    key: "updateAnimation",
    value: function updateAnimation(t) {
      this.mixer.update(t);
    }
  }, {
    key: "updateShadow",
    value: function updateShadow() {
      var t = this.shadow;

      if (null != t) {
        var _e305 = "wall" === this.element.arPlacement ? "back" : "bottom";

        t.setScene(this, this.shadowSoftness, _e305);
      }
    }
  }, {
    key: "setShadowIntensity",
    value: function setShadowIntensity(t) {
      if (this.shadowIntensity = t, null == this._currentGLTF) return;
      var e = this.shadow;
      var n = "wall" === this.element.arPlacement ? "back" : "bottom";
      null != e ? (e.setIntensity(t), e.setScene(this, this.shadowSoftness, n)) : t > 0 && (e = new yu(this, this.shadowSoftness, n), e.setIntensity(t), this.shadow = e);
    }
  }, {
    key: "setShadowSoftness",
    value: function setShadowSoftness(t) {
      this.shadowSoftness = t;
      var e = this.shadow;
      null != e && e.setSoftness(t);
    }
  }, {
    key: "setShadowRotation",
    value: function setShadowRotation(t) {
      var e = this.shadow;
      null != e && e.setRotation(t);
    }
  }, {
    key: "isShadowDirty",
    value: function isShadowDirty() {
      var t = this.shadow;
      if (null == t) return !1;
      {
        var _e306 = t.needsUpdate;
        return t.needsUpdate = !1, _e306;
      }
    }
  }, {
    key: "setShadowScaleAndOffset",
    value: function setShadowScaleAndOffset(t, e) {
      var n = this.shadow;
      null != n && n.setScaleAndOffset(t, e);
    }
  }, {
    key: "positionAndNormalFromPoint",
    value: function positionAndNormalFromPoint(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Cu.setFromCamera(t, this.getCamera());
      var n = Cu.intersectObject(e, !0);
      if (0 === n.length) return null;
      var i = n[0];
      return null == i.face ? null : (i.face.normal.applyNormalMatrix(new At().getNormalMatrix(i.object.matrixWorld)), {
        position: i.point,
        normal: i.face.normal
      });
    }
  }, {
    key: "addHotspot",
    value: function addHotspot(t) {
      this.target.add(t), this.annotationRenderer.domElement.appendChild(t.element);
    }
  }, {
    key: "removeHotspot",
    value: function removeHotspot(t) {
      this.target.remove(t);
    }
  }, {
    key: "forHotspots",
    value: function forHotspots(t) {
      var e = this.target.children;

      for (var n = 0, _i223 = e.length; n < _i223; n++) {
        var _i224 = e[n];
        _i224 instanceof fu && t(_i224);
      }
    }
  }, {
    key: "updateHotspots",
    value: function updateHotspots(t) {
      var _this121 = this;

      this.forHotspots(function (e) {
        bu.copy(t), _u.setFromMatrixPosition(e.matrixWorld), bu.sub(_u), Iu.copy(e.normal).transformDirection(_this121.target.matrixWorld), bu.dot(Iu) < 0 ? e.hide() : e.show();
      });
    }
  }, {
    key: "orientHotspots",
    value: function orientHotspots(t) {
      this.forHotspots(function (e) {
        e.orient(t);
      });
    }
  }, {
    key: "setHotspotsVisibility",
    value: function setHotspotsVisibility(t) {
      this.forHotspots(function (e) {
        e.visible = t;
      });
    }
  }]);

  return Su;
}(Ps);

var Bu = function () {
  var t = new si({
    uniforms: {
      roughnessMap: {
        value: null
      },
      normalMap: {
        value: null
      },
      texelSize: {
        value: new pt(1, 1)
      }
    },
    vertexShader: "\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tattribute vec3 position;\n\t\t\tattribute vec2 uv;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\tvoid main() {\n\n\t\t\t\tvUv = uv;\n\n\t\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t\t}\n\t\t",
    fragmentShader: "\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\tuniform sampler2D roughnessMap;\n\t\t\tuniform sampler2D normalMap;\n\t\t\tuniform vec2 texelSize;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\n\t\t\tvec4 envMapTexelToLinear( vec4 a ) { return a; }\n\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tfloat roughnessToVariance( float roughness ) {\n\n\t\t\t\tfloat variance = 0.0;\n\n\t\t\t\tif ( roughness >= r1 ) {\n\n\t\t\t\t\tvariance = ( r0 - roughness ) * ( v1 - v0 ) / ( r0 - r1 ) + v0;\n\n\t\t\t\t} else if ( roughness >= r4 ) {\n\n\t\t\t\t\tvariance = ( r1 - roughness ) * ( v4 - v1 ) / ( r1 - r4 ) + v1;\n\n\t\t\t\t} else if ( roughness >= r5 ) {\n\n\t\t\t\t\tvariance = ( r4 - roughness ) * ( v5 - v4 ) / ( r4 - r5 ) + v4;\n\n\t\t\t\t} else {\n\n\t\t\t\t\tfloat roughness2 = roughness * roughness;\n\n\t\t\t\t\tvariance = 1.79 * roughness2 * roughness2;\n\n\t\t\t\t}\n\n\t\t\t\treturn variance;\n\n\t\t\t}\n\n\t\t\tfloat varianceToRoughness( float variance ) {\n\n\t\t\t\tfloat roughness = 0.0;\n\n\t\t\t\tif ( variance >= v1 ) {\n\n\t\t\t\t\troughness = ( v0 - variance ) * ( r1 - r0 ) / ( v0 - v1 ) + r0;\n\n\t\t\t\t} else if ( variance >= v4 ) {\n\n\t\t\t\t\troughness = ( v1 - variance ) * ( r4 - r1 ) / ( v1 - v4 ) + r1;\n\n\t\t\t\t} else if ( variance >= v5 ) {\n\n\t\t\t\t\troughness = ( v4 - variance ) * ( r5 - r4 ) / ( v4 - v5 ) + r4;\n\n\t\t\t\t} else {\n\n\t\t\t\t\troughness = pow( 0.559 * variance, 0.25 ); // 0.559 = 1.0 / 1.79\n\n\t\t\t\t}\n\n\t\t\t\treturn roughness;\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = texture2D( roughnessMap, vUv, - 1.0 );\n\n\t\t\t\tif ( texelSize.x == 0.0 ) return;\n\n\t\t\t\tfloat roughness = gl_FragColor.g;\n\n\t\t\t\tfloat variance = roughnessToVariance( roughness );\n\n\t\t\t\tvec3 avgNormal;\n\n\t\t\t\tfor ( float x = - 1.0; x < 2.0; x += 2.0 ) {\n\n\t\t\t\t\tfor ( float y = - 1.0; y < 2.0; y += 2.0 ) {\n\n\t\t\t\t\t\tvec2 uv = vUv + vec2( x, y ) * 0.25 * texelSize;\n\n\t\t\t\t\t\tavgNormal += normalize( texture2D( normalMap, uv, - 1.0 ).xyz - 0.5 );\n\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\tvariance += 1.0 - 0.25 * length( avgNormal );\n\n\t\t\t\tgl_FragColor.g = varianceToRoughness( variance );\n\n\t\t\t}\n\t\t",
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
  return t.type = "RoughnessMipmapper", t;
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(),
    Tu = new Mn(new Yn(2, 2), Bu),
    Lu = new ri(0, 1, 0, 1, 0, 1);

var Ru = null,
    Du = null;

var Qu = /*#__PURE__*/function () {
  function Qu(t) {
    _classCallCheck(this, Qu);

    Du = t, Du.compile(Tu, Lu);
  }

  _createClass(Qu, [{
    key: "generateMipmaps",
    value: function generateMipmaps(t) {
      if ("roughnessMap" in t == !1) return;
      var e = t.roughnessMap,
          n = t.normalMap;
      if (null === e || null === n || !e.generateMipmaps || t.userData.roughnessUpdated) return;
      t.userData.roughnessUpdated = !0;
      var i = Math.max(e.image.width, n.image.width),
          r = Math.max(e.image.height, n.image.height);
      if (!dt.isPowerOfTwo(i) || !dt.isPowerOfTwo(r)) return;
      var s = Du.getRenderTarget(),
          a = Du.autoClear;

      if (Du.autoClear = !1, null !== Ru && Ru.width === i && Ru.height === r || (null !== Ru && Ru.dispose(), Ru = new wt(i, r, {
        depthBuffer: !1
      }), Ru.scissorTest = !0), i !== e.image.width || r !== e.image.height) {
        var _n276 = {
          wrapS: e.wrapS,
          wrapT: e.wrapT,
          magFilter: e.magFilter,
          minFilter: e.minFilter,
          depthBuffer: !1
        },
            _s88 = new wt(i, r, _n276);

        _s88.texture.generateMipmaps = !0, Du.setRenderTarget(_s88), t.roughnessMap = _s88.texture, t.metalnessMap == e && (t.metalnessMap = t.roughnessMap), t.aoMap == e && (t.aoMap = t.roughnessMap), t.roughnessMap.offset.copy(e.offset), t.roughnessMap.repeat.copy(e.repeat), t.roughnessMap.center.copy(e.center), t.roughnessMap.rotation = e.rotation, t.roughnessMap.matrixAutoUpdate = e.matrixAutoUpdate, t.roughnessMap.matrix.copy(e.matrix);
      }

      Bu.uniforms.roughnessMap.value = e, Bu.uniforms.normalMap.value = n;
      var o = new pt(0, 0),
          l = Bu.uniforms.texelSize.value;

      for (var _e307 = 0; i >= 1 && r >= 1; ++_e307, i /= 2, r /= 2) {
        l.set(1 / i, 1 / r), 0 == _e307 && l.set(0, 0), Ru.viewport.set(o.x, o.y, i, r), Ru.scissor.set(o.x, o.y, i, r), Du.setRenderTarget(Ru), Du.render(Tu, Lu), Du.copyFramebufferToTexture(o, t.roughnessMap, _e307), Bu.uniforms.roughnessMap.value = t.roughnessMap;
      }

      e !== t.roughnessMap && e.dispose(), Du.setRenderTarget(s), Du.autoClear = a;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      Bu.dispose(), Tu.geometry.dispose(), null != Ru && Ru.dispose();
    }
  }]);

  return Qu;
}();

var Pu = function Pu(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Fu = Symbol("currentEnvironmentMap"),
    Nu = Symbol("applyEnvironmentMap"),
    Uu = Symbol("updateEnvironment"),
    ku = Symbol("cancelEnvironmentUpdate"),
    Gu = Symbol("onPreload");

var Ou = /*#__PURE__*/function () {
  function Ou(t, e, n, i, r) {
    var _this122 = this;

    _classCallCheck(this, Ou);

    this.xrLight = t, this.renderer = e, this.lightProbe = n, this.xrWebGLBinding = null, this.estimationStartCallback = r, this.frameCallback = this.onXRFrame.bind(this);
    var s = e.xr.getSession();

    if (i && "XRWebGLBinding" in window) {
      var _n277 = new Un(16);

      t.environment = _n277.texture;

      var _i225 = e.getContext();

      switch (s.preferredReflectionFormat) {
        case "srgba8":
          _i225.getExtension("EXT_sRGB");

          break;

        case "rgba16f":
          _i225.getExtension("OES_texture_half_float");

      }

      this.xrWebGLBinding = new XRWebGLBinding(s, _i225), this.lightProbe.addEventListener("reflectionchange", function () {
        _this122.updateReflection();
      });
    }

    s.requestAnimationFrame(this.frameCallback);
  }

  _createClass(Ou, [{
    key: "updateReflection",
    value: function updateReflection() {
      var t = this.renderer.properties.get(this.xrLight.environment);

      if (t) {
        var _e308 = this.xrWebGLBinding.getReflectionCubeMap(this.lightProbe);

        _e308 && (t.__webglTexture = _e308);
      }
    }
  }, {
    key: "onXRFrame",
    value: function onXRFrame(t, e) {
      if (!this.xrLight) return;
      e.session.requestAnimationFrame(this.frameCallback);
      var n = e.getLightEstimate(this.lightProbe);

      if (n) {
        this.xrLight.lightProbe.sh.fromArray(n.sphericalHarmonicsCoefficients), this.xrLight.lightProbe.intensity = 1;

        var _t360 = Math.max(1, Math.max(n.primaryLightIntensity.x, Math.max(n.primaryLightIntensity.y, n.primaryLightIntensity.z)));

        this.xrLight.directionalLight.color.setRGB(n.primaryLightIntensity.x / _t360, n.primaryLightIntensity.y / _t360, n.primaryLightIntensity.z / _t360), this.xrLight.directionalLight.intensity = _t360, this.xrLight.directionalLight.position.copy(n.primaryLightDirection), this.estimationStartCallback && (this.estimationStartCallback(), this.estimationStartCallback = null);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.xrLight = null, this.renderer = null, this.lightProbe = null, this.xrWebGLBinding = null;
    }
  }]);

  return Ou;
}();

var Hu = /*#__PURE__*/function (_Bs) {
  _inherits(Hu, _Bs);

  var _super125 = _createSuper(Hu);

  function Hu(t) {
    var _this123;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;

    _classCallCheck(this, Hu);

    _this123 = _super125.call(this), _this123.lightProbe = new bl(), _this123.lightProbe.intensity = 0, _this123.add(_this123.lightProbe), _this123.directionalLight = new wl(), _this123.directionalLight.intensity = 0, _this123.add(_this123.directionalLight), _this123.environment = null;
    var n = null,
        i = !1;
    t.xr.addEventListener("sessionstart", function () {
      var r = t.xr.getSession();
      "requestLightProbe" in r && r.requestLightProbe({
        reflectionFormat: r.preferredReflectionFormat
      }).then(function (r) {
        n = new Ou(_assertThisInitialized(_this123), t, r, e, function () {
          i = !0, _this123.dispatchEvent({
            type: "estimationstart"
          });
        });
      });
    }), t.xr.addEventListener("sessionend", function () {
      n && (n.dispose(), n = null), i && _this123.dispatchEvent({
        type: "estimationend"
      });
    }), _this123.dispose = function () {
      n && (n.dispose(), n = null), _this123.remove(_this123.lightProbe), _this123.lightProbe = null, _this123.remove(_this123.directionalLight), _this123.directionalLight = null, _this123.environment = null;
    };
    return _this123;
  }

  return _createClass(Hu);
}(Bs);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var zu = Math.PI / 24,
    Vu = new pt(),
    Wu = function Wu(t, e, n) {
  var i = e > 0 ? n > 0 ? 0 : -Math.PI / 2 : n > 0 ? Math.PI / 2 : Math.PI;

  for (var _r153 = 0; _r153 <= 12; ++_r153) {
    t.push(e + .17 * Math.cos(i), n + .17 * Math.sin(i), 0, e + .2 * Math.cos(i), n + .2 * Math.sin(i), 0), i += zu;
  }
};

var qu = /*#__PURE__*/function (_Mn3) {
  _inherits(qu, _Mn3);

  var _super126 = _createSuper(qu);

  function qu(t, e) {
    var _this124;

    _classCallCheck(this, qu);

    var n = new cn(),
        i = [],
        r = [],
        s = t.size,
        a = t.boundingBox,
        o = s.x / 2,
        l = ("back" === e ? s.y : s.z) / 2;
    Wu(r, o, l), Wu(r, -o, l), Wu(r, -o, -l), Wu(r, o, -l);
    var c = r.length / 3;

    for (var _t361 = 0; _t361 < c - 2; _t361 += 2) {
      i.push(_t361, _t361 + 1, _t361 + 3, _t361, _t361 + 3, _t361 + 2);
    }

    var h = c - 2;
    i.push(h, h + 1, 1, h, 1, 0), n.setAttribute("position", new $e(r, 3)), n.setIndex(i), _this124 = _super126.call(this, n), _this124.side = e;
    var u = _this124.material;

    switch (u.side = 2, u.transparent = !0, u.opacity = 0, _this124.goalOpacity = 0, _this124.opacityDamper = new iu(), _this124.hitPlane = new Mn(new Yn(2 * (o + .2), 2 * (l + .2))), _this124.hitPlane.visible = !1, _this124.add(_this124.hitPlane), a.getCenter(_this124.position), e) {
      case "bottom":
        _this124.rotateX(-Math.PI / 2), _this124.shadowHeight = a.min.y, _this124.position.y = _this124.shadowHeight;
        break;

      case "back":
        _this124.shadowHeight = a.min.z, _this124.position.z = _this124.shadowHeight;
    }

    t.target.add(_assertThisInitialized(_this124));
    return _this124;
  }

  _createClass(qu, [{
    key: "getHit",
    value: function getHit(t, e, n) {
      Vu.set(e, -n), this.hitPlane.visible = !0;
      var i = t.positionAndNormalFromPoint(Vu, this.hitPlane);
      return this.hitPlane.visible = !1, null == i ? null : i.position;
    }
  }, {
    key: "getExpandedHit",
    value: function getExpandedHit(t, e, n) {
      this.hitPlane.scale.set(1e3, 1e3, 1e3);
      var i = this.getHit(t, e, n);
      return this.hitPlane.scale.set(1, 1, 1), i;
    }
  }, {
    key: "offsetHeight",
    get: function get() {
      return "back" === this.side ? this.position.z - this.shadowHeight : this.position.y - this.shadowHeight;
    },
    set: function set(t) {
      "back" === this.side ? this.position.z = this.shadowHeight + t : this.position.y = this.shadowHeight + t;
    }
  }, {
    key: "show",
    set: function set(t) {
      this.goalOpacity = t ? .75 : 0;
    }
  }, {
    key: "updateOpacity",
    value: function updateOpacity(t) {
      var e = this.material;
      e.opacity = this.opacityDamper.update(e.opacity, this.goalOpacity, t, 1), this.visible = e.opacity > 0;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var t;
      var _this$hitPlane = this.hitPlane,
          e = _this$hitPlane.geometry,
          n = _this$hitPlane.material;
      e.dispose(), n.dispose(), this.geometry.dispose(), this.material.dispose(), null === (t = this.parent) || void 0 === t || t.remove(this);
    }
  }]);

  return qu;
}(Mn);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ju = "not-presenting",
    Yu = "session-started",
    Ju = "object-placed",
    Xu = "failed",
    Ku = "tracking",
    Zu = "not-tracking",
    $u = new _t(),
    td = new ee(),
    ed = new _t(),
    nd = new Pn(45, 1, .1, 100);

var id = /*#__PURE__*/function (_tt9) {
  _inherits(id, _tt9);

  var _super127 = _createSuper(id);

  function id(t) {
    var _this125;

    _classCallCheck(this, id);

    _this125 = _super127.call(this), _this125.renderer = t, _this125.currentSession = null, _this125.placeOnWall = !1, _this125.placementBox = null, _this125.lastTick = null, _this125.turntableRotation = null, _this125.oldShadowIntensity = null, _this125.oldBackground = null, _this125.oldEnvironment = null, _this125.frame = null, _this125.initialHitSource = null, _this125.transientHitTestSource = null, _this125.inputSource = null, _this125._presentedScene = null, _this125.resolveCleanup = null, _this125.exitWebXRButtonContainer = null, _this125.overlay = null, _this125.xrLight = null, _this125.environmentEstimation = !1, _this125.tracking = !0, _this125.frames = 0, _this125.initialized = !1, _this125.oldTarget = new _t(), _this125.oldFramedFieldOfView = 45, _this125.placementComplete = !1, _this125.isTranslating = !1, _this125.isRotating = !1, _this125.isTwoFingering = !1, _this125.lastDragPosition = new _t(), _this125.firstRatio = 0, _this125.lastAngle = 0, _this125.goalPosition = new _t(), _this125.goalYaw = 0, _this125.goalScale = 1, _this125.xDamper = new iu(), _this125.yDamper = new iu(), _this125.zDamper = new iu(), _this125.yawDamper = new iu(), _this125.scaleDamper = new iu(), _this125.onExitWebXRButtonContainerClick = function () {
      return _this125.stopPresenting();
    }, _this125.onUpdateScene = function () {
      null != _this125.placementBox && _this125.isPresenting && (_this125.placementBox.dispose(), _this125.placementBox = new qu(_this125.presentedScene, _this125.placeOnWall ? "back" : "bottom"));
    }, _this125.onSelectStart = function (t) {
      var e = _this125.transientHitTestSource;
      if (null == e) return;

      var n = _this125.frame.getHitTestResultsForTransientInput(e),
          i = _this125.presentedScene,
          r = _this125.placementBox;

      if (1 === n.length) {
        _this125.inputSource = t.inputSource;

        var _e309 = _this125.inputSource.gamepad.axes,
            _n278 = r.getHit(_this125.presentedScene, _e309[0], _e309[1]);

        r.show = !0, null != _n278 ? (_this125.isTranslating = !0, _this125.lastDragPosition.copy(_n278)) : !1 === _this125.placeOnWall && (_this125.isRotating = !0, _this125.lastAngle = 1.5 * _e309[0]);
      } else if (2 === n.length) {
        r.show = !0, _this125.isTwoFingering = !0;

        var _this125$fingerPolar = _this125.fingerPolar(n),
            _t362 = _this125$fingerPolar.separation;

        _this125.firstRatio = _t362 / i.scale.x;
      }
    }, _this125.onSelectEnd = function () {
      _this125.isTranslating = !1, _this125.isRotating = !1, _this125.isTwoFingering = !1, _this125.inputSource = null, _this125.goalPosition.y += _this125.placementBox.offsetHeight * _this125.presentedScene.scale.x, _this125.placementBox.show = !1;
    }, _this125.threeRenderer = t.threeRenderer, _this125.threeRenderer.xr.enabled = !0, _this125.xrLight = new Hu(_this125.threeRenderer), _this125.xrLight.addEventListener("estimationstart", function () {
      if (!_this125.isPresenting || null == _this125.xrLight) return;
      var t = _this125.presentedScene;
      t.add(_this125.xrLight), _this125.environmentEstimation && _this125.xrLight.environment && (_this125.oldEnvironment = t.environment, t.environment = _this125.xrLight.environment);
    });
    return _this125;
  }

  _createClass(id, [{
    key: "resolveARSession",
    value: function () {
      var _resolveARSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var t;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                Kh();
                _context12.next = 3;
                return navigator.xr.requestSession("immersive-ar", {
                  requiredFeatures: ["hit-test"],
                  optionalFeatures: ["dom-overlay", "light-estimation"],
                  domOverlay: {
                    root: this.overlay
                  }
                });

              case 3:
                t = _context12.sent;
                this.threeRenderer.xr.setReferenceSpaceType("local");
                _context12.next = 7;
                return this.threeRenderer.xr.setSession(t);

              case 7:
                this.threeRenderer.xr.cameraAutoUpdate = !1;
                return _context12.abrupt("return", t);

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function resolveARSession() {
        return _resolveARSession.apply(this, arguments);
      }

      return resolveARSession;
    }()
  }, {
    key: "presentedScene",
    get: function get() {
      return this._presentedScene;
    }
  }, {
    key: "supportsPresentation",
    value: function () {
      var _supportsPresentation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                Kh();
                _context13.next = 4;
                return navigator.xr.isSessionSupported("immersive-ar");

              case 4:
                return _context13.abrupt("return", _context13.sent);

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", (console.warn("Request to present in WebXR denied:"), console.warn(_context13.t0), console.warn("Falling back to next ar-mode"), !1));

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 7]]);
      }));

      function supportsPresentation() {
        return _supportsPresentation.apply(this, arguments);
      }

      return supportsPresentation;
    }()
  }, {
    key: "present",
    value: function () {
      var _present = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t) {
        var _this126 = this;

        var e,
            n,
            i,
            r,
            s,
            a,
            o,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                e = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : !1;
                this.isPresenting && console.warn("Cannot present while a model is already presenting");
                n = new Promise(function (t, e) {
                  requestAnimationFrame(function () {
                    return t();
                  });
                });
                t.setHotspotsVisibility(!1);
                t.isDirty = !0;
                _context14.next = 7;
                return n;

              case 7:
                this._presentedScene = t;
                this.overlay = t.element.shadowRoot.querySelector("div.default");
                this.environmentEstimation = e;
                _context14.next = 12;
                return this.resolveARSession();

              case 12:
                i = _context14.sent;
                i.addEventListener("end", function () {
                  _this126.postSessionCleanup();
                }, {
                  once: !0
                });
                r = t.element.shadowRoot.querySelector(".slot.exit-webxr-ar-button");
                r.classList.add("enabled"), r.addEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = r;
                _context14.next = 18;
                return i.requestReferenceSpace("viewer");

              case 18:
                s = _context14.sent;
                this.tracking = !0, this.frames = 0, this.initialized = !1, this.turntableRotation = t.yaw, this.goalYaw = t.yaw, this.goalScale = 1, this.oldBackground = t.background, t.background = null, this.oldShadowIntensity = t.shadowIntensity, t.setShadowIntensity(0), this.oldTarget.copy(t.getTarget()), this.oldFramedFieldOfView = t.framedFieldOfView, t.addEventListener("model-load", this.onUpdateScene);
                a = 20 * Math.PI / 180, o = !0 === this.placeOnWall ? void 0 : new XRRay(new DOMPoint(0, 0, 0), {
                  x: 0,
                  y: -Math.sin(a),
                  z: -Math.cos(a)
                });
                i.requestHitTestSource({
                  space: s,
                  offsetRay: o
                }).then(function (t) {
                  _this126.initialHitSource = t;
                }), this.currentSession = i, this.placementBox = new qu(t, this.placeOnWall ? "back" : "bottom"), this.placementComplete = !1, this.lastTick = performance.now(), this.dispatchEvent({
                  type: "status",
                  status: Yu
                });

              case 22:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function present(_x18) {
        return _present.apply(this, arguments);
      }

      return present;
    }()
  }, {
    key: "stopPresenting",
    value: function () {
      var _stopPresenting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this127 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.isPresenting) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                t = new Promise(function (t) {
                  _this127.resolveCleanup = t;
                });
                _context15.prev = 3;
                _context15.next = 6;
                return this.currentSession.end();

              case 6:
                _context15.next = 8;
                return t;

              case 8:
                _context15.next = 13;
                break;

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](3);
                console.warn("Error while trying to end WebXR AR session"), console.warn(_context15.t0), this.postSessionCleanup();

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[3, 10]]);
      }));

      function stopPresenting() {
        return _stopPresenting.apply(this, arguments);
      }

      return stopPresenting;
    }()
  }, {
    key: "isPresenting",
    get: function get() {
      return null != this.presentedScene;
    }
  }, {
    key: "target",
    get: function get() {
      return this.oldTarget;
    }
  }, {
    key: "updateTarget",
    value: function updateTarget() {
      var t = this.presentedScene;

      if (null != t) {
        var _e310 = t.getTarget();

        this.oldTarget.copy(_e310), this.placeOnWall ? _e310.z = t.boundingBox.min.z : _e310.y = t.boundingBox.min.y, t.setTarget(_e310.x, _e310.y, _e310.z);
      }
    }
  }, {
    key: "postSessionCleanup",
    value: function postSessionCleanup() {
      var t = this.currentSession;
      null != t && (t.removeEventListener("selectstart", this.onSelectStart), t.removeEventListener("selectend", this.onSelectEnd), this.currentSession = null);
      var e = this.presentedScene;

      if (null != e) {
        var _t363 = e.element;
        null != this.xrLight && null != this.xrLight.parent && (e.remove(this.xrLight), null != this.oldEnvironment && (e.environment = this.oldEnvironment, this.oldEnvironment = null)), e.position.set(0, 0, 0), e.scale.set(1, 1, 1), e.setShadowScaleAndOffset(1, 0);
        var _n279 = this.turntableRotation;
        null != _n279 && (e.yaw = _n279);
        var _i226 = this.oldShadowIntensity;
        null != _i226 && e.setShadowIntensity(_i226);
        var _r154 = this.oldBackground;
        null != _r154 && (e.background = _r154);
        var _s89 = this.oldTarget;
        e.setTarget(_s89.x, _s89.y, _s89.z), e.framedFieldOfView = this.oldFramedFieldOfView, e.xrCamera = null, e.removeEventListener("model-load", this.onUpdateScene), e.orientHotspots(0), _t363.requestUpdate("cameraTarget"), _t363.requestUpdate("maxCameraOrbit"), _t363[xp](_t363.getBoundingClientRect());
      }

      this.renderer.height = 0;
      var n = this.exitWebXRButtonContainer;
      null != n && (n.classList.remove("enabled"), n.removeEventListener("click", this.onExitWebXRButtonContainerClick), this.exitWebXRButtonContainer = null);
      var i = this.transientHitTestSource;
      null != i && (i.cancel(), this.transientHitTestSource = null);
      var r = this.initialHitSource;
      null != r && (r.cancel(), this.initialHitSource = null), null != this.placementBox && (this.placementBox.dispose(), this.placementBox = null), this.lastTick = null, this.turntableRotation = null, this.oldShadowIntensity = null, this.oldBackground = null, this._presentedScene = null, this.frame = null, this.inputSource = null, this.overlay = null, null != this.resolveCleanup && this.resolveCleanup(), this.dispatchEvent({
        type: "status",
        status: ju
      });
    }
  }, {
    key: "updateView",
    value: function updateView(t) {
      var e = this.presentedScene,
          n = this.threeRenderer.xr;
      n.updateCamera(nd), e.xrCamera = n.getCamera();
      var i = e.getCamera().matrixWorld.elements;

      if (e.orientHotspots(Math.atan2(i[1], i[5])), this.initialized || (this.placeInitially(), this.initialized = !0), t.requestViewportScale && t.recommendedViewportScale) {
        var _e311 = t.recommendedViewportScale;
        t.requestViewportScale(Math.max(_e311, .25));
      }

      var r = this.currentSession.renderState.baseLayer.getViewport(t);
      this.threeRenderer.setViewport(r.x, r.y, r.width, r.height);
    }
  }, {
    key: "placeInitially",
    value: function placeInitially() {
      var _this128 = this;

      var t = this.presentedScene,
          e = t.position,
          n = t.element,
          i = t.getCamera(),
          _this$overlay$getBoun = this.overlay.getBoundingClientRect(),
          r = _this$overlay$getBoun.width,
          s = _this$overlay$getBoun.height;

      t.setSize(r, s), i.projectionMatrixInverse.copy(i.projectionMatrix).invert();

      var _n$getCameraOrbit = n.getCameraOrbit(),
          a = _n$getCameraOrbit.theta,
          o = _n$getCameraOrbit.radius,
          l = i.getWorldDirection($u);

      t.yaw = Math.atan2(-l.x, -l.z) - a, this.goalYaw = t.yaw, e.copy(i.position).add(l.multiplyScalar(o)), this.updateTarget();
      var c = t.getTarget();
      e.add(c).sub(this.oldTarget), this.goalPosition.copy(e), t.setHotspotsVisibility(!0);
      var h = this.frame.session;
      h.addEventListener("selectstart", this.onSelectStart), h.addEventListener("selectend", this.onSelectEnd), h.requestHitTestSourceForTransientInput({
        profile: "generic-touchscreen"
      }).then(function (t) {
        _this128.transientHitTestSource = t;
      });
    }
  }, {
    key: "getTouchLocation",
    value: function getTouchLocation() {
      var t = this.inputSource.gamepad.axes;
      var e = this.placementBox.getExpandedHit(this.presentedScene, t[0], t[1]);
      return null != e && ($u.copy(e).sub(this.presentedScene.getCamera().position), $u.length() > 10) ? null : e;
    }
  }, {
    key: "getHitPoint",
    value: function getHitPoint(t) {
      var e = this.threeRenderer.xr.getReferenceSpace(),
          n = t.getPose(e);
      if (null == n) return null;
      var i = td.fromArray(n.transform.matrix);
      return !0 === this.placeOnWall && (this.goalYaw = Math.atan2(i.elements[4], i.elements[6])), i.elements[5] > .75 !== this.placeOnWall ? ed.setFromMatrixPosition(i) : null;
    }
  }, {
    key: "moveToFloor",
    value: function moveToFloor(t) {
      var e = this.initialHitSource;
      if (null == e) return;
      var n = t.getHitTestResults(e);
      if (0 == n.length) return;
      var i = n[0],
          r = this.getHitPoint(i);
      null != r && (this.placementBox.show = !0, this.isTranslating || (this.placeOnWall ? this.goalPosition.copy(r) : this.goalPosition.y = r.y), e.cancel(), this.initialHitSource = null, this.dispatchEvent({
        type: "status",
        status: Ju
      }));
    }
  }, {
    key: "fingerPolar",
    value: function fingerPolar(t) {
      var e = t[0].inputSource.gamepad.axes,
          n = t[1].inputSource.gamepad.axes,
          i = n[0] - e[0],
          r = n[1] - e[1],
          s = Math.atan2(r, i);
      var a = this.lastAngle - s;
      return a > Math.PI ? a -= 2 * Math.PI : a < -Math.PI && (a += 2 * Math.PI), this.lastAngle = s, {
        separation: Math.sqrt(i * i + r * r),
        deltaYaw: a
      };
    }
  }, {
    key: "processInput",
    value: function processInput(t) {
      var _this129 = this;

      var e = this.transientHitTestSource;
      if (null == e) return;
      if (!this.isTranslating && !this.isTwoFingering && !this.isRotating) return;
      var n = t.getHitTestResultsForTransientInput(e),
          i = this.presentedScene,
          r = i.scale.x;
      if (this.isTwoFingering) {
        if (n.length < 2) this.isTwoFingering = !1;else {
          var _this$fingerPolar = this.fingerPolar(n),
              _t364 = _this$fingerPolar.separation,
              _e312 = _this$fingerPolar.deltaYaw;

          if (!1 === this.placeOnWall && (this.goalYaw += _e312), i.canScale) {
            var _e313 = _t364 / this.firstRatio;

            this.goalScale = _e313 < 1.3 && _e313 > .7692307692307692 ? 1 : _e313;
          }
        }
      } else if (2 !== n.length) {
        if (this.isRotating) {
          var _t365 = 1.5 * this.inputSource.gamepad.axes[0];

          this.goalYaw += _t365 - this.lastAngle, this.lastAngle = _t365;
        } else this.isTranslating && n.forEach(function (t) {
          if (t.inputSource !== _this129.inputSource) return;
          var e = null;

          if (t.results.length > 0 && (e = _this129.getHitPoint(t.results[0])), null == e && (e = _this129.getTouchLocation()), null != e) {
            if (_this129.goalPosition.sub(_this129.lastDragPosition), !1 === _this129.placeOnWall) {
              var _t366 = e.y - _this129.lastDragPosition.y;

              if (_t366 < 0) {
                _this129.placementBox.offsetHeight = _t366 / r, _this129.presentedScene.setShadowScaleAndOffset(r, _t366);

                var _n280 = $u.copy(i.getCamera().position),
                    _s90 = -_t366 / (_n280.y - e.y);

                _n280.multiplyScalar(_s90), e.multiplyScalar(1 - _s90).add(_n280);
              }
            }

            _this129.goalPosition.add(e), _this129.lastDragPosition.copy(e);
          }
        });
      } else {
        this.isTranslating = !1, this.isRotating = !1, this.isTwoFingering = !0;

        var _this$fingerPolar2 = this.fingerPolar(n),
            _t367 = _this$fingerPolar2.separation;

        this.firstRatio = _t367 / r;
      }
    }
  }, {
    key: "moveScene",
    value: function moveScene(t) {
      var e = this.presentedScene,
          n = e.position,
          i = e.yaw,
          r = e.idealCameraDistance,
          s = this.goalPosition,
          a = e.scale.x,
          o = this.placementBox;

      if (!s.equals(n) || this.goalScale !== a) {
        var _i227 = n.x,
            _l35 = n.y,
            _c29 = n.z;
        _i227 = this.xDamper.update(_i227, s.x, t, r), _l35 = this.yDamper.update(_l35, s.y, t, r), _c29 = this.zDamper.update(_c29, s.z, t, r), n.set(_i227, _l35, _c29);

        var _h15 = this.scaleDamper.update(a, this.goalScale, t, 1);

        if (e.scale.set(_h15, _h15, _h15), !this.isTranslating) {
          var _t368 = s.y - _l35;

          this.placementComplete && !1 === this.placeOnWall ? (o.offsetHeight = _t368 / _h15, e.setShadowScaleAndOffset(_h15, _t368)) : 0 === _t368 && (this.placementComplete = !0, o.show = !1, e.setShadowIntensity(.3));
        }
      }

      o.updateOpacity(t), e.updateTarget(t), e.yaw = this.yawDamper.update(i, this.goalYaw, t, Math.PI);
    }
  }, {
    key: "onWebXRFrame",
    value: function onWebXRFrame(t, e) {
      this.frame = e, ++this.frames;
      var n = this.threeRenderer.xr.getReferenceSpace(),
          i = e.getViewerPose(n);
      null == i && !0 === this.tracking && this.frames > 30 && (this.tracking = !1, this.dispatchEvent({
        type: "tracking",
        status: Zu
      }));
      var r = this.presentedScene;
      if (null == i || null == r || !r.element[Cp]()) return void this.threeRenderer.clear();
      !1 === this.tracking && (this.tracking = !0, this.dispatchEvent({
        type: "tracking",
        status: Ku
      }));
      var s = !0;

      var _iterator14 = _createForOfIteratorHelper(i.views),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _n281 = _step14.value;

          if (this.updateView(_n281), s) {
            this.moveToFloor(e), this.processInput(e);

            var _n282 = t - this.lastTick;

            this.moveScene(_n282), this.renderer.preRender(r, t, _n282), this.lastTick = t;
          }

          var _i228 = this.threeRenderer.getContext();

          _i228.depthMask(!1), _i228.clear(_i228.DEPTH_BUFFER_BIT), _i228.depthMask(!0), this.threeRenderer.render(r, r.getCamera()), s = !1;
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }]);

  return id;
}(tt);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var rd = /*#__PURE__*/function () {
  function rd(t) {
    _classCallCheck(this, rd);

    t.threeRenderer.debug = {
      checkShaderErrors: !0
    }, Promise.resolve().then(function () {
      self.dispatchEvent(new CustomEvent("model-viewer-renderer-debug", {
        detail: {
          renderer: t,
          THREE: {
            ShaderMaterial: Dn,
            Texture: vt,
            Mesh: Mn,
            Scene: Ps,
            PlaneBufferGeometry: Yn,
            OrthographicCamera: ri,
            WebGLRenderTarget: wt
          }
        }
      }));
    });
  }

  _createClass(rd, [{
    key: "addScene",
    value: function addScene(t) {
      self.dispatchEvent(new CustomEvent("model-viewer-scene-added-debug", {
        detail: {
          scene: t
        }
      }));
    }
  }, {
    key: "removeScene",
    value: function removeScene(t) {
      self.dispatchEvent(new CustomEvent("model-viewer-scene-removed-debug", {
        detail: {
          scene: t
        }
      }));
    }
  }]);

  return rd;
}();

function sd(t, e, n) {
  n(t, e);

  for (var _i229 = 0; _i229 < t.children.length; _i229++) {
    sd(t.children[_i229], e.children[_i229], n);
  }
}
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ad = Symbol("prepared"),
    od = Symbol("prepare"),
    ld = Symbol("preparedGLTF"),
    cd = Symbol("clone");

var hd = /*#__PURE__*/function () {
  function hd(t) {
    _classCallCheck(this, hd);

    this[ld] = t;
  }

  _createClass(hd, [{
    key: "parser",
    get: function get() {
      return this[ld].parser;
    }
  }, {
    key: "animations",
    get: function get() {
      return this[ld].animations;
    }
  }, {
    key: "scene",
    get: function get() {
      return this[ld].scene;
    }
  }, {
    key: "scenes",
    get: function get() {
      return this[ld].scenes;
    }
  }, {
    key: "cameras",
    get: function get() {
      return this[ld].cameras;
    }
  }, {
    key: "asset",
    get: function get() {
      return this[ld].asset;
    }
  }, {
    key: "userData",
    get: function get() {
      return this[ld].userData;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new (0, this.constructor)(this[cd]());
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.scenes.forEach(function (t) {
        t.traverse(function (t) {
          if (!t.isMesh) return;
          var e = t;
          (Array.isArray(e.material) ? e.material : [e.material]).forEach(function (t) {
            for (var _e314 in t) {
              var n = t[_e314];
              n instanceof vt && n.dispose();
            }

            t.dispose();
          }), e.geometry.dispose();
        });
      });
    }
  }, {
    key: cd,
    value: function value() {
      var t = this[ld],
          e = /*#__PURE__*/function () {
        function _class32() {
          _classCallCheck(this, _class32);
        }

        _createClass(_class32, null, [{
          key: "retarget",
          value: function retarget(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new _t(),
                r = new bt(),
                s = new _t(),
                a = new ee(),
                o = new ee(),
                l = new ee();
            n.preserveMatrix = void 0 === n.preserveMatrix || n.preserveMatrix, n.preservePosition = void 0 === n.preservePosition || n.preservePosition, n.preserveHipPosition = void 0 !== n.preserveHipPosition && n.preserveHipPosition, n.useTargetMatrix = void 0 !== n.useTargetMatrix && n.useTargetMatrix, n.hip = void 0 !== n.hip ? n.hip : "hip", n.names = n.names || {};
            var c = e.isObject3D ? e.skeleton.bones : this.getBones(e),
                h = t.isObject3D ? t.skeleton.bones : this.getBones(t);
            var u, d, p, A, m;

            if (t.isObject3D ? t.skeleton.pose() : (n.useTargetMatrix = !0, n.preserveMatrix = !1), n.preservePosition) {
              m = [];

              for (var _t369 = 0; _t369 < h.length; _t369++) {
                m.push(h[_t369].position.clone());
              }
            }

            if (n.preserveMatrix) {
              t.updateMatrixWorld(), t.matrixWorld.identity();

              for (var _e315 = 0; _e315 < t.children.length; ++_e315) {
                t.children[_e315].updateMatrixWorld(!0);
              }
            }

            if (n.offsets) {
              u = [];

              for (var _t370 = 0; _t370 < h.length; ++_t370) {
                d = h[_t370], p = n.names[d.name] || d.name, n.offsets && n.offsets[p] && (d.matrix.multiply(n.offsets[p]), d.matrix.decompose(d.position, d.quaternion, d.scale), d.updateMatrixWorld()), u.push(d.matrixWorld.clone());
              }
            }

            for (var _e316 = 0; _e316 < h.length; ++_e316) {
              if (d = h[_e316], p = n.names[d.name] || d.name, A = this.getBoneByName(p, c), l.copy(d.matrixWorld), A) {
                if (A.updateMatrixWorld(), n.useTargetMatrix ? o.copy(A.matrixWorld) : (o.copy(t.matrixWorld).invert(), o.multiply(A.matrixWorld)), s.setFromMatrixScale(o), o.scale(s.set(1 / s.x, 1 / s.y, 1 / s.z)), l.makeRotationFromQuaternion(r.setFromRotationMatrix(o)), t.isObject3D) {
                  var _e317 = h.indexOf(d),
                      _n283 = u ? u[_e317] : a.copy(t.skeleton.boneInverses[_e317]).invert();

                  l.multiply(_n283);
                }

                l.copyPosition(o);
              }

              d.parent && d.parent.isBone ? (d.matrix.copy(d.parent.matrixWorld).invert(), d.matrix.multiply(l)) : d.matrix.copy(l), n.preserveHipPosition && p === n.hip && d.matrix.setPosition(i.set(0, d.position.y, 0)), d.matrix.decompose(d.position, d.quaternion, d.scale), d.updateMatrixWorld();
            }

            if (n.preservePosition) for (var _t371 = 0; _t371 < h.length; ++_t371) {
              d = h[_t371], p = n.names[d.name] || d.name, p !== n.hip && d.position.copy(m[_t371]);
            }
            n.preserveMatrix && t.updateMatrixWorld(!0);
          }
        }, {
          key: "retargetClip",
          value: function retargetClip(t, e, n) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            i.useFirstFramePosition = void 0 !== i.useFirstFramePosition && i.useFirstFramePosition, i.fps = void 0 !== i.fps ? i.fps : 30, i.names = i.names || [], e.isObject3D || (e = this.getHelperFromSkeleton(e));
            var r = Math.round(n.duration * (i.fps / 1e3) * 1e3),
                s = 1 / i.fps,
                a = [],
                o = new Gl(e),
                l = this.getBones(t.skeleton),
                c = [];
            var h, u, d, p, A;
            o.clipAction(n).play(), o.update(0), e.updateMatrixWorld();

            for (var _n284 = 0; _n284 < r; ++_n284) {
              var _a67 = _n284 * s;

              this.retarget(t, e, i);

              for (var _t372 = 0; _t372 < l.length; ++_t372) {
                A = i.names[l[_t372].name] || l[_t372].name, d = this.getBoneByName(A, e.skeleton), d && (u = l[_t372], p = c[_t372] = c[_t372] || {
                  bone: u
                }, i.hip === A && (p.pos || (p.pos = {
                  times: new Float32Array(r),
                  values: new Float32Array(3 * r)
                }), i.useFirstFramePosition && (0 === _n284 && (h = u.position.clone()), u.position.sub(h)), p.pos.times[_n284] = _a67, u.position.toArray(p.pos.values, 3 * _n284)), p.quat || (p.quat = {
                  times: new Float32Array(r),
                  values: new Float32Array(4 * r)
                }), p.quat.times[_n284] = _a67, u.quaternion.toArray(p.quat.values, 4 * _n284));
              }

              o.update(s), e.updateMatrixWorld();
            }

            for (var _t373 = 0; _t373 < c.length; ++_t373) {
              p = c[_t373], p && (p.pos && a.push(new qo(".bones[" + p.bone.name + "].position", p.pos.times, p.pos.values)), a.push(new Vo(".bones[" + p.bone.name + "].quaternion", p.quat.times, p.quat.values)));
            }

            return o.uncacheAction(n), new jo(n.name, -1, a);
          }
        }, {
          key: "getHelperFromSkeleton",
          value: function getHelperFromSkeleton(t) {
            var e = new jl(t.bones[0]);
            return e.skeleton = t, e;
          }
        }, {
          key: "getSkeletonOffsets",
          value: function getSkeletonOffsets(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new _t(),
                r = new _t(),
                s = new _t(),
                a = new _t(),
                o = new pt(),
                l = new pt();
            n.hip = void 0 !== n.hip ? n.hip : "hip", n.names = n.names || {}, e.isObject3D || (e = this.getHelperFromSkeleton(e));
            var c = Object.keys(n.names),
                h = Object.values(n.names),
                u = e.isObject3D ? e.skeleton.bones : this.getBones(e),
                d = t.isObject3D ? t.skeleton.bones : this.getBones(t),
                p = [];
            var A, m, g, f;

            for (t.skeleton.pose(), f = 0; f < d.length; ++f) {
              if (A = d[f], g = n.names[A.name] || A.name, m = this.getBoneByName(g, u), m && g !== n.hip) {
                var _t374 = this.getNearestBone(A.parent, c),
                    _e318 = this.getNearestBone(m.parent, h);

                _t374.updateMatrixWorld(), _e318.updateMatrixWorld(), i.setFromMatrixPosition(_t374.matrixWorld), r.setFromMatrixPosition(A.matrixWorld), s.setFromMatrixPosition(_e318.matrixWorld), a.setFromMatrixPosition(m.matrixWorld), o.subVectors(new pt(r.x, r.y), new pt(i.x, i.y)).normalize(), l.subVectors(new pt(a.x, a.y), new pt(s.x, s.y)).normalize();

                var _n285 = o.angle() - l.angle(),
                    _u15 = new ee().makeRotationFromEuler(new ue(0, 0, _n285));

                A.matrix.multiply(_u15), A.matrix.decompose(A.position, A.quaternion, A.scale), A.updateMatrixWorld(), p[g] = _u15;
              }
            }

            return p;
          }
        }, {
          key: "renameBones",
          value: function renameBones(t, e) {
            var n = this.getBones(t);

            for (var _t375 = 0; _t375 < n.length; ++_t375) {
              var _i230 = n[_t375];
              e[_i230.name] && (_i230.name = e[_i230.name]);
            }

            return this;
          }
        }, {
          key: "getBones",
          value: function getBones(t) {
            return Array.isArray(t) ? t : t.bones;
          }
        }, {
          key: "getBoneByName",
          value: function getBoneByName(t, e) {
            for (var _n286 = 0, _i231 = this.getBones(e); _n286 < _i231.length; _n286++) {
              if (t === _i231[_n286].name) return _i231[_n286];
            }
          }
        }, {
          key: "getNearestBone",
          value: function getNearestBone(t, e) {
            for (; t.isBone;) {
              if (-1 !== e.indexOf(t.name)) return t;
              t = t.parent;
            }
          }
        }, {
          key: "findBoneTrackData",
          value: function findBoneTrackData(t, e) {
            var n = /\[(.*)\]\.(.*)/,
                i = {
              name: t
            };

            for (var _r155 = 0; _r155 < e.length; ++_r155) {
              var _s91 = n.exec(e[_r155].name);

              _s91 && t === _s91[1] && (i[_s91[2]] = _r155);
            }

            return i;
          }
        }, {
          key: "getEqualsBonesNames",
          value: function getEqualsBonesNames(t, e) {
            var n = this.getBones(t),
                i = this.getBones(e),
                r = [];

            t: for (var _t376 = 0; _t376 < n.length; _t376++) {
              var _e319 = n[_t376].name;

              for (var _t377 = 0; _t377 < i.length; _t377++) {
                if (_e319 === i[_t377].name) {
                  r.push(_e319);
                  continue t;
                }
              }
            }

            return r;
          }
        }, {
          key: "clone",
          value: function clone(t) {
            var e = new Map(),
                n = new Map(),
                i = t.clone();
            return sd(t, i, function (t, i) {
              e.set(i, t), n.set(t, i);
            }), i.traverse(function (t) {
              if (!t.isSkinnedMesh) return;
              var i = t,
                  r = e.get(t),
                  s = r.skeleton.bones;
              i.skeleton = r.skeleton.clone(), i.bindMatrix.copy(r.bindMatrix), i.skeleton.bones = s.map(function (t) {
                return n.get(t);
              }), i.bind(i.skeleton, i.bindMatrix);
            }), i;
          }
        }]);

        return _class32;
      }().clone(this.scene);

      ud(e, this.scene);
      var n = [e],
          i = t.userData ? Object.assign({}, t.userData) : {};
      return Object.assign(Object.assign({}, t), {
        scene: e,
        scenes: n,
        userData: i
      });
    }
  }], [{
    key: "prepare",
    value: function prepare(t) {
      if (null == t.scene) throw new Error("Model does not have a scene");
      if (t[ad]) return t;
      var e = this[od](t);
      return e[ad] = !0, e;
    }
  }, {
    key: od,
    value: function value(t) {
      var e = t.scene,
          n = [e];
      return Object.assign(Object.assign({}, t), {
        scene: e,
        scenes: n
      });
    }
  }]);

  return hd;
}();

var ud = function ud(t, e) {
  dd(t, e, function (t, e) {
    void 0 !== e.userData.variantMaterials && (t.userData.variantMaterials = new Map(e.userData.variantMaterials)), void 0 !== e.userData.originalMaterial && (t.userData.originalMaterial = e.userData.originalMaterial);
  });
},
    dd = function dd(t, e, n) {
  n(t, e);

  for (var _i232 = 0; _i232 < t.children.length; _i232++) {
    dd(t.children[_i232], e.children[_i232], n);
  }
},
    pd = "\n#ifdef ALPHATEST\n\n    if ( diffuseColor.a < ALPHATEST ) discard;\n    diffuseColor.a = 1.0;\n\n#endif\n",
    Ad = Symbol("threeGLTF"),
    md = Symbol("gltf"),
    gd = Symbol("gltfElementMap"),
    fd = Symbol("threeObjectMap"),
    vd = Symbol("parallelTraverseThreeScene"),
    yd = Symbol("correlateOriginalThreeGLTF"),
    xd = Symbol("correlateCloneThreeGLTF");

var wd = /*#__PURE__*/function () {
  function wd(t, e, n, i) {
    _classCallCheck(this, wd);

    this[Ad] = t, this[md] = e, this[gd] = i, this[fd] = n;
  }

  _createClass(wd, [{
    key: "threeGLTF",
    get: function get() {
      return this[Ad];
    }
  }, {
    key: "gltf",
    get: function get() {
      return this[md];
    }
  }, {
    key: "gltfElementMap",
    get: function get() {
      return this[gd];
    }
  }, {
    key: "threeObjectMap",
    get: function get() {
      return this[fd];
    }
  }, {
    key: "loadVariant",
    value: function () {
      var _loadVariant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(t) {
        var _this130 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                e = new Set();

                if (!("variants" in this.threeGLTF.userData && "functions" in this.threeGLTF.userData && "selectVariant" in this.threeGLTF.userData.functions)) {
                  _context16.next = 7;
                  break;
                }

                _context16.next = 4;
                return this.threeGLTF.userData.functions.selectVariant(this.threeGLTF.scene, t, !0, function (t, n, i) {
                  e.add(i);
                  var r = _this130.gltf.materials[i];

                  var s = _this130.gltfElementMap.get(r);

                  null == s && (s = new Set(), _this130.gltfElementMap.set(r, s)), s.add(t.material);
                });

              case 4:
                _context16.t0 = e;
                _context16.next = 8;
                break;

              case 7:
                _context16.t0 = e;

              case 8:
                return _context16.abrupt("return", _context16.t0);

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function loadVariant(_x19) {
        return _loadVariant.apply(this, arguments);
      }

      return loadVariant;
    }()
  }], [{
    key: "from",
    value: function from(t, e) {
      return null != e ? this[xd](t, e) : this[yd](t);
    }
  }, {
    key: yd,
    value: function value(t) {
      var e = t.parser.json,
          n = t.parser.associations,
          i = new Map(),
          r = {
        name: "Default"
      },
          s = {
        type: "materials",
        index: -1
      };
      return n.forEach(function (t, n) {
        null == t && (s.index < 0 && (null == e.materials && (e.materials = []), s.index = e.materials.length, e.materials.push(r)), t = s);
        var _t378 = t,
            a = _t378.type,
            o = _t378.index,
            l = (e[a] || [])[o];
        if (null == l) return;
        var c = i.get(l);
        null == c && (c = new Set(), i.set(l, c)), c.add(n);
      }), new wd(t, e, n, i);
    }
  }, {
    key: xd,
    value: function value(t, e) {
      var n = e.threeGLTF,
          i = e.gltf,
          r = JSON.parse(JSON.stringify(i)),
          s = new Map(),
          a = new Map(),
          o = {
        name: "Default"
      },
          l = {
        type: "materials",
        index: -1
      };

      for (var _i233 = 0; _i233 < n.scenes.length; _i233++) {
        this[vd](n.scenes[_i233], t.scenes[_i233], function (t, n) {
          var i = e.threeObjectMap.get(t);

          if ((t.isMesh || t.isMaterial) && null == i) {
            if (r.materials && r.materials.length) {
              "Default" === r.materials[r.materials.length - 1].name && (l.index = r.materials.length - 1);
            }

            l.index < 0 && (null == r.materials && (r.materials = []), l.index = r.materials.length, r.materials.push(o)), i = l;
          }

          if (null == i) return;
          var _i234 = i,
              c = _i234.type,
              h = _i234.index,
              u = r[c][h];
          s.set(n, {
            type: c,
            index: h
          });
          var d = a.get(u) || new Set();
          d.add(n), a.set(u, d);
        });
      }

      return new wd(t, r, s, a);
    }
  }, {
    key: vd,
    value: function value(t, e, n) {
      var i = function i(t, e) {
        if (n(t, e), t.isObject3D) {
          if (t.isMesh) if (Array.isArray(t.material)) for (var _n287 = 0; _n287 < t.material.length; ++_n287) {
            i(t.material[_n287], e.material[_n287]);
          } else i(t.material, e.material);

          for (var _n288 = 0; _n288 < t.children.length; ++_n288) {
            i(t.children[_n288], e.children[_n288]);
          }
        }
      };

      i(t, e);
    }
  }]);

  return wd;
}();
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ed = Symbol("cloneAndPatchMaterial"),
    bd = Symbol("correlatedSceneGraph");

var _d = /*#__PURE__*/function (_hd) {
  _inherits(_d, _hd);

  var _super128 = _createSuper(_d);

  function _d() {
    _classCallCheck(this, _d);

    return _super128.apply(this, arguments);
  }

  _createClass(_d, [{
    key: "correlatedSceneGraph",
    get: function get() {
      return this[ld][bd];
    }
  }, {
    key: cd,
    value: function value() {
      var _this131 = this;

      var t = _get(_getPrototypeOf(_d.prototype), cd, this).call(this),
          e = new Map();

      return t.scene.traverse(function (t) {
        if (t.isMesh) {
          var n = t;
          Array.isArray(n.material) ? n.material = n.material.map(function (t) {
            return _this131[Ed](t, e);
          }) : null != n.material && (n.material = _this131[Ed](n.material, e));
        }
      }), t[bd] = wd.from(t, this.correlatedSceneGraph), t;
    }
  }, {
    key: Ed,
    value: function value(t, e) {
      if (e.has(t.uuid)) return e.get(t.uuid);
      var n = t.clone();
      null != t.map && (n.map = t.map.clone(), n.map.needsUpdate = !0), null != t.normalMap && (n.normalMap = t.normalMap.clone(), n.normalMap.needsUpdate = !0), null != t.emissiveMap && (n.emissiveMap = t.emissiveMap.clone(), n.emissiveMap.needsUpdate = !0);
      var i = null;

      if (null != t.roughnessMap && (i = t.roughnessMap.clone()), null != i) {
        i.needsUpdate = !0, n.roughnessMap = i;
        var _Dd$singleton = Dd.singleton,
            _t379 = _Dd$singleton.threeRenderer,
            _e320 = _Dd$singleton.roughnessMipmapper,
            _r156 = _t379.xr.enabled;
        _t379.xr.enabled = !1, _e320.generateMipmaps(n), _t379.xr.enabled = _r156;
      }

      t.roughnessMap === t.metalnessMap ? n.metalnessMap = i : null != t.metalnessMap && (n.metalnessMap = t.metalnessMap.clone(), n.metalnessMap.needsUpdate = !0), t.roughnessMap === t.aoMap ? n.aoMap = i : null != t.aoMap && (n.aoMap = t.aoMap.clone(), n.aoMap.needsUpdate = !0);
      var r = t.onBeforeCompile;
      return n.onBeforeCompile = t.isGLTFSpecularGlossinessMaterial ? function (t) {
        r(t, void 0), t.fragmentShader = t.fragmentShader.replace("#include <alphatest_fragment>", pd);
      } : function (t) {
        t.fragmentShader = t.fragmentShader.replace("#include <alphatest_fragment>", pd), r(t, void 0);
      }, n.shadowSide = 0, n.transparent && (n.depthWrite = !1), n.alphaTest || n.transparent || (n.alphaTest = -.5), e.set(t.uuid, n), n;
    }
  }], [{
    key: od,
    value: function value(t) {
      var e = _get(_getPrototypeOf(_d), od, this).call(this, t);

      null == e[bd] && (e[bd] = wd.from(e));
      var n = e.scene;
      return n.traverse(function (t) {
        t.renderOrder = 1e3, t.frustumCulled = !1, t.name || (t.name = t.uuid), t.isMesh && (t.castShadow = !0);
      }), e;
    }
  }]);

  return _d;
}(hd);
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Id = /*#__PURE__*/function (_Ps2) {
  _inherits(Id, _Ps2);

  var _super129 = _createSuper(Id);

  function Id() {
    var _this132;

    _classCallCheck(this, Id);

    _this132 = _super129.call(this), _this132.position.y = -3.5;
    var t = new Bn();
    t.deleteAttribute("uv");
    var e = new Ro({
      metalness: 0,
      side: 1
    }),
        n = new Ro({
      metalness: 0
    }),
        i = new yl(16777215, 500, 28, 2);
    i.position.set(.418, 16.199, .3), _this132.add(i);
    var r = new Mn(t, e);
    r.position.set(-.757, 13.219, .717), r.scale.set(31.713, 28.305, 28.591), _this132.add(r);
    var s = new Mn(t, n);
    s.position.set(-10.906, 2.009, 1.846), s.rotation.set(0, -.195, 0), s.scale.set(2.328, 7.905, 4.651), _this132.add(s);
    var a = new Mn(t, n);
    a.position.set(-5.607, -.754, -.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), _this132.add(a);
    var o = new Mn(t, n);
    o.position.set(6.167, .857, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), _this132.add(o);
    var l = new Mn(t, n);
    l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), _this132.add(l);
    var c = new Mn(t, n);
    c.position.set(2.291, -.756, -2.621), c.rotation.set(0, -.286, 0), c.scale.set(1.546, 1.552, 1.496), _this132.add(c);
    var h = new Mn(t, n);
    h.position.set(-2.193, -.369, -5.547), h.rotation.set(0, .516, 0), h.scale.set(3.875, 3.487, 2.986), _this132.add(h);
    var u = new Mn(t, _this132.createAreaLightMaterial(50));
    u.position.set(-16.116, 14.37, 8.208), u.scale.set(.1, 2.428, 2.739), _this132.add(u);
    var d = new Mn(t, _this132.createAreaLightMaterial(50));
    d.position.set(-16.109, 18.021, -8.207), d.scale.set(.1, 2.425, 2.751), _this132.add(d);
    var p = new Mn(t, _this132.createAreaLightMaterial(17));
    p.position.set(14.904, 12.198, -1.832), p.scale.set(.15, 4.265, 6.331), _this132.add(p);
    var A = new Mn(t, _this132.createAreaLightMaterial(43));
    A.position.set(-.462, 8.89, 14.52), A.scale.set(4.38, 5.441, .088), _this132.add(A);
    var m = new Mn(t, _this132.createAreaLightMaterial(20));
    m.position.set(3.235, 11.486, -12.541), m.scale.set(2.5, 2, .1), _this132.add(m);
    var g = new Mn(t, _this132.createAreaLightMaterial(100));
    g.position.set(0, 20, 0), g.scale.set(1, .1, 1), _this132.add(g);
    return _this132;
  }

  _createClass(Id, [{
    key: "createAreaLightMaterial",
    value: function createAreaLightMaterial(t) {
      var e = new je();
      return e.color.setScalar(t), e;
    }
  }]);

  return Id;
}(Ps);
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cd = /*#__PURE__*/function (_Ps3) {
  _inherits(Cd, _Ps3);

  var _super130 = _createSuper(Cd);

  function Cd() {
    var _this133;

    _classCallCheck(this, Cd);

    _this133 = _super130.call(this), _this133.position.y = -3.5;
    var t = new Bn();
    t.deleteAttribute("uv");
    var e = new Ro({
      metalness: 0,
      side: 1
    }),
        n = new Ro({
      metalness: 0
    }),
        i = new yl(16777215, 400, 28, 2);
    i.position.set(.5, 14, .5), _this133.add(i);
    var r = new Mn(t, e);
    r.position.set(0, 13.2, 0), r.scale.set(31.5, 28.5, 31.5), _this133.add(r);
    var s = new Mn(t, n);
    s.position.set(-10.906, -1, 1.846), s.rotation.set(0, -.195, 0), s.scale.set(2.328, 7.905, 4.651), _this133.add(s);
    var a = new Mn(t, n);
    a.position.set(-5.607, -.754, -.758), a.rotation.set(0, .994, 0), a.scale.set(1.97, 1.534, 3.955), _this133.add(a);
    var o = new Mn(t, n);
    o.position.set(6.167, -.16, 7.803), o.rotation.set(0, .561, 0), o.scale.set(3.927, 6.285, 3.687), _this133.add(o);
    var l = new Mn(t, n);
    l.position.set(-2.017, .018, 6.124), l.rotation.set(0, .333, 0), l.scale.set(2.002, 4.566, 2.064), _this133.add(l);
    var c = new Mn(t, n);
    c.position.set(2.291, -.756, -2.621), c.rotation.set(0, -.286, 0), c.scale.set(1.546, 1.552, 1.496), _this133.add(c);
    var h = new Mn(t, n);
    h.position.set(-2.193, -.369, -5.547), h.rotation.set(0, .516, 0), h.scale.set(3.875, 3.487, 2.986), _this133.add(h);
    var u = new Mn(t, _this133.createAreaLightMaterial(80));
    u.position.set(-14, 10, 8), u.scale.set(.1, 2.5, 2.5), _this133.add(u);
    var d = new Mn(t, _this133.createAreaLightMaterial(80));
    d.position.set(-14, 14, -4), d.scale.set(.1, 2.5, 2.5), _this133.add(d);
    var p = new Mn(t, _this133.createAreaLightMaterial(23));
    p.position.set(14, 12, 0), p.scale.set(.1, 5, 5), _this133.add(p);
    var A = new Mn(t, _this133.createAreaLightMaterial(16));
    A.position.set(0, 9, 14), A.scale.set(5, 5, .1), _this133.add(A);
    var m = new Mn(t, _this133.createAreaLightMaterial(80));
    m.position.set(7, 8, -14), m.scale.set(2.5, 2.5, .1), _this133.add(m);
    var g = new Mn(t, _this133.createAreaLightMaterial(80));
    g.position.set(-7, 16, -14), g.scale.set(2.5, 2.5, .1), _this133.add(g);
    var f = new Mn(t, _this133.createAreaLightMaterial(1));
    f.position.set(0, 20, 0), f.scale.set(.1, .1, .1), _this133.add(f);
    return _this133;
  }

  _createClass(Cd, [{
    key: "createAreaLightMaterial",
    value: function createAreaLightMaterial(t) {
      var e = new je();
      return e.color.setScalar(t), e;
    }
  }]);

  return Cd;
}(Ps);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Md = /\.hdr(\.js)?$/,
    Sd = new rl(),
    Bd = new ( /*#__PURE__*/function (_il) {
  _inherits(_class33, _il);

  var _super131 = _createSuper(_class33);

  function _class33(t) {
    var _this134;

    _classCallCheck(this, _class33);

    _this134 = _super131.call(this, t), _this134.type = 1015;
    return _this134;
  }

  _createClass(_class33, [{
    key: "parse",
    value: function parse(t) {
      var e = function e(t, _e321) {
        switch (t) {
          case 1:
            console.error("THREE.RGBELoader Read Error: " + (_e321 || ""));
            break;

          case 2:
            console.error("THREE.RGBELoader Write Error: " + (_e321 || ""));
            break;

          case 3:
            console.error("THREE.RGBELoader Bad File Format: " + (_e321 || ""));
            break;

          default:
          case 4:
            console.error("THREE.RGBELoader: Error: " + (_e321 || ""));
        }

        return -1;
      },
          n = function n(t, e, _n289) {
        e = e || 1024;
        var i = t.pos,
            r = -1,
            s = 0,
            a = "",
            o = String.fromCharCode.apply(null, new Uint16Array(t.subarray(i, i + 128)));

        for (; 0 > (r = o.indexOf("\n")) && s < e && i < t.byteLength;) {
          a += o, s += o.length, i += 128, o += String.fromCharCode.apply(null, new Uint16Array(t.subarray(i, i + 128)));
        }

        return -1 < r && (!1 !== _n289 && (t.pos += s + r + 1), a + o.slice(0, r));
      },
          i = function i(t, e, n, _i235) {
        var r = t[e + 3],
            s = Math.pow(2, r - 128) / 255;
        n[_i235 + 0] = t[e + 0] * s, n[_i235 + 1] = t[e + 1] * s, n[_i235 + 2] = t[e + 2] * s;
      },
          r = function r(t, e, n, i) {
        var r = t[e + 3],
            s = Math.pow(2, r - 128) / 255;
        n[i + 0] = Kl.toHalfFloat(t[e + 0] * s), n[i + 1] = Kl.toHalfFloat(t[e + 1] * s), n[i + 2] = Kl.toHalfFloat(t[e + 2] * s);
      },
          s = new Uint8Array(t);

      s.pos = 0;

      var a = function (t) {
        var i = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/,
            r = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/,
            s = /^\s*FORMAT=(\S+)\s*$/,
            a = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/,
            o = {
          valid: 0,
          string: "",
          comments: "",
          programtype: "RGBE",
          format: "",
          gamma: 1,
          exposure: 1,
          width: 0,
          height: 0
        };
        var l, c;
        if (t.pos >= t.byteLength || !(l = n(t))) return e(1, "no header found");
        if (!(c = l.match(/^#\?(\S+)/))) return e(3, "bad initial token");

        for (o.valid |= 1, o.programtype = c[1], o.string += l + "\n"; l = n(t), !1 !== l;) {
          if (o.string += l + "\n", "#" !== l.charAt(0)) {
            if ((c = l.match(i)) && (o.gamma = parseFloat(c[1], 10)), (c = l.match(r)) && (o.exposure = parseFloat(c[1], 10)), (c = l.match(s)) && (o.valid |= 2, o.format = c[1]), (c = l.match(a)) && (o.valid |= 4, o.height = parseInt(c[1], 10), o.width = parseInt(c[2], 10)), 2 & o.valid && 4 & o.valid) break;
          } else o.comments += l + "\n";
        }

        return 2 & o.valid ? 4 & o.valid ? o : e(3, "missing image size specifier") : e(3, "missing format specifier");
      }(s);

      if (-1 !== a) {
        var _t380 = a.width,
            _n290 = a.height,
            _o42 = function (t, n, i) {
          var r = n;
          if (r < 8 || r > 32767 || 2 !== t[0] || 2 !== t[1] || 128 & t[2]) return new Uint8Array(t);
          if (r !== (t[2] << 8 | t[3])) return e(3, "wrong scanline width");
          var s = new Uint8Array(4 * n * i);
          if (!s.length) return e(4, "unable to allocate buffer space");
          var a = 0,
              o = 0;
          var l = 4 * r,
              c = new Uint8Array(4),
              h = new Uint8Array(l);
          var u = i;

          for (; u > 0 && o < t.byteLength;) {
            if (o + 4 > t.byteLength) return e(1);
            if (c[0] = t[o++], c[1] = t[o++], c[2] = t[o++], c[3] = t[o++], 2 != c[0] || 2 != c[1] || (c[2] << 8 | c[3]) != r) return e(3, "bad rgbe scanline format");

            var _n291 = void 0,
                _i236 = 0;

            for (; _i236 < l && o < t.byteLength;) {
              _n291 = t[o++];

              var _r157 = _n291 > 128;

              if (_r157 && (_n291 -= 128), 0 === _n291 || _i236 + _n291 > l) return e(3, "bad scanline data");

              if (_r157) {
                var _e322 = t[o++];

                for (var _t381 = 0; _t381 < _n291; _t381++) {
                  h[_i236++] = _e322;
                }
              } else h.set(t.subarray(o, o + _n291), _i236), _i236 += _n291, o += _n291;
            }

            var _d14 = r;

            for (var _t382 = 0; _t382 < _d14; _t382++) {
              var _e323 = 0;
              s[a] = h[_t382 + _e323], _e323 += r, s[a + 1] = h[_t382 + _e323], _e323 += r, s[a + 2] = h[_t382 + _e323], _e323 += r, s[a + 3] = h[_t382 + _e323], a += 4;
            }

            u--;
          }

          return s;
        }(s.subarray(s.pos), _t380, _n290);

        if (-1 !== _o42) {
          var _e324, _s92, _l36, _c30;

          switch (this.type) {
            case 1009:
              _e324 = _o42, _s92 = 1023, _l36 = 1009;
              break;

            case 1015:
              _c30 = _o42.length / 4 * 3;

              var _t383 = new Float32Array(_c30);

              for (var _e325 = 0; _e325 < _c30; _e325++) {
                i(_o42, 4 * _e325, _t383, 3 * _e325);
              }

              _e324 = _t383, _s92 = 1022, _l36 = 1015;
              break;

            case 1016:
              _c30 = _o42.length / 4 * 3;

              var _n292 = new Uint16Array(_c30);

              for (var _t384 = 0; _t384 < _c30; _t384++) {
                r(_o42, 4 * _t384, _n292, 3 * _t384);
              }

              _e324 = _n292, _s92 = 1022, _l36 = 1016;
              break;

            default:
              console.error("THREE.RGBELoader: unsupported type: ", this.type);
          }

          return {
            width: _t380,
            height: _n290,
            data: _e324,
            header: a.string,
            gamma: a.gamma,
            exposure: a.exposure,
            format: _s92,
            type: _l36
          };
        }
      }

      return null;
    }
  }, {
    key: "setDataType",
    value: function setDataType(t) {
      return this.type = t, this;
    }
  }, {
    key: "load",
    value: function load(t, e, n, i) {
      return _get(_getPrototypeOf(_class33.prototype), "load", this).call(this, t, function (t, n) {
        switch (t.type) {
          case 1009:
            t.encoding = 3002, t.minFilter = 1003, t.magFilter = 1003, t.generateMipmaps = !1, t.flipY = !0;
            break;

          case 1015:
          case 1016:
            t.encoding = 3e3, t.minFilter = 1006, t.magFilter = 1006, t.generateMipmaps = !1, t.flipY = !0;
        }

        e && e(t, n);
      }, n, i);
    }
  }]);

  return _class33;
}(il))();
Bd.setDataType(1009);
var Td = {
  url: null
};

var Ld = /*#__PURE__*/function (_tt10) {
  _inherits(Ld, _tt10);

  var _super132 = _createSuper(Ld);

  function Ld(t) {
    var _this135;

    _classCallCheck(this, Ld);

    _this135 = _super132.call(this), _this135.generatedEnvironmentMap = null, _this135.generatedEnvironmentMapAlt = null, _this135.skyboxCache = new Map(), _this135.environmentMapCache = new Map(), _this135.PMREMGenerator = new Ei(t);
    return _this135;
  }

  _createClass(Ld, [{
    key: "load",
    value: function () {
      var _load2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t) {
        var e,
            n,
            _i237,
            _r158,
            _args17 = arguments;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                e = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : function () {};
                _context17.prev = 1;
                n = Md.test(t);
                _i237 = n ? Bd : Sd;
                _context17.next = 6;
                return new Promise(function (n, r) {
                  return _i237.load(t, n, function (t) {
                    e(t.loaded / t.total * .9);
                  }, r);
                });

              case 6:
                _r158 = _context17.sent;
                return _context17.abrupt("return", (e(1), this.addMetadata(_r158, t), _r158.mapping = 303, n || (_r158.encoding = 3007), _r158));

              case 8:
                _context17.prev = 8;
                e && e(1);
                return _context17.finish(8);

              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[1,, 8, 11]]);
      }));

      function load(_x20) {
        return _load2.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "generateEnvironmentMapAndSkybox",
    value: function () {
      var _generateEnvironmentMapAndSkybox = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var t,
            e,
            n,
            i,
            r,
            s,
            a,
            _e326,
            _n293,
            _yield$Promise$all,
            _yield$Promise$all2,
            _o43,
            _l37,
            _args18 = arguments;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                t = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : null;
                e = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : null;
                n = _args18.length > 2 && _args18[2] !== undefined ? _args18[2] : {};
                i = n.progressTracker, r = null != i ? i.beginActivity() : function () {}, s = "neutral" === e;
                !0 === s && (e = null);
                a = Xh(e);
                _context18.prev = 6;
                _n293 = Promise.resolve(null);
                t && (_n293 = this.loadSkyboxFromUrl(t, i)), _e326 = a ? this.loadEnvironmentMapFromUrl(a, i) : t ? this.loadEnvironmentMapFromUrl(t, i) : !0 === s ? this.loadGeneratedEnvironmentMapAlt() : this.loadGeneratedEnvironmentMap();
                _context18.next = 11;
                return Promise.all([_e326, _n293]);

              case 11:
                _yield$Promise$all = _context18.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                _o43 = _yield$Promise$all2[0];
                _l37 = _yield$Promise$all2[1];

                if (!(null == _o43)) {
                  _context18.next = 17;
                  break;
                }

                throw new Error("Failed to load environment map.");

              case 17:
                return _context18.abrupt("return", {
                  environmentMap: _o43,
                  skybox: _l37
                });

              case 18:
                _context18.prev = 18;
                r(1);
                return _context18.finish(18);

              case 21:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[6,, 18, 21]]);
      }));

      function generateEnvironmentMapAndSkybox() {
        return _generateEnvironmentMapAndSkybox.apply(this, arguments);
      }

      return generateEnvironmentMapAndSkybox;
    }()
  }, {
    key: "addMetadata",
    value: function addMetadata(t, e) {
      null != t && (t.userData = Object.assign(Object.assign({}, Td), {
        url: e
      }));
    }
  }, {
    key: "loadSkyboxFromUrl",
    value: function loadSkyboxFromUrl(t, e) {
      if (!this.skyboxCache.has(t)) {
        var n = e ? e.beginActivity() : function () {},
            _i238 = this.load(t, n);

        this.skyboxCache.set(t, _i238);
      }

      return this.skyboxCache.get(t);
    }
  }, {
    key: "loadEnvironmentMapFromUrl",
    value: function loadEnvironmentMapFromUrl(t, e) {
      var _this136 = this;

      if (!this.environmentMapCache.has(t)) {
        var n = this.loadSkyboxFromUrl(t, e).then(function (e) {
          var n = _this136.PMREMGenerator.fromEquirectangular(e);

          return _this136.addMetadata(n.texture, t), n;
        });
        this.PMREMGenerator.compileEquirectangularShader(), this.environmentMapCache.set(t, n);
      }

      return this.environmentMapCache.get(t);
    }
  }, {
    key: "loadGeneratedEnvironmentMap",
    value: function loadGeneratedEnvironmentMap() {
      if (null == this.generatedEnvironmentMap) {
        var _t385 = new Id();

        this.generatedEnvironmentMap = this.PMREMGenerator.fromScene(_t385, .04), this.addMetadata(this.generatedEnvironmentMap.texture, null);
      }

      return Promise.resolve(this.generatedEnvironmentMap);
    }
  }, {
    key: "loadGeneratedEnvironmentMapAlt",
    value: function loadGeneratedEnvironmentMapAlt() {
      if (null == this.generatedEnvironmentMapAlt) {
        var _t386 = new Cd();

        this.generatedEnvironmentMapAlt = this.PMREMGenerator.fromScene(_t386, .04), this.addMetadata(this.generatedEnvironmentMapAlt.texture, null);
      }

      return Promise.resolve(this.generatedEnvironmentMapAlt);
    }
  }, {
    key: "dispose",
    value: function () {
      var _dispose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var t, _i239, _t387, _e327;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                t = [];
                this.environmentMapCache.forEach(function (e) {
                  t.push(e);
                }), this.environmentMapCache.clear();
                _i239 = 0, _t387 = t;

              case 3:
                if (!(_i239 < _t387.length)) {
                  _context19.next = 16;
                  break;
                }

                _e327 = _t387[_i239];
                _context19.prev = 5;
                _context19.next = 8;
                return _e327;

              case 8:
                _context19.sent.dispose();

                _context19.next = 13;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](5);

              case 13:
                _i239++;
                _context19.next = 3;
                break;

              case 16:
                null != this.generatedEnvironmentMap && (this.generatedEnvironmentMap.dispose(), this.generatedEnvironmentMap = null), null != this.generatedEnvironmentMapAlt && (this.generatedEnvironmentMapAlt.dispose(), this.generatedEnvironmentMapAlt = null);

              case 17:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[5, 11]]);
      }));

      function dispose() {
        return _dispose.apply(this, arguments);
      }

      return dispose;
    }()
  }]);

  return Ld;
}(tt);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Rd = [1, .79, .62, .5, .4, .31, .25];

var Dd = /*#__PURE__*/function (_tt11) {
  _inherits(Dd, _tt11);

  var _super133 = _createSuper(Dd);

  function Dd(t) {
    var _this137;

    _classCallCheck(this, Dd);

    _this137 = _super133.call(this), _this137.loader = new Hh(_d), _this137.width = 0, _this137.height = 0, _this137.dpr = 1, _this137.debugger = null, _this137.scenes = new Set(), _this137.multipleScenesVisible = !1, _this137.scaleStep = 0, _this137.lastStep = 3, _this137.avgFrameDuration = 22, _this137.onWebGLContextLost = function (t) {
      _this137.dispatchEvent({
        type: "contextlost",
        sourceEvent: t
      });
    }, _this137.onWebGLContextRestored = function () {
      var t;
      null === (t = _this137.textureUtils) || void 0 === t || t.dispose(), _this137.textureUtils = new Ld(_this137.threeRenderer), _this137.roughnessMipmapper = new Qu(_this137.threeRenderer);

      var _iterator15 = _createForOfIteratorHelper(_this137.scenes),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _t388 = _step15.value;

          _t388.element[Uu]();
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      _this137.threeRenderer.shadowMap.needsUpdate = !0;
    }, _this137.dpr = eu(), _this137.canvas3D = document.createElement("canvas"), _this137.canvas3D.id = "webgl-canvas";

    try {
      _this137.threeRenderer = new Qs({
        canvas: _this137.canvas3D,
        alpha: !0,
        antialias: !0,
        powerPreference: t.powerPreference,
        preserveDrawingBuffer: !0
      }), _this137.threeRenderer.autoClear = !0, _this137.threeRenderer.outputEncoding = 3007, _this137.threeRenderer.physicallyCorrectLights = !0, _this137.threeRenderer.setPixelRatio(1), _this137.threeRenderer.shadowMap.enabled = !0, _this137.threeRenderer.shadowMap.type = 2, _this137.threeRenderer.shadowMap.autoUpdate = !1, _this137.debugger = t.debug ? new rd(_assertThisInitialized(_this137)) : null, _this137.threeRenderer.debug = {
        checkShaderErrors: !!_this137.debugger
      }, _this137.threeRenderer.toneMapping = 4;
    } catch (t) {
      console.warn(t);
    }

    _this137.arRenderer = new id(_assertThisInitialized(_this137)), _this137.textureUtils = _this137.canRender ? new Ld(_this137.threeRenderer) : null, _this137.roughnessMipmapper = new Qu(_this137.threeRenderer), Hh.initializeKTX2Loader(_this137.threeRenderer), _this137.canvas3D.addEventListener("webglcontextlost", _this137.onWebGLContextLost), _this137.canvas3D.addEventListener("webglcontextrestored", _this137.onWebGLContextRestored), _this137.updateRendererSize(), _this137.lastTick = performance.now(), _this137.avgFrameDuration = 0;
    return _this137;
  }

  _createClass(Dd, [{
    key: "canRender",
    get: function get() {
      return null != this.threeRenderer;
    }
  }, {
    key: "scaleFactor",
    get: function get() {
      return Rd[this.scaleStep];
    }
  }, {
    key: "minScale",
    set: function set(t) {
      var e = 1;

      for (; e < Rd.length && !(Rd[e] < t);) {
        ++e;
      }

      this.lastStep = e - 1;
    }
  }, {
    key: "updateRendererSize",
    value: function updateRendererSize() {
      var t = eu();

      if (t !== this.dpr) {
        var _iterator16 = _createForOfIteratorHelper(this.scenes),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _t389 = _step16.value;
            var _e328 = _t389.element;

            _e328[sp](_e328.getBoundingClientRect());
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }

      var e = 0,
          n = 0;

      var _iterator17 = _createForOfIteratorHelper(this.scenes),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _t390 = _step17.value;
          e = Math.max(e, _t390.width), n = Math.max(n, _t390.height);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      if (e === this.width && n === this.height && t === this.dpr) return;
      this.width = e, this.height = n, this.dpr = t, this.canRender && this.threeRenderer.setSize(e * t, n * t, !1);
      var i = this.scaleFactor,
          r = e / i,
          s = n / i;
      this.canvas3D.style.width = "".concat(r, "px"), this.canvas3D.style.height = "".concat(s, "px");

      var _iterator18 = _createForOfIteratorHelper(this.scenes),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _i240 = _step18.value;
          var _a68 = _i240.canvas;
          _a68.width = Math.round(e * t), _a68.height = Math.round(n * t), _a68.style.width = "".concat(r, "px"), _a68.style.height = "".concat(s, "px"), _i240.isDirty = !0;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }
  }, {
    key: "updateRendererScale",
    value: function updateRendererScale() {
      var t = this.scaleStep;
      if (this.avgFrameDuration > 26 && this.scaleStep < this.lastStep ? ++this.scaleStep : this.avgFrameDuration < 18 && this.scaleStep > 0 && --this.scaleStep, t == this.scaleStep) return;
      var e = this.scaleFactor;
      this.avgFrameDuration = 22;
      var n = this.width / e,
          i = this.height / e;
      this.canvas3D.style.width = "".concat(n, "px"), this.canvas3D.style.height = "".concat(i, "px");

      var _iterator19 = _createForOfIteratorHelper(this.scenes),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _t391 = _step19.value;
          var _e329 = _t391.canvas.style;
          _e329.width = "".concat(n, "px"), _e329.height = "".concat(i, "px"), _t391.isDirty = !0;
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }, {
    key: "registerScene",
    value: function registerScene(t) {
      var _this138 = this;

      this.scenes.add(t);
      var e = t.canvas,
          n = this.scaleFactor;
      e.width = Math.round(this.width * this.dpr), e.height = Math.round(this.height * this.dpr), e.style.width = this.width / n + "px", e.style.height = this.height / n + "px", this.multipleScenesVisible && e.classList.add("show"), t.isDirty = !0, this.canRender && this.scenes.size > 0 && this.threeRenderer.setAnimationLoop(function (t, e) {
        return _this138.render(t, e);
      }), null != this.debugger && this.debugger.addScene(t);
    }
  }, {
    key: "unregisterScene",
    value: function unregisterScene(t) {
      this.scenes.delete(t), this.canRender && 0 === this.scenes.size && this.threeRenderer.setAnimationLoop(null), null != this.debugger && this.debugger.removeScene(t);
    }
  }, {
    key: "displayCanvas",
    value: function displayCanvas(t) {
      return this.multipleScenesVisible ? t.element[mp] : this.canvas3D;
    }
  }, {
    key: "selectCanvas",
    value: function selectCanvas() {
      var t = 0,
          e = null;

      var _iterator20 = _createForOfIteratorHelper(this.scenes),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _n294 = _step20.value;
          var _i241 = _n294.element;
          _i241.modelIsVisible && null == _n294.externalRenderer && (++t, e = _n294.canvas);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      if (null == e) return;
      var n = t > 1,
          i = this.canvas3D;

      if (n !== this.multipleScenesVisible || !n && i.parentElement !== e.parentElement) {
        this.multipleScenesVisible = n, n && i.classList.remove("show");

        var _iterator21 = _createForOfIteratorHelper(this.scenes),
            _step21;

        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _t392 = _step21.value;
            if (null != _t392.externalRenderer) continue;
            var _r159 = _t392.element[mp];
            n ? (_r159.classList.add("show"), _t392.isDirty = !0) : _t392.canvas === e && (_t392.canvas.parentElement.appendChild(i), i.classList.add("show"), _r159.classList.remove("show"), _t392.isDirty = !0);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
      }
    }
  }, {
    key: "orderedScenes",
    value: function orderedScenes() {
      var t = [];

      for (var _i242 = 0, _arr2 = [!1, !0]; _i242 < _arr2.length; _i242++) {
        var _e330 = _arr2[_i242];

        var _iterator22 = _createForOfIteratorHelper(this.scenes),
            _step22;

        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var n = _step22.value;
            n.element.modelIsVisible === _e330 && t.push(n);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
      }

      return t;
    }
  }, {
    key: "isPresenting",
    get: function get() {
      return this.arRenderer.isPresenting;
    }
  }, {
    key: "preRender",
    value: function preRender(t, e, n) {
      var i = t.element,
          r = t.exposure;
      i[vp](e, n);
      var s = "number" == typeof r && !self.isNaN(r);
      this.threeRenderer.toneMappingExposure = s ? r : 1, t.isShadowDirty() && (this.threeRenderer.shadowMap.needsUpdate = !0);
    }
  }, {
    key: "render",
    value: function render(t, e) {
      if (null != e) return void this.arRenderer.onWebXRFrame(t, e);
      var n = t - this.lastTick;
      if (this.lastTick = t, !this.canRender || this.isPresenting) return;
      this.avgFrameDuration += tu(.2 * (n - this.avgFrameDuration), -2, 2), this.selectCanvas(), this.updateRendererSize(), this.updateRendererScale();
      var i = this.dpr,
          r = this.scaleFactor;

      var _iterator23 = _createForOfIteratorHelper(this.orderedScenes()),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _e331 = _step23.value;
          var _s93 = _e331.element;
          if (!_s93.modelIsVisible && _e331.renderCount > 0) continue;
          if (this.preRender(_e331, t, n), !_e331.isDirty) continue;

          if (null != _e331.externalRenderer) {
            var _t393 = _e331.getCamera();

            _t393.updateMatrix();

            var _n295 = _t393.matrix,
                _i243 = _t393.projectionMatrix,
                _r160 = _n295.elements.slice(),
                _s94 = _e331.getTarget();

            _r160[12] += _s94.x, _r160[13] += _s94.y, _r160[14] += _s94.z, _e331.externalRenderer.render({
              viewMatrix: _r160,
              projectionMatrix: _i243.elements
            });
            continue;
          }

          if (!_s93.modelIsVisible && !this.multipleScenesVisible) {
            var _iterator24 = _createForOfIteratorHelper(this.scenes),
                _step24;

            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var _t394 = _step24.value;
                _t394.element.modelIsVisible && (_t394.isDirty = !0);
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }
          }

          var _a69 = Math.min(Math.ceil(_e331.width * r * i), this.canvas3D.width),
              _o44 = Math.min(Math.ceil(_e331.height * r * i), this.canvas3D.height);

          if (this.threeRenderer.setRenderTarget(null), this.threeRenderer.setViewport(0, Math.floor(this.height * i) - _o44, _a69, _o44), this.threeRenderer.render(_e331, _e331.camera), this.multipleScenesVisible) {
            null == _e331.context && _e331.createContext();
            var _t395 = _e331.context;
            _t395.clearRect(0, 0, _a69, _o44), _t395.drawImage(this.canvas3D, 0, 0, _a69, _o44, 0, 0, _a69, _o44);
          }

          _e331.isDirty = !1, _s93.loaded && ++_e331.renderCount;
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      null != this.textureUtils && this.textureUtils.dispose(), null != this.roughnessMipmapper && this.roughnessMipmapper.dispose(), null != this.threeRenderer && this.threeRenderer.dispose(), this.textureUtils = null, this.threeRenderer = null;
      var t = [];

      var _iterator25 = _createForOfIteratorHelper(this.scenes),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _e332 = _step25.value;
          t.push(_e332.element);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      return this.canvas3D.removeEventListener("webglcontextlost", this.onWebGLContextLost), this.canvas3D.removeEventListener("webglcontextrestored", this.onWebGLContextRestored), t;
    }
  }], [{
    key: "singleton",
    get: function get() {
      return this._singleton;
    }
  }, {
    key: "resetSingleton",
    value: function resetSingleton() {
      var t = this._singleton.dispose();

      var _iterator26 = _createForOfIteratorHelper(t),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _e333 = _step26.value;

          _e333.disconnectedCallback();
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      this._singleton = new Dd({
        powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
        debug: nu()
      });

      var _iterator27 = _createForOfIteratorHelper(t),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _e334 = _step27.value;

          _e334.connectedCallback();
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }
  }]);

  return Dd;
}(tt);

Dd._singleton = new Dd({
  powerPreference: (self.ModelViewerElement || {}).powerPreference || "high-performance",
  debug: nu()
});
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Qd, Pd;
var Fd = Symbol("ongoingActivities"),
    Nd = Symbol("announceTotalProgress"),
    Ud = Symbol("eventDelegate");

var kd = /*#__PURE__*/function (_ref14) {
  function kd() {
    var _this139 = this;

    _classCallCheck(this, kd);

    this[Qd] = document.createDocumentFragment(), this.addEventListener = function () {
      var _this139$Ud;

      return (_this139$Ud = _this139[Ud]).addEventListener.apply(_this139$Ud, arguments);
    }, this.removeEventListener = function () {
      var _this139$Ud2;

      return (_this139$Ud2 = _this139[Ud]).removeEventListener.apply(_this139$Ud2, arguments);
    }, this.dispatchEvent = function () {
      var _this139$Ud3;

      return (_this139$Ud3 = _this139[Ud]).dispatchEvent.apply(_this139$Ud3, arguments);
    }, this[Pd] = new Set();
  }

  _createClass(kd, [{
    key: "ongoingActivityCount",
    get: function get() {
      return this[Fd].size;
    }
  }, {
    key: "beginActivity",
    value: function beginActivity() {
      var _this140 = this;

      var t = {
        progress: 0
      };
      return this[Fd].add(t), 1 === this.ongoingActivityCount && this[Nd](), function (e) {
        var n;
        return n = Math.max(tu(e, 0, 1), t.progress), n !== t.progress && (t.progress = n, _this140[Nd]()), t.progress;
      };
    }
  }, {
    key: _ref14,
    value: function value() {
      var t = 0,
          e = 0,
          n = 0;

      var _iterator28 = _createForOfIteratorHelper(this[Fd]),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var _i244 = _step28.value;
          var _r161 = _i244.progress;
          t += _r161 * (.5 / Math.pow(2, e++)), 1 === _r161 && n++;
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }

      n === this.ongoingActivityCount && (t = 1, this[Fd].clear()), this.dispatchEvent(new CustomEvent("progress", {
        detail: {
          totalProgress: t
        }
      }));
    }
  }]);

  return kd;
}((Qd = Ud, Pd = Fd, Nd));
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Gd,
    Od,
    Hd,
    zd,
    Vd,
    Wd,
    qd,
    jd,
    Yd,
    Jd,
    Xd = function Xd(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Kd = document.createElement("canvas"),
    Zd = Symbol("template"),
    $d = Symbol("fallbackResizeHandler"),
    tp = Symbol("defaultAriaLabel"),
    ep = Symbol("resizeObserver"),
    np = Symbol("clearModelTimeout"),
    ip = Symbol("onContextLost"),
    rp = Symbol("loaded"),
    sp = Symbol("updateSize"),
    ap = Symbol("intersectionObserver"),
    op = Symbol("isElementInViewport"),
    lp = Symbol("announceModelVisibility"),
    cp = Symbol("ariaLabel"),
    hp = Symbol("loadedTime"),
    up = Symbol("updateSource"),
    dp = Symbol("markLoaded"),
    pp = Symbol("container"),
    Ap = Symbol("input"),
    mp = Symbol("canvas"),
    gp = Symbol("scene"),
    fp = Symbol("needsRender"),
    vp = Symbol("tick"),
    yp = Symbol("onModelLoad"),
    xp = Symbol("onResize"),
    wp = Symbol("renderer"),
    Ep = Symbol("progressTracker"),
    bp = Symbol("getLoaded"),
    _p = Symbol("getModelIsVisible"),
    Ip = Symbol("shouldAttemptPreload"),
    Cp = Symbol("sceneIsReady"),
    Mp = Symbol("hasTransitioned"),
    Sp = function Sp(t) {
  return {
    x: t.x,
    y: t.y,
    z: t.z,
    toString: function toString() {
      return "".concat(this.x, "m ").concat(this.y, "m ").concat(this.z, "m");
    }
  };
};

var Bp = /*#__PURE__*/function (_Q2, _ref15, _ref16) {
  _inherits(Bp, _Q2);

  var _super134 = _createSuper(Bp);

  function Bp() {
    var _this141;

    _classCallCheck(this, Bp);

    _this141 = _super134.call(this), _this141.alt = null, _this141.src = null, _this141[Gd] = !1, _this141[Od] = !1, _this141[Hd] = 0, _this141[zd] = null, _this141[Vd] = $h(function () {
      var t = _this141.getBoundingClientRect();

      _this141[sp](t);
    }, 50), _this141[Wd] = $h(function (t) {
      var e = _this141.modelIsVisible;
      e !== t && _this141.dispatchEvent(new CustomEvent("model-visibility", {
        detail: {
          visible: e
        }
      }));
    }, 0), _this141[qd] = null, _this141[jd] = null, _this141[Yd] = new kd(), _this141[Jd] = function (t) {
      _this141.dispatchEvent(new CustomEvent("error", {
        detail: {
          type: "webglcontextlost",
          sourceError: t.sourceEvent
        }
      }));
    };
    var t = _this141.constructor.template;
    window.ShadyCSS && window.ShadyCSS.styleElement(_assertThisInitialized(_this141), {}), _this141.attachShadow({
      mode: "open"
    });
    var e = _this141.shadowRoot;
    var n, i;

    if (e.appendChild(t.content.cloneNode(!0)), _this141[pp] = e.querySelector(".container"), _this141[Ap] = e.querySelector(".userInput"), _this141[mp] = e.querySelector("canvas"), _this141[tp] = _this141[Ap].getAttribute("aria-label"), _this141.isConnected) {
      var _t396 = _this141.getBoundingClientRect();

      n = _t396.width, i = _t396.height;
    } else n = 300, i = 150;

    _this141[gp] = new Su({
      canvas: _this141[mp],
      element: _assertThisInitialized(_this141),
      width: n,
      height: i
    }), _this141[gp].addEventListener("model-load", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this141[dp]();

                _this141[yp]();

                _context20.next = 4;
                return function () {
                  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                  return new Promise(function (e) {
                    return setTimeout(e, t);
                  });
                }();

              case 4:
                _this141.dispatchEvent(new CustomEvent("load", {
                  detail: {
                    url: t.url
                  }
                }));

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x21) {
        return _ref17.apply(this, arguments);
      };
    }()), Promise.resolve().then(function () {
      _this141[sp](_this141.getBoundingClientRect());
    }), V && (_this141[ep] = new ResizeObserver(function (t) {
      if (!_this141[wp].isPresenting) {
        var _iterator29 = _createForOfIteratorHelper(t),
            _step29;

        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var _e335 = _step29.value;
            _e335.target === _assertThisInitialized(_this141) && _this141[sp](_e335.contentRect);
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }
    })), W ? _this141[ap] = new IntersectionObserver(function (t) {
      var _iterator30 = _createForOfIteratorHelper(t),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var _e336 = _step30.value;

          if (_e336.target === _assertThisInitialized(_this141)) {
            var _t397 = _this141.modelIsVisible;
            _this141[op] = _e336.isIntersecting, _this141[lp](_t397), _this141[op] && !_this141[Cp]() && _this141[up]();
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    }) : _this141[op] = !0;
    return _this141;
  }

  _createClass(Bp, [{
    key: "loaded",
    get: function get() {
      return this[bp]();
    }
  }, {
    key: _ref15,
    get: function get() {
      return Dd.singleton;
    }
  }, {
    key: "modelIsVisible",
    get: function get() {
      return this[_p]();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(Bp.prototype), "connectedCallback", this) && _get(_getPrototypeOf(Bp.prototype), "connectedCallback", this).call(this), V ? this[ep].observe(this) : self.addEventListener("resize", this[$d]), W && this[ap].observe(this);
      var t = this[wp];
      t.addEventListener("contextlost", this[ip]), t.registerScene(this[gp]), null != this[np] && (self.clearTimeout(this[np]), this[np] = null, this.requestUpdate("src", null));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this142 = this;

      _get(_getPrototypeOf(Bp.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(Bp.prototype), "disconnectedCallback", this).call(this), V ? this[ep].unobserve(this) : self.removeEventListener("resize", this[$d]), W && this[ap].unobserve(this);
      var t = this[wp];
      t.removeEventListener("contextlost", this[ip]), t.unregisterScene(this[gp]), this[np] = self.setTimeout(function () {
        _this142[gp].reset();
      }, 1e3);
    }
  }, {
    key: "updated",
    value: function updated(t) {
      if (_get(_getPrototypeOf(Bp.prototype), "updated", this).call(this, t), t.has("src") && (null == this.src ? (this[rp] = !1, this[hp] = 0, this[gp].reset()) : this.src !== this[gp].url && (this[rp] = !1, this[hp] = 0, this[up]())), t.has("alt")) {
        var _t398 = null == this.alt ? this[tp] : this.alt;

        this[Ap].setAttribute("aria-label", _t398);
      }
    }
  }, {
    key: "toDataURL",
    value: function toDataURL(t, e) {
      return this[wp].displayCanvas(this[gp]).toDataURL(t, e);
    }
  }, {
    key: "toBlob",
    value: function () {
      var _toBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
        var _this143 = this;

        var e, n, i, _this$gp, r, s, a, o, _this$wp, l, c, h, u, d, p, _t399, _t400;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                e = t ? t.mimeType : void 0, n = t ? t.qualityArgument : void 0, i = t ? t.idealAspect : void 0, _this$gp = this[gp], r = _this$gp.width, s = _this$gp.height, a = _this$gp.fieldOfViewAspect, o = _this$gp.aspect, _this$wp = this[wp], l = _this$wp.dpr, c = _this$wp.scaleFactor;
                h = r * c * l, u = s * c * l, d = 0, p = 0;
                if (!0 === i) if (a > o) {
                  _t399 = u;
                  u = Math.round(h / a), p = (_t399 - u) / 2;
                } else {
                  _t400 = h;
                  h = Math.round(u * a), d = (_t400 - h) / 2;
                }
                Kd.width = h, Kd.height = u;
                _context23.prev = 4;
                return _context23.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t, i) {
                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            Kd.getContext("2d").drawImage(_this143[wp].displayCanvas(_this143[gp]), d, p, h, u, 0, 0, h, u);

                            if (!(!Kd.msToBlob || e && "image/png" !== e)) {
                              _context22.next = 14;
                              break;
                            }

                            if (!Kd.toBlob) {
                              _context22.next = 6;
                              break;
                            }

                            _context22.t1 = void Kd.toBlob(function (e) {
                              if (!e) return i(new Error("Unable to retrieve canvas blob"));
                              t(e);
                            }, e, n);
                            _context22.next = 11;
                            break;

                          case 6:
                            _context22.t2 = t;
                            _context22.next = 9;
                            return function () {
                              var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(t) {
                                return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                                  while (1) {
                                    switch (_context21.prev = _context21.next) {
                                      case 0:
                                        return _context21.abrupt("return", new Promise(function (e, n) {
                                          var i = t.match(/data:(.*);/);
                                          if (!i) return n(new Error("".concat(t, " is not a valid data Url")));
                                          var r = i[1],
                                              s = t.replace(/data:image\/\w+;base64,/, ""),
                                              a = atob(s),
                                              o = [];

                                          for (var _t401 = 0; _t401 < a.length; _t401 += 512) {
                                            var _e337 = a.slice(_t401, _t401 + 512),
                                                _n296 = new Array(_e337.length);

                                            for (var _t402 = 0; _t402 < _e337.length; _t402++) {
                                              _n296[_t402] = _e337.charCodeAt(_t402);
                                            }

                                            var _i245 = new Uint8Array(_n296);

                                            o.push(_i245);
                                          }

                                          e(new Blob(o, {
                                            type: r
                                          }));
                                        }));

                                      case 1:
                                      case "end":
                                        return _context21.stop();
                                    }
                                  }
                                }, _callee21);
                              }));

                              return function (_x25) {
                                return _ref19.apply(this, arguments);
                              };
                            }()(Kd.toDataURL(e, n));

                          case 9:
                            _context22.t3 = _context22.sent;
                            _context22.t1 = (0, _context22.t2)(_context22.t3);

                          case 11:
                            _context22.t0 = _context22.t1;
                            _context22.next = 15;
                            break;

                          case 14:
                            _context22.t0 = t(Kd.msToBlob());

                          case 15:
                            return _context22.abrupt("return", _context22.t0);

                          case 16:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22);
                  }));

                  return function (_x23, _x24) {
                    return _ref18.apply(this, arguments);
                  };
                }()));

              case 6:
                _context23.prev = 6;
                this[sp]({
                  width: r,
                  height: s
                });
                return _context23.finish(6);

              case 9:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[4,, 6, 9]]);
      }));

      function toBlob(_x22) {
        return _toBlob.apply(this, arguments);
      }

      return toBlob;
    }()
  }, {
    key: "registerRenderer",
    value: function registerRenderer(t) {
      this[gp].externalRenderer = t;
    }
  }, {
    key: "unregisterRenderer",
    value: function unregisterRenderer() {
      this[gp].externalRenderer = null;
    }
  }, {
    key: cp,
    get: function get() {
      return null == this.alt || "null" === this.alt ? this[tp] : this.alt;
    }
  }, {
    key: bp,
    value: function value() {
      return this[rp];
    }
  }, {
    key: _p,
    value: function value() {
      return this.loaded && this[op];
    }
  }, {
    key: Mp,
    value: function value() {
      return this.modelIsVisible;
    }
  }, {
    key: Ip,
    value: function value() {
      return !!this.src && this[op];
    }
  }, {
    key: Cp,
    value: function value() {
      return this[rp];
    }
  }, {
    key: sp,
    value: function value(_ref20) {
      var t = _ref20.width,
          e = _ref20.height;
      this[pp].style.width = "".concat(t, "px"), this[pp].style.height = "".concat(e, "px"), this[xp]({
        width: parseFloat(t),
        height: parseFloat(e)
      });
    }
  }, {
    key: vp,
    value: function value(t, e) {}
  }, {
    key: dp,
    value: function value() {
      this[rp] || (this[rp] = !0, this[hp] = performance.now());
    }
  }, {
    key: fp,
    value: function value() {
      this[gp].isDirty = !0;
    }
  }, {
    key: yp,
    value: function value() {}
  }, {
    key: xp,
    value: function value(t) {
      this[gp].setSize(t.width, t.height);
    }
  }, {
    key: _ref16,
    value: function () {
      var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var t, e, n;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(this.loaded || !this[Ip]())) {
                  _context24.next = 2;
                  break;
                }

                return _context24.abrupt("return");

              case 2:
                t = this[Ep].beginActivity(), e = this.src;
                _context24.prev = 3;
                _context24.next = 6;
                return this[gp].setSource(e, function (e) {
                  return t(.8 * e);
                });

              case 6:
                n = {
                  url: e
                };
                this.dispatchEvent(new CustomEvent("preload", {
                  detail: n
                }));
                _context24.next = 13;
                break;

              case 10:
                _context24.prev = 10;
                _context24.t0 = _context24["catch"](3);
                this.dispatchEvent(new CustomEvent("error", {
                  detail: _context24.t0
                }));

              case 13:
                _context24.prev = 13;
                t(.9), requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    t(1);
                  });
                });
                return _context24.finish(13);

              case 16:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[3, 10, 13, 16]]);
      }));

      function value() {
        return _value.apply(this, arguments);
      }

      return value;
    }()
  }], [{
    key: "is",
    get: function get() {
      return "model-viewer";
    }
  }, {
    key: "template",
    get: function get() {
      return this.hasOwnProperty(Zd) || (this[Zd] = function (t) {
        var e = document.createElement("template");
        return e.innerHTML = $.innerHTML, window.ShadyCSS && window.ShadyCSS.prepareTemplate(e, t), e;
      }(this.is)), this[Zd];
    }
  }, {
    key: "modelCacheSize",
    get: function get() {
      return Hh[Gh].evictionThreshold;
    },
    set: function set(t) {
      Hh[Gh].evictionThreshold = t;
    }
  }, {
    key: "minimumRenderScale",
    get: function get() {
      return Dd.singleton.minScale;
    },
    set: function set(t) {
      t > 1 && console.warn("<model-viewer> minimumRenderScale has been clamped to a maximum value of 1."), t <= 0 && console.warn("<model-viewer> minimumRenderScale has been clamped to a minimum value of 0.25."), Dd.singleton.minScale = t;
    }
  }]);

  return Bp;
}(Q, (Gd = op, Od = rp, Hd = hp, zd = np, Vd = $d, Wd = lp, qd = ep, jd = ap, Yd = Ep, wp), (Jd = ip, up));

Xd([F({
  type: String
})], Bp.prototype, "alt", void 0), Xd([F({
  type: String
})], Bp.prototype, "src", void 0);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Tp = function Tp(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var Lp = Symbol("changeAnimation"),
    Rp = Symbol("paused"),
    Dp = Symbol("hotspotMap"),
    Qp = Symbol("mutationCallback"),
    Pp = Symbol("observer"),
    Fp = Symbol("addHotspot"),
    Np = Symbol("removeHotspot"),
    Up = new pt(),
    kp = new ee(),
    Gp = new At();
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.6.9
*/

var Op = function Op(t) {
  return URL.createObjectURL(new Blob([t], {
    type: "text/javascript"
  }));
};

try {
  URL.revokeObjectURL(Op(""));
} catch (Zc) {
  Op = function Op(t) {
    return "data:application/javascript;charset=UTF-8," + encodeURI(t);
  };
}

var Hp = Uint8Array,
    zp = Uint16Array,
    Vp = Uint32Array,
    Wp = new Hp([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
    qp = new Hp([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
    jp = new Hp([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    Yp = function Yp(t, e) {
  for (var n = new zp(31), i = 0; i < 31; ++i) {
    n[i] = e += 1 << t[i - 1];
  }

  var r = new Vp(n[30]);

  for (i = 1; i < 30; ++i) {
    for (var s = n[i]; s < n[i + 1]; ++s) {
      r[s] = s - n[i] << 5 | i;
    }
  }

  return [n, r];
},
    Jp = Yp(Wp, 2),
    Xp = Jp[0],
    Kp = Jp[1];

Xp[28] = 258, Kp[258] = 28;

for (var Zp = Yp(qp, 0)[1], $p = new zp(32768), tA = 0; tA < 32768; ++tA) {
  var eA = (43690 & tA) >>> 1 | (21845 & tA) << 1;
  eA = (61680 & (eA = (52428 & eA) >>> 2 | (13107 & eA) << 2)) >>> 4 | (3855 & eA) << 4, $p[tA] = ((65280 & eA) >>> 8 | (255 & eA) << 8) >>> 1;
}

var nA = function nA(t, e, n) {
  for (var i = t.length, r = 0, s = new zp(e); r < i; ++r) {
    ++s[t[r] - 1];
  }

  var a,
      o = new zp(e);

  for (r = 0; r < e; ++r) {
    o[r] = o[r - 1] + s[r - 1] << 1;
  }

  if (n) {
    a = new zp(1 << e);
    var l = 15 - e;

    for (r = 0; r < i; ++r) {
      if (t[r]) for (var c = r << 4 | t[r], h = e - t[r], u = o[t[r] - 1]++ << h, d = u | (1 << h) - 1; u <= d; ++u) {
        a[$p[u] >>> l] = c;
      }
    }
  } else for (a = new zp(i), r = 0; r < i; ++r) {
    t[r] && (a[r] = $p[o[t[r] - 1]++] >>> 15 - t[r]);
  }

  return a;
},
    iA = new Hp(288);

for (tA = 0; tA < 144; ++tA) {
  iA[tA] = 8;
}

for (tA = 144; tA < 256; ++tA) {
  iA[tA] = 9;
}

for (tA = 256; tA < 280; ++tA) {
  iA[tA] = 7;
}

for (tA = 280; tA < 288; ++tA) {
  iA[tA] = 8;
}

var rA = new Hp(32);

for (tA = 0; tA < 32; ++tA) {
  rA[tA] = 5;
}

var sA = nA(iA, 9, 0),
    aA = nA(rA, 5, 0),
    oA = function oA(t) {
  return (t / 8 | 0) + (7 & t && 1);
},
    lA = function lA(t, e, n) {
  (null == e || e < 0) && (e = 0), (null == n || n > t.length) && (n = t.length);
  var i = new (t instanceof zp ? zp : t instanceof Vp ? Vp : Hp)(n - e);
  return i.set(t.subarray(e, n)), i;
},
    cA = function cA(t, e, n) {
  n <<= 7 & e;
  var i = e / 8 | 0;
  t[i] |= n, t[i + 1] |= n >>> 8;
},
    hA = function hA(t, e, n) {
  n <<= 7 & e;
  var i = e / 8 | 0;
  t[i] |= n, t[i + 1] |= n >>> 8, t[i + 2] |= n >>> 16;
},
    uA = function uA(t, e) {
  for (var n = [], i = 0; i < t.length; ++i) {
    t[i] && n.push({
      s: i,
      f: t[i]
    });
  }

  var r = n.length,
      s = n.slice();
  if (!r) return [vA, 0];

  if (1 == r) {
    var a = new Hp(n[0].s + 1);
    return a[n[0].s] = 1, [a, 1];
  }

  n.sort(function (t, e) {
    return t.f - e.f;
  }), n.push({
    s: -1,
    f: 25001
  });
  var o = n[0],
      l = n[1],
      c = 0,
      h = 1,
      u = 2;

  for (n[0] = {
    s: -1,
    f: o.f + l.f,
    l: o,
    r: l
  }; h != r - 1;) {
    o = n[n[c].f < n[u].f ? c++ : u++], l = n[c != h && n[c].f < n[u].f ? c++ : u++], n[h++] = {
      s: -1,
      f: o.f + l.f,
      l: o,
      r: l
    };
  }

  var d = s[0].s;

  for (i = 1; i < r; ++i) {
    s[i].s > d && (d = s[i].s);
  }

  var p = new zp(d + 1),
      A = dA(n[h - 1], p, 0);

  if (A > e) {
    i = 0;
    var m = 0,
        g = A - e,
        f = 1 << g;

    for (s.sort(function (t, e) {
      return p[e.s] - p[t.s] || t.f - e.f;
    }); i < r; ++i) {
      var v = s[i].s;
      if (!(p[v] > e)) break;
      m += f - (1 << A - p[v]), p[v] = e;
    }

    for (m >>>= g; m > 0;) {
      var y = s[i].s;
      p[y] < e ? m -= 1 << e - p[y]++ - 1 : ++i;
    }

    for (; i >= 0 && m; --i) {
      var x = s[i].s;
      p[x] == e && (--p[x], ++m);
    }

    A = e;
  }

  return [new Hp(p), A];
},
    dA = function dA(t, e, n) {
  return -1 == t.s ? Math.max(dA(t.l, e, n + 1), dA(t.r, e, n + 1)) : e[t.s] = n;
},
    pA = function pA(t) {
  for (var e = t.length; e && !t[--e];) {
    ;
  }

  for (var n = new zp(++e), i = 0, r = t[0], s = 1, a = function a(t) {
    n[i++] = t;
  }, o = 1; o <= e; ++o) {
    if (t[o] == r && o != e) ++s;else {
      if (!r && s > 2) {
        for (; s > 138; s -= 138) {
          a(32754);
        }

        s > 2 && (a(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
      } else if (s > 3) {
        for (a(r), --s; s > 6; s -= 6) {
          a(8304);
        }

        s > 2 && (a(s - 3 << 5 | 8208), s = 0);
      }

      for (; s--;) {
        a(r);
      }

      s = 1, r = t[o];
    }
  }

  return [n.subarray(0, i), e];
},
    AA = function AA(t, e) {
  for (var n = 0, i = 0; i < e.length; ++i) {
    n += t[i] * e[i];
  }

  return n;
},
    mA = function mA(t, e, n) {
  var i = n.length,
      r = oA(e + 2);
  t[r] = 255 & i, t[r + 1] = i >>> 8, t[r + 2] = 255 ^ t[r], t[r + 3] = 255 ^ t[r + 1];

  for (var s = 0; s < i; ++s) {
    t[r + s + 4] = n[s];
  }

  return 8 * (r + 4 + i);
},
    gA = function gA(t, e, n, i, r, s, a, o, l, c, h) {
  cA(e, h++, n), ++r[256];

  for (var u = uA(r, 15), d = u[0], p = u[1], A = uA(s, 15), m = A[0], g = A[1], f = pA(d), v = f[0], y = f[1], x = pA(m), w = x[0], E = x[1], b = new zp(19), _ = 0; _ < v.length; ++_) {
    b[31 & v[_]]++;
  }

  for (_ = 0; _ < w.length; ++_) {
    b[31 & w[_]]++;
  }

  for (var I = uA(b, 7), C = I[0], M = I[1], S = 19; S > 4 && !C[jp[S - 1]]; --S) {
    ;
  }

  var B,
      T,
      L,
      R,
      D = c + 5 << 3,
      Q = AA(r, iA) + AA(s, rA) + a,
      P = AA(r, d) + AA(s, m) + a + 14 + 3 * S + AA(b, C) + (2 * b[16] + 3 * b[17] + 7 * b[18]);
  if (D <= Q && D <= P) return mA(e, h, t.subarray(l, l + c));

  if (cA(e, h, 1 + (P < Q)), h += 2, P < Q) {
    B = nA(d, p, 0), T = d, L = nA(m, g, 0), R = m;
    var F = nA(C, M, 0);
    cA(e, h, y - 257), cA(e, h + 5, E - 1), cA(e, h + 10, S - 4), h += 14;

    for (_ = 0; _ < S; ++_) {
      cA(e, h + 3 * _, C[jp[_]]);
    }

    h += 3 * S;

    for (var N = [v, w], U = 0; U < 2; ++U) {
      var k = N[U];

      for (_ = 0; _ < k.length; ++_) {
        var G = 31 & k[_];
        cA(e, h, F[G]), h += C[G], G > 15 && (cA(e, h, k[_] >>> 5 & 127), h += k[_] >>> 12);
      }
    }
  } else B = sA, T = iA, L = aA, R = rA;

  for (_ = 0; _ < o; ++_) {
    if (i[_] > 255) {
      G = i[_] >>> 18 & 31;
      hA(e, h, B[G + 257]), h += T[G + 257], G > 7 && (cA(e, h, i[_] >>> 23 & 31), h += Wp[G]);
      var O = 31 & i[_];
      hA(e, h, L[O]), h += R[O], O > 3 && (hA(e, h, i[_] >>> 5 & 8191), h += qp[O]);
    } else hA(e, h, B[i[_]]), h += T[i[_]];
  }

  return hA(e, h, B[256]), h + T[256];
},
    fA = new Vp([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]),
    vA = new Hp(0),
    yA = function () {
  for (var t = new Vp(256), e = 0; e < 256; ++e) {
    for (var n = e, i = 9; --i;) {
      n = (1 & n && 3988292384) ^ n >>> 1;
    }

    t[e] = n;
  }

  return t;
}(),
    xA = function xA() {
  var t = -1;
  return {
    p: function p(e) {
      for (var n = t, i = 0; i < e.length; ++i) {
        n = yA[255 & n ^ e[i]] ^ n >>> 8;
      }

      t = n;
    },
    d: function d() {
      return ~t;
    }
  };
},
    wA = function wA(t, e, n, i, r) {
  return function (t, e, n, i, r, s) {
    var a = t.length,
        o = new Hp(i + a + 5 * (1 + Math.ceil(a / 7e3)) + r),
        l = o.subarray(i, o.length - r),
        c = 0;
    if (!e || a < 8) for (var h = 0; h <= a; h += 65535) {
      var u = h + 65535;
      u < a ? c = mA(l, c, t.subarray(h, u)) : (l[h] = s, c = mA(l, c, t.subarray(h, a)));
    } else {
      for (var d = fA[e - 1], p = d >>> 13, A = 8191 & d, m = (1 << n) - 1, g = new zp(32768), f = new zp(m + 1), v = Math.ceil(n / 3), y = 2 * v, x = function x(e) {
        return (t[e] ^ t[e + 1] << v ^ t[e + 2] << y) & m;
      }, w = new Vp(25e3), E = new zp(288), b = new zp(32), _ = 0, I = 0, C = (h = 0, 0), M = 0, S = 0; h < a; ++h) {
        var B = x(h),
            T = 32767 & h,
            L = f[B];

        if (g[T] = L, f[B] = T, M <= h) {
          var R = a - h;

          if ((_ > 7e3 || C > 24576) && R > 423) {
            c = gA(t, l, 0, w, E, b, I, C, S, h - S, c), C = _ = I = 0, S = h;

            for (var D = 0; D < 286; ++D) {
              E[D] = 0;
            }

            for (D = 0; D < 30; ++D) {
              b[D] = 0;
            }
          }

          var Q = 2,
              P = 0,
              F = A,
              N = T - L & 32767;
          if (R > 2 && B == x(h - N)) for (var U = Math.min(p, R) - 1, k = Math.min(32767, h), G = Math.min(258, R); N <= k && --F && T != L;) {
            if (t[h + Q] == t[h + Q - N]) {
              for (var O = 0; O < G && t[h + O] == t[h + O - N]; ++O) {
                ;
              }

              if (O > Q) {
                if (Q = O, P = N, O > U) break;
                var H = Math.min(N, O - 2),
                    z = 0;

                for (D = 0; D < H; ++D) {
                  var V = h - N + D + 32768 & 32767,
                      W = V - g[V] + 32768 & 32767;
                  W > z && (z = W, L = V);
                }
              }
            }

            N += (T = L) - (L = g[T]) + 32768 & 32767;
          }

          if (P) {
            w[C++] = 268435456 | Kp[Q] << 18 | Zp[P];
            var q = 31 & Kp[Q],
                j = 31 & Zp[P];
            I += Wp[q] + qp[j], ++E[257 + q], ++b[j], M = h + Q, ++_;
          } else w[C++] = t[h], ++E[t[h]];
        }
      }

      c = gA(t, l, s, w, E, b, I, C, S, h - S, c), !s && 7 & c && (c = mA(l, c + 1, vA));
    }
    return lA(o, 0, i + oA(c) + r);
  }(t, null == e.level ? 6 : e.level, null == e.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + e.mem, n, i, !r);
},
    EA = function EA(t, e) {
  var n = {};

  for (var i in t) {
    n[i] = t[i];
  }

  for (var i in e) {
    n[i] = e[i];
  }

  return n;
},
    bA = function bA(t, e, n) {
  for (; n; ++e) {
    t[e] = n, n >>>= 8;
  }
};

function _A(t, e) {
  return wA(t, e || {}, 0, 0);
}

var IA = function IA(t, e, n, i) {
  for (var r in t) {
    var s = t[r],
        a = e + r;
    s instanceof Hp ? n[a] = [s, i] : Array.isArray(s) ? n[a] = [s[0], EA(i, s[1])] : IA(s, a + "/", n, i);
  }
},
    CA = "undefined" != typeof TextEncoder && new TextEncoder(),
    MA = "undefined" != typeof TextDecoder && new TextDecoder();

try {
  MA.decode(vA, {
    stream: !0
  }), 1;
} catch (Zc) {}

function SA(t, e) {
  if (e) {
    for (var n = new Hp(t.length), i = 0; i < t.length; ++i) {
      n[i] = t.charCodeAt(i);
    }

    return n;
  }

  if (CA) return CA.encode(t);

  var r = t.length,
      s = new Hp(t.length + (t.length >> 1)),
      a = 0,
      o = function o(t) {
    s[a++] = t;
  };

  for (i = 0; i < r; ++i) {
    if (a + 5 > s.length) {
      var l = new Hp(a + 8 + (r - i << 1));
      l.set(s), s = l;
    }

    var c = t.charCodeAt(i);
    c < 128 || e ? o(c) : c < 2048 ? (o(192 | c >> 6), o(128 | 63 & c)) : c > 55295 && c < 57344 ? (o(240 | (c = 65536 + (1047552 & c) | 1023 & t.charCodeAt(++i)) >> 18), o(128 | c >> 12 & 63), o(128 | c >> 6 & 63), o(128 | 63 & c)) : (o(224 | c >> 12), o(128 | c >> 6 & 63), o(128 | 63 & c));
  }

  return lA(s, 0, a);
}

var BA = function BA(t) {
  var e = 0;
  if (t) for (var n in t) {
    var i = t[n].length;
    if (i > 65535) throw "extra field too long";
    e += i + 4;
  }
  return e;
},
    TA = function TA(t, e, n, i, r, s, a, o) {
  var l = i.length,
      c = n.extra,
      h = o && o.length,
      u = BA(c);
  bA(t, e, null != a ? 33639248 : 67324752), e += 4, null != a && (t[e++] = 20, t[e++] = n.os), t[e] = 20, e += 2, t[e++] = n.flag << 1 | (null == s && 8), t[e++] = r && 8, t[e++] = 255 & n.compression, t[e++] = n.compression >> 8;
  var d = new Date(null == n.mtime ? Date.now() : n.mtime),
      p = d.getFullYear() - 1980;
  if (p < 0 || p > 119) throw "date not in range 1980-2099";
  if (bA(t, e, p << 25 | d.getMonth() + 1 << 21 | d.getDate() << 16 | d.getHours() << 11 | d.getMinutes() << 5 | d.getSeconds() >>> 1), e += 4, null != s && (bA(t, e, n.crc), bA(t, e + 4, s), bA(t, e + 8, n.size)), bA(t, e + 12, l), bA(t, e + 14, u), e += 16, null != a && (bA(t, e, h), bA(t, e + 6, n.attrs), bA(t, e + 10, a), e += 14), t.set(i, e), e += l, u) for (var A in c) {
    var m = c[A],
        g = m.length;
    bA(t, e, +A), bA(t, e + 2, g), t.set(m, e + 4), e += 4 + g;
  }
  return h && (t.set(o, e), e += h), e;
};

function LA(t, e) {
  e || (e = {});
  var n = {},
      i = [];
  IA(t, "", n, e);
  var r = 0,
      s = 0;

  for (var a in n) {
    var o = n[a],
        l = o[0],
        c = o[1],
        h = 0 == c.level ? 0 : 8,
        u = (b = SA(a)).length,
        d = c.comment,
        p = d && SA(d),
        A = p && p.length,
        m = BA(c.extra);
    if (u > 65535) throw "filename too long";
    var g = h ? _A(l, c) : l,
        f = g.length,
        v = xA();
    v.p(l), i.push(EA(c, {
      size: l.length,
      crc: v.d(),
      c: g,
      f: b,
      m: p,
      u: u != a.length || p && d.length != A,
      o: r,
      compression: h
    })), r += 30 + u + m + f, s += 76 + 2 * (u + m) + (A || 0) + f;
  }

  for (var y = new Hp(s + 22), x = r, w = s - r, E = 0; E < i.length; ++E) {
    var b = i[E];
    TA(y, b.o, b, b.f, b.u, b.c.length);

    var _ = 30 + b.f.length + BA(b.extra);

    y.set(b.c, b.o + _), TA(y, r, b, b.f, b.u, b.c.length, b.o, b.m), r += 16 + _ + (b.m ? b.m.length : 0);
  }

  return function (t, e, n, i, r) {
    bA(t, e, 101010256), bA(t, e + 8, n), bA(t, e + 10, n), bA(t, e + 12, i), bA(t, e + 16, r);
  }(y, r, i.length, w, x), y;
}

var RA = /*#__PURE__*/function () {
  function RA() {
    _classCallCheck(this, RA);
  }

  _createClass(RA, [{
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t) {
        var e, n, i, r, _loop4, _t406, s, _t407, _n297, _i247, _r164;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                e = {};
                e["model.usda"] = null;
                n = QA();
                i = {}, r = {};
                t.traverseVisible(function (t) {
                  if (t.isMesh && t.material.isMeshStandardMaterial) {
                    var _r162 = t.geometry,
                        _s95 = t.material,
                        _a70 = "geometries/Geometry_" + _r162.id + ".usd";

                    if (!(_a70 in e)) {
                      var _t403 = function (t) {
                        return "\ndef \"Geometry\"\n{\n  ".concat(function (t) {
                          var e = "Geometry",
                              n = t.attributes,
                              i = n.position.count;
                          return "\n    def Mesh \"".concat(e, "\"\n    {\n        int[] faceVertexCounts = [").concat(function (t) {
                            var e = null !== t.index ? t.index.array.length : t.attributes.position.count;
                            return Array(e / 3).fill(3).join(", ");
                          }(t), "]\n        int[] faceVertexIndices = [").concat(function (t) {
                            if (null !== t.index) return t.index.array.join(", ");
                            var e = [],
                                n = t.attributes.position.count;

                            for (var _t404 = 0; _t404 < n; _t404++) {
                              e.push(_t404);
                            }

                            return e.join(", ");
                          }(t), "]\n        normal3f[] normals = [").concat(FA(n.normal, i), "] (\n            interpolation = \"vertex\"\n        )\n        point3f[] points = [").concat(FA(n.position, i), "]\n        float2[] primvars:st = [").concat(function (t, e) {
                            if (void 0 === t) return console.warn("USDZExporter: UVs missing."), Array(e).fill("(0, 0)").join(", ");
                            var n = [],
                                i = t.array;

                            for (var _t405 = 0; _t405 < i.length; _t405 += 2) {
                              n.push("(".concat(i[_t405 + 0].toPrecision(7), ", ").concat(1 - i[_t405 + 1].toPrecision(7), ")"));
                            }

                            return n.join(", ");
                          }(n.uv, i), "] (\n            interpolation = \"vertex\"\n        )\n        uniform token subdivisionScheme = \"none\"\n    }\n");
                        }(t), "\n}\n");
                      }(_r162);

                      e[_a70] = function (t) {
                        var e = QA();
                        return e += t, SA(e);
                      }(_t403);
                    }

                    _s95.uuid in i || (i[_s95.uuid] = _s95), n += function (t, e, n) {
                      var i = "Object_" + t.id,
                          r = function (t) {
                        var e = t.elements;
                        return "( ".concat(PA(e, 0), ", ").concat(PA(e, 4), ", ").concat(PA(e, 8), ", ").concat(PA(e, 12), " )");
                      }(t.matrixWorld);

                      t.matrixWorld.determinant() < 0 && console.warn("THREE.USDZExporter: USDZ does not support negative scales", t);
                      return "def Xform \"".concat(i, "\" (\n    prepend references = @./geometries/Geometry_").concat(e.id, ".usd@</Geometry>\n)\n{\n    matrix4d xformOp:transform = ").concat(r, "\n    uniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n    rel material:binding = </Materials/Material_").concat(n.id, ">\n}\n\n");
                    }(t, _r162, _s95);
                  }
                }), n += function (t, e) {
                  var n = [];

                  for (var _i246 in t) {
                    var _r163 = t[_i246];
                    n.push(NA(_r163, e));
                  }

                  return "def \"Materials\"\n{\n".concat(n.join(""), "\n}\n\n");
                }(i, r), e["model.usda"] = SA(n), n = null;
                _loop4 = /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_t406) {
                  var n, i, s, a, o;
                  return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          n = r[_t406];
                          i = _t406.split("_")[1];
                          s = 1023 === n.format;
                          a = DA(n.image, i);
                          _context25.next = 6;
                          return new Promise(function (t) {
                            return a.toBlob(t, s ? "image/png" : "image/jpeg", 1);
                          });

                        case 6:
                          o = _context25.sent;
                          _context25.t0 = Uint8Array;
                          _context25.next = 10;
                          return o.arrayBuffer();

                        case 10:
                          _context25.t1 = _context25.sent;
                          e["textures/Texture_".concat(_t406, ".").concat(s ? "png" : "jpg")] = new _context25.t0(_context25.t1);

                        case 12:
                        case "end":
                          return _context25.stop();
                      }
                    }
                  }, _callee25);
                });
                _context26.t0 = _regeneratorRuntime.keys(r);

              case 7:
                if ((_context26.t1 = _context26.t0()).done) {
                  _context26.next = 12;
                  break;
                }

                _t406 = _context26.t1.value;
                return _context26.delegateYield(_loop4(_t406), "t2", 10);

              case 10:
                _context26.next = 7;
                break;

              case 12:
                s = 0;

                for (_t407 in e) {
                  _n297 = e[_t407];
                  s += 34 + _t407.length;
                  _i247 = 63 & s;

                  if (4 !== _i247) {
                    _r164 = new Uint8Array(64 - _i247);
                    e[_t407] = [_n297, {
                      extra: {
                        12345: _r164
                      }
                    }];
                  }

                  s = _n297.length;
                }

                return _context26.abrupt("return", LA(e, {
                  level: 0
                }));

              case 15:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function parse(_x26) {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
  }]);

  return RA;
}();

function DA(t, e) {
  if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) {
    var n = 1024 / Math.max(t.width, t.height),
        _i248 = document.createElement("canvas");

    _i248.width = t.width * Math.min(1, n), _i248.height = t.height * Math.min(1, n);

    var _r165 = _i248.getContext("2d");

    if (_r165.drawImage(t, 0, 0, _i248.width, _i248.height), void 0 !== e) {
      var _t408 = parseInt(e, 16),
          _n298 = (_t408 >> 16 & 255) / 255,
          _s96 = (_t408 >> 8 & 255) / 255,
          _a71 = (255 & _t408) / 255,
          _o45 = _r165.getImageData(0, 0, _i248.width, _i248.height),
          _l38 = _o45.data;

      for (var _t409 = 0; _t409 < _l38.length; _t409 += 4) {
        _l38[_t409 + 0] = _l38[_t409 + 0] * _n298, _l38[_t409 + 1] = _l38[_t409 + 1] * _s96, _l38[_t409 + 2] = _l38[_t409 + 2] * _a71;
      }

      _r165.putImageData(_o45, 0, 0);
    }

    return _i248;
  }
}

function QA() {
  return '#usda 1.0\n(\n    customLayerData = {\n        string creator = "Three.js USDZExporter"\n    }\n    metersPerUnit = 1\n    upAxis = "Y"\n)\n\n';
}

function PA(t, e) {
  return "(".concat(t[e + 0], ", ").concat(t[e + 1], ", ").concat(t[e + 2], ", ").concat(t[e + 3], ")");
}

function FA(t, e) {
  if (void 0 === t) return console.warn("USDZExporter: Normals missing."), Array(e).fill("(0, 0, 0)").join(", ");
  var n = [],
      i = t.array;

  for (var _t410 = 0; _t410 < i.length; _t410 += 3) {
    n.push("(".concat(i[_t410 + 0].toPrecision(7), ", ").concat(i[_t410 + 1].toPrecision(7), ", ").concat(i[_t410 + 2].toPrecision(7), ")"));
  }

  return n.join(", ");
}

function NA(t, e) {
  var n = "            ",
      i = [],
      r = [];

  function s(n, i, r) {
    var s = n.id + (r ? "_" + r.getHexString() : ""),
        a = 1023 === n.format;
    return e[s] = n, "\n        def Shader \"Transform2d_".concat(i, "\" (\n            sdrMetadata = {\n                string role = \"math\"\n            }\n        )\n        {\n            uniform token info:id = \"UsdTransform2d\"\n            float2 inputs:in.connect = </Materials/Material_").concat(t.id, "/uvReader_st.outputs:result>\n            float2 inputs:scale = ").concat(kA(n.repeat), "\n            float2 inputs:translation = ").concat(kA(n.offset), "\n            float2 outputs:result\n        }\n\n        def Shader \"Texture_").concat(n.id, "_").concat(i, "\"\n        {\n            uniform token info:id = \"UsdUVTexture\"\n            asset inputs:file = @textures/Texture_").concat(s, ".").concat(a ? "png" : "jpg", "@\n            float2 inputs:st.connect = </Materials/Material_").concat(t.id, "/Transform2d_").concat(i, ".outputs:result>\n            token inputs:wrapS = \"repeat\"\n            token inputs:wrapT = \"repeat\"\n            float outputs:r\n            float outputs:g\n            float outputs:b\n            float3 outputs:rgb\n        }");
  }

  return null !== t.map ? (i.push("".concat(n, "color3f inputs:diffuseColor.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.map.id, "_diffuse.outputs:rgb>")), r.push(s(t.map, "diffuse", t.color))) : i.push("".concat(n, "color3f inputs:diffuseColor = ").concat(UA(t.color))), null !== t.emissiveMap ? (i.push("".concat(n, "color3f inputs:emissiveColor.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.emissiveMap.id, "_emissive.outputs:rgb>")), r.push(s(t.emissiveMap, "emissive"))) : t.emissive.getHex() > 0 && i.push("".concat(n, "color3f inputs:emissiveColor = ").concat(UA(t.emissive))), null !== t.normalMap && (i.push("".concat(n, "normal3f inputs:normal.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.normalMap.id, "_normal.outputs:rgb>")), r.push(s(t.normalMap, "normal"))), null !== t.aoMap && (i.push("".concat(n, "float inputs:occlusion.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.aoMap.id, "_occlusion.outputs:r>")), r.push(s(t.aoMap, "occlusion"))), null !== t.roughnessMap && 1 === t.roughness ? (i.push("".concat(n, "float inputs:roughness.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.roughnessMap.id, "_roughness.outputs:g>")), r.push(s(t.roughnessMap, "roughness"))) : i.push("".concat(n, "float inputs:roughness = ").concat(t.roughness)), null !== t.metalnessMap && 1 === t.metalness ? (i.push("".concat(n, "float inputs:metallic.connect = </Materials/Material_").concat(t.id, "/Texture_").concat(t.metalnessMap.id, "_metallic.outputs:b>")), r.push(s(t.metalnessMap, "metallic"))) : i.push("".concat(n, "float inputs:metallic = ").concat(t.metalness)), i.push("".concat(n, "float inputs:opacity = ").concat(t.opacity)), t.isMeshPhysicalMaterial && (i.push("".concat(n, "float inputs:clearcoat = ").concat(t.clearcoat)), i.push("".concat(n, "float inputs:clearcoatRoughness = ").concat(t.clearcoatRoughness)), i.push("".concat(n, "float inputs:ior = ").concat(t.ior))), "\n    def Material \"Material_".concat(t.id, "\"\n    {\n        def Shader \"PreviewSurface\"\n        {\n            uniform token info:id = \"UsdPreviewSurface\"\n").concat(i.join("\n"), "\n            int inputs:useSpecularWorkflow = 0\n            token outputs:surface\n        }\n\n        token outputs:surface.connect = </Materials/Material_").concat(t.id, "/PreviewSurface.outputs:surface>\n        token inputs:frame:stPrimvarName = \"st\"\n\n        def Shader \"uvReader_st\"\n        {\n            uniform token info:id = \"UsdPrimvarReader_float2\"\n            token inputs:varname.connect = </Materials/Material_").concat(t.id, ".inputs:frame:stPrimvarName>\n            float2 inputs:fallback = (0.0, 0.0)\n            float2 outputs:result\n        }\n\n").concat(r.join("\n"), "\n\n    }\n");
}

function UA(t) {
  return "(".concat(t.r, ", ").concat(t.g, ", ").concat(t.b, ")");
}

function kA(t) {
  return "(".concat(t.x, ", ").concat(t.y, ")");
}
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var GA = function GA(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var OA = !1,
    HA = !1;
var zA = (VA = ["quick-look", "scene-viewer", "webxr", "none"], function (t) {
  try {
    var _e338 = su(t),
        n = (_e338.length ? _e338[0].terms : []).filter(function (t) {
      return t && "ident" === t.type;
    }).map(function (t) {
      return t.value;
    }).filter(function (t) {
      return VA.indexOf(t) > -1;
    }),
        _i249 = new Set();

    var _iterator31 = _createForOfIteratorHelper(n),
        _step31;

    try {
      for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
        var _t411 = _step31.value;

        _i249.add(_t411);
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }

    return _i249;
  } catch (t) {}

  return new Set();
});
var VA;
var WA = "quick-look",
    qA = "scene-viewer",
    jA = "webxr",
    YA = "none",
    JA = Symbol("arButtonContainer"),
    XA = Symbol("enterARWithWebXR"),
    KA = Symbol("openSceneViewer"),
    ZA = Symbol("openIOSARQuickLook"),
    $A = Symbol("canActivateAR"),
    tm = Symbol("arMode"),
    em = Symbol("arModes"),
    nm = Symbol("arAnchor"),
    im = Symbol("preload"),
    rm = Symbol("onARButtonContainerClick"),
    sm = Symbol("onARStatus"),
    am = Symbol("onARTracking"),
    om = Symbol("onARTap"),
    lm = Symbol("selectARMode"),
    cm = Symbol("triggerLoad");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var hm, um, dm;
var pm = Symbol("evaluate"),
    Am = Symbol("lastValue");

var mm = /*#__PURE__*/function () {
  function mm() {
    _classCallCheck(this, mm);

    this[hm] = null;
  }

  _createClass(mm, [{
    key: "isConstant",
    get: function get() {
      return !1;
    }
  }, {
    key: "evaluate",
    value: function evaluate() {
      return this.isConstant && null != this[Am] || (this[Am] = this[pm]()), this[Am];
    }
  }], [{
    key: "evaluatableFor",
    value: function evaluatableFor(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pu;
      if (t instanceof mm) return t;
      if ("number" === t.type) return "%" === t.unit ? new vm(t, e) : t;

      switch (t.name.value) {
        case "calc":
          return new bm(t, e);

        case "env":
          return new xm(t);
      }

      return pu;
    }
  }, {
    key: "evaluate",
    value: function evaluate(t) {
      return t instanceof mm ? t.evaluate() : t;
    }
  }, {
    key: "isConstant",
    value: function isConstant(t) {
      return !(t instanceof mm) || t.isConstant;
    }
  }, {
    key: "applyIntrinsics",
    value: function applyIntrinsics(t, e) {
      var n = e.basis,
          i = e.keywords,
          r = i.auto;
      return n.map(function (e, n) {
        var s = null == r[n] ? e : r[n];
        var a = t[n] ? t[n] : s;

        if ("ident" === a.type) {
          var _t412 = a.value;
          _t412 in i && (a = i[_t412][n]);
        }

        return null != a && "ident" !== a.type || (a = s), "%" === a.unit ? ru(a.number / 100 * e.number, e.unit) : (a = gu(a, e), a.unit !== e.unit ? e : a);
      });
    }
  }]);

  return mm;
}();

hm = Am;
var gm = Symbol("percentage"),
    fm = Symbol("basis");

var vm = /*#__PURE__*/function (_mm) {
  _inherits(vm, _mm);

  var _super135 = _createSuper(vm);

  function vm(t, e) {
    var _this144;

    _classCallCheck(this, vm);

    _this144 = _super135.call(this), _this144[gm] = t, _this144[fm] = e;
    return _this144;
  }

  _createClass(vm, [{
    key: "isConstant",
    get: function get() {
      return !0;
    }
  }, {
    key: pm,
    value: function value() {
      return ru(this[gm].number / 100 * this[fm].number, this[fm].unit);
    }
  }]);

  return vm;
}(mm);

var ym = Symbol("identNode");

var xm = /*#__PURE__*/function (_mm2, _ref21) {
  _inherits(xm, _mm2);

  var _super136 = _createSuper(xm);

  function xm(t) {
    var _this145;

    _classCallCheck(this, xm);

    _this145 = _super136.call(this), _this145[um] = null;
    var e = t.arguments.length ? t.arguments[0].terms[0] : null;
    null != e && "ident" === e.type && (_this145[ym] = e);
    return _this145;
  }

  _createClass(xm, [{
    key: "isConstant",
    get: function get() {
      return !1;
    }
  }, {
    key: _ref21,
    value: function value() {
      if (null != this[ym]) switch (this[ym].value) {
        case "window-scroll-y":
          return {
            type: "number",
            number: window.pageYOffset / (Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight) || 0,
            unit: null
          };
      }
      return pu;
    }
  }]);

  return xm;
}(mm, (um = ym, pm));

var wm = /[\*\/]/,
    Em = Symbol("evalutor");

var bm = /*#__PURE__*/function (_mm3, _ref22) {
  _inherits(bm, _mm3);

  var _super137 = _createSuper(bm);

  function bm(t) {
    var _this146;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pu;

    _classCallCheck(this, bm);

    if (_this146 = _super137.call(this), _this146[dm] = null, 1 !== t.arguments.length) return _possibleConstructorReturn(_this146);
    var n = t.arguments[0].terms.slice(),
        i = [];

    for (; n.length;) {
      var _t413 = n.shift();

      if (i.length > 0) {
        var _n299 = i[i.length - 1];

        if ("operator" === _n299.type && wm.test(_n299.value)) {
          var _n300 = i.pop(),
              _r166 = i.pop();

          if (null == _r166) return _possibleConstructorReturn(_this146);
          i.push(new Mm(_n300, mm.evaluatableFor(_r166, e), mm.evaluatableFor(_t413, e)));
          continue;
        }
      }

      i.push("operator" === _t413.type ? _t413 : mm.evaluatableFor(_t413, e));
    }

    for (; i.length > 2;) {
      var _i$splice = i.splice(0, 3),
          _i$splice2 = _slicedToArray(_i$splice, 3),
          _t414 = _i$splice2[0],
          _n301 = _i$splice2[1],
          _r167 = _i$splice2[2];

      if ("operator" !== _n301.type) return _possibleConstructorReturn(_this146);
      i.unshift(new Mm(_n301, mm.evaluatableFor(_t414, e), mm.evaluatableFor(_r167, e)));
    }

    1 === i.length && (_this146[Em] = i[0]);
    return _possibleConstructorReturn(_this146);
  }

  _createClass(bm, [{
    key: "isConstant",
    get: function get() {
      return null == this[Em] || mm.isConstant(this[Em]);
    }
  }, {
    key: _ref22,
    value: function value() {
      return null != this[Em] ? mm.evaluate(this[Em]) : pu;
    }
  }]);

  return bm;
}(mm, (dm = Em, pm));

var _m = Symbol("operator"),
    Im = Symbol("left"),
    Cm = Symbol("right");

var Mm = /*#__PURE__*/function (_mm4) {
  _inherits(Mm, _mm4);

  var _super138 = _createSuper(Mm);

  function Mm(t, e, n) {
    var _this147;

    _classCallCheck(this, Mm);

    _this147 = _super138.call(this), _this147[_m] = t, _this147[Im] = e, _this147[Cm] = n;
    return _this147;
  }

  _createClass(Mm, [{
    key: "isConstant",
    get: function get() {
      return mm.isConstant(this[Im]) && mm.isConstant(this[Cm]);
    }
  }, {
    key: pm,
    value: function value() {
      var t = gu(mm.evaluate(this[Im])),
          e = gu(mm.evaluate(this[Cm])),
          n = t.number,
          i = t.unit,
          r = e.number,
          s = e.unit;
      if (null != s && null != i && s != i) return pu;
      var a = i || s;
      var o;

      switch (this[_m].value) {
        case "+":
          o = n + r;
          break;

        case "-":
          o = n - r;
          break;

        case "/":
          o = n / r;
          break;

        case "*":
          o = n * r;
          break;

        default:
          return pu;
      }

      return {
        type: "number",
        number: o,
        unit: a
      };
    }
  }]);

  return Mm;
}(mm);

var Sm = Symbol("evaluatables"),
    Bm = Symbol("intrinsics");

var Tm = /*#__PURE__*/function (_mm5) {
  _inherits(Tm, _mm5);

  var _super139 = _createSuper(Tm);

  function Tm(t, e) {
    var _this148;

    _classCallCheck(this, Tm);

    _this148 = _super139.call(this), _this148[Bm] = e;
    var n = t[0],
        i = null != n ? n.terms : [];
    _this148[Sm] = e.basis.map(function (t, e) {
      var n = i[e];
      return null == n ? {
        type: "ident",
        value: "auto"
      } : "ident" === n.type ? n : mm.evaluatableFor(n, t);
    });
    return _this148;
  }

  _createClass(Tm, [{
    key: "isConstant",
    get: function get() {
      var _iterator32 = _createForOfIteratorHelper(this[Sm]),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _t415 = _step32.value;
          if (!mm.isConstant(_t415)) return !1;
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }

      return !0;
    }
  }, {
    key: pm,
    value: function value() {
      var t = this[Sm].map(function (t) {
        return mm.evaluate(t);
      });
      return mm.applyIntrinsics(t, this[Bm]).map(function (t) {
        return t.number;
      });
    }
  }]);

  return Tm;
}(mm);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Lm, Rm, Dm, Qm;
var Pm = Symbol("instances"),
    Fm = Symbol("activateListener"),
    Nm = Symbol("deactivateListener"),
    Um = Symbol("notifyInstances"),
    km = Symbol("notify"),
    Gm = Symbol("callback");

var Om = /*#__PURE__*/function (_ref23) {
  function Om(t) {
    _classCallCheck(this, Om);

    this[Gm] = t;
  }

  _createClass(Om, [{
    key: "observe",
    value: function observe() {
      0 === Om[Pm].size && Om[Fm](), Om[Pm].add(this);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      Om[Pm].delete(this), 0 === Om[Pm].size && Om[Nm]();
    }
  }, {
    key: km,
    value: function value() {
      this[Gm]();
    }
  }], [{
    key: Um,
    value: function value() {
      var _iterator33 = _createForOfIteratorHelper(Om[Pm]),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _t416 = _step33.value;

          _t416[km]();
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }
  }, {
    key: _ref23,
    value: function value() {
      window.addEventListener("scroll", this[Um], {
        passive: !0
      });
    }
  }, {
    key: Nm,
    value: function value() {
      window.removeEventListener("scroll", this[Um]);
    }
  }]);

  return Om;
}((Lm = Pm, Fm));

Om[Lm] = new Set();
var Hm = Symbol("computeStyleCallback"),
    zm = Symbol("astWalker"),
    Vm = Symbol("dependencies"),
    Wm = Symbol("onScroll");

var qm = /*#__PURE__*/function () {
  function qm(t) {
    var _this149 = this;

    _classCallCheck(this, qm);

    this[Rm] = {}, this[Dm] = new du(["function"]), this[Qm] = function () {
      _this149[Hm]({
        relatedState: "window-scroll"
      });
    }, this[Hm] = t;
  }

  _createClass(qm, [{
    key: "observeEffectsFor",
    value: function observeEffectsFor(t) {
      var _this150 = this;

      var e = {},
          n = this[Vm];
      this[zm].walk(t, function (t) {
        var i = t.name,
            r = t.arguments[0].terms[0];
        if ("env" === i.value && null != r && "ident" === r.type) switch (r.value) {
          case "window-scroll-y":
            if (null == e["window-scroll"]) {
              var _t417 = "window-scroll" in n ? n["window-scroll"] : new Om(_this150[Wm]);

              _t417.observe(), delete n["window-scroll"], e["window-scroll"] = _t417;
            }

        }
      });

      for (var _t418 in n) {
        n[_t418].disconnect();
      }

      this[Vm] = e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var _t419 in this[Vm]) {
        this[Vm][_t419].disconnect();
      }
    }
  }]);

  return qm;
}();

Rm = Vm, Dm = zm, Qm = Wm;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var jm = function jm(t) {
  var e = t.observeEffects || !1,
      n = t.intrinsics instanceof Function ? t.intrinsics : function () {
    return t.intrinsics;
  };
  return function (i, r) {
    var _Object$definePropert;

    var s = i.updated,
        a = i.connectedCallback,
        o = i.disconnectedCallback,
        l = Symbol("".concat(r, "StyleEffector")),
        c = Symbol("".concat(r, "StyleEvaluator")),
        h = Symbol("".concat(r, "UpdateEvaluator")),
        u = Symbol("".concat(r, "EvaluateAndSync"));
    Object.defineProperties(i, (_Object$definePropert = {}, _defineProperty(_Object$definePropert, l, {
      value: null,
      writable: !0
    }), _defineProperty(_Object$definePropert, c, {
      value: null,
      writable: !0
    }), _defineProperty(_Object$definePropert, h, {
      value: function value() {
        var _this151 = this;

        var t = su(this[r]);
        this[c] = new Tm(t, n(this)), null == this[l] && e && (this[l] = new qm(function () {
          return _this151[u]();
        })), null != this[l] && this[l].observeEffectsFor(t);
      }
    }), _defineProperty(_Object$definePropert, u, {
      value: function value() {
        if (null == this[c]) return;
        var e = this[c].evaluate();
        this[t.updateHandler](e);
      }
    }), _defineProperty(_Object$definePropert, "updated", {
      value: function value(t) {
        t.has(r) && (this[h](), this[u]()), s.call(this, t);
      }
    }), _defineProperty(_Object$definePropert, "connectedCallback", {
      value: function value() {
        a.call(this), this.requestUpdate(r, this[r]);
      }
    }), _defineProperty(_Object$definePropert, "disconnectedCallback", {
      value: function value() {
        o.call(this), null != this[l] && (this[l].dispose(), this[l] = null);
      }
    }), _Object$definePropert));
  };
},
    Ym = Object.freeze({
  minimumRadius: 0,
  maximumRadius: 1 / 0,
  minimumPolarAngle: Math.PI / 8,
  maximumPolarAngle: Math.PI - Math.PI / 8,
  minimumAzimuthalAngle: -1 / 0,
  maximumAzimuthalAngle: 1 / 0,
  minimumFieldOfView: 10,
  maximumFieldOfView: 45,
  interactionPolicy: "always-allow",
  touchAction: "pan-y"
}),
    Jm = /^touch(start|end|move)$/,
    Xm = Math.PI / 8,
    Km = 33,
    Zm = 34,
    $m = 37,
    tg = 38,
    eg = 39,
    ng = 40,
    ig = "user-interaction",
    rg = "none";
/* @license
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var sg = /*#__PURE__*/function (_tt12) {
  _inherits(sg, _tt12);

  var _super140 = _createSuper(sg);

  function sg(t, e) {
    var _this152;

    _classCallCheck(this, sg);

    _this152 = _super140.call(this), _this152.camera = t, _this152.element = e, _this152.sensitivity = 1, _this152._interactionEnabled = !1, _this152._disableZoom = !1, _this152.isUserChange = !1, _this152.isUserPointing = !1, _this152.spherical = new zl(), _this152.goalSpherical = new zl(), _this152.thetaDamper = new iu(), _this152.phiDamper = new iu(), _this152.radiusDamper = new iu(), _this152.logFov = Math.log(Ym.maximumFieldOfView), _this152.goalLogFov = _this152.logFov, _this152.fovDamper = new iu(), _this152.pointerIsDown = !1, _this152.lastPointerPosition = {
      clientX: 0,
      clientY: 0
    }, _this152.touchMode = "rotate", _this152.touchDecided = !1, _this152.onPointerMove = function (t) {
      if (_this152.pointerIsDown && _this152.canInteract) {
        if (Jm.test(t.type)) {
          var _e339 = t.touches;

          switch (_this152.touchMode) {
            case "zoom":
              if (_this152.lastTouches.length > 1 && _e339.length > 1) {
                var _t421 = .04 * (_this152.twoTouchDistance(_this152.lastTouches[0], _this152.lastTouches[1]) - _this152.twoTouchDistance(_e339[0], _e339[1])) / 10;

                _this152.userAdjustOrbit(0, 0, _t421);
              }

              break;

            case "rotate":
              var _t420 = _this152._options.touchAction;

              if (!_this152.touchDecided && "none" !== _t420) {
                _this152.touchDecided = !0;

                var _e339$ = _e339[0],
                    n = _e339$.clientX,
                    _i250 = _e339$.clientY,
                    _r168 = Math.abs(n - _this152.lastPointerPosition.clientX),
                    _s97 = Math.abs(_i250 - _this152.lastPointerPosition.clientY);

                if ("pan-y" === _t420 && _s97 > _r168 || "pan-x" === _t420 && _r168 > _s97) return void (_this152.touchMode = "scroll");
              }

              _this152.handleSinglePointerMove(_e339[0]);

              break;

            case "scroll":
              return;
          }

          _this152.lastTouches = _e339;
        } else _this152.handleSinglePointerMove(t);

        t.cancelable && t.preventDefault();
      }
    }, _this152.onPointerDown = function (t) {
      if (_this152.pointerIsDown = !0, _this152.isUserPointing = !1, Jm.test(t.type)) {
        var _e340 = t.touches;

        switch (_this152.touchDecided = !1, _e340.length) {
          default:
          case 1:
            _this152.touchMode = "rotate", _this152.handleSinglePointerDown(_e340[0]);
            break;

          case 2:
            _this152.touchMode = _this152._disableZoom ? "scroll" : "zoom";
        }

        _this152.lastTouches = _e340;
      } else _this152.handleSinglePointerDown(t);
    }, _this152.onPointerUp = function (t) {
      _this152.element.style.cursor = "grab", _this152.pointerIsDown = !1, _this152.isUserPointing && _this152.dispatchEvent({
        type: "pointer-change-end",
        pointer: Object.assign({}, _this152.lastPointerPosition)
      });
    }, _this152.onWheel = function (t) {
      if (!_this152.canInteract) return;
      var e = t.deltaY * (1 == t.deltaMode ? 18 : 1) * .04 / 30;
      _this152.userAdjustOrbit(0, 0, e), t.cancelable && t.preventDefault();
    }, _this152.onKeyDown = function (t) {
      var e = !1;

      switch (t.keyCode) {
        case Km:
          e = !0, _this152.userAdjustOrbit(0, 0, .04);
          break;

        case Zm:
          e = !0, _this152.userAdjustOrbit(0, 0, -.04);
          break;

        case tg:
          e = !0, _this152.userAdjustOrbit(0, -Xm, 0);
          break;

        case ng:
          e = !0, _this152.userAdjustOrbit(0, Xm, 0);
          break;

        case $m:
          e = !0, _this152.userAdjustOrbit(-Xm, 0, 0);
          break;

        case eg:
          e = !0, _this152.userAdjustOrbit(Xm, 0, 0);
      }

      e && t.cancelable && t.preventDefault();
    }, _this152._options = Object.assign({}, Ym), _this152.setOrbit(0, Math.PI / 2, 1), _this152.setFieldOfView(100), _this152.jumpToGoal();
    return _this152;
  }

  _createClass(sg, [{
    key: "interactionEnabled",
    get: function get() {
      return this._interactionEnabled;
    }
  }, {
    key: "enableInteraction",
    value: function enableInteraction() {
      if (!1 === this._interactionEnabled) {
        var _t422 = this.element;
        _t422.addEventListener("mousemove", this.onPointerMove), _t422.addEventListener("mousedown", this.onPointerDown), this._disableZoom || _t422.addEventListener("wheel", this.onWheel), _t422.addEventListener("keydown", this.onKeyDown), _t422.addEventListener("touchstart", this.onPointerDown, {
          passive: !0
        }), _t422.addEventListener("touchmove", this.onPointerMove), self.addEventListener("mouseup", this.onPointerUp), self.addEventListener("touchend", this.onPointerUp), this.element.style.cursor = "grab", this._interactionEnabled = !0;
      }
    }
  }, {
    key: "disableInteraction",
    value: function disableInteraction() {
      if (!0 === this._interactionEnabled) {
        var _t423 = this.element;
        _t423.removeEventListener("mousemove", this.onPointerMove), _t423.removeEventListener("mousedown", this.onPointerDown), this._disableZoom || _t423.removeEventListener("wheel", this.onWheel), _t423.removeEventListener("keydown", this.onKeyDown), _t423.removeEventListener("touchstart", this.onPointerDown), _t423.removeEventListener("touchmove", this.onPointerMove), self.removeEventListener("mouseup", this.onPointerUp), self.removeEventListener("touchend", this.onPointerUp), _t423.style.cursor = "", this._interactionEnabled = !1;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "disableZoom",
    set: function set(t) {
      this._disableZoom != t && (this._disableZoom = t, !0 === t ? this.element.removeEventListener("wheel", this.onWheel) : this.element.addEventListener("wheel", this.onWheel));
    }
  }, {
    key: "getCameraSpherical",
    value: function getCameraSpherical() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new zl();
      return t.copy(this.spherical);
    }
  }, {
    key: "getFieldOfView",
    value: function getFieldOfView() {
      return this.camera.fov;
    }
  }, {
    key: "applyOptions",
    value: function applyOptions(t) {
      Object.assign(this._options, t), this.setOrbit(), this.setFieldOfView(Math.exp(this.goalLogFov));
    }
  }, {
    key: "updateNearFar",
    value: function updateNearFar(t, e) {
      this.camera.near = Math.max(t, e / 1e3), this.camera.far = e, this.camera.updateProjectionMatrix();
    }
  }, {
    key: "updateAspect",
    value: function updateAspect(t) {
      this.camera.aspect = t, this.camera.updateProjectionMatrix();
    }
  }, {
    key: "setOrbit",
    value: function setOrbit() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.goalSpherical.theta;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.goalSpherical.phi;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.goalSpherical.radius;
      var _this$_options = this._options,
          i = _this$_options.minimumAzimuthalAngle,
          r = _this$_options.maximumAzimuthalAngle,
          s = _this$_options.minimumPolarAngle,
          a = _this$_options.maximumPolarAngle,
          o = _this$_options.minimumRadius,
          l = _this$_options.maximumRadius,
          _this$goalSpherical = this.goalSpherical,
          c = _this$goalSpherical.theta,
          h = _this$goalSpherical.phi,
          u = _this$goalSpherical.radius,
          d = tu(t, i, r);
      isFinite(i) || isFinite(r) || (this.spherical.theta = this.wrapAngle(this.spherical.theta - d) + d);
      var p = tu(e, s, a),
          A = tu(n, o, l);
      return (d !== c || p !== h || A !== u) && (this.goalSpherical.theta = d, this.goalSpherical.phi = p, this.goalSpherical.radius = A, this.goalSpherical.makeSafe(), this.isUserChange = !1, !0);
    }
  }, {
    key: "setRadius",
    value: function setRadius(t) {
      this.goalSpherical.radius = t, this.setOrbit();
    }
  }, {
    key: "setFieldOfView",
    value: function setFieldOfView(t) {
      var _this$_options2 = this._options,
          e = _this$_options2.minimumFieldOfView,
          n = _this$_options2.maximumFieldOfView;
      t = tu(t, e, n), this.goalLogFov = Math.log(t);
    }
  }, {
    key: "setDamperDecayTime",
    value: function setDamperDecayTime(t) {
      this.thetaDamper.setDecayTime(t), this.phiDamper.setDecayTime(t), this.radiusDamper.setDecayTime(t), this.fovDamper.setDecayTime(t);
    }
  }, {
    key: "adjustOrbit",
    value: function adjustOrbit(t, e, n) {
      var _this$goalSpherical2 = this.goalSpherical,
          i = _this$goalSpherical2.theta,
          r = _this$goalSpherical2.phi,
          s = _this$goalSpherical2.radius,
          _this$_options3 = this._options,
          a = _this$_options3.minimumRadius,
          o = _this$_options3.maximumRadius,
          l = _this$_options3.minimumFieldOfView,
          c = _this$_options3.maximumFieldOfView,
          h = this.spherical.theta - i,
          u = Math.PI - .001,
          d = i - tu(t, -u - h, u - h),
          p = r - e,
          A = 0 === n ? 0 : ((n > 0 ? o : a) - s) / (Math.log(n > 0 ? c : l) - this.goalLogFov),
          m = s + n * Math.min(isFinite(A) ? A : 1 / 0, o - a);

      if (this.setOrbit(d, p, m), 0 !== n) {
        var _t424 = this.goalLogFov + n;

        this.setFieldOfView(Math.exp(_t424));
      }
    }
  }, {
    key: "jumpToGoal",
    value: function jumpToGoal() {
      this.update(0, 1e4);
    }
  }, {
    key: "update",
    value: function update(t, e) {
      if (this.isStationary()) return;
      var _this$_options4 = this._options,
          n = _this$_options4.maximumPolarAngle,
          i = _this$_options4.maximumRadius,
          r = this.spherical.theta - this.goalSpherical.theta;
      Math.abs(r) > Math.PI && !isFinite(this._options.minimumAzimuthalAngle) && !isFinite(this._options.maximumAzimuthalAngle) && (this.spherical.theta -= 2 * Math.sign(r) * Math.PI), this.spherical.theta = this.thetaDamper.update(this.spherical.theta, this.goalSpherical.theta, e, Math.PI), this.spherical.phi = this.phiDamper.update(this.spherical.phi, this.goalSpherical.phi, e, n), this.spherical.radius = this.radiusDamper.update(this.spherical.radius, this.goalSpherical.radius, e, i), this.logFov = this.fovDamper.update(this.logFov, this.goalLogFov, e, 1), this.moveCamera();
    }
  }, {
    key: "isStationary",
    value: function isStationary() {
      return this.goalSpherical.theta === this.spherical.theta && this.goalSpherical.phi === this.spherical.phi && this.goalSpherical.radius === this.spherical.radius && this.goalLogFov === this.logFov;
    }
  }, {
    key: "moveCamera",
    value: function moveCamera() {
      this.spherical.makeSafe(), this.camera.position.setFromSpherical(this.spherical), this.camera.setRotationFromEuler(new ue(this.spherical.phi - Math.PI / 2, this.spherical.theta, 0, "YXZ")), this.camera.fov !== Math.exp(this.logFov) && (this.camera.fov = Math.exp(this.logFov), this.camera.updateProjectionMatrix());
      var t = this.isUserChange ? ig : rg;
      this.dispatchEvent({
        type: "change",
        source: t
      });
    }
  }, {
    key: "canInteract",
    get: function get() {
      if ("allow-when-focused" == this._options.interactionPolicy) {
        return this.element.getRootNode().activeElement === this.element;
      }

      return "always-allow" === this._options.interactionPolicy;
    }
  }, {
    key: "userAdjustOrbit",
    value: function userAdjustOrbit(t, e, n) {
      this.adjustOrbit(t * this.sensitivity, e * this.sensitivity, n), this.isUserChange = !0, this.dispatchEvent({
        type: "change",
        source: ig
      });
    }
  }, {
    key: "wrapAngle",
    value: function wrapAngle(t) {
      var e = (t + Math.PI) / (2 * Math.PI);
      return 2 * (e - Math.floor(e)) * Math.PI - Math.PI;
    }
  }, {
    key: "pixelLengthToSphericalAngle",
    value: function pixelLengthToSphericalAngle(t) {
      return 2 * Math.PI * t / this.element.clientHeight;
    }
  }, {
    key: "twoTouchDistance",
    value: function twoTouchDistance(t, e) {
      var n = t.clientX,
          i = t.clientY,
          r = e.clientX,
          s = e.clientY,
          a = r - n,
          o = s - i;
      return Math.sqrt(a * a + o * o);
    }
  }, {
    key: "handleSinglePointerMove",
    value: function handleSinglePointerMove(t) {
      var e = t.clientX,
          n = t.clientY,
          i = this.pixelLengthToSphericalAngle(e - this.lastPointerPosition.clientX),
          r = this.pixelLengthToSphericalAngle(n - this.lastPointerPosition.clientY);
      this.lastPointerPosition.clientX = e, this.lastPointerPosition.clientY = n, !1 === this.isUserPointing && (this.isUserPointing = !0, this.dispatchEvent({
        type: "pointer-change-start",
        pointer: Object.assign({}, t)
      })), this.userAdjustOrbit(i, r, 0);
    }
  }, {
    key: "handleSinglePointerDown",
    value: function handleSinglePointerDown(t) {
      this.lastPointerPosition.clientX = t.clientX, this.lastPointerPosition.clientY = t.clientY, this.element.style.cursor = "grabbing";
    }
  }]);

  return sg;
}(tt);
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ag = function ag(t) {
  return t < .5 ? 2 * t * t : (4 - 2 * t) * t - 1;
},
    og = function og(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ag;
  return function (i) {
    return t + (e - t) * n(i);
  };
},
    lg = function lg(t, e) {
  var n = [],
      i = [];
  var r = t;

  for (var _t425 = 0; _t425 < e.length; ++_t425) {
    var _s98 = e[_t425],
        _a72 = _s98.value,
        _o46 = _s98.frames,
        _l39 = _s98.ease || ag,
        _c31 = og(r, _a72, _l39);

    n.push(_c31), i.push(_o46), r = _a72;
  }

  return function (t, e) {
    var n = e.reduce(function (t, e) {
      return t + e;
    }, 0),
        i = e.map(function (t) {
      return t / n;
    });
    return function (e) {
      var n = 0,
          r = 1 / 0,
          s = function s() {
        return 0;
      };

      for (var _a73 = 0; _a73 < i.length && (r = i[_a73], s = t[_a73], !(e <= n + r)); ++_a73) {
        n += r;
      }

      return s((e - n) / r);
    };
  }(n, i);
};
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var cg = function cg(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var hg = lg(0, [{
  frames: 5,
  value: -1
}, {
  frames: 1,
  value: -1
}, {
  frames: 8,
  value: 1
}, {
  frames: 1,
  value: 1
}, {
  frames: 5,
  value: 0
}, {
  frames: 18,
  value: 0
}]),
    ug = lg(0, [{
  frames: 1,
  value: 1
}, {
  frames: 5,
  value: 1
}, {
  frames: 1,
  value: 0
}, {
  frames: 6,
  value: 0
}]),
    dg = 1.1 * wu,
    pg = ["front", "right", "back", "left"],
    Ag = ["upper-", "", "lower-"],
    mg = "auto",
    gg = "when-focused",
    fg = "wiggle",
    vg = "always-allow",
    yg = "pan-y",
    xg = function xg(t) {
  return {
    basis: [ru(t[qg] * Math.PI / 180, "rad")],
    keywords: {
      auto: [null]
    }
  };
},
    wg = {
  basis: [Au(ru(25, "deg"))],
  keywords: {
    auto: [null]
  }
},
    Eg = function Eg(t) {
  var e = t[gp];
  return {
    basis: [Au(ru(45, "deg"))],
    keywords: {
      auto: [ru(e.framedFieldOfView, "deg")]
    }
  };
},
    bg = function () {
  var t = su("0deg 75deg 105%")[0].terms,
      e = gu(t[0]),
      n = gu(t[1]);
  return function (t) {
    var i = t[gp].idealCameraDistance;
    return {
      basis: [e, n, ru(i, "m")],
      keywords: {
        auto: [null, null, ru(105, "%")]
      }
    };
  };
}(),
    _g = function _g(t) {
  var e = dg * t[gp].idealCameraDistance;
  return {
    basis: [ru(-1 / 0, "rad"), ru(Math.PI / 8, "rad"), ru(e, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Ig = function Ig(t) {
  var e = bg(t),
      n = new Tm([], e).evaluate()[2];
  return {
    basis: [ru(1 / 0, "rad"), ru(Math.PI - Math.PI / 8, "rad"), ru(n, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Cg = function Cg(t) {
  var e = t[gp].boundingBox.getCenter(new _t());
  return {
    basis: [ru(e.x, "m"), ru(e.y, "m"), ru(e.z, "m")],
    keywords: {
      auto: [null, null, null]
    }
  };
},
    Mg = Math.PI / 2,
    Sg = Math.PI / 3,
    Bg = Mg / 2,
    Tg = 2 * Math.PI,
    Lg = Symbol("controls"),
    Rg = Symbol("promptElement"),
    Dg = Symbol("promptAnimatedContainer"),
    Qg = Symbol("deferInteractionPrompt"),
    Pg = Symbol("updateAria"),
    Fg = Symbol("updateCameraForRadius"),
    Ng = Symbol("onBlur"),
    Ug = Symbol("onFocus"),
    kg = Symbol("onChange"),
    Gg = Symbol("onPointerChange"),
    Og = Symbol("waitingToPromptUser"),
    Hg = Symbol("userHasInteracted"),
    zg = Symbol("promptElementVisibleTime"),
    Vg = Symbol("lastPromptOffset"),
    Wg = Symbol("focusedTime"),
    qg = Symbol("zoomAdjustedFieldOfView"),
    jg = Symbol("lastSpherical"),
    Yg = Symbol("jumpCamera"),
    Jg = Symbol("initialized"),
    Xg = Symbol("maintainThetaPhi"),
    Kg = Symbol("syncCameraOrbit"),
    Zg = Symbol("syncFieldOfView"),
    $g = Symbol("syncCameraTarget"),
    tf = Symbol("syncMinCameraOrbit"),
    ef = Symbol("syncMaxCameraOrbit"),
    nf = Symbol("syncMinFieldOfView"),
    rf = Symbol("syncMaxFieldOfView");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var sf, af;
var of = Symbol("modelViewerStatusInstance"),
    lf = Symbol("updateStatus");
sf = of, af = lf;
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cf = function cf(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var hf = "auto",
    uf = "manual",
    df = "auto",
    pf = "eager",
    Af = "interaction",
    mf = new ( /*#__PURE__*/function (_tt13) {
  _inherits(_class34, _tt13);

  var _super141 = _createSuper(_class34);

  function _class34() {
    var _this153;

    _classCallCheck(this, _class34);

    _this153 = _super141.call(this), _this153[sf] = null, _this153.registeredInstanceStatuses = new Map(), _this153.loadingPromises = [], _this153.statusElement = document.createElement("p"), _this153.statusUpdateInProgress = !1, _this153[af] = $h(function () {
      return _this153.updateStatus();
    }, 100);

    var _assertThisInitialize = _assertThisInitialized(_this153),
        t = _assertThisInitialize.statusElement,
        e = t.style;

    t.setAttribute("role", "status"), t.classList.add("screen-reader-only"), e.top = e.left = "0", e.pointerEvents = "none";
    return _this153;
  }

  _createClass(_class34, [{
    key: "registerInstance",
    value: function registerInstance(t) {
      if (this.registeredInstanceStatuses.has(t)) return;

      var e = function e() {};

      var n = !1 === t.loaded && !!t.src,
          i = new Promise(function (i) {
        if (!n) return void i();

        var r = function r() {
          i(), t.removeEventListener("load", r), t.removeEventListener("error", r);
        };

        t.addEventListener("load", r), t.addEventListener("error", r), e = r;
      });
      this.registeredInstanceStatuses.set(t, {
        onUnregistered: e
      }), this.loadingPromises.push(i), null == this.modelViewerStatusInstance && (this.modelViewerStatusInstance = t);
    }
  }, {
    key: "unregisterInstance",
    value: function unregisterInstance(t) {
      if (!this.registeredInstanceStatuses.has(t)) return;
      var e = this.registeredInstanceStatuses,
          n = e.get(t);
      e.delete(t), n.onUnregistered(), this.modelViewerStatusInstance === t && (this.modelViewerStatusInstance = e.size > 0 ? function (t) {
        if (null != t.keys) return t.keys().next().value || null;
        var e = null;

        try {
          t.forEach(function (t, n, i) {
            throw e = n, new Error();
          });
        } catch (t) {}

        return e;
      }(e) : null);
    }
  }, {
    key: "modelViewerStatusInstance",
    get: function get() {
      return this[of];
    },
    set: function set(t) {
      if (this[of] === t) return;
      var e = this.statusElement;
      null != t && null != t.shadowRoot ? t.shadowRoot.appendChild(e) : null != e.parentNode && e.parentNode.removeChild(e), this[of] = t, this[lf]();
    }
  }, {
    key: "updateStatus",
    value: function () {
      var _updateStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _t426;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!(!this.statusUpdateInProgress && 0 !== this.loadingPromises.length)) {
                  _context27.next = 10;
                  break;
                }

                this.statusElement.textContent = "This page includes one or more 3D models that are loading", this.statusUpdateInProgress = !0, this.dispatchEvent({
                  type: "initial-status-announced"
                });

              case 2:
                if (!this.loadingPromises.length) {
                  _context27.next = 9;
                  break;
                }

                _t426 = this.loadingPromises;
                this.loadingPromises = [];
                _context27.next = 7;
                return Promise.all(_t426);

              case 7:
                _context27.next = 2;
                break;

              case 9:
                this.statusElement.textContent = "All 3D models in the page have loaded", this.statusUpdateInProgress = !1, this.dispatchEvent({
                  type: "finished-loading-announced"
                });

              case 10:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function updateStatus() {
        return _updateStatus.apply(this, arguments);
      }

      return updateStatus;
    }()
  }]);

  return _class34;
}(tt))(),
    gf = Symbol("defaultProgressBarElement"),
    ff = Symbol("defaultProgressMaskElement"),
    vf = Symbol("posterContainerElement"),
    yf = Symbol("defaultPosterElement"),
    xf = Symbol("posterDismissalSource"),
    wf = Symbol("hidePoster"),
    Ef = Symbol("modelIsRevealed"),
    bf = Symbol("updateProgressBar"),
    _f = Symbol("lastReportedProgress"),
    If = Symbol("transitioned"),
    Cf = Symbol("ariaLabelCallToAction"),
    Mf = Symbol("onClick"),
    Sf = Symbol("onKeydown"),
    Bf = Symbol("onProgress");

var Tf = /*#__PURE__*/function () {
  function Tf() {
    _classCallCheck(this, Tf);

    this.pluginCallbacks = [], this.register(function (t) {
      return new rv(t);
    }), this.register(function (t) {
      return new sv(t);
    }), this.register(function (t) {
      return new av(t);
    }), this.register(function (t) {
      return new ov(t);
    }), this.register(function (t) {
      return new lv(t);
    });
  }

  _createClass(Tf, [{
    key: "register",
    value: function register(t) {
      return -1 === this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.push(t), this;
    }
  }, {
    key: "unregister",
    value: function unregister(t) {
      return -1 !== this.pluginCallbacks.indexOf(t) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t), 1), this;
    }
  }, {
    key: "parse",
    value: function parse(t, e, n) {
      var i = new iv(),
          r = [];

      for (var _t427 = 0, _e341 = this.pluginCallbacks.length; _t427 < _e341; _t427++) {
        r.push(this.pluginCallbacks[_t427](i));
      }

      i.setPlugins(r), i.write(t, e, n);
    }
  }]);

  return Tf;
}();

var Lf = 0,
    Rf = 1,
    Df = 2,
    Qf = 3,
    Pf = 4,
    Ff = 5121,
    Nf = 5123,
    Uf = 5126,
    kf = 5125,
    Gf = 34962,
    Of = 34963,
    Hf = 9728,
    zf = 9729,
    Vf = 9984,
    Wf = 9985,
    qf = 9986,
    jf = 9987,
    Yf = 33071,
    Jf = 33648,
    Xf = 10497,
    Kf = {};
Kf[1003] = Hf, Kf[1004] = Vf, Kf[1005] = qf, Kf[1006] = zf, Kf[1007] = Wf, Kf[1008] = jf, Kf[1001] = Yf, Kf[1e3] = Xf, Kf[1002] = Jf;
var Zf = {
  scale: "scale",
  position: "translation",
  quaternion: "rotation",
  morphTargetInfluences: "weights"
};

function $f(t, e) {
  return t.length === e.length && t.every(function (t, n) {
    return t === e[n];
  });
}

function tv(t) {
  return 4 * Math.ceil(t / 4);
}

function ev(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = tv(t.byteLength);

  if (n !== t.byteLength) {
    var _i251 = new Uint8Array(n);

    if (_i251.set(new Uint8Array(t)), 0 !== e) for (var _r169 = t.byteLength; _r169 < n; _r169++) {
      _i251[_r169] = e;
    }
    return _i251.buffer;
  }

  return t;
}

var nv = null;

var iv = /*#__PURE__*/function () {
  function iv() {
    _classCallCheck(this, iv);

    this.plugins = [], this.options = {}, this.pending = [], this.buffers = [], this.byteOffset = 0, this.buffers = [], this.nodeMap = new Map(), this.skins = [], this.extensionsUsed = {}, this.uids = new Map(), this.uid = 0, this.json = {
      asset: {
        version: "2.0",
        generator: "THREE.GLTFExporter"
      }
    }, this.cache = {
      meshes: new Map(),
      attributes: new Map(),
      attributesNormalized: new Map(),
      materials: new Map(),
      textures: new Map(),
      images: new Map()
    };
  }

  _createClass(iv, [{
    key: "setPlugins",
    value: function setPlugins(t) {
      this.plugins = t;
    }
  }, {
    key: "write",
    value: function write(t, e, n) {
      this.options = Object.assign({}, {
        binary: !1,
        trs: !1,
        onlyVisible: !0,
        truncateDrawRange: !0,
        embedImages: !0,
        maxTextureSize: 1 / 0,
        animations: [],
        includeCustomExtensions: !1
      }, n), this.options.animations.length > 0 && (this.options.trs = !0), this.processInput(t);
      var i = this;
      Promise.all(this.pending).then(function () {
        var t = i.buffers,
            n = i.json,
            r = i.options,
            s = i.extensionsUsed,
            a = new Blob(t, {
          type: "application/octet-stream"
        }),
            o = Object.keys(s);

        if (o.length > 0 && (n.extensionsUsed = o), n.buffers && n.buffers.length > 0 && (n.buffers[0].byteLength = a.size), !0 === r.binary) {
          var _t428 = new window.FileReader();

          _t428.readAsArrayBuffer(a), _t428.onloadend = function () {
            var i = ev(_t428.result),
                r = new DataView(new ArrayBuffer(8));
            r.setUint32(0, i.byteLength, !0), r.setUint32(4, 5130562, !0);
            var s = ev(function (t) {
              if (void 0 !== window.TextEncoder) return new TextEncoder().encode(t).buffer;
              var e = new Uint8Array(new ArrayBuffer(t.length));

              for (var _n302 = 0, _i252 = t.length; _n302 < _i252; _n302++) {
                var _i253 = t.charCodeAt(_n302);

                e[_n302] = _i253 > 255 ? 32 : _i253;
              }

              return e.buffer;
            }(JSON.stringify(n)), 32),
                a = new DataView(new ArrayBuffer(8));
            a.setUint32(0, s.byteLength, !0), a.setUint32(4, 1313821514, !0);
            var o = new ArrayBuffer(12),
                l = new DataView(o);
            l.setUint32(0, 1179937895, !0), l.setUint32(4, 2, !0);
            var c = 12 + a.byteLength + s.byteLength + r.byteLength + i.byteLength;
            l.setUint32(8, c, !0);
            var h = new Blob([o, a, s, r, i], {
              type: "application/octet-stream"
            }),
                u = new window.FileReader();
            u.readAsArrayBuffer(h), u.onloadend = function () {
              e(u.result);
            };
          };
        } else if (n.buffers && n.buffers.length > 0) {
          var _t429 = new window.FileReader();

          _t429.readAsDataURL(a), _t429.onloadend = function () {
            var i = _t429.result;
            n.buffers[0].uri = i, e(n);
          };
        } else e(n);
      });
    }
  }, {
    key: "serializeUserData",
    value: function serializeUserData(t, e) {
      if (0 === Object.keys(t.userData).length) return;
      var n = this.options,
          i = this.extensionsUsed;

      try {
        var _r170 = JSON.parse(JSON.stringify(t.userData));

        if (n.includeCustomExtensions && _r170.gltfExtensions) {
          void 0 === e.extensions && (e.extensions = {});

          for (var _t430 in _r170.gltfExtensions) {
            e.extensions[_t430] = _r170.gltfExtensions[_t430], i[_t430] = !0;
          }

          delete _r170.gltfExtensions;
        }

        Object.keys(_r170).length > 0 && (e.extras = _r170);
      } catch (e) {
        console.warn("THREE.GLTFExporter: userData of '" + t.name + "' won't be serialized because of JSON.stringify error - " + e.message);
      }
    }
  }, {
    key: "getUID",
    value: function getUID(t) {
      return this.uids.has(t) || this.uids.set(t, this.uid++), this.uids.get(t);
    }
  }, {
    key: "isNormalizedNormalAttribute",
    value: function isNormalizedNormalAttribute(t) {
      if (this.cache.attributesNormalized.has(t)) return !1;
      var e = new _t();

      for (var n = 0, _i254 = t.count; n < _i254; n++) {
        if (Math.abs(e.fromBufferAttribute(t, n).length() - 1) > 5e-4) return !1;
      }

      return !0;
    }
  }, {
    key: "createNormalizedNormalAttribute",
    value: function createNormalizedNormalAttribute(t) {
      var e = this.cache;
      if (e.attributesNormalized.has(t)) return e.attributesNormalized.get(t);
      var n = t.clone(),
          i = new _t();

      for (var _t431 = 0, _e342 = n.count; _t431 < _e342; _t431++) {
        i.fromBufferAttribute(n, _t431), 0 === i.x && 0 === i.y && 0 === i.z ? i.setX(1) : i.normalize(), n.setXYZ(_t431, i.x, i.y, i.z);
      }

      return e.attributesNormalized.set(t, n), n;
    }
  }, {
    key: "applyTextureTransform",
    value: function applyTextureTransform(t, e) {
      var n = !1;
      var i = {};
      0 === e.offset.x && 0 === e.offset.y || (i.offset = e.offset.toArray(), n = !0), 0 !== e.rotation && (i.rotation = e.rotation, n = !0), 1 === e.repeat.x && 1 === e.repeat.y || (i.scale = e.repeat.toArray(), n = !0), n && (t.extensions = t.extensions || {}, t.extensions.KHR_texture_transform = i, this.extensionsUsed.KHR_texture_transform = !0);
    }
  }, {
    key: "processBuffer",
    value: function processBuffer(t) {
      var e = this.json,
          n = this.buffers;
      return e.buffers || (e.buffers = [{
        byteLength: 0
      }]), n.push(t), 0;
    }
  }, {
    key: "processBufferView",
    value: function processBufferView(t, e, n, i, r) {
      var s = this.json;
      var a;
      s.bufferViews || (s.bufferViews = []), a = e === Ff ? 1 : e === Nf ? 2 : 4;
      var o = tv(i * t.itemSize * a),
          l = new DataView(new ArrayBuffer(o));
      var c = 0;

      for (var _r171 = n; _r171 < n + i; _r171++) {
        for (var _n303 = 0; _n303 < t.itemSize; _n303++) {
          var _i255 = void 0;

          t.itemSize > 4 ? _i255 = t.array[_r171 * t.itemSize + _n303] : 0 === _n303 ? _i255 = t.getX(_r171) : 1 === _n303 ? _i255 = t.getY(_r171) : 2 === _n303 ? _i255 = t.getZ(_r171) : 3 === _n303 && (_i255 = t.getW(_r171)), e === Uf ? l.setFloat32(c, _i255, !0) : e === kf ? l.setUint32(c, _i255, !0) : e === Nf ? l.setUint16(c, _i255, !0) : e === Ff && l.setUint8(c, _i255), c += a;
        }
      }

      var h = {
        buffer: this.processBuffer(l.buffer),
        byteOffset: this.byteOffset,
        byteLength: o
      };
      void 0 !== r && (h.target = r), r === Gf && (h.byteStride = t.itemSize * a), this.byteOffset += o, s.bufferViews.push(h);
      return {
        id: s.bufferViews.length - 1,
        byteLength: 0
      };
    }
  }, {
    key: "processBufferViewImage",
    value: function processBufferViewImage(t) {
      var e = this,
          n = e.json;
      return n.bufferViews || (n.bufferViews = []), new Promise(function (i) {
        var r = new window.FileReader();
        r.readAsArrayBuffer(t), r.onloadend = function () {
          var t = ev(r.result),
              s = {
            buffer: e.processBuffer(t),
            byteOffset: e.byteOffset,
            byteLength: t.byteLength
          };
          e.byteOffset += t.byteLength, i(n.bufferViews.push(s) - 1);
        };
      });
    }
  }, {
    key: "processAccessor",
    value: function processAccessor(t, e, n, i) {
      var r = this.options,
          s = this.json;
      var a;
      if (t.array.constructor === Float32Array) a = Uf;else if (t.array.constructor === Uint32Array) a = kf;else if (t.array.constructor === Uint16Array) a = Nf;else {
        if (t.array.constructor !== Uint8Array) throw new Error("THREE.GLTFExporter: Unsupported bufferAttribute component type.");
        a = Ff;
      }

      if (void 0 === n && (n = 0), void 0 === i && (i = t.count), r.truncateDrawRange && void 0 !== e && null === e.index) {
        var _r172 = n + i,
            _s99 = e.drawRange.count === 1 / 0 ? t.count : e.drawRange.start + e.drawRange.count;

        n = Math.max(n, e.drawRange.start), (i = Math.min(_r172, _s99) - n) < 0 && (i = 0);
      }

      if (0 === i) return null;

      var o = function (t, e, n) {
        var i = {
          min: new Array(t.itemSize).fill(Number.POSITIVE_INFINITY),
          max: new Array(t.itemSize).fill(Number.NEGATIVE_INFINITY)
        };

        for (var _r173 = e; _r173 < e + n; _r173++) {
          for (var _e343 = 0; _e343 < t.itemSize; _e343++) {
            var _n304 = void 0;

            t.itemSize > 4 ? _n304 = t.array[_r173 * t.itemSize + _e343] : 0 === _e343 ? _n304 = t.getX(_r173) : 1 === _e343 ? _n304 = t.getY(_r173) : 2 === _e343 ? _n304 = t.getZ(_r173) : 3 === _e343 && (_n304 = t.getW(_r173)), i.min[_e343] = Math.min(i.min[_e343], _n304), i.max[_e343] = Math.max(i.max[_e343], _n304);
          }
        }

        return i;
      }(t, n, i);

      var l;
      void 0 !== e && (l = t === e.index ? Of : Gf);
      var c = this.processBufferView(t, a, n, i, l),
          h = {
        bufferView: c.id,
        byteOffset: c.byteOffset,
        componentType: a,
        count: i,
        max: o.max,
        min: o.min,
        type: {
          1: "SCALAR",
          2: "VEC2",
          3: "VEC3",
          4: "VEC4",
          16: "MAT4"
        }[t.itemSize]
      };
      return !0 === t.normalized && (h.normalized = !0), s.accessors || (s.accessors = []), s.accessors.push(h) - 1;
    }
  }, {
    key: "processImage",
    value: function processImage(t, e, n) {
      var i = this,
          r = i.cache,
          s = i.json,
          a = i.options,
          o = i.pending;
      r.images.has(t) || r.images.set(t, {});
      var l = r.images.get(t),
          c = 1023 === e ? "image/png" : "image/jpeg",
          h = c + ":flipY/" + n.toString();
      if (void 0 !== l[h]) return l[h];
      s.images || (s.images = []);
      var u = {
        mimeType: c
      };

      if (a.embedImages) {
        var _r174 = nv = nv || document.createElement("canvas");

        _r174.width = Math.min(t.width, a.maxTextureSize), _r174.height = Math.min(t.height, a.maxTextureSize);

        var _s100 = _r174.getContext("2d");

        if (!0 === n && (_s100.translate(0, _r174.height), _s100.scale(1, -1)), "undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && t instanceof OffscreenCanvas || "undefined" != typeof ImageBitmap && t instanceof ImageBitmap) _s100.drawImage(t, 0, 0, _r174.width, _r174.height);else {
          1023 !== e && 1022 !== e && console.error("GLTFExporter: Only RGB and RGBA formats are supported."), (t.width > a.maxTextureSize || t.height > a.maxTextureSize) && console.warn("GLTFExporter: Image size is bigger than maxTextureSize", t);

          var _n305 = new Uint8ClampedArray(t.height * t.width * 4);

          if (1023 === e) for (var _e344 = 0; _e344 < _n305.length; _e344 += 4) {
            _n305[_e344 + 0] = t.data[_e344 + 0], _n305[_e344 + 1] = t.data[_e344 + 1], _n305[_e344 + 2] = t.data[_e344 + 2], _n305[_e344 + 3] = t.data[_e344 + 3];
          } else for (var _e345 = 0, _i256 = 0; _e345 < _n305.length; _e345 += 4, _i256 += 3) {
            _n305[_e345 + 0] = t.data[_i256 + 0], _n305[_e345 + 1] = t.data[_i256 + 1], _n305[_e345 + 2] = t.data[_i256 + 2], _n305[_e345 + 3] = 255;
          }

          _s100.putImageData(new ImageData(_n305, t.width, t.height), 0, 0);
        }
        !0 === a.binary ? o.push(new Promise(function (t) {
          _r174.toBlob(function (e) {
            i.processBufferViewImage(e).then(function (e) {
              u.bufferView = e, t();
            });
          }, c);
        })) : u.uri = _r174.toDataURL(c);
      } else u.uri = t.src;

      var d = s.images.push(u) - 1;
      return l[h] = d, d;
    }
  }, {
    key: "processSampler",
    value: function processSampler(t) {
      var e = this.json;
      e.samplers || (e.samplers = []);
      var n = {
        magFilter: Kf[t.magFilter],
        minFilter: Kf[t.minFilter],
        wrapS: Kf[t.wrapS],
        wrapT: Kf[t.wrapT]
      };
      return e.samplers.push(n) - 1;
    }
  }, {
    key: "processTexture",
    value: function processTexture(t) {
      var e = this.cache,
          n = this.json;
      if (e.textures.has(t)) return e.textures.get(t);
      n.textures || (n.textures = []);
      var i = {
        sampler: this.processSampler(t),
        source: this.processImage(t.image, t.format, t.flipY)
      };
      t.name && (i.name = t.name), this._invokeAll(function (e) {
        e.writeTexture && e.writeTexture(t, i);
      });
      var r = n.textures.push(i) - 1;
      return e.textures.set(t, r), r;
    }
  }, {
    key: "processMaterial",
    value: function processMaterial(t) {
      var e = this.cache,
          n = this.json;
      if (e.materials.has(t)) return e.materials.get(t);
      if (t.isShaderMaterial) return console.warn("GLTFExporter: THREE.ShaderMaterial not supported."), null;
      n.materials || (n.materials = []);
      var i = {
        pbrMetallicRoughness: {}
      };
      !0 !== t.isMeshStandardMaterial && !0 !== t.isMeshBasicMaterial && console.warn("GLTFExporter: Use MeshStandardMaterial or MeshBasicMaterial for best results.");
      var r = t.color.toArray().concat([t.opacity]);
      if ($f(r, [1, 1, 1, 1]) || (i.pbrMetallicRoughness.baseColorFactor = r), t.isMeshStandardMaterial ? (i.pbrMetallicRoughness.metallicFactor = t.metalness, i.pbrMetallicRoughness.roughnessFactor = t.roughness) : (i.pbrMetallicRoughness.metallicFactor = .5, i.pbrMetallicRoughness.roughnessFactor = .5), t.metalnessMap || t.roughnessMap) if (t.metalnessMap === t.roughnessMap) {
        var _e346 = {
          index: this.processTexture(t.metalnessMap)
        };
        this.applyTextureTransform(_e346, t.metalnessMap), i.pbrMetallicRoughness.metallicRoughnessTexture = _e346;
      } else console.warn("THREE.GLTFExporter: Ignoring metalnessMap and roughnessMap because they are not the same Texture.");

      if (t.map) {
        var _e347 = {
          index: this.processTexture(t.map)
        };
        this.applyTextureTransform(_e347, t.map), i.pbrMetallicRoughness.baseColorTexture = _e347;
      }

      if (t.emissive) {
        var _e348 = t.emissive.clone().multiplyScalar(t.emissiveIntensity),
            _n306 = Math.max(_e348.r, _e348.g, _e348.b);

        if (_n306 > 1 && (_e348.multiplyScalar(1 / _n306), console.warn("THREE.GLTFExporter: Some emissive components exceed 1; emissive has been limited")), _n306 > 0 && (i.emissiveFactor = _e348.toArray()), t.emissiveMap) {
          var _e349 = {
            index: this.processTexture(t.emissiveMap)
          };
          this.applyTextureTransform(_e349, t.emissiveMap), i.emissiveTexture = _e349;
        }
      }

      if (t.normalMap) {
        var _e350 = {
          index: this.processTexture(t.normalMap)
        };
        t.normalScale && 1 !== t.normalScale.x && (_e350.scale = t.normalScale.x), this.applyTextureTransform(_e350, t.normalMap), i.normalTexture = _e350;
      }

      if (t.aoMap) {
        var _e351 = {
          index: this.processTexture(t.aoMap),
          texCoord: 1
        };
        1 !== t.aoMapIntensity && (_e351.strength = t.aoMapIntensity), this.applyTextureTransform(_e351, t.aoMap), i.occlusionTexture = _e351;
      }

      t.transparent ? i.alphaMode = "BLEND" : t.alphaTest > 0 && (i.alphaMode = "MASK", i.alphaCutoff = t.alphaTest), 2 === t.side && (i.doubleSided = !0), "" !== t.name && (i.name = t.name), this.serializeUserData(t, i), this._invokeAll(function (e) {
        e.writeMaterial && e.writeMaterial(t, i);
      });
      var s = n.materials.push(i) - 1;
      return e.materials.set(t, s), s;
    }
  }, {
    key: "processMesh",
    value: function processMesh(t) {
      var e = this.cache,
          n = this.json,
          i = [t.geometry.uuid];
      if (Array.isArray(t.material)) for (var _e352 = 0, _n307 = t.material.length; _e352 < _n307; _e352++) {
        i.push(t.material[_e352].uuid);
      } else i.push(t.material.uuid);
      var r = i.join(":");
      if (e.meshes.has(r)) return e.meshes.get(r);
      var s = t.geometry;
      var a;
      if (a = t.isLineSegments ? Rf : t.isLineLoop ? Df : t.isLine ? Qf : t.isPoints ? Lf : t.material.wireframe ? Rf : Pf, !0 !== s.isBufferGeometry) throw new Error("THREE.GLTFExporter: Geometry is not of type THREE.BufferGeometry.");
      var o = {},
          l = {},
          c = [],
          h = [],
          u = {
        uv: "TEXCOORD_0",
        uv2: "TEXCOORD_1",
        color: "COLOR_0",
        skinWeight: "WEIGHTS_0",
        skinIndex: "JOINTS_0"
      },
          d = s.getAttribute("normal");
      void 0 === d || this.isNormalizedNormalAttribute(d) || (console.warn("THREE.GLTFExporter: Creating normalized normal attribute from the non-normalized one."), s.setAttribute("normal", this.createNormalizedNormalAttribute(d)));
      var p = null;

      for (var _t432 in s.attributes) {
        if ("morph" === _t432.substr(0, 5)) continue;
        var _n308 = s.attributes[_t432];
        _t432 = u[_t432] || _t432.toUpperCase();

        if (/^(POSITION|NORMAL|TANGENT|TEXCOORD_\d+|COLOR_\d+|JOINTS_\d+|WEIGHTS_\d+)$/.test(_t432) || (_t432 = "_" + _t432), e.attributes.has(this.getUID(_n308))) {
          l[_t432] = e.attributes.get(this.getUID(_n308));
          continue;
        }

        p = null;
        var _i257 = _n308.array;
        "JOINTS_0" !== _t432 || _i257 instanceof Uint16Array || _i257 instanceof Uint8Array || (console.warn('GLTFExporter: Attribute "skinIndex" converted to type UNSIGNED_SHORT.'), p = new Xe(new Uint16Array(_i257), _n308.itemSize, _n308.normalized));

        var _r175 = this.processAccessor(p || _n308, s);

        null !== _r175 && (l[_t432] = _r175, e.attributes.set(this.getUID(_n308), _r175));
      }

      if (void 0 !== d && s.setAttribute("normal", d), 0 === Object.keys(l).length) return null;

      if (void 0 !== t.morphTargetInfluences && t.morphTargetInfluences.length > 0) {
        var _n309 = [],
            _i258 = [],
            _r176 = {};
        if (void 0 !== t.morphTargetDictionary) for (var _e353 in t.morphTargetDictionary) {
          _r176[t.morphTargetDictionary[_e353]] = _e353;
        }

        for (var _a74 = 0; _a74 < t.morphTargetInfluences.length; ++_a74) {
          var _o47 = {};

          var _l40 = !1;

          for (var _t433 in s.morphAttributes) {
            if ("position" !== _t433 && "normal" !== _t433) {
              _l40 || (console.warn("GLTFExporter: Only POSITION and NORMAL morph are supported."), _l40 = !0);
              continue;
            }

            var _n310 = s.morphAttributes[_t433][_a74],
                _i259 = _t433.toUpperCase(),
                _r177 = s.attributes[_t433];

            if (e.attributes.has(this.getUID(_n310))) {
              _o47[_i259] = e.attributes.get(this.getUID(_n310));
              continue;
            }

            var _c32 = _n310.clone();

            if (!s.morphTargetsRelative) for (var _t434 = 0, _e354 = _n310.count; _t434 < _e354; _t434++) {
              _c32.setXYZ(_t434, _n310.getX(_t434) - _r177.getX(_t434), _n310.getY(_t434) - _r177.getY(_t434), _n310.getZ(_t434) - _r177.getZ(_t434));
            }
            _o47[_i259] = this.processAccessor(_c32, s), e.attributes.set(this.getUID(_r177), _o47[_i259]);
          }

          h.push(_o47), _n309.push(t.morphTargetInfluences[_a74]), void 0 !== t.morphTargetDictionary && _i258.push(_r176[_a74]);
        }

        o.weights = _n309, _i258.length > 0 && (o.extras = {}, o.extras.targetNames = _i258);
      }

      var A = Array.isArray(t.material);
      if (A && 0 === s.groups.length) return null;
      var m = A ? t.material : [t.material],
          g = A ? s.groups : [{
        materialIndex: 0,
        start: void 0,
        count: void 0
      }];

      for (var _t435 = 0, _n311 = g.length; _t435 < _n311; _t435++) {
        var _n312 = {
          mode: a,
          attributes: l
        };

        if (this.serializeUserData(s, _n312), h.length > 0 && (_n312.targets = h), null !== s.index) {
          var _i261 = this.getUID(s.index);

          void 0 === g[_t435].start && void 0 === g[_t435].count || (_i261 += ":" + g[_t435].start + ":" + g[_t435].count), e.attributes.has(_i261) ? _n312.indices = e.attributes.get(_i261) : (_n312.indices = this.processAccessor(s.index, s, g[_t435].start, g[_t435].count), e.attributes.set(_i261, _n312.indices)), null === _n312.indices && delete _n312.indices;
        }

        var _i260 = this.processMaterial(m[g[_t435].materialIndex]);

        null !== _i260 && (_n312.material = _i260), c.push(_n312);
      }

      o.primitives = c, n.meshes || (n.meshes = []), this._invokeAll(function (e) {
        e.writeMesh && e.writeMesh(t, o);
      });
      var f = n.meshes.push(o) - 1;
      return e.meshes.set(r, f), f;
    }
  }, {
    key: "processCamera",
    value: function processCamera(t) {
      var e = this.json;
      e.cameras || (e.cameras = []);
      var n = t.isOrthographicCamera,
          i = {
        type: n ? "orthographic" : "perspective"
      };
      return n ? i.orthographic = {
        xmag: 2 * t.right,
        ymag: 2 * t.top,
        zfar: t.far <= 0 ? .001 : t.far,
        znear: t.near < 0 ? 0 : t.near
      } : i.perspective = {
        aspectRatio: t.aspect,
        yfov: dt.degToRad(t.fov),
        zfar: t.far <= 0 ? .001 : t.far,
        znear: t.near < 0 ? 0 : t.near
      }, "" !== t.name && (i.name = t.type), e.cameras.push(i) - 1;
    }
  }, {
    key: "processAnimation",
    value: function processAnimation(t, e) {
      var n = this.json,
          i = this.nodeMap;
      n.animations || (n.animations = []);
      var r = (t = Tf.Utils.mergeMorphTargetTracks(t.clone(), e)).tracks,
          s = [],
          a = [];

      for (var _t436 = 0; _t436 < r.length; ++_t436) {
        var _n313 = r[_t436],
            _o48 = Ul.parseTrackName(_n313.name);

        var _l41 = Ul.findNode(e, _o48.nodeName);

        var _c33 = Zf[_o48.propertyName];
        if ("bones" === _o48.objectName && (_l41 = !0 === _l41.isSkinnedMesh ? _l41.skeleton.getBoneByName(_o48.objectIndex) : void 0), !_l41 || !_c33) return console.warn('THREE.GLTFExporter: Could not export animation track "%s".', _n313.name), null;
        var _h16 = 1;

        var _u16 = void 0,
            _d15 = _n313.values.length / _n313.times.length;

        _c33 === Zf.morphTargetInfluences && (_d15 /= _l41.morphTargetInfluences.length), !0 === _n313.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline ? (_u16 = "CUBICSPLINE", _d15 /= 3) : _u16 = 2300 === _n313.getInterpolation() ? "STEP" : "LINEAR", a.push({
          input: this.processAccessor(new Xe(_n313.times, _h16)),
          output: this.processAccessor(new Xe(_n313.values, _d15)),
          interpolation: _u16
        }), s.push({
          sampler: a.length - 1,
          target: {
            node: i.get(_l41),
            path: _c33
          }
        });
      }

      return n.animations.push({
        name: t.name || "clip_" + n.animations.length,
        samplers: a,
        channels: s
      }), n.animations.length - 1;
    }
  }, {
    key: "processSkin",
    value: function processSkin(t) {
      var e = this.json,
          n = this.nodeMap,
          i = e.nodes[n.get(t)],
          r = t.skeleton;
      if (void 0 === r) return null;
      var s = t.skeleton.bones[0];
      if (void 0 === s) return null;
      var a = [],
          o = new Float32Array(16 * r.bones.length),
          l = new ee();

      for (var _e355 = 0; _e355 < r.bones.length; ++_e355) {
        a.push(n.get(r.bones[_e355])), l.copy(r.boneInverses[_e355]), l.multiply(t.bindMatrix).toArray(o, 16 * _e355);
      }

      void 0 === e.skins && (e.skins = []), e.skins.push({
        inverseBindMatrices: this.processAccessor(new Xe(o, 16)),
        joints: a,
        skeleton: n.get(s)
      });
      return i.skin = e.skins.length - 1;
    }
  }, {
    key: "processNode",
    value: function processNode(t) {
      var e = this.json,
          n = this.options,
          i = this.nodeMap;
      e.nodes || (e.nodes = []);
      var r = {};

      if (n.trs) {
        var _e356 = t.quaternion.toArray(),
            _n314 = t.position.toArray(),
            _i262 = t.scale.toArray();

        $f(_e356, [0, 0, 0, 1]) || (r.rotation = _e356), $f(_n314, [0, 0, 0]) || (r.translation = _n314), $f(_i262, [1, 1, 1]) || (r.scale = _i262);
      } else t.matrixAutoUpdate && t.updateMatrix(), !1 === $f(t.matrix.elements, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]) && (r.matrix = t.matrix.elements);

      if ("" !== t.name && (r.name = String(t.name)), this.serializeUserData(t, r), t.isMesh || t.isLine || t.isPoints) {
        var _e357 = this.processMesh(t);

        null !== _e357 && (r.mesh = _e357);
      } else t.isCamera && (r.camera = this.processCamera(t));

      if (t.isSkinnedMesh && this.skins.push(t), t.children.length > 0) {
        var _e358 = [];

        for (var _i263 = 0, _r178 = t.children.length; _i263 < _r178; _i263++) {
          var _r179 = t.children[_i263];

          if (_r179.visible || !1 === n.onlyVisible) {
            var _t437 = this.processNode(_r179);

            null !== _t437 && _e358.push(_t437);
          }
        }

        _e358.length > 0 && (r.children = _e358);
      }

      this._invokeAll(function (e) {
        e.writeNode && e.writeNode(t, r);
      });

      var s = e.nodes.push(r) - 1;
      return i.set(t, s), s;
    }
  }, {
    key: "processScene",
    value: function processScene(t) {
      var e = this.json,
          n = this.options;
      e.scenes || (e.scenes = [], e.scene = 0);
      var i = {};
      "" !== t.name && (i.name = t.name), e.scenes.push(i);
      var r = [];

      for (var _e359 = 0, _i264 = t.children.length; _e359 < _i264; _e359++) {
        var _i265 = t.children[_e359];

        if (_i265.visible || !1 === n.onlyVisible) {
          var _t438 = this.processNode(_i265);

          null !== _t438 && r.push(_t438);
        }
      }

      r.length > 0 && (i.nodes = r), this.serializeUserData(t, i);
    }
  }, {
    key: "processObjects",
    value: function processObjects(t) {
      var e = new Ps();
      e.name = "AuxScene";

      for (var n = 0; n < t.length; n++) {
        e.children.push(t[n]);
      }

      this.processScene(e);
    }
  }, {
    key: "processInput",
    value: function processInput(t) {
      var e = this.options;
      t = t instanceof Array ? t : [t], this._invokeAll(function (e) {
        e.beforeParse && e.beforeParse(t);
      });
      var n = [];

      for (var _e360 = 0; _e360 < t.length; _e360++) {
        t[_e360] instanceof Ps ? this.processScene(t[_e360]) : n.push(t[_e360]);
      }

      n.length > 0 && this.processObjects(n);

      for (var _t439 = 0; _t439 < this.skins.length; ++_t439) {
        this.processSkin(this.skins[_t439]);
      }

      for (var _n315 = 0; _n315 < e.animations.length; ++_n315) {
        this.processAnimation(e.animations[_n315], t[0]);
      }

      this._invokeAll(function (e) {
        e.afterParse && e.afterParse(t);
      });
    }
  }, {
    key: "_invokeAll",
    value: function _invokeAll(t) {
      for (var _e361 = 0, n = this.plugins.length; _e361 < n; _e361++) {
        t(this.plugins[_e361]);
      }
    }
  }]);

  return iv;
}();

var rv = /*#__PURE__*/function () {
  function rv(t) {
    _classCallCheck(this, rv);

    this.writer = t, this.name = "KHR_lights_punctual";
  }

  _createClass(rv, [{
    key: "writeNode",
    value: function writeNode(t, e) {
      if (!t.isLight) return;
      if (!t.isDirectionalLight && !t.isPointLight && !t.isSpotLight) return void console.warn("THREE.GLTFExporter: Only directional, point, and spot lights are supported.", t);
      var n = this.writer,
          i = n.json,
          r = n.extensionsUsed,
          s = {};
      t.name && (s.name = t.name), s.color = t.color.toArray(), s.intensity = t.intensity, t.isDirectionalLight ? s.type = "directional" : t.isPointLight ? (s.type = "point", t.distance > 0 && (s.range = t.distance)) : t.isSpotLight && (s.type = "spot", t.distance > 0 && (s.range = t.distance), s.spot = {}, s.spot.innerConeAngle = (t.penumbra - 1) * t.angle * -1, s.spot.outerConeAngle = t.angle), void 0 !== t.decay && 2 !== t.decay && console.warn("THREE.GLTFExporter: Light decay may be lost. glTF is physically-based, and expects light.decay=2."), !t.target || t.target.parent === t && 0 === t.target.position.x && 0 === t.target.position.y && -1 === t.target.position.z || console.warn("THREE.GLTFExporter: Light direction may be lost. For best results, make light.target a child of the light with position 0,0,-1."), r[this.name] || (i.extensions = i.extensions || {}, i.extensions[this.name] = {
        lights: []
      }, r[this.name] = !0);
      var a = i.extensions[this.name].lights;
      a.push(s), e.extensions = e.extensions || {}, e.extensions[this.name] = {
        light: a.length - 1
      };
    }
  }]);

  return rv;
}();

var sv = /*#__PURE__*/function () {
  function sv(t) {
    _classCallCheck(this, sv);

    this.writer = t, this.name = "KHR_materials_unlit";
  }

  _createClass(sv, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshBasicMaterial) return;
      var n = this.writer.extensionsUsed;
      e.extensions = e.extensions || {}, e.extensions[this.name] = {}, n[this.name] = !0, e.pbrMetallicRoughness.metallicFactor = 0, e.pbrMetallicRoughness.roughnessFactor = .9;
    }
  }]);

  return sv;
}();

var av = /*#__PURE__*/function () {
  function av(t) {
    _classCallCheck(this, av);

    this.writer = t, this.name = "KHR_materials_pbrSpecularGlossiness";
  }

  _createClass(av, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isGLTFSpecularGlossinessMaterial) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};
      e.pbrMetallicRoughness.baseColorFactor && (r.diffuseFactor = e.pbrMetallicRoughness.baseColorFactor);
      var s = [1, 1, 1];

      if (t.specular.toArray(s, 0), r.specularFactor = s, r.glossinessFactor = t.glossiness, e.pbrMetallicRoughness.baseColorTexture && (r.diffuseTexture = e.pbrMetallicRoughness.baseColorTexture), t.specularMap) {
        var _e362 = {
          index: n.processTexture(t.specularMap)
        };
        n.applyTextureTransform(_e362, t.specularMap), r.specularGlossinessTexture = _e362;
      }

      e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return av;
}();

var ov = /*#__PURE__*/function () {
  function ov(t) {
    _classCallCheck(this, ov);

    this.writer = t, this.name = "KHR_materials_transmission";
  }

  _createClass(ov, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshPhysicalMaterial || 0 === t.transmission) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};

      if (r.transmissionFactor = t.transmission, t.transmissionMap) {
        var _e363 = {
          index: n.processTexture(t.transmissionMap)
        };
        n.applyTextureTransform(_e363, t.transmissionMap), r.transmissionTexture = _e363;
      }

      e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return ov;
}();

var lv = /*#__PURE__*/function () {
  function lv(t) {
    _classCallCheck(this, lv);

    this.writer = t, this.name = "KHR_materials_volume";
  }

  _createClass(lv, [{
    key: "writeMaterial",
    value: function writeMaterial(t, e) {
      if (!t.isMeshPhysicalMaterial || 0 === t.thickness) return;
      var n = this.writer,
          i = n.extensionsUsed,
          r = {};

      if (r.thicknessFactor = t.thickness, t.thicknessMap) {
        var _e364 = {
          index: n.processTexture(t.thicknessMap)
        };
        n.applyTextureTransform(_e364, t.thicknessMap), r.thicknessTexture = _e364;
      }

      r.attenuationDistance = t.attenuationDistance, r.attenuationColor = t.attenuationTint.toArray(), e.extensions = e.extensions || {}, e.extensions[this.name] = r, i[this.name] = !0;
    }
  }]);

  return lv;
}();

Tf.Utils = {
  insertKeyframe: function insertKeyframe(t, e) {
    var n = .001,
        i = t.getValueSize(),
        r = new t.TimeBufferType(t.times.length + 1),
        s = new t.ValueBufferType(t.values.length + i),
        a = t.createInterpolant(new t.ValueBufferType(i));
    var o;

    if (0 === t.times.length) {
      r[0] = e;

      for (var _t440 = 0; _t440 < i; _t440++) {
        s[_t440] = 0;
      }

      o = 0;
    } else if (e < t.times[0]) {
      if (Math.abs(t.times[0] - e) < n) return 0;
      r[0] = e, r.set(t.times, 1), s.set(a.evaluate(e), 0), s.set(t.values, i), o = 0;
    } else if (e > t.times[t.times.length - 1]) {
      if (Math.abs(t.times[t.times.length - 1] - e) < n) return t.times.length - 1;
      r[r.length - 1] = e, r.set(t.times, 0), s.set(t.values, 0), s.set(a.evaluate(e), t.values.length), o = r.length - 1;
    } else for (var _l42 = 0; _l42 < t.times.length; _l42++) {
      if (Math.abs(t.times[_l42] - e) < n) return _l42;

      if (t.times[_l42] < e && t.times[_l42 + 1] > e) {
        r.set(t.times.slice(0, _l42 + 1), 0), r[_l42 + 1] = e, r.set(t.times.slice(_l42 + 1), _l42 + 2), s.set(t.values.slice(0, (_l42 + 1) * i), 0), s.set(a.evaluate(e), (_l42 + 1) * i), s.set(t.values.slice((_l42 + 1) * i), (_l42 + 2) * i), o = _l42 + 1;
        break;
      }
    }

    return t.times = r, t.values = s, o;
  },
  mergeMorphTargetTracks: function mergeMorphTargetTracks(t, e) {
    var n = [],
        i = {},
        r = t.tracks;

    for (var _t441 = 0; _t441 < r.length; ++_t441) {
      var _s101 = r[_t441];

      var _a75 = Ul.parseTrackName(_s101.name),
          _o49 = Ul.findNode(e, _a75.nodeName);

      if ("morphTargetInfluences" !== _a75.propertyName || void 0 === _a75.propertyIndex) {
        n.push(_s101);
        continue;
      }

      if (_s101.createInterpolant !== _s101.InterpolantFactoryMethodDiscrete && _s101.createInterpolant !== _s101.InterpolantFactoryMethodLinear) {
        if (_s101.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) throw new Error("THREE.GLTFExporter: Cannot merge tracks with glTF CUBICSPLINE interpolation.");
        console.warn("THREE.GLTFExporter: Morph target interpolation mode not yet supported. Using LINEAR instead."), _s101 = _s101.clone(), _s101.setInterpolation(2301);
      }

      var _l43 = _o49.morphTargetInfluences.length,
          _c34 = _o49.morphTargetDictionary[_a75.propertyIndex];
      if (void 0 === _c34) throw new Error("THREE.GLTFExporter: Morph target name not found: " + _a75.propertyIndex);

      var _h17 = void 0;

      if (void 0 === i[_o49.uuid]) {
        _h17 = _s101.clone();

        var _t442 = new _h17.ValueBufferType(_l43 * _h17.times.length);

        for (var _e365 = 0; _e365 < _h17.times.length; _e365++) {
          _t442[_e365 * _l43 + _c34] = _h17.values[_e365];
        }

        _h17.name = (_a75.nodeName || "") + ".morphTargetInfluences", _h17.values = _t442, i[_o49.uuid] = _h17, n.push(_h17);
        continue;
      }

      var _u17 = _s101.createInterpolant(new _s101.ValueBufferType(1));

      _h17 = i[_o49.uuid];

      for (var _t443 = 0; _t443 < _h17.times.length; _t443++) {
        _h17.values[_t443 * _l43 + _c34] = _u17.evaluate(_h17.times[_t443]);
      }

      for (var _t444 = 0; _t444 < _s101.times.length; _t444++) {
        var _e366 = this.insertKeyframe(_h17, _s101.times[_t444]);

        _h17.values[_e366 * _l43 + _c34] = _s101.values[_t444];
      }
    }

    return t.tracks = n, t;
  }
};
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var cv = function cv(t) {
  return void 0 !== t.material && t.userData && t.userData.variantMaterials && !!Array.from(t.userData.variantMaterials.values()).filter(function (t) {
    return hv(t.material);
  });
},
    hv = function hv(t) {
  return t && t.isMaterial && !Array.isArray(t);
};

var uv = /*#__PURE__*/function () {
  function uv(t) {
    _classCallCheck(this, uv);

    this.writer = t, this.name = "KHR_materials_variants", this.variantNames = [];
  }

  _createClass(uv, [{
    key: "beforeParse",
    value: function beforeParse(t) {
      var _this154 = this;

      var e = new Set();

      var _iterator34 = _createForOfIteratorHelper(t),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var n = _step34.value;
          n.traverse(function (t) {
            if (!cv(t)) return;
            var n = t.userData.variantMaterials;

            var _iterator35 = _createForOfIteratorHelper(n.keys()),
                _step35;

            try {
              for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                var _t445 = _step35.value;

                var _i266 = n.get(_t445);

                hv(_i266.material) && e.add(_t445);
              }
            } catch (err) {
              _iterator35.e(err);
            } finally {
              _iterator35.f();
            }
          });
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }

      e.forEach(function (t) {
        return _this154.variantNames.push(t);
      });
    }
  }, {
    key: "writeMesh",
    value: function writeMesh(t, e) {
      if (!cv(t)) return;
      var n = t.userData,
          i = n.variantMaterials,
          r = new Map();

      var _iterator36 = _createForOfIteratorHelper(i.keys()),
          _step36;

      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _t446 = _step36.value;
          var _e367 = i.get(_t446).material;
          if (!hv(_e367)) continue;

          var _n316 = this.variantNames.indexOf(_t446),
              _s102 = this.writer.processMaterial(_e367);

          r.has(_s102) || r.set(_s102, {
            material: _s102,
            variants: []
          }), r.get(_s102).variants.push(_n316);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }

      var s = Array.from(r.values()).map(function (t) {
        return t.variants.sort(function (t, e) {
          return t - e;
        }) && t;
      }).sort(function (t, e) {
        return t.material - e.material;
      });
      if (0 === s.length) return;
      var a = hv(n.originalMaterial) ? this.writer.processMaterial(n.originalMaterial) : -1;

      var _iterator37 = _createForOfIteratorHelper(e.primitives),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var _t447 = _step37.value;
          a >= 0 && (_t447.material = a), _t447.extensions = _t447.extensions || {}, _t447.extensions[this.name] = {
            mappings: s
          };
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }
  }, {
    key: "afterParse",
    value: function afterParse() {
      if (0 === this.variantNames.length) return;
      var t = this.writer.json;
      t.extensions = t.extensions || {};
      var e = this.variantNames.map(function (t) {
        return {
          name: t
        };
      });
      t.extensions[this.name] = {
        variants: e
      }, this.writer.extensionsUsed[this.name] = !0;
    }
  }]);

  return uv;
}();
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var dv = Symbol("correlatedObjects"),
    pv = Symbol("sourceObject"),
    Av = Symbol("onUpdate");

var mv = /*#__PURE__*/_createClass(function mv(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  _classCallCheck(this, mv);

  this[Av] = t, this[pv] = e, this[dv] = n;
});
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var gv = new el(),
    fv = new je(),
    vv = new Yn(2, 2),
    yv = Symbol("threeTexture");

var xv = /*#__PURE__*/function (_mv) {
  _inherits(xv, _mv);

  var _super142 = _createSuper(xv);

  function xv(t, e, n) {
    _classCallCheck(this, xv);

    return _super142.call(this, t, n = null != n ? n : {
      name: "adhoc_image",
      uri: e && e.image ? e.image.src : "adhoc_image"
    }, new Set(e ? [e] : []));
  }

  _createClass(xv, [{
    key: yv,
    get: function get() {
      var t;
      return console.assert(null != this[dv] && this[dv].size > 0, "Image correlated object is undefined"), null === (t = this[dv]) || void 0 === t ? void 0 : t.values().next().value;
    }
  }, {
    key: "name",
    get: function get() {
      return this[pv].name || "";
    }
  }, {
    key: "uri",
    get: function get() {
      return this[pv].uri;
    }
  }, {
    key: "bufferView",
    get: function get() {
      return this[pv].bufferView;
    }
  }, {
    key: "type",
    get: function get() {
      return null != this.uri ? "external" : "embedded";
    }
  }, {
    key: "setURI",
    value: function () {
      var _setURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t) {
        var e, n;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this[pv].uri = t;
                _context28.next = 3;
                return new Promise(function (e, n) {
                  gv.load(t, e, void 0, n);
                });

              case 3:
                e = _context28.sent;
                n = this[yv];
                n.image = e, n.needsUpdate = !0, this[Av]();

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function setURI(_x27) {
        return _setURI.apply(this, arguments);
      }

      return setURI;
    }()
  }, {
    key: "createThumbnail",
    value: function () {
      var _createThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t, e) {
        var n, i, r, s, a, o, l, c;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                n = new Ps();
                fv.map = this[yv];
                i = new Mn(vv, fv);
                n.add(i);
                r = new ri(-1, 1, 1, -1, 0, 1), s = Dd.singleton.threeRenderer, a = new wt(t, e);
                s.setRenderTarget(a), s.render(n, r), s.setRenderTarget(null);
                o = new Uint8Array(t * e * 4);
                s.readRenderTargetPixels(a, 0, 0, t, e, o), Kd.width = t, Kd.height = e;
                l = Kd.getContext("2d"), c = l.createImageData(t, e);
                return _context30.abrupt("return", (c.data.set(o), l.putImageData(c, 0, 0), new Promise( /*#__PURE__*/function () {
                  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t, e) {
                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            Kd.toBlob(function (n) {
                              if (!n) return e("Failed to capture thumbnail.");
                              t(URL.createObjectURL(n));
                            }, "image/png");

                          case 1:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));

                  return function (_x30, _x31) {
                    return _ref24.apply(this, arguments);
                  };
                }())));

              case 10:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function createThumbnail(_x28, _x29) {
        return _createThumbnail.apply(this, arguments);
      }

      return createThumbnail;
    }()
  }]);

  return xv;
}(mv);

var wv, Ev;
!function (t) {
  t[t.Nearest = 9728] = "Nearest", t[t.Linear = 9729] = "Linear", t[t.NearestMipmapNearest = 9984] = "NearestMipmapNearest", t[t.LinearMipmapNearest = 9985] = "LinearMipmapNearest", t[t.NearestMipmapLinear = 9986] = "NearestMipmapLinear", t[t.LinearMipmapLinear = 9987] = "LinearMipmapLinear";
}(wv || (wv = {})), function (t) {
  t[t.ClampToEdge = 33071] = "ClampToEdge", t[t.MirroredRepeat = 33648] = "MirroredRepeat", t[t.Repeat = 10497] = "Repeat";
}(Ev || (Ev = {}));
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var bv = function () {
  var t = [wv.Nearest, wv.Linear, wv.NearestMipmapNearest, wv.LinearMipmapLinear, wv.NearestMipmapLinear, wv.LinearMipmapLinear];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    _v = function () {
  var t = [wv.Nearest, wv.Linear];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    Iv = function () {
  var t = [Ev.ClampToEdge, Ev.MirroredRepeat, Ev.Repeat];
  return function (e) {
    return t.indexOf(e) > -1;
  };
}(),
    Cv = Symbol("threeTextures"),
    Mv = Symbol("setProperty"),
    Sv = Symbol("sourceSampler");

var Bv = /*#__PURE__*/function (_mv2) {
  _inherits(Bv, _mv2);

  var _super143 = _createSuper(Bv);

  function Bv(t, e, n) {
    var _this155;

    _classCallCheck(this, Bv);

    null == (n = null != n ? n : {}).minFilter && (n.minFilter = e ? e.minFilter : wv.LinearMipmapLinear), null == n.magFilter && (n.magFilter = e ? e.magFilter : wv.Linear), null == n.wrapS && (n.wrapS = e ? e.wrapS : Ev.Repeat), null == n.wrapT && (n.wrapT = e ? e.wrapT : Ev.Repeat), _this155 = _super143.call(this, t, n, new Set(e ? [e] : []));
    return _this155;
  }

  _createClass(Bv, [{
    key: Cv,
    get: function get() {
      return console.assert(null != this[dv] && this[dv].size > 0, "Sampler correlated object is undefined"), this[dv];
    }
  }, {
    key: Sv,
    get: function get() {
      return console.assert(null != this[pv], "Sampler source is undefined"), this[pv];
    }
  }, {
    key: "name",
    get: function get() {
      return this[pv].name || "";
    }
  }, {
    key: "minFilter",
    get: function get() {
      return this[Sv].minFilter;
    }
  }, {
    key: "magFilter",
    get: function get() {
      return this[Sv].magFilter;
    }
  }, {
    key: "wrapS",
    get: function get() {
      return this[Sv].wrapS;
    }
  }, {
    key: "wrapT",
    get: function get() {
      return this[Sv].wrapT;
    }
  }, {
    key: "setMinFilter",
    value: function setMinFilter(t) {
      this[Mv]("minFilter", t);
    }
  }, {
    key: "setMagFilter",
    value: function setMagFilter(t) {
      this[Mv]("magFilter", t);
    }
  }, {
    key: "setWrapS",
    value: function setWrapS(t) {
      this[Mv]("wrapS", t);
    }
  }, {
    key: "setWrapT",
    value: function setWrapT(t) {
      this[Mv]("wrapT", t);
    }
  }, {
    key: Mv,
    value: function value(t, e) {
      var n = this[Sv];

      if (null != n) {
        if (function (t, e) {
          switch (t) {
            case "minFilter":
              return bv(e);

            case "magFilter":
              return _v(e);

            case "wrapS":
            case "wrapT":
              return Iv(e);

            default:
              throw new Error("Cannot configure property \"".concat(t, "\" on Sampler"));
          }
        }(t, e)) {
          n[t] = e;

          var _iterator38 = _createForOfIteratorHelper(this[Cv]),
              _step38;

          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _n317 = _step38.value;
              _n317[t] = e, _n317.needsUpdate = !0;
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
        }

        this[Av]();
      }
    }
  }]);

  return Bv;
}(mv);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Tv = Symbol("image"),
    Lv = Symbol("sampler");

var Rv = /*#__PURE__*/function (_mv3) {
  _inherits(Rv, _mv3);

  var _super144 = _createSuper(Rv);

  function Rv(t, e) {
    var _this156;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, Rv);

    _this156 = _super144.call(this, t, n || {}, new Set(e ? [e] : [])), _this156[Lv] = new Bv(t, e, i), _this156[Tv] = new xv(t, e, r);
    return _this156;
  }

  _createClass(Rv, [{
    key: "name",
    get: function get() {
      return this[pv].name || "";
    }
  }, {
    key: "sampler",
    get: function get() {
      return this[Lv];
    }
  }, {
    key: "source",
    get: function get() {
      return this[Tv];
    }
  }]);

  return Rv;
}(mv);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Dv;
var Qv = Symbol("texture"),
    Pv = Symbol("materials"),
    Fv = Symbol("usage");
var Nv;
!function (t) {
  t[t.Base = 0] = "Base", t[t.MetallicRoughness = 1] = "MetallicRoughness", t[t.Normal = 2] = "Normal", t[t.Occlusion = 3] = "Occlusion", t[t.Emissive = 4] = "Emissive";
}(Nv || (Nv = {}));

var Uv = /*#__PURE__*/function () {
  function Uv(t, e, n, i, r, s) {
    _classCallCheck(this, Uv);

    if (this[Dv] = null, s) {
      var _e368 = r.textures ? r.textures[s.index] : null,
          _i267 = _e368 && r.samplers ? r.samplers[_e368.sampler] : null,
          _a76 = _e368 && r.images ? r.images[_e368.source] : null;

      this[Qv] = new Rv(t, n, _e368, _i267, _a76);
    }

    this.onUpdate = t, this[Pv] = i, this[Fv] = e;
  }

  _createClass(Uv, [{
    key: "texture",
    get: function get() {
      return this[Qv];
    }
  }, {
    key: "setTexture",
    value: function setTexture(t) {
      var e = null != t ? t.source[yv] : null;
      var n = 3001;

      if (this[Qv] = t, this[Pv]) {
        var _iterator39 = _createForOfIteratorHelper(this[Pv]),
            _step39;

        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var _t448 = _step39.value;

            switch (this[Fv]) {
              case Nv.Base:
                _t448.map = e;
                break;

              case Nv.MetallicRoughness:
                n = 3e3, _t448.metalnessMap = e, _t448.roughnessMap = e;
                break;

              case Nv.Normal:
                n = 3e3, _t448.normalMap = e;
                break;

              case Nv.Occlusion:
                n = 3e3, _t448.aoMap = e;
                break;

              case Nv.Emissive:
                _t448.emissiveMap = e;
            }

            _t448.needsUpdate = !0;
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }
      }

      e && (e.encoding = n), this.onUpdate();
    }
  }]);

  return Uv;
}();

Dv = Qv;
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var kv = Symbol("threeMaterials"),
    Gv = Symbol("baseColorTexture"),
    Ov = Symbol("metallicRoughnessTexture");

var Hv = /*#__PURE__*/function (_mv4) {
  _inherits(Hv, _mv4);

  var _super145 = _createSuper(Hv);

  function Hv(t, e, n, i) {
    var _this157;

    _classCallCheck(this, Hv);

    _this157 = _super145.call(this, t, n, i), null == n.baseColorFactor && (n.baseColorFactor = [1, 1, 1, 1]), null == n.roughnessFactor && (n.roughnessFactor = 1), null == n.metallicFactor && (n.metallicFactor = 1);
    var r = n.baseColorTexture,
        s = n.metallicRoughnessTexture,
        _i$values$next$value = i.values().next().value,
        a = _i$values$next$value.map,
        o = _i$values$next$value.metalnessMap;
    _this157[Gv] = new Uv(t, Nv.Base, a, i, e, r || null), _this157[Ov] = new Uv(t, Nv.MetallicRoughness, o, i, e, s || null);
    return _this157;
  }

  _createClass(Hv, [{
    key: kv,
    get: function get() {
      return this[dv];
    }
  }, {
    key: "baseColorFactor",
    get: function get() {
      return this[pv].baseColorFactor;
    }
  }, {
    key: "metallicFactor",
    get: function get() {
      return this[pv].metallicFactor;
    }
  }, {
    key: "roughnessFactor",
    get: function get() {
      return this[pv].roughnessFactor;
    }
  }, {
    key: "baseColorTexture",
    get: function get() {
      return this[Gv];
    }
  }, {
    key: "metallicRoughnessTexture",
    get: function get() {
      return this[Ov];
    }
  }, {
    key: "setBaseColorFactor",
    value: function setBaseColorFactor(t) {
      var _iterator40 = _createForOfIteratorHelper(this[kv]),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var _e369 = _step40.value;
          _e369.color.fromArray(t), _e369.opacity = t[3];
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }

      this[pv].baseColorFactor = t, this[Av]();
    }
  }, {
    key: "setMetallicFactor",
    value: function setMetallicFactor(t) {
      var _iterator41 = _createForOfIteratorHelper(this[kv]),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var _e370 = _step41.value;
          _e370.metalness = t;
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }

      this[pv].metallicFactor = t, this[Av]();
    }
  }, {
    key: "setRoughnessFactor",
    value: function setRoughnessFactor(t) {
      var _iterator42 = _createForOfIteratorHelper(this[kv]),
          _step42;

      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var _e371 = _step42.value;
          _e371.roughness = t;
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }

      this[pv].roughnessFactor = t, this[Av]();
    }
  }]);

  return Hv;
}(mv);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var zv = Symbol("pbrMetallicRoughness"),
    Vv = Symbol("normalTexture"),
    Wv = Symbol("occlusionTexture"),
    qv = Symbol("emissiveTexture"),
    jv = Symbol("backingThreeMaterial"),
    Yv = Symbol("applyAlphaCutoff");

var Jv = /*#__PURE__*/function (_mv5) {
  _inherits(Jv, _mv5);

  var _super146 = _createSuper(Jv);

  function Jv(t, e, n, i) {
    var _this158;

    _classCallCheck(this, Jv);

    if (_this158 = _super146.call(this, t, n, i), null == i) return _possibleConstructorReturn(_this158);
    n.extensions && n.extensions.KHR_materials_pbrSpecularGlossiness && console.warn("Material ".concat(n.name, " uses a deprecated extension\n          \"KHR_materials_pbrSpecularGlossiness\", please use\n          \"pbrMetallicRoughness\" instead. Specular Glossiness materials are\n          currently supported for rendering, but not for our scene-graph API,\n          nor for auto-generation of USDZ for Quick Look.")), null == n.pbrMetallicRoughness && (n.pbrMetallicRoughness = {}), _this158[zv] = new Hv(t, e, n.pbrMetallicRoughness, i), null == n.emissiveFactor && (n.emissiveFactor = [0, 0, 0]), null == n.doubleSided && (n.doubleSided = !1), null == n.alphaMode && (n.alphaMode = "OPAQUE"), null == n.alphaCutoff && (n.alphaCutoff = .5);
    var r = n.normalTexture,
        s = n.occlusionTexture,
        a = n.emissiveTexture,
        _i$values$next$value2 = i.values().next().value,
        o = _i$values$next$value2.normalMap,
        l = _i$values$next$value2.aoMap,
        c = _i$values$next$value2.emissiveMap;
    _this158[Vv] = new Uv(t, Nv.Normal, o, i, e, r || null), _this158[Wv] = new Uv(t, Nv.Occlusion, l, i, e, s || null), _this158[qv] = new Uv(t, Nv.Emissive, c, i, e, a || null);
    return _possibleConstructorReturn(_this158);
  }

  _createClass(Jv, [{
    key: jv,
    get: function get() {
      return this[dv].values().next().value;
    }
  }, {
    key: "name",
    get: function get() {
      return this[pv].name || "";
    }
  }, {
    key: "pbrMetallicRoughness",
    get: function get() {
      return this[zv];
    }
  }, {
    key: "normalTexture",
    get: function get() {
      return this[Vv];
    }
  }, {
    key: "occlusionTexture",
    get: function get() {
      return this[Wv];
    }
  }, {
    key: "emissiveTexture",
    get: function get() {
      return this[qv];
    }
  }, {
    key: "emissiveFactor",
    get: function get() {
      return this[pv].emissiveFactor;
    }
  }, {
    key: "setEmissiveFactor",
    value: function setEmissiveFactor(t) {
      var _iterator43 = _createForOfIteratorHelper(this[dv]),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var _e372 = _step43.value;

          _e372.emissive.fromArray(t);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }

      this[pv].emissiveFactor = t, this[Av]();
    }
  }, {
    key: Yv,
    value: function value() {
      var t = this[pv],
          e = "OPAQUE" === t.alphaMode ? -.5 : "BLEND" === t.alphaMode ? 0 : Math.max(1e-4, Math.min(1, t.alphaCutoff));

      var _iterator44 = _createForOfIteratorHelper(this[dv]),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var _t449 = _step44.value;
          _t449.alphaTest = e, _t449.needsUpdate = !0;
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    }
  }, {
    key: "setAlphaCutoff",
    value: function setAlphaCutoff(t) {
      this[pv].alphaCutoff = t, this[Yv](), this[Av]();
    }
  }, {
    key: "getAlphaCutoff",
    value: function getAlphaCutoff() {
      return this[pv].alphaCutoff;
    }
  }, {
    key: "setDoubleSided",
    value: function setDoubleSided(t) {
      var _iterator45 = _createForOfIteratorHelper(this[dv]),
          _step45;

      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var _e373 = _step45.value;
          _e373.side = t ? 2 : 0, _e373.needsUpdate = !0;
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }

      this[pv].doubleSided = t, this[Av]();
    }
  }, {
    key: "getDoubleSided",
    value: function getDoubleSided() {
      return this[pv].doubleSided;
    }
  }, {
    key: "setAlphaMode",
    value: function setAlphaMode(t) {
      var e = function e(t, _e374) {
        t.transparent = _e374, t.depthWrite = !_e374;
      };

      this[pv].alphaMode = t;

      var _iterator46 = _createForOfIteratorHelper(this[dv]),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var n = _step46.value;
          e(n, "OPAQUE" !== t), this[Yv](), n.needsUpdate = !0;
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }

      this[Av]();
    }
  }, {
    key: "getAlphaMode",
    value: function getAlphaMode() {
      return this[pv].alphaMode;
    }
  }]);

  return Jv;
}(mv);
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xv;
var Kv = Symbol("materials");

var Zv = /*#__PURE__*/function () {
  function Zv(t) {
    var _this159 = this;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    _classCallCheck(this, Zv);

    this[Xv] = [];
    var n = t.gltf,
        i = t.gltfElementMap;
    n.materials.forEach(function (t) {
      _this159[Kv].push(new Jv(e, n, t, i.get(t)));
    });
  }

  _createClass(Zv, [{
    key: "materials",
    get: function get() {
      return this[Kv];
    }
  }]);

  return Zv;
}();

Xv = Kv;
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var $v = function $v(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var ty = Symbol("currentGLTF"),
    ey = Symbol("model"),
    ny = Symbol("variants"),
    iy = Symbol("getOnUpdateMethod"),
    ry = Symbol("textureLoader"),
    sy = Symbol("originalGltfJson");
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var ay = function ay(t, e, n, i) {
  for (var r, s = arguments.length, a = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i, o = t.length - 1; o >= 0; o--) {
    (r = t[o]) && (a = (s < 3 ? r(a) : s > 3 ? r(e, n, a) : r(e, n)) || a);
  }

  return s > 3 && a && Object.defineProperty(e, n, a), a;
};

var oy = Math.PI / 32,
    ly = {
  basis: [Au(ru(oy, "rad"))],
  keywords: {
    auto: [null]
  }
},
    cy = Symbol("autoRotateStartTime"),
    hy = Symbol("radiansPerSecond"),
    uy = Symbol("syncRotationRate"),
    dy = Symbol("onCameraChange"),
    py = function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t450, _ref25) {
    _inherits(r, _t450);

    var _super147 = _createSuper(r);

    function r() {
      var _this160;

      _classCallCheck(this, r);

      _this160 = _super147.apply(this, arguments), _this160[e] = new Map(), _this160[n] = function (t) {
        t.forEach(function (t) {
          t instanceof MutationRecord && "childList" !== t.type || (t.addedNodes.forEach(function (t) {
            _this160[Fp](t);
          }), t.removedNodes.forEach(function (t) {
            _this160[Np](t);
          }), _this160[fp]());
        });
      }, _this160[i] = new MutationObserver(_this160[Qp]);
      return _this160;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this);

        for (var _t451 = 0; _t451 < this.children.length; ++_t451) {
          this[Fp](this.children[_t451]);
        }

        var _self = self,
            t = _self.ShadyDOM;
        null == t ? this[Pp].observe(this, {
          childList: !0
        }) : this[Pp] = t.observeChildren(this, this[Qp]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this);

        var _self2 = self,
            t = _self2.ShadyDOM;
        null == t ? this[Pp].disconnect() : t.unobserveChildren(this[Pp]);
      }
    }, {
      key: _ref25,
      value: function value(t, e) {
        _get(_getPrototypeOf(r.prototype), vp, this).call(this, t, e);

        var n = this[gp],
            i = n.annotationRenderer,
            _r180 = n.getCamera();

        n.isDirty && (n.updateHotspots(_r180.position), i.domElement.style.display = "", i.render(n, _r180));
      }
    }, {
      key: "updateHotspot",
      value: function updateHotspot(t) {
        var e = this[Dp].get(t.name);
        null != e && (e.updatePosition(t.position), e.updateNormal(t.normal), this[fp]());
      }
    }, {
      key: "positionAndNormalFromPoint",
      value: function positionAndNormalFromPoint(t, e) {
        var n = this[gp],
            i = n.width,
            _r181 = n.height,
            s = n.target;
        Up.set(t / i, e / _r181).multiplyScalar(2).subScalar(1), Up.y *= -1;
        var a = n.positionAndNormalFromPoint(Up);
        if (null == a) return null;
        kp.copy(s.matrixWorld).invert();
        var o = Sp(a.position.applyMatrix4(kp));
        Gp.getNormalMatrix(kp);
        return {
          position: o,
          normal: Sp(a.normal.applyNormalMatrix(Gp))
        };
      }
    }, {
      key: Fp,
      value: function value(t) {
        if (!(t instanceof HTMLElement && 0 === t.slot.indexOf("hotspot"))) return;
        var e = this[Dp].get(t.slot);
        null != e ? e.increment() : (e = new fu({
          name: t.slot,
          position: t.dataset.position,
          normal: t.dataset.normal
        }), this[Dp].set(t.slot, e), this[gp].addHotspot(e)), this[gp].isDirty = !0;
      }
    }, {
      key: Np,
      value: function value(t) {
        if (!(t instanceof HTMLElement)) return;
        var e = this[Dp].get(t.slot);
        e && (e.decrement() && (this[gp].removeHotspot(e), this[Dp].delete(t.slot)), this[gp].isDirty = !0);
      }
    }]);

    return r;
  }(t, (e = Dp, n = Qp, i = Pp, vp));

  return r;
}(function (t) {
  var e, n, i, r, s;

  var a = /*#__PURE__*/function (_t452, _ref26) {
    _inherits(a, _t452);

    var _super148 = _createSuper(a);

    function a() {
      var _this161;

      _classCallCheck(this, a);

      _this161 = _super148.apply(this, arguments), _this161[e] = void 0, _this161[n] = null, _this161[i] = [], _this161[r] = new rl(), _this161[s] = null, _this161.variantName = void 0, _this161.orientation = "0 0 0", _this161.scale = "1 1 1";
      return _this161;
    }

    _createClass(a, [{
      key: "model",
      get: function get() {
        return this[ey];
      }
    }, {
      key: "availableVariants",
      get: function get() {
        return this[ny];
      }
    }, {
      key: "originalGltfJson",
      get: function get() {
        return this[sy];
      }
    }, {
      key: _ref26,
      value: function value() {
        var _this162 = this;

        return function () {
          _this162[fp]();
        };
      }
    }, {
      key: "createTexture",
      value: function () {
        var _createTexture2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(t) {
          var _this163 = this;

          var e,
              n,
              i,
              _args31 = arguments;
          return _regeneratorRuntime.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  e = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : "image/png";
                  n = this[ty];
                  _context31.next = 4;
                  return new Promise(function (e) {
                    return _this163[ry].load(t, e);
                  });

                case 4:
                  i = _context31.sent;
                  return _context31.abrupt("return", n && i ? (i.encoding = 3001, i.wrapS = 1e3, i.wrapT = 1e3, i.flipY = !1, "image/jpeg" === e && (i.format = 1022), new Rv(this[iy](), i)) : null);

                case 6:
                case "end":
                  return _context31.stop();
              }
            }
          }, _callee31, this);
        }));

        function createTexture(_x32) {
          return _createTexture2.apply(this, arguments);
        }

        return createTexture;
      }()
    }, {
      key: "updated",
      value: function () {
        var _updated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(t) {
          var _t453, _e375, _n318, _t453$correlatedScene, _i268, _r182, _iterator47, _step47, _t454, _e376, _t455, _e377, _n319, _i269, _r183, _s103;

          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  if (!(_get(_getPrototypeOf(a.prototype), "updated", this).call(this, t), t.has("variantName"))) {
                    _context32.next = 13;
                    break;
                  }

                  _t453 = this[ty], _e375 = this.variantName;

                  if (!(null == _t453)) {
                    _context32.next = 4;
                    break;
                  }

                  return _context32.abrupt("return");

                case 4:
                  _context32.next = 6;
                  return _t453.correlatedSceneGraph.loadVariant(_e375);

                case 6:
                  _n318 = _context32.sent;
                  _t453$correlatedScene = _t453.correlatedSceneGraph;
                  _i268 = _t453$correlatedScene.gltf;
                  _r182 = _t453$correlatedScene.gltfElementMap;
                  _iterator47 = _createForOfIteratorHelper(_n318);

                  try {
                    for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                      _t454 = _step47.value;
                      _e376 = _i268.materials[_t454];
                      this[ey].materials[_t454] = new Jv(this[iy](), _i268, _e376, _r182.get(_e376));
                    }
                  } catch (err) {
                    _iterator47.e(err);
                  } finally {
                    _iterator47.f();
                  }

                  this[fp]();

                case 13:
                  if (t.has("orientation") || t.has("scale")) {
                    _t455 = this[gp].modelContainer, _e377 = su(this.orientation)[0].terms, _n319 = gu(_e377[0]).number, _i269 = gu(_e377[1]).number, _r183 = gu(_e377[2]).number;

                    _t455.quaternion.setFromEuler(new ue(_i269, _r183, _n319, "YXZ"));

                    _s103 = su(this.scale)[0].terms;
                    _t455.scale.set(_s103[0].number, _s103[1].number, _s103[2].number), this[gp].updateBoundingBox(), this[gp].updateShadow(), this[wp].arRenderer.onUpdateScene(), this[fp]();
                  }

                case 14:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32, this);
        }));

        function updated(_x33) {
          return _updated.apply(this, arguments);
        }

        return updated;
      }()
    }, {
      key: yp,
      value: function value() {
        _get(_getPrototypeOf(a.prototype), yp, this).call(this), this[ny] = [];
        var t = this[gp].currentGLTF;

        if (null != t) {
          var _e378 = t.correlatedSceneGraph;
          null != _e378 && t !== this[ty] && (this[ey] = new Zv(_e378, this[iy]()), this[sy] = JSON.parse(JSON.stringify(_e378.gltf))), "variants" in t.userData && (this[ny] = t.userData.variants.slice(), this.requestUpdate("variantName"));
        }

        this[ty] = t, this.dispatchEvent(new CustomEvent("scene-graph-ready"));
      }
    }, {
      key: "exportScene",
      value: function () {
        var _exportScene = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(t) {
          var _this164 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  e = this[gp];
                  return _context34.abrupt("return", new Promise( /*#__PURE__*/function () {
                    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(n) {
                      var i, r, s, _a77;

                      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                        while (1) {
                          switch (_context33.prev = _context33.next) {
                            case 0:
                              i = {
                                binary: !0,
                                onlyVisible: !0,
                                maxTextureSize: 1 / 0,
                                forcePowerOfTwoTextures: !1,
                                includeCustomExtensions: !1,
                                embedImages: !0
                              };
                              Object.assign(i, t), i.animations = e.animations, i.truncateDrawRange = !0;
                              r = e.shadow;
                              s = !1;
                              null != r && (s = r.visible, r.visible = !1);
                              _a77 = _this164[ty];
                              _context33.t0 = null != _a77 && "functions" in _a77.userData && "ensureLoadVariants" in _a77.userData.functions;

                              if (!_context33.t0) {
                                _context33.next = 10;
                                break;
                              }

                              _context33.next = 10;
                              return _a77.userData.functions.ensureLoadVariants(e);

                            case 10:
                              new Tf().register(function (t) {
                                return new uv(t);
                              }).parse(e.modelContainer.children[0], function (t) {
                                return n(new Blob([i.binary ? t : JSON.stringify(t)], {
                                  type: i.binary ? "application/octet-stream" : "application/json"
                                }));
                              }, i), null != r && (r.visible = s);

                            case 11:
                            case "end":
                              return _context33.stop();
                          }
                        }
                      }, _callee33);
                    }));

                    return function (_x35) {
                      return _ref27.apply(this, arguments);
                    };
                  }()));

                case 2:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34, this);
        }));

        function exportScene(_x34) {
          return _exportScene.apply(this, arguments);
        }

        return exportScene;
      }()
    }]);

    return a;
  }(t, (e = ey, n = ty, i = ny, r = ry, s = sy, iy));

  return $v([F({
    type: String,
    attribute: "variant-name"
  })], a.prototype, "variantName", void 0), $v([F({
    type: String,
    attribute: "orientation"
  })], a.prototype, "orientation", void 0), $v([F({
    type: String,
    attribute: "scale"
  })], a.prototype, "scale", void 0), a;
}(function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t456, _ref28) {
    _inherits(r, _t456);

    var _super149 = _createSuper(r);

    function r() {
      var _this165;

      _classCallCheck(this, r);

      _this165 = _super149.apply(this, arguments), _this165.autoRotate = !1, _this165.autoRotateDelay = 3e3, _this165.rotationPerSecond = "auto", _this165[e] = performance.now(), _this165[n] = 0, _this165[i] = function (t) {
        _this165.autoRotate && "user-interaction" === t.detail.source && (_this165[cy] = performance.now());
      };
      return _this165;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this), this.addEventListener("camera-change", this[dy]), this[cy] = performance.now();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this), this.removeEventListener("camera-change", this[dy]), this[cy] = performance.now();
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(r.prototype), "updated", this).call(this, t), t.has("autoRotate") && (this[cy] = performance.now());
      }
    }, {
      key: _ref28,
      value: function value(t) {
        this[hy] = t[0];
      }
    }, {
      key: vp,
      value: function value(t, e) {
        if (_get(_getPrototypeOf(r.prototype), vp, this).call(this, t, e), !this.autoRotate || !this[Mp]() || this[wp].isPresenting) return;
        var n = Math.min(e, t - this[cy] - this.autoRotateDelay);
        n > 0 && (this[gp].yaw = this.turntableRotation + this[hy] * n * .001);
      }
    }, {
      key: "turntableRotation",
      get: function get() {
        return this[gp].yaw;
      }
    }, {
      key: "resetTurntableRotation",
      value: function resetTurntableRotation() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this[gp].yaw = t;
      }
    }]);

    return r;
  }(t, (e = cy, n = hy, uy));

  return i = dy, ay([F({
    type: Boolean,
    attribute: "auto-rotate"
  })], r.prototype, "autoRotate", void 0), ay([F({
    type: Number,
    attribute: "auto-rotate-delay"
  })], r.prototype, "autoRotateDelay", void 0), ay([jm({
    intrinsics: ly,
    updateHandler: uy
  }), F({
    type: String,
    attribute: "rotation-per-second"
  })], r.prototype, "rotationPerSecond", void 0), r;
}(function (t) {
  var e, n, i;

  var r = /*#__PURE__*/function (_t457, _ref29) {
    _inherits(r, _t457);

    var _super150 = _createSuper(r);

    function r() {
      var _this166;

      _classCallCheck(this, r);

      _this166 = _super150.apply(this, arguments), _this166.environmentImage = null, _this166.skyboxImage = null, _this166.shadowIntensity = 0, _this166.shadowSoftness = 1, _this166.exposure = 1, _this166[e] = null, _this166[n] = null, _this166[i] = function (t) {
        t.element === _assertThisInitialized(_this166) && _this166[Uu]();
      };
      return _this166;
    }

    _createClass(r, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(r.prototype), "connectedCallback", this).call(this), this[wp].loader.addEventListener("preload", this[Gu]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(r.prototype), "disconnectedCallback", this).call(this), this[wp].loader.removeEventListener("preload", this[Gu]);
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(r.prototype), "updated", this).call(this, t), t.has("shadowIntensity") && (this[gp].setShadowIntensity(.1 * this.shadowIntensity), this[fp]()), t.has("shadowSoftness") && (this[gp].setShadowSoftness(this.shadowSoftness), this[fp]()), t.has("exposure") && (this[gp].exposure = this.exposure, this[fp]()), (t.has("environmentImage") || t.has("skyboxImage")) && this[Ip]() && this[Uu]();
      }
    }, {
      key: _ref29,
      value: function value() {
        _get(_getPrototypeOf(r.prototype), yp, this).call(this), null != this[Fu] && this[Nu](this[Fu]);
      }
    }, {
      key: Uu,
      value: function () {
        var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
          var _this167 = this;

          var t, e, n, _yield$Promise, _i270, _r186, _s104;

          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  t = this.skyboxImage, e = this.environmentImage;
                  null != this[ku] && (this[ku](), this[ku] = null);
                  n = this[wp].textureUtils;

                  if (!(null != n)) {
                    _context36.next = 18;
                    break;
                  }

                  _context36.prev = 4;
                  _context36.next = 7;
                  return new Promise( /*#__PURE__*/function () {
                    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(i, _r185) {
                      var s;
                      return _regeneratorRuntime.wrap(function _callee35$(_context35) {
                        while (1) {
                          switch (_context35.prev = _context35.next) {
                            case 0:
                              s = n.generateEnvironmentMapAndSkybox(Xh(t), e, {
                                progressTracker: _this167[Ep]
                              });

                              _this167[ku] = function () {
                                return _r185(s);
                              };

                              _context35.t0 = i;
                              _context35.next = 5;
                              return s;

                            case 5:
                              _context35.t1 = _context35.sent;
                              (0, _context35.t0)(_context35.t1);

                            case 7:
                            case "end":
                              return _context35.stop();
                          }
                        }
                      }, _callee35);
                    }));

                    return function (_x36, _x37) {
                      return _ref30.apply(this, arguments);
                    };
                  }());

                case 7:
                  _yield$Promise = _context36.sent;
                  _i270 = _yield$Promise.environmentMap;
                  _r186 = _yield$Promise.skybox;
                  _s104 = _i270.texture;
                  this[gp].background = null != _r186 ? _r186.userData.url === _s104.userData.url ? _s104 : _r186 : null, this[Nu](_i270.texture), this[gp].dispatchEvent({
                    type: "envmap-update"
                  });
                  _context36.next = 18;
                  break;

                case 14:
                  _context36.prev = 14;
                  _context36.t0 = _context36["catch"](4);

                  if (!(_context36.t0 instanceof Error)) {
                    _context36.next = 18;
                    break;
                  }

                  throw this[Nu](null), _context36.t0;

                case 18:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36, this, [[4, 14]]);
        }));

        function value() {
          return _value2.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Nu,
      value: function value(t) {
        this[Fu] = t, this[gp].environment = this[Fu], this.dispatchEvent(new CustomEvent("environment-change")), this[fp]();
      }
    }]);

    return r;
  }(t, (e = Fu, n = ku, i = Gu, yp));

  return Pu([F({
    type: String,
    attribute: "environment-image"
  })], r.prototype, "environmentImage", void 0), Pu([F({
    type: String,
    attribute: "skybox-image"
  })], r.prototype, "skyboxImage", void 0), Pu([F({
    type: Number,
    attribute: "shadow-intensity"
  })], r.prototype, "shadowIntensity", void 0), Pu([F({
    type: Number,
    attribute: "shadow-softness"
  })], r.prototype, "shadowSoftness", void 0), Pu([F({
    type: Number
  })], r.prototype, "exposure", void 0), r;
}(function (t) {
  var e, n, i, r, s, a, o, l, c, h, u, d, p, A, m, g, f;

  var v = /*#__PURE__*/function (_t458, _ref31) {
    _inherits(v, _t458);

    var _super151 = _createSuper(v);

    function v() {
      var _this168;

      _classCallCheck(this, v);

      _this168 = _super151.apply(this, arguments), _this168.cameraControls = !1, _this168.cameraOrbit = "0deg 75deg 105%", _this168.cameraTarget = "auto auto auto", _this168.fieldOfView = "auto", _this168.minCameraOrbit = "auto", _this168.maxCameraOrbit = "auto", _this168.minFieldOfView = "auto", _this168.maxFieldOfView = "auto", _this168.interactionPromptThreshold = 3e3, _this168.interactionPromptStyle = fg, _this168.interactionPrompt = mg, _this168.interactionPolicy = vg, _this168.orbitSensitivity = 1, _this168.touchAction = yg, _this168.disableZoom = !1, _this168.interpolationDecay = 50, _this168.bounds = "legacy", _this168[e] = _this168.shadowRoot.querySelector(".interaction-prompt"), _this168[n] = _this168.shadowRoot.querySelector(".interaction-prompt > .animated-container"), _this168[i] = 1 / 0, _this168[r] = 0, _this168[s] = 1 / 0, _this168[a] = !1, _this168[o] = !1, _this168[l] = new sg(_this168[gp].camera, _this168[Ap]), _this168[c] = 0, _this168[h] = new zl(), _this168[u] = !1, _this168[d] = !1, _this168[p] = !1, _this168[A] = function () {
        var t = _this168[Ap];
        isFinite(_this168[Wg]) || (_this168[Wg] = performance.now());
        var e = _this168[cp];
        t.getAttribute("aria-label") !== e && t.setAttribute("aria-label", e), _this168.interactionPrompt !== gg || _this168[Hg] || (_this168[Og] = !0);
      }, _this168[m] = function () {
        _this168.interactionPrompt === gg && (_this168[Og] = !1, _this168[Rg].classList.remove("visible"), _this168[zg] = 1 / 0, _this168[Wg] = 1 / 0);
      }, _this168[g] = function (_ref32) {
        var t = _ref32.source;
        _this168[Pg](), _this168[fp](), t === ig && (_this168[Hg] = !0, _this168[Qg]()), _this168.dispatchEvent(new CustomEvent("camera-change", {
          detail: {
            source: t
          }
        }));
      }, _this168[f] = function (t) {
        "pointer-change-start" === t.type ? _this168[pp].classList.add("pointer-tumbling") : _this168[pp].classList.remove("pointer-tumbling");
      };
      return _this168;
    }

    _createClass(v, [{
      key: "getCameraOrbit",
      value: function getCameraOrbit() {
        var _this$jg = this[jg],
            t = _this$jg.theta,
            e = _this$jg.phi,
            n = _this$jg.radius;
        return {
          theta: t,
          phi: e,
          radius: n,
          toString: function toString() {
            return "".concat(this.theta, "rad ").concat(this.phi, "rad ").concat(this.radius, "m");
          }
        };
      }
    }, {
      key: "getCameraTarget",
      value: function getCameraTarget() {
        return Sp(this[wp].isPresenting ? this[wp].arRenderer.target : this[gp].getTarget());
      }
    }, {
      key: "getFieldOfView",
      value: function getFieldOfView() {
        return this[Lg].getFieldOfView();
      }
    }, {
      key: "getMinimumFieldOfView",
      value: function getMinimumFieldOfView() {
        return this[Lg].options.minimumFieldOfView;
      }
    }, {
      key: "getMaximumFieldOfView",
      value: function getMaximumFieldOfView() {
        return this[Lg].options.maximumFieldOfView;
      }
    }, {
      key: "jumpCameraToGoal",
      value: function jumpCameraToGoal() {
        this[Yg] = !0, this.requestUpdate(Yg, !1);
      }
    }, {
      key: "resetInteractionPrompt",
      value: function resetInteractionPrompt() {
        this[Vg] = 0, this[zg] = 1 / 0, this[Hg] = !1, this[Og] = this.interactionPrompt === mg && this.cameraControls;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(v.prototype), "connectedCallback", this).call(this), this[Lg].addEventListener("change", this[kg]), this[Lg].addEventListener("pointer-change-start", this[Gg]), this[Lg].addEventListener("pointer-change-end", this[Gg]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(v.prototype), "disconnectedCallback", this).call(this), this[Lg].removeEventListener("change", this[kg]), this[Lg].removeEventListener("pointer-change-start", this[Gg]), this[Lg].removeEventListener("pointer-change-end", this[Gg]);
      }
    }, {
      key: "updated",
      value: function updated(t) {
        var _this169 = this;

        _get(_getPrototypeOf(v.prototype), "updated", this).call(this, t);

        var e = this[Lg],
            n = this[Ap];

        if (t.has("cameraControls") && (this.cameraControls ? (e.enableInteraction(), this.interactionPrompt === mg && (this[Og] = !0), n.addEventListener("focus", this[Ug]), n.addEventListener("blur", this[Ng])) : (n.removeEventListener("focus", this[Ug]), n.removeEventListener("blur", this[Ng]), e.disableInteraction(), this[Qg]())), t.has("disableZoom") && (e.disableZoom = this.disableZoom), t.has("bounds") && (this[gp].tightBounds = "tight" === this.bounds), (t.has("interactionPrompt") || t.has("cameraControls") || t.has("src")) && (this.interactionPrompt === mg && this.cameraControls && !this[Hg] ? this[Og] = !0 : this[Qg]()), t.has("interactionPromptStyle") && this[Rg].classList.toggle("wiggle", this.interactionPromptStyle === fg), t.has("interactionPolicy")) {
          var _t459 = this.interactionPolicy;
          e.applyOptions({
            interactionPolicy: _t459
          });
        }

        if (t.has("touchAction")) {
          var _t460 = this.touchAction;
          e.applyOptions({
            touchAction: _t460
          });
        }

        t.has("orbitSensitivity") && (e.sensitivity = this.orbitSensitivity), t.has("interpolationDecay") && (e.setDamperDecayTime(this.interpolationDecay), this[gp].setTargetDamperDecayTime(this.interpolationDecay)), !0 === this[Yg] && Promise.resolve().then(function () {
          e.jumpToGoal(), _this169[gp].jumpToGoal(), _this169[Yg] = !1;
        });
      }
    }, {
      key: "updateFraming",
      value: function () {
        var _updateFraming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
          var t, e, n, i;
          return _regeneratorRuntime.wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  t = this[gp], e = t.framedFieldOfView;
                  _context37.next = 3;
                  return this.requestUpdate("cameraTarget");

                case 3:
                  t.updateFraming("tight" === this.bounds ? t.getTarget() : void 0);
                  t.frameModel();
                  n = t.framedFieldOfView, i = this[Lg].getFieldOfView() / e;
                  this[qg] = n * i;
                  this[Xg] = !0;
                  this.requestUpdate("maxFieldOfView");
                  this.requestUpdate("fieldOfView");
                  this.requestUpdate("minCameraOrbit");
                  this.requestUpdate("maxCameraOrbit");
                  _context37.next = 14;
                  return this.requestUpdate("cameraOrbit");

                case 14:
                case "end":
                  return _context37.stop();
              }
            }
          }, _callee37, this);
        }));

        function updateFraming() {
          return _updateFraming.apply(this, arguments);
        }

        return updateFraming;
      }()
    }, {
      key: _ref31,
      value: function value(t) {
        this[Lg].setFieldOfView(180 * t[0] / Math.PI);
      }
    }, {
      key: Kg,
      value: function value(t) {
        if (this[Xg]) {
          var _this$getCameraOrbit = this.getCameraOrbit(),
              _e379 = _this$getCameraOrbit.theta,
              _n320 = _this$getCameraOrbit.phi;

          t[0] = _e379, t[1] = _n320, this[Xg] = !1;
        }

        this[Lg].setOrbit(t[0], t[1], t[2]);
      }
    }, {
      key: tf,
      value: function value(t) {
        this[Lg].applyOptions({
          minimumAzimuthalAngle: t[0],
          minimumPolarAngle: t[1],
          minimumRadius: t[2]
        }), this.jumpCameraToGoal();
      }
    }, {
      key: ef,
      value: function value(t) {
        this[Lg].applyOptions({
          maximumAzimuthalAngle: t[0],
          maximumPolarAngle: t[1],
          maximumRadius: t[2]
        }), this[Fg](t[2]), this.jumpCameraToGoal();
      }
    }, {
      key: nf,
      value: function value(t) {
        this[Lg].applyOptions({
          minimumFieldOfView: 180 * t[0] / Math.PI
        }), this.jumpCameraToGoal();
      }
    }, {
      key: rf,
      value: function value(t) {
        this[Lg].applyOptions({
          maximumFieldOfView: 180 * t[0] / Math.PI
        }), this.jumpCameraToGoal();
      }
    }, {
      key: $g,
      value: function value(t) {
        var _t461 = _slicedToArray(t, 3),
            e = _t461[0],
            n = _t461[1],
            i = _t461[2];

        this[gp].setTarget(e, n, i), this[wp].arRenderer.updateTarget();
      }
    }, {
      key: vp,
      value: function value(t, e) {
        if (_get(_getPrototypeOf(v.prototype), vp, this).call(this, t, e), this[wp].isPresenting || !this[Mp]()) return;
        var n = performance.now();

        if (this[Og]) {
          var _t462 = this.interactionPrompt === mg ? this[hp] : this[Wg];

          this.loaded && n > _t462 + this.interactionPromptThreshold && (this[Ap].setAttribute("aria-label", "Use mouse, touch or arrow keys to control the camera!"), this[Og] = !1, this[zg] = n, this[Rg].classList.add("visible"));
        }

        if (isFinite(this[zg]) && this.interactionPromptStyle === fg) {
          var _t463 = this[gp],
              _e380 = (n - this[zg]) / 5e3 % 1,
              _i271 = hg(_e380),
              _r187 = ug(_e380);

          if (this[Dg].style.opacity = "".concat(_r187), _i271 !== this[Vg]) {
            var _e381 = _i271 * _t463.width * .05,
                _n321 = (_i271 - this[Vg]) * Math.PI / 16;

            this[Dg].style.transform = "translateX(".concat(_e381, "px)"), this[Lg].adjustOrbit(_n321, 0, 0), this[Vg] = _i271;
          }
        }

        this[Lg].update(t, e), this[gp].updateTarget(e);
      }
    }, {
      key: Qg,
      value: function value() {
        this[Og] = !1, this[Rg].classList.remove("visible"), this[zg] = 1 / 0;
      }
    }, {
      key: Fg,
      value: function value(t) {
        var e = this[gp].idealCameraDistance,
            n = 2 * Math.max(e, t);
        this[Lg].updateNearFar(0, n);
      }
    }, {
      key: Pg,
      value: function value() {
        var _this$jg2 = this[jg],
            t = _this$jg2.theta,
            e = _this$jg2.phi,
            _this$Lg$getCameraSph = this[Lg].getCameraSpherical(this[jg]),
            n = _this$Lg$getCameraSph.theta,
            i = _this$Lg$getCameraSph.phi,
            r = this.getRootNode();

        if (null != r && r.activeElement === this) {
          var _r188 = (4 + Math.floor((t % Tg + Bg) / Mg)) % 4,
              _s105 = (4 + Math.floor((n % Tg + Bg) / Mg)) % 4,
              _a78 = Math.floor(e / Sg),
              _o50 = Math.floor(i / Sg);

          if (_s105 !== _r188 || _o50 !== _a78) {
            var _t464 = "View from stage ".concat(Ag[_o50]).concat(pg[_s105]);

            this[Ap].setAttribute("aria-label", _t464);
          }
        }
      }
    }, {
      key: xp,
      value: function value(t) {
        var e = this[Lg],
            n = this[gp].framedFieldOfView;

        _get(_getPrototypeOf(v.prototype), xp, this).call(this, t);

        var i = this[gp].framedFieldOfView,
            r = e.getFieldOfView() / n;
        this[qg] = i * r, e.updateAspect(this[gp].aspect), this.requestUpdate("maxFieldOfView", this.maxFieldOfView), this.requestUpdate("fieldOfView", this.fieldOfView), this.jumpCameraToGoal();
      }
    }, {
      key: yp,
      value: function value() {
        _get(_getPrototypeOf(v.prototype), yp, this).call(this);

        var t = this[gp].framedFieldOfView;
        this[qg] = t, this[Jg] ? this[Xg] = !0 : this[Jg] = !0, this.requestUpdate("maxFieldOfView", this.maxFieldOfView), this.requestUpdate("fieldOfView", this.fieldOfView), this.requestUpdate("minCameraOrbit", this.minCameraOrbit), this.requestUpdate("maxCameraOrbit", this.maxCameraOrbit), this.requestUpdate("cameraOrbit", this.cameraOrbit), this.requestUpdate("cameraTarget", this.cameraTarget), this.jumpCameraToGoal();
      }
    }]);

    return v;
  }(t, (e = Rg, n = Dg, i = Wg, r = Vg, s = zg, a = Hg, o = Og, l = Lg, c = qg, h = jg, u = Yg, d = Jg, p = Xg, Zg));

  return A = Ug, m = Ng, g = kg, f = Gg, cg([F({
    type: Boolean,
    attribute: "camera-controls"
  })], v.prototype, "cameraControls", void 0), cg([jm({
    intrinsics: bg,
    observeEffects: !0,
    updateHandler: Kg
  }), F({
    type: String,
    attribute: "camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "cameraOrbit", void 0), cg([jm({
    intrinsics: Cg,
    observeEffects: !0,
    updateHandler: $g
  }), F({
    type: String,
    attribute: "camera-target",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "cameraTarget", void 0), cg([jm({
    intrinsics: xg,
    observeEffects: !0,
    updateHandler: Zg
  }), F({
    type: String,
    attribute: "field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "fieldOfView", void 0), cg([jm({
    intrinsics: _g,
    updateHandler: tf
  }), F({
    type: String,
    attribute: "min-camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "minCameraOrbit", void 0), cg([jm({
    intrinsics: Ig,
    updateHandler: ef
  }), F({
    type: String,
    attribute: "max-camera-orbit",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "maxCameraOrbit", void 0), cg([jm({
    intrinsics: wg,
    updateHandler: nf
  }), F({
    type: String,
    attribute: "min-field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "minFieldOfView", void 0), cg([jm({
    intrinsics: Eg,
    updateHandler: rf
  }), F({
    type: String,
    attribute: "max-field-of-view",
    hasChanged: function hasChanged() {
      return !0;
    }
  })], v.prototype, "maxFieldOfView", void 0), cg([F({
    type: Number,
    attribute: "interaction-prompt-threshold"
  })], v.prototype, "interactionPromptThreshold", void 0), cg([F({
    type: String,
    attribute: "interaction-prompt-style"
  })], v.prototype, "interactionPromptStyle", void 0), cg([F({
    type: String,
    attribute: "interaction-prompt"
  })], v.prototype, "interactionPrompt", void 0), cg([F({
    type: String,
    attribute: "interaction-policy"
  })], v.prototype, "interactionPolicy", void 0), cg([F({
    type: Number,
    attribute: "orbit-sensitivity"
  })], v.prototype, "orbitSensitivity", void 0), cg([F({
    type: String,
    attribute: "touch-action"
  })], v.prototype, "touchAction", void 0), cg([F({
    type: Boolean,
    attribute: "disable-zoom"
  })], v.prototype, "disableZoom", void 0), cg([F({
    type: Number,
    attribute: "interpolation-decay"
  })], v.prototype, "interpolationDecay", void 0), cg([F({
    type: String,
    attribute: "bounds"
  })], v.prototype, "bounds", void 0), v;
}(function (t) {
  var e, n, i, r, s, a, o, l, c, h;

  var u = /*#__PURE__*/function (_t465, _ref33) {
    _inherits(u, _t465);

    var _super152 = _createSuper(u);

    function u() {
      var _this170;

      _classCallCheck(this, u);

      _this170 = _super152.apply(this, arguments), _this170.ar = !1, _this170.arScale = "auto", _this170.arPlacement = "floor", _this170.arModes = "webxr scene-viewer", _this170.iosSrc = null, _this170.xrEnvironment = !1, _this170[e] = !1, _this170[n] = _this170.shadowRoot.querySelector(".ar-button"), _this170[i] = document.createElement("a"), _this170[r] = new Set(), _this170[s] = YA, _this170[a] = !1, _this170[o] = function (t) {
        t.preventDefault(), _this170.activateAR();
      }, _this170[l] = function (_ref34) {
        var t = _ref34.status;
        t !== ju && _this170[wp].arRenderer.presentedScene !== _this170[gp] || (_this170.setAttribute("ar-status", t), _this170.dispatchEvent(new CustomEvent("ar-status", {
          detail: {
            status: t
          }
        })), t === ju ? _this170.removeAttribute("ar-tracking") : t === Yu && _this170.setAttribute("ar-tracking", Ku));
      }, _this170[c] = function (_ref35) {
        var t = _ref35.status;
        _this170.setAttribute("ar-tracking", t), _this170.dispatchEvent(new CustomEvent("ar-tracking", {
          detail: {
            status: t
          }
        }));
      }, _this170[h] = function (t) {
        "_apple_ar_quicklook_button_tapped" == t.data && _this170.dispatchEvent(new CustomEvent("quick-look-button-tapped"));
      };
      return _this170;
    }

    _createClass(u, [{
      key: "canActivateAR",
      get: function get() {
        return this[tm] !== YA;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(u.prototype), "connectedCallback", this).call(this), this[wp].arRenderer.addEventListener("status", this[sm]), this.setAttribute("ar-status", ju), this[wp].arRenderer.addEventListener("tracking", this[am]), this[nm].addEventListener("message", this[om]);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(u.prototype), "disconnectedCallback", this).call(this), this[wp].arRenderer.removeEventListener("status", this[sm]), this[wp].arRenderer.removeEventListener("tracking", this[am]), this[nm].removeEventListener("message", this[om]);
      }
    }, {
      key: "update",
      value: function () {
        var _update2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(t) {
          return _regeneratorRuntime.wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  _get(_getPrototypeOf(u.prototype), "update", this).call(this, t), t.has("arScale") && (this[gp].canScale = "fixed" !== this.arScale), t.has("arPlacement") && (this[gp].setShadowIntensity(this[gp].shadowIntensity), this[fp]()), (t.has("ar") || t.has("arModes") || t.has("iosSrc")) && (t.has("arModes") && (this[em] = zA(this.arModes)), this[lm]());

                case 1:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee38, this);
        }));

        function update(_x38) {
          return _update2.apply(this, arguments);
        }

        return update;
      }()
    }, {
      key: "activateAR",
      value: function () {
        var _activateAR = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
          return _regeneratorRuntime.wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  _context39.t0 = this[tm];
                  _context39.next = _context39.t0 === WA ? 3 : _context39.t0 === jA ? 5 : _context39.t0 === qA ? 8 : 10;
                  break;

                case 3:
                  this[ZA]();
                  return _context39.abrupt("break", 11);

                case 5:
                  _context39.next = 7;
                  return this[XA]();

                case 7:
                  return _context39.abrupt("break", 11);

                case 8:
                  this[KA]();
                  return _context39.abrupt("break", 11);

                case 10:
                  console.warn("No AR Mode can be activated. This is probably due to missing configuration or device capabilities");

                case 11:
                case "end":
                  return _context39.stop();
              }
            }
          }, _callee39, this);
        }));

        function activateAR() {
          return _activateAR.apply(this, arguments);
        }

        return activateAR;
      }()
    }, {
      key: _ref33,
      value: function () {
        var _value3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
          var _iterator48, _step48, _t466, _t467;

          return _regeneratorRuntime.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  if (!(this[tm] = YA, this.ar)) {
                    _context40.next = 32;
                    break;
                  }

                  if (!(null != this.src)) {
                    _context40.next = 31;
                    break;
                  }

                  _iterator48 = _createForOfIteratorHelper(this[em]);
                  _context40.prev = 3;

                  _iterator48.s();

                case 5:
                  if ((_step48 = _iterator48.n()).done) {
                    _context40.next = 23;
                    break;
                  }

                  _t466 = _step48.value;
                  _context40.t0 = "webxr" === _t466 && q && !OA;

                  if (!_context40.t0) {
                    _context40.next = 12;
                    break;
                  }

                  _context40.next = 11;
                  return this[wp].arRenderer.supportsPresentation();

                case 11:
                  _context40.t0 = _context40.sent;

                case 12:
                  if (!_context40.t0) {
                    _context40.next = 15;
                    break;
                  }

                  this[tm] = jA;
                  return _context40.abrupt("break", 23);

                case 15:
                  if (!("scene-viewer" === _t466 && Z && !HA)) {
                    _context40.next = 18;
                    break;
                  }

                  this[tm] = qA;
                  return _context40.abrupt("break", 23);

                case 18:
                  if (!("quick-look" === _t466 && J)) {
                    _context40.next = 21;
                    break;
                  }

                  this[tm] = WA;
                  return _context40.abrupt("break", 23);

                case 21:
                  _context40.next = 5;
                  break;

                case 23:
                  _context40.next = 28;
                  break;

                case 25:
                  _context40.prev = 25;
                  _context40.t1 = _context40["catch"](3);

                  _iterator48.e(_context40.t1);

                case 28:
                  _context40.prev = 28;

                  _iterator48.f();

                  return _context40.finish(28);

                case 31:
                  !this.canActivateAR && null != this.iosSrc && J && (this[tm] = WA);

                case 32:
                  if (this.canActivateAR) this[JA].classList.add("enabled"), this[JA].addEventListener("click", this[rm]);else if (this[JA].classList.contains("enabled")) {
                    this[JA].removeEventListener("click", this[rm]), this[JA].classList.remove("enabled");
                    _t467 = Xu;
                    this.setAttribute("ar-status", _t467), this.dispatchEvent(new CustomEvent("ar-status", {
                      detail: {
                        status: _t467
                      }
                    }));
                  }

                case 33:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40, this, [[3, 25, 28, 31]]);
        }));

        function value() {
          return _value3.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: XA,
      value: function () {
        var _value4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
          var _t468;

          return _regeneratorRuntime.wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  console.log("Attempting to present in AR with WebXR...");
                  _context41.next = 3;
                  return this[cm]();

                case 3:
                  _context41.prev = 3;
                  this[JA].removeEventListener("click", this[rm]);
                  _t468 = this[wp].arRenderer;
                  _t468.placeOnWall = "wall" === this.arPlacement;
                  _context41.next = 9;
                  return _t468.present(this[gp], this.xrEnvironment);

                case 9:
                  _context41.next = 22;
                  break;

                case 11:
                  _context41.prev = 11;
                  _context41.t0 = _context41["catch"](3);
                  console.warn("Error while trying to present in AR with WebXR");
                  console.error(_context41.t0);
                  _context41.next = 17;
                  return this[wp].arRenderer.stopPresenting();

                case 17:
                  OA = !0;
                  console.warn("Falling back to next ar-mode");
                  _context41.next = 21;
                  return this[lm]();

                case 21:
                  this.activateAR();

                case 22:
                  _context41.prev = 22;
                  this[lm]();
                  return _context41.finish(22);

                case 25:
                case "end":
                  return _context41.stop();
              }
            }
          }, _callee41, this, [[3, 11, 22, 25]]);
        }));

        function value() {
          return _value4.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: cm,
      value: function () {
        var _value5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
          return _regeneratorRuntime.wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  _context42.t0 = this.loaded;

                  if (_context42.t0) {
                    _context42.next = 7;
                    break;
                  }

                  this[im] = !0;
                  this[up]();
                  _context42.next = 6;
                  return function (t, e) {
                    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    return new Promise(function (i) {
                      t.addEventListener(e, function r(s) {
                        n && !n(s) || (i(s), t.removeEventListener(e, r));
                      });
                    });
                  }
                  /* @license
                   * Copyright 2020 Google LLC. All Rights Reserved.
                   * Licensed under the Apache License, Version 2.0 (the 'License');
                   * you may not use this file except in compliance with the License.
                   * You may obtain a copy of the License at
                   *
                   *     http://www.apache.org/licenses/LICENSE-2.0
                   *
                   * Unless required by applicable law or agreed to in writing, software
                   * distributed under the License is distributed on an 'AS IS' BASIS,
                   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                   * See the License for the specific language governing permissions and
                   * limitations under the License.
                   */
                  (this, "load");

                case 6:
                  this[im] = !1;

                case 7:
                case "end":
                  return _context42.stop();
              }
            }
          }, _callee42, this);
        }));

        function value() {
          return _value5.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Ip,
      value: function value() {
        return _get(_getPrototypeOf(u.prototype), Ip, this).call(this) || this[im];
      }
    }, {
      key: KA,
      value: function value() {
        var _this171 = this;

        var t = self.location.toString(),
            e = new URL(t),
            n = new URL(this.src, t),
            i = new URLSearchParams(n.search);

        if (e.hash = "#model-viewer-no-ar-fallback", i.set("mode", "ar_preferred"), i.has("disable_occlusion") || i.set("disable_occlusion", "true"), "fixed" === this.arScale && i.set("resizable", "false"), "wall" === this.arPlacement && i.set("enable_vertical_placement", "true"), i.has("sound")) {
          var _e382 = new URL(i.get("sound"), t);

          i.set("sound", _e382.toString());
        }

        if (i.has("link")) {
          var _e383 = new URL(i.get("link"), t);

          i.set("link", _e383.toString());
        }

        var r = "intent://arvr.google.com/scene-viewer/1.0?".concat(i.toString() + "&file=" + encodeURIComponent(n.toString()), "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=").concat(encodeURIComponent(e.toString()), ";end;");
        self.addEventListener("hashchange", function () {
          "#model-viewer-no-ar-fallback" === self.location.hash && (HA = !0, self.history.back(), console.warn("Error while trying to present in AR with Scene Viewer"), console.warn("Falling back to next ar-mode"), _this171[lm]());
        }, {
          once: !0
        }), this[nm].setAttribute("href", r), console.log("Attempting to present in AR with Scene Viewer..."), this[nm].click();
      }
    }, {
      key: ZA,
      value: function () {
        var _value6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
          var t, e, n, i, r;
          return _regeneratorRuntime.wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  t = !this.iosSrc;
                  this[JA].classList.remove("enabled");

                  if (!t) {
                    _context43.next = 8;
                    break;
                  }

                  _context43.next = 5;
                  return this.prepareUSDZ();

                case 5:
                  _context43.t0 = _context43.sent;
                  _context43.next = 9;
                  break;

                case 8:
                  _context43.t0 = this.iosSrc;

                case 9:
                  e = _context43.t0;
                  n = new URL(e, self.location.toString());
                  "fixed" === this.arScale && (n.hash && (n.hash += "&"), n.hash += "allowsContentScaling=0");
                  i = this[nm];
                  i.setAttribute("rel", "ar");
                  r = document.createElement("img");
                  i.appendChild(r), i.setAttribute("href", n.toString()), t && i.setAttribute("download", "model.usdz"), console.log("Attempting to present in AR with Quick Look..."), i.click(), i.removeChild(r), t && URL.revokeObjectURL(e), this[JA].classList.add("enabled");

                case 16:
                case "end":
                  return _context43.stop();
              }
            }
          }, _callee43, this);
        }));

        function value() {
          return _value6.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: "prepareUSDZ",
      value: function () {
        var _prepareUSDZ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
          var t, e, n, i, r, s, a, o;
          return _regeneratorRuntime.wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  t = this[Ep].beginActivity();
                  _context44.next = 3;
                  return this[cm]();

                case 3:
                  e = this[gp], n = e.shadow;
                  i = !1;
                  null != n && (i = n.visible, n.visible = !1), t(.2);
                  r = new RA();
                  _context44.next = 9;
                  return r.parse(e.modelContainer);

                case 9:
                  s = _context44.sent;
                  a = new Blob([s], {
                    type: "model/vnd.usdz+zip"
                  });
                  o = URL.createObjectURL(a);
                  return _context44.abrupt("return", (t(1), null != n && (n.visible = i), o));

                case 13:
                case "end":
                  return _context44.stop();
              }
            }
          }, _callee44, this);
        }));

        function prepareUSDZ() {
          return _prepareUSDZ.apply(this, arguments);
        }

        return prepareUSDZ;
      }()
    }]);

    return u;
  }(t, (e = $A, n = JA, i = nm, r = em, s = tm, a = im, o = rm, l = sm, c = am, h = om, lm));

  return GA([F({
    type: Boolean,
    attribute: "ar"
  })], u.prototype, "ar", void 0), GA([F({
    type: String,
    attribute: "ar-scale"
  })], u.prototype, "arScale", void 0), GA([F({
    type: String,
    attribute: "ar-placement"
  })], u.prototype, "arPlacement", void 0), GA([F({
    type: String,
    attribute: "ar-modes"
  })], u.prototype, "arModes", void 0), GA([F({
    type: String,
    attribute: "ios-src"
  })], u.prototype, "iosSrc", void 0), GA([F({
    type: Boolean,
    attribute: "xr-environment"
  })], u.prototype, "xrEnvironment", void 0), u;
}(function (t) {
  var e, n, i, r, s, a, o, l, c, h, u, d, p;

  var A = /*#__PURE__*/function (_t469, _ref36) {
    _inherits(A, _t469);

    var _super153 = _createSuper(A);

    function A() {
      var _this172;

      _classCallCheck(this, A);

      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      _this172 = _super153.call.apply(_super153, [this].concat(t)), _this172.poster = null, _this172.reveal = hf, _this172.loading = df, _this172[e] = !1, _this172[n] = !1, _this172[i] = 0, _this172[r] = null, _this172[s] = _this172.shadowRoot.querySelector(".slot.poster"), _this172[a] = _this172.shadowRoot.querySelector("#default-poster"), _this172[o] = _this172.shadowRoot.querySelector("#default-progress-bar > .bar"), _this172[l] = _this172.shadowRoot.querySelector("#default-progress-bar > .mask"), _this172[c] = _this172[yf].getAttribute("aria-label"), _this172[h] = function (t, e) {
        var n = null;

        var i = function i() {
          null == n && (t.apply(void 0, arguments), n = self.setTimeout(function () {
            return n = null;
          }, e));
        };

        return i.flush = function () {
          null != n && (self.clearTimeout(n), n = null);
        }, i;
      }(function (t) {
        var e = _this172[gf].parentNode;
        requestAnimationFrame(function () {
          _this172[ff].style.opacity = "" + .2 * (1 - t), _this172[gf].style.transform = "scaleX(".concat(t, ")"), 0 === t && (e.removeChild(_this172[gf]), e.appendChild(_this172[gf])), 1 === t ? _this172[gf].classList.add("hide") : _this172[gf].classList.remove("hide");
        });
      }, 100), _this172[u] = function () {
        _this172.reveal !== uf && _this172.dismissPoster();
      }, _this172[d] = function (t) {
        if (_this172.reveal !== uf) switch (t.keyCode) {
          case 32:
          case 13:
            _this172.dismissPoster();

        }
      }, _this172[p] = function (t) {
        var e = t.detail.totalProgress;
        _this172[_f] = Math.max(e, _this172[_f]), 1 === e && (_this172[bf].flush(), !_this172[Cp]() || null == _this172[xf] && _this172.reveal !== hf || _this172[wf]()), _this172[bf](e), _this172.dispatchEvent(new CustomEvent("progress", {
          detail: {
            totalProgress: e
          }
        }));
      };

      var _A7 = self.ModelViewerElement || {},
          m = _A7.dracoDecoderLocation || "https://www.gstatic.com/draco/versioned/decoders/1.3.6/";

      Hh.setDRACODecoderLocation(m);
      var g = _A7.ktx2TranscoderLocation || "https://www.gstatic.com/basis-universal/versioned/2021-04-15-ba1c3e4/";
      Hh.setKTX2TranscoderLocation(g);
      return _this172;
    }

    _createClass(A, [{
      key: "dismissPoster",
      value: function dismissPoster() {
        this[Cp]() ? this[wf]() : (this[xf] = Af, this[up]());
      }
    }, {
      key: "showPoster",
      value: function showPoster() {
        var t = this[vf],
            e = this[yf];
        e.removeAttribute("tabindex"), e.removeAttribute("aria-hidden"), t.classList.add("show");
        var n = this.modelIsVisible;
        this[Ef] = !1, this[lp](n), this[If] = !1;
      }
    }, {
      key: "getDimensions",
      value: function getDimensions() {
        return Sp(this[gp].size);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(A.prototype), "connectedCallback", this).call(this), this[vf].addEventListener("click", this[Mf]), this[vf].addEventListener("keydown", this[Sf]), this[Ep].addEventListener("progress", this[Bf]), mf.registerInstance(this);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(A.prototype), "disconnectedCallback", this).call(this), this[vf].removeEventListener("click", this[Mf]), this[vf].removeEventListener("keydown", this[Sf]), this[Ep].removeEventListener("progress", this[Bf]), mf.unregisterInstance(this);
      }
    }, {
      key: "updated",
      value: function () {
        var _updated2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(t) {
          return _regeneratorRuntime.wrap(function _callee45$(_context45) {
            while (1) {
              switch (_context45.prev = _context45.next) {
                case 0:
                  _get(_getPrototypeOf(A.prototype), "updated", this).call(this, t), t.has("poster") && null != this.poster && (this[yf].style.backgroundImage = "url(".concat(this.poster, ")")), t.has("alt") && this[yf].setAttribute("aria-label", "".concat(this[cp], ". ").concat(this[Cf])), (t.has("reveal") || t.has("loading")) && this[up]();

                case 1:
                case "end":
                  return _context45.stop();
              }
            }
          }, _callee45, this);
        }));

        function updated(_x39) {
          return _updated2.apply(this, arguments);
        }

        return updated;
      }()
    }, {
      key: _ref36,
      value: function value() {
        return !!this.src && (null != this[xf] || this.loading === pf || this.reveal === hf && this[op]);
      }
    }, {
      key: Cp,
      value: function value() {
        var t = this.src;
        return !!t && _get(_getPrototypeOf(A.prototype), Cp, this).call(this) && 1 === this[_f];
      }
    }, {
      key: wf,
      value: function value() {
        var _this173 = this;

        this[xf] = null;
        var t = this[vf],
            e = this[yf];

        if (t.classList.contains("show")) {
          t.classList.remove("show");
          var _n322 = this.modelIsVisible;
          this[Ef] = !0, this[lp](_n322), t.addEventListener("transitionend", function () {
            requestAnimationFrame(function () {
              _this173[If] = !0;

              var t = _this173.getRootNode();

              t && t.activeElement === _this173 && _this173[Ap].focus(), e.setAttribute("aria-hidden", "true"), e.tabIndex = -1, _this173.dispatchEvent(new CustomEvent("poster-dismissed"));
            });
          }, {
            once: !0
          });
        }
      }
    }, {
      key: _p,
      value: function value() {
        return _get(_getPrototypeOf(A.prototype), _p, this).call(this) && this[Ef];
      }
    }, {
      key: Mp,
      value: function value() {
        return _get(_getPrototypeOf(A.prototype), Mp, this).call(this) && this[If];
      }
    }, {
      key: up,
      value: function () {
        var _value7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
          return _regeneratorRuntime.wrap(function _callee46$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  this[_f] = 0;
                  null != this[gp].currentGLTF && null != this.src && this[Ip]() || this.showPoster();
                  _context46.next = 4;
                  return _get(_getPrototypeOf(A.prototype), up, this).call(this);

                case 4:
                case "end":
                  return _context46.stop();
              }
            }
          }, _callee46, this);
        }));

        function value() {
          return _value7.apply(this, arguments);
        }

        return value;
      }()
    }], [{
      key: "dracoDecoderLocation",
      get: function get() {
        return Hh.getDRACODecoderLocation();
      },
      set: function set(t) {
        Hh.setDRACODecoderLocation(t);
      }
    }, {
      key: "ktx2TranscoderLocation",
      get: function get() {
        return Hh.getKTX2TranscoderLocation();
      },
      set: function set(t) {
        Hh.setKTX2TranscoderLocation(t);
      }
    }, {
      key: "mapURLs",
      value: function mapURLs(t) {
        Dd.singleton.loader[kh].manager.setURLModifier(t);
      }
    }]);

    return A;
  }(t, (e = Ef, n = If, i = _f, r = xf, s = vf, a = yf, o = gf, l = ff, c = Cf, h = bf, u = Mf, d = Sf, p = Bf, Ip));

  return cf([F({
    type: String
  })], A.prototype, "poster", void 0), cf([F({
    type: String
  })], A.prototype, "reveal", void 0), cf([F({
    type: String
  })], A.prototype, "loading", void 0), A;
}(function (t) {
  var e;

  var n = /*#__PURE__*/function (_t470, _ref37) {
    _inherits(n, _t470);

    var _super154 = _createSuper(n);

    function n() {
      var _this174;

      _classCallCheck(this, n);

      _this174 = _super154.apply(this, arguments), _this174.autoplay = !1, _this174.animationName = void 0, _this174.animationCrossfadeDuration = 300, _this174[e] = !0;
      return _this174;
    }

    _createClass(n, [{
      key: "availableAnimations",
      get: function get() {
        return this.loaded ? this[gp].animationNames : [];
      }
    }, {
      key: "duration",
      get: function get() {
        return this[gp].duration;
      }
    }, {
      key: "paused",
      get: function get() {
        return this[Rp];
      }
    }, {
      key: "currentTime",
      get: function get() {
        return this[gp].animationTime;
      },
      set: function set(t) {
        this[gp].animationTime = t, this[wp].threeRenderer.shadowMap.needsUpdate = !0, this[fp]();
      }
    }, {
      key: "pause",
      value: function pause() {
        this[Rp] || (this[Rp] = !0, this[wp].threeRenderer.shadowMap.autoUpdate = !1, this.dispatchEvent(new CustomEvent("pause")));
      }
    }, {
      key: "play",
      value: function play() {
        this[Rp] && this.availableAnimations.length > 0 && (this[Rp] = !1, this[wp].threeRenderer.shadowMap.autoUpdate = !0, this[gp].hasActiveAnimation || this[Lp](), this.dispatchEvent(new CustomEvent("play")));
      }
    }, {
      key: _ref37,
      value: function value() {
        _get(_getPrototypeOf(n.prototype), yp, this).call(this), this[Rp] = !0, this.autoplay && (this[Lp](), this.play());
      }
    }, {
      key: vp,
      value: function value(t, e) {
        _get(_getPrototypeOf(n.prototype), vp, this).call(this, t, e), this[Rp] || !this[Mp]() && !this[wp].isPresenting || (this[gp].updateAnimation(e / 1e3), this[fp]());
      }
    }, {
      key: "updated",
      value: function updated(t) {
        _get(_getPrototypeOf(n.prototype), "updated", this).call(this, t), t.has("autoplay") && this.autoplay && this.play(), t.has("animationName") && this[Lp]();
      }
    }, {
      key: up,
      value: function () {
        var _value8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
          return _regeneratorRuntime.wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  return _context47.abrupt("return", (this[gp].stopAnimation(), _get(_getPrototypeOf(n.prototype), up, this).call(this)));

                case 1:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47, this);
        }));

        function value() {
          return _value8.apply(this, arguments);
        }

        return value;
      }()
    }, {
      key: Lp,
      value: function value() {
        this[gp].playAnimation(this.animationName, this.animationCrossfadeDuration / 1e3), this[Rp] && (this[gp].updateAnimation(0), this[fp]());
      }
    }]);

    return n;
  }(t, (e = Rp, yp));

  return Tp([F({
    type: Boolean
  })], n.prototype, "autoplay", void 0), Tp([F({
    type: String,
    attribute: "animation-name"
  })], n.prototype, "animationName", void 0), Tp([F({
    type: Number,
    attribute: "animation-crossfade-duration"
  })], n.prototype, "animationCrossfadeDuration", void 0), n;
}(function (t) {
  var e;
  var n = Symbol("endPolyfillCoordination");
  return e = n, /*#__PURE__*/function (_t471) {
    _inherits(_class35, _t471);

    var _super155 = _createSuper(_class35);

    function _class35() {
      var _this175;

      _classCallCheck(this, _class35);

      _this175 = _super155.apply(this, arguments), _this175[e] = null;
      return _this175;
    }

    _createClass(_class35, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(_class35.prototype), "connectedCallback", this) && _get(_getPrototypeOf(_class35.prototype), "connectedCallback", this).call(this), null == this[n] && (this[n] = function (t) {
          if (null == t.shadowRoot || t.hasAttribute("data-js-focus-visible")) return function () {};

          if (!self.applyFocusVisiblePolyfill) {
            var _e384 = function _e384() {
              self.applyFocusVisiblePolyfill(t.shadowRoot);
            };

            return self.addEventListener("focus-visible-polyfill-ready", _e384, {
              once: !0
            }), function () {
              self.removeEventListener("focus-visible-polyfill-ready", _e384);
            };
          }

          return self.applyFocusVisiblePolyfill(t.shadowRoot), function () {};
        }(this));
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(_class35.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(_class35.prototype), "disconnectedCallback", this).call(this), null != this[n] && (this[n](), this[n] = null);
      }
    }]);

    return _class35;
  }(t);
}(Bp)))))))));

customElements.define("model-viewer", py);
export { py as ModelViewerElement };